(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root['ca-plateform-bonus-payment-domain'] = factory(typeof this['ca-plateform-bonus-payment-domain'] === 'undefined' ? {} : this['ca-plateform-bonus-payment-domain']);
}(this, function (_) {
  //region block: imports
  var imul = Math.imul;
  //endregion
  'use strict';
  //region block: pre-declaration
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  NotFoundException.prototype = Object.create(Exception.prototype);
  NotFoundException.prototype.constructor = NotFoundException;
  function _get_type__810427985() {
    return 'ADD_TERRITORY_ZONE';
  }
  function _get_type__810427985_0() {
    return 'TERRITORY_ZONE_ADDED';
  }
  function _get_type__810427985_1() {
    return 'ARCHIVE_GEOZONE';
  }
  function _get_type__810427985_2() {
    return 'GEOZONE_ARCHIVED';
  }
  function _get_type__810427985_3() {
    return 'CREATE_GEOZONE';
  }
  function _get_type__810427985_4() {
    return 'GEOZONE_CREATED';
  }
  function _get_type__810427985_5() {
    return 'CREATE_TERRITORY';
  }
  function _get_type__810427985_6() {
    return 'TERRITORY_CREATED';
  }
  HubType.prototype = Object.create(Enum.prototype);
  HubType.prototype.constructor = HubType;
  function getOrganizationsPage(page, size, organizationName, organizationType) {
    return this.getOrganizationsPage_8l2d1x_k$(page, size, organizationName === void 1 ? '' : organizationName, organizationType === void 1 ? '' : organizationType);
  }
  function getOrganizationsPage$default(page, size, organizationName, organizationType, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      organizationName = '';
    if (!(($mask0 & 8) === 0))
      organizationType = '';
    return $handler == null ? this.getOrganizationsPage_8l2d1x_k$(page, size, organizationName, organizationType) : $handler(page, size, organizationName, organizationType);
  }
  ManagerType.prototype = Object.create(OrganizationTypeBase.prototype);
  ManagerType.prototype.constructor = ManagerType;
  OperatorType.prototype = Object.create(OrganizationTypeBase.prototype);
  OperatorType.prototype.constructor = OperatorType;
  FunderType.prototype = Object.create(OrganizationTypeBase.prototype);
  FunderType.prototype.constructor = FunderType;
  FunderCeeType.prototype = Object.create(OrganizationTypeBase.prototype);
  FunderCeeType.prototype.constructor = FunderCeeType;
  CarrierType.prototype = Object.create(OrganizationTypeBase.prototype);
  CarrierType.prototype.constructor = CarrierType;
  TmsType.prototype = Object.create(OrganizationTypeBase.prototype);
  TmsType.prototype.constructor = TmsType;
  VisitorType.prototype = Object.create(OrganizationTypeBase.prototype);
  VisitorType.prototype.constructor = VisitorType;
  FoodPackageType.prototype = Object.create(PackageTypeBase.prototype);
  FoodPackageType.prototype.constructor = FoodPackageType;
  NonFoodPackageType.prototype = Object.create(PackageTypeBase.prototype);
  NonFoodPackageType.prototype.constructor = NonFoodPackageType;
  WastePackageType.prototype = Object.create(PackageTypeBase.prototype);
  WastePackageType.prototype.constructor = WastePackageType;
  MixFoodPackageType.prototype = Object.create(PackageTypeBase.prototype);
  MixFoodPackageType.prototype.constructor = MixFoodPackageType;
  MixNonFoodPackageType.prototype = Object.create(PackageTypeBase.prototype);
  MixNonFoodPackageType.prototype.constructor = MixNonFoodPackageType;
  function _get_type__810427985_7() {
    return 'ADD_APPLICATION_PROPERTIES';
  }
  function _get_type__810427985_8() {
    return 'APPLICATION_PROPERTIES_ADDED';
  }
  function _get_type__810427985_9() {
    return 'ADD_HUB';
  }
  function _get_type__810427985_10() {
    return 'ORGANIZATION_HUB_ADDED';
  }
  function _get_type__810427985_11() {
    return 'USER_CHANGE_PASSWORD';
  }
  function _get_type__810427985_12() {
    return 'USER_CHANGED_PASSWORD';
  }
  function _get_type__810427985_13() {
    return 'CREATE_CLIENT';
  }
  function _get_type__810427985_14() {
    return 'ORGANIZATION_EVENT';
  }
  function _get_type__810427985_15() {
    return 'CREATE_ORGANIZATION';
  }
  function _get_type__810427985_16() {
    return 'CREATED_ORGANIZATION_EVENT';
  }
  function _get_type__810427985_17() {
    return 'UPLOAD_SIMPLIFIED_CONVENTION';
  }
  function _get_type__810427985_18() {
    return 'UPLOADED_SIMPLIFIED_CONVENTION_EVENT';
  }
  function _get_type__810427985_19() {
    return 'DELETE_ORGANIZATION';
  }
  function _get_type__810427985_20() {
    return 'DELETED_ORGANIZATION_EVENT';
  }
  function _get_type__810427985_21() {
    return 'DELETE_USER';
  }
  function _get_type__810427985_22() {
    return 'DELETED_USER_EVENT';
  }
  function _get_type__810427985_23() {
    return 'DISABLE_ORGANIZATION';
  }
  function _get_type__810427985_24() {
    return 'DISABLED_ORGANIZATION_EVENT';
  }
  function _get_type__810427985_25() {
    return 'DISABLE_USER';
  }
  function _get_type__810427985_26() {
    return 'DISABLED_USER_EVENT';
  }
  function _get_type__810427985_27() {
    return 'ENABLE_USER';
  }
  function _get_type__810427985_28() {
    return 'ENABLED_USER_EVENT';
  }
  function _get_type__810427985_29() {
    return 'UPDATE_EXPORT_AUTHORIZATION_COMMAND';
  }
  function _get_type__810427985_30() {
    return 'UPDATED_EXPORT_AUTHORIZATION';
  }
  function _get_type__810427985_31() {
    return 'EXPORT_DOLIBARR_ORGANIZATIONS';
  }
  function _get_type__810427985_32() {
    return 'EXPORT_ORGANIZATIONS';
  }
  function _get_type__810427985_33() {
    return 'HUB_ACTIVATION_TOGGLE';
  }
  function _get_type__810427985_34() {
    return 'HUB_ACTIVATION_TOGGLED_EVENT';
  }
  function _get_type__810427985_35() {
    return 'LOGO_CREATE';
  }
  function _get_type__810427985_36() {
    return 'LOGO_CREATED_EVENT';
  }
  function _get_type__810427985_37() {
    return 'USER_ADD';
  }
  function _get_type__810427985_38() {
    return 'USER_ADDED_EVENT';
  }
  function _get_type__810427985_39() {
    return 'USER_UPDATE';
  }
  function _get_type__810427985_40() {
    return 'USER_UPDATED_EVENT';
  }
  function _get_type__810427985_41() {
    return 'UPDATE_ORGANIZATION';
  }
  function _get_type__810427985_42() {
    return 'ORGANIZATION_EVENT';
  }
  function _get_type__810427985_43() {
    return 'REMOVE_HUB';
  }
  function _get_type__810427985_44() {
    return 'HUB_REMOVED_EVENT';
  }
  function _get_type__810427985_45() {
    return 'SET_ORGANIZATION_RSA_KEYPAIR';
  }
  function _get_type__810427985_46() {
    return 'ORGANIZATION_RSA_KEYPAIR_SET';
  }
  function _get_type__810427985_47() {
    return 'UPDATE_HUB_ACTIVITY_END_DATE';
  }
  function _get_type__810427985_48() {
    return 'HUB_ACTIVITY_END_DATE_UPDATED_EVENT';
  }
  function _get_type__810427985_49() {
    return 'UPDATE_HUB_COMMENT';
  }
  function _get_type__810427985_50() {
    return 'HUB_COMMENT_UPDATED_EVENT';
  }
  function _get_type__810427985_51() {
    return 'UPLOAD_PAYMENT_INFORMATION_COMMAND';
  }
  function _get_type__810427985_52() {
    return 'UPLOAD_PAYMENT_INFORMATION_EVENT';
  }
  function _get_type__810427985_53() {
    return 'UPDATE_VISITOR_AUTHORIZATION_COMMAND';
  }
  function _get_type__810427985_54() {
    return 'UPDATED_VISITOR_AUTHORIZATION';
  }
  function _get_type__810427985_55() {
    return 'CONVENTION_PREFILLED';
  }
  function _get_type__810427985_56() {
    return 'CONVENTION_RESETED_EVENT';
  }
  function _get_type__810427985_57() {
    return 'CREATE_CONVENTION';
  }
  function _get_type__810427985_58() {
    return 'CONVENTION_CREATED_EVENT';
  }
  function _get_type__810427985_59() {
    return 'FINALIZED_CONVENTION';
  }
  function _get_type__810427985_60() {
    return 'CONVENTION_CREATED_EVENT';
  }
  function _get_type__810427985_61() {
    return 'PREPARE_SIGN_CONVENTION';
  }
  function _get_type__810427985_62() {
    return 'CONVENTION_CREATED_EVENT';
  }
  function _get_type__810427985_63() {
    return 'SIGNED_CONVENTION';
  }
  function _get_type__810427985_64() {
    return 'CONVENTION_CREATED_EVENT';
  }
  function _get_type__810427985_65() {
    return 'UPDATE_SECRET';
  }
  function _get_type__810427985_66() {
    return 'ORGANIZATION_EVENT';
  }
  function getUsersPage(page, size, organizationId, emOrFnOrLn, role, status) {
    return this.getUsersPage_sye0cd_k$(page, size, organizationId, emOrFnOrLn === void 1 ? '' : emOrFnOrLn, role === void 1 ? '' : role, status === void 1 ? '' : status);
  }
  function getUsersPage$default(page, size, organizationId, emOrFnOrLn, role, status, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      emOrFnOrLn = '';
    if (!(($mask0 & 16) === 0))
      role = '';
    if (!(($mask0 & 32) === 0))
      status = '';
    return $handler == null ? this.getUsersPage_sye0cd_k$(page, size, organizationId, emOrFnOrLn, role, status) : $handler(page, size, organizationId, emOrFnOrLn, role, status);
  }
  AdminRole.prototype = Object.create(UserRoleBase.prototype);
  AdminRole.prototype.constructor = AdminRole;
  SuperAdminRole.prototype = Object.create(UserRoleBase.prototype);
  SuperAdminRole.prototype.constructor = SuperAdminRole;
  OperatorAdminRole.prototype = Object.create(UserRoleBase.prototype);
  OperatorAdminRole.prototype.constructor = OperatorAdminRole;
  OperatorUserRole.prototype = Object.create(UserRoleBase.prototype);
  OperatorUserRole.prototype.constructor = OperatorUserRole;
  OperatorAdminOnboardingRole.prototype = Object.create(UserRoleBase.prototype);
  OperatorAdminOnboardingRole.prototype.constructor = OperatorAdminOnboardingRole;
  OperatorUserOnboardingRole.prototype = Object.create(UserRoleBase.prototype);
  OperatorUserOnboardingRole.prototype.constructor = OperatorUserOnboardingRole;
  FunderAdminRole.prototype = Object.create(UserRoleBase.prototype);
  FunderAdminRole.prototype.constructor = FunderAdminRole;
  FunderUserRole.prototype = Object.create(UserRoleBase.prototype);
  FunderUserRole.prototype.constructor = FunderUserRole;
  CarrierAdminRole.prototype = Object.create(UserRoleBase.prototype);
  CarrierAdminRole.prototype.constructor = CarrierAdminRole;
  CarrierUserRole.prototype = Object.create(UserRoleBase.prototype);
  CarrierUserRole.prototype.constructor = CarrierUserRole;
  TmsAdminRole.prototype = Object.create(UserRoleBase.prototype);
  TmsAdminRole.prototype.constructor = TmsAdminRole;
  TmsUserRole.prototype = Object.create(UserRoleBase.prototype);
  TmsUserRole.prototype.constructor = TmsUserRole;
  VisitorAdminRole.prototype = Object.create(UserRoleBase.prototype);
  VisitorAdminRole.prototype.constructor = VisitorAdminRole;
  VisitorUserRole.prototype = Object.create(UserRoleBase.prototype);
  VisitorUserRole.prototype.constructor = VisitorUserRole;
  ReadHeatMap.prototype = Object.create(VisitorRoleBase.prototype);
  ReadHeatMap.prototype.constructor = ReadHeatMap;
  ReadFluxMap.prototype = Object.create(VisitorRoleBase.prototype);
  ReadFluxMap.prototype.constructor = ReadFluxMap;
  ReadDashboardBonusTotal.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardBonusTotal.prototype.constructor = ReadDashboardBonusTotal;
  ReadDashboardBonusPerPackage.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardBonusPerPackage.prototype.constructor = ReadDashboardBonusPerPackage;
  ReadDashboardDeliveryTime.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardDeliveryTime.prototype.constructor = ReadDashboardDeliveryTime;
  ReadDashboardActiveDeliveries.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardActiveDeliveries.prototype.constructor = ReadDashboardActiveDeliveries;
  ReadDashboardActivePackCount.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardActivePackCount.prototype.constructor = ReadDashboardActivePackCount;
  ReadDashboardHubCount.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardHubCount.prototype.constructor = ReadDashboardHubCount;
  ReadDashboardAverageApproachDistance.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardAverageApproachDistance.prototype.constructor = ReadDashboardAverageApproachDistance;
  ReadDashboardAverageDistancePerDelivery.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardAverageDistancePerDelivery.prototype.constructor = ReadDashboardAverageDistancePerDelivery;
  ReadDashboardTourAmount.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardTourAmount.prototype.constructor = ReadDashboardTourAmount;
  ReadDashboardDistanceTotal.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardDistanceTotal.prototype.constructor = ReadDashboardDistanceTotal;
  ReadDashboardThermalKmAvoided.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardThermalKmAvoided.prototype.constructor = ReadDashboardThermalKmAvoided;
  ReadDashboardCo2Avoided.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardCo2Avoided.prototype.constructor = ReadDashboardCo2Avoided;
  ReadDashboardNoxPpmAvoided.prototype = Object.create(VisitorRoleBase.prototype);
  ReadDashboardNoxPpmAvoided.prototype.constructor = ReadDashboardNoxPpmAvoided;
  function _get_type__810427985_67() {
    return 'ADD_CAMPAIGN';
  }
  function _get_type__810427985_68() {
    return 'ADDED_CAMPAIGN';
  }
  function _get_type__810427985_69() {
    return 'ADD_FUNDER';
  }
  function _get_type__810427985_70() {
    return 'FUNDER_ADDED';
  }
  function _get_type__810427985_71() {
    return 'ACTIVATE_CAMPAIGN';
  }
  function _get_type__810427985_72() {
    return 'ACTIVATED_CAMPAIGN';
  }
  function _get_type__810427985_73() {
    return 'CREATE_PROJECT';
  }
  function _get_type__810427985_74() {
    return 'CREATED_PROJECT_EVENT';
  }
  function _get_type__810427985_75() {
    return 'ADD_CAMPAIGN';
  }
  function _get_type__810427985_76() {
    return 'ADDED_CAMPAIGN';
  }
  function _get_type__810427985_77() {
    return 'ACTIVATE_CAMPAIGN';
  }
  function _get_type__810427985_78() {
    return 'ACTIVATED_CAMPAIGN';
  }
  function _get_type__810427985_79() {
    return 'FINISH_PROJECT';
  }
  function _get_type__810427985_80() {
    return 'PROJECT_DONE_EVENT';
  }
  function _get_type__810427985_81() {
    return 'ACTIVATE_CAMPAIGN';
  }
  function _get_type__810427985_82() {
    return 'ACTIVATED_CAMPAIGN';
  }
  function _get_type__810427985_83() {
    return 'ACTIVATE_CAMPAIGN';
  }
  function _get_type__810427985_84() {
    return 'ACTIVATED_CAMPAIGN';
  }
  function _get_type__810427985_85() {
    return 'REMOVE_CAMPAIGN';
  }
  function _get_type__810427985_86() {
    return 'REMOVED_CAMPAIGN';
  }
  function _get_type__810427985_87() {
    return 'ACTIVATE_CAMPAIGN';
  }
  function _get_type__810427985_88() {
    return 'ACTIVATED_CAMPAIGN';
  }
  function _get_type__810427985_89() {
    return 'ADD_CAMPAIGN';
  }
  function _get_type__810427985_90() {
    return 'ADDED_CAMPAIGN';
  }
  function _get_type__810427985_91() {
    return 'UPDATE_CAMPAIGN_MISSING_BUDGET';
  }
  function _get_type__810427985_92() {
    return 'UPDATED_CAMPAIGN_MISSING_BUDGET';
  }
  function _get_type__810427985_93() {
    return 'UPDATE_CAMPAIGN_NOTIFICATION';
  }
  function _get_type__810427985_94() {
    return 'UPDATED_CAMPAIGN_NOTIFICATION';
  }
  function _get_type__810427985_95() {
    return 'UPDATE_PROJECT';
  }
  function _get_type__810427985_96() {
    return 'UPDATED_PROJECT_EVENT';
  }
  DeliveryCsvAnalysisQueryStatus.prototype = Object.create(Enum.prototype);
  DeliveryCsvAnalysisQueryStatus.prototype.constructor = DeliveryCsvAnalysisQueryStatus;
  DeliveryCsvError.prototype = Object.create(Enum.prototype);
  DeliveryCsvError.prototype.constructor = DeliveryCsvError;
  ReanalysisJobStatus.prototype = Object.create(Enum.prototype);
  ReanalysisJobStatus.prototype.constructor = ReanalysisJobStatus;
  function _get_type__810427985_97() {
    return 'ADD_DELIVERIES';
  }
  function _get_type__810427985_98() {
    return 'DELIVERY_ADDED';
  }
  function _get_type__810427985_99() {
    return 'ADD_DELIVERY_BLOCKCHAIN_TRACE';
  }
  function _get_type__810427985_100() {
    return 'DELIVERY_BLOCKCHAIN_TRACE_ADDED';
  }
  function _get_type__810427985_101() {
    return 'ADD_TOUR_METADATA_BLOCKCHAIN_TRACE';
  }
  function _get_type__810427985_102() {
    return 'TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED';
  }
  function _get_type__810427985_103() {
    return 'ADD_TOUR_TRACE_GPS';
  }
  function _get_type__810427985_104() {
    return 'TOUR_TRACE_GPS_ADDED';
  }
  function _get_type__810427985_105() {
    return 'DECLARE_TOUR';
  }
  function _get_type__810427985_106() {
    return 'TOUR_DECLARED';
  }
  function _get_type__810427985_107() {
    return 'GET_TOURS_WITH_DELIVERIES';
  }
  function _get_type__810427985_108() {
    return 'TOUR_AUDITED';
  }
  function _get_type__810427985_109() {
    return 'UPDATE_ACCEPTED_BY_AI';
  }
  function _get_type__810427985_110() {
    return 'ACCEPTED_BY_AI_UPDATED';
  }
  function _get_type__810427985_111() {
    return 'UPDATE_DELIVERY_STATUS';
  }
  function _get_type__810427985_112() {
    return 'DELIVERY_STATUS_UPDATED';
  }
  function _get_type__810427985_113() {
    return 'UPDATE_TERRITORY_CODE';
  }
  function _get_type__810427985_114() {
    return 'TERRITORY_CODE_UPDATED';
  }
  function getBonusList(campaignId, operatorId, carrierId, areaCode, period, groupStatuses) {
    return this.getBonusList_5layrw_k$(campaignId === void 1 ? null : campaignId, operatorId === void 1 ? null : operatorId, carrierId === void 1 ? null : carrierId, areaCode === void 1 ? null : areaCode, period === void 1 ? null : period, groupStatuses === void 1 ? null : groupStatuses);
  }
  function getBonusList$default(campaignId, operatorId, carrierId, areaCode, period, groupStatuses, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      campaignId = null;
    if (!(($mask0 & 2) === 0))
      operatorId = null;
    if (!(($mask0 & 4) === 0))
      carrierId = null;
    if (!(($mask0 & 8) === 0))
      areaCode = null;
    if (!(($mask0 & 16) === 0))
      period = null;
    if (!(($mask0 & 32) === 0))
      groupStatuses = null;
    return $handler == null ? this.getBonusList_5layrw_k$(campaignId, operatorId, carrierId, areaCode, period, groupStatuses) : $handler(campaignId, operatorId, carrierId, areaCode, period, groupStatuses);
  }
  function _get_type__810427985_115() {
    return 'ADD_BONUS_DELIVERY_TOURS';
  }
  function _get_type__810427985_116() {
    return 'BONUS_DELIVERY_TOURS_ADDED';
  }
  function _get_type__810427985_117() {
    return 'BONUS_UPDATED';
  }
  function _get_type__810427985_118() {
    return 'CREATE_BONUS';
  }
  function _get_type__810427985_119() {
    return 'BONUS_CREATED';
  }
  function _get_type__810427985_120() {
    return 'CREATE_OR_UPDATE_GROUP_OF_BONUS';
  }
  function _get_type__810427985_121() {
    return 'REMOVE_BONUS_TOURS';
  }
  function _get_type__810427985_122() {
    return 'BONUS_TOURS_REMOVED';
  }
  function _get_type__810427985_123() {
    return 'SET_BONUS_TOURS_AS_ACTIVE';
  }
  function _get_type__810427985_124() {
    return 'BONUS_TOURS_SET_AS_ACTIVE';
  }
  function _get_type__810427985_125() {
    return 'UPDATE_BONUS_AMOUNT';
  }
  function _get_type__810427985_126() {
    return 'BONUS_AMOUNT_UPDATED';
  }
  function _get_type__810427985_127() {
    return 'UPDATE_BONUS_STATUS';
  }
  function _get_type__810427985_128() {
    return 'BONUS_STATUS_UPDATED';
  }
  BonusGroupLogType.prototype = Object.create(Enum.prototype);
  BonusGroupLogType.prototype.constructor = BonusGroupLogType;
  function _get_type__810427985_129() {
    return 'ADD_BONUS_TO_GROUP';
  }
  function _get_type__810427985_130() {
    return 'BONUS_ADDED_TO_GROUP';
  }
  function _get_type__810427985_131() {
    return 'BONUS_GROUP_COMMENT_EDITED';
  }
  function _get_type__810427985_132() {
    return 'BONUS_GROUP_CREATED';
  }
  function _get_type__810427985_133() {
    return 'BONUS_GROUP_DELETED';
  }
  function _get_type__810427985_134() {
    return 'BONUS_GROUP_INVOICE_DELETED';
  }
  function _get_type__810427985_135() {
    return 'BONUS_GROUP_LOG_COMMENT_EDITED';
  }
  function _get_type__810427985_136() {
    return 'BONUS_GROUP_STATUS_UPDATED';
  }
  function _get_type__810427985_137() {
    return 'CREATE_BONUS_GROUP_INCIDENT';
  }
  function _get_type__810427985_138() {
    return 'BONUS_GROUP_INCIDENT_CREATED';
  }
  function _get_type__810427985_139() {
    return 'CREATE_BONUS_GROUP_INVOICE';
  }
  function _get_type__810427985_140() {
    return 'BONUS_GROUP_INVOICE_CREATED';
  }
  function _get_type__810427985_141() {
    return 'DEDUCE_BONUS_GROUP';
  }
  function _get_type__810427985_142() {
    return 'DELETE_BONUS_GROUP';
  }
  function _get_type__810427985_143() {
    return 'DELETE_BONUS_GROUPS';
  }
  function _get_type__810427985_144() {
    return 'EDIT_BONUS_GROUP_COMMENT';
  }
  function _get_type__810427985_145() {
    return 'EDIT_BONUS_GROUP_LOG_COMMENT';
  }
  function _get_type__810427985_146() {
    return 'LOG_BONUS_GROUP';
  }
  function _get_type__810427985_147() {
    return 'PAY_BONUS_GROUP';
  }
  function _get_type__810427985_148() {
    return 'PUBLISH_BONUS_GROUP';
  }
  function _get_type__810427985_149() {
    return 'REJECT_BONUS_GROUP';
  }
  function _get_type__810427985_150() {
    return 'REPORT_BONUS_GROUP';
  }
  function _get_type__810427985_151() {
    return _get_CREATE_BONUS__3098369487();
  }
  function _get_type__810427985_152() {
    return 'BONUS_GROUP_INCIDENT_RESOLVED';
  }
  function _get_type__810427985_153() {
    return 'UPDATE_BONUS_GROUP_INVOICE';
  }
  function _get_type__810427985_154() {
    return 'BONUS_GROUP_INVOICE_UPDATED';
  }
  function _get_type__810427985_155() {
    return 'UPDATE_BONUS_GROUP_INVOICE_DETAILS';
  }
  function _get_type__810427985_156() {
    return 'BONUS_GROUP_INVOICE_DETAILS_UPDATED';
  }
  function _get_type__810427985_157() {
    return 'VALIDATE_BONUS_GROUP';
  }
  function _get_type__810427985_158() {
    return _get_PAY_BONUS_PAYMENT__2631622402();
  }
  function _get_type__810427985_159() {
    return _get_PAID_BONUS_PAYMENT_EVENT__427829981();
  }
  function _get_type__810427985_160() {
    return 'CREATE_BONUS_PAYMENT';
  }
  function _get_type__810427985_161() {
    return 'CREATED_BONUS_PAYMENT_EVENT';
  }
  function _get_type__810427985_162() {
    return 'PAY_BONUS_PAYMENT';
  }
  function _get_type__810427985_163() {
    return 'PAID_BONUS_PAYMENT_EVENT';
  }
  function _get_type__810427985_164() {
    return 'EXPORT_BONUS_GROUP_INVOICE';
  }
  //endregion
  function indexOf(_this__1828080292, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last = _this__1828080292.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this__1828080292[index] == null) {
            return index;
          }
        }
         while (inductionVariable <= last);
    } else {
      var inductionVariable_0 = 0;
      var last_0 = _this__1828080292.length - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, _this__1828080292[index_0])) {
            return index_0;
          }
        }
         while (inductionVariable_0 <= last_0);
    }
    return -1;
  }
  function joinToString(_this__1828080292, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this__1828080292, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this__1828080292, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this__1828080292, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo(_this__1828080292, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_oz4qxs_k$(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this__1828080292;
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_oz4qxs_k$(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_oz4qxs_k$(truncated);
      Unit_getInstance();
    }
    buffer.append_oz4qxs_k$(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinToString_0(_this__1828080292, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this__1828080292, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this__1828080292, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this__1828080292, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo_0(_this__1828080292, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_oz4qxs_k$(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this__1828080292.iterator_jk1svi_k$();
    $l$loop: while (tmp0_iterator.hasNext_bitz1p_k$()) {
      var element = tmp0_iterator.next_20eer_k$();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_oz4qxs_k$(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_oz4qxs_k$(truncated);
      Unit_getInstance();
    }
    buffer.append_oz4qxs_k$(postfix);
    Unit_getInstance();
    return buffer;
  }
  function AbstractCollection$toString$lambda(this$0) {
    return function (it) {
      return it === this$0 ? '(this Collection)' : toString_0(it);
    };
  }
  function AbstractCollection() {
  }
  AbstractCollection.prototype.isEmpty_y1axqb_k$ = function () {
    return this._get_size__809037418_ddoh9m_k$() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, AbstractCollection$toString$lambda(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function Companion() {
    Companion_instance = this;
  }
  Companion.prototype.checkElementIndex_ux0wz1_k$ = function (index, size) {
    if (index < 0 ? true : index >= size) {
      throw IndexOutOfBoundsException_init_$Create$('index: ' + index + ', size: ' + size);
    }
  };
  Companion.prototype.checkPositionIndex_kxpgsw_k$ = function (index, size) {
    if (index < 0 ? true : index > size) {
      throw IndexOutOfBoundsException_init_$Create$('index: ' + index + ', size: ' + size);
    }
  };
  Companion.prototype.orderedHashCode_2n0ag_k$ = function (c) {
    var hashCode_0 = 1;
    var tmp0_iterator = c.iterator_jk1svi_k$();
    while (tmp0_iterator.hasNext_bitz1p_k$()) {
      var e = tmp0_iterator.next_20eer_k$();
      var tmp = imul(31, hashCode_0);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_0 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  Companion.prototype.orderedEquals_evsvp0_k$ = function (c, other) {
    if (!(c._get_size__809037418_ddoh9m_k$() === other._get_size__809037418_ddoh9m_k$()))
      return false;
    var otherIterator = other.iterator_jk1svi_k$();
    var tmp0_iterator = c.iterator_jk1svi_k$();
    while (tmp0_iterator.hasNext_bitz1p_k$()) {
      var elem = tmp0_iterator.next_20eer_k$();
      var elemOther = otherIterator.next_20eer_k$();
      if (!equals(elem, elemOther)) {
        return false;
      }
    }
    return true;
  };
  Companion.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function EmptyList() {
    EmptyList_instance = this;
    this.serialVersionUID_1 = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_y1axqb_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_y1axqb_k$ = function () {
    return true;
  };
  EmptyList.prototype.contains_a7ux40_k$ = function (element) {
    return false;
  };
  EmptyList.prototype.contains_i4byw0_k$ = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_a7ux40_k$(tmp);
  };
  EmptyList.prototype.iterator_jk1svi_k$ = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_bitz1p_k$ = function () {
    return false;
  };
  EmptyIterator.prototype.next_20eer_k$ = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function _get_lastIndex__339712501(_this__1828080292) {
    return _this__1828080292._get_size__809037418_ddoh9m_k$() - 1 | 0;
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function ArrayAsCollection(values, isVarargs) {
    this.values_1 = values;
    this.isVarargs_1 = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.values_1.length;
  };
  ArrayAsCollection.prototype.iterator_jk1svi_k$ = function () {
    return arrayIterator(this.values_1);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function collectionSizeOrDefault(_this__1828080292, default_0) {
    var tmp;
    if (isInterface(_this__1828080292, Collection)) {
      tmp = _this__1828080292._get_size__809037418_ddoh9m_k$();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function EmptySet() {
    EmptySet_instance = this;
    this.serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_y1axqb_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_y1axqb_k$ = function () {
    return true;
  };
  EmptySet.prototype.iterator_jk1svi_k$ = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this__1828080292, element, transform) {
    if (!(transform == null)) {
      _this__1828080292.append_oz4qxs_k$(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this__1828080292.append_oz4qxs_k$(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this__1828080292.append_t8oh9e_k$(element.value_1);
          Unit_getInstance();
        } else {
          {
            _this__1828080292.append_oz4qxs_k$(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function copyToArray(collection) {
    var tmp;
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = collection;
      break $l$block;
    }
    if (tmp$ret$0.toArray !== undefined) {
      var tmp$ret$2;
      $l$block_1: {
        var tmp$ret$1;
        $l$block_0: {
          tmp$ret$1 = collection;
          break $l$block_0;
        }
        var tmp0_unsafeCast_0 = tmp$ret$1.toArray();
        tmp$ret$2 = tmp0_unsafeCast_0;
        break $l$block_1;
      }
      tmp = tmp$ret$2;
    } else {
      {
        var tmp$ret$4;
        $l$block_3: {
          var tmp1_unsafeCast_0 = copyToArrayImpl(collection);
          var tmp$ret$3;
          $l$block_2: {
            tmp$ret$3 = tmp1_unsafeCast_0;
            break $l$block_2;
          }
          tmp$ret$4 = tmp$ret$3;
          break $l$block_3;
        }
        tmp = tmp$ret$4;
      }
    }
    return tmp;
  }
  function copyToArrayImpl(collection) {
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = [];
      break $l$block;
    }
    var array = tmp$ret$0;
    var iterator = collection.iterator_jk1svi_k$();
    while (iterator.hasNext_bitz1p_k$()) {
      var tmp$ret$1;
      $l$block_0: {
        tmp$ret$1 = array;
        break $l$block_0;
      }
      tmp$ret$1.push(iterator.next_20eer_k$());
    }
    return array;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_h4zzmr_k$ = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function IteratorImpl($outer) {
    this.$this_1 = $outer;
    this.index_1 = 0;
    this.last_1 = -1;
  }
  IteratorImpl.prototype.hasNext_bitz1p_k$ = function () {
    return this.index_1 < this.$this_1._get_size__809037418_ddoh9m_k$();
  };
  IteratorImpl.prototype.next_20eer_k$ = function () {
    if (!this.hasNext_bitz1p_k$())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this.index_1;
    tmp0_this.index_1 = tmp1 + 1 | 0;
    tmp.last_1 = tmp1;
    return this.$this_1.get_fkrdnv_k$(this.last_1);
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this.modCount_1 = 0;
  }
  AbstractMutableList.prototype._set_modCount__3570657354_7f6d5y_k$ = function (_set____804775014) {
    this.modCount_1 = _set____804775014;
  };
  AbstractMutableList.prototype._get_modCount__2796526142_os4sle_k$ = function () {
    return this.modCount_1;
  };
  AbstractMutableList.prototype.add_6wmvoe_k$ = function (element) {
    this.checkIsMutable_h4zzmr_k$();
    this.add_ty7c0g_k$(this._get_size__809037418_ddoh9m_k$(), element);
    return true;
  };
  AbstractMutableList.prototype.iterator_jk1svi_k$ = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_i4byw0_k$ = function (element) {
    return this.indexOf_q1puly_k$(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_q1puly_k$ = function (element) {
    var inductionVariable = 0;
    var last = _get_lastIndex__339712501(this);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.get_fkrdnv_k$(index), element)) {
          return index;
        }
      }
       while (!(index === last));
    return -1;
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals_evsvp0_k$(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode_2n0ag_k$(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function ArrayList_init_$Init$($this) {
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = [];
      break $l$block;
    }
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = [];
      break $l$block;
    }
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = copyToArray(elements);
      break $l$block;
    }
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    var tmp$ret$0;
    $l$block: {
      {
      }
      {
        Companion_getInstance().checkElementIndex_ux0wz1_k$(index, $this._get_size__809037418_ddoh9m_k$());
      }
      tmp$ret$0 = index;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function insertionRangeCheck($this, index) {
    var tmp$ret$0;
    $l$block: {
      {
      }
      {
        Companion_getInstance().checkPositionIndex_kxpgsw_k$(index, $this._get_size__809037418_ddoh9m_k$());
      }
      tmp$ret$0 = index;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this.array_1 = array;
    this.isReadOnly_1 = false;
  }
  ArrayList.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.array_1.length;
  };
  ArrayList.prototype.get_fkrdnv_k$ = function (index) {
    var tmp = this.array_1[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_6wmvoe_k$ = function (element) {
    this.checkIsMutable_h4zzmr_k$();
    var tmp$ret$0;
    $l$block: {
      var tmp0_asDynamic_0 = this.array_1;
      tmp$ret$0 = tmp0_asDynamic_0;
      break $l$block;
    }
    tmp$ret$0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__2796526142_os4sle_k$();
    tmp0_this._set_modCount__3570657354_7f6d5y_k$(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_ty7c0g_k$ = function (index, element) {
    this.checkIsMutable_h4zzmr_k$();
    var tmp$ret$0;
    $l$block: {
      var tmp0_asDynamic_0 = this.array_1;
      tmp$ret$0 = tmp0_asDynamic_0;
      break $l$block;
    }
    tmp$ret$0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__2796526142_os4sle_k$();
    tmp0_this._set_modCount__3570657354_7f6d5y_k$(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_q1puly_k$ = function (element) {
    return indexOf(this.array_1, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this.array_1);
  };
  ArrayList.prototype.toArray_jjyjqa_k$ = function () {
    return [].slice.call(this.array_1);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_jjyjqa_k$();
  };
  ArrayList.prototype.checkIsMutable_h4zzmr_k$ = function () {
    if (this.isReadOnly_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function isNaN_0(_this__1828080292) {
    return !(_this__1828080292 === _this__1828080292);
  }
  function _get_js__1413122402(_this__1828080292) {
    return (_this__1828080292 instanceof KClassImpl ? _this__1828080292 : THROW_CCE())._get_jClass__3892345245_6npl5v_k$();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this.jClass_1 = jClass;
  }
  KClassImpl.prototype._get_jClass__3892345245_6npl5v_k$ = function () {
    return this.jClass_1;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals(this._get_jClass__3892345245_6npl5v_k$(), other._get_jClass__3892345245_6npl5v_k$());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__973554894_g3mnri_k$();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return 'class ' + this._get_simpleName__973554894_g3mnri_k$();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this.givenSimpleName_1 = givenSimpleName;
    this.isInstanceFunction_1 = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this.givenSimpleName_1 === other.givenSimpleName_1 : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__973554894_g3mnri_k$ = function () {
    return this.givenSimpleName_1;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this.simpleName_1 = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__973554894_g3mnri_k$ = function () {
    return this.simpleName_1;
  };
  NothingKClassImpl.prototype._get_jClass__3892345245_6npl5v_k$ = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp$ret$1;
    $l$block_0: {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = jClass;
        break $l$block;
      }
      var tmp0_safe_receiver = tmp$ret$0.$metadata$;
      var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
      tmp$ret$1 = tmp0_unsafeCast_0;
      break $l$block_0;
    }
    tmp.simpleName_1 = tmp$ret$1;
  }
  SimpleKClassImpl.prototype._get_simpleName__973554894_g3mnri_k$ = function () {
    return this.simpleName_1;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KProperty1() {
  }
  KProperty1.$metadata$ = {
    simpleName: 'KProperty1',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty() {
  }
  KProperty.$metadata$ = {
    simpleName: 'KProperty',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function _get_functionClasses__573580451() {
    init_properties_primitives_kt_1669626638();
    return functionClasses;
  }
  var functionClasses;
  function PrimitiveClasses$anyClass$lambda() {
    return function (it) {
      return isObject(it);
    };
  }
  function PrimitiveClasses$numberClass$lambda() {
    return function (it) {
      return isNumber(it);
    };
  }
  function PrimitiveClasses$booleanClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'boolean' : false;
    };
  }
  function PrimitiveClasses$byteClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'number' : false;
    };
  }
  function PrimitiveClasses$shortClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'number' : false;
    };
  }
  function PrimitiveClasses$intClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'number' : false;
    };
  }
  function PrimitiveClasses$floatClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'number' : false;
    };
  }
  function PrimitiveClasses$doubleClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'number' : false;
    };
  }
  function PrimitiveClasses$arrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isArray(it) : false;
    };
  }
  function PrimitiveClasses$stringClass$lambda() {
    return function (it) {
      return !(it == null) ? typeof it === 'string' : false;
    };
  }
  function PrimitiveClasses$throwableClass$lambda() {
    return function (it) {
      return it instanceof Error;
    };
  }
  function PrimitiveClasses$booleanArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isBooleanArray(it) : false;
    };
  }
  function PrimitiveClasses$charArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isCharArray(it) : false;
    };
  }
  function PrimitiveClasses$byteArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isByteArray(it) : false;
    };
  }
  function PrimitiveClasses$shortArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isShortArray(it) : false;
    };
  }
  function PrimitiveClasses$intArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isIntArray(it) : false;
    };
  }
  function PrimitiveClasses$longArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isLongArray(it) : false;
    };
  }
  function PrimitiveClasses$floatArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isFloatArray(it) : false;
    };
  }
  function PrimitiveClasses$doubleArrayClass$lambda() {
    return function (it) {
      return !(it == null) ? isDoubleArray(it) : false;
    };
  }
  function PrimitiveClasses$functionClass$lambda($arity) {
    return function (it) {
      var tmp;
      if (typeof it === 'function') {
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = it;
          break $l$block;
        }
        tmp = tmp$ret$0.length === $arity;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function PrimitiveClasses() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = Object;
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    var tmp_0 = tmp$ret$0;
    tmp.anyClass_1 = new PrimitiveKClassImpl(tmp_0, 'Any', PrimitiveClasses$anyClass$lambda());
    var tmp_1 = this;
    var tmp$ret$1;
    $l$block_0: {
      var tmp0_unsafeCast_0_0 = Number;
      tmp$ret$1 = tmp0_unsafeCast_0_0;
      break $l$block_0;
    }
    var tmp_2 = tmp$ret$1;
    tmp_1.numberClass_1 = new PrimitiveKClassImpl(tmp_2, 'Number', PrimitiveClasses$numberClass$lambda());
    this.nothingClass_1 = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp$ret$2;
    $l$block_1: {
      var tmp0_unsafeCast_0_1 = Boolean;
      tmp$ret$2 = tmp0_unsafeCast_0_1;
      break $l$block_1;
    }
    var tmp_4 = tmp$ret$2;
    tmp_3.booleanClass_1 = new PrimitiveKClassImpl(tmp_4, 'Boolean', PrimitiveClasses$booleanClass$lambda());
    var tmp_5 = this;
    var tmp$ret$3;
    $l$block_2: {
      var tmp0_unsafeCast_0_2 = Number;
      tmp$ret$3 = tmp0_unsafeCast_0_2;
      break $l$block_2;
    }
    var tmp_6 = tmp$ret$3;
    tmp_5.byteClass_1 = new PrimitiveKClassImpl(tmp_6, 'Byte', PrimitiveClasses$byteClass$lambda());
    var tmp_7 = this;
    var tmp$ret$4;
    $l$block_3: {
      var tmp0_unsafeCast_0_3 = Number;
      tmp$ret$4 = tmp0_unsafeCast_0_3;
      break $l$block_3;
    }
    var tmp_8 = tmp$ret$4;
    tmp_7.shortClass_1 = new PrimitiveKClassImpl(tmp_8, 'Short', PrimitiveClasses$shortClass$lambda());
    var tmp_9 = this;
    var tmp$ret$5;
    $l$block_4: {
      var tmp0_unsafeCast_0_4 = Number;
      tmp$ret$5 = tmp0_unsafeCast_0_4;
      break $l$block_4;
    }
    var tmp_10 = tmp$ret$5;
    tmp_9.intClass_1 = new PrimitiveKClassImpl(tmp_10, 'Int', PrimitiveClasses$intClass$lambda());
    var tmp_11 = this;
    var tmp$ret$6;
    $l$block_5: {
      var tmp0_unsafeCast_0_5 = Number;
      tmp$ret$6 = tmp0_unsafeCast_0_5;
      break $l$block_5;
    }
    var tmp_12 = tmp$ret$6;
    tmp_11.floatClass_1 = new PrimitiveKClassImpl(tmp_12, 'Float', PrimitiveClasses$floatClass$lambda());
    var tmp_13 = this;
    var tmp$ret$7;
    $l$block_6: {
      var tmp0_unsafeCast_0_6 = Number;
      tmp$ret$7 = tmp0_unsafeCast_0_6;
      break $l$block_6;
    }
    var tmp_14 = tmp$ret$7;
    tmp_13.doubleClass_1 = new PrimitiveKClassImpl(tmp_14, 'Double', PrimitiveClasses$doubleClass$lambda());
    var tmp_15 = this;
    var tmp$ret$8;
    $l$block_7: {
      var tmp0_unsafeCast_0_7 = Array;
      tmp$ret$8 = tmp0_unsafeCast_0_7;
      break $l$block_7;
    }
    var tmp_16 = tmp$ret$8;
    tmp_15.arrayClass_1 = new PrimitiveKClassImpl(tmp_16, 'Array', PrimitiveClasses$arrayClass$lambda());
    var tmp_17 = this;
    var tmp$ret$9;
    $l$block_8: {
      var tmp0_unsafeCast_0_8 = String;
      tmp$ret$9 = tmp0_unsafeCast_0_8;
      break $l$block_8;
    }
    var tmp_18 = tmp$ret$9;
    tmp_17.stringClass_1 = new PrimitiveKClassImpl(tmp_18, 'String', PrimitiveClasses$stringClass$lambda());
    var tmp_19 = this;
    var tmp$ret$10;
    $l$block_9: {
      var tmp0_unsafeCast_0_9 = Error;
      tmp$ret$10 = tmp0_unsafeCast_0_9;
      break $l$block_9;
    }
    var tmp_20 = tmp$ret$10;
    tmp_19.throwableClass_1 = new PrimitiveKClassImpl(tmp_20, 'Throwable', PrimitiveClasses$throwableClass$lambda());
    var tmp_21 = this;
    var tmp$ret$11;
    $l$block_10: {
      var tmp0_unsafeCast_0_10 = Array;
      tmp$ret$11 = tmp0_unsafeCast_0_10;
      break $l$block_10;
    }
    var tmp_22 = tmp$ret$11;
    tmp_21.booleanArrayClass_1 = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', PrimitiveClasses$booleanArrayClass$lambda());
    var tmp_23 = this;
    var tmp$ret$12;
    $l$block_11: {
      var tmp0_unsafeCast_0_11 = Uint16Array;
      tmp$ret$12 = tmp0_unsafeCast_0_11;
      break $l$block_11;
    }
    var tmp_24 = tmp$ret$12;
    tmp_23.charArrayClass_1 = new PrimitiveKClassImpl(tmp_24, 'CharArray', PrimitiveClasses$charArrayClass$lambda());
    var tmp_25 = this;
    var tmp$ret$13;
    $l$block_12: {
      var tmp0_unsafeCast_0_12 = Int8Array;
      tmp$ret$13 = tmp0_unsafeCast_0_12;
      break $l$block_12;
    }
    var tmp_26 = tmp$ret$13;
    tmp_25.byteArrayClass_1 = new PrimitiveKClassImpl(tmp_26, 'ByteArray', PrimitiveClasses$byteArrayClass$lambda());
    var tmp_27 = this;
    var tmp$ret$14;
    $l$block_13: {
      var tmp0_unsafeCast_0_13 = Int16Array;
      tmp$ret$14 = tmp0_unsafeCast_0_13;
      break $l$block_13;
    }
    var tmp_28 = tmp$ret$14;
    tmp_27.shortArrayClass_1 = new PrimitiveKClassImpl(tmp_28, 'ShortArray', PrimitiveClasses$shortArrayClass$lambda());
    var tmp_29 = this;
    var tmp$ret$15;
    $l$block_14: {
      var tmp0_unsafeCast_0_14 = Int32Array;
      tmp$ret$15 = tmp0_unsafeCast_0_14;
      break $l$block_14;
    }
    var tmp_30 = tmp$ret$15;
    tmp_29.intArrayClass_1 = new PrimitiveKClassImpl(tmp_30, 'IntArray', PrimitiveClasses$intArrayClass$lambda());
    var tmp_31 = this;
    var tmp$ret$16;
    $l$block_15: {
      var tmp0_unsafeCast_0_15 = Array;
      tmp$ret$16 = tmp0_unsafeCast_0_15;
      break $l$block_15;
    }
    var tmp_32 = tmp$ret$16;
    tmp_31.longArrayClass_1 = new PrimitiveKClassImpl(tmp_32, 'LongArray', PrimitiveClasses$longArrayClass$lambda());
    var tmp_33 = this;
    var tmp$ret$17;
    $l$block_16: {
      var tmp0_unsafeCast_0_16 = Float32Array;
      tmp$ret$17 = tmp0_unsafeCast_0_16;
      break $l$block_16;
    }
    var tmp_34 = tmp$ret$17;
    tmp_33.floatArrayClass_1 = new PrimitiveKClassImpl(tmp_34, 'FloatArray', PrimitiveClasses$floatArrayClass$lambda());
    var tmp_35 = this;
    var tmp$ret$18;
    $l$block_17: {
      var tmp0_unsafeCast_0_17 = Float64Array;
      tmp$ret$18 = tmp0_unsafeCast_0_17;
      break $l$block_17;
    }
    var tmp_36 = tmp$ret$18;
    tmp_35.doubleArrayClass_1 = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', PrimitiveClasses$doubleArrayClass$lambda());
  }
  PrimitiveClasses.prototype._get_anyClass__2722679391_q03l41_k$ = function () {
    return this.anyClass_1;
  };
  PrimitiveClasses.prototype._get_numberClass__2243734466_xx91dq_k$ = function () {
    return this.numberClass_1;
  };
  PrimitiveClasses.prototype._get_nothingClass__2888957184_n93ocg_k$ = function () {
    return this.nothingClass_1;
  };
  PrimitiveClasses.prototype._get_booleanClass__1099338011_i6immz_k$ = function () {
    return this.booleanClass_1;
  };
  PrimitiveClasses.prototype._get_byteClass__3017072385_l4tq0v_k$ = function () {
    return this.byteClass_1;
  };
  PrimitiveClasses.prototype._get_shortClass__2900162991_n2fhw1_k$ = function () {
    return this.shortClass_1;
  };
  PrimitiveClasses.prototype._get_intClass__1005394466_gml3c2_k$ = function () {
    return this.intClass_1;
  };
  PrimitiveClasses.prototype._get_floatClass__141668239_2ccfwv_k$ = function () {
    return this.floatClass_1;
  };
  PrimitiveClasses.prototype._get_doubleClass__2234697290_y2mqie_k$ = function () {
    return this.doubleClass_1;
  };
  PrimitiveClasses.prototype._get_arrayClass__2667531724_qwxlbo_k$ = function () {
    return this.arrayClass_1;
  };
  PrimitiveClasses.prototype._get_stringClass__1269070474_kzkl1m_k$ = function () {
    return this.stringClass_1;
  };
  PrimitiveClasses.prototype._get_throwableClass__2200583411_ymxwy5_k$ = function () {
    return this.throwableClass_1;
  };
  PrimitiveClasses.prototype._get_booleanArrayClass__3316760394_g6ed9y_k$ = function () {
    return this.booleanArrayClass_1;
  };
  PrimitiveClasses.prototype._get_charArrayClass__2352161302_w4p2p6_k$ = function () {
    return this.charArrayClass_1;
  };
  PrimitiveClasses.prototype._get_byteArrayClass__2177249572_z0u1gc_k$ = function () {
    return this.byteArrayClass_1;
  };
  PrimitiveClasses.prototype._get_shortArrayClass__1957270326_wdb3g6_k$ = function () {
    return this.shortArrayClass_1;
  };
  PrimitiveClasses.prototype._get_intArrayClass__787137187_d0n2xv_k$ = function () {
    return this.intArrayClass_1;
  };
  PrimitiveClasses.prototype._get_longArrayClass__2852100912_nv1mts_k$ = function () {
    return this.longArrayClass_1;
  };
  PrimitiveClasses.prototype._get_floatArrayClass__2432403798_usx76y_k$ = function () {
    return this.floatArrayClass_1;
  };
  PrimitiveClasses.prototype._get_doubleArrayClass__2928832379_mld0g5_k$ = function () {
    return this.doubleArrayClass_1;
  };
  PrimitiveClasses.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = _get_functionClasses__573580451()[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$3;
      $l$block_2: {
        {
        }
        var tmp$ret$2;
        $l$block_1: {
          var tmp$ret$0;
          $l$block: {
            var tmp0_unsafeCast_0_3 = Function;
            tmp$ret$0 = tmp0_unsafeCast_0_3;
            break $l$block;
          }
          var tmp_0 = tmp$ret$0;
          var tmp_1 = 'Function' + arity;
          var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, PrimitiveClasses$functionClass$lambda(arity));
          var tmp$ret$1;
          $l$block_0: {
            var tmp1_asDynamic_0_5 = _get_functionClasses__573580451();
            tmp$ret$1 = tmp1_asDynamic_0_5;
            break $l$block_0;
          }
          tmp$ret$1[arity] = result_2;
          tmp$ret$2 = result_2;
          break $l$block_1;
        }
        tmp$ret$3 = tmp$ret$2;
        break $l$block_2;
      }
      tmp = tmp$ret$3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_anyClass__2722679391_q03l41_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_numberClass__2243734466_xx91dq_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_nothingClass__2888957184_n93ocg_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_booleanClass__1099338011_i6immz_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_byteClass__3017072385_l4tq0v_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_shortClass__2900162991_n2fhw1_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_intClass__1005394466_gml3c2_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_floatClass__141668239_2ccfwv_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_doubleClass__2234697290_y2mqie_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_arrayClass__2667531724_qwxlbo_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_stringClass__1269070474_kzkl1m_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_throwableClass__2200583411_ymxwy5_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_booleanArrayClass__3316760394_g6ed9y_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_charArrayClass__2352161302_w4p2p6_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_byteArrayClass__2177249572_z0u1gc_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_shortArrayClass__1957270326_wdb3g6_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_intArrayClass__787137187_d0n2xv_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_longArrayClass__2852100912_nv1mts_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_floatArrayClass__2432403798_usx76y_k$
  });
  Object.defineProperty(PrimitiveClasses.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses.prototype._get_doubleArrayClass__2928832379_mld0g5_k$
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses();
    return PrimitiveClasses_instance;
  }
  var properties_initialized_primitives_kt_3110183218;
  function init_properties_primitives_kt_1669626638() {
    if (!properties_initialized_primitives_kt_3110183218) {
      properties_initialized_primitives_kt_3110183218 = true;
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = fillArrayVal(Array(0), null);
        break $l$block;
      }
      functionClasses = tmp$ret$0;
    }
  }
  function getKClass(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      var tmp$ret$1;
      $l$block_0: {
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = jClass;
          break $l$block;
        }
        tmp$ret$1 = tmp$ret$0;
        break $l$block_0;
      }
      tmp = getKClassM(tmp$ret$1);
    } else {
      var tmp$ret$3;
      $l$block_2: {
        var tmp$ret$2;
        $l$block_1: {
          tmp$ret$2 = jClass;
          break $l$block_1;
        }
        tmp$ret$3 = tmp$ret$2;
        break $l$block_2;
      }
      tmp = getKClass1(tmp$ret$3);
    }
    return tmp;
  }
  function getKClassM(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1(jClasses[0]);
        break;
      case 0:
        var tmp$ret$1;
        $l$block_0: {
          var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
          var tmp$ret$0;
          $l$block: {
            tmp$ret$0 = tmp0_unsafeCast_0;
            break $l$block;
          }
          tmp$ret$1 = tmp$ret$0;
          break $l$block_0;
        }

        tmp = tmp$ret$1;
        break;
      default:
        var tmp$ret$3;
        $l$block_2: {
          var tmp1_unsafeCast_0 = new ErrorKClass();
          var tmp$ret$2;
          $l$block_1: {
            tmp$ret$2 = tmp1_unsafeCast_0;
            break $l$block_1;
          }
          tmp$ret$3 = tmp$ret$2;
          break $l$block_2;
        }

        tmp = tmp$ret$3;
        break;
    }
    return tmp;
  }
  function getKClass1(jClass) {
    if (jClass === String) {
      var tmp$ret$1;
      $l$block_0: {
        var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._get_stringClass__1269070474_kzkl1m_k$();
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = tmp0_unsafeCast_0;
          break $l$block;
        }
        tmp$ret$1 = tmp$ret$0;
        break $l$block_0;
      }
      return tmp$ret$1;
    }
    var tmp$ret$2;
    $l$block_1: {
      tmp$ret$2 = jClass;
      break $l$block_1;
    }
    var metadata = tmp$ret$2.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$() {
    return StringBuilder_init_$Init$(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this.string_1 = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype.append_t8oh9e_k$ = function (value) {
    var tmp0_this = this;
    tmp0_this.string_1 = tmp0_this.string_1 + new Char(value);
    return this;
  };
  StringBuilder.prototype.append_oz4qxs_k$ = function (value) {
    var tmp0_this = this;
    tmp0_this.string_1 = tmp0_this.string_1 + toString_0(value);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this.string_1;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function _Char___init__impl__380027157(value) {
    return value;
  }
  function _get_value__3683422336($this) {
    return $this;
  }
  function Char__compareTo_impl_2098686179(this_0, other) {
    return _get_value__3683422336(this_0) - _get_value__3683422336(other) | 0;
  }
  function Char__compareTo_impl_2098686179_0(this_0, other) {
    var tmp = this_0.value_1;
    return Char__compareTo_impl_2098686179(tmp, other instanceof Char ? other.value_1 : THROW_CCE());
  }
  function Char__equals_impl_2289177560(this_0, other) {
    if (!(other instanceof Char))
      return false;
    else {
    }
    return _get_value__3683422336(this_0) === _get_value__3683422336(other.value_1);
  }
  function Char__hashCode_impl_4253273724(this_0) {
    return _get_value__3683422336(this_0);
  }
  function toString(this_0) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = String.fromCharCode(_get_value__3683422336(this_0));
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.MIN_VALUE_1 = _Char___init__impl__380027157(0);
    this.MAX_VALUE_1 = _Char___init__impl__380027157(65535);
    this.MIN_HIGH_SURROGATE_1 = _Char___init__impl__380027157(55296);
    this.MAX_HIGH_SURROGATE_1 = _Char___init__impl__380027157(56319);
    this.MIN_LOW_SURROGATE_1 = _Char___init__impl__380027157(56320);
    this.MAX_LOW_SURROGATE_1 = _Char___init__impl__380027157(57343);
    this.MIN_SURROGATE_1 = _Char___init__impl__380027157(55296);
    this.MAX_SURROGATE_1 = _Char___init__impl__380027157(57343);
    this.SIZE_BYTES_1 = 2;
    this.SIZE_BITS_1 = 16;
  }
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function Char(value) {
    Companion_getInstance_0();
    this.value_1 = value;
  }
  Char.prototype.compareTo_n49u4k_k$ = function (other) {
    return Char__compareTo_impl_2098686179(this.value_1, other);
  };
  Char.prototype.compareTo_n48p4x_k$ = function (other) {
    return Char__compareTo_impl_2098686179_0(this, other);
  };
  Char.prototype.equals = function (other) {
    return Char__equals_impl_2289177560(this.value_1, other);
  };
  Char.prototype.hashCode = function () {
    return Char__hashCode_impl_4253273724(this.value_1);
  };
  Char.prototype.toString = function () {
    return toString(this.value_1);
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Companion_1() {
    Companion_instance_1 = this;
  }
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_1();
    this.name_1 = name;
    this.ordinal_1 = ordinal;
  }
  Enum.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  Enum.prototype._get_ordinal__3363892928_fec5kw_k$ = function () {
    return this.ordinal_1;
  };
  Enum.prototype.compareTo_oyy8sa_k$ = function (other) {
    return compareTo(this.ordinal_1, other.ordinal_1);
  };
  Enum.prototype.compareTo_n48p4x_k$ = function (other) {
    return this.compareTo_oyy8sa_k$(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this.name_1;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this__1828080292) {
    var tmp0_safe_receiver = _this__1828080292;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last = array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last));
    return array;
  }
  function arrayIterator(array) {
    return new arrayIterator$1(array);
  }
  function arrayIterator$1($array) {
    this.$array_1 = $array;
    this.index_1 = 0;
  }
  arrayIterator$1.prototype.hasNext_bitz1p_k$ = function () {
    return !(this.index_1 === this.$array_1.length);
  };
  arrayIterator$1.prototype.next_20eer_k$ = function () {
    var tmp;
    if (!(this.index_1 === this.$array_1.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.index_1;
      tmp0_this.index_1 = tmp1 + 1 | 0;
      tmp = this.$array_1[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this.index_1);
    }
    return tmp;
  };
  arrayIterator$1.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _get_buf__856886398() {
    init_properties_bitUtils_kt_782416278();
    return buf;
  }
  var buf;
  function _get_bufFloat64__3281801540() {
    init_properties_bitUtils_kt_782416278();
    return bufFloat64;
  }
  var bufFloat64;
  var bufFloat32;
  function _get_bufInt32__721419088() {
    init_properties_bitUtils_kt_782416278();
    return bufInt32;
  }
  var bufInt32;
  function _get_lowIndex__162050477() {
    init_properties_bitUtils_kt_782416278();
    return lowIndex;
  }
  var lowIndex;
  function _get_highIndex__2347002881() {
    init_properties_bitUtils_kt_782416278();
    return highIndex;
  }
  var highIndex;
  function getNumberHashCode(obj) {
    init_properties_bitUtils_kt_782416278();
    var tmp$ret$1;
    $l$block_0: {
      var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = tmp0_unsafeCast_0;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0;
      break $l$block_0;
    }
    if (tmp$ret$1 === obj) {
      return numberToInt(obj);
    } else {
    }
    _get_bufFloat64__3281801540()[0] = obj;
    return imul(_get_bufInt32__721419088()[_get_highIndex__2347002881()], 31) + _get_bufInt32__721419088()[_get_lowIndex__162050477()] | 0;
  }
  var properties_initialized_bitUtils_kt_1092294842;
  function init_properties_bitUtils_kt_782416278() {
    if (!properties_initialized_bitUtils_kt_1092294842) {
      properties_initialized_bitUtils_kt_1092294842 = true;
      buf = new ArrayBuffer(8);
      var tmp$ret$1;
      $l$block_0: {
        var tmp0_unsafeCast_0 = new Float64Array(_get_buf__856886398());
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = tmp0_unsafeCast_0;
          break $l$block;
        }
        tmp$ret$1 = tmp$ret$0;
        break $l$block_0;
      }
      bufFloat64 = tmp$ret$1;
      var tmp$ret$1_0;
      $l$block_2: {
        var tmp0_unsafeCast_0_0 = new Float32Array(_get_buf__856886398());
        var tmp$ret$0_0;
        $l$block_1: {
          tmp$ret$0_0 = tmp0_unsafeCast_0_0;
          break $l$block_1;
        }
        tmp$ret$1_0 = tmp$ret$0_0;
        break $l$block_2;
      }
      bufFloat32 = tmp$ret$1_0;
      var tmp$ret$1_1;
      $l$block_4: {
        var tmp0_unsafeCast_0_1 = new Int32Array(_get_buf__856886398());
        var tmp$ret$0_1;
        $l$block_3: {
          tmp$ret$0_1 = tmp0_unsafeCast_0_1;
          break $l$block_3;
        }
        tmp$ret$1_1 = tmp$ret$0_1;
        break $l$block_4;
      }
      bufInt32 = tmp$ret$1_1;
      var tmp$ret$1_2;
      $l$block_6: {
        {
        }
        var tmp$ret$0_2;
        $l$block_5: {
          _get_bufFloat64__3281801540()[0] = -1.0;
          tmp$ret$0_2 = !(_get_bufInt32__721419088()[0] === 0) ? 1 : 0;
          break $l$block_5;
        }
        tmp$ret$1_2 = tmp$ret$0_2;
        break $l$block_6;
      }
      lowIndex = tmp$ret$1_2;
      highIndex = 1 - _get_lowIndex__162050477() | 0;
    }
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, arrayToString$lambda(), 24, null);
  }
  function arrayToString$lambda() {
    return function (it) {
      return toString_1(it);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_ygsx0s_k$());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:
        tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = 1;
          break $l$block;
        }
        var ia = tmp$ret$0 / a;
        var tmp_1;
        var tmp$ret$1;
        $l$block_0: {
          tmp$ret$1 = 1;
          break $l$block_0;
        }
        if (ia === tmp$ret$1 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_n48p4x_k$(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }
    if (obj2 == null) {
      return false;
    }
    if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }
    if (obj1 !== obj1) {
      return obj2 !== obj2;
    }
    if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp$ret$0;
          $l$block: {
            tmp$ret$0 = 1;
            break $l$block;
          }
          var tmp_1 = tmp$ret$0 / obj1;
          var tmp$ret$1;
          $l$block_0: {
            tmp$ret$1 = 1;
            break $l$block_0;
          }
          tmp_0 = tmp_1 === tmp$ret$1 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }
    return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = obj;
          break $l$block;
        }

        if (tmp$ret$0) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:
        tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp$ret$0;
      $l$block: {
        var tmp0_unsafeCast_0 = o.toString();
        tmp$ret$0 = tmp0_unsafeCast_0;
        break $l$block;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last = length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = str;
          break $l$block;
        }
        var code = tmp$ret$0.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last));
    return hash;
  }
  function boxIntrinsic(x) {
    throw IllegalStateException_init_$Create$_0('Should be lowered');
  }
  function unboxIntrinsic(x) {
    throw IllegalStateException_init_$Create$_0('Should be lowered');
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = instance;
        break $l$block;
      }
      tmp$ret$0.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }
    if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }
    this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function THROW_ISE() {
    throw IllegalStateException_init_$Create$();
  }
  function Companion_2() {
    Companion_instance_2 = this;
    this.MIN_VALUE_1 = new Long(0, -2147483648);
    this.MAX_VALUE_1 = new Long(-1, 2147483647);
    this.SIZE_BYTES_1 = 8;
    this.SIZE_BITS_1 = 64;
  }
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function Long(low, high) {
    Companion_getInstance_2();
    Number_0.call(this);
    this.low_1 = low;
    this.high_1 = high;
  }
  Long.prototype._get_low__857179069_e6cblp_k$ = function () {
    return this.low_1;
  };
  Long.prototype._get_high__798860521_d7mcq1_k$ = function () {
    return this.high_1;
  };
  Long.prototype.compareTo_n4fqi2_k$ = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_n48p4x_k$ = function (other) {
    return this.compareTo_n4fqi2_k$(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_u6jwas_k$ = function (other) {
    return add(this, other);
  };
  Long.prototype.div_9s1fi3_k$ = function (other) {
    return divide(this, other);
  };
  Long.prototype.unaryMinus_6uz0qp_k$ = function () {
    return this.inv_28kx_k$().plus_u6jwas_k$(new Long(1, 0));
  };
  Long.prototype.inv_28kx_k$ = function () {
    return new Long(~this.low_1, ~this.high_1);
  };
  Long.prototype.toInt_1tsl84_k$ = function () {
    return this.low_1;
  };
  Long.prototype.toDouble_ygsx0s_k$ = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_ygsx0s_k$();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _get_ZERO__784837795() {
    init_properties_longjs_kt_2491794837();
    return ZERO;
  }
  var ZERO;
  function _get_ONE__856281867() {
    init_properties_longjs_kt_2491794837();
    return ONE;
  }
  var ONE;
  function _get_NEG_ONE__3857310458() {
    init_properties_longjs_kt_2491794837();
    return NEG_ONE;
  }
  var NEG_ONE;
  function _get_MAX_VALUE__3201573499() {
    init_properties_longjs_kt_2491794837();
    return MAX_VALUE;
  }
  var MAX_VALUE;
  function _get_MIN_VALUE__1378605517() {
    init_properties_longjs_kt_2491794837();
    return MIN_VALUE;
  }
  var MIN_VALUE;
  function _get_TWO_PWR_24___3968246811() {
    init_properties_longjs_kt_2491794837();
    return TWO_PWR_24_;
  }
  var TWO_PWR_24_;
  function compare(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    if (equalsLong(_this__1828080292, other)) {
      return 0;
    }
    var thisNeg = isNegative(_this__1828080292);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this__1828080292, other)) ? -1 : 1;
  }
  function add(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    var a48 = _this__1828080292._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var a32 = _this__1828080292._get_high__798860521_d7mcq1_k$() & 65535;
    var a16 = _this__1828080292._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var a00 = _this__1828080292._get_low__857179069_e6cblp_k$() & 65535;
    var b48 = other._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var b32 = other._get_high__798860521_d7mcq1_k$() & 65535;
    var b16 = other._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var b00 = other._get_low__857179069_e6cblp_k$() & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return add(_this__1828080292, other.unaryMinus_6uz0qp_k$());
  }
  function multiply(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    if (isZero(_this__1828080292)) {
      return _get_ZERO__784837795();
    } else if (isZero(other)) {
      return _get_ZERO__784837795();
    }
    if (equalsLong(_this__1828080292, _get_MIN_VALUE__1378605517())) {
      return isOdd(other) ? _get_MIN_VALUE__1378605517() : _get_ZERO__784837795();
    } else if (equalsLong(other, _get_MIN_VALUE__1378605517())) {
      return isOdd(_this__1828080292) ? _get_MIN_VALUE__1378605517() : _get_ZERO__784837795();
    }
    if (isNegative(_this__1828080292)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this__1828080292), negate(other));
      } else {
        tmp = negate(multiply(negate(_this__1828080292), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this__1828080292, negate(other)));
    }
    if (lessThan(_this__1828080292, _get_TWO_PWR_24___3968246811()) ? lessThan(other, _get_TWO_PWR_24___3968246811()) : false) {
      return fromNumber(toNumber(_this__1828080292) * toNumber(other));
    }
    var a48 = _this__1828080292._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var a32 = _this__1828080292._get_high__798860521_d7mcq1_k$() & 65535;
    var a16 = _this__1828080292._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var a00 = _this__1828080292._get_low__857179069_e6cblp_k$() & 65535;
    var b48 = other._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var b32 = other._get_high__798860521_d7mcq1_k$() & 65535;
    var b16 = other._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var b00 = other._get_low__857179069_e6cblp_k$() & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this__1828080292)) {
      return _get_ZERO__784837795();
    }
    if (equalsLong(_this__1828080292, _get_MIN_VALUE__1378605517())) {
      if (equalsLong(other, _get_ONE__856281867()) ? true : equalsLong(other, _get_NEG_ONE__3857310458())) {
        return _get_MIN_VALUE__1378605517();
      } else if (equalsLong(other, _get_MIN_VALUE__1378605517())) {
        return _get_ONE__856281867();
      } else {
        var halfThis = shiftRight(_this__1828080292, 1);
        var approx = shiftLeft(halfThis.div_9s1fi3_k$(other), 1);
        if (equalsLong(approx, _get_ZERO__784837795())) {
          return isNegative(other) ? _get_ONE__856281867() : _get_NEG_ONE__3857310458();
        } else {
          var rem = subtract(_this__1828080292, multiply(other, approx));
          return add(approx, rem.div_9s1fi3_k$(other));
        }
      }
    } else if (equalsLong(other, _get_MIN_VALUE__1378605517())) {
      return _get_ZERO__784837795();
    }
    if (isNegative(_this__1828080292)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this__1828080292).div_9s1fi3_k$(negate(other));
      } else {
        tmp = negate(negate(_this__1828080292).div_9s1fi3_k$(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this__1828080292.div_9s1fi3_k$(negate(other)));
    }
    var res = _get_ZERO__784837795();
    var rem_0 = _this__1828080292;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2.0, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = _get_ONE__856281867();
      }
      res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this__1828080292, numBits) {
    init_properties_longjs_kt_2491794837();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__1828080292;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__1828080292._get_low__857179069_e6cblp_k$() << numBits_0, _this__1828080292._get_high__798860521_d7mcq1_k$() << numBits_0 | (_this__1828080292._get_low__857179069_e6cblp_k$() >>> (32 - numBits_0 | 0) | 0));
      } else {
        return new Long(0, _this__1828080292._get_low__857179069_e6cblp_k$() << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this__1828080292, numBits) {
    init_properties_longjs_kt_2491794837();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__1828080292;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__1828080292._get_low__857179069_e6cblp_k$() >>> numBits_0 | 0 | _this__1828080292._get_high__798860521_d7mcq1_k$() << (32 - numBits_0 | 0), _this__1828080292._get_high__798860521_d7mcq1_k$() >> numBits_0);
      } else {
        return new Long(_this__1828080292._get_high__798860521_d7mcq1_k$() >> (numBits_0 - 32 | 0), _this__1828080292._get_high__798860521_d7mcq1_k$() >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() * 4.294967296E9 + getLowBitsUnsigned(_this__1828080292);
  }
  function equalsLong(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() === other._get_high__798860521_d7mcq1_k$() ? _this__1828080292._get_low__857179069_e6cblp_k$() === other._get_low__857179069_e6cblp_k$() : false;
  }
  function hashCode_0(l) {
    init_properties_longjs_kt_2491794837();
    return l._get_low__857179069_e6cblp_k$() ^ l._get_high__798860521_d7mcq1_k$();
  }
  function toStringImpl(_this__1828080292, radix) {
    init_properties_longjs_kt_2491794837();
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('radix out of range: ' + radix);
    }
    if (isZero(_this__1828080292)) {
      return '0';
    }
    if (isNegative(_this__1828080292)) {
      if (equalsLong(_this__1828080292, _get_MIN_VALUE__1378605517())) {
        var radixLong = fromInt(radix);
        var div = _this__1828080292.div_9s1fi3_k$(radixLong);
        var rem = subtract(multiply(div, radixLong), _this__1828080292).toInt_1tsl84_k$();
        var tmp = toStringImpl(div, radix);
        var tmp$ret$1;
        $l$block_0: {
          var tmp$ret$0;
          $l$block: {
            tmp$ret$0 = rem;
            break $l$block;
          }
          var tmp0_unsafeCast_0 = tmp$ret$0.toString(radix);
          tmp$ret$1 = tmp0_unsafeCast_0;
          break $l$block_0;
        }
        return tmp + tmp$ret$1;
      } else {
        return '-' + toStringImpl(negate(_this__1828080292), radix);
      }
    }
    var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this__1828080292;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_9s1fi3_k$(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_1tsl84_k$();
      var tmp$ret$3;
      $l$block_2: {
        var tmp$ret$2;
        $l$block_1: {
          tmp$ret$2 = intval;
          break $l$block_1;
        }
        var tmp1_unsafeCast_0 = tmp$ret$2.toString(radix);
        tmp$ret$3 = tmp1_unsafeCast_0;
        break $l$block_2;
      }
      var digits = tmp$ret$3;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    init_properties_longjs_kt_2491794837();
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() < 0;
  }
  function isZero(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() === 0 ? _this__1828080292._get_low__857179069_e6cblp_k$() === 0 : false;
  }
  function isOdd(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return (_this__1828080292._get_low__857179069_e6cblp_k$() & 1) === 1;
  }
  function negate(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292.unaryMinus_6uz0qp_k$();
  }
  function lessThan(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return compare(_this__1828080292, other) < 0;
  }
  function fromNumber(value) {
    init_properties_longjs_kt_2491794837();
    if (isNaN_0(value)) {
      return _get_ZERO__784837795();
    } else if (value <= -9.223372036854776E18) {
      return _get_MIN_VALUE__1378605517();
    } else if (value + 1 >= 9.223372036854776E18) {
      return _get_MAX_VALUE__3201573499();
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return compare(_this__1828080292, other) > 0;
  }
  function greaterThanOrEqual(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return compare(_this__1828080292, other) >= 0;
  }
  function getLowBitsUnsigned(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_low__857179069_e6cblp_k$() >= 0 ? _this__1828080292._get_low__857179069_e6cblp_k$() : 4.294967296E9 + _this__1828080292._get_low__857179069_e6cblp_k$();
  }
  var properties_initialized_longjs_kt_320052665;
  function init_properties_longjs_kt_2491794837() {
    if (!properties_initialized_longjs_kt_320052665) {
      properties_initialized_longjs_kt_320052665 = true;
      ZERO = fromInt(0);
      ONE = fromInt(1);
      NEG_ONE = fromInt(-1);
      MAX_VALUE = new Long(-1, 2147483647);
      MIN_VALUE = new Long(0, -2147483648);
      TWO_PWR_24_ = fromInt(16777216);
    }
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_1tsl84_k$();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function _get_propertyRefClassMetadataCache__1118137304() {
    init_properties_reflectRuntime_kt_2213475647();
    return propertyRefClassMetadataCache;
  }
  var propertyRefClassMetadataCache;
  function getPropertyCallableRef(name, paramCount, type, getter, setter) {
    init_properties_reflectRuntime_kt_2213475647();
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = getPropertyRefClass(getter, getKPropMetadata(paramCount, setter, type));
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function getPropertyRefClass(obj, metadata) {
    init_properties_reflectRuntime_kt_2213475647();
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    return obj;
  }
  function getKPropMetadata(paramCount, setter, type) {
    init_properties_reflectRuntime_kt_2213475647();
    var mdata = _get_propertyRefClassMetadataCache__1118137304()[paramCount][setter == null ? 0 : 1];
    if (mdata.interfaces.length == 0) {
      mdata.interfaces.push(type);
    }
    return mdata;
  }
  var properties_initialized_reflectRuntime_kt_3166988643;
  function init_properties_reflectRuntime_kt_2213475647() {
    if (!properties_initialized_reflectRuntime_kt_3166988643) {
      properties_initialized_reflectRuntime_kt_3166988643 = true;
      var tmp$ret$17;
      $l$block_16: {
        var tmp$ret$4;
        $l$block_3: {
          var tmp$ret$0;
          $l$block: {
            tmp$ret$0 = {kind: 'class', interfaces: []};
            break $l$block;
          }
          var tmp = tmp$ret$0;
          var tmp$ret$1;
          $l$block_0: {
            tmp$ret$1 = {kind: 'class', interfaces: []};
            break $l$block_0;
          }
          var tmp0_arrayOf_0 = [tmp, tmp$ret$1];
          var tmp$ret$3;
          $l$block_2: {
            var tmp$ret$2;
            $l$block_1: {
              tmp$ret$2 = tmp0_arrayOf_0;
              break $l$block_1;
            }
            tmp$ret$3 = tmp$ret$2;
            break $l$block_2;
          }
          tmp$ret$4 = tmp$ret$3;
          break $l$block_3;
        }
        var tmp_0 = tmp$ret$4;
        var tmp$ret$9;
        $l$block_8: {
          var tmp$ret$5;
          $l$block_4: {
            tmp$ret$5 = {kind: 'class', interfaces: []};
            break $l$block_4;
          }
          var tmp_1 = tmp$ret$5;
          var tmp$ret$6;
          $l$block_5: {
            tmp$ret$6 = {kind: 'class', interfaces: []};
            break $l$block_5;
          }
          var tmp1_arrayOf_0 = [tmp_1, tmp$ret$6];
          var tmp$ret$8;
          $l$block_7: {
            var tmp$ret$7;
            $l$block_6: {
              tmp$ret$7 = tmp1_arrayOf_0;
              break $l$block_6;
            }
            tmp$ret$8 = tmp$ret$7;
            break $l$block_7;
          }
          tmp$ret$9 = tmp$ret$8;
          break $l$block_8;
        }
        var tmp_2 = tmp$ret$9;
        var tmp$ret$14;
        $l$block_13: {
          var tmp$ret$10;
          $l$block_9: {
            tmp$ret$10 = {kind: 'class', interfaces: []};
            break $l$block_9;
          }
          var tmp_3 = tmp$ret$10;
          var tmp$ret$11;
          $l$block_10: {
            tmp$ret$11 = {kind: 'class', interfaces: []};
            break $l$block_10;
          }
          var tmp2_arrayOf_0 = [tmp_3, tmp$ret$11];
          var tmp$ret$13;
          $l$block_12: {
            var tmp$ret$12;
            $l$block_11: {
              tmp$ret$12 = tmp2_arrayOf_0;
              break $l$block_11;
            }
            tmp$ret$13 = tmp$ret$12;
            break $l$block_12;
          }
          tmp$ret$14 = tmp$ret$13;
          break $l$block_13;
        }
        var tmp3_arrayOf_0 = [tmp_0, tmp_2, tmp$ret$14];
        var tmp$ret$16;
        $l$block_15: {
          var tmp$ret$15;
          $l$block_14: {
            tmp$ret$15 = tmp3_arrayOf_0;
            break $l$block_14;
          }
          tmp$ret$16 = tmp$ret$15;
          break $l$block_15;
        }
        tmp$ret$17 = tmp$ret$16;
        break $l$block_16;
      }
      propertyRefClassMetadataCache = tmp$ret$17;
    }
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp$ret$0;
      $l$block: {
        var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
        tmp$ret$0 = tmp0_unsafeCast_0;
        break $l$block;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = Array.isArray(obj);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }
      }
    }
    var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = obj;
        break $l$block;
      }
      tmp = !tmp$ret$0.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:
        return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js__1413122402(getKClass(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return jsInstanceOf(a, Uint16Array) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function asList(_this__1828080292) {
    var tmp$ret$1;
    $l$block_0: {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = _this__1828080292;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0;
      break $l$block_0;
    }
    return new ArrayList(tmp$ret$1);
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = jsIn$outlinedJsCode$(lhs_hack, rhs_hack);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = jsBitwiseOr$outlinedJsCode$(lhs_hack, rhs_hack);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function jsTypeOf(value_hack) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = jsTypeOf$outlinedJsCode$(value_hack);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = jsInstanceOf$outlinedJsCode$(obj_hack, jsClass_hack);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function jsIn$outlinedJsCode$(lhs_hack, rhs_hack) {
    return lhs_hack in rhs_hack;
  }
  function jsBitwiseOr$outlinedJsCode$(lhs_hack, rhs_hack) {
    return lhs_hack | rhs_hack;
  }
  function jsTypeOf$outlinedJsCode$(value_hack) {
    return typeof value_hack;
  }
  function jsInstanceOf$outlinedJsCode$(obj_hack, jsClass_hack) {
    return obj_hack instanceof jsClass_hack;
  }
  function Function1() {
  }
  Function1.$metadata$ = {
    simpleName: 'Function1',
    kind: 'interface',
    interfaces: []
  };
  function Alert() {
  }
  Alert.$metadata$ = {
    simpleName: 'Alert',
    kind: 'interface',
    interfaces: []
  };
  function AlertSeverity(severity) {
    this.severity_1 = severity;
  }
  AlertSeverity.prototype._get_severity__64506990_12elwu_k$ = function () {
    return this.severity_1;
  };
  AlertSeverity.$metadata$ = {
    simpleName: 'AlertSeverity',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AlertSeverity.prototype, 'severity', {
    configurable: true,
    get: AlertSeverity.prototype._get_severity__64506990_12elwu_k$
  });
  function Attachment() {
  }
  Attachment.$metadata$ = {
    simpleName: 'Attachment',
    kind: 'interface',
    interfaces: []
  };
  function Command() {
  }
  Command.$metadata$ = {
    simpleName: 'Command',
    kind: 'interface',
    interfaces: []
  };
  function DateInterval() {
  }
  DateInterval.$metadata$ = {
    simpleName: 'DateInterval',
    kind: 'interface',
    interfaces: []
  };
  function Event() {
  }
  Event.$metadata$ = {
    simpleName: 'Event',
    kind: 'interface',
    interfaces: []
  };
  function GeoLocation() {
  }
  GeoLocation.$metadata$ = {
    simpleName: 'GeoLocation',
    kind: 'interface',
    interfaces: []
  };
  function GeoStamp() {
  }
  GeoStamp.$metadata$ = {
    simpleName: 'GeoStamp',
    kind: 'interface',
    interfaces: []
  };
  function Page() {
  }
  Page.$metadata$ = {
    simpleName: 'Page',
    kind: 'interface',
    interfaces: []
  };
  function PageRequest() {
  }
  PageRequest.$metadata$ = {
    simpleName: 'PageRequest',
    kind: 'interface',
    interfaces: []
  };
  function AlertBase(type, description, date, payload, severity) {
    this.type_1 = type;
    this.description_1 = description;
    this.date_1 = date;
    this.payload_1 = payload;
    this.severity_1 = severity;
  }
  AlertBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  AlertBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  AlertBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  AlertBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AlertBase.prototype._get_severity__64506990_12elwu_k$ = function () {
    return this.severity_1;
  };
  AlertBase.prototype.toString = function () {
    return "AlertBase(type='" + this.type + "', description='" + this.description + "', date='" + this.date + "', payload=" + this.payload + ', severity=' + this.severity + ')';
  };
  AlertBase.$metadata$ = {
    simpleName: 'AlertBase',
    kind: 'class',
    interfaces: [Alert]
  };
  Object.defineProperty(AlertBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'severity', {
    configurable: true,
    get: function () {
      return this._get_severity__64506990_12elwu_k$();
    }
  });
  function DateIntervalBase(startDate, endDate) {
    this.startDate_1 = startDate;
    this.endDate_1 = endDate;
  }
  DateIntervalBase.prototype._get_startDate__1388556577_mypl41_k$ = function () {
    return this.startDate_1;
  };
  DateIntervalBase.prototype._get_endDate__3826071816_7r622g_k$ = function () {
    return this.endDate_1;
  };
  DateIntervalBase.prototype.component1 = function () {
    return this.startDate_1;
  };
  DateIntervalBase.prototype.component2 = function () {
    return this.endDate_1;
  };
  DateIntervalBase.prototype.copy = function (startDate, endDate) {
    return this.copy_j05hop_k$(startDate === void 1 ? this.startDate_1 : startDate, endDate === void 1 ? this.endDate_1 : endDate);
  };
  DateIntervalBase.prototype.copy_j05hop_k$ = function (startDate, endDate) {
    return new DateIntervalBase(startDate, endDate);
  };
  DateIntervalBase.prototype.copy$default_75mnvg_k$ = function (startDate, endDate, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      startDate = this.startDate_1;
    if (!(($mask0 & 2) === 0))
      endDate = this.endDate_1;
    return this.copy_j05hop_k$(startDate, endDate);
  };
  DateIntervalBase.prototype.toString = function () {
    return 'DateIntervalBase(startDate=' + toString_1(this.startDate_1) + ', endDate=' + toString_1(this.endDate_1) + ')';
  };
  DateIntervalBase.prototype.hashCode = function () {
    var result = this.startDate_1.hashCode();
    result = imul(result, 31) + this.endDate_1.hashCode() | 0;
    return result;
  };
  DateIntervalBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DateIntervalBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DateIntervalBase ? other : THROW_CCE();
    if (!this.startDate_1.equals(tmp0_other_with_cast.startDate_1))
      return false;
    if (!this.endDate_1.equals(tmp0_other_with_cast.endDate_1))
      return false;
    return true;
  };
  DateIntervalBase.$metadata$ = {
    simpleName: 'DateIntervalBase',
    kind: 'class',
    interfaces: [DateInterval]
  };
  Object.defineProperty(DateIntervalBase.prototype, 'startDate', {
    configurable: true,
    get: function () {
      return this._get_startDate__1388556577_mypl41_k$();
    }
  });
  Object.defineProperty(DateIntervalBase.prototype, 'endDate', {
    configurable: true,
    get: function () {
      return this._get_endDate__3826071816_7r622g_k$();
    }
  });
  function GeoLocationBase(lon, lat) {
    this.lon_1 = lon;
    this.lat_1 = lat;
  }
  GeoLocationBase.prototype._get_lon__857178790_e6cbdy_k$ = function () {
    return this.lon_1;
  };
  GeoLocationBase.prototype._get_lat__857165522_e6c15e_k$ = function () {
    return this.lat_1;
  };
  GeoLocationBase.prototype.component1 = function () {
    return this.lon_1;
  };
  GeoLocationBase.prototype.component2 = function () {
    return this.lat_1;
  };
  GeoLocationBase.prototype.copy = function (lon, lat) {
    return this.copy_fws33n_k$(lon === void 1 ? this.lon_1 : lon, lat === void 1 ? this.lat_1 : lat);
  };
  GeoLocationBase.prototype.copy_fws33n_k$ = function (lon, lat) {
    return new GeoLocationBase(lon, lat);
  };
  GeoLocationBase.prototype.copy$default_l1hfaq_k$ = function (lon, lat, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      lon = this.lon_1;
    if (!(($mask0 & 2) === 0))
      lat = this.lat_1;
    return this.copy_fws33n_k$(lon, lat);
  };
  GeoLocationBase.prototype.toString = function () {
    return 'GeoLocationBase(lon=' + this.lon_1 + ', lat=' + this.lat_1 + ')';
  };
  GeoLocationBase.prototype.hashCode = function () {
    var result = getNumberHashCode(this.lon_1);
    result = imul(result, 31) + getNumberHashCode(this.lat_1) | 0;
    return result;
  };
  GeoLocationBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GeoLocationBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GeoLocationBase ? other : THROW_CCE();
    if (!equals(this.lon_1, tmp0_other_with_cast.lon_1))
      return false;
    if (!equals(this.lat_1, tmp0_other_with_cast.lat_1))
      return false;
    return true;
  };
  GeoLocationBase.$metadata$ = {
    simpleName: 'GeoLocationBase',
    kind: 'class',
    interfaces: [GeoLocation]
  };
  Object.defineProperty(GeoLocationBase.prototype, 'lon', {
    configurable: true,
    get: function () {
      return this._get_lon__857178790_e6cbdy_k$();
    }
  });
  Object.defineProperty(GeoLocationBase.prototype, 'lat', {
    configurable: true,
    get: function () {
      return this._get_lat__857165522_e6c15e_k$();
    }
  });
  function GeoStampBase(date, location) {
    this.date_1 = date;
    this.location_1 = location;
  }
  GeoStampBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  GeoStampBase.prototype._get_location__284645046_4pgxiu_k$ = function () {
    return this.location_1;
  };
  GeoStampBase.$metadata$ = {
    simpleName: 'GeoStampBase',
    kind: 'class',
    interfaces: [GeoStamp]
  };
  Object.defineProperty(GeoStampBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(GeoStampBase.prototype, 'location', {
    configurable: true,
    get: function () {
      return this._get_location__284645046_4pgxiu_k$();
    }
  });
  function PageBase(page, size, total, list) {
    this.page_1 = page;
    this.size_1 = size;
    this.total_1 = total;
    this.list_1 = list;
  }
  PageBase.prototype._get_page__806010268_dbvli4_k$ = function () {
    return this.page_1;
  };
  PageBase.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.size_1;
  };
  PageBase.prototype._get_total__3639312653_aucycz_k$ = function () {
    return this.total_1;
  };
  PageBase.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return this.list_1;
  };
  PageBase.$metadata$ = {
    simpleName: 'PageBase',
    kind: 'class',
    interfaces: [Page]
  };
  Object.defineProperty(PageBase.prototype, 'page', {
    configurable: true,
    get: function () {
      return this._get_page__806010268_dbvli4_k$();
    }
  });
  Object.defineProperty(PageBase.prototype, 'size', {
    configurable: true,
    get: function () {
      return this._get_size__809037418_ddoh9m_k$();
    }
  });
  Object.defineProperty(PageBase.prototype, 'total', {
    configurable: true,
    get: function () {
      return this._get_total__3639312653_aucycz_k$();
    }
  });
  Object.defineProperty(PageBase.prototype, 'list', {
    configurable: true,
    get: function () {
      return this._get_list__802566509_d9tsa5_k$();
    }
  });
  function PageRequestBase(page, size) {
    this.page_1 = page;
    this.size_1 = size;
  }
  PageRequestBase.prototype._get_page__806010268_dbvli4_k$ = function () {
    return this.page_1;
  };
  PageRequestBase.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.size_1;
  };
  PageRequestBase.$metadata$ = {
    simpleName: 'PageRequestBase',
    kind: 'class',
    interfaces: [PageRequest]
  };
  Object.defineProperty(PageRequestBase.prototype, 'page', {
    configurable: true,
    get: function () {
      return this._get_page__806010268_dbvli4_k$();
    }
  });
  Object.defineProperty(PageRequestBase.prototype, 'size', {
    configurable: true,
    get: function () {
      return this._get_size__809037418_ddoh9m_k$();
    }
  });
  function _get_ROLE_ADMIN__3149651749() {
    return ROLE_ADMIN;
  }
  var ROLE_ADMIN;
  function _get_ROLE_SUPER_ADMIN__3554080777() {
    return ROLE_SUPER_ADMIN;
  }
  var ROLE_SUPER_ADMIN;
  function _get_ROLE_OPERATOR_ADMIN__1787221876() {
    return ROLE_OPERATOR_ADMIN;
  }
  var ROLE_OPERATOR_ADMIN;
  function _get_ROLE_OPERATOR_USER__1600582830() {
    return ROLE_OPERATOR_USER;
  }
  var ROLE_OPERATOR_USER;
  function _get_ROLE_OPERATOR_ADMIN_ONBOARDING__962210510() {
    return ROLE_OPERATOR_ADMIN_ONBOARDING;
  }
  var ROLE_OPERATOR_ADMIN_ONBOARDING;
  function _get_ROLE_OPERATOR_USER_ONBOARDING__1450534228() {
    return ROLE_OPERATOR_USER_ONBOARDING;
  }
  var ROLE_OPERATOR_USER_ONBOARDING;
  function _get_ROLE_FUNDER_ADMIN__3418638502() {
    return ROLE_FUNDER_ADMIN;
  }
  var ROLE_FUNDER_ADMIN;
  function _get_ROLE_FUNDER_USER__821925180() {
    return ROLE_FUNDER_USER;
  }
  var ROLE_FUNDER_USER;
  function _get_ROLE_CARRIER_ADMIN__3637737580() {
    return ROLE_CARRIER_ADMIN;
  }
  var ROLE_CARRIER_ADMIN;
  function _get_ROLE_CARRIER_USER__2768655542() {
    return ROLE_CARRIER_USER;
  }
  var ROLE_CARRIER_USER;
  function _get_ROLE_TMS_ADMIN__3958562570() {
    return ROLE_TMS_ADMIN;
  }
  var ROLE_TMS_ADMIN;
  function _get_ROLE_TMS_USER__3610288728() {
    return ROLE_TMS_USER;
  }
  var ROLE_TMS_USER;
  function _get_ROLE_VISITOR_ADMIN__635253302() {
    return ROLE_VISITOR_ADMIN;
  }
  var ROLE_VISITOR_ADMIN;
  function _get_ROLE_VISITOR_USER__39401900() {
    return ROLE_VISITOR_USER;
  }
  var ROLE_VISITOR_USER;
  function _get_ROLE_READ_HEAT_MAP__2334907966() {
    return ROLE_READ_HEAT_MAP;
  }
  var ROLE_READ_HEAT_MAP;
  function _get_ROLE_READ_FLUX_MAP__1654341093() {
    return ROLE_READ_FLUX_MAP;
  }
  var ROLE_READ_FLUX_MAP;
  function _get_ROLE_READ_DASHBOARD_BONUS_TOTAL__3980768280() {
    return ROLE_READ_DASHBOARD_BONUS_TOTAL;
  }
  var ROLE_READ_DASHBOARD_BONUS_TOTAL;
  function _get_ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE__961309144() {
    return ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE;
  }
  var ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE;
  function _get_ROLE_READ_DASHBOARD_DELIVERY_TIME__1042262468() {
    return ROLE_READ_DASHBOARD_DELIVERY_TIME;
  }
  var ROLE_READ_DASHBOARD_DELIVERY_TIME;
  function _get_ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES__628138737() {
    return ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES;
  }
  var ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES;
  function _get_ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT__3236390426() {
    return ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT;
  }
  var ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT;
  function _get_ROLE_READ_DASHBOARD_HUB_COUNT__3178299799() {
    return ROLE_READ_DASHBOARD_HUB_COUNT;
  }
  var ROLE_READ_DASHBOARD_HUB_COUNT;
  function _get_ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE__1081766482() {
    return ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE;
  }
  var ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE;
  function _get_ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__2332509822() {
    return ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY;
  }
  var ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY;
  function _get_ROLE_READ_DASHBOARD_TOUR_AMOUNT__144310845() {
    return ROLE_READ_DASHBOARD_TOUR_AMOUNT;
  }
  var ROLE_READ_DASHBOARD_TOUR_AMOUNT;
  function _get_ROLE_READ_DASHBOARD_DISTANCE_TOTAL__2048129574() {
    return ROLE_READ_DASHBOARD_DISTANCE_TOTAL;
  }
  var ROLE_READ_DASHBOARD_DISTANCE_TOTAL;
  function _get_ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED__1801289601() {
    return ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED;
  }
  var ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED;
  function _get_ROLE_READ_DASHBOARD_CO2_AVOIDED__3570012961() {
    return ROLE_READ_DASHBOARD_CO2_AVOIDED;
  }
  var ROLE_READ_DASHBOARD_CO2_AVOIDED;
  function _get_ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED__3490441090() {
    return ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED;
  }
  var ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED;
  function NotFoundException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, NotFoundException);
  }
  NotFoundException.$metadata$ = {
    simpleName: 'NotFoundException',
    kind: 'class',
    interfaces: []
  };
  function GeoZone() {
  }
  GeoZone.$metadata$ = {
    simpleName: 'GeoZone',
    kind: 'interface',
    interfaces: []
  };
  function GeoZoneBase(id, code, name, isCustom, isArchived, creationDate) {
    this.id_1 = id;
    this.code_1 = code;
    this.name_1 = name;
    this.isCustom_1 = isCustom;
    this.isArchived_1 = isArchived;
    this.creationDate_1 = creationDate;
  }
  GeoZoneBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  GeoZoneBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  GeoZoneBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  GeoZoneBase.prototype._get_isCustom__2029988336_xklp0w_k$ = function () {
    return this.isCustom_1;
  };
  GeoZoneBase.prototype._get_isArchived__1921144543_vrssm7_k$ = function () {
    return this.isArchived_1;
  };
  GeoZoneBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  GeoZoneBase.$metadata$ = {
    simpleName: 'GeoZoneBase',
    kind: 'class',
    interfaces: [GeoZone]
  };
  Object.defineProperty(GeoZoneBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(GeoZoneBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(GeoZoneBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(GeoZoneBase.prototype, 'isCustom', {
    configurable: true,
    get: function () {
      return this._get_isCustom__2029988336_xklp0w_k$();
    }
  });
  Object.defineProperty(GeoZoneBase.prototype, 'isArchived', {
    configurable: true,
    get: function () {
      return this._get_isArchived__1921144543_vrssm7_k$();
    }
  });
  Object.defineProperty(GeoZoneBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  function Territory() {
  }
  Territory.$metadata$ = {
    simpleName: 'Territory',
    kind: 'interface',
    interfaces: []
  };
  function TerritoryBase(id, code, name, zones) {
    this.id_1 = id;
    this.code_1 = code;
    this.name_1 = name;
    this.zones_1 = zones;
  }
  TerritoryBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  TerritoryBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  TerritoryBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  TerritoryBase.prototype._get_zones__3810912874_806ys6_k$ = function () {
    return this.zones_1;
  };
  TerritoryBase.$metadata$ = {
    simpleName: 'TerritoryBase',
    kind: 'class',
    interfaces: [Territory]
  };
  Object.defineProperty(TerritoryBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(TerritoryBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(TerritoryBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(TerritoryBase.prototype, 'zones', {
    configurable: true,
    get: function () {
      return this._get_zones__3810912874_806ys6_k$();
    }
  });
  function _get_ADD_TERRITORY_ZONE__3834524956() {
    return ADD_TERRITORY_ZONE;
  }
  var ADD_TERRITORY_ZONE;
  function _get_TERRITORY_ZONE_ADDED__2440044185() {
    return TERRITORY_ZONE_ADDED;
  }
  var TERRITORY_ZONE_ADDED;
  function AddTerritoryZoneCommand() {
  }
  AddTerritoryZoneCommand.$metadata$ = {
    simpleName: 'AddTerritoryZoneCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddTerritoryZoneCommandDTO() {
  }
  AddTerritoryZoneCommandDTO.$metadata$ = {
    simpleName: 'AddTerritoryZoneCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddTerritoryZoneCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddTerritoryZoneCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddTerritoryZoneCommandBase.$metadata$ = {
    simpleName: 'AddTerritoryZoneCommandBase',
    kind: 'class',
    interfaces: [AddTerritoryZoneCommand]
  };
  Object.defineProperty(AddTerritoryZoneCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddTerritoryZoneCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddTerritoryZoneCommandDTOBase(territory, name, geojson, isCustom) {
    this.territory_1 = territory;
    this.name_1 = name;
    this.geojson_1 = geojson;
    this.isCustom_1 = isCustom;
  }
  AddTerritoryZoneCommandDTOBase.prototype._get_territory__1826884983_u7ohh3_k$ = function () {
    return this.territory_1;
  };
  AddTerritoryZoneCommandDTOBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  AddTerritoryZoneCommandDTOBase.prototype._get_geojson__3969672824_5do6tk_k$ = function () {
    return this.geojson_1;
  };
  AddTerritoryZoneCommandDTOBase.prototype._get_isCustom__2029988336_xklp0w_k$ = function () {
    return this.isCustom_1;
  };
  AddTerritoryZoneCommandDTOBase.$metadata$ = {
    simpleName: 'AddTerritoryZoneCommandDTOBase',
    kind: 'class',
    interfaces: [AddTerritoryZoneCommandDTO]
  };
  Object.defineProperty(AddTerritoryZoneCommandDTOBase.prototype, 'territory', {
    configurable: true,
    get: function () {
      return this._get_territory__1826884983_u7ohh3_k$();
    }
  });
  Object.defineProperty(AddTerritoryZoneCommandDTOBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(AddTerritoryZoneCommandDTOBase.prototype, 'geojson', {
    configurable: true,
    get: function () {
      return this._get_geojson__3969672824_5do6tk_k$();
    }
  });
  Object.defineProperty(AddTerritoryZoneCommandDTOBase.prototype, 'isCustom', {
    configurable: true,
    get: function () {
      return this._get_isCustom__2029988336_xklp0w_k$();
    }
  });
  function TerritoryZoneAddedEvent() {
  }
  TerritoryZoneAddedEvent.$metadata$ = {
    simpleName: 'TerritoryZoneAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TerritoryZoneAddedEventDTO() {
  }
  TerritoryZoneAddedEventDTO.$metadata$ = {
    simpleName: 'TerritoryZoneAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TerritoryZoneAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  TerritoryZoneAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TerritoryZoneAddedEventBase.$metadata$ = {
    simpleName: 'TerritoryZoneAddedEventBase',
    kind: 'class',
    interfaces: [TerritoryZoneAddedEvent]
  };
  Object.defineProperty(TerritoryZoneAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TerritoryZoneAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TerritoryZoneAddedEventDTOBase(territoryCode, geozoneCode) {
    this.territoryCode_1 = territoryCode;
    this.geozoneCode_1 = geozoneCode;
  }
  TerritoryZoneAddedEventDTOBase.prototype._get_territoryCode__421324938_6yugei_k$ = function () {
    return this.territoryCode_1;
  };
  TerritoryZoneAddedEventDTOBase.prototype._get_geozoneCode__1133460679_iqtzuv_k$ = function () {
    return this.geozoneCode_1;
  };
  TerritoryZoneAddedEventDTOBase.$metadata$ = {
    simpleName: 'TerritoryZoneAddedEventDTOBase',
    kind: 'class',
    interfaces: [TerritoryZoneAddedEventDTO]
  };
  Object.defineProperty(TerritoryZoneAddedEventDTOBase.prototype, 'territoryCode', {
    configurable: true,
    get: function () {
      return this._get_territoryCode__421324938_6yugei_k$();
    }
  });
  Object.defineProperty(TerritoryZoneAddedEventDTOBase.prototype, 'geozoneCode', {
    configurable: true,
    get: function () {
      return this._get_geozoneCode__1133460679_iqtzuv_k$();
    }
  });
  function _get_ARCHIVE_GEOZONE__2071154769() {
    return ARCHIVE_GEOZONE;
  }
  var ARCHIVE_GEOZONE;
  function _get_GEOZONE_ARCHIVED__116494279() {
    return GEOZONE_ARCHIVED;
  }
  var GEOZONE_ARCHIVED;
  function ArchiveGeoZoneCommand() {
  }
  ArchiveGeoZoneCommand.$metadata$ = {
    simpleName: 'ArchiveGeoZoneCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ArchiveGeoZoneCommandDTO() {
  }
  ArchiveGeoZoneCommandDTO.$metadata$ = {
    simpleName: 'ArchiveGeoZoneCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function ArchiveGeoZoneCommandBase(payload) {
    this.payload_1 = payload;
  }
  ArchiveGeoZoneCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ArchiveGeoZoneCommandBase.$metadata$ = {
    simpleName: 'ArchiveGeoZoneCommandBase',
    kind: 'class',
    interfaces: [ArchiveGeoZoneCommand]
  };
  Object.defineProperty(ArchiveGeoZoneCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ArchiveGeoZoneCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ArchiveGeoZoneCommandDTOBase(id) {
    this.id_1 = id;
  }
  ArchiveGeoZoneCommandDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ArchiveGeoZoneCommandDTOBase.$metadata$ = {
    simpleName: 'ArchiveGeoZoneCommandDTOBase',
    kind: 'class',
    interfaces: [ArchiveGeoZoneCommandDTO]
  };
  Object.defineProperty(ArchiveGeoZoneCommandDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function GeoZoneArchivedEvent() {
  }
  GeoZoneArchivedEvent.$metadata$ = {
    simpleName: 'GeoZoneArchivedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function GeoZoneArchivedEventDTO() {
  }
  GeoZoneArchivedEventDTO.$metadata$ = {
    simpleName: 'GeoZoneArchivedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function GeoZoneArchivedEventBase(payload) {
    this.payload_1 = payload;
  }
  GeoZoneArchivedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  GeoZoneArchivedEventBase.$metadata$ = {
    simpleName: 'GeoZoneArchivedEventBase',
    kind: 'class',
    interfaces: [GeoZoneArchivedEvent]
  };
  Object.defineProperty(GeoZoneArchivedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(GeoZoneArchivedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function GeoZoneArchivedEventDTOBase(id) {
    this.id_1 = id;
  }
  GeoZoneArchivedEventDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  GeoZoneArchivedEventDTOBase.$metadata$ = {
    simpleName: 'GeoZoneArchivedEventDTOBase',
    kind: 'class',
    interfaces: [GeoZoneArchivedEventDTO]
  };
  Object.defineProperty(GeoZoneArchivedEventDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function _get_CREATE_GEOZONE__992900913() {
    return CREATE_GEOZONE;
  }
  var CREATE_GEOZONE;
  function _get_GEOZONE_CREATED__353894891() {
    return GEOZONE_CREATED;
  }
  var GEOZONE_CREATED;
  function CreateGeoZoneCommand() {
  }
  CreateGeoZoneCommand.$metadata$ = {
    simpleName: 'CreateGeoZoneCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateGeoZoneCommandDetails() {
  }
  CreateGeoZoneCommandDetails.$metadata$ = {
    simpleName: 'CreateGeoZoneCommandDetails',
    kind: 'interface',
    interfaces: []
  };
  function CreateGeoZoneCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateGeoZoneCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateGeoZoneCommandBase.$metadata$ = {
    simpleName: 'CreateGeoZoneCommandBase',
    kind: 'class',
    interfaces: [CreateGeoZoneCommand]
  };
  Object.defineProperty(CreateGeoZoneCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateGeoZoneCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateGeoZoneCommandDetailsBase(data) {
    this.data_1 = data;
  }
  CreateGeoZoneCommandDetailsBase.prototype._get_data__794940385_d5abxd_k$ = function () {
    return this.data_1;
  };
  CreateGeoZoneCommandDetailsBase.$metadata$ = {
    simpleName: 'CreateGeoZoneCommandDetailsBase',
    kind: 'class',
    interfaces: [CreateGeoZoneCommandDetails]
  };
  Object.defineProperty(CreateGeoZoneCommandDetailsBase.prototype, 'data', {
    configurable: true,
    get: function () {
      return this._get_data__794940385_d5abxd_k$();
    }
  });
  function GeoZoneCreatedEvent() {
  }
  GeoZoneCreatedEvent.$metadata$ = {
    simpleName: 'GeoZoneCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function GeoZoneCreatedEventDetails() {
  }
  GeoZoneCreatedEventDetails.$metadata$ = {
    simpleName: 'GeoZoneCreatedEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function GeoZoneCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  GeoZoneCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  GeoZoneCreatedEventBase.$metadata$ = {
    simpleName: 'GeoZoneCreatedEventBase',
    kind: 'class',
    interfaces: [GeoZoneCreatedEvent]
  };
  Object.defineProperty(GeoZoneCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(GeoZoneCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function GeoZoneCreatedEventDetailsBase(id, code, name) {
    this.id_1 = id;
    this.code_1 = code;
    this.name_1 = name;
  }
  GeoZoneCreatedEventDetailsBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  GeoZoneCreatedEventDetailsBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  GeoZoneCreatedEventDetailsBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  GeoZoneCreatedEventDetailsBase.$metadata$ = {
    simpleName: 'GeoZoneCreatedEventDetailsBase',
    kind: 'class',
    interfaces: [GeoZoneCreatedEventDetails]
  };
  Object.defineProperty(GeoZoneCreatedEventDetailsBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(GeoZoneCreatedEventDetailsBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(GeoZoneCreatedEventDetailsBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  function _get_CREATE_TERRITORY__397817140() {
    return CREATE_TERRITORY;
  }
  var CREATE_TERRITORY;
  function _get_TERRITORY_CREATED__689705006() {
    return TERRITORY_CREATED;
  }
  var TERRITORY_CREATED;
  function CreateTerritoryCommand() {
  }
  CreateTerritoryCommand.$metadata$ = {
    simpleName: 'CreateTerritoryCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateTerritoryCommandDTO() {
  }
  CreateTerritoryCommandDTO.$metadata$ = {
    simpleName: 'CreateTerritoryCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateTerritoryCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateTerritoryCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateTerritoryCommandBase.$metadata$ = {
    simpleName: 'CreateTerritoryCommandBase',
    kind: 'class',
    interfaces: [CreateTerritoryCommand]
  };
  Object.defineProperty(CreateTerritoryCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateTerritoryCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateTerritoryCommandDTOBase(code, name, zones) {
    this.code_1 = code;
    this.name_1 = name;
    this.zones_1 = zones;
  }
  CreateTerritoryCommandDTOBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  CreateTerritoryCommandDTOBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  CreateTerritoryCommandDTOBase.prototype._get_zones__3810912874_806ys6_k$ = function () {
    return this.zones_1;
  };
  CreateTerritoryCommandDTOBase.$metadata$ = {
    simpleName: 'CreateTerritoryCommandDTOBase',
    kind: 'class',
    interfaces: [CreateTerritoryCommandDTO]
  };
  Object.defineProperty(CreateTerritoryCommandDTOBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(CreateTerritoryCommandDTOBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(CreateTerritoryCommandDTOBase.prototype, 'zones', {
    configurable: true,
    get: function () {
      return this._get_zones__3810912874_806ys6_k$();
    }
  });
  function TerritoryCreatedEvent() {
  }
  TerritoryCreatedEvent.$metadata$ = {
    simpleName: 'TerritoryCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TerritoryCreatedEventDTO() {
  }
  TerritoryCreatedEventDTO.$metadata$ = {
    simpleName: 'TerritoryCreatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TerritoryCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  TerritoryCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TerritoryCreatedEventBase.$metadata$ = {
    simpleName: 'TerritoryCreatedEventBase',
    kind: 'class',
    interfaces: [TerritoryCreatedEvent]
  };
  Object.defineProperty(TerritoryCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TerritoryCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TerritoryCreatedEventDTOBase(id) {
    this.id_1 = id;
  }
  TerritoryCreatedEventDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  TerritoryCreatedEventDTOBase.$metadata$ = {
    simpleName: 'TerritoryCreatedEventDTOBase',
    kind: 'class',
    interfaces: [TerritoryCreatedEventDTO]
  };
  Object.defineProperty(TerritoryCreatedEventDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function Address() {
  }
  Address.$metadata$ = {
    simpleName: 'Address',
    kind: 'interface',
    interfaces: []
  };
  function AddressBase_init_$Init$(zipCode, city, street, houseNumber, geoLocation, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      houseNumber = null;
    if (!(($mask0 & 16) === 0))
      geoLocation = null;
    AddressBase.call($this, zipCode, city, street, houseNumber, geoLocation);
    return $this;
  }
  function AddressBase_init_$Create$(zipCode, city, street, houseNumber, geoLocation, $mask0, $marker) {
    return AddressBase_init_$Init$(zipCode, city, street, houseNumber, geoLocation, $mask0, $marker, Object.create(AddressBase.prototype));
  }
  function AddressBase(zipCode, city, street, houseNumber, geoLocation) {
    var houseNumber_0 = houseNumber === void 1 ? null : houseNumber;
    var geoLocation_0 = geoLocation === void 1 ? null : geoLocation;
    this.zipCode_1 = zipCode;
    this.city_1 = city;
    this.street_1 = street;
    this.houseNumber_1 = houseNumber_0;
    this.geoLocation_1 = geoLocation_0;
  }
  AddressBase.prototype._get_zipCode__1970860067_wledcz_k$ = function () {
    return this.zipCode_1;
  };
  AddressBase.prototype._get_city__794255936_d4vnsw_k$ = function () {
    return this.city_1;
  };
  AddressBase.prototype._get_street__403451752_6o7dd4_k$ = function () {
    return this.street_1;
  };
  AddressBase.prototype._get_houseNumber__973984808_g3vvhk_k$ = function () {
    return this.houseNumber_1;
  };
  AddressBase.prototype._get_geoLocation__1429949483_nncs2z_k$ = function () {
    return this.geoLocation_1;
  };
  AddressBase.$metadata$ = {
    simpleName: 'AddressBase',
    kind: 'class',
    interfaces: [Address]
  };
  Object.defineProperty(AddressBase.prototype, 'zipCode', {
    configurable: true,
    get: function () {
      return this._get_zipCode__1970860067_wledcz_k$();
    }
  });
  Object.defineProperty(AddressBase.prototype, 'city', {
    configurable: true,
    get: function () {
      return this._get_city__794255936_d4vnsw_k$();
    }
  });
  Object.defineProperty(AddressBase.prototype, 'street', {
    configurable: true,
    get: function () {
      return this._get_street__403451752_6o7dd4_k$();
    }
  });
  Object.defineProperty(AddressBase.prototype, 'houseNumber', {
    configurable: true,
    get: function () {
      return this._get_houseNumber__973984808_g3vvhk_k$();
    }
  });
  Object.defineProperty(AddressBase.prototype, 'geoLocation', {
    configurable: true,
    get: function () {
      return this._get_geoLocation__1429949483_nncs2z_k$();
    }
  });
  function Convention() {
  }
  Convention.$metadata$ = {
    simpleName: 'Convention',
    kind: 'interface',
    interfaces: []
  };
  function ConventionBase(id, status, envelope, signerEmail) {
    this.id_1 = id;
    this.status_1 = status;
    this.envelope_1 = envelope;
    this.signerEmail_1 = signerEmail;
  }
  ConventionBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ConventionBase.prototype._set_status__299634277_aklcgd_k$ = function (_set____804775014) {
    this.status_1 = _set____804775014;
  };
  ConventionBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  ConventionBase.prototype._get_envelope__2394089979_vfqebp_k$ = function () {
    return this.envelope_1;
  };
  ConventionBase.prototype._set_signerEmail__2168921011_1sc9h8_k$ = function (_set____804775014) {
    this.signerEmail_1 = _set____804775014;
  };
  ConventionBase.prototype._get_signerEmail__4000363839_4vedhd_k$ = function () {
    return this.signerEmail_1;
  };
  ConventionBase.prototype.component1 = function () {
    return this.id_1;
  };
  ConventionBase.prototype.component2 = function () {
    return this.status_1;
  };
  ConventionBase.prototype.component3 = function () {
    return this.envelope_1;
  };
  ConventionBase.prototype.component4 = function () {
    return this.signerEmail_1;
  };
  ConventionBase.prototype.copy = function (id, status, envelope, signerEmail) {
    return this.copy_dk9wn4_k$(id === void 1 ? this.id_1 : id, status === void 1 ? this.status_1 : status, envelope === void 1 ? this.envelope_1 : envelope, signerEmail === void 1 ? this.signerEmail_1 : signerEmail);
  };
  ConventionBase.prototype.copy_dk9wn4_k$ = function (id, status, envelope, signerEmail) {
    return new ConventionBase(id, status, envelope, signerEmail);
  };
  ConventionBase.prototype.copy$default_unhszh_k$ = function (id, status, envelope, signerEmail, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      status = this.status_1;
    if (!(($mask0 & 4) === 0))
      envelope = this.envelope_1;
    if (!(($mask0 & 8) === 0))
      signerEmail = this.signerEmail_1;
    return this.copy_dk9wn4_k$(id, status, envelope, signerEmail);
  };
  ConventionBase.prototype.toString = function () {
    return 'ConventionBase(id=' + this.id_1 + ', status=' + this.status_1 + ', envelope=' + this.envelope_1 + ', signerEmail=' + this.signerEmail_1 + ')';
  };
  ConventionBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + this.status_1.hashCode() | 0;
    result = imul(result, 31) + (this.envelope_1 == null ? 0 : hashCode(this.envelope_1)) | 0;
    result = imul(result, 31) + (this.signerEmail_1 == null ? 0 : getStringHashCode(this.signerEmail_1)) | 0;
    return result;
  };
  ConventionBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConventionBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ConventionBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!this.status_1.equals(tmp0_other_with_cast.status_1))
      return false;
    if (!equals(this.envelope_1, tmp0_other_with_cast.envelope_1))
      return false;
    if (!(this.signerEmail_1 == tmp0_other_with_cast.signerEmail_1))
      return false;
    return true;
  };
  ConventionBase.$metadata$ = {
    simpleName: 'ConventionBase',
    kind: 'class',
    interfaces: [Convention]
  };
  Object.defineProperty(ConventionBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(ConventionBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    },
    set: function (value) {
      this._set_status__299634277_aklcgd_k$(value);
    }
  });
  Object.defineProperty(ConventionBase.prototype, 'envelope', {
    configurable: true,
    get: function () {
      return this._get_envelope__2394089979_vfqebp_k$();
    }
  });
  Object.defineProperty(ConventionBase.prototype, 'signerEmail', {
    configurable: true,
    get: function () {
      return this._get_signerEmail__4000363839_4vedhd_k$();
    },
    set: function (value) {
      this._set_signerEmail__2168921011_1sc9h8_k$(value);
    }
  });
  function ConventionActions(canPrefill, canSign, canView) {
    this.canPrefill_1 = canPrefill;
    this.canSign_1 = canSign;
    this.canView_1 = canView;
  }
  ConventionActions.prototype._get_canPrefill__541760149_8yjst1_k$ = function () {
    return this.canPrefill_1;
  };
  ConventionActions.prototype._get_canSign__1988175620_wvpi4k_k$ = function () {
    return this.canSign_1;
  };
  ConventionActions.prototype._get_canView__1990944540_wxcun0_k$ = function () {
    return this.canView_1;
  };
  ConventionActions.$metadata$ = {
    simpleName: 'ConventionActions',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ConventionActions.prototype, 'canPrefill', {
    configurable: true,
    get: ConventionActions.prototype._get_canPrefill__541760149_8yjst1_k$
  });
  Object.defineProperty(ConventionActions.prototype, 'canSign', {
    configurable: true,
    get: ConventionActions.prototype._get_canSign__1988175620_wvpi4k_k$
  });
  Object.defineProperty(ConventionActions.prototype, 'canView', {
    configurable: true,
    get: ConventionActions.prototype._get_canView__1990944540_wxcun0_k$
  });
  function ConventionStateMachine() {
    this.Status_1 = new ConventionStatusValues();
  }
  ConventionStateMachine.prototype.getAvailableActions = function (status, isAdmin, isOperatorAdmin) {
    var isCreated = this.Status_1.isCreated(status);
    var isPrefilled = this.Status_1.isPrefilled(status);
    var isSignedByOrg = this.Status_1.isSignedByOrg(status);
    return new ConventionActions(isAdmin ? isCreated : false, (isPrefilled ? isOperatorAdmin : false) ? true : isSignedByOrg ? isAdmin : false, isAdmin ? true : isOperatorAdmin);
  };
  ConventionStateMachine.$metadata$ = {
    simpleName: 'ConventionStateMachine',
    kind: 'class',
    interfaces: []
  };
  function _get_CONVENTION_STATUS_CREATED__4034007912() {
    init_properties_ConventionStatus_kt_1764240119();
    return CONVENTION_STATUS_CREATED;
  }
  var CONVENTION_STATUS_CREATED;
  function _get_CONVENTION_STATUS_PREFILLED__4195736491() {
    init_properties_ConventionStatus_kt_1764240119();
    return CONVENTION_STATUS_PREFILLED;
  }
  var CONVENTION_STATUS_PREFILLED;
  function _get_CONVENTION_STATUS_SIGNED_BY_ORG__3257362993() {
    init_properties_ConventionStatus_kt_1764240119();
    return CONVENTION_STATUS_SIGNED_BY_ORG;
  }
  var CONVENTION_STATUS_SIGNED_BY_ORG;
  function _get_CONVENTION_STATUS_FINALIZED__3694499210() {
    init_properties_ConventionStatus_kt_1764240119();
    return CONVENTION_STATUS_FINALIZED;
  }
  var CONVENTION_STATUS_FINALIZED;
  function ConventionStatus() {
  }
  ConventionStatus.$metadata$ = {
    simpleName: 'ConventionStatus',
    kind: 'interface',
    interfaces: []
  };
  function ConventionStatusBase(value) {
    this.value_1 = value;
  }
  ConventionStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  ConventionStatusBase.prototype.component1 = function () {
    return this.value_1;
  };
  ConventionStatusBase.prototype.copy = function (value) {
    return this.copy_3t26ic_k$(value === void 1 ? this.value_1 : value);
  };
  ConventionStatusBase.prototype.copy_3t26ic_k$ = function (value) {
    return new ConventionStatusBase(value);
  };
  ConventionStatusBase.prototype.copy$default_q3pzg4_k$ = function (value, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      value = this.value_1;
    return this.copy_3t26ic_k$(value);
  };
  ConventionStatusBase.prototype.toString = function () {
    return 'ConventionStatusBase(value=' + this.value_1 + ')';
  };
  ConventionStatusBase.prototype.hashCode = function () {
    return getStringHashCode(this.value_1);
  };
  ConventionStatusBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConventionStatusBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ConventionStatusBase ? other : THROW_CCE();
    if (!(this.value_1 === tmp0_other_with_cast.value_1))
      return false;
    return true;
  };
  ConventionStatusBase.$metadata$ = {
    simpleName: 'ConventionStatusBase',
    kind: 'class',
    interfaces: [ConventionStatus]
  };
  Object.defineProperty(ConventionStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function ConventionStatusValues() {
    this.CREATED_1 = _get_CONVENTION_STATUS_CREATED__4034007912();
    this.PREFILLED_1 = _get_CONVENTION_STATUS_PREFILLED__4195736491();
    this.SIGNED_BY_ORG_1 = _get_CONVENTION_STATUS_SIGNED_BY_ORG__3257362993();
    this.FINALIZED_1 = _get_CONVENTION_STATUS_FINALIZED__3694499210();
  }
  ConventionStatusValues.prototype._get_CREATED__434088265_76g0nd_k$ = function () {
    return this.CREATED_1;
  };
  ConventionStatusValues.prototype._get_PREFILLED__2121629004_z35vf0_k$ = function () {
    return this.PREFILLED_1;
  };
  ConventionStatusValues.prototype._get_SIGNED_BY_ORG__3836433234_7kzz5a_k$ = function () {
    return this.SIGNED_BY_ORG_1;
  };
  ConventionStatusValues.prototype._get_FINALIZED__1620391723_qsqm97_k$ = function () {
    return this.FINALIZED_1;
  };
  ConventionStatusValues.prototype.isCreated = function (status) {
    return status === this.CREATED_1.value_1;
  };
  ConventionStatusValues.prototype.isPrefilled = function (status) {
    return status === this.PREFILLED_1.value_1;
  };
  ConventionStatusValues.prototype.isSignedByOrg = function (status) {
    return status === this.SIGNED_BY_ORG_1.value_1;
  };
  ConventionStatusValues.prototype.isFinalized = function (status) {
    return status === this.FINALIZED_1.value_1;
  };
  ConventionStatusValues.$metadata$ = {
    simpleName: 'ConventionStatusValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ConventionStatusValues.prototype, 'CREATED', {
    configurable: true,
    get: ConventionStatusValues.prototype._get_CREATED__434088265_76g0nd_k$
  });
  Object.defineProperty(ConventionStatusValues.prototype, 'PREFILLED', {
    configurable: true,
    get: ConventionStatusValues.prototype._get_PREFILLED__2121629004_z35vf0_k$
  });
  Object.defineProperty(ConventionStatusValues.prototype, 'SIGNED_BY_ORG', {
    configurable: true,
    get: ConventionStatusValues.prototype._get_SIGNED_BY_ORG__3836433234_7kzz5a_k$
  });
  Object.defineProperty(ConventionStatusValues.prototype, 'FINALIZED', {
    configurable: true,
    get: ConventionStatusValues.prototype._get_FINALIZED__1620391723_qsqm97_k$
  });
  var properties_initialized_ConventionStatus_kt_3262195227;
  function init_properties_ConventionStatus_kt_1764240119() {
    if (!properties_initialized_ConventionStatus_kt_3262195227) {
      properties_initialized_ConventionStatus_kt_3262195227 = true;
      CONVENTION_STATUS_CREATED = new ConventionStatusBase('CREATED');
      CONVENTION_STATUS_PREFILLED = new ConventionStatusBase('PREFILLED');
      CONVENTION_STATUS_SIGNED_BY_ORG = new ConventionStatusBase('SIGNED_BY_ORG');
      CONVENTION_STATUS_FINALIZED = new ConventionStatusBase('FINALIZED');
    }
  }
  function _get_CONVENTION_TYPE_SIMPLIFIED__3417727932() {
    init_properties_ConventionType_kt_1917330223();
    return CONVENTION_TYPE_SIMPLIFIED;
  }
  var CONVENTION_TYPE_SIMPLIFIED;
  function _get_CONVENTION_TYPE_DOCUSIGN__3488179034() {
    init_properties_ConventionType_kt_1917330223();
    return CONVENTION_TYPE_DOCUSIGN;
  }
  var CONVENTION_TYPE_DOCUSIGN;
  function ConventionType() {
  }
  ConventionType.$metadata$ = {
    simpleName: 'ConventionType',
    kind: 'interface',
    interfaces: []
  };
  function ConventionTypeBase(value) {
    this.value_1 = value;
  }
  ConventionTypeBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  ConventionTypeBase.prototype.component1 = function () {
    return this.value_1;
  };
  ConventionTypeBase.prototype.copy = function (value) {
    return this.copy_3t26ic_k$(value === void 1 ? this.value_1 : value);
  };
  ConventionTypeBase.prototype.copy_3t26ic_k$ = function (value) {
    return new ConventionTypeBase(value);
  };
  ConventionTypeBase.prototype.copy$default_q3pzg4_k$ = function (value, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      value = this.value_1;
    return this.copy_3t26ic_k$(value);
  };
  ConventionTypeBase.prototype.toString = function () {
    return 'ConventionTypeBase(value=' + this.value_1 + ')';
  };
  ConventionTypeBase.prototype.hashCode = function () {
    return getStringHashCode(this.value_1);
  };
  ConventionTypeBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConventionTypeBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ConventionTypeBase ? other : THROW_CCE();
    if (!(this.value_1 === tmp0_other_with_cast.value_1))
      return false;
    return true;
  };
  ConventionTypeBase.$metadata$ = {
    simpleName: 'ConventionTypeBase',
    kind: 'class',
    interfaces: [ConventionType]
  };
  Object.defineProperty(ConventionTypeBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function ConventionTypeValues() {
    this.SIMPLIFIED_1 = _get_CONVENTION_TYPE_SIMPLIFIED__3417727932();
    this.DOCUSIGN_1 = _get_CONVENTION_TYPE_DOCUSIGN__3488179034();
  }
  ConventionTypeValues.prototype._get_SIMPLIFIED__3263427635_h25h3h_k$ = function () {
    return this.SIMPLIFIED_1;
  };
  ConventionTypeValues.prototype._get_DOCUSIGN__922658193_f9brm9_k$ = function () {
    return this.DOCUSIGN_1;
  };
  ConventionTypeValues.prototype.isSimplified = function (status) {
    return status === this.SIMPLIFIED_1.value_1;
  };
  ConventionTypeValues.prototype.isDocusign = function (status) {
    return status === this.DOCUSIGN_1.value_1;
  };
  ConventionTypeValues.$metadata$ = {
    simpleName: 'ConventionTypeValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ConventionTypeValues.prototype, 'SIMPLIFIED', {
    configurable: true,
    get: ConventionTypeValues.prototype._get_SIMPLIFIED__3263427635_h25h3h_k$
  });
  Object.defineProperty(ConventionTypeValues.prototype, 'DOCUSIGN', {
    configurable: true,
    get: ConventionTypeValues.prototype._get_DOCUSIGN__922658193_f9brm9_k$
  });
  var properties_initialized_ConventionType_kt_2870843219;
  function init_properties_ConventionType_kt_1917330223() {
    if (!properties_initialized_ConventionType_kt_2870843219) {
      properties_initialized_ConventionType_kt_2870843219 = true;
      CONVENTION_TYPE_SIMPLIFIED = new ConventionTypeBase('SIMPLIFIED');
      CONVENTION_TYPE_DOCUSIGN = new ConventionTypeBase('DOCUSIGN');
    }
  }
  function Envelope() {
  }
  Envelope.$metadata$ = {
    simpleName: 'Envelope',
    kind: 'interface',
    interfaces: []
  };
  function EnvelopeBase(email, name) {
    this.email_1 = email;
    this.name_1 = name;
  }
  EnvelopeBase.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  EnvelopeBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  EnvelopeBase.$metadata$ = {
    simpleName: 'EnvelopeBase',
    kind: 'class',
    interfaces: [Envelope]
  };
  Object.defineProperty(EnvelopeBase.prototype, 'email', {
    configurable: true,
    get: function () {
      return this._get_email__3207470005_hzgua3_k$();
    }
  });
  Object.defineProperty(EnvelopeBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  function _get_ENVELOPE_RECIPIENT_STATUS_CREATED__1918709569() {
    init_properties_EnvelopeRecipentStatus_kt_1432037828();
    return ENVELOPE_RECIPIENT_STATUS_CREATED;
  }
  var ENVELOPE_RECIPIENT_STATUS_CREATED;
  function _get_ENVELOPE_RECIPIENT_STATUS_PUBLISHED__1889100347() {
    init_properties_EnvelopeRecipentStatus_kt_1432037828();
    return ENVELOPE_RECIPIENT_STATUS_PUBLISHED;
  }
  var ENVELOPE_RECIPIENT_STATUS_PUBLISHED;
  function _get_ENVELOPE_RECIPIENT_STATUS_APPROVED__1134934268() {
    init_properties_EnvelopeRecipentStatus_kt_1432037828();
    return ENVELOPE_RECIPIENT_STATUS_APPROVED;
  }
  var ENVELOPE_RECIPIENT_STATUS_APPROVED;
  function _get_ENVELOPE_RECIPIENT_STATUS_COMPLETED__3723008382() {
    init_properties_EnvelopeRecipentStatus_kt_1432037828();
    return ENVELOPE_RECIPIENT_STATUS_COMPLETED;
  }
  var ENVELOPE_RECIPIENT_STATUS_COMPLETED;
  function _get_ENVELOPE_RECIPIENT_STATUS_DECLINED__3481260645() {
    init_properties_EnvelopeRecipentStatus_kt_1432037828();
    return ENVELOPE_RECIPIENT_STATUS_DECLINED;
  }
  var ENVELOPE_RECIPIENT_STATUS_DECLINED;
  function _get_ENVELOPE_RECIPIENT_STATUS_VOIDED__1740686144() {
    init_properties_EnvelopeRecipentStatus_kt_1432037828();
    return ENVELOPE_RECIPIENT_STATUS_VOIDED;
  }
  var ENVELOPE_RECIPIENT_STATUS_VOIDED;
  function EnvelopeRecipientStatus() {
  }
  EnvelopeRecipientStatus.$metadata$ = {
    simpleName: 'EnvelopeRecipientStatus',
    kind: 'interface',
    interfaces: []
  };
  function EnvelopeRecipientStatusBase(value) {
    this.value_1 = value;
  }
  EnvelopeRecipientStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  EnvelopeRecipientStatusBase.$metadata$ = {
    simpleName: 'EnvelopeRecipientStatusBase',
    kind: 'class',
    interfaces: [EnvelopeRecipientStatus]
  };
  Object.defineProperty(EnvelopeRecipientStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  var properties_initialized_EnvelopeRecipentStatus_kt_3306961384;
  function init_properties_EnvelopeRecipentStatus_kt_1432037828() {
    if (!properties_initialized_EnvelopeRecipentStatus_kt_3306961384) {
      properties_initialized_EnvelopeRecipentStatus_kt_3306961384 = true;
      ENVELOPE_RECIPIENT_STATUS_CREATED = new EnvelopeRecipientStatusBase('sent');
      ENVELOPE_RECIPIENT_STATUS_PUBLISHED = new EnvelopeRecipientStatusBase('delivered');
      ENVELOPE_RECIPIENT_STATUS_APPROVED = new EnvelopeRecipientStatusBase('signed');
      ENVELOPE_RECIPIENT_STATUS_COMPLETED = new EnvelopeRecipientStatusBase('completed');
      ENVELOPE_RECIPIENT_STATUS_DECLINED = new EnvelopeRecipientStatusBase('declined');
      ENVELOPE_RECIPIENT_STATUS_VOIDED = new EnvelopeRecipientStatusBase('voided');
    }
  }
  function ExportAuthorization() {
  }
  ExportAuthorization.$metadata$ = {
    simpleName: 'ExportAuthorization',
    kind: 'interface',
    interfaces: []
  };
  function ExportAuthorizationBase(deliveryPeriod, tracePeriod) {
    this.deliveryPeriod_1 = deliveryPeriod;
    this.tracePeriod_1 = tracePeriod;
  }
  ExportAuthorizationBase.prototype._set_deliveryPeriod__3373013730_np87b9_k$ = function (_set____804775014) {
    this.deliveryPeriod_1 = _set____804775014;
  };
  ExportAuthorizationBase.prototype._get_deliveryPeriod__621774294_aa6s46_k$ = function () {
    return this.deliveryPeriod_1;
  };
  ExportAuthorizationBase.prototype._set_tracePeriod__3702194527_e0yb94_k$ = function (_set____804775014) {
    this.tracePeriod_1 = _set____804775014;
  };
  ExportAuthorizationBase.prototype._get_tracePeriod__1238670059_khgzxn_k$ = function () {
    return this.tracePeriod_1;
  };
  ExportAuthorizationBase.prototype.component1 = function () {
    return this.deliveryPeriod_1;
  };
  ExportAuthorizationBase.prototype.component2 = function () {
    return this.tracePeriod_1;
  };
  ExportAuthorizationBase.prototype.copy = function (deliveryPeriod, tracePeriod) {
    return this.copy_45azpl_k$(deliveryPeriod === void 1 ? this.deliveryPeriod_1 : deliveryPeriod, tracePeriod === void 1 ? this.tracePeriod_1 : tracePeriod);
  };
  ExportAuthorizationBase.prototype.copy_45azpl_k$ = function (deliveryPeriod, tracePeriod) {
    return new ExportAuthorizationBase(deliveryPeriod, tracePeriod);
  };
  ExportAuthorizationBase.prototype.copy$default_i5njdo_k$ = function (deliveryPeriod, tracePeriod, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      deliveryPeriod = this.deliveryPeriod_1;
    if (!(($mask0 & 2) === 0))
      tracePeriod = this.tracePeriod_1;
    return this.copy_45azpl_k$(deliveryPeriod, tracePeriod);
  };
  ExportAuthorizationBase.prototype.toString = function () {
    return 'ExportAuthorizationBase(deliveryPeriod=' + this.deliveryPeriod_1 + ', tracePeriod=' + this.tracePeriod_1 + ')';
  };
  ExportAuthorizationBase.prototype.hashCode = function () {
    var result = this.deliveryPeriod_1 == null ? 0 : this.deliveryPeriod_1.hashCode();
    result = imul(result, 31) + (this.tracePeriod_1 == null ? 0 : this.tracePeriod_1.hashCode()) | 0;
    return result;
  };
  ExportAuthorizationBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ExportAuthorizationBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ExportAuthorizationBase ? other : THROW_CCE();
    if (!equals(this.deliveryPeriod_1, tmp0_other_with_cast.deliveryPeriod_1))
      return false;
    if (!equals(this.tracePeriod_1, tmp0_other_with_cast.tracePeriod_1))
      return false;
    return true;
  };
  ExportAuthorizationBase.$metadata$ = {
    simpleName: 'ExportAuthorizationBase',
    kind: 'class',
    interfaces: [ExportAuthorization]
  };
  Object.defineProperty(ExportAuthorizationBase.prototype, 'deliveryPeriod', {
    configurable: true,
    get: function () {
      return this._get_deliveryPeriod__621774294_aa6s46_k$();
    },
    set: function (value) {
      this._set_deliveryPeriod__3373013730_np87b9_k$(value);
    }
  });
  Object.defineProperty(ExportAuthorizationBase.prototype, 'tracePeriod', {
    configurable: true,
    get: function () {
      return this._get_tracePeriod__1238670059_khgzxn_k$();
    },
    set: function (value) {
      this._set_tracePeriod__3702194527_e0yb94_k$(value);
    }
  });
  function Hub() {
  }
  Hub.$metadata$ = {
    simpleName: 'Hub',
    kind: 'interface',
    interfaces: []
  };
  function HubBase_init_$Init$(id, address, activityStartDate, activityEndDate, territories, comment, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      activityEndDate = null;
    if (!(($mask0 & 16) === 0))
      territories = null;
    if (!(($mask0 & 32) === 0))
      comment = '';
    HubBase.call($this, id, address, activityStartDate, activityEndDate, territories, comment);
    return $this;
  }
  function HubBase_init_$Create$(id, address, activityStartDate, activityEndDate, territories, comment, $mask0, $marker) {
    return HubBase_init_$Init$(id, address, activityStartDate, activityEndDate, territories, comment, $mask0, $marker, Object.create(HubBase.prototype));
  }
  function HubBase(id, address, activityStartDate, activityEndDate, territories, comment) {
    var activityEndDate_0 = activityEndDate === void 1 ? null : activityEndDate;
    var territories_0 = territories === void 1 ? null : territories;
    var comment_0 = comment === void 1 ? '' : comment;
    this.id_1 = id;
    this.address_1 = address;
    this.activityStartDate_1 = activityStartDate;
    this.activityEndDate_1 = activityEndDate_0;
    this.territories_1 = territories_0;
    this.comment_1 = comment_0;
  }
  HubBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  HubBase.prototype._get_address__907296157_f06i71_k$ = function () {
    return this.address_1;
  };
  HubBase.prototype._get_activityStartDate__976647824_g5gya8_k$ = function () {
    return this.activityStartDate_1;
  };
  HubBase.prototype._get_activityEndDate__3137375799_j577bd_k$ = function () {
    return this.activityEndDate_1;
  };
  HubBase.prototype._get_territories__3289376345_gmpaxz_k$ = function () {
    return this.territories_1;
  };
  HubBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  HubBase.$metadata$ = {
    simpleName: 'HubBase',
    kind: 'class',
    interfaces: [Hub]
  };
  Object.defineProperty(HubBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(HubBase.prototype, 'address', {
    configurable: true,
    get: function () {
      return this._get_address__907296157_f06i71_k$();
    }
  });
  Object.defineProperty(HubBase.prototype, 'activityStartDate', {
    configurable: true,
    get: function () {
      return this._get_activityStartDate__976647824_g5gya8_k$();
    }
  });
  Object.defineProperty(HubBase.prototype, 'activityEndDate', {
    configurable: true,
    get: function () {
      return this._get_activityEndDate__3137375799_j577bd_k$();
    }
  });
  Object.defineProperty(HubBase.prototype, 'territories', {
    configurable: true,
    get: function () {
      return this._get_territories__3289376345_gmpaxz_k$();
    }
  });
  Object.defineProperty(HubBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  var HubType_OPERATOR_ACTIVE_HUB_instance;
  var HubType_OPERATOR_INACTIVE_HUB_instance;
  var HubType_CARRIER_ACTIVE_HUB_instance;
  var HubType_CARRIER_INACTIVE_HUB_instance;
  function values() {
    return [HubType_OPERATOR_ACTIVE_HUB_getInstance(), HubType_OPERATOR_INACTIVE_HUB_getInstance(), HubType_CARRIER_ACTIVE_HUB_getInstance(), HubType_CARRIER_INACTIVE_HUB_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'OPERATOR_ACTIVE_HUB':
        return HubType_OPERATOR_ACTIVE_HUB_getInstance();
      case 'OPERATOR_INACTIVE_HUB':
        return HubType_OPERATOR_INACTIVE_HUB_getInstance();
      case 'CARRIER_ACTIVE_HUB':
        return HubType_CARRIER_ACTIVE_HUB_getInstance();
      case 'CARRIER_INACTIVE_HUB':
        return HubType_CARRIER_INACTIVE_HUB_getInstance();
      default:
        HubType_initEntries();
        THROW_ISE();
        break;
    }
  }
  var HubType_entriesInitialized;
  function HubType_initEntries() {
    if (HubType_entriesInitialized)
      return Unit_getInstance();
    HubType_entriesInitialized = true;
    HubType_OPERATOR_ACTIVE_HUB_instance = new HubType('OPERATOR_ACTIVE_HUB', 0);
    HubType_OPERATOR_INACTIVE_HUB_instance = new HubType('OPERATOR_INACTIVE_HUB', 1);
    HubType_CARRIER_ACTIVE_HUB_instance = new HubType('CARRIER_ACTIVE_HUB', 2);
    HubType_CARRIER_INACTIVE_HUB_instance = new HubType('CARRIER_INACTIVE_HUB', 3);
  }
  function HubType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  HubType.$metadata$ = {
    simpleName: 'HubType',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(HubType.prototype, 'name', {
    configurable: true,
    get: HubType.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(HubType.prototype, 'ordinal', {
    configurable: true,
    get: HubType.prototype._get_ordinal__3363892928_fec5kw_k$
  });
  function HubType_OPERATOR_ACTIVE_HUB_getInstance() {
    HubType_initEntries();
    return HubType_OPERATOR_ACTIVE_HUB_instance;
  }
  function HubType_OPERATOR_INACTIVE_HUB_getInstance() {
    HubType_initEntries();
    return HubType_OPERATOR_INACTIVE_HUB_instance;
  }
  function HubType_CARRIER_ACTIVE_HUB_getInstance() {
    HubType_initEntries();
    return HubType_CARRIER_ACTIVE_HUB_instance;
  }
  function HubType_CARRIER_INACTIVE_HUB_getInstance() {
    HubType_initEntries();
    return HubType_CARRIER_INACTIVE_HUB_instance;
  }
  function Organization() {
  }
  Organization.$metadata$ = {
    simpleName: 'Organization',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationBase_init_$Init$(id, friendlyId, organizationType, details, date, payment, applications, status, hasLogo, conventionSelected, convention, packageType, packagePerPallet, exportAuthorization, territories, visitorAuthorization, hubs, minPointsPerTourThreshold, $mask0, $marker, $this) {
    if (!(($mask0 & 131072) === 0))
      minPointsPerTourThreshold = null;
    OrganizationBase.call($this, id, friendlyId, organizationType, details, date, payment, applications, status, hasLogo, conventionSelected, convention, packageType, packagePerPallet, exportAuthorization, territories, visitorAuthorization, hubs, minPointsPerTourThreshold);
    return $this;
  }
  function OrganizationBase_init_$Create$(id, friendlyId, organizationType, details, date, payment, applications, status, hasLogo, conventionSelected, convention, packageType, packagePerPallet, exportAuthorization, territories, visitorAuthorization, hubs, minPointsPerTourThreshold, $mask0, $marker) {
    return OrganizationBase_init_$Init$(id, friendlyId, organizationType, details, date, payment, applications, status, hasLogo, conventionSelected, convention, packageType, packagePerPallet, exportAuthorization, territories, visitorAuthorization, hubs, minPointsPerTourThreshold, $mask0, $marker, Object.create(OrganizationBase.prototype));
  }
  function OrganizationBase(id, friendlyId, organizationType, details, date, payment, applications, status, hasLogo, conventionSelected, convention, packageType, packagePerPallet, exportAuthorization, territories, visitorAuthorization, hubs, minPointsPerTourThreshold) {
    var minPointsPerTourThreshold_0 = minPointsPerTourThreshold === void 1 ? null : minPointsPerTourThreshold;
    this.id_1 = id;
    this.friendlyId_1 = friendlyId;
    this.organizationType_1 = organizationType;
    this.details_1 = details;
    this.date_1 = date;
    this.payment_1 = payment;
    this.applications_1 = applications;
    this.status_1 = status;
    this.hasLogo_1 = hasLogo;
    this.conventionSelected_1 = conventionSelected;
    this.convention_1 = convention;
    this.packageType_1 = packageType;
    this.packagePerPallet_1 = packagePerPallet;
    this.exportAuthorization_1 = exportAuthorization;
    this.territories_1 = territories;
    this.visitorAuthorization_1 = visitorAuthorization;
    this.hubs_1 = hubs;
    this.minPointsPerTourThreshold_1 = minPointsPerTourThreshold_0;
  }
  OrganizationBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  OrganizationBase.prototype._get_friendlyId__3809034789_81b7x7_k$ = function () {
    return this.friendlyId_1;
  };
  OrganizationBase.prototype._get_organizationType__2268849502_xiaqhu_k$ = function () {
    return this.organizationType_1;
  };
  OrganizationBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  OrganizationBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  OrganizationBase.prototype._get_payment__3508693451_d04ks5_k$ = function () {
    return this.payment_1;
  };
  OrganizationBase.prototype._get_applications__3023466632_l10o6w_k$ = function () {
    return this.applications_1;
  };
  OrganizationBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  OrganizationBase.prototype._get_hasLogo__2249152588_xu0wqc_k$ = function () {
    return this.hasLogo_1;
  };
  OrganizationBase.prototype._get_conventionSelected__607201247_a1ifhb_k$ = function () {
    return this.conventionSelected_1;
  };
  OrganizationBase.prototype._get_convention__1210803002_k0vpkq_k$ = function () {
    return this.convention_1;
  };
  OrganizationBase.prototype._get_packageType__4062161137_3uludr_k$ = function () {
    return this.packageType_1;
  };
  OrganizationBase.prototype._get_packagePerPallet__652770356_asn4tw_k$ = function () {
    return this.packagePerPallet_1;
  };
  OrganizationBase.prototype._get_exportAuthorization__2209036812_yhwq9g_k$ = function () {
    return this.exportAuthorization_1;
  };
  OrganizationBase.prototype._get_territories__3289376345_gmpaxz_k$ = function () {
    return this.territories_1;
  };
  OrganizationBase.prototype._get_visitorAuthorization__1161751296_j7od1c_k$ = function () {
    return this.visitorAuthorization_1;
  };
  OrganizationBase.prototype._get_hubs__799213549_d7tx4d_k$ = function () {
    return this.hubs_1;
  };
  OrganizationBase.prototype._get_minPointsPerTourThreshold__2301177574_wz1tzu_k$ = function () {
    return this.minPointsPerTourThreshold_1;
  };
  OrganizationBase.$metadata$ = {
    simpleName: 'OrganizationBase',
    kind: 'class',
    interfaces: [Organization]
  };
  Object.defineProperty(OrganizationBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'friendlyId', {
    configurable: true,
    get: function () {
      return this._get_friendlyId__3809034789_81b7x7_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'organizationType', {
    configurable: true,
    get: function () {
      return this._get_organizationType__2268849502_xiaqhu_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'payment', {
    configurable: true,
    get: function () {
      return this._get_payment__3508693451_d04ks5_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'applications', {
    configurable: true,
    get: function () {
      return this._get_applications__3023466632_l10o6w_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'hasLogo', {
    configurable: true,
    get: function () {
      return this._get_hasLogo__2249152588_xu0wqc_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'conventionSelected', {
    configurable: true,
    get: function () {
      return this._get_conventionSelected__607201247_a1ifhb_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'convention', {
    configurable: true,
    get: function () {
      return this._get_convention__1210803002_k0vpkq_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'packageType', {
    configurable: true,
    get: function () {
      return this._get_packageType__4062161137_3uludr_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'packagePerPallet', {
    configurable: true,
    get: function () {
      return this._get_packagePerPallet__652770356_asn4tw_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'exportAuthorization', {
    configurable: true,
    get: function () {
      return this._get_exportAuthorization__2209036812_yhwq9g_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'territories', {
    configurable: true,
    get: function () {
      return this._get_territories__3289376345_gmpaxz_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'visitorAuthorization', {
    configurable: true,
    get: function () {
      return this._get_visitorAuthorization__1161751296_j7od1c_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'hubs', {
    configurable: true,
    get: function () {
      return this._get_hubs__799213549_d7tx4d_k$();
    }
  });
  Object.defineProperty(OrganizationBase.prototype, 'minPointsPerTourThreshold', {
    configurable: true,
    get: function () {
      return this._get_minPointsPerTourThreshold__2301177574_wz1tzu_k$();
    }
  });
  function OrganizationDetails() {
  }
  OrganizationDetails.$metadata$ = {
    simpleName: 'OrganizationDetails',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationDetailsBase(name, siret, address) {
    this.name_1 = name;
    this.siret_1 = siret;
    this.address_1 = address;
  }
  OrganizationDetailsBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  OrganizationDetailsBase.prototype._get_siret__3605086886_beqj4q_k$ = function () {
    return this.siret_1;
  };
  OrganizationDetailsBase.prototype._get_address__907296157_f06i71_k$ = function () {
    return this.address_1;
  };
  OrganizationDetailsBase.$metadata$ = {
    simpleName: 'OrganizationDetailsBase',
    kind: 'class',
    interfaces: [OrganizationDetails]
  };
  Object.defineProperty(OrganizationDetailsBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(OrganizationDetailsBase.prototype, 'siret', {
    configurable: true,
    get: function () {
      return this._get_siret__3605086886_beqj4q_k$();
    }
  });
  Object.defineProperty(OrganizationDetailsBase.prototype, 'address', {
    configurable: true,
    get: function () {
      return this._get_address__907296157_f06i71_k$();
    }
  });
  function Application() {
  }
  Application.$metadata$ = {
    simpleName: 'Application',
    kind: 'interface',
    interfaces: []
  };
  function ApplicationBase(clientId, keycloackId, clientSecret) {
    this.clientId_1 = clientId;
    this.keycloackId_1 = keycloackId;
    this.clientSecret_1 = clientSecret;
  }
  ApplicationBase.prototype._get_clientId__3872690757_6zeunv_k$ = function () {
    return this.clientId_1;
  };
  ApplicationBase.prototype._get_keycloackId__2470334388_u6c7rg_k$ = function () {
    return this.keycloackId_1;
  };
  ApplicationBase.prototype._get_clientSecret__2130301520_z8br68_k$ = function () {
    return this.clientSecret_1;
  };
  ApplicationBase.$metadata$ = {
    simpleName: 'ApplicationBase',
    kind: 'class',
    interfaces: [Application]
  };
  Object.defineProperty(ApplicationBase.prototype, 'clientId', {
    configurable: true,
    get: function () {
      return this._get_clientId__3872690757_6zeunv_k$();
    }
  });
  Object.defineProperty(ApplicationBase.prototype, 'keycloackId', {
    configurable: true,
    get: function () {
      return this._get_keycloackId__2470334388_u6c7rg_k$();
    }
  });
  Object.defineProperty(ApplicationBase.prototype, 'clientSecret', {
    configurable: true,
    get: function () {
      return this._get_clientSecret__2130301520_z8br68_k$();
    }
  });
  function OrganizationAction(canDelete) {
    this.canDelete_1 = canDelete;
  }
  OrganizationAction.prototype._get_canDelete__3133526038_j7hpt6_k$ = function () {
    return this.canDelete_1;
  };
  OrganizationAction.$metadata$ = {
    simpleName: 'OrganizationAction',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(OrganizationAction.prototype, 'canDelete', {
    configurable: true,
    get: OrganizationAction.prototype._get_canDelete__3133526038_j7hpt6_k$
  });
  function OrganizationStateMachine() {
    this.Status_1 = new OrganizationStatusValues();
  }
  OrganizationStateMachine.prototype.getAvailableActions = function (status) {
    var isCreated = this.Status_1.isCreated(status);
    return new OrganizationAction(isCreated);
  };
  OrganizationStateMachine.$metadata$ = {
    simpleName: 'OrganizationStateMachine',
    kind: 'class',
    interfaces: []
  };
  function OrganizationAggregate() {
  }
  OrganizationAggregate.$metadata$ = {
    simpleName: 'OrganizationAggregate',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationFinder() {
  }
  OrganizationFinder.$metadata$ = {
    simpleName: 'OrganizationFinder',
    kind: 'interface',
    interfaces: []
  };
  function _get_ORGANIZATION_STATUS_CREATED__2062558314() {
    init_properties_OrganizationStatus_kt_2715213493();
    return ORGANIZATION_STATUS_CREATED;
  }
  var ORGANIZATION_STATUS_CREATED;
  function _get_ORGANIZATION_STATUS_APPROVED__1299278067() {
    init_properties_OrganizationStatus_kt_2715213493();
    return ORGANIZATION_STATUS_APPROVED;
  }
  var ORGANIZATION_STATUS_APPROVED;
  function OrganizationStatus() {
  }
  OrganizationStatus.$metadata$ = {
    simpleName: 'OrganizationStatus',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationStatusBase(value) {
    this.value_1 = value;
  }
  OrganizationStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  OrganizationStatusBase.prototype.component1 = function () {
    return this.value_1;
  };
  OrganizationStatusBase.prototype.copy = function (value) {
    return this.copy_3t26ic_k$(value === void 1 ? this.value_1 : value);
  };
  OrganizationStatusBase.prototype.copy_3t26ic_k$ = function (value) {
    return new OrganizationStatusBase(value);
  };
  OrganizationStatusBase.prototype.copy$default_q3pzg4_k$ = function (value, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      value = this.value_1;
    return this.copy_3t26ic_k$(value);
  };
  OrganizationStatusBase.prototype.toString = function () {
    return 'OrganizationStatusBase(value=' + this.value_1 + ')';
  };
  OrganizationStatusBase.prototype.hashCode = function () {
    return getStringHashCode(this.value_1);
  };
  OrganizationStatusBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationStatusBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof OrganizationStatusBase ? other : THROW_CCE();
    if (!(this.value_1 === tmp0_other_with_cast.value_1))
      return false;
    return true;
  };
  OrganizationStatusBase.$metadata$ = {
    simpleName: 'OrganizationStatusBase',
    kind: 'class',
    interfaces: [OrganizationStatus]
  };
  Object.defineProperty(OrganizationStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function OrganizationStatusValues() {
    this.CREATED_1 = _get_ORGANIZATION_STATUS_CREATED__2062558314();
    this.APPROVED_1 = _get_ORGANIZATION_STATUS_APPROVED__1299278067();
  }
  OrganizationStatusValues.prototype._get_CREATED__434088265_76g0nd_k$ = function () {
    return this.CREATED_1;
  };
  OrganizationStatusValues.prototype._get_APPROVED__2356314100_w282do_k$ = function () {
    return this.APPROVED_1;
  };
  OrganizationStatusValues.prototype.isCreated = function (status) {
    return status === this.CREATED_1.value_1;
  };
  OrganizationStatusValues.prototype.isApproved = function (status) {
    return status === this.APPROVED_1.value_1;
  };
  OrganizationStatusValues.$metadata$ = {
    simpleName: 'OrganizationStatusValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(OrganizationStatusValues.prototype, 'CREATED', {
    configurable: true,
    get: OrganizationStatusValues.prototype._get_CREATED__434088265_76g0nd_k$
  });
  Object.defineProperty(OrganizationStatusValues.prototype, 'APPROVED', {
    configurable: true,
    get: OrganizationStatusValues.prototype._get_APPROVED__2356314100_w282do_k$
  });
  var properties_initialized_OrganizationStatus_kt_3436028121;
  function init_properties_OrganizationStatus_kt_2715213493() {
    if (!properties_initialized_OrganizationStatus_kt_3436028121) {
      properties_initialized_OrganizationStatus_kt_3436028121 = true;
      ORGANIZATION_STATUS_CREATED = new OrganizationStatusBase('CREATED');
      ORGANIZATION_STATUS_APPROVED = new OrganizationStatusBase('APPROVED');
    }
  }
  function OrganizationType() {
  }
  OrganizationType.$metadata$ = {
    simpleName: 'OrganizationType',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationTypeValues() {
    this.MANAGER_1 = new ManagerType();
    this.OPERATOR_1 = new OperatorType();
    this.FUNDER_1 = new FunderType();
    this.FUNDER_CEE_1 = new FunderCeeType();
    this.CARRIER_1 = new CarrierType();
    this.TMS_1 = new TmsType();
    this.VISITOR_1 = new VisitorType();
  }
  OrganizationTypeValues.prototype._get_MANAGER__3031904548_kvztgc_k$ = function () {
    return this.MANAGER_1;
  };
  OrganizationTypeValues.prototype._get_OPERATOR__1636170663_r24td3_k$ = function () {
    return this.OPERATOR_1;
  };
  OrganizationTypeValues.prototype._get_FUNDER__2493693721_tsfjl3_k$ = function () {
    return this.FUNDER_1;
  };
  OrganizationTypeValues.prototype._get_FUNDER_CEE__4202435253_1j3a6j_k$ = function () {
    return this.FUNDER_CEE_1;
  };
  OrganizationTypeValues.prototype._get_CARRIER__2913946425_mu82iv_k$ = function () {
    return this.CARRIER_1;
  };
  OrganizationTypeValues.prototype._get_TMS__856430295_e5w9uf_k$ = function () {
    return this.TMS_1;
  };
  OrganizationTypeValues.prototype._get_VISITOR__198354051_3a3eyr_k$ = function () {
    return this.VISITOR_1;
  };
  OrganizationTypeValues.prototype.isManager = function (status) {
    return status === this.MANAGER_1.type;
  };
  OrganizationTypeValues.prototype.isOperator = function (status) {
    return status === this.OPERATOR_1.type;
  };
  OrganizationTypeValues.prototype.isFunder = function (status) {
    return status === this.FUNDER_1.type ? true : status === this.FUNDER_CEE_1.type;
  };
  OrganizationTypeValues.prototype.isCarrier = function (status) {
    return status === this.CARRIER_1.type;
  };
  OrganizationTypeValues.prototype.isFunderCee = function (status) {
    return status === this.FUNDER_CEE_1.type;
  };
  OrganizationTypeValues.prototype.isTms = function (status) {
    return status === this.TMS_1.type;
  };
  OrganizationTypeValues.prototype.isVisitor = function (status) {
    return status === this.VISITOR_1.type;
  };
  OrganizationTypeValues.$metadata$ = {
    simpleName: 'OrganizationTypeValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(OrganizationTypeValues.prototype, 'MANAGER', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_MANAGER__3031904548_kvztgc_k$
  });
  Object.defineProperty(OrganizationTypeValues.prototype, 'OPERATOR', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_OPERATOR__1636170663_r24td3_k$
  });
  Object.defineProperty(OrganizationTypeValues.prototype, 'FUNDER', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_FUNDER__2493693721_tsfjl3_k$
  });
  Object.defineProperty(OrganizationTypeValues.prototype, 'FUNDER_CEE', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_FUNDER_CEE__4202435253_1j3a6j_k$
  });
  Object.defineProperty(OrganizationTypeValues.prototype, 'CARRIER', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_CARRIER__2913946425_mu82iv_k$
  });
  Object.defineProperty(OrganizationTypeValues.prototype, 'TMS', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_TMS__856430295_e5w9uf_k$
  });
  Object.defineProperty(OrganizationTypeValues.prototype, 'VISITOR', {
    configurable: true,
    get: OrganizationTypeValues.prototype._get_VISITOR__198354051_3a3eyr_k$
  });
  function OrganizationTypeBase(type) {
    this.type_1 = type;
  }
  OrganizationTypeBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  OrganizationTypeBase.$metadata$ = {
    simpleName: 'OrganizationTypeBase',
    kind: 'class',
    interfaces: [OrganizationType]
  };
  Object.defineProperty(OrganizationTypeBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ManagerType() {
    OrganizationTypeBase.call(this, 'Manager');
  }
  ManagerType.$metadata$ = {
    simpleName: 'ManagerType',
    kind: 'class',
    interfaces: []
  };
  function OperatorType() {
    OrganizationTypeBase.call(this, 'Operator');
  }
  OperatorType.$metadata$ = {
    simpleName: 'OperatorType',
    kind: 'class',
    interfaces: []
  };
  function FunderType() {
    OrganizationTypeBase.call(this, 'Funder');
  }
  FunderType.$metadata$ = {
    simpleName: 'FunderType',
    kind: 'class',
    interfaces: []
  };
  function FunderCeeType() {
    OrganizationTypeBase.call(this, 'FunderCee');
  }
  FunderCeeType.$metadata$ = {
    simpleName: 'FunderCeeType',
    kind: 'class',
    interfaces: []
  };
  function CarrierType() {
    OrganizationTypeBase.call(this, 'Carrier');
  }
  CarrierType.$metadata$ = {
    simpleName: 'CarrierType',
    kind: 'class',
    interfaces: []
  };
  function TmsType() {
    OrganizationTypeBase.call(this, 'Tms');
  }
  TmsType.$metadata$ = {
    simpleName: 'TmsType',
    kind: 'class',
    interfaces: []
  };
  function VisitorType() {
    OrganizationTypeBase.call(this, 'Visitor');
  }
  VisitorType.$metadata$ = {
    simpleName: 'VisitorType',
    kind: 'class',
    interfaces: []
  };
  function PackageTypeValues() {
    this.FOOD_1 = new FoodPackageType();
    this.NON_FOOD_1 = new NonFoodPackageType();
    this.WASTE_1 = new WastePackageType();
    this.MIX_FOOD_1 = new MixFoodPackageType();
    this.MIX_NON_FOOD_1 = new MixNonFoodPackageType();
  }
  PackageTypeValues.prototype._get_FOOD__766662061_cog88d_k$ = function () {
    return this.FOOD_1;
  };
  PackageTypeValues.prototype._get_NON_FOOD__1475060507_oe7nyz_k$ = function () {
    return this.NON_FOOD_1;
  };
  PackageTypeValues.prototype._get_WASTE__2765588503_pajw89_k$ = function () {
    return this.WASTE_1;
  };
  PackageTypeValues.prototype._get_MIX_FOOD__1700689770_s4jomi_k$ = function () {
    return this.MIX_FOOD_1;
  };
  PackageTypeValues.prototype._get_MIX_NON_FOOD__3037109848_ksw90o_k$ = function () {
    return this.MIX_NON_FOOD_1;
  };
  PackageTypeValues.prototype.isFood = function (type) {
    return type === this.FOOD_1.value;
  };
  PackageTypeValues.prototype.isNonFood = function (type) {
    return type === this.NON_FOOD_1.value;
  };
  PackageTypeValues.prototype.isWaste = function (type) {
    return type === this.WASTE_1.value;
  };
  PackageTypeValues.prototype.isMixFood = function (type) {
    return type === this.MIX_FOOD_1.value;
  };
  PackageTypeValues.prototype.isMixNonFood = function (type) {
    return type === this.MIX_NON_FOOD_1.value;
  };
  PackageTypeValues.$metadata$ = {
    simpleName: 'PackageTypeValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(PackageTypeValues.prototype, 'FOOD', {
    configurable: true,
    get: PackageTypeValues.prototype._get_FOOD__766662061_cog88d_k$
  });
  Object.defineProperty(PackageTypeValues.prototype, 'NON_FOOD', {
    configurable: true,
    get: PackageTypeValues.prototype._get_NON_FOOD__1475060507_oe7nyz_k$
  });
  Object.defineProperty(PackageTypeValues.prototype, 'WASTE', {
    configurable: true,
    get: PackageTypeValues.prototype._get_WASTE__2765588503_pajw89_k$
  });
  Object.defineProperty(PackageTypeValues.prototype, 'MIX_FOOD', {
    configurable: true,
    get: PackageTypeValues.prototype._get_MIX_FOOD__1700689770_s4jomi_k$
  });
  Object.defineProperty(PackageTypeValues.prototype, 'MIX_NON_FOOD', {
    configurable: true,
    get: PackageTypeValues.prototype._get_MIX_NON_FOOD__3037109848_ksw90o_k$
  });
  function PackageType() {
  }
  PackageType.$metadata$ = {
    simpleName: 'PackageType',
    kind: 'interface',
    interfaces: []
  };
  function PackageTypeBase(value) {
    this.value_1 = value;
  }
  PackageTypeBase.prototype._set_value__1325260276_wbpkyq_k$ = function (_set____804775014) {
    this.value_1 = _set____804775014;
  };
  PackageTypeBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  PackageTypeBase.$metadata$ = {
    simpleName: 'PackageTypeBase',
    kind: 'class',
    interfaces: [PackageType]
  };
  Object.defineProperty(PackageTypeBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    },
    set: function (value) {
      this._set_value__1325260276_wbpkyq_k$(value);
    }
  });
  function FoodPackageType() {
    PackageTypeBase.call(this, 'Food');
  }
  FoodPackageType.$metadata$ = {
    simpleName: 'FoodPackageType',
    kind: 'class',
    interfaces: []
  };
  function NonFoodPackageType() {
    PackageTypeBase.call(this, 'NonFood');
  }
  NonFoodPackageType.$metadata$ = {
    simpleName: 'NonFoodPackageType',
    kind: 'class',
    interfaces: []
  };
  function WastePackageType() {
    PackageTypeBase.call(this, 'Waste');
  }
  WastePackageType.$metadata$ = {
    simpleName: 'WastePackageType',
    kind: 'class',
    interfaces: []
  };
  function MixFoodPackageType() {
    PackageTypeBase.call(this, 'MixFood');
  }
  MixFoodPackageType.$metadata$ = {
    simpleName: 'MixFoodPackageType',
    kind: 'class',
    interfaces: []
  };
  function MixNonFoodPackageType() {
    PackageTypeBase.call(this, 'MixNonFood');
  }
  MixNonFoodPackageType.$metadata$ = {
    simpleName: 'MixNonFoodPackageType',
    kind: 'class',
    interfaces: []
  };
  function PaymentDetails() {
  }
  PaymentDetails.$metadata$ = {
    simpleName: 'PaymentDetails',
    kind: 'interface',
    interfaces: []
  };
  function PaymentDetailsBase(iban, bic, tva) {
    this.iban_1 = iban;
    this.bic_1 = bic;
    this.tva_1 = tva;
  }
  PaymentDetailsBase.prototype._get_iban__799569925_d81k3p_k$ = function () {
    return this.iban_1;
  };
  PaymentDetailsBase.prototype._get_bic__856874773_e65st1_k$ = function () {
    return this.bic_1;
  };
  PaymentDetailsBase.prototype._get_tva__857423442_e6hk5u_k$ = function () {
    return this.tva_1;
  };
  PaymentDetailsBase.$metadata$ = {
    simpleName: 'PaymentDetailsBase',
    kind: 'class',
    interfaces: [PaymentDetails]
  };
  Object.defineProperty(PaymentDetailsBase.prototype, 'iban', {
    configurable: true,
    get: function () {
      return this._get_iban__799569925_d81k3p_k$();
    }
  });
  Object.defineProperty(PaymentDetailsBase.prototype, 'bic', {
    configurable: true,
    get: function () {
      return this._get_bic__856874773_e65st1_k$();
    }
  });
  Object.defineProperty(PaymentDetailsBase.prototype, 'tva', {
    configurable: true,
    get: function () {
      return this._get_tva__857423442_e6hk5u_k$();
    }
  });
  function VisitorAuthorization() {
  }
  VisitorAuthorization.$metadata$ = {
    simpleName: 'VisitorAuthorization',
    kind: 'interface',
    interfaces: []
  };
  function VisitorAuthorizationBase(roles, watchedOperatorId, watchedCarrierId) {
    this.roles_1 = roles;
    this.watchedOperatorId_1 = watchedOperatorId;
    this.watchedCarrierId_1 = watchedCarrierId;
  }
  VisitorAuthorizationBase.prototype._set_roles__1223658024_5lwn61_k$ = function (_set____804775014) {
    this.roles_1 = _set____804775014;
  };
  VisitorAuthorizationBase.prototype._get_roles__3581820084_bsl7ws_k$ = function () {
    return this.roles_1;
  };
  VisitorAuthorizationBase.prototype._set_watchedOperatorId__354289464_yj1yqx_k$ = function (_set____804775014) {
    this.watchedOperatorId_1 = _set____804775014;
  };
  VisitorAuthorizationBase.prototype._get_watchedOperatorId__3336128452_fuv8sc_k$ = function () {
    return this.watchedOperatorId_1;
  };
  VisitorAuthorizationBase.prototype._set_watchedCarrierId__397923666_65156l_k$ = function (_set____804775014) {
    this.watchedCarrierId_1 = _set____804775014;
  };
  VisitorAuthorizationBase.prototype._get_watchedCarrierId__2156680006_zd2x16_k$ = function () {
    return this.watchedCarrierId_1;
  };
  VisitorAuthorizationBase.prototype.component1 = function () {
    return this.roles_1;
  };
  VisitorAuthorizationBase.prototype.component2 = function () {
    return this.watchedOperatorId_1;
  };
  VisitorAuthorizationBase.prototype.component3 = function () {
    return this.watchedCarrierId_1;
  };
  VisitorAuthorizationBase.prototype.copy = function (roles, watchedOperatorId, watchedCarrierId) {
    return this.copy_k7028r_k$(roles === void 1 ? this.roles_1 : roles, watchedOperatorId === void 1 ? this.watchedOperatorId_1 : watchedOperatorId, watchedCarrierId === void 1 ? this.watchedCarrierId_1 : watchedCarrierId);
  };
  VisitorAuthorizationBase.prototype.copy_k7028r_k$ = function (roles, watchedOperatorId, watchedCarrierId) {
    return new VisitorAuthorizationBase(roles, watchedOperatorId, watchedCarrierId);
  };
  VisitorAuthorizationBase.prototype.copy$default_m2ys2z_k$ = function (roles, watchedOperatorId, watchedCarrierId, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      roles = this.roles_1;
    if (!(($mask0 & 2) === 0))
      watchedOperatorId = this.watchedOperatorId_1;
    if (!(($mask0 & 4) === 0))
      watchedCarrierId = this.watchedCarrierId_1;
    return this.copy_k7028r_k$(roles, watchedOperatorId, watchedCarrierId);
  };
  VisitorAuthorizationBase.prototype.toString = function () {
    return 'VisitorAuthorizationBase(roles=' + this.roles_1 + ', watchedOperatorId=' + this.watchedOperatorId_1 + ', watchedCarrierId=' + this.watchedCarrierId_1 + ')';
  };
  VisitorAuthorizationBase.prototype.hashCode = function () {
    var result = hashCode(this.roles_1);
    result = imul(result, 31) + (this.watchedOperatorId_1 == null ? 0 : getStringHashCode(this.watchedOperatorId_1)) | 0;
    result = imul(result, 31) + (this.watchedCarrierId_1 == null ? 0 : getStringHashCode(this.watchedCarrierId_1)) | 0;
    return result;
  };
  VisitorAuthorizationBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitorAuthorizationBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VisitorAuthorizationBase ? other : THROW_CCE();
    if (!equals(this.roles_1, tmp0_other_with_cast.roles_1))
      return false;
    if (!(this.watchedOperatorId_1 == tmp0_other_with_cast.watchedOperatorId_1))
      return false;
    if (!(this.watchedCarrierId_1 == tmp0_other_with_cast.watchedCarrierId_1))
      return false;
    return true;
  };
  VisitorAuthorizationBase.$metadata$ = {
    simpleName: 'VisitorAuthorizationBase',
    kind: 'class',
    interfaces: [VisitorAuthorization]
  };
  Object.defineProperty(VisitorAuthorizationBase.prototype, 'roles', {
    configurable: true,
    get: function () {
      return this._get_roles__3581820084_bsl7ws_k$();
    },
    set: function (value) {
      this._set_roles__1223658024_5lwn61_k$(value);
    }
  });
  Object.defineProperty(VisitorAuthorizationBase.prototype, 'watchedOperatorId', {
    configurable: true,
    get: function () {
      return this._get_watchedOperatorId__3336128452_fuv8sc_k$();
    },
    set: function (value) {
      this._set_watchedOperatorId__354289464_yj1yqx_k$(value);
    }
  });
  Object.defineProperty(VisitorAuthorizationBase.prototype, 'watchedCarrierId', {
    configurable: true,
    get: function () {
      return this._get_watchedCarrierId__2156680006_zd2x16_k$();
    },
    set: function (value) {
      this._set_watchedCarrierId__397923666_65156l_k$(value);
    }
  });
  function _get_ADD_APPLICATION_PROPERTIES__684736875() {
    return ADD_APPLICATION_PROPERTIES;
  }
  var ADD_APPLICATION_PROPERTIES;
  function _get_APPLICATION_PROPERTIES_ADDED__2391332264() {
    return APPLICATION_PROPERTIES_ADDED;
  }
  var APPLICATION_PROPERTIES_ADDED;
  function AddApplicationProperties() {
  }
  AddApplicationProperties.$metadata$ = {
    simpleName: 'AddApplicationPropertiesCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddApplicationPropertiesDTO() {
  }
  AddApplicationPropertiesDTO.$metadata$ = {
    simpleName: 'AddApplicationPropertiesCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddApplicationPropertiesBase(payload) {
    this.payload_1 = payload;
  }
  AddApplicationPropertiesBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddApplicationPropertiesBase.$metadata$ = {
    simpleName: 'AddApplicationPropertiesCommandBase',
    kind: 'class',
    interfaces: [AddApplicationProperties]
  };
  Object.defineProperty(AddApplicationPropertiesBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddApplicationPropertiesBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddApplicationPropertiesDTOBase(properties) {
    this.properties_1 = properties;
  }
  AddApplicationPropertiesDTOBase.prototype._get_properties__3765791160_8r22x4_k$ = function () {
    return this.properties_1;
  };
  AddApplicationPropertiesDTOBase.$metadata$ = {
    simpleName: 'AddApplicationPropertiesCommandDTOBase',
    kind: 'class',
    interfaces: [AddApplicationPropertiesDTO]
  };
  Object.defineProperty(AddApplicationPropertiesDTOBase.prototype, 'properties', {
    configurable: true,
    get: function () {
      return this._get_properties__3765791160_8r22x4_k$();
    }
  });
  function ApplicationPropertiesAddedEvent() {
  }
  ApplicationPropertiesAddedEvent.$metadata$ = {
    simpleName: 'ApplicationPropertiesAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ApplicationPropertiesAddedEventDTO() {
  }
  ApplicationPropertiesAddedEventDTO.$metadata$ = {
    simpleName: 'ApplicationPropertiesAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ApplicationPropertiesAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  ApplicationPropertiesAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ApplicationPropertiesAddedEventBase.$metadata$ = {
    simpleName: 'ApplicationPropertiesAddedEventBase',
    kind: 'class',
    interfaces: [ApplicationPropertiesAddedEvent]
  };
  Object.defineProperty(ApplicationPropertiesAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ApplicationPropertiesAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ApplicationPropertiesAddedEventDTOBase(organizationId, properties) {
    this.organizationId_1 = organizationId;
    this.properties_1 = properties;
  }
  ApplicationPropertiesAddedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ApplicationPropertiesAddedEventDTOBase.prototype._get_properties__3765791160_8r22x4_k$ = function () {
    return this.properties_1;
  };
  ApplicationPropertiesAddedEventDTOBase.$metadata$ = {
    simpleName: 'ApplicationPropertiesAddedEventDTOBase',
    kind: 'class',
    interfaces: [ApplicationPropertiesAddedEventDTO]
  };
  Object.defineProperty(ApplicationPropertiesAddedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ApplicationPropertiesAddedEventDTOBase.prototype, 'properties', {
    configurable: true,
    get: function () {
      return this._get_properties__3765791160_8r22x4_k$();
    }
  });
  function _get_ADD_HUB__1702019546() {
    return ADD_HUB;
  }
  var ADD_HUB;
  function AddHubCommand() {
  }
  AddHubCommand.$metadata$ = {
    simpleName: 'AddHubCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddHubCommandBase(organizationId, payload) {
    this.organizationId_1 = organizationId;
    this.payload_1 = payload;
  }
  AddHubCommandBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  AddHubCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddHubCommandBase.$metadata$ = {
    simpleName: 'AddHubCommandBase',
    kind: 'class',
    interfaces: [AddHubCommand]
  };
  Object.defineProperty(AddHubCommandBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(AddHubCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddHubCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddHubCommandDTO() {
  }
  AddHubCommandDTO.$metadata$ = {
    simpleName: 'AddHubCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddHubCommandDTOBase(address, activityStartDate, territories) {
    this.address_1 = address;
    this.activityStartDate_1 = activityStartDate;
    this.territories_1 = territories;
  }
  AddHubCommandDTOBase.prototype._get_address__907296157_f06i71_k$ = function () {
    return this.address_1;
  };
  AddHubCommandDTOBase.prototype._get_activityStartDate__976647824_g5gya8_k$ = function () {
    return this.activityStartDate_1;
  };
  AddHubCommandDTOBase.prototype._get_territories__3289376345_gmpaxz_k$ = function () {
    return this.territories_1;
  };
  AddHubCommandDTOBase.$metadata$ = {
    simpleName: 'AddHubCommandDTOBase',
    kind: 'class',
    interfaces: [AddHubCommandDTO]
  };
  Object.defineProperty(AddHubCommandDTOBase.prototype, 'address', {
    configurable: true,
    get: function () {
      return this._get_address__907296157_f06i71_k$();
    }
  });
  Object.defineProperty(AddHubCommandDTOBase.prototype, 'activityStartDate', {
    configurable: true,
    get: function () {
      return this._get_activityStartDate__976647824_g5gya8_k$();
    }
  });
  Object.defineProperty(AddHubCommandDTOBase.prototype, 'territories', {
    configurable: true,
    get: function () {
      return this._get_territories__3289376345_gmpaxz_k$();
    }
  });
  function HubAddedEvent() {
  }
  HubAddedEvent.$metadata$ = {
    simpleName: 'HubAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function HubAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  HubAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  HubAddedEventBase.$metadata$ = {
    simpleName: 'HubAddedEventBase',
    kind: 'class',
    interfaces: [HubAddedEvent]
  };
  Object.defineProperty(HubAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(HubAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function HubAddedEventDTO() {
  }
  HubAddedEventDTO.$metadata$ = {
    simpleName: 'HubAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function HubAddedEventDTOBase(organizationId, hubId) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
  }
  HubAddedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  HubAddedEventDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  HubAddedEventDTOBase.$metadata$ = {
    simpleName: 'HubAddedEventDTOBase',
    kind: 'class',
    interfaces: [HubAddedEventDTO]
  };
  Object.defineProperty(HubAddedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(HubAddedEventDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  function _get_USER_CHANGE_PASSWORD__2583171381() {
    return USER_CHANGE_PASSWORD;
  }
  var USER_CHANGE_PASSWORD;
  function ChangeUserPasswordCommand() {
  }
  ChangeUserPasswordCommand.$metadata$ = {
    simpleName: 'ChangeUserPasswordCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ChangeUserPasswordCommandBase(payload) {
    this.payload_1 = payload;
  }
  ChangeUserPasswordCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ChangeUserPasswordCommandBase.$metadata$ = {
    simpleName: 'ChangeUserPasswordCommandBase',
    kind: 'class',
    interfaces: [ChangeUserPasswordCommand]
  };
  Object.defineProperty(ChangeUserPasswordCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ChangeUserPasswordCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ChangeUserPasswordCommandDTO() {
  }
  ChangeUserPasswordCommandDTO.$metadata$ = {
    simpleName: 'ChangeUserPasswordCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function ChangeUserPasswordCommandDTOBase(organizationId, userId, password) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
    this.password_1 = password;
  }
  ChangeUserPasswordCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ChangeUserPasswordCommandDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  ChangeUserPasswordCommandDTOBase.prototype._get_password__553687184_95nfrk_k$ = function () {
    return this.password_1;
  };
  ChangeUserPasswordCommandDTOBase.$metadata$ = {
    simpleName: 'ChangeUserPasswordCommandDTOBase',
    kind: 'class',
    interfaces: [ChangeUserPasswordCommandDTO]
  };
  Object.defineProperty(ChangeUserPasswordCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ChangeUserPasswordCommandDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  Object.defineProperty(ChangeUserPasswordCommandDTOBase.prototype, 'password', {
    configurable: true,
    get: function () {
      return this._get_password__553687184_95nfrk_k$();
    }
  });
  function _get_USER_CHANGED_PASSWORD__2634180407() {
    return USER_CHANGED_PASSWORD;
  }
  var USER_CHANGED_PASSWORD;
  function UserChangedPasswordEvent() {
  }
  UserChangedPasswordEvent.$metadata$ = {
    simpleName: 'UserChangedPasswordEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UserChangedPasswordEventDTO() {
  }
  UserChangedPasswordEventDTO.$metadata$ = {
    simpleName: 'UserChangedPasswordEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function UserChangedPasswordEventDTOBase(organizationId, userId) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
  }
  UserChangedPasswordEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UserChangedPasswordEventDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  UserChangedPasswordEventDTOBase.$metadata$ = {
    simpleName: 'UserChangedPasswordEventDTOBase',
    kind: 'class',
    interfaces: [UserChangedPasswordEventDTO]
  };
  Object.defineProperty(UserChangedPasswordEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(UserChangedPasswordEventDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  function _get_CREATE_CLIENT__2356691491() {
    return CREATE_CLIENT;
  }
  var CREATE_CLIENT;
  function CreateApplicationCommand() {
  }
  CreateApplicationCommand.$metadata$ = {
    simpleName: 'CreateApplicationCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateApplicationCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateApplicationCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateApplicationCommandBase.$metadata$ = {
    simpleName: 'CreateApplicationCommandBase',
    kind: 'class',
    interfaces: [CreateApplicationCommand]
  };
  Object.defineProperty(CreateApplicationCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateApplicationCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateApplicationCommandDTO() {
  }
  CreateApplicationCommandDTO.$metadata$ = {
    simpleName: 'CreateApplicationCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateApplicationCommandDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  CreateApplicationCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  CreateApplicationCommandDTOBase.$metadata$ = {
    simpleName: 'CreateApplicationCommandDTOBase',
    kind: 'class',
    interfaces: [CreateApplicationCommandDTO]
  };
  Object.defineProperty(CreateApplicationCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function ApplicationCreatedEvent() {
  }
  ApplicationCreatedEvent.$metadata$ = {
    simpleName: 'ApplicationCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ApplicationCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  ApplicationCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ApplicationCreatedEventBase.$metadata$ = {
    simpleName: 'ApplicationCreatedEventBase',
    kind: 'class',
    interfaces: [ApplicationCreatedEvent]
  };
  Object.defineProperty(ApplicationCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ApplicationCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ApplicationEventDetails() {
  }
  ApplicationEventDetails.$metadata$ = {
    simpleName: 'ApplicationEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function ApplicationEventDetailsBase(applicationId, keycloackId) {
    this.applicationId_1 = applicationId;
    this.keycloackId_1 = keycloackId;
  }
  ApplicationEventDetailsBase.prototype._get_applicationId__3533113254_cll6ca_k$ = function () {
    return this.applicationId_1;
  };
  ApplicationEventDetailsBase.prototype._get_keycloackId__2470334388_u6c7rg_k$ = function () {
    return this.keycloackId_1;
  };
  ApplicationEventDetailsBase.$metadata$ = {
    simpleName: 'ApplicationEventDetailsBase',
    kind: 'class',
    interfaces: [ApplicationEventDetails]
  };
  Object.defineProperty(ApplicationEventDetailsBase.prototype, 'applicationId', {
    configurable: true,
    get: function () {
      return this._get_applicationId__3533113254_cll6ca_k$();
    }
  });
  Object.defineProperty(ApplicationEventDetailsBase.prototype, 'keycloackId', {
    configurable: true,
    get: function () {
      return this._get_keycloackId__2470334388_u6c7rg_k$();
    }
  });
  function _get_CREATE_ORGANIZATION__281445819() {
    return CREATE_ORGANIZATION;
  }
  var CREATE_ORGANIZATION;
  function CreateOrganizationCommand() {
  }
  CreateOrganizationCommand.$metadata$ = {
    simpleName: 'CreateOrganizationCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateOrganizationCommandDTO() {
  }
  CreateOrganizationCommandDTO.$metadata$ = {
    simpleName: 'CreateOrganizationCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateOrganizationCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateOrganizationCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateOrganizationCommandBase.$metadata$ = {
    simpleName: 'CreateOrganizationCommandBase',
    kind: 'class',
    interfaces: [CreateOrganizationCommand]
  };
  Object.defineProperty(CreateOrganizationCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateOrganizationCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateOrganizationCommandDTOBase_init_$Init$(type, details, packageType, packagePerPallet, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      packageType = null;
    if (!(($mask0 & 8) === 0))
      packagePerPallet = null;
    CreateOrganizationCommandDTOBase.call($this, type, details, packageType, packagePerPallet);
    return $this;
  }
  function CreateOrganizationCommandDTOBase_init_$Create$(type, details, packageType, packagePerPallet, $mask0, $marker) {
    return CreateOrganizationCommandDTOBase_init_$Init$(type, details, packageType, packagePerPallet, $mask0, $marker, Object.create(CreateOrganizationCommandDTOBase.prototype));
  }
  function CreateOrganizationCommandDTOBase(type, details, packageType, packagePerPallet) {
    var packageType_0 = packageType === void 1 ? null : packageType;
    var packagePerPallet_0 = packagePerPallet === void 1 ? null : packagePerPallet;
    this.type_1 = type;
    this.details_1 = details;
    this.packageType_1 = packageType_0;
    this.packagePerPallet_1 = packagePerPallet_0;
  }
  CreateOrganizationCommandDTOBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  CreateOrganizationCommandDTOBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  CreateOrganizationCommandDTOBase.prototype._get_packageType__4062161137_3uludr_k$ = function () {
    return this.packageType_1;
  };
  CreateOrganizationCommandDTOBase.prototype._get_packagePerPallet__652770356_asn4tw_k$ = function () {
    return this.packagePerPallet_1;
  };
  CreateOrganizationCommandDTOBase.$metadata$ = {
    simpleName: 'CreateOrganizationCommandDTOBase',
    kind: 'class',
    interfaces: [CreateOrganizationCommandDTO]
  };
  Object.defineProperty(CreateOrganizationCommandDTOBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(CreateOrganizationCommandDTOBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(CreateOrganizationCommandDTOBase.prototype, 'packageType', {
    configurable: true,
    get: function () {
      return this._get_packageType__4062161137_3uludr_k$();
    }
  });
  Object.defineProperty(CreateOrganizationCommandDTOBase.prototype, 'packagePerPallet', {
    configurable: true,
    get: function () {
      return this._get_packagePerPallet__652770356_asn4tw_k$();
    }
  });
  function _get_CREATED_ORGANIZATION_EVENT__1975633894() {
    return CREATED_ORGANIZATION_EVENT;
  }
  var CREATED_ORGANIZATION_EVENT;
  function OrganizationCreatedEvent() {
  }
  OrganizationCreatedEvent.$metadata$ = {
    simpleName: 'OrganizationCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function OrganizationCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  OrganizationCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  OrganizationCreatedEventBase.$metadata$ = {
    simpleName: 'OrganizationCreatedEventBase',
    kind: 'class',
    interfaces: [OrganizationCreatedEvent]
  };
  Object.defineProperty(OrganizationCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(OrganizationCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function OrganizationEventDetails() {
  }
  OrganizationEventDetails.$metadata$ = {
    simpleName: 'OrganizationEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationEventDetailsBase(id, organizationType, conventionType) {
    this.id_1 = id;
    this.organizationType_1 = organizationType;
    this.conventionType_1 = conventionType;
  }
  OrganizationEventDetailsBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  OrganizationEventDetailsBase.prototype._get_organizationType__2268849502_xiaqhu_k$ = function () {
    return this.organizationType_1;
  };
  OrganizationEventDetailsBase.prototype._get_conventionType__2992762144_ljarxc_k$ = function () {
    return this.conventionType_1;
  };
  OrganizationEventDetailsBase.$metadata$ = {
    simpleName: 'OrganizationEventDetailsBase',
    kind: 'class',
    interfaces: [OrganizationEventDetails]
  };
  Object.defineProperty(OrganizationEventDetailsBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(OrganizationEventDetailsBase.prototype, 'organizationType', {
    configurable: true,
    get: function () {
      return this._get_organizationType__2268849502_xiaqhu_k$();
    }
  });
  Object.defineProperty(OrganizationEventDetailsBase.prototype, 'conventionType', {
    configurable: true,
    get: function () {
      return this._get_conventionType__2992762144_ljarxc_k$();
    }
  });
  function _get_UPLOAD_SIMPLIFIED_CONVENTION__4273269649() {
    return UPLOAD_SIMPLIFIED_CONVENTION;
  }
  var UPLOAD_SIMPLIFIED_CONVENTION;
  function UploadSimplifiedConventionCommand() {
  }
  UploadSimplifiedConventionCommand.$metadata$ = {
    simpleName: 'UploadSimplifiedConventionCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UploadSimplifiedConventionCommandDTO() {
  }
  UploadSimplifiedConventionCommandDTO.$metadata$ = {
    simpleName: 'UploadSimplifiedConventionCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UploadSimplifiedConventionCommandBase(payload) {
    this.payload_1 = payload;
  }
  UploadSimplifiedConventionCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UploadSimplifiedConventionCommandBase.$metadata$ = {
    simpleName: 'UploadSimplifiedConventionCommandBase',
    kind: 'class',
    interfaces: [UploadSimplifiedConventionCommand]
  };
  Object.defineProperty(UploadSimplifiedConventionCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UploadSimplifiedConventionCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UploadSimplifiedConventionCommandDTOBase(id, name, file) {
    this.id_1 = id;
    this.name_1 = name;
    this.file_1 = file;
  }
  UploadSimplifiedConventionCommandDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  UploadSimplifiedConventionCommandDTOBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  UploadSimplifiedConventionCommandDTOBase.prototype._get_file__797018191_d6iv67_k$ = function () {
    return this.file_1;
  };
  UploadSimplifiedConventionCommandDTOBase.$metadata$ = {
    simpleName: 'UploadSimplifiedConventionCommandDTOBase',
    kind: 'class',
    interfaces: [UploadSimplifiedConventionCommandDTO]
  };
  Object.defineProperty(UploadSimplifiedConventionCommandDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(UploadSimplifiedConventionCommandDTOBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(UploadSimplifiedConventionCommandDTOBase.prototype, 'file', {
    configurable: true,
    get: function () {
      return this._get_file__797018191_d6iv67_k$();
    }
  });
  function _get_UPLOADED_SIMPLIFIED_CONVENTION_EVENT__2878814199() {
    return UPLOADED_SIMPLIFIED_CONVENTION_EVENT;
  }
  var UPLOADED_SIMPLIFIED_CONVENTION_EVENT;
  function SimplifiedConventionUploadedEvent() {
  }
  SimplifiedConventionUploadedEvent.$metadata$ = {
    simpleName: 'SimplifiedConventionUploadedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function SimplifiedConventionUploadedEventBase(payload) {
    this.payload_1 = payload;
  }
  SimplifiedConventionUploadedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  SimplifiedConventionUploadedEventBase.$metadata$ = {
    simpleName: 'SimplifiedConventionUploadedEventBase',
    kind: 'class',
    interfaces: [SimplifiedConventionUploadedEvent]
  };
  Object.defineProperty(SimplifiedConventionUploadedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(SimplifiedConventionUploadedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function SimplifiedConventionUploadedEventDTO() {
  }
  SimplifiedConventionUploadedEventDTO.$metadata$ = {
    simpleName: 'SimplifiedConventionUploadedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function SimplifiedConventionUploadedEventDTOBase(id) {
    this.id_1 = id;
  }
  SimplifiedConventionUploadedEventDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  SimplifiedConventionUploadedEventDTOBase.$metadata$ = {
    simpleName: 'SimplifiedConventionUploadedEventDTOBase',
    kind: 'class',
    interfaces: [SimplifiedConventionUploadedEventDTO]
  };
  Object.defineProperty(SimplifiedConventionUploadedEventDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function _get_DELETE_ORGANIZATION__694553642() {
    return DELETE_ORGANIZATION;
  }
  var DELETE_ORGANIZATION;
  function DeleteOrganizationCommand() {
  }
  DeleteOrganizationCommand.$metadata$ = {
    simpleName: 'DeleteOrganizationCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DeleteOrganizationCommandBase(payload) {
    this.payload_1 = payload;
  }
  DeleteOrganizationCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeleteOrganizationCommandBase.$metadata$ = {
    simpleName: 'DeleteOrganizationCommandBase',
    kind: 'class',
    interfaces: [DeleteOrganizationCommand]
  };
  Object.defineProperty(DeleteOrganizationCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeleteOrganizationCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeleteOrganizationDTO() {
  }
  DeleteOrganizationDTO.$metadata$ = {
    simpleName: 'DeleteOrganizationDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeleteOrganizationDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  DeleteOrganizationDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DeleteOrganizationDTOBase.$metadata$ = {
    simpleName: 'DeleteOrganizationDTOBase',
    kind: 'class',
    interfaces: [DeleteOrganizationDTO]
  };
  Object.defineProperty(DeleteOrganizationDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_DELETED_ORGANIZATION_EVENT__610399895() {
    return DELETED_ORGANIZATION_EVENT;
  }
  var DELETED_ORGANIZATION_EVENT;
  function DeletedOrganizationEvent() {
  }
  DeletedOrganizationEvent.$metadata$ = {
    simpleName: 'DeletedOrganizationEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DeletedOrganizationEventBase(payload) {
    this.payload_1 = payload;
  }
  DeletedOrganizationEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeletedOrganizationEventBase.$metadata$ = {
    simpleName: 'DeletedOrganizationEventBase',
    kind: 'class',
    interfaces: [DeletedOrganizationEvent]
  };
  Object.defineProperty(DeletedOrganizationEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeletedOrganizationEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeletedOrganizationDTO() {
  }
  DeletedOrganizationDTO.$metadata$ = {
    simpleName: 'DeletedOrganizationDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeletedOrganizationDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  DeletedOrganizationDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DeletedOrganizationDTOBase.$metadata$ = {
    simpleName: 'DeletedOrganizationDTOBase',
    kind: 'class',
    interfaces: [DeletedOrganizationDTO]
  };
  Object.defineProperty(DeletedOrganizationDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_DELETE_USER__177078162() {
    return DELETE_USER;
  }
  var DELETE_USER;
  function DeleteUserCommand() {
  }
  DeleteUserCommand.$metadata$ = {
    simpleName: 'DeleteUserCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DeleteUserCommandBase(payload) {
    this.payload_1 = payload;
  }
  DeleteUserCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeleteUserCommandBase.$metadata$ = {
    simpleName: 'DeleteUserCommandBase',
    kind: 'class',
    interfaces: [DeleteUserCommand]
  };
  Object.defineProperty(DeleteUserCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeleteUserCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeleteUserDTO() {
  }
  DeleteUserDTO.$metadata$ = {
    simpleName: 'DeleteUserDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeleteUserDTOBase(organizationId, userId) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
  }
  DeleteUserDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DeleteUserDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  DeleteUserDTOBase.$metadata$ = {
    simpleName: 'DeleteUserDTOBase',
    kind: 'class',
    interfaces: [DeleteUserDTO]
  };
  Object.defineProperty(DeleteUserDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(DeleteUserDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  function _get_DELETED_USER_EVENT__1409663999() {
    return DELETED_USER_EVENT;
  }
  var DELETED_USER_EVENT;
  function DeletedUserEvent() {
  }
  DeletedUserEvent.$metadata$ = {
    simpleName: 'DeletedUserEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DeletedUserEventBase(payload) {
    this.payload_1 = payload;
  }
  DeletedUserEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeletedUserEventBase.$metadata$ = {
    simpleName: 'DeletedUserEventBase',
    kind: 'class',
    interfaces: [DeletedUserEvent]
  };
  Object.defineProperty(DeletedUserEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeletedUserEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeletedUserDTO() {
  }
  DeletedUserDTO.$metadata$ = {
    simpleName: 'DeletedUserDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeletedUserDTOBase(organizationId, userId) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
  }
  DeletedUserDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DeletedUserDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  DeletedUserDTOBase.$metadata$ = {
    simpleName: 'DeletedUserDTOBase',
    kind: 'class',
    interfaces: [DeletedUserDTO]
  };
  Object.defineProperty(DeletedUserDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(DeletedUserDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  function _get_DISABLE_ORGANIZATION__1420290113() {
    return DISABLE_ORGANIZATION;
  }
  var DISABLE_ORGANIZATION;
  function DisableOrganizationCommand() {
  }
  DisableOrganizationCommand.$metadata$ = {
    simpleName: 'DisableOrganizationCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DisableOrganizationCommandBase(payload) {
    this.payload_1 = payload;
  }
  DisableOrganizationCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DisableOrganizationCommandBase.$metadata$ = {
    simpleName: 'DisableOrganizationCommandBase',
    kind: 'class',
    interfaces: [DisableOrganizationCommand]
  };
  Object.defineProperty(DisableOrganizationCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DisableOrganizationCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DisableOrganizationDTO() {
  }
  DisableOrganizationDTO.$metadata$ = {
    simpleName: 'DisableOrganizationDTO',
    kind: 'interface',
    interfaces: []
  };
  function DisableOrganizationDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  DisableOrganizationDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DisableOrganizationDTOBase.$metadata$ = {
    simpleName: 'DisableOrganizationDTOBase',
    kind: 'class',
    interfaces: [DisableOrganizationDTO]
  };
  Object.defineProperty(DisableOrganizationDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_DISABLED_ORGANIZATION_EVENT__3586892448() {
    return DISABLED_ORGANIZATION_EVENT;
  }
  var DISABLED_ORGANIZATION_EVENT;
  function DisabledOrganizationEvent() {
  }
  DisabledOrganizationEvent.$metadata$ = {
    simpleName: 'DisabledOrganizationEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DisabledOrganizationEventBase(payload) {
    this.payload_1 = payload;
  }
  DisabledOrganizationEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DisabledOrganizationEventBase.$metadata$ = {
    simpleName: 'DisabledOrganizationEventBase',
    kind: 'class',
    interfaces: [DisabledOrganizationEvent]
  };
  Object.defineProperty(DisabledOrganizationEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DisabledOrganizationEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DisabledOrganizationDTO() {
  }
  DisabledOrganizationDTO.$metadata$ = {
    simpleName: 'DisabledOrganizationDTO',
    kind: 'interface',
    interfaces: []
  };
  function DisabledOrganizationDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  DisabledOrganizationDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DisabledOrganizationDTOBase.$metadata$ = {
    simpleName: 'DisabledOrganizationDTOBase',
    kind: 'class',
    interfaces: [DisabledOrganizationDTO]
  };
  Object.defineProperty(DisabledOrganizationDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_DISABLE_USER__3275547305() {
    return DISABLE_USER;
  }
  var DISABLE_USER;
  function DisableUserCommand() {
  }
  DisableUserCommand.$metadata$ = {
    simpleName: 'DisableUserCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DisableUserCommandBase(payload) {
    this.payload_1 = payload;
  }
  DisableUserCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DisableUserCommandBase.$metadata$ = {
    simpleName: 'DisableUserCommandBase',
    kind: 'class',
    interfaces: [DisableUserCommand]
  };
  Object.defineProperty(DisableUserCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DisableUserCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DisableUserDTO() {
  }
  DisableUserDTO.$metadata$ = {
    simpleName: 'DisableUserDTO',
    kind: 'interface',
    interfaces: []
  };
  function DisableUserDTOBase(organizationId, userId) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
  }
  DisableUserDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DisableUserDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  DisableUserDTOBase.$metadata$ = {
    simpleName: 'DisableUserDTOBase',
    kind: 'class',
    interfaces: [DisableUserDTO]
  };
  Object.defineProperty(DisableUserDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(DisableUserDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  function _get_DISABLED_USER_EVENT__463243528() {
    return DISABLED_USER_EVENT;
  }
  var DISABLED_USER_EVENT;
  function DisabledUserEvent() {
  }
  DisabledUserEvent.$metadata$ = {
    simpleName: 'DisabledUserEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DisabledUserEventBase(payload) {
    this.payload_1 = payload;
  }
  DisabledUserEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DisabledUserEventBase.$metadata$ = {
    simpleName: 'DisabledUserEventBase',
    kind: 'class',
    interfaces: [DisabledUserEvent]
  };
  Object.defineProperty(DisabledUserEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DisabledUserEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DisabledUserDTO() {
  }
  DisabledUserDTO.$metadata$ = {
    simpleName: 'DisabledUserDTO',
    kind: 'interface',
    interfaces: []
  };
  function DisabledUserDTOBase(organizationId, userId) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
  }
  DisabledUserDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DisabledUserDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  DisabledUserDTOBase.$metadata$ = {
    simpleName: 'DisabledUserDTOBase',
    kind: 'class',
    interfaces: [DisabledUserDTO]
  };
  Object.defineProperty(DisabledUserDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(DisabledUserDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  function _get_ENABLE_USER__3544931690() {
    return ENABLE_USER;
  }
  var ENABLE_USER;
  function EnableUserCommand() {
  }
  EnableUserCommand.$metadata$ = {
    simpleName: 'EnableUserCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function EnableUserCommandBase(payload) {
    this.payload_1 = payload;
  }
  EnableUserCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  EnableUserCommandBase.$metadata$ = {
    simpleName: 'EnableUserCommandBase',
    kind: 'class',
    interfaces: [EnableUserCommand]
  };
  Object.defineProperty(EnableUserCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(EnableUserCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function EnableUserDTO() {
  }
  EnableUserDTO.$metadata$ = {
    simpleName: 'EnableUserDTO',
    kind: 'interface',
    interfaces: []
  };
  function EnableUserDTOBase(organizationId, userId) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
  }
  EnableUserDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  EnableUserDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  EnableUserDTOBase.$metadata$ = {
    simpleName: 'EnableUserDTOBase',
    kind: 'class',
    interfaces: [EnableUserDTO]
  };
  Object.defineProperty(EnableUserDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(EnableUserDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  function _get_ENABLED_USER_EVENT__536060711() {
    return ENABLED_USER_EVENT;
  }
  var ENABLED_USER_EVENT;
  function EnabledUserEvent() {
  }
  EnabledUserEvent.$metadata$ = {
    simpleName: 'EnabledUserEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function EnabledUserEventBase(payload) {
    this.payload_1 = payload;
  }
  EnabledUserEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  EnabledUserEventBase.$metadata$ = {
    simpleName: 'EnabledUserEventBase',
    kind: 'class',
    interfaces: [EnabledUserEvent]
  };
  Object.defineProperty(EnabledUserEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(EnabledUserEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function EnabledUserDTO() {
  }
  EnabledUserDTO.$metadata$ = {
    simpleName: 'EnabledUserDTO',
    kind: 'interface',
    interfaces: []
  };
  function EnabledUserDTOBase(organizationId, userId, isFirstConnection) {
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
    this.isFirstConnection_1 = isFirstConnection;
  }
  EnabledUserDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  EnabledUserDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  EnabledUserDTOBase.prototype._get_isFirstConnection__4251488429_pvwib_k$ = function () {
    return this.isFirstConnection_1;
  };
  EnabledUserDTOBase.$metadata$ = {
    simpleName: 'EnabledUserDTOBase',
    kind: 'class',
    interfaces: [EnabledUserDTO]
  };
  Object.defineProperty(EnabledUserDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(EnabledUserDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  Object.defineProperty(EnabledUserDTOBase.prototype, 'isFirstConnection', {
    configurable: true,
    get: function () {
      return this._get_isFirstConnection__4251488429_pvwib_k$();
    }
  });
  function ExportAuthorizationUpdateCommand() {
  }
  ExportAuthorizationUpdateCommand.$metadata$ = {
    simpleName: 'ExportAuthorizationUpdateCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ExportAuthorizationUpdateCommandBase(payload, organizationId) {
    this.payload_1 = payload;
    this.organizationId_1 = organizationId;
  }
  ExportAuthorizationUpdateCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ExportAuthorizationUpdateCommandBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ExportAuthorizationUpdateCommandBase.$metadata$ = {
    simpleName: 'ExportAuthorizationUpdateCommandBase',
    kind: 'class',
    interfaces: [ExportAuthorizationUpdateCommand]
  };
  Object.defineProperty(ExportAuthorizationUpdateCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ExportAuthorizationUpdateCommandBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ExportAuthorizationUpdateCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ExportAuthorizationUpdatedEvent() {
  }
  ExportAuthorizationUpdatedEvent.$metadata$ = {
    simpleName: 'ExportAuthorizationUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ExportAuthorizationUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  ExportAuthorizationUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ExportAuthorizationUpdatedEventBase.$metadata$ = {
    simpleName: 'ExportAuthorizationUpdatedEventBase',
    kind: 'class',
    interfaces: [ExportAuthorizationUpdatedEvent]
  };
  Object.defineProperty(ExportAuthorizationUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ExportAuthorizationUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ExportAuthorizationUpdatedEventDTO() {
  }
  ExportAuthorizationUpdatedEventDTO.$metadata$ = {
    simpleName: 'ExportAuthorizationUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ExportAuthorizationUpdatedEventDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  ExportAuthorizationUpdatedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ExportAuthorizationUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'ExportAuthorizationUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [ExportAuthorizationUpdatedEventDTO]
  };
  Object.defineProperty(ExportAuthorizationUpdatedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_EXPORT_DOLIBARR_ORGANIZATIONS__858079998() {
    return EXPORT_DOLIBARR_ORGANIZATIONS;
  }
  var EXPORT_DOLIBARR_ORGANIZATIONS;
  function ExportDolibarrOrganizationsQuery() {
  }
  ExportDolibarrOrganizationsQuery.$metadata$ = {
    simpleName: 'ExportDolibarrOrganizationsQuery',
    kind: 'interface',
    interfaces: [Command]
  };
  function ExportDolibarrOrganizationsQueryDTO() {
  }
  ExportDolibarrOrganizationsQueryDTO.$metadata$ = {
    simpleName: 'ExportDolibarrOrganizationsQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ExportDolibarrOrganizationsQueryBase(payload) {
    this.payload_1 = payload;
  }
  ExportDolibarrOrganizationsQueryBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ExportDolibarrOrganizationsQueryBase.$metadata$ = {
    simpleName: 'ExportDolibarrOrganizationsQueryBase',
    kind: 'class',
    interfaces: [ExportDolibarrOrganizationsQuery]
  };
  Object.defineProperty(ExportDolibarrOrganizationsQueryBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ExportDolibarrOrganizationsQueryBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ExportDolibarrOrganizationsQueryDTOBase(period, type) {
    this.period_1 = period;
    this.type_1 = type;
  }
  ExportDolibarrOrganizationsQueryDTOBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  ExportDolibarrOrganizationsQueryDTOBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  ExportDolibarrOrganizationsQueryDTOBase.$metadata$ = {
    simpleName: 'ExportDolibarrOrganizationsQueryDTOBase',
    kind: 'class',
    interfaces: [ExportDolibarrOrganizationsQueryDTO]
  };
  Object.defineProperty(ExportDolibarrOrganizationsQueryDTOBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(ExportDolibarrOrganizationsQueryDTOBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_EXPORT_ORGANIZATIONS__3146513078() {
    return EXPORT_ORGANIZATIONS;
  }
  var EXPORT_ORGANIZATIONS;
  function ExportOrganizationsQuery() {
  }
  ExportOrganizationsQuery.$metadata$ = {
    simpleName: 'ExportOrganizationsQuery',
    kind: 'interface',
    interfaces: [Command]
  };
  function ExportOrganizationsQueryDTO() {
  }
  ExportOrganizationsQueryDTO.$metadata$ = {
    simpleName: 'ExportOrganizationsQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ExportOrganizationsQueryBase(payload) {
    this.payload_1 = payload;
  }
  ExportOrganizationsQueryBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ExportOrganizationsQueryBase.$metadata$ = {
    simpleName: 'ExportOrganizationsQueryBase',
    kind: 'class',
    interfaces: [ExportOrganizationsQuery]
  };
  Object.defineProperty(ExportOrganizationsQueryBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ExportOrganizationsQueryBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ExportOrganizationsQueryDTOBase_init_$Init$(types, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      types = null;
    ExportOrganizationsQueryDTOBase.call($this, types);
    return $this;
  }
  function ExportOrganizationsQueryDTOBase_init_$Create$(types, $mask0, $marker) {
    return ExportOrganizationsQueryDTOBase_init_$Init$(types, $mask0, $marker, Object.create(ExportOrganizationsQueryDTOBase.prototype));
  }
  function ExportOrganizationsQueryDTOBase(types) {
    var types_0 = types === void 1 ? null : types;
    this.types_1 = types_0;
  }
  ExportOrganizationsQueryDTOBase.prototype._get_types__3648432760_aoxh8o_k$ = function () {
    return this.types_1;
  };
  ExportOrganizationsQueryDTOBase.$metadata$ = {
    simpleName: 'ExportOrganizationsQueryDTOBase',
    kind: 'class',
    interfaces: [ExportOrganizationsQueryDTO]
  };
  Object.defineProperty(ExportOrganizationsQueryDTOBase.prototype, 'types', {
    configurable: true,
    get: function () {
      return this._get_types__3648432760_aoxh8o_k$();
    }
  });
  function _get_HUB_ACTIVATION_TOGGLE__3035746942() {
    return HUB_ACTIVATION_TOGGLE;
  }
  var HUB_ACTIVATION_TOGGLE;
  function HubActivationToggleCommand() {
  }
  HubActivationToggleCommand.$metadata$ = {
    simpleName: 'HubActivationToggleCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function HubActivationToggleCommandBase(payload) {
    this.payload_1 = payload;
  }
  HubActivationToggleCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  HubActivationToggleCommandBase.$metadata$ = {
    simpleName: 'HubActivationToggleCommandBase',
    kind: 'class',
    interfaces: [HubActivationToggleCommand]
  };
  Object.defineProperty(HubActivationToggleCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(HubActivationToggleCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function HubActivationToggleCommandDTO() {
  }
  HubActivationToggleCommandDTO.$metadata$ = {
    simpleName: 'HubActivationToggleCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function HubActivationToggleCommandDTOBase(organizationId, hubId) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
  }
  HubActivationToggleCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  HubActivationToggleCommandDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  HubActivationToggleCommandDTOBase.$metadata$ = {
    simpleName: 'HubActivationToggleCommandDTOBase',
    kind: 'class',
    interfaces: [HubActivationToggleCommandDTO]
  };
  Object.defineProperty(HubActivationToggleCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(HubActivationToggleCommandDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  function _get_HUB_ACTIVATION_TOGGLED_EVENT__1826874143() {
    return HUB_ACTIVATION_TOGGLED_EVENT;
  }
  var HUB_ACTIVATION_TOGGLED_EVENT;
  function HubActivationToggledEvent() {
  }
  HubActivationToggledEvent.$metadata$ = {
    simpleName: 'HubActivationToggledEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function HubActivationToggledEventBase(payload) {
    this.payload_1 = payload;
  }
  HubActivationToggledEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  HubActivationToggledEventBase.$metadata$ = {
    simpleName: 'HubActivationToggledEventBase',
    kind: 'class',
    interfaces: [HubActivationToggledEvent]
  };
  Object.defineProperty(HubActivationToggledEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(HubActivationToggledEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function HubActivationToggledEventDTO() {
  }
  HubActivationToggledEventDTO.$metadata$ = {
    simpleName: 'HubActivationToggledEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function HubActivationToggledEventDTOBase(organizationId, hubId, activityEndDate) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
    this.activityEndDate_1 = activityEndDate;
  }
  HubActivationToggledEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  HubActivationToggledEventDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  HubActivationToggledEventDTOBase.prototype._get_activityEndDate__3137375799_j577bd_k$ = function () {
    return this.activityEndDate_1;
  };
  HubActivationToggledEventDTOBase.$metadata$ = {
    simpleName: 'HubActivationToggledEventDTOBase',
    kind: 'class',
    interfaces: [HubActivationToggledEventDTO]
  };
  Object.defineProperty(HubActivationToggledEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(HubActivationToggledEventDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  Object.defineProperty(HubActivationToggledEventDTOBase.prototype, 'activityEndDate', {
    configurable: true,
    get: function () {
      return this._get_activityEndDate__3137375799_j577bd_k$();
    }
  });
  function _get_LOGO_CREATE__336547201() {
    return LOGO_CREATE;
  }
  var LOGO_CREATE;
  function LogoCreatedCommand() {
  }
  LogoCreatedCommand.$metadata$ = {
    simpleName: 'LogoCreateCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function LogoCreatedCommandDetails() {
  }
  LogoCreatedCommandDetails.$metadata$ = {
    simpleName: 'LogoCreateCommandDetails',
    kind: 'interface',
    interfaces: []
  };
  function LogoCreatedCommandDetailsBase(id, logo, name, type) {
    this.id_1 = id;
    this.logo_1 = logo;
    this.name_1 = name;
    this.type_1 = type;
  }
  LogoCreatedCommandDetailsBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  LogoCreatedCommandDetailsBase.prototype._get_logo__802733568_d9xd6o_k$ = function () {
    return this.logo_1;
  };
  LogoCreatedCommandDetailsBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  LogoCreatedCommandDetailsBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  LogoCreatedCommandDetailsBase.$metadata$ = {
    simpleName: 'LogoCreateCommandDetailsBase',
    kind: 'class',
    interfaces: [LogoCreatedCommandDetails]
  };
  Object.defineProperty(LogoCreatedCommandDetailsBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(LogoCreatedCommandDetailsBase.prototype, 'logo', {
    configurable: true,
    get: function () {
      return this._get_logo__802733568_d9xd6o_k$();
    }
  });
  Object.defineProperty(LogoCreatedCommandDetailsBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(LogoCreatedCommandDetailsBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function LogoCreatedCommandBase(payload) {
    this.payload_1 = payload;
  }
  LogoCreatedCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  LogoCreatedCommandBase.$metadata$ = {
    simpleName: 'LogoCreateCommandBase',
    kind: 'class',
    interfaces: [LogoCreatedCommand]
  };
  Object.defineProperty(LogoCreatedCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(LogoCreatedCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_LOGO_CREATED_EVENT__2874773180() {
    return LOGO_CREATED_EVENT;
  }
  var LOGO_CREATED_EVENT;
  function LogoEvent() {
  }
  LogoEvent.$metadata$ = {
    simpleName: 'LogoCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function LogoCreatedEventDetails() {
  }
  LogoCreatedEventDetails.$metadata$ = {
    simpleName: 'LogoCreatedEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function LogoCreatedEventDetailsBase(id) {
    this.id_1 = id;
  }
  LogoCreatedEventDetailsBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  LogoCreatedEventDetailsBase.$metadata$ = {
    simpleName: 'LogoCreatedEventDetailsBase',
    kind: 'class',
    interfaces: [LogoCreatedEventDetails]
  };
  Object.defineProperty(LogoCreatedEventDetailsBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function LogoCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  LogoCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  LogoCreatedEventBase.$metadata$ = {
    simpleName: 'LogoCreatedEventBase',
    kind: 'class',
    interfaces: [LogoEvent]
  };
  Object.defineProperty(LogoCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(LogoCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_USER_ADD__341970782() {
    return USER_ADD;
  }
  var USER_ADD;
  function OrganizationAddUserCommand() {
  }
  OrganizationAddUserCommand.$metadata$ = {
    simpleName: 'OrganizationAddUserCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function OrganizationAddUserCommandBase(payload) {
    this.payload_1 = payload;
  }
  OrganizationAddUserCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  OrganizationAddUserCommandBase.$metadata$ = {
    simpleName: 'OrganizationAddUserCommandBase',
    kind: 'class',
    interfaces: [OrganizationAddUserCommand]
  };
  Object.defineProperty(OrganizationAddUserCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(OrganizationAddUserCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function OrganizationAddUserCommandDTO() {
  }
  OrganizationAddUserCommandDTO.$metadata$ = {
    simpleName: 'OrganizationAddUserCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationAddUserCommandDTOBase(organizationId, userDetails) {
    this.organizationId_1 = organizationId;
    this.userDetails_1 = userDetails;
  }
  OrganizationAddUserCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  OrganizationAddUserCommandDTOBase.prototype._get_userDetails__1930978426_vxnkhm_k$ = function () {
    return this.userDetails_1;
  };
  OrganizationAddUserCommandDTOBase.$metadata$ = {
    simpleName: 'OrganizationAddUserCommandDTOBase',
    kind: 'class',
    interfaces: [OrganizationAddUserCommandDTO]
  };
  Object.defineProperty(OrganizationAddUserCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(OrganizationAddUserCommandDTOBase.prototype, 'userDetails', {
    configurable: true,
    get: function () {
      return this._get_userDetails__1930978426_vxnkhm_k$();
    }
  });
  function _get_USER_ADDED_EVENT__3351091140() {
    return USER_ADDED_EVENT;
  }
  var USER_ADDED_EVENT;
  function UserAddedEvent() {
  }
  UserAddedEvent.$metadata$ = {
    simpleName: 'UserAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UserEventDetails() {
  }
  UserEventDetails.$metadata$ = {
    simpleName: 'UserEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function UserAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  UserAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UserAddedEventBase.$metadata$ = {
    simpleName: 'UserAddedEventBase',
    kind: 'class',
    interfaces: [UserAddedEvent]
  };
  Object.defineProperty(UserAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UserAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UserEventDetailsBase_init_$Init$(organizationId, userId, userDetails, organizationType, inviter, visitorAuthorization, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0))
      visitorAuthorization = null;
    UserEventDetailsBase.call($this, organizationId, userId, userDetails, organizationType, inviter, visitorAuthorization);
    return $this;
  }
  function UserEventDetailsBase_init_$Create$(organizationId, userId, userDetails, organizationType, inviter, visitorAuthorization, $mask0, $marker) {
    return UserEventDetailsBase_init_$Init$(organizationId, userId, userDetails, organizationType, inviter, visitorAuthorization, $mask0, $marker, Object.create(UserEventDetailsBase.prototype));
  }
  function UserEventDetailsBase(organizationId, userId, userDetails, organizationType, inviter, visitorAuthorization) {
    var visitorAuthorization_0 = visitorAuthorization === void 1 ? null : visitorAuthorization;
    this.organizationId_1 = organizationId;
    this.userId_1 = userId;
    this.userDetails_1 = userDetails;
    this.organizationType_1 = organizationType;
    this.inviter_1 = inviter;
    this.visitorAuthorization_1 = visitorAuthorization_0;
  }
  UserEventDetailsBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UserEventDetailsBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  UserEventDetailsBase.prototype._get_userDetails__1930978426_vxnkhm_k$ = function () {
    return this.userDetails_1;
  };
  UserEventDetailsBase.prototype._get_organizationType__2268849502_xiaqhu_k$ = function () {
    return this.organizationType_1;
  };
  UserEventDetailsBase.prototype._get_inviter__2757425576_pfeus8_k$ = function () {
    return this.inviter_1;
  };
  UserEventDetailsBase.prototype._get_visitorAuthorization__1161751296_j7od1c_k$ = function () {
    return this.visitorAuthorization_1;
  };
  UserEventDetailsBase.$metadata$ = {
    simpleName: 'UserEventDetailsBase',
    kind: 'class',
    interfaces: [UserEventDetails]
  };
  Object.defineProperty(UserEventDetailsBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(UserEventDetailsBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  Object.defineProperty(UserEventDetailsBase.prototype, 'userDetails', {
    configurable: true,
    get: function () {
      return this._get_userDetails__1930978426_vxnkhm_k$();
    }
  });
  Object.defineProperty(UserEventDetailsBase.prototype, 'organizationType', {
    configurable: true,
    get: function () {
      return this._get_organizationType__2268849502_xiaqhu_k$();
    }
  });
  Object.defineProperty(UserEventDetailsBase.prototype, 'inviter', {
    configurable: true,
    get: function () {
      return this._get_inviter__2757425576_pfeus8_k$();
    }
  });
  Object.defineProperty(UserEventDetailsBase.prototype, 'visitorAuthorization', {
    configurable: true,
    get: function () {
      return this._get_visitorAuthorization__1161751296_j7od1c_k$();
    }
  });
  function _get_USER_UPDATE__903066996() {
    return USER_UPDATE;
  }
  var USER_UPDATE;
  function OrganizationUpdateUserDetailsCommand() {
  }
  OrganizationUpdateUserDetailsCommand.$metadata$ = {
    simpleName: 'OrganizationUpdateUserDetailsCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function OrganizationUpdateUserDetailsCommandBase(payload) {
    this.payload_1 = payload;
  }
  OrganizationUpdateUserDetailsCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  OrganizationUpdateUserDetailsCommandBase.$metadata$ = {
    simpleName: 'OrganizationUpdateUserDetailsCommandBase',
    kind: 'class',
    interfaces: [OrganizationUpdateUserDetailsCommand]
  };
  Object.defineProperty(OrganizationUpdateUserDetailsCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(OrganizationUpdateUserDetailsCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function OrganizationUpdateUserDetailsCommandDTO() {
  }
  OrganizationUpdateUserDetailsCommandDTO.$metadata$ = {
    simpleName: 'OrganizationUpdateUserDetailsCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationUpdateUserDetailsCommandDTOBase(organizationId, userDetails) {
    this.organizationId_1 = organizationId;
    this.userDetails_1 = userDetails;
  }
  OrganizationUpdateUserDetailsCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  OrganizationUpdateUserDetailsCommandDTOBase.prototype._get_userDetails__1930978426_vxnkhm_k$ = function () {
    return this.userDetails_1;
  };
  OrganizationUpdateUserDetailsCommandDTOBase.$metadata$ = {
    simpleName: 'OrganizationUpdateUserDetailsCommandDTOBase',
    kind: 'class',
    interfaces: [OrganizationUpdateUserDetailsCommandDTO]
  };
  Object.defineProperty(OrganizationUpdateUserDetailsCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(OrganizationUpdateUserDetailsCommandDTOBase.prototype, 'userDetails', {
    configurable: true,
    get: function () {
      return this._get_userDetails__1930978426_vxnkhm_k$();
    }
  });
  function _get_USER_UPDATED_EVENT__4175486825() {
    return USER_UPDATED_EVENT;
  }
  var USER_UPDATED_EVENT;
  function UserUpdatedEvent() {
  }
  UserUpdatedEvent.$metadata$ = {
    simpleName: 'UserUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UserUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  UserUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UserUpdatedEventBase.$metadata$ = {
    simpleName: 'UserUpdatedEventBase',
    kind: 'class',
    interfaces: [UserUpdatedEvent]
  };
  Object.defineProperty(UserUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UserUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_UPDATE_ORGANIZATION__4198560456() {
    return UPDATE_ORGANIZATION;
  }
  var UPDATE_ORGANIZATION;
  function OrganizationUpdateCommand() {
  }
  OrganizationUpdateCommand.$metadata$ = {
    simpleName: 'OrganizationUpdateCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function OrganizationUpdateCommandBase(payload) {
    this.payload_1 = payload;
  }
  OrganizationUpdateCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  OrganizationUpdateCommandBase.$metadata$ = {
    simpleName: 'OrganizationUpdateCommandBase',
    kind: 'class',
    interfaces: [OrganizationUpdateCommand]
  };
  Object.defineProperty(OrganizationUpdateCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(OrganizationUpdateCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateOrganizationCommandDTO() {
  }
  UpdateOrganizationCommandDTO.$metadata$ = {
    simpleName: 'UpdateOrganizationCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateOrganizationCommandDTOBase_init_$Init$(type, details, organizationId, packageType, packagePerPallet, minPointsPerTourThreshold, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      packagePerPallet = null;
    if (!(($mask0 & 32) === 0))
      minPointsPerTourThreshold = null;
    UpdateOrganizationCommandDTOBase.call($this, type, details, organizationId, packageType, packagePerPallet, minPointsPerTourThreshold);
    return $this;
  }
  function UpdateOrganizationCommandDTOBase_init_$Create$(type, details, organizationId, packageType, packagePerPallet, minPointsPerTourThreshold, $mask0, $marker) {
    return UpdateOrganizationCommandDTOBase_init_$Init$(type, details, organizationId, packageType, packagePerPallet, minPointsPerTourThreshold, $mask0, $marker, Object.create(UpdateOrganizationCommandDTOBase.prototype));
  }
  function UpdateOrganizationCommandDTOBase(type, details, organizationId, packageType, packagePerPallet, minPointsPerTourThreshold) {
    var packagePerPallet_0 = packagePerPallet === void 1 ? null : packagePerPallet;
    var minPointsPerTourThreshold_0 = minPointsPerTourThreshold === void 1 ? null : minPointsPerTourThreshold;
    this.type_1 = type;
    this.details_1 = details;
    this.organizationId_1 = organizationId;
    this.packageType_1 = packageType;
    this.packagePerPallet_1 = packagePerPallet_0;
    this.minPointsPerTourThreshold_1 = minPointsPerTourThreshold_0;
  }
  UpdateOrganizationCommandDTOBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  UpdateOrganizationCommandDTOBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  UpdateOrganizationCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UpdateOrganizationCommandDTOBase.prototype._get_packageType__4062161137_3uludr_k$ = function () {
    return this.packageType_1;
  };
  UpdateOrganizationCommandDTOBase.prototype._get_packagePerPallet__652770356_asn4tw_k$ = function () {
    return this.packagePerPallet_1;
  };
  UpdateOrganizationCommandDTOBase.prototype._get_minPointsPerTourThreshold__2301177574_wz1tzu_k$ = function () {
    return this.minPointsPerTourThreshold_1;
  };
  UpdateOrganizationCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateOrganizationCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateOrganizationCommandDTO]
  };
  Object.defineProperty(UpdateOrganizationCommandDTOBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(UpdateOrganizationCommandDTOBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(UpdateOrganizationCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(UpdateOrganizationCommandDTOBase.prototype, 'packageType', {
    configurable: true,
    get: function () {
      return this._get_packageType__4062161137_3uludr_k$();
    }
  });
  Object.defineProperty(UpdateOrganizationCommandDTOBase.prototype, 'packagePerPallet', {
    configurable: true,
    get: function () {
      return this._get_packagePerPallet__652770356_asn4tw_k$();
    }
  });
  Object.defineProperty(UpdateOrganizationCommandDTOBase.prototype, 'minPointsPerTourThreshold', {
    configurable: true,
    get: function () {
      return this._get_minPointsPerTourThreshold__2301177574_wz1tzu_k$();
    }
  });
  function OrganizationUpdatedEvent() {
  }
  OrganizationUpdatedEvent.$metadata$ = {
    simpleName: 'OrganizationUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function OrganizationUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  OrganizationUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  OrganizationUpdatedEventBase.$metadata$ = {
    simpleName: 'OrganizationUpdatedEventBase',
    kind: 'class',
    interfaces: [OrganizationUpdatedEvent]
  };
  Object.defineProperty(OrganizationUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(OrganizationUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_REMOVE_HUB__2314545() {
    return REMOVE_HUB;
  }
  var REMOVE_HUB;
  function RemoveHubCommand() {
  }
  RemoveHubCommand.$metadata$ = {
    simpleName: 'RemoveHubCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function RemoveHubCommandBase(payload) {
    this.payload_1 = payload;
  }
  RemoveHubCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  RemoveHubCommandBase.$metadata$ = {
    simpleName: 'RemoveHubCommandBase',
    kind: 'class',
    interfaces: [RemoveHubCommand]
  };
  Object.defineProperty(RemoveHubCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(RemoveHubCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function RemoveHubDTO() {
  }
  RemoveHubDTO.$metadata$ = {
    simpleName: 'RemoveHubDTO',
    kind: 'interface',
    interfaces: []
  };
  function RemoveHubDTOBase(organizationId, hubId) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
  }
  RemoveHubDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  RemoveHubDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  RemoveHubDTOBase.$metadata$ = {
    simpleName: 'RemoveHubDTOBase',
    kind: 'class',
    interfaces: [RemoveHubDTO]
  };
  Object.defineProperty(RemoveHubDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(RemoveHubDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  function _get_HUB_REMOVED_EVENT__3386574240() {
    return HUB_REMOVED_EVENT;
  }
  var HUB_REMOVED_EVENT;
  function HubRemovedEvent() {
  }
  HubRemovedEvent.$metadata$ = {
    simpleName: 'HubRemovedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function HubRemovedEventBase(payload) {
    this.payload_1 = payload;
  }
  HubRemovedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  HubRemovedEventBase.$metadata$ = {
    simpleName: 'HubRemovedEventBase',
    kind: 'class',
    interfaces: [HubRemovedEvent]
  };
  Object.defineProperty(HubRemovedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(HubRemovedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function HubRemovedEventDTO() {
  }
  HubRemovedEventDTO.$metadata$ = {
    simpleName: 'HubRemovedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function HubRemovedEventDTOBase(organizationId, hubId) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
  }
  HubRemovedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  HubRemovedEventDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  HubRemovedEventDTOBase.$metadata$ = {
    simpleName: 'HubRemovedEventDTOBase',
    kind: 'class',
    interfaces: [HubRemovedEventDTO]
  };
  Object.defineProperty(HubRemovedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(HubRemovedEventDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  function _get_SET_ORGANIZATION_RSA_KEYPAIR__1563051488() {
    return SET_ORGANIZATION_RSA_KEYPAIR;
  }
  var SET_ORGANIZATION_RSA_KEYPAIR;
  function _get_ORGANIZATION_RSA_KEYPAIR_SET__1323295610() {
    return ORGANIZATION_RSA_KEYPAIR_SET;
  }
  var ORGANIZATION_RSA_KEYPAIR_SET;
  function SetOrganizationRsaKeypairCommand() {
  }
  SetOrganizationRsaKeypairCommand.$metadata$ = {
    simpleName: 'SetOrganizationRsaKeypairCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function SetOrganizationRsaKeypairCommandDTO() {
  }
  SetOrganizationRsaKeypairCommandDTO.$metadata$ = {
    simpleName: 'SetOrganizationRsaKeypairCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function SetOrganizationRsaKeypairCommandBase(payload) {
    this.payload_1 = payload;
  }
  SetOrganizationRsaKeypairCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  SetOrganizationRsaKeypairCommandBase.$metadata$ = {
    simpleName: 'SetOrganizationRsaKeypairCommandBase',
    kind: 'class',
    interfaces: [SetOrganizationRsaKeypairCommand]
  };
  Object.defineProperty(SetOrganizationRsaKeypairCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(SetOrganizationRsaKeypairCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function SetOrganizationRsaKeypairCommandDTOBase(pub, prv) {
    this.pub_1 = pub;
    this.prv_1 = prv;
  }
  SetOrganizationRsaKeypairCommandDTOBase.prototype._get_pub__857303348_e6ezhw_k$ = function () {
    return this.pub_1;
  };
  SetOrganizationRsaKeypairCommandDTOBase.prototype._get_prv__857301085_e6exr1_k$ = function () {
    return this.prv_1;
  };
  SetOrganizationRsaKeypairCommandDTOBase.$metadata$ = {
    simpleName: 'SetOrganizationRsaKeypairCommandDTOBase',
    kind: 'class',
    interfaces: [SetOrganizationRsaKeypairCommandDTO]
  };
  Object.defineProperty(SetOrganizationRsaKeypairCommandDTOBase.prototype, 'pub', {
    configurable: true,
    get: function () {
      return this._get_pub__857303348_e6ezhw_k$();
    }
  });
  Object.defineProperty(SetOrganizationRsaKeypairCommandDTOBase.prototype, 'prv', {
    configurable: true,
    get: function () {
      return this._get_prv__857301085_e6exr1_k$();
    }
  });
  function OrganizationRsaKeypairSetEvent() {
  }
  OrganizationRsaKeypairSetEvent.$metadata$ = {
    simpleName: 'OrganizationRsaKeypairSetEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function OrganizationRsaKeypairSetEventDTO() {
  }
  OrganizationRsaKeypairSetEventDTO.$metadata$ = {
    simpleName: 'OrganizationRsaKeypairSetEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationRsaKeypairSetEventBase(payload) {
    this.payload_1 = payload;
  }
  OrganizationRsaKeypairSetEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  OrganizationRsaKeypairSetEventBase.$metadata$ = {
    simpleName: 'OrganizationRsaKeypairSetEventBase',
    kind: 'class',
    interfaces: [OrganizationRsaKeypairSetEvent]
  };
  Object.defineProperty(OrganizationRsaKeypairSetEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(OrganizationRsaKeypairSetEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function OrganizationRsaKeypairSetEventDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  OrganizationRsaKeypairSetEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  OrganizationRsaKeypairSetEventDTOBase.$metadata$ = {
    simpleName: 'OrganizationRsaKeypairSetEventDTOBase',
    kind: 'class',
    interfaces: [OrganizationRsaKeypairSetEventDTO]
  };
  Object.defineProperty(OrganizationRsaKeypairSetEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_UPDATE_HUB_ACTIVITY_END_DATE__2746941321() {
    return UPDATE_HUB_ACTIVITY_END_DATE;
  }
  var UPDATE_HUB_ACTIVITY_END_DATE;
  function UpdateHubActivityEndDateCommand() {
  }
  UpdateHubActivityEndDateCommand.$metadata$ = {
    simpleName: 'UpdateHubActivityEndDateCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateHubActivityEndDateCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateHubActivityEndDateCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateHubActivityEndDateCommandBase.$metadata$ = {
    simpleName: 'UpdateHubActivityEndDateCommandBase',
    kind: 'class',
    interfaces: [UpdateHubActivityEndDateCommand]
  };
  Object.defineProperty(UpdateHubActivityEndDateCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateHubActivityEndDateCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateHubActivityEndDateCommandDTO() {
  }
  UpdateHubActivityEndDateCommandDTO.$metadata$ = {
    simpleName: 'UpdateHubActivityEndDateCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateHubActivityEndDateCommandDTOBase(organizationId, hubId, activityEndDate) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
    this.activityEndDate_1 = activityEndDate;
  }
  UpdateHubActivityEndDateCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UpdateHubActivityEndDateCommandDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  UpdateHubActivityEndDateCommandDTOBase.prototype._get_activityEndDate__3137375799_j577bd_k$ = function () {
    return this.activityEndDate_1;
  };
  UpdateHubActivityEndDateCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateHubActivityEndDateCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateHubActivityEndDateCommandDTO]
  };
  Object.defineProperty(UpdateHubActivityEndDateCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(UpdateHubActivityEndDateCommandDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  Object.defineProperty(UpdateHubActivityEndDateCommandDTOBase.prototype, 'activityEndDate', {
    configurable: true,
    get: function () {
      return this._get_activityEndDate__3137375799_j577bd_k$();
    }
  });
  function _get_HUB_ACTIVITY_END_DATE_UPDATED_EVENT__794257826() {
    return HUB_ACTIVITY_END_DATE_UPDATED_EVENT;
  }
  var HUB_ACTIVITY_END_DATE_UPDATED_EVENT;
  function HubActivityEndDateUpdatedEvent() {
  }
  HubActivityEndDateUpdatedEvent.$metadata$ = {
    simpleName: 'HubActivityEndDateUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function HubActivityEndDateUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  HubActivityEndDateUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  HubActivityEndDateUpdatedEventBase.$metadata$ = {
    simpleName: 'HubActivityEndDateUpdatedEventBase',
    kind: 'class',
    interfaces: [HubActivityEndDateUpdatedEvent]
  };
  Object.defineProperty(HubActivityEndDateUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(HubActivityEndDateUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function HubActivityEndDateUpdatedEventDTO() {
  }
  HubActivityEndDateUpdatedEventDTO.$metadata$ = {
    simpleName: 'HubActivityEndDateUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function HubActivityEndDateUpdatedEventDTOBase(organizationId, hubId, activityEndDate) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
    this.activityEndDate_1 = activityEndDate;
  }
  HubActivityEndDateUpdatedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  HubActivityEndDateUpdatedEventDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  HubActivityEndDateUpdatedEventDTOBase.prototype._get_activityEndDate__3137375799_j577bd_k$ = function () {
    return this.activityEndDate_1;
  };
  HubActivityEndDateUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'HubActivityEndDateUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [HubActivityEndDateUpdatedEventDTO]
  };
  Object.defineProperty(HubActivityEndDateUpdatedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(HubActivityEndDateUpdatedEventDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  Object.defineProperty(HubActivityEndDateUpdatedEventDTOBase.prototype, 'activityEndDate', {
    configurable: true,
    get: function () {
      return this._get_activityEndDate__3137375799_j577bd_k$();
    }
  });
  function _get_UPDATE_HUB_COMMENT__1485161740() {
    return UPDATE_HUB_COMMENT;
  }
  var UPDATE_HUB_COMMENT;
  function UpdateHubCommentCommand() {
  }
  UpdateHubCommentCommand.$metadata$ = {
    simpleName: 'UpdateHubCommentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateHubCommentCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateHubCommentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateHubCommentCommandBase.$metadata$ = {
    simpleName: 'UpdateHubCommentCommandBase',
    kind: 'class',
    interfaces: [UpdateHubCommentCommand]
  };
  Object.defineProperty(UpdateHubCommentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateHubCommentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateHubCommentCommandDTO() {
  }
  UpdateHubCommentCommandDTO.$metadata$ = {
    simpleName: 'UpdateHubCommentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateHubCommentCommandDTOBase(organizationId, hubId, comment) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
    this.comment_1 = comment;
  }
  UpdateHubCommentCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UpdateHubCommentCommandDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  UpdateHubCommentCommandDTOBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  UpdateHubCommentCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateHubCommentCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateHubCommentCommandDTO]
  };
  Object.defineProperty(UpdateHubCommentCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(UpdateHubCommentCommandDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  Object.defineProperty(UpdateHubCommentCommandDTOBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  function _get_HUB_COMMENT_UPDATED_EVENT__1396077029() {
    return HUB_COMMENT_UPDATED_EVENT;
  }
  var HUB_COMMENT_UPDATED_EVENT;
  function HubCommentUpdatedEvent() {
  }
  HubCommentUpdatedEvent.$metadata$ = {
    simpleName: 'HubCommentUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function HubCommentUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  HubCommentUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  HubCommentUpdatedEventBase.$metadata$ = {
    simpleName: 'HubCommentUpdatedEventBase',
    kind: 'class',
    interfaces: [HubCommentUpdatedEvent]
  };
  Object.defineProperty(HubCommentUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(HubCommentUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function HubCommentUpdatedEventDTO() {
  }
  HubCommentUpdatedEventDTO.$metadata$ = {
    simpleName: 'HubCommentUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function HubCommentUpdatedEventDTOBase(organizationId, hubId, comment) {
    this.organizationId_1 = organizationId;
    this.hubId_1 = hubId;
    this.comment_1 = comment;
  }
  HubCommentUpdatedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  HubCommentUpdatedEventDTOBase.prototype._get_hubId__3300744417_gfxna7_k$ = function () {
    return this.hubId_1;
  };
  HubCommentUpdatedEventDTOBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  HubCommentUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'HubCommentUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [HubCommentUpdatedEventDTO]
  };
  Object.defineProperty(HubCommentUpdatedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(HubCommentUpdatedEventDTOBase.prototype, 'hubId', {
    configurable: true,
    get: function () {
      return this._get_hubId__3300744417_gfxna7_k$();
    }
  });
  Object.defineProperty(HubCommentUpdatedEventDTOBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  function UploadPaymentInfoCommand() {
  }
  UploadPaymentInfoCommand.$metadata$ = {
    simpleName: 'UploadPaymentInfoCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UploadPaymentInfoCommandBase(payload, organizationId) {
    this.payload_1 = payload;
    this.organizationId_1 = organizationId;
  }
  UploadPaymentInfoCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UploadPaymentInfoCommandBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UploadPaymentInfoCommandBase.$metadata$ = {
    simpleName: 'UploadPaymentInfoCommandBase',
    kind: 'class',
    interfaces: [UploadPaymentInfoCommand]
  };
  Object.defineProperty(UploadPaymentInfoCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UploadPaymentInfoCommandBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(UploadPaymentInfoCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UploadedPaymentInfoEvent() {
  }
  UploadedPaymentInfoEvent.$metadata$ = {
    simpleName: 'UploadedPaymentInfoEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UploadedPaymentInfoEventDetails() {
  }
  UploadedPaymentInfoEventDetails.$metadata$ = {
    simpleName: 'UploadedPaymentInfoEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function UploadedPaymentInfoEventBase(payload) {
    this.payload_1 = payload;
  }
  UploadedPaymentInfoEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UploadedPaymentInfoEventBase.$metadata$ = {
    simpleName: 'UploadedPaymentInfoEventBase',
    kind: 'class',
    interfaces: [UploadedPaymentInfoEvent]
  };
  Object.defineProperty(UploadedPaymentInfoEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UploadedPaymentInfoEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UploadedPaymentInfoEventDetailsBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  UploadedPaymentInfoEventDetailsBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UploadedPaymentInfoEventDetailsBase.$metadata$ = {
    simpleName: 'UploadedPaymentInfoEventDetailsBase',
    kind: 'class',
    interfaces: [UploadedPaymentInfoEventDetails]
  };
  Object.defineProperty(UploadedPaymentInfoEventDetailsBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function VisitorAuthorizationUpdateCommand() {
  }
  VisitorAuthorizationUpdateCommand.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdateCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function VisitorAuthorizationUpdateCommandBase(organizationId, payload) {
    this.organizationId_1 = organizationId;
    this.payload_1 = payload;
  }
  VisitorAuthorizationUpdateCommandBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  VisitorAuthorizationUpdateCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  VisitorAuthorizationUpdateCommandBase.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdateCommandBase',
    kind: 'class',
    interfaces: [VisitorAuthorizationUpdateCommand]
  };
  Object.defineProperty(VisitorAuthorizationUpdateCommandBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(VisitorAuthorizationUpdateCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(VisitorAuthorizationUpdateCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function VisitorAuthorizationUpdateCommandDTO() {
  }
  VisitorAuthorizationUpdateCommandDTO.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdateCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function VisitorAuthorizationUpdateCommandDTOBase(territoryCodes, visitorAuthorization) {
    this.territoryCodes_1 = territoryCodes;
    this.visitorAuthorization_1 = visitorAuthorization;
  }
  VisitorAuthorizationUpdateCommandDTOBase.prototype._get_territoryCodes__176172895_2wvzvj_k$ = function () {
    return this.territoryCodes_1;
  };
  VisitorAuthorizationUpdateCommandDTOBase.prototype._get_visitorAuthorization__1161751296_j7od1c_k$ = function () {
    return this.visitorAuthorization_1;
  };
  VisitorAuthorizationUpdateCommandDTOBase.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdateCommandDTOBase',
    kind: 'class',
    interfaces: [VisitorAuthorizationUpdateCommandDTO]
  };
  Object.defineProperty(VisitorAuthorizationUpdateCommandDTOBase.prototype, 'territoryCodes', {
    configurable: true,
    get: function () {
      return this._get_territoryCodes__176172895_2wvzvj_k$();
    }
  });
  Object.defineProperty(VisitorAuthorizationUpdateCommandDTOBase.prototype, 'visitorAuthorization', {
    configurable: true,
    get: function () {
      return this._get_visitorAuthorization__1161751296_j7od1c_k$();
    }
  });
  function VisitorAuthorizationUpdatedEvent() {
  }
  VisitorAuthorizationUpdatedEvent.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function VisitorAuthorizationUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  VisitorAuthorizationUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  VisitorAuthorizationUpdatedEventBase.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdatedEventBase',
    kind: 'class',
    interfaces: [VisitorAuthorizationUpdatedEvent]
  };
  Object.defineProperty(VisitorAuthorizationUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(VisitorAuthorizationUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function VisitorAuthorizationUpdatedEventDTO() {
  }
  VisitorAuthorizationUpdatedEventDTO.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function VisitorAuthorizationUpdatedEventDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  VisitorAuthorizationUpdatedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  VisitorAuthorizationUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'VisitorAuthorizationUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [VisitorAuthorizationUpdatedEventDTO]
  };
  Object.defineProperty(VisitorAuthorizationUpdatedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_CONVENTION_PREFILLED__623529172() {
    return CONVENTION_PREFILLED;
  }
  var CONVENTION_PREFILLED;
  function ConventionPrefilledEvent() {
  }
  ConventionPrefilledEvent.$metadata$ = {
    simpleName: 'ConventionPrefilledEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ConventionPrefilledEventDTO() {
  }
  ConventionPrefilledEventDTO.$metadata$ = {
    simpleName: 'ConventionPrefilledEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ConventionPrefilledEventBase(payload) {
    this.payload_1 = payload;
  }
  ConventionPrefilledEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ConventionPrefilledEventBase.$metadata$ = {
    simpleName: 'ConventionPrefilledEventBase',
    kind: 'class',
    interfaces: [ConventionPrefilledEvent]
  };
  Object.defineProperty(ConventionPrefilledEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ConventionPrefilledEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ConventionPrefilledEventDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  ConventionPrefilledEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ConventionPrefilledEventDTOBase.$metadata$ = {
    simpleName: 'ConventionPrefilledEventDTOBase',
    kind: 'class',
    interfaces: [ConventionPrefilledEventDTO]
  };
  Object.defineProperty(ConventionPrefilledEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_CONVENTION_RESETED_EVENT__3447678064() {
    return CONVENTION_RESETED_EVENT;
  }
  var CONVENTION_RESETED_EVENT;
  function ConventionResetedEvent() {
  }
  ConventionResetedEvent.$metadata$ = {
    simpleName: 'ConventionResetedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ConventionResetedEventDTO() {
  }
  ConventionResetedEventDTO.$metadata$ = {
    simpleName: 'ConventionResetedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ConventionResetedEventBase(payload) {
    this.payload_1 = payload;
  }
  ConventionResetedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ConventionResetedEventBase.$metadata$ = {
    simpleName: 'ConventionResetedEventBase',
    kind: 'class',
    interfaces: [ConventionResetedEvent]
  };
  Object.defineProperty(ConventionResetedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ConventionResetedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ConventionResetedEventDTOBase(organizationId, convention) {
    this.organizationId_1 = organizationId;
    this.convention_1 = convention;
  }
  ConventionResetedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ConventionResetedEventDTOBase.prototype._get_convention__1210803002_k0vpkq_k$ = function () {
    return this.convention_1;
  };
  ConventionResetedEventDTOBase.$metadata$ = {
    simpleName: 'ConventionResetedEventDTOBase',
    kind: 'class',
    interfaces: [ConventionResetedEventDTO]
  };
  Object.defineProperty(ConventionResetedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ConventionResetedEventDTOBase.prototype, 'convention', {
    configurable: true,
    get: function () {
      return this._get_convention__1210803002_k0vpkq_k$();
    }
  });
  function _get_CREATE_CONVENTION__4154339133() {
    return CREATE_CONVENTION;
  }
  var CREATE_CONVENTION;
  function CreateConventionCommand() {
  }
  CreateConventionCommand.$metadata$ = {
    simpleName: 'CreateConventionCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateConventionCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateConventionCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateConventionCommandBase.$metadata$ = {
    simpleName: 'CreateConventionCommandBase',
    kind: 'class',
    interfaces: [CreateConventionCommand]
  };
  Object.defineProperty(CreateConventionCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateConventionCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateConventionCommandDTO() {
  }
  CreateConventionCommandDTO.$metadata$ = {
    simpleName: 'CreateConventionCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateConventionCommandDTOBase(organizationId, convention) {
    this.organizationId_1 = organizationId;
    this.convention_1 = convention;
  }
  CreateConventionCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  CreateConventionCommandDTOBase.prototype._get_convention__1210803002_k0vpkq_k$ = function () {
    return this.convention_1;
  };
  CreateConventionCommandDTOBase.$metadata$ = {
    simpleName: 'CreateConventionCommandDTOBase',
    kind: 'class',
    interfaces: [CreateConventionCommandDTO]
  };
  Object.defineProperty(CreateConventionCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(CreateConventionCommandDTOBase.prototype, 'convention', {
    configurable: true,
    get: function () {
      return this._get_convention__1210803002_k0vpkq_k$();
    }
  });
  function ConventionCreatedEvent() {
  }
  ConventionCreatedEvent.$metadata$ = {
    simpleName: 'ConventionCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ConventionCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  ConventionCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ConventionCreatedEventBase.$metadata$ = {
    simpleName: 'ConventionCreatedEventBase',
    kind: 'class',
    interfaces: [ConventionCreatedEvent]
  };
  Object.defineProperty(ConventionCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ConventionCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ConventionEventDetails() {
  }
  ConventionEventDetails.$metadata$ = {
    simpleName: 'ConventionEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function ConventionEventDetailsBase(organizationId, convention) {
    this.organizationId_1 = organizationId;
    this.convention_1 = convention;
  }
  ConventionEventDetailsBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ConventionEventDetailsBase.prototype._get_convention__1210803002_k0vpkq_k$ = function () {
    return this.convention_1;
  };
  ConventionEventDetailsBase.$metadata$ = {
    simpleName: 'ConventionEventDetailsBase',
    kind: 'class',
    interfaces: [ConventionEventDetails]
  };
  Object.defineProperty(ConventionEventDetailsBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ConventionEventDetailsBase.prototype, 'convention', {
    configurable: true,
    get: function () {
      return this._get_convention__1210803002_k0vpkq_k$();
    }
  });
  function _get_FINALIZED_CONVENTION__2357012513() {
    return FINALIZED_CONVENTION;
  }
  var FINALIZED_CONVENTION;
  function FinalizedConventionCommand() {
  }
  FinalizedConventionCommand.$metadata$ = {
    simpleName: 'FinalizedConventionCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function FinalizedConventionCommandBase(payload) {
    this.payload_1 = payload;
  }
  FinalizedConventionCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  FinalizedConventionCommandBase.$metadata$ = {
    simpleName: 'FinalizedConventionCommandBase',
    kind: 'class',
    interfaces: [FinalizedConventionCommand]
  };
  Object.defineProperty(FinalizedConventionCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(FinalizedConventionCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function FinalizedConventionCommandDTO() {
  }
  FinalizedConventionCommandDTO.$metadata$ = {
    simpleName: 'FinalizedConventionCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function FinalizedConventionCommandDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  FinalizedConventionCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  FinalizedConventionCommandDTOBase.$metadata$ = {
    simpleName: 'FinalizedConventionCommandDTOBase',
    kind: 'class',
    interfaces: [FinalizedConventionCommandDTO]
  };
  Object.defineProperty(FinalizedConventionCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function ConventionFinalizedEvent() {
  }
  ConventionFinalizedEvent.$metadata$ = {
    simpleName: 'ConventionFinalizedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ConventionFinalizedEventBase(payload) {
    this.payload_1 = payload;
  }
  ConventionFinalizedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ConventionFinalizedEventBase.$metadata$ = {
    simpleName: 'ConventionFinalizedEventBase',
    kind: 'class',
    interfaces: [ConventionFinalizedEvent]
  };
  Object.defineProperty(ConventionFinalizedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ConventionFinalizedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ConventionFinalizedEventDTO() {
  }
  ConventionFinalizedEventDTO.$metadata$ = {
    simpleName: 'ConventionFinalizedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ConventionFinalizedEventDTOBase(organizationId, envelopeId) {
    this.organizationId_1 = organizationId;
    this.envelopeId_1 = envelopeId;
  }
  ConventionFinalizedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ConventionFinalizedEventDTOBase.prototype._get_envelopeId__2912980192_muss2o_k$ = function () {
    return this.envelopeId_1;
  };
  ConventionFinalizedEventDTOBase.$metadata$ = {
    simpleName: 'ConventionFinalizedEventDTOBase',
    kind: 'class',
    interfaces: [ConventionFinalizedEventDTO]
  };
  Object.defineProperty(ConventionFinalizedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ConventionFinalizedEventDTOBase.prototype, 'envelopeId', {
    configurable: true,
    get: function () {
      return this._get_envelopeId__2912980192_muss2o_k$();
    }
  });
  function _get_PREPARE_SIGN_CONVENTION__3123269782() {
    return PREPARE_SIGN_CONVENTION;
  }
  var PREPARE_SIGN_CONVENTION;
  function PrepareSignConventionCommand() {
  }
  PrepareSignConventionCommand.$metadata$ = {
    simpleName: 'PrepareSignConventionCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function PrepareSignConventionCommandBase(payload) {
    this.payload_1 = payload;
  }
  PrepareSignConventionCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PrepareSignConventionCommandBase.$metadata$ = {
    simpleName: 'PrepareSignConventionCommandBase',
    kind: 'class',
    interfaces: [PrepareSignConventionCommand]
  };
  Object.defineProperty(PrepareSignConventionCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PrepareSignConventionCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PrepareSignConventionCommandDTO() {
  }
  PrepareSignConventionCommandDTO.$metadata$ = {
    simpleName: 'PrepareSignConventionCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function PrepareSignConventionCommandDTOBase(organizationId, redirectUrl) {
    this.organizationId_1 = organizationId;
    this.redirectUrl_1 = redirectUrl;
  }
  PrepareSignConventionCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  PrepareSignConventionCommandDTOBase.prototype._get_redirectUrl__2605105150_ry3lz6_k$ = function () {
    return this.redirectUrl_1;
  };
  PrepareSignConventionCommandDTOBase.$metadata$ = {
    simpleName: 'PrepareSignConventionCommandDTOBase',
    kind: 'class',
    interfaces: [PrepareSignConventionCommandDTO]
  };
  Object.defineProperty(PrepareSignConventionCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(PrepareSignConventionCommandDTOBase.prototype, 'redirectUrl', {
    configurable: true,
    get: function () {
      return this._get_redirectUrl__2605105150_ry3lz6_k$();
    }
  });
  function ConventionSignPreparedEvent() {
  }
  ConventionSignPreparedEvent.$metadata$ = {
    simpleName: 'ConventionSignPreparedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ConventionSignPreparedEventBase(payload) {
    this.payload_1 = payload;
  }
  ConventionSignPreparedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ConventionSignPreparedEventBase.$metadata$ = {
    simpleName: 'ConventionSignPreparedEventBase',
    kind: 'class',
    interfaces: [ConventionSignPreparedEvent]
  };
  Object.defineProperty(ConventionSignPreparedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ConventionSignPreparedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ConventionSignPreparedEventDTO() {
  }
  ConventionSignPreparedEventDTO.$metadata$ = {
    simpleName: 'ConventionSignPreparedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ConventionSignPreparedEventDTOBase(organizationId, envelopeId, docuSignUrl) {
    this.organizationId_1 = organizationId;
    this.envelopeId_1 = envelopeId;
    this.docuSignUrl_1 = docuSignUrl;
  }
  ConventionSignPreparedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ConventionSignPreparedEventDTOBase.prototype._get_envelopeId__2912980192_muss2o_k$ = function () {
    return this.envelopeId_1;
  };
  ConventionSignPreparedEventDTOBase.prototype._get_docuSignUrl__1161676476_j7mrb0_k$ = function () {
    return this.docuSignUrl_1;
  };
  ConventionSignPreparedEventDTOBase.$metadata$ = {
    simpleName: 'ConventionSignPreparedEventDTOBase',
    kind: 'class',
    interfaces: [ConventionSignPreparedEventDTO]
  };
  Object.defineProperty(ConventionSignPreparedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ConventionSignPreparedEventDTOBase.prototype, 'envelopeId', {
    configurable: true,
    get: function () {
      return this._get_envelopeId__2912980192_muss2o_k$();
    }
  });
  Object.defineProperty(ConventionSignPreparedEventDTOBase.prototype, 'docuSignUrl', {
    configurable: true,
    get: function () {
      return this._get_docuSignUrl__1161676476_j7mrb0_k$();
    }
  });
  function _get_SIGNED_CONVENTION__2475281757() {
    return SIGNED_CONVENTION;
  }
  var SIGNED_CONVENTION;
  function SignedConventionCommand() {
  }
  SignedConventionCommand.$metadata$ = {
    simpleName: 'SignedConventionCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function SignedConventionCommandBase(payload) {
    this.payload_1 = payload;
  }
  SignedConventionCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  SignedConventionCommandBase.$metadata$ = {
    simpleName: 'SignedConventionCommandBase',
    kind: 'class',
    interfaces: [SignedConventionCommand]
  };
  Object.defineProperty(SignedConventionCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(SignedConventionCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function SignedConventionCommandDTO() {
  }
  SignedConventionCommandDTO.$metadata$ = {
    simpleName: 'SignedConventionCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function SignedConventionCommandDTOBase(organizationId) {
    this.organizationId_1 = organizationId;
  }
  SignedConventionCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  SignedConventionCommandDTOBase.$metadata$ = {
    simpleName: 'SignedConventionCommandDTOBase',
    kind: 'class',
    interfaces: [SignedConventionCommandDTO]
  };
  Object.defineProperty(SignedConventionCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function ConventionSignedEvent() {
  }
  ConventionSignedEvent.$metadata$ = {
    simpleName: 'ConventionSignedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ConventionSignedEventBase(payload) {
    this.payload_1 = payload;
  }
  ConventionSignedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ConventionSignedEventBase.$metadata$ = {
    simpleName: 'ConventionSignedEventBase',
    kind: 'class',
    interfaces: [ConventionSignedEvent]
  };
  Object.defineProperty(ConventionSignedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ConventionSignedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ConventionSignedEventDTO() {
  }
  ConventionSignedEventDTO.$metadata$ = {
    simpleName: 'ConventionSignedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ConventionSignedEventDTOBase(organizationId, envelopeId, signerEmail) {
    this.organizationId_1 = organizationId;
    this.envelopeId_1 = envelopeId;
    this.signerEmail_1 = signerEmail;
  }
  ConventionSignedEventDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  ConventionSignedEventDTOBase.prototype._get_envelopeId__2912980192_muss2o_k$ = function () {
    return this.envelopeId_1;
  };
  ConventionSignedEventDTOBase.prototype._get_signerEmail__4000363839_4vedhd_k$ = function () {
    return this.signerEmail_1;
  };
  ConventionSignedEventDTOBase.$metadata$ = {
    simpleName: 'ConventionSignedEventDTOBase',
    kind: 'class',
    interfaces: [ConventionSignedEventDTO]
  };
  Object.defineProperty(ConventionSignedEventDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(ConventionSignedEventDTOBase.prototype, 'envelopeId', {
    configurable: true,
    get: function () {
      return this._get_envelopeId__2912980192_muss2o_k$();
    }
  });
  Object.defineProperty(ConventionSignedEventDTOBase.prototype, 'signerEmail', {
    configurable: true,
    get: function () {
      return this._get_signerEmail__4000363839_4vedhd_k$();
    }
  });
  function _get_UPDATE_SECRET__3413884587() {
    return UPDATE_SECRET;
  }
  var UPDATE_SECRET;
  function UpdateApplicationSecretCommand() {
  }
  UpdateApplicationSecretCommand.$metadata$ = {
    simpleName: 'UpdateApplicationSecretCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateApplicationSecretCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateApplicationSecretCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateApplicationSecretCommandBase.$metadata$ = {
    simpleName: 'UpdateApplicationSecretCommandBase',
    kind: 'class',
    interfaces: [UpdateApplicationSecretCommand]
  };
  Object.defineProperty(UpdateApplicationSecretCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateApplicationSecretCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateApplicationSecretCommandDTO() {
  }
  UpdateApplicationSecretCommandDTO.$metadata$ = {
    simpleName: 'UpdateApplicationSecretCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateApplicationSecretCommandDTOBase(keycloackId) {
    this.keycloackId_1 = keycloackId;
  }
  UpdateApplicationSecretCommandDTOBase.prototype._get_keycloackId__2470334388_u6c7rg_k$ = function () {
    return this.keycloackId_1;
  };
  UpdateApplicationSecretCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateApplicationSecretCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateApplicationSecretCommandDTO]
  };
  Object.defineProperty(UpdateApplicationSecretCommandDTOBase.prototype, 'keycloackId', {
    configurable: true,
    get: function () {
      return this._get_keycloackId__2470334388_u6c7rg_k$();
    }
  });
  function ApplicationSecretUpdatedEvent() {
  }
  ApplicationSecretUpdatedEvent.$metadata$ = {
    simpleName: 'ApplicationSecretUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ApplicationSecretUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  ApplicationSecretUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ApplicationSecretUpdatedEventBase.$metadata$ = {
    simpleName: 'ApplicationSecretUpdatedEventBase',
    kind: 'class',
    interfaces: [ApplicationSecretUpdatedEvent]
  };
  Object.defineProperty(ApplicationSecretUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ApplicationSecretUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ApplicationSecretEventDetails() {
  }
  ApplicationSecretEventDetails.$metadata$ = {
    simpleName: 'ApplicationSecretEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function ApplicationSecretEventDetailsBase(clientSecret) {
    this.clientSecret_1 = clientSecret;
  }
  ApplicationSecretEventDetailsBase.prototype._get_clientSecret__2130301520_z8br68_k$ = function () {
    return this.clientSecret_1;
  };
  ApplicationSecretEventDetailsBase.$metadata$ = {
    simpleName: 'ApplicationSecretEventDetailsBase',
    kind: 'class',
    interfaces: [ApplicationSecretEventDetails]
  };
  Object.defineProperty(ApplicationSecretEventDetailsBase.prototype, 'clientSecret', {
    configurable: true,
    get: function () {
      return this._get_clientSecret__2130301520_z8br68_k$();
    }
  });
  function Logo() {
  }
  Logo.$metadata$ = {
    simpleName: 'Logo',
    kind: 'interface',
    interfaces: []
  };
  function LogoBase(id, name, logo, contentType) {
    this.id_1 = id;
    this.name_1 = name;
    this.logo_1 = logo;
    this.contentType_1 = contentType;
  }
  LogoBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  LogoBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  LogoBase.prototype._get_logo__802733568_d9xd6o_k$ = function () {
    return this.logo_1;
  };
  LogoBase.prototype._get_contentType__2476003486_u2ypgi_k$ = function () {
    return this.contentType_1;
  };
  LogoBase.$metadata$ = {
    simpleName: 'LogoBase',
    kind: 'class',
    interfaces: [Logo]
  };
  Object.defineProperty(LogoBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(LogoBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(LogoBase.prototype, 'logo', {
    configurable: true,
    get: function () {
      return this._get_logo__802733568_d9xd6o_k$();
    }
  });
  Object.defineProperty(LogoBase.prototype, 'contentType', {
    configurable: true,
    get: function () {
      return this._get_contentType__2476003486_u2ypgi_k$();
    }
  });
  function LogoAggregate() {
  }
  LogoAggregate.$metadata$ = {
    simpleName: 'LogoAggregate',
    kind: 'interface',
    interfaces: []
  };
  function LogoFinder() {
  }
  LogoFinder.$metadata$ = {
    simpleName: 'LogoFinder',
    kind: 'interface',
    interfaces: []
  };
  function SimplifiedConvention() {
  }
  SimplifiedConvention.$metadata$ = {
    simpleName: 'SimplifiedConvention',
    kind: 'interface',
    interfaces: []
  };
  function SimplifiedConventionBase(id, name, file) {
    this.id_1 = id;
    this.name_1 = name;
    this.file_1 = file;
  }
  SimplifiedConventionBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  SimplifiedConventionBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  SimplifiedConventionBase.prototype._get_file__797018191_d6iv67_k$ = function () {
    return this.file_1;
  };
  SimplifiedConventionBase.prototype.component1 = function () {
    return this.id_1;
  };
  SimplifiedConventionBase.prototype.component2 = function () {
    return this.name_1;
  };
  SimplifiedConventionBase.prototype.component3 = function () {
    return this.file_1;
  };
  SimplifiedConventionBase.prototype.copy = function (id, name, file) {
    return this.copy_2aqvua_k$(id === void 1 ? this.id_1 : id, name === void 1 ? this.name_1 : name, file === void 1 ? this.file_1 : file);
  };
  SimplifiedConventionBase.prototype.copy_2aqvua_k$ = function (id, name, file) {
    return new SimplifiedConventionBase(id, name, file);
  };
  SimplifiedConventionBase.prototype.copy$default_ixgix8_k$ = function (id, name, file, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      name = this.name_1;
    if (!(($mask0 & 4) === 0))
      file = this.file_1;
    return this.copy_2aqvua_k$(id, name, file);
  };
  SimplifiedConventionBase.prototype.toString = function () {
    return 'SimplifiedConventionBase(id=' + this.id_1 + ', name=' + this.name_1 + ', file=' + this.file_1 + ')';
  };
  SimplifiedConventionBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.file_1) | 0;
    return result;
  };
  SimplifiedConventionBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimplifiedConventionBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SimplifiedConventionBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.file_1 === tmp0_other_with_cast.file_1))
      return false;
    return true;
  };
  SimplifiedConventionBase.$metadata$ = {
    simpleName: 'SimplifiedConventionBase',
    kind: 'class',
    interfaces: [SimplifiedConvention]
  };
  Object.defineProperty(SimplifiedConventionBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(SimplifiedConventionBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(SimplifiedConventionBase.prototype, 'file', {
    configurable: true,
    get: function () {
      return this._get_file__797018191_d6iv67_k$();
    }
  });
  function SimplifiedConventionFinder() {
  }
  SimplifiedConventionFinder.$metadata$ = {
    simpleName: 'SimplifiedConventionFinder',
    kind: 'interface',
    interfaces: []
  };
  function _get_UserCreatedStatus__2559825506() {
    init_properties_User_kt_1314336111();
    return UserCreatedStatus;
  }
  var UserCreatedStatus;
  function _get_UserEnabledStatus__1981146089() {
    init_properties_User_kt_1314336111();
    return UserEnabledStatus;
  }
  var UserEnabledStatus;
  function _get_UserDisabledStatus__3958956114() {
    init_properties_User_kt_1314336111();
    return UserDisabledStatus;
  }
  var UserDisabledStatus;
  function User() {
  }
  User.$metadata$ = {
    simpleName: 'User',
    kind: 'interface',
    interfaces: []
  };
  function UserBase(userId, details, hasLogo, status) {
    this.userId_1 = userId;
    this.details_1 = details;
    this.hasLogo_1 = hasLogo;
    this.status_1 = status;
  }
  UserBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  UserBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  UserBase.prototype._get_hasLogo__2249152588_xu0wqc_k$ = function () {
    return this.hasLogo_1;
  };
  UserBase.prototype._set_status__299634277_xefru8_k$ = function (_set____804775014) {
    this.status_1 = _set____804775014;
  };
  UserBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  UserBase.$metadata$ = {
    simpleName: 'UserBase',
    kind: 'class',
    interfaces: [User]
  };
  Object.defineProperty(UserBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  Object.defineProperty(UserBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(UserBase.prototype, 'hasLogo', {
    configurable: true,
    get: function () {
      return this._get_hasLogo__2249152588_xu0wqc_k$();
    }
  });
  Object.defineProperty(UserBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    },
    set: function (value) {
      this._set_status__299634277_xefru8_k$(value);
    }
  });
  function UserDetails() {
  }
  UserDetails.$metadata$ = {
    simpleName: 'UserDetails',
    kind: 'interface',
    interfaces: []
  };
  function UserDetailsBase(organizationId, firstname, lastname, email, phoneNumber, role, fonction, territories) {
    this.organizationId_1 = organizationId;
    this.firstname_1 = firstname;
    this.lastname_1 = lastname;
    this.email_1 = email;
    this.phoneNumber_1 = phoneNumber;
    this.role_1 = role;
    this.fonction_1 = fonction;
    this.territories_1 = territories;
  }
  UserDetailsBase.prototype._set_organizationId__3182638889_72o5om_k$ = function (_set____804775014) {
    this.organizationId_1 = _set____804775014;
  };
  UserDetailsBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  UserDetailsBase.prototype._get_firstname__2839684214_o2frm2_k$ = function () {
    return this.firstname_1;
  };
  UserDetailsBase.prototype._get_lastname__3508433354_d0a5h2_k$ = function () {
    return this.lastname_1;
  };
  UserDetailsBase.prototype._get_email__3207470005_hzgua3_k$ = function () {
    return this.email_1;
  };
  UserDetailsBase.prototype._get_phoneNumber__3326822938_g0eoyu_k$ = function () {
    return this.phoneNumber_1;
  };
  UserDetailsBase.prototype._set_role__593662113_z2zs5r_k$ = function (_set____804775014) {
    this.role_1 = _set____804775014;
  };
  UserDetailsBase.prototype._get_role__808279189_dd887p_k$ = function () {
    return this.role_1;
  };
  UserDetailsBase.prototype._get_fonction__3769301433_8oyudj_k$ = function () {
    return this.fonction_1;
  };
  UserDetailsBase.prototype._get_territories__3289376345_gmpaxz_k$ = function () {
    return this.territories_1;
  };
  UserDetailsBase.prototype.component1 = function () {
    return this.organizationId_1;
  };
  UserDetailsBase.prototype.component2 = function () {
    return this.firstname_1;
  };
  UserDetailsBase.prototype.component3 = function () {
    return this.lastname_1;
  };
  UserDetailsBase.prototype.component4 = function () {
    return this.email_1;
  };
  UserDetailsBase.prototype.component5 = function () {
    return this.phoneNumber_1;
  };
  UserDetailsBase.prototype.component6 = function () {
    return this.role_1;
  };
  UserDetailsBase.prototype.component7 = function () {
    return this.fonction_1;
  };
  UserDetailsBase.prototype.component8 = function () {
    return this.territories_1;
  };
  UserDetailsBase.prototype.copy = function (organizationId, firstname, lastname, email, phoneNumber, role, fonction, territories) {
    return this.copy_r8wrje_k$(organizationId === void 1 ? this.organizationId_1 : organizationId, firstname === void 1 ? this.firstname_1 : firstname, lastname === void 1 ? this.lastname_1 : lastname, email === void 1 ? this.email_1 : email, phoneNumber === void 1 ? this.phoneNumber_1 : phoneNumber, role === void 1 ? this.role_1 : role, fonction === void 1 ? this.fonction_1 : fonction, territories === void 1 ? this.territories_1 : territories);
  };
  UserDetailsBase.prototype.copy_r8wrje_k$ = function (organizationId, firstname, lastname, email, phoneNumber, role, fonction, territories) {
    return new UserDetailsBase(organizationId, firstname, lastname, email, phoneNumber, role, fonction, territories);
  };
  UserDetailsBase.prototype.copy$default_xks1w9_k$ = function (organizationId, firstname, lastname, email, phoneNumber, role, fonction, territories, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      organizationId = this.organizationId_1;
    if (!(($mask0 & 2) === 0))
      firstname = this.firstname_1;
    if (!(($mask0 & 4) === 0))
      lastname = this.lastname_1;
    if (!(($mask0 & 8) === 0))
      email = this.email_1;
    if (!(($mask0 & 16) === 0))
      phoneNumber = this.phoneNumber_1;
    if (!(($mask0 & 32) === 0))
      role = this.role_1;
    if (!(($mask0 & 64) === 0))
      fonction = this.fonction_1;
    if (!(($mask0 & 128) === 0))
      territories = this.territories_1;
    return this.copy_r8wrje_k$(organizationId, firstname, lastname, email, phoneNumber, role, fonction, territories);
  };
  UserDetailsBase.prototype.toString = function () {
    return 'UserDetailsBase(organizationId=' + this.organizationId_1 + ', firstname=' + this.firstname_1 + ', lastname=' + this.lastname_1 + ', email=' + this.email_1 + ', phoneNumber=' + this.phoneNumber_1 + ', role=' + this.role_1 + ', fonction=' + this.fonction_1 + ', territories=' + this.territories_1 + ')';
  };
  UserDetailsBase.prototype.hashCode = function () {
    var result = this.organizationId_1 == null ? 0 : getStringHashCode(this.organizationId_1);
    result = imul(result, 31) + getStringHashCode(this.firstname_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lastname_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.email_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.phoneNumber_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.role_1) | 0;
    result = imul(result, 31) + (this.fonction_1 == null ? 0 : getStringHashCode(this.fonction_1)) | 0;
    result = imul(result, 31) + hashCode(this.territories_1) | 0;
    return result;
  };
  UserDetailsBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserDetailsBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UserDetailsBase ? other : THROW_CCE();
    if (!(this.organizationId_1 == tmp0_other_with_cast.organizationId_1))
      return false;
    if (!(this.firstname_1 === tmp0_other_with_cast.firstname_1))
      return false;
    if (!(this.lastname_1 === tmp0_other_with_cast.lastname_1))
      return false;
    if (!(this.email_1 === tmp0_other_with_cast.email_1))
      return false;
    if (!(this.phoneNumber_1 === tmp0_other_with_cast.phoneNumber_1))
      return false;
    if (!(this.role_1 === tmp0_other_with_cast.role_1))
      return false;
    if (!(this.fonction_1 == tmp0_other_with_cast.fonction_1))
      return false;
    if (!equals(this.territories_1, tmp0_other_with_cast.territories_1))
      return false;
    return true;
  };
  UserDetailsBase.$metadata$ = {
    simpleName: 'UserDetailsBase',
    kind: 'class',
    interfaces: [UserDetails]
  };
  Object.defineProperty(UserDetailsBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    },
    set: function (value) {
      this._set_organizationId__3182638889_72o5om_k$(value);
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'firstname', {
    configurable: true,
    get: function () {
      return this._get_firstname__2839684214_o2frm2_k$();
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'lastname', {
    configurable: true,
    get: function () {
      return this._get_lastname__3508433354_d0a5h2_k$();
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'email', {
    configurable: true,
    get: function () {
      return this._get_email__3207470005_hzgua3_k$();
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'phoneNumber', {
    configurable: true,
    get: function () {
      return this._get_phoneNumber__3326822938_g0eoyu_k$();
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'role', {
    configurable: true,
    get: function () {
      return this._get_role__808279189_dd887p_k$();
    },
    set: function (value) {
      this._set_role__593662113_z2zs5r_k$(value);
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'fonction', {
    configurable: true,
    get: function () {
      return this._get_fonction__3769301433_8oyudj_k$();
    }
  });
  Object.defineProperty(UserDetailsBase.prototype, 'territories', {
    configurable: true,
    get: function () {
      return this._get_territories__3289376345_gmpaxz_k$();
    }
  });
  function UserStatus() {
  }
  UserStatus.$metadata$ = {
    simpleName: 'UserStatus',
    kind: 'interface',
    interfaces: []
  };
  function UserStatusBase(value) {
    this.value_1 = value;
  }
  UserStatusBase.prototype._set_value__1325260276_wbpkyq_k$ = function (_set____804775014) {
    this.value_1 = _set____804775014;
  };
  UserStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  UserStatusBase.prototype.component1 = function () {
    return this.value_1;
  };
  UserStatusBase.prototype.copy = function (value) {
    return this.copy_3t26ic_k$(value === void 1 ? this.value_1 : value);
  };
  UserStatusBase.prototype.copy_3t26ic_k$ = function (value) {
    return new UserStatusBase(value);
  };
  UserStatusBase.prototype.copy$default_q3pzg4_k$ = function (value, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      value = this.value_1;
    return this.copy_3t26ic_k$(value);
  };
  UserStatusBase.prototype.toString = function () {
    return 'UserStatusBase(value=' + this.value_1 + ')';
  };
  UserStatusBase.prototype.hashCode = function () {
    return getStringHashCode(this.value_1);
  };
  UserStatusBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserStatusBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UserStatusBase ? other : THROW_CCE();
    if (!(this.value_1 === tmp0_other_with_cast.value_1))
      return false;
    return true;
  };
  UserStatusBase.$metadata$ = {
    simpleName: 'UserStatusBase',
    kind: 'class',
    interfaces: [UserStatus]
  };
  Object.defineProperty(UserStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    },
    set: function (value) {
      this._set_value__1325260276_wbpkyq_k$(value);
    }
  });
  var properties_initialized_User_kt_33865363;
  function init_properties_User_kt_1314336111() {
    if (!properties_initialized_User_kt_33865363) {
      properties_initialized_User_kt_33865363 = true;
      UserCreatedStatus = new UserStatusBase('created');
      UserEnabledStatus = new UserStatusBase('enabled');
      UserDisabledStatus = new UserStatusBase('disabled');
    }
  }
  function UserAggregate() {
  }
  UserAggregate.$metadata$ = {
    simpleName: 'UserAggregate',
    kind: 'interface',
    interfaces: []
  };
  function UserFinder() {
  }
  UserFinder.$metadata$ = {
    simpleName: 'UserFinder',
    kind: 'interface',
    interfaces: []
  };
  function UserRole() {
  }
  UserRole.$metadata$ = {
    simpleName: 'UserRole',
    kind: 'interface',
    interfaces: []
  };
  function UserRoleBase(role) {
    this.role_1 = role;
  }
  UserRoleBase.prototype._get_role__808279189_dd887p_k$ = function () {
    return this.role_1;
  };
  UserRoleBase.$metadata$ = {
    simpleName: 'UserRoleBase',
    kind: 'class',
    interfaces: [UserRole]
  };
  Object.defineProperty(UserRoleBase.prototype, 'role', {
    configurable: true,
    get: function () {
      return this._get_role__808279189_dd887p_k$();
    }
  });
  function AdminRole() {
    UserRoleBase.call(this, _get_ROLE_ADMIN__3149651749());
  }
  AdminRole.$metadata$ = {
    simpleName: 'AdminRole',
    kind: 'class',
    interfaces: []
  };
  function SuperAdminRole() {
    UserRoleBase.call(this, _get_ROLE_SUPER_ADMIN__3554080777());
  }
  SuperAdminRole.$metadata$ = {
    simpleName: 'SuperAdminRole',
    kind: 'class',
    interfaces: []
  };
  function OperatorAdminRole() {
    UserRoleBase.call(this, _get_ROLE_OPERATOR_ADMIN__1787221876());
  }
  OperatorAdminRole.$metadata$ = {
    simpleName: 'OperatorAdminRole',
    kind: 'class',
    interfaces: []
  };
  function OperatorUserRole() {
    UserRoleBase.call(this, _get_ROLE_OPERATOR_USER__1600582830());
  }
  OperatorUserRole.$metadata$ = {
    simpleName: 'OperatorUserRole',
    kind: 'class',
    interfaces: []
  };
  function OperatorAdminOnboardingRole() {
    UserRoleBase.call(this, _get_ROLE_OPERATOR_ADMIN_ONBOARDING__962210510());
  }
  OperatorAdminOnboardingRole.$metadata$ = {
    simpleName: 'OperatorAdminOnboardingRole',
    kind: 'class',
    interfaces: []
  };
  function OperatorUserOnboardingRole() {
    UserRoleBase.call(this, _get_ROLE_OPERATOR_USER_ONBOARDING__1450534228());
  }
  OperatorUserOnboardingRole.$metadata$ = {
    simpleName: 'OperatorUserOnboardingRole',
    kind: 'class',
    interfaces: []
  };
  function FunderAdminRole() {
    UserRoleBase.call(this, _get_ROLE_FUNDER_ADMIN__3418638502());
  }
  FunderAdminRole.$metadata$ = {
    simpleName: 'FunderAdminRole',
    kind: 'class',
    interfaces: []
  };
  function FunderUserRole() {
    UserRoleBase.call(this, _get_ROLE_FUNDER_USER__821925180());
  }
  FunderUserRole.$metadata$ = {
    simpleName: 'FunderUserRole',
    kind: 'class',
    interfaces: []
  };
  function CarrierAdminRole() {
    UserRoleBase.call(this, _get_ROLE_CARRIER_ADMIN__3637737580());
  }
  CarrierAdminRole.$metadata$ = {
    simpleName: 'CarrierAdminRole',
    kind: 'class',
    interfaces: []
  };
  function CarrierUserRole() {
    UserRoleBase.call(this, _get_ROLE_CARRIER_USER__2768655542());
  }
  CarrierUserRole.$metadata$ = {
    simpleName: 'CarrierUserRole',
    kind: 'class',
    interfaces: []
  };
  function TmsAdminRole() {
    UserRoleBase.call(this, _get_ROLE_TMS_ADMIN__3958562570());
  }
  TmsAdminRole.$metadata$ = {
    simpleName: 'TmsAdminRole',
    kind: 'class',
    interfaces: []
  };
  function TmsUserRole() {
    UserRoleBase.call(this, _get_ROLE_TMS_USER__3610288728());
  }
  TmsUserRole.$metadata$ = {
    simpleName: 'TmsUserRole',
    kind: 'class',
    interfaces: []
  };
  function VisitorAdminRole() {
    UserRoleBase.call(this, _get_ROLE_VISITOR_ADMIN__635253302());
  }
  VisitorAdminRole.$metadata$ = {
    simpleName: 'VisitorAdminRole',
    kind: 'class',
    interfaces: []
  };
  function VisitorUserRole() {
    UserRoleBase.call(this, _get_ROLE_VISITOR_USER__39401900());
  }
  VisitorUserRole.$metadata$ = {
    simpleName: 'VisitorUserRole',
    kind: 'class',
    interfaces: []
  };
  function UserRoleValues() {
    this.ADMIN_1 = new AdminRole();
    this.SUPER_ADMIN_1 = new SuperAdminRole();
    this.OPERATOR_ADMIN_1 = new OperatorAdminRole();
    this.OPERATOR_USER_1 = new OperatorUserRole();
    this.OPERATOR_ADMIN_ONBOARDING_1 = new OperatorAdminOnboardingRole();
    this.OPERATOR_USER_ONBOARDING_1 = new OperatorUserOnboardingRole();
    this.FUNDER_ADMIN_1 = new FunderAdminRole();
    this.FUNDER_USER_1 = new FunderUserRole();
    this.CARRIER_ADMIN_1 = new CarrierAdminRole();
    this.CARRIER_USER_1 = new CarrierUserRole();
    this.TMS_ADMIN_1 = new TmsAdminRole();
    this.TMS_USER_1 = new TmsUserRole();
    this.VISITOR_ADMIN_1 = new VisitorAdminRole();
    this.VISITOR_USER_1 = new VisitorUserRole();
  }
  UserRoleValues.prototype._get_ADMIN__2138328706_zd3szm_k$ = function () {
    return this.ADMIN_1;
  };
  UserRoleValues.prototype._get_SUPER_ADMIN__4175670694_1z0xui_k$ = function () {
    return this.SUPER_ADMIN_1;
  };
  UserRoleValues.prototype._get_OPERATOR_ADMIN__3968426167_5eewqx_k$ = function () {
    return this.OPERATOR_ADMIN_1;
  };
  UserRoleValues.prototype._get_OPERATOR_USER__1948038923_w7t8gb_k$ = function () {
    return this.OPERATOR_USER_1;
  };
  UserRoleValues.prototype._get_OPERATOR_ADMIN_ONBOARDING__3608562091_bco1n9_k$ = function () {
    return this.OPERATOR_ADMIN_ONBOARDING_1;
  };
  UserRoleValues.prototype._get_OPERATOR_USER_ONBOARDING__427521751_72j9w7_k$ = function () {
    return this.OPERATOR_USER_ONBOARDING_1;
  };
  UserRoleValues.prototype._get_FUNDER_ADMIN__1213089449_k28pt5_k$ = function () {
    return this.FUNDER_ADMIN_1;
  };
  UserRoleValues.prototype._get_FUNDER_USER__1443515097_nvfjdl_k$ = function () {
    return this.FUNDER_USER_1;
  };
  UserRoleValues.prototype._get_CARRIER_ADMIN__3985193673_54fiuv_k$ = function () {
    return this.CARRIER_ADMIN_1;
  };
  UserRoleValues.prototype._get_CARRIER_USER__563106489_9b9bqx_k$ = function () {
    return this.CARRIER_USER_1;
  };
  UserRoleValues.prototype._get_TMS_ADMIN__888821735_ep6j8n_k$ = function () {
    return this.TMS_ADMIN_1;
  };
  UserRoleValues.prototype._get_TMS_USER__186128859_32tdy3_k$ = function () {
    return this.TMS_USER_1;
  };
  UserRoleValues.prototype._get_VISITOR_ADMIN__982709395_g92vf7_k$ = function () {
    return this.VISITOR_ADMIN_1;
  };
  UserRoleValues.prototype._get_VISITOR_USER__2128820143_z7g04v_k$ = function () {
    return this.VISITOR_USER_1;
  };
  UserRoleValues.prototype.getAll = function () {
    return listOf([this.SUPER_ADMIN_1, this.ADMIN_1, this.OPERATOR_ADMIN_1, this.OPERATOR_USER_1, this.FUNDER_ADMIN_1, this.FUNDER_USER_1, this.CARRIER_ADMIN_1, this.CARRIER_USER_1, this.TMS_ADMIN_1, this.TMS_USER_1, this.VISITOR_ADMIN_1, this.VISITOR_USER_1]);
  };
  UserRoleValues.prototype.isManagerUserRole = function (name) {
    return name === (new AdminRole()).role;
  };
  UserRoleValues.prototype.isManagerAdminRole = function (name) {
    return name === (new SuperAdminRole()).role;
  };
  UserRoleValues.prototype.isOperatorAdminRole = function (name) {
    return name === (new OperatorAdminRole()).role;
  };
  UserRoleValues.prototype.isOperatorUserRole = function (name) {
    return name === (new OperatorUserRole()).role;
  };
  UserRoleValues.prototype.isOperatorAdminOnboardingRole = function (name) {
    return name === (new OperatorAdminOnboardingRole()).role;
  };
  UserRoleValues.prototype.isOperatorUserOnboardingRole = function (name) {
    return name === (new OperatorUserOnboardingRole()).role;
  };
  UserRoleValues.prototype.isFunderAdminRole = function (name) {
    return name === (new FunderAdminRole()).role;
  };
  UserRoleValues.prototype.isFunderUserRole = function (name) {
    return name === (new FunderUserRole()).role;
  };
  UserRoleValues.prototype.isCarrierAdminRole = function (name) {
    return name === (new CarrierAdminRole()).role;
  };
  UserRoleValues.prototype.isCarrierUserRole = function (name) {
    return name === (new CarrierUserRole()).role;
  };
  UserRoleValues.prototype.isTmsAdminRole = function (name) {
    return name === (new TmsAdminRole()).role;
  };
  UserRoleValues.prototype.isTmsUserRole = function (name) {
    return name === (new TmsUserRole()).role;
  };
  UserRoleValues.prototype.isVisitorAdminRole = function (name) {
    return name === (new VisitorAdminRole()).role;
  };
  UserRoleValues.prototype.isVisitorUserRole = function (name) {
    return name === (new VisitorUserRole()).role;
  };
  UserRoleValues.prototype.getRole = function (role, organizationType) {
    var tmp0_subject = organizationType.type;
    var tmp;
    if (tmp0_subject === (new OrganizationTypeValues()).CARRIER.type) {
      tmp = 'carrier_' + role;
    } else if (tmp0_subject === (new OrganizationTypeValues()).OPERATOR.type) {
      tmp = 'operator_' + role;
    } else if (tmp0_subject === (new OrganizationTypeValues()).FUNDER.type) {
      tmp = 'funder_' + role;
    } else if (tmp0_subject === (new OrganizationTypeValues()).TMS.type) {
      tmp = 'tms_' + role;
    } else if (tmp0_subject === (new OrganizationTypeValues()).VISITOR.type) {
      tmp = 'visitor_' + role;
    } else if (tmp0_subject === (new OrganizationTypeValues()).MANAGER.type) {
      var tmp_0;
      if (role === 'admin') {
        tmp_0 = _get_ROLE_SUPER_ADMIN__3554080777();
      } else {
        tmp_0 = _get_ROLE_ADMIN__3149651749();
      }
      tmp = tmp_0;
    } else {
      tmp = '';
    }
    var roleString = tmp;
    return new UserRoleBase(roleString);
  };
  UserRoleValues.$metadata$ = {
    simpleName: 'UserRoleValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(UserRoleValues.prototype, 'ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_ADMIN__2138328706_zd3szm_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'SUPER_ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_SUPER_ADMIN__4175670694_1z0xui_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'OPERATOR_ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_OPERATOR_ADMIN__3968426167_5eewqx_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'OPERATOR_USER', {
    configurable: true,
    get: UserRoleValues.prototype._get_OPERATOR_USER__1948038923_w7t8gb_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'OPERATOR_ADMIN_ONBOARDING', {
    configurable: true,
    get: UserRoleValues.prototype._get_OPERATOR_ADMIN_ONBOARDING__3608562091_bco1n9_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'OPERATOR_USER_ONBOARDING', {
    configurable: true,
    get: UserRoleValues.prototype._get_OPERATOR_USER_ONBOARDING__427521751_72j9w7_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'FUNDER_ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_FUNDER_ADMIN__1213089449_k28pt5_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'FUNDER_USER', {
    configurable: true,
    get: UserRoleValues.prototype._get_FUNDER_USER__1443515097_nvfjdl_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'CARRIER_ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_CARRIER_ADMIN__3985193673_54fiuv_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'CARRIER_USER', {
    configurable: true,
    get: UserRoleValues.prototype._get_CARRIER_USER__563106489_9b9bqx_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'TMS_ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_TMS_ADMIN__888821735_ep6j8n_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'TMS_USER', {
    configurable: true,
    get: UserRoleValues.prototype._get_TMS_USER__186128859_32tdy3_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'VISITOR_ADMIN', {
    configurable: true,
    get: UserRoleValues.prototype._get_VISITOR_ADMIN__982709395_g92vf7_k$
  });
  Object.defineProperty(UserRoleValues.prototype, 'VISITOR_USER', {
    configurable: true,
    get: UserRoleValues.prototype._get_VISITOR_USER__2128820143_z7g04v_k$
  });
  function VisitorRole() {
  }
  VisitorRole.$metadata$ = {
    simpleName: 'VisitorRole',
    kind: 'interface',
    interfaces: [UserRole]
  };
  function VisitorRoleBase(role) {
    this.role_1 = role;
  }
  VisitorRoleBase.prototype._get_role__808279189_dd887p_k$ = function () {
    return this.role_1;
  };
  VisitorRoleBase.$metadata$ = {
    simpleName: 'VisitorRoleBase',
    kind: 'class',
    interfaces: [VisitorRole]
  };
  Object.defineProperty(VisitorRoleBase.prototype, 'role', {
    configurable: true,
    get: function () {
      return this._get_role__808279189_dd887p_k$();
    }
  });
  function ReadHeatMap() {
    VisitorRoleBase.call(this, _get_ROLE_READ_HEAT_MAP__2334907966());
  }
  ReadHeatMap.$metadata$ = {
    simpleName: 'ReadHeatMapRole',
    kind: 'class',
    interfaces: []
  };
  function ReadFluxMap() {
    VisitorRoleBase.call(this, _get_ROLE_READ_FLUX_MAP__1654341093());
  }
  ReadFluxMap.$metadata$ = {
    simpleName: 'ReadFluxMapRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardBonusTotal() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_BONUS_TOTAL__3980768280());
  }
  ReadDashboardBonusTotal.$metadata$ = {
    simpleName: 'ReadDashboardBonusTotalRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardBonusPerPackage() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE__961309144());
  }
  ReadDashboardBonusPerPackage.$metadata$ = {
    simpleName: 'ReadDashboardBonusPerPackageRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardDeliveryTime() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_DELIVERY_TIME__1042262468());
  }
  ReadDashboardDeliveryTime.$metadata$ = {
    simpleName: 'ReadDashboardDeliveryTimeRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardActiveDeliveries() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES__628138737());
  }
  ReadDashboardActiveDeliveries.$metadata$ = {
    simpleName: 'ReadDashboardActiveDeliveriesRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardActivePackCount() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT__3236390426());
  }
  ReadDashboardActivePackCount.$metadata$ = {
    simpleName: 'ReadDashboardActivePackCountRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardHubCount() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_HUB_COUNT__3178299799());
  }
  ReadDashboardHubCount.$metadata$ = {
    simpleName: 'ReadDashboardHubCountRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardAverageApproachDistance() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE__1081766482());
  }
  ReadDashboardAverageApproachDistance.$metadata$ = {
    simpleName: 'ReadDashboardAverageApproachDistanceRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardAverageDistancePerDelivery() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__2332509822());
  }
  ReadDashboardAverageDistancePerDelivery.$metadata$ = {
    simpleName: 'ReadDashboardAverageDistancePerDeliveryRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardTourAmount() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_TOUR_AMOUNT__144310845());
  }
  ReadDashboardTourAmount.$metadata$ = {
    simpleName: 'ReadDashboardTourAmountRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardDistanceTotal() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_DISTANCE_TOTAL__2048129574());
  }
  ReadDashboardDistanceTotal.$metadata$ = {
    simpleName: 'ReadDashboardDistanceTotalRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardThermalKmAvoided() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED__1801289601());
  }
  ReadDashboardThermalKmAvoided.$metadata$ = {
    simpleName: 'ReadDashboardThermalKmAvoidedRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardCo2Avoided() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_CO2_AVOIDED__3570012961());
  }
  ReadDashboardCo2Avoided.$metadata$ = {
    simpleName: 'ReadDashboardCo2AvoidedRole',
    kind: 'class',
    interfaces: []
  };
  function ReadDashboardNoxPpmAvoided() {
    VisitorRoleBase.call(this, _get_ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED__3490441090());
  }
  ReadDashboardNoxPpmAvoided.$metadata$ = {
    simpleName: 'ReadDashboardNoxPpmAvoidedRole',
    kind: 'class',
    interfaces: []
  };
  function VisitorRoleValues() {
    this.READ_HEAT_MAP_1 = new ReadHeatMap();
    this.READ_FLUX_MAP_1 = new ReadFluxMap();
    this.READ_DASHBOARD_BONUS_TOTAL_1 = new ReadDashboardBonusTotal();
    this.READ_DASHBOARD_BONUS_PER_PACKAGE_1 = new ReadDashboardBonusPerPackage();
    this.READ_DASHBOARD_DELIVERY_TIME_1 = new ReadDashboardDeliveryTime();
    this.READ_DASHBOARD_ACTIVE_DELIVERIES_1 = new ReadDashboardActiveDeliveries();
    this.READ_DASHBOARD_ACTIVE_PACK_COUNT_1 = new ReadDashboardActivePackCount();
    this.READ_DASHBOARD_HUB_COUNT_1 = new ReadDashboardHubCount();
    this.READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY_1 = new ReadDashboardAverageDistancePerDelivery();
    this.READ_DASHBOARD_TOUR_AMOUNT_1 = new ReadDashboardTourAmount();
    this.READ_DASHBOARD_DISTANCE_TOTAL_1 = new ReadDashboardDistanceTotal();
    this.READ_DASHBOARD_THERMAL_KM_AVOIDED_1 = new ReadDashboardThermalKmAvoided();
    this.READ_DASHBOARD_CO2_AVOIDED_1 = new ReadDashboardCo2Avoided();
    this.READ_DASHBOARD_NOX_PPM_AVOIDED_1 = new ReadDashboardNoxPpmAvoided();
  }
  VisitorRoleValues.prototype._get_READ_HEAT_MAP__2682364059_qo3omd_k$ = function () {
    return this.READ_HEAT_MAP_1;
  };
  VisitorRoleValues.prototype._get_READ_FLUX_MAP__2001797186_x3tgle_k$ = function () {
    return this.READ_FLUX_MAP_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_BONUS_TOTAL__118321371_1yg1cr_k$ = function () {
    return this.READ_DASHBOARD_BONUS_TOTAL_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_BONUS_PER_PACKAGE__11946075_741nf_k$ = function () {
    return this.READ_DASHBOARD_BONUS_PER_PACKAGE_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_DELIVERY_TIME__82526663_1d4tzb_k$ = function () {
    return this.READ_DASHBOARD_DELIVERY_TIME_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_ACTIVE_DELIVERIES__3973742964_5b8ya4_k$ = function () {
    return this.READ_DASHBOARD_ACTIVE_DELIVERIES_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_ACTIVE_PACK_COUNT__2287027357_x7h4df_k$ = function () {
    return this.READ_DASHBOARD_ACTIVE_PACK_COUNT_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_HUB_COUNT__2155287322_zdwrmu_k$ = function () {
    return this.READ_DASHBOARD_HUB_COUNT_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__698382465_bjsrcx_k$ = function () {
    return this.READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_TOUR_AMOUNT__576831232_9jfhts_k$ = function () {
    return this.READ_DASHBOARD_TOUR_AMOUNT_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_DISTANCE_TOTAL__2361090691_vzdoql_k$ = function () {
    return this.READ_DASHBOARD_DISTANCE_TOTAL_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_THERMAL_KM_AVOIDED__2435805534_uqwaea_k$ = function () {
    return this.READ_DASHBOARD_THERMAL_KM_AVOIDED_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_CO2_AVOIDED__4002533348_4u3vh8_k$ = function () {
    return this.READ_DASHBOARD_CO2_AVOIDED_1;
  };
  VisitorRoleValues.prototype._get_READ_DASHBOARD_NOX_PPM_AVOIDED__307333829_52z8at_k$ = function () {
    return this.READ_DASHBOARD_NOX_PPM_AVOIDED_1;
  };
  VisitorRoleValues.prototype.getAll = function () {
    var tmp$ret$2;
    $l$block_1: {
      var tmp0_arrayOf_0 = [this.READ_HEAT_MAP_1, this.READ_FLUX_MAP_1, this.READ_DASHBOARD_BONUS_TOTAL_1, this.READ_DASHBOARD_BONUS_PER_PACKAGE_1, this.READ_DASHBOARD_DELIVERY_TIME_1, this.READ_DASHBOARD_ACTIVE_DELIVERIES_1, this.READ_DASHBOARD_ACTIVE_PACK_COUNT_1, this.READ_DASHBOARD_HUB_COUNT_1, this.READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY_1, this.READ_DASHBOARD_TOUR_AMOUNT_1, this.READ_DASHBOARD_DISTANCE_TOTAL_1, this.READ_DASHBOARD_THERMAL_KM_AVOIDED_1, this.READ_DASHBOARD_CO2_AVOIDED_1, this.READ_DASHBOARD_NOX_PPM_AVOIDED_1];
      var tmp$ret$1;
      $l$block_0: {
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = tmp0_arrayOf_0;
          break $l$block;
        }
        tmp$ret$1 = tmp$ret$0;
        break $l$block_0;
      }
      tmp$ret$2 = tmp$ret$1;
      break $l$block_1;
    }
    return tmp$ret$2;
  };
  VisitorRoleValues.prototype.isReadHeatMapRole = function (name) {
    return name === (new ReadHeatMap()).role;
  };
  VisitorRoleValues.prototype.isReadFluxMapRole = function (name) {
    return name === (new ReadFluxMap()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardBonusTotalRole = function (name) {
    return name === (new ReadDashboardBonusTotal()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardBonusPerPackageRole = function (name) {
    return name === (new ReadDashboardBonusPerPackage()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardDeliveryTimeRole = function (name) {
    return name === (new ReadDashboardDeliveryTime()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardActiveDeliveriesRole = function (name) {
    return name === (new ReadDashboardActiveDeliveries()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardActivePackCountRole = function (name) {
    return name === (new ReadDashboardActivePackCount()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardHubCountRole = function (name) {
    return name === (new ReadDashboardHubCount()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardAverageApproachDistance = function (name) {
    return name === (new ReadDashboardAverageApproachDistance()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardAverageDistancePerDeliveryRole = function (name) {
    return name === (new ReadDashboardAverageDistancePerDelivery()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardTourAmountRole = function (name) {
    return name === (new ReadDashboardTourAmount()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardDistanceTotalRole = function (name) {
    return name === (new ReadDashboardDistanceTotal()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardThermalKmAvoidedRole = function (name) {
    return name === (new ReadDashboardThermalKmAvoided()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardCo2AvoidedRole = function (name) {
    return name === (new ReadDashboardCo2Avoided()).role;
  };
  VisitorRoleValues.prototype.isReadDashboardNoxPpmAvoidedRole = function (name) {
    return name === (new ReadDashboardNoxPpmAvoided()).role;
  };
  VisitorRoleValues.$metadata$ = {
    simpleName: 'VisitorRoleValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_HEAT_MAP', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_HEAT_MAP__2682364059_qo3omd_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_FLUX_MAP', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_FLUX_MAP__2001797186_x3tgle_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_BONUS_TOTAL', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_BONUS_TOTAL__118321371_1yg1cr_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_BONUS_PER_PACKAGE', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_BONUS_PER_PACKAGE__11946075_741nf_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_DELIVERY_TIME', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_DELIVERY_TIME__82526663_1d4tzb_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_ACTIVE_DELIVERIES', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_ACTIVE_DELIVERIES__3973742964_5b8ya4_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_ACTIVE_PACK_COUNT', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_ACTIVE_PACK_COUNT__2287027357_x7h4df_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_HUB_COUNT', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_HUB_COUNT__2155287322_zdwrmu_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__698382465_bjsrcx_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_TOUR_AMOUNT', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_TOUR_AMOUNT__576831232_9jfhts_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_DISTANCE_TOTAL', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_DISTANCE_TOTAL__2361090691_vzdoql_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_THERMAL_KM_AVOIDED', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_THERMAL_KM_AVOIDED__2435805534_uqwaea_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_CO2_AVOIDED', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_CO2_AVOIDED__4002533348_4u3vh8_k$
  });
  Object.defineProperty(VisitorRoleValues.prototype, 'READ_DASHBOARD_NOX_PPM_AVOIDED', {
    configurable: true,
    get: VisitorRoleValues.prototype._get_READ_DASHBOARD_NOX_PPM_AVOIDED__307333829_52z8at_k$
  });
  function BonusPrice() {
  }
  BonusPrice.$metadata$ = {
    simpleName: 'BonusPrice',
    kind: 'interface',
    interfaces: []
  };
  function BonusPriceBase(value, areas, operatorIds, carrierIds, maxHourRate) {
    this.value_1 = value;
    this.areas_1 = areas;
    this.operatorIds_1 = operatorIds;
    this.carrierIds_1 = carrierIds;
    this.maxHourRate_1 = maxHourRate;
  }
  BonusPriceBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  BonusPriceBase.prototype._get_areas__3097682699_jstyph_k$ = function () {
    return this.areas_1;
  };
  BonusPriceBase.prototype._get_operatorIds__1553507485_pox21p_k$ = function () {
    return this.operatorIds_1;
  };
  BonusPriceBase.prototype._get_carrierIds__1640409067_r4nnqj_k$ = function () {
    return this.carrierIds_1;
  };
  BonusPriceBase.prototype._get_maxHourRate__1218804777_k5n7s9_k$ = function () {
    return this.maxHourRate_1;
  };
  BonusPriceBase.$metadata$ = {
    simpleName: 'BonusPriceBase',
    kind: 'class',
    interfaces: [BonusPrice]
  };
  Object.defineProperty(BonusPriceBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  Object.defineProperty(BonusPriceBase.prototype, 'areas', {
    configurable: true,
    get: function () {
      return this._get_areas__3097682699_jstyph_k$();
    }
  });
  Object.defineProperty(BonusPriceBase.prototype, 'operatorIds', {
    configurable: true,
    get: function () {
      return this._get_operatorIds__1553507485_pox21p_k$();
    }
  });
  Object.defineProperty(BonusPriceBase.prototype, 'carrierIds', {
    configurable: true,
    get: function () {
      return this._get_carrierIds__1640409067_r4nnqj_k$();
    }
  });
  Object.defineProperty(BonusPriceBase.prototype, 'maxHourRate', {
    configurable: true,
    get: function () {
      return this._get_maxHourRate__1218804777_k5n7s9_k$();
    }
  });
  function Campaign() {
  }
  Campaign.$metadata$ = {
    simpleName: 'Campaign',
    kind: 'interface',
    interfaces: []
  };
  function CampaignBase(id, projectId, status, details, bonusPrices, funders, budget, missingBudget, sendExpiringNotification, creationDate) {
    this.id_1 = id;
    this.projectId_1 = projectId;
    this.status_1 = status;
    this.details_1 = details;
    this.bonusPrices_1 = bonusPrices;
    this.funders_1 = funders;
    this.budget_1 = budget;
    this.missingBudget_1 = missingBudget;
    this.sendExpiringNotification_1 = sendExpiringNotification;
    this.creationDate_1 = creationDate;
  }
  CampaignBase.prototype._set_id__3473230556_thlcja_k$ = function (_set____804775014) {
    this.id_1 = _set____804775014;
  };
  CampaignBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  CampaignBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  CampaignBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  CampaignBase.prototype._set_details__424767875_7w703e_k$ = function (_set____804775014) {
    this.details_1 = _set____804775014;
  };
  CampaignBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  CampaignBase.prototype._get_bonusPrices__2570137960_six2u0_k$ = function () {
    return this.bonusPrices_1;
  };
  CampaignBase.prototype._set_funders__761460516_y0y8fv_k$ = function (_set____804775014) {
    this.funders_1 = _set____804775014;
  };
  CampaignBase.prototype._get_funders__3507435184_d0vjo0_k$ = function () {
    return this.funders_1;
  };
  CampaignBase.prototype._get_budget__2511517798_thtifu_k$ = function () {
    return this.budget_1;
  };
  CampaignBase.prototype._get_missingBudget__2581184998_sccavu_k$ = function () {
    return this.missingBudget_1;
  };
  CampaignBase.prototype._get_sendExpiringNotification__1305120476_ll19ek_k$ = function () {
    return this.sendExpiringNotification_1;
  };
  CampaignBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  CampaignBase.prototype.component1 = function () {
    return this.id_1;
  };
  CampaignBase.prototype.component2 = function () {
    return this.projectId_1;
  };
  CampaignBase.prototype.component3 = function () {
    return this.status_1;
  };
  CampaignBase.prototype.component4 = function () {
    return this.details_1;
  };
  CampaignBase.prototype.component5 = function () {
    return this.bonusPrices_1;
  };
  CampaignBase.prototype.component6 = function () {
    return this.funders_1;
  };
  CampaignBase.prototype.component7 = function () {
    return this.budget_1;
  };
  CampaignBase.prototype.component8 = function () {
    return this.missingBudget_1;
  };
  CampaignBase.prototype.component9 = function () {
    return this.sendExpiringNotification_1;
  };
  CampaignBase.prototype.component10 = function () {
    return this.creationDate_1;
  };
  CampaignBase.prototype.copy = function (id, projectId, status, details, bonusPrices, funders, budget, missingBudget, sendExpiringNotification, creationDate) {
    return this.copy_976f4t_k$(id === void 1 ? this.id_1 : id, projectId === void 1 ? this.projectId_1 : projectId, status === void 1 ? this.status_1 : status, details === void 1 ? this.details_1 : details, bonusPrices === void 1 ? this.bonusPrices_1 : bonusPrices, funders === void 1 ? this.funders_1 : funders, budget === void 1 ? this.budget_1 : budget, missingBudget === void 1 ? this.missingBudget_1 : missingBudget, sendExpiringNotification === void 1 ? this.sendExpiringNotification_1 : sendExpiringNotification, creationDate === void 1 ? this.creationDate_1 : creationDate);
  };
  CampaignBase.prototype.copy_976f4t_k$ = function (id, projectId, status, details, bonusPrices, funders, budget, missingBudget, sendExpiringNotification, creationDate) {
    return new CampaignBase(id, projectId, status, details, bonusPrices, funders, budget, missingBudget, sendExpiringNotification, creationDate);
  };
  CampaignBase.prototype.copy$default_2ryh3m_k$ = function (id, projectId, status, details, bonusPrices, funders, budget, missingBudget, sendExpiringNotification, creationDate, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      projectId = this.projectId_1;
    if (!(($mask0 & 4) === 0))
      status = this.status_1;
    if (!(($mask0 & 8) === 0))
      details = this.details_1;
    if (!(($mask0 & 16) === 0))
      bonusPrices = this.bonusPrices_1;
    if (!(($mask0 & 32) === 0))
      funders = this.funders_1;
    if (!(($mask0 & 64) === 0))
      budget = this.budget_1;
    if (!(($mask0 & 128) === 0))
      missingBudget = this.missingBudget_1;
    if (!(($mask0 & 256) === 0))
      sendExpiringNotification = this.sendExpiringNotification_1;
    if (!(($mask0 & 512) === 0))
      creationDate = this.creationDate_1;
    return this.copy_976f4t_k$(id, projectId, status, details, bonusPrices, funders, budget, missingBudget, sendExpiringNotification, creationDate);
  };
  CampaignBase.prototype.toString = function () {
    return 'CampaignBase(id=' + this.id_1 + ', projectId=' + this.projectId_1 + ', status=' + this.status_1 + ', details=' + this.details_1 + ', bonusPrices=' + this.bonusPrices_1 + ', funders=' + this.funders_1 + ', budget=' + this.budget_1 + ', missingBudget=' + this.missingBudget_1 + ', sendExpiringNotification=' + this.sendExpiringNotification_1 + ', creationDate=' + toString_1(this.creationDate_1) + ')';
  };
  CampaignBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.projectId_1) | 0;
    result = imul(result, 31) + hashCode(this.status_1) | 0;
    result = imul(result, 31) + this.details_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.bonusPrices_1) | 0;
    result = imul(result, 31) + hashCode(this.funders_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.budget_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.missingBudget_1) | 0;
    result = imul(result, 31) + (this.sendExpiringNotification_1 | 0) | 0;
    result = imul(result, 31) + this.creationDate_1.hashCode() | 0;
    return result;
  };
  CampaignBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CampaignBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CampaignBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.projectId_1 === tmp0_other_with_cast.projectId_1))
      return false;
    if (!equals(this.status_1, tmp0_other_with_cast.status_1))
      return false;
    if (!this.details_1.equals(tmp0_other_with_cast.details_1))
      return false;
    if (!equals(this.bonusPrices_1, tmp0_other_with_cast.bonusPrices_1))
      return false;
    if (!equals(this.funders_1, tmp0_other_with_cast.funders_1))
      return false;
    if (!equals(this.budget_1, tmp0_other_with_cast.budget_1))
      return false;
    if (!equals(this.missingBudget_1, tmp0_other_with_cast.missingBudget_1))
      return false;
    if (!(this.sendExpiringNotification_1 === tmp0_other_with_cast.sendExpiringNotification_1))
      return false;
    if (!this.creationDate_1.equals(tmp0_other_with_cast.creationDate_1))
      return false;
    return true;
  };
  CampaignBase.$metadata$ = {
    simpleName: 'CampaignBase',
    kind: 'class',
    interfaces: [Campaign]
  };
  Object.defineProperty(CampaignBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    },
    set: function (value) {
      this._set_id__3473230556_thlcja_k$(value);
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    },
    set: function (value) {
      this._set_details__424767875_7w703e_k$(value);
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'bonusPrices', {
    configurable: true,
    get: function () {
      return this._get_bonusPrices__2570137960_six2u0_k$();
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'funders', {
    configurable: true,
    get: function () {
      return this._get_funders__3507435184_d0vjo0_k$();
    },
    set: function (value) {
      this._set_funders__761460516_y0y8fv_k$(value);
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'budget', {
    configurable: true,
    get: function () {
      return this._get_budget__2511517798_thtifu_k$();
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'missingBudget', {
    configurable: true,
    get: function () {
      return this._get_missingBudget__2581184998_sccavu_k$();
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'sendExpiringNotification', {
    configurable: true,
    get: function () {
      return this._get_sendExpiringNotification__1305120476_ll19ek_k$();
    }
  });
  Object.defineProperty(CampaignBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  function CampaignDetails() {
  }
  CampaignDetails.$metadata$ = {
    simpleName: 'CampaignDetails',
    kind: 'interface',
    interfaces: []
  };
  function CampaignDetailsBase(name, period) {
    this.name_1 = name;
    this.period_1 = period;
  }
  CampaignDetailsBase.prototype._set_name__589551916_2ji656_k$ = function (_set____804775014) {
    this.name_1 = _set____804775014;
  };
  CampaignDetailsBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  CampaignDetailsBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  CampaignDetailsBase.prototype.component1 = function () {
    return this.name_1;
  };
  CampaignDetailsBase.prototype.component2 = function () {
    return this.period_1;
  };
  CampaignDetailsBase.prototype.copy = function (name, period) {
    return this.copy_gjz4ap_k$(name === void 1 ? this.name_1 : name, period === void 1 ? this.period_1 : period);
  };
  CampaignDetailsBase.prototype.copy_gjz4ap_k$ = function (name, period) {
    return new CampaignDetailsBase(name, period);
  };
  CampaignDetailsBase.prototype.copy$default_i4sty_k$ = function (name, period, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      name = this.name_1;
    if (!(($mask0 & 2) === 0))
      period = this.period_1;
    return this.copy_gjz4ap_k$(name, period);
  };
  CampaignDetailsBase.prototype.toString = function () {
    return 'CampaignDetailsBase(name=' + this.name_1 + ', period=' + this.period_1 + ')';
  };
  CampaignDetailsBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.name_1);
    result = imul(result, 31) + this.period_1.hashCode() | 0;
    return result;
  };
  CampaignDetailsBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CampaignDetailsBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CampaignDetailsBase ? other : THROW_CCE();
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!this.period_1.equals(tmp0_other_with_cast.period_1))
      return false;
    return true;
  };
  CampaignDetailsBase.$metadata$ = {
    simpleName: 'CampaignDetailsBase',
    kind: 'class',
    interfaces: [CampaignDetails]
  };
  Object.defineProperty(CampaignDetailsBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    },
    set: function (value) {
      this._set_name__589551916_2ji656_k$(value);
    }
  });
  Object.defineProperty(CampaignDetailsBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  function CampaignFunder() {
  }
  CampaignFunder.$metadata$ = {
    simpleName: 'CampaignFunder',
    kind: 'interface',
    interfaces: []
  };
  function CampaignFunderBase(funderId, budgetPercentage) {
    this.funderId_1 = funderId;
    this.budgetPercentage_1 = budgetPercentage;
  }
  CampaignFunderBase.prototype._get_funderId__1356269182_mfhjzy_k$ = function () {
    return this.funderId_1;
  };
  CampaignFunderBase.prototype._get_budgetPercentage__4286754540_4w104_k$ = function () {
    return this.budgetPercentage_1;
  };
  CampaignFunderBase.$metadata$ = {
    simpleName: 'CampaignFunderBase',
    kind: 'class',
    interfaces: [CampaignFunder]
  };
  Object.defineProperty(CampaignFunderBase.prototype, 'funderId', {
    configurable: true,
    get: function () {
      return this._get_funderId__1356269182_mfhjzy_k$();
    }
  });
  Object.defineProperty(CampaignFunderBase.prototype, 'budgetPercentage', {
    configurable: true,
    get: function () {
      return this._get_budgetPercentage__4286754540_4w104_k$();
    }
  });
  function _get_CAMPAIGN_STATUS_CREATED__1335265223() {
    init_properties_CampaignStatus_kt_2882415864();
    return CAMPAIGN_STATUS_CREATED;
  }
  var CAMPAIGN_STATUS_CREATED;
  function _get_CAMPAIGN_STATUS_PUBLISHED__3839799617() {
    init_properties_CampaignStatus_kt_2882415864();
    return CAMPAIGN_STATUS_PUBLISHED;
  }
  var CAMPAIGN_STATUS_PUBLISHED;
  function _get_CAMPAIGN_STATUS_STARTED__831650126() {
    init_properties_CampaignStatus_kt_2882415864();
    return CAMPAIGN_STATUS_STARTED;
  }
  var CAMPAIGN_STATUS_STARTED;
  function _get_CAMPAIGN_STATUS_PAUSED__3904762207() {
    init_properties_CampaignStatus_kt_2882415864();
    return CAMPAIGN_STATUS_PAUSED;
  }
  var CAMPAIGN_STATUS_PAUSED;
  function _get_CAMPAIGN_STATUS_DONE__333055307() {
    init_properties_CampaignStatus_kt_2882415864();
    return CAMPAIGN_STATUS_DONE;
  }
  var CAMPAIGN_STATUS_DONE;
  function _get_CAMPAIGN_STATUS_ARCHIVED__474203499() {
    init_properties_CampaignStatus_kt_2882415864();
    return CAMPAIGN_STATUS_ARCHIVED;
  }
  var CAMPAIGN_STATUS_ARCHIVED;
  function CampaignStatus() {
  }
  CampaignStatus.$metadata$ = {
    simpleName: 'CampaignStatus',
    kind: 'interface',
    interfaces: []
  };
  function CampaignStatusBase(value) {
    this.value_1 = value;
  }
  CampaignStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  CampaignStatusBase.$metadata$ = {
    simpleName: 'CampaignStatusBase',
    kind: 'class',
    interfaces: [CampaignStatus]
  };
  Object.defineProperty(CampaignStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function CampaignStatusValues() {
    this.CREATED_1 = _get_CAMPAIGN_STATUS_CREATED__1335265223();
    this.PUBLISHED_1 = _get_CAMPAIGN_STATUS_PUBLISHED__3839799617();
    this.STARTED_1 = _get_CAMPAIGN_STATUS_STARTED__831650126();
    this.PAUSED_1 = _get_CAMPAIGN_STATUS_PAUSED__3904762207();
    this.DONE_1 = _get_CAMPAIGN_STATUS_DONE__333055307();
    this.ARCHIVED_1 = _get_CAMPAIGN_STATUS_ARCHIVED__474203499();
  }
  CampaignStatusValues.prototype._get_CREATED__434088265_76g0nd_k$ = function () {
    return this.CREATED_1;
  };
  CampaignStatusValues.prototype._get_PUBLISHED__1097169475_i585dv_k$ = function () {
    return this.PUBLISHED_1;
  };
  CampaignStatusValues.prototype._get_STARTED__4225440464_15e78w_k$ = function () {
    return this.STARTED_1;
  };
  CampaignStatusValues.prototype._get_PAUSED__2213123997_yfh4kj_k$ = function () {
    return this.PAUSED_1;
  };
  CampaignStatusValues.prototype._get_DONE__764814089_cncmbt_k$ = function () {
    return this.DONE_1;
  };
  CampaignStatusValues.prototype._get_ARCHIVED__2602488873_rznopj_k$ = function () {
    return this.ARCHIVED_1;
  };
  CampaignStatusValues.prototype.isCreated = function (status) {
    return status === this.CREATED_1.value_1;
  };
  CampaignStatusValues.prototype.isPublished = function (status) {
    return status === this.PUBLISHED_1.value_1;
  };
  CampaignStatusValues.prototype.isStarted = function (status) {
    return status === this.STARTED_1.value_1;
  };
  CampaignStatusValues.prototype.isPaused = function (status) {
    return status === this.PAUSED_1.value_1;
  };
  CampaignStatusValues.prototype.isDone = function (status) {
    return status === this.DONE_1.value_1;
  };
  CampaignStatusValues.prototype.isArchived = function (status) {
    return status === this.ARCHIVED_1.value_1;
  };
  CampaignStatusValues.$metadata$ = {
    simpleName: 'CampaignStatusValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(CampaignStatusValues.prototype, 'CREATED', {
    configurable: true,
    get: CampaignStatusValues.prototype._get_CREATED__434088265_76g0nd_k$
  });
  Object.defineProperty(CampaignStatusValues.prototype, 'PUBLISHED', {
    configurable: true,
    get: CampaignStatusValues.prototype._get_PUBLISHED__1097169475_i585dv_k$
  });
  Object.defineProperty(CampaignStatusValues.prototype, 'STARTED', {
    configurable: true,
    get: CampaignStatusValues.prototype._get_STARTED__4225440464_15e78w_k$
  });
  Object.defineProperty(CampaignStatusValues.prototype, 'PAUSED', {
    configurable: true,
    get: CampaignStatusValues.prototype._get_PAUSED__2213123997_yfh4kj_k$
  });
  Object.defineProperty(CampaignStatusValues.prototype, 'DONE', {
    configurable: true,
    get: CampaignStatusValues.prototype._get_DONE__764814089_cncmbt_k$
  });
  Object.defineProperty(CampaignStatusValues.prototype, 'ARCHIVED', {
    configurable: true,
    get: CampaignStatusValues.prototype._get_ARCHIVED__2602488873_rznopj_k$
  });
  var properties_initialized_CampaignStatus_kt_3835928860;
  function init_properties_CampaignStatus_kt_2882415864() {
    if (!properties_initialized_CampaignStatus_kt_3835928860) {
      properties_initialized_CampaignStatus_kt_3835928860 = true;
      CAMPAIGN_STATUS_CREATED = new CampaignStatusBase('CREATED');
      CAMPAIGN_STATUS_PUBLISHED = new CampaignStatusBase('PUBLISHED');
      CAMPAIGN_STATUS_STARTED = new CampaignStatusBase('STARTED');
      CAMPAIGN_STATUS_PAUSED = new CampaignStatusBase('PAUSED');
      CAMPAIGN_STATUS_DONE = new CampaignStatusBase('DONE');
      CAMPAIGN_STATUS_ARCHIVED = new CampaignStatusBase('ARCHIVED');
    }
  }
  function Project() {
  }
  Project.$metadata$ = {
    simpleName: 'Project',
    kind: 'interface',
    interfaces: []
  };
  function ProjectBase(id, details, funders, campaigns, status) {
    this.id_1 = id;
    this.details_1 = details;
    this.funders_1 = funders;
    this.campaigns_1 = campaigns;
    this.status_1 = status;
  }
  ProjectBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProjectBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  ProjectBase.prototype._get_funders__3507435184_d0vjo0_k$ = function () {
    return this.funders_1;
  };
  ProjectBase.prototype._get_campaigns__1668939086_rln5n2_k$ = function () {
    return this.campaigns_1;
  };
  ProjectBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  ProjectBase.$metadata$ = {
    simpleName: 'ProjectBase',
    kind: 'class',
    interfaces: [Project]
  };
  Object.defineProperty(ProjectBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(ProjectBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(ProjectBase.prototype, 'funders', {
    configurable: true,
    get: function () {
      return this._get_funders__3507435184_d0vjo0_k$();
    }
  });
  Object.defineProperty(ProjectBase.prototype, 'campaigns', {
    configurable: true,
    get: function () {
      return this._get_campaigns__1668939086_rln5n2_k$();
    }
  });
  Object.defineProperty(ProjectBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  function ProjectDetails() {
  }
  ProjectDetails.$metadata$ = {
    simpleName: 'ProjectDetails',
    kind: 'interface',
    interfaces: []
  };
  function ProjectDetailsBase_init_$Init$(name, notificationsDisabled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      notificationsDisabled = false;
    ProjectDetailsBase.call($this, name, notificationsDisabled);
    return $this;
  }
  function ProjectDetailsBase_init_$Create$(name, notificationsDisabled, $mask0, $marker) {
    return ProjectDetailsBase_init_$Init$(name, notificationsDisabled, $mask0, $marker, Object.create(ProjectDetailsBase.prototype));
  }
  function ProjectDetailsBase(name, notificationsDisabled) {
    var notificationsDisabled_0 = notificationsDisabled === void 1 ? false : notificationsDisabled;
    this.name_1 = name;
    this.notificationsDisabled_1 = notificationsDisabled_0;
  }
  ProjectDetailsBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  ProjectDetailsBase.prototype._get_notificationsDisabled__2027754189_xj9t59_k$ = function () {
    return this.notificationsDisabled_1;
  };
  ProjectDetailsBase.$metadata$ = {
    simpleName: 'ProjectDetailsBase',
    kind: 'class',
    interfaces: [ProjectDetails]
  };
  Object.defineProperty(ProjectDetailsBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(ProjectDetailsBase.prototype, 'notificationsDisabled', {
    configurable: true,
    get: function () {
      return this._get_notificationsDisabled__2027754189_xj9t59_k$();
    }
  });
  function ProjectAggregate() {
  }
  ProjectAggregate.$metadata$ = {
    simpleName: 'ProjectAggregate',
    kind: 'interface',
    interfaces: []
  };
  function ProjectFunder() {
  }
  ProjectFunder.$metadata$ = {
    simpleName: 'ProjectFunder',
    kind: 'interface',
    interfaces: []
  };
  function ProjectFunderBase(funderId, budget, territories) {
    this.funderId_1 = funderId;
    this.budget_1 = budget;
    this.territories_1 = territories;
  }
  ProjectFunderBase.prototype._get_funderId__1356269182_mfhjzy_k$ = function () {
    return this.funderId_1;
  };
  ProjectFunderBase.prototype._get_budget__2511517798_thtifu_k$ = function () {
    return this.budget_1;
  };
  ProjectFunderBase.prototype._get_territories__3289376345_gmpaxz_k$ = function () {
    return this.territories_1;
  };
  ProjectFunderBase.$metadata$ = {
    simpleName: 'ProjectFunderBase',
    kind: 'class',
    interfaces: [ProjectFunder]
  };
  Object.defineProperty(ProjectFunderBase.prototype, 'funderId', {
    configurable: true,
    get: function () {
      return this._get_funderId__1356269182_mfhjzy_k$();
    }
  });
  Object.defineProperty(ProjectFunderBase.prototype, 'budget', {
    configurable: true,
    get: function () {
      return this._get_budget__2511517798_thtifu_k$();
    }
  });
  Object.defineProperty(ProjectFunderBase.prototype, 'territories', {
    configurable: true,
    get: function () {
      return this._get_territories__3289376345_gmpaxz_k$();
    }
  });
  function _get_PROJECT_STATUS_CREATED__848325546() {
    init_properties_ProjectStatus_kt_1362233897();
    return PROJECT_STATUS_CREATED;
  }
  var PROJECT_STATUS_CREATED;
  function _get_PROJECT_STATUS_STARTED__344710449() {
    init_properties_ProjectStatus_kt_1362233897();
    return PROJECT_STATUS_STARTED;
  }
  var PROJECT_STATUS_STARTED;
  function _get_PROJECT_STATUS_DONE__1334731848() {
    init_properties_ProjectStatus_kt_1362233897();
    return PROJECT_STATUS_DONE;
  }
  var PROJECT_STATUS_DONE;
  function _get_PROJECT_STATUS_ARCHIVED__2558942696() {
    init_properties_ProjectStatus_kt_1362233897();
    return PROJECT_STATUS_ARCHIVED;
  }
  var PROJECT_STATUS_ARCHIVED;
  function ProjectStatus() {
  }
  ProjectStatus.$metadata$ = {
    simpleName: 'ProjectStatus',
    kind: 'interface',
    interfaces: []
  };
  function ProjectStatusBase(status) {
    this.status_1 = status;
  }
  ProjectStatusBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  ProjectStatusBase.$metadata$ = {
    simpleName: 'ProjectStatusBase',
    kind: 'class',
    interfaces: [ProjectStatus]
  };
  Object.defineProperty(ProjectStatusBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  var properties_initialized_ProjectStatus_kt_1670087045;
  function init_properties_ProjectStatus_kt_1362233897() {
    if (!properties_initialized_ProjectStatus_kt_1670087045) {
      properties_initialized_ProjectStatus_kt_1670087045 = true;
      PROJECT_STATUS_CREATED = new ProjectStatusBase('CREATED');
      PROJECT_STATUS_STARTED = new ProjectStatusBase('STARTED');
      PROJECT_STATUS_DONE = new ProjectStatusBase('DONE');
      PROJECT_STATUS_ARCHIVED = new ProjectStatusBase('ARCHIVED');
    }
  }
  function AddCampaignCommand() {
  }
  AddCampaignCommand.$metadata$ = {
    simpleName: 'AddCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddCampaignDTO() {
  }
  AddCampaignDTO.$metadata$ = {
    simpleName: 'AddCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddCampaignCommandBase.$metadata$ = {
    simpleName: 'AddCampaignCommandBase',
    kind: 'class',
    interfaces: [AddCampaignCommand]
  };
  Object.defineProperty(AddCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddCampaignDTOBase(projectId, campaignDetails, bonusPrices, funders, budget) {
    this.projectId_1 = projectId;
    this.campaignDetails_1 = campaignDetails;
    this.bonusPrices_1 = bonusPrices;
    this.funders_1 = funders;
    this.budget_1 = budget;
  }
  AddCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  AddCampaignDTOBase.prototype._get_campaignDetails__2477032255_u2cnnl_k$ = function () {
    return this.campaignDetails_1;
  };
  AddCampaignDTOBase.prototype._get_bonusPrices__2570137960_six2u0_k$ = function () {
    return this.bonusPrices_1;
  };
  AddCampaignDTOBase.prototype._get_funders__3507435184_d0vjo0_k$ = function () {
    return this.funders_1;
  };
  AddCampaignDTOBase.prototype._get_budget__2511517798_thtifu_k$ = function () {
    return this.budget_1;
  };
  AddCampaignDTOBase.$metadata$ = {
    simpleName: 'AddCampaignDTOBase',
    kind: 'class',
    interfaces: [AddCampaignDTO]
  };
  Object.defineProperty(AddCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(AddCampaignDTOBase.prototype, 'campaignDetails', {
    configurable: true,
    get: function () {
      return this._get_campaignDetails__2477032255_u2cnnl_k$();
    }
  });
  Object.defineProperty(AddCampaignDTOBase.prototype, 'bonusPrices', {
    configurable: true,
    get: function () {
      return this._get_bonusPrices__2570137960_six2u0_k$();
    }
  });
  Object.defineProperty(AddCampaignDTOBase.prototype, 'funders', {
    configurable: true,
    get: function () {
      return this._get_funders__3507435184_d0vjo0_k$();
    }
  });
  Object.defineProperty(AddCampaignDTOBase.prototype, 'budget', {
    configurable: true,
    get: function () {
      return this._get_budget__2511517798_thtifu_k$();
    }
  });
  function AddedCampaignEvent() {
  }
  AddedCampaignEvent.$metadata$ = {
    simpleName: 'AddedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function AddedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  AddedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddedCampaignEventBase.$metadata$ = {
    simpleName: 'AddedCampaignEventBase',
    kind: 'class',
    interfaces: [AddedCampaignEvent]
  };
  Object.defineProperty(AddedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddedCampaignEventDTO() {
  }
  AddedCampaignEventDTO.$metadata$ = {
    simpleName: 'AddedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddedCampaignEventDTOBase(campaignId, projectId) {
    this.campaignId_1 = campaignId;
    this.projectId_1 = projectId;
  }
  AddedCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  AddedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  AddedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'AddedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [AddedCampaignEventDTO]
  };
  Object.defineProperty(AddedCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(AddedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function AddFunderCommand() {
  }
  AddFunderCommand.$metadata$ = {
    simpleName: 'AddFunderCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddFunderDetails() {
  }
  AddFunderDetails.$metadata$ = {
    simpleName: 'AddFunderDetails',
    kind: 'interface',
    interfaces: []
  };
  function AddFunderDetailsBase(projectId, projectFunder) {
    this.projectId_1 = projectId;
    this.projectFunder_1 = projectFunder;
  }
  AddFunderDetailsBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  AddFunderDetailsBase.prototype._get_projectFunder__834319238_dsqcue_k$ = function () {
    return this.projectFunder_1;
  };
  AddFunderDetailsBase.$metadata$ = {
    simpleName: 'AddFunderDetailsBase',
    kind: 'class',
    interfaces: [AddFunderDetails]
  };
  Object.defineProperty(AddFunderDetailsBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(AddFunderDetailsBase.prototype, 'projectFunder', {
    configurable: true,
    get: function () {
      return this._get_projectFunder__834319238_dsqcue_k$();
    }
  });
  function AddFunderCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddFunderCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddFunderCommandBase.$metadata$ = {
    simpleName: 'AddFunderCommandBase',
    kind: 'class',
    interfaces: [AddFunderCommand]
  };
  Object.defineProperty(AddFunderCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddFunderCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddedFunderEvent() {
  }
  AddedFunderEvent.$metadata$ = {
    simpleName: 'AddedFunderEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function AddedFunderEventBase(payload) {
    this.payload_1 = payload;
  }
  AddedFunderEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddedFunderEventBase.$metadata$ = {
    simpleName: 'AddedFunderEventBase',
    kind: 'class',
    interfaces: [AddedFunderEvent]
  };
  Object.defineProperty(AddedFunderEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddedFunderEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ArchiveCampaignCommand() {
  }
  ArchiveCampaignCommand.$metadata$ = {
    simpleName: 'ArchiveCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ArchiveCampaignDTO() {
  }
  ArchiveCampaignDTO.$metadata$ = {
    simpleName: 'ArchiveCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function ArchiveCampaignDTOBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  ArchiveCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  ArchiveCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  ArchiveCampaignDTOBase.$metadata$ = {
    simpleName: 'ArchiveCampaignDTOBase',
    kind: 'class',
    interfaces: [ArchiveCampaignDTO]
  };
  Object.defineProperty(ArchiveCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(ArchiveCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function ArchiveCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  ArchiveCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ArchiveCampaignCommandBase.$metadata$ = {
    simpleName: 'ArchiveCampaignCommandBase',
    kind: 'class',
    interfaces: [ArchiveCampaignCommand]
  };
  Object.defineProperty(ArchiveCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ArchiveCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ArchivedCampaignEvent() {
  }
  ArchivedCampaignEvent.$metadata$ = {
    simpleName: 'ArchivedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ArchivedCampaignEventDTO() {
  }
  ArchivedCampaignEventDTO.$metadata$ = {
    simpleName: 'ArchivedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ArchivedCampaignEventDTOBase(projectId, campaignId, projectStatus, campaignStatus) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.projectStatus_1 = projectStatus;
    this.campaignStatus_1 = campaignStatus;
  }
  ArchivedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  ArchivedCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  ArchivedCampaignEventDTOBase.prototype._get_projectStatus__3741789638_95cim2_k$ = function () {
    return this.projectStatus_1;
  };
  ArchivedCampaignEventDTOBase.prototype._get_campaignStatus__3829519657_7p45p3_k$ = function () {
    return this.campaignStatus_1;
  };
  ArchivedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'ArchivedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [ArchivedCampaignEventDTO]
  };
  Object.defineProperty(ArchivedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(ArchivedCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(ArchivedCampaignEventDTOBase.prototype, 'projectStatus', {
    configurable: true,
    get: function () {
      return this._get_projectStatus__3741789638_95cim2_k$();
    }
  });
  Object.defineProperty(ArchivedCampaignEventDTOBase.prototype, 'campaignStatus', {
    configurable: true,
    get: function () {
      return this._get_campaignStatus__3829519657_7p45p3_k$();
    }
  });
  function ArchivedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  ArchivedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ArchivedCampaignEventBase.$metadata$ = {
    simpleName: 'ArchivedCampaignEventBase',
    kind: 'class',
    interfaces: [ArchivedCampaignEvent]
  };
  Object.defineProperty(ArchivedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ArchivedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_CREATE_PROJECT__2430853653() {
    return CREATE_PROJECT;
  }
  var CREATE_PROJECT;
  function CreateProjectCommand() {
  }
  CreateProjectCommand.$metadata$ = {
    simpleName: 'CreateProjectCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateProjectCommandDTO() {
  }
  CreateProjectCommandDTO.$metadata$ = {
    simpleName: 'CreateProjectCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateProjectCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateProjectCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateProjectCommandBase.$metadata$ = {
    simpleName: 'CreateProjectCommandBase',
    kind: 'class',
    interfaces: [CreateProjectCommand]
  };
  Object.defineProperty(CreateProjectCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateProjectCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateProjectCommandDTOBase(details, projectFunders) {
    this.details_1 = details;
    this.projectFunders_1 = projectFunders;
  }
  CreateProjectCommandDTOBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  CreateProjectCommandDTOBase.prototype._get_projectFunders__94094307_1k0rmr_k$ = function () {
    return this.projectFunders_1;
  };
  CreateProjectCommandDTOBase.$metadata$ = {
    simpleName: 'CreateProjectCommandDTOBase',
    kind: 'class',
    interfaces: [CreateProjectCommandDTO]
  };
  Object.defineProperty(CreateProjectCommandDTOBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(CreateProjectCommandDTOBase.prototype, 'projectFunders', {
    configurable: true,
    get: function () {
      return this._get_projectFunders__94094307_1k0rmr_k$();
    }
  });
  function _get_CREATED_PROJECT_EVENT__846514420() {
    return CREATED_PROJECT_EVENT;
  }
  var CREATED_PROJECT_EVENT;
  function ProjectCreatedEvent() {
  }
  ProjectCreatedEvent.$metadata$ = {
    simpleName: 'ProjectCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ProjectCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  ProjectCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ProjectCreatedEventBase.$metadata$ = {
    simpleName: 'ProjectCreatedEventBase',
    kind: 'class',
    interfaces: [ProjectCreatedEvent]
  };
  Object.defineProperty(ProjectCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ProjectCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ProjectEventDetails() {
  }
  ProjectEventDetails.$metadata$ = {
    simpleName: 'ProjectEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function ProjectEventDetailsBase(id) {
    this.id_1 = id;
  }
  ProjectEventDetailsBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProjectEventDetailsBase.$metadata$ = {
    simpleName: 'ProjectEventDetailsBase',
    kind: 'class',
    interfaces: [ProjectEventDetails]
  };
  Object.defineProperty(ProjectEventDetailsBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function DuplicateCampaignCommand() {
  }
  DuplicateCampaignCommand.$metadata$ = {
    simpleName: 'DuplicateCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DuplicateCampaignDTO() {
  }
  DuplicateCampaignDTO.$metadata$ = {
    simpleName: 'DuplicateCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function DuplicateCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  DuplicateCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DuplicateCampaignCommandBase.$metadata$ = {
    simpleName: 'DuplicateCampaignCommandBase',
    kind: 'class',
    interfaces: [DuplicateCampaignCommand]
  };
  Object.defineProperty(DuplicateCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DuplicateCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DuplicateCampaignDTOBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  DuplicateCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  DuplicateCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  DuplicateCampaignDTOBase.$metadata$ = {
    simpleName: 'DuplicateCampaignDTOBase',
    kind: 'class',
    interfaces: [DuplicateCampaignDTO]
  };
  Object.defineProperty(DuplicateCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(DuplicateCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function DuplicatedCampaignEvent() {
  }
  DuplicatedCampaignEvent.$metadata$ = {
    simpleName: 'DuplicatedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DuplicatedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  DuplicatedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DuplicatedCampaignEventBase.$metadata$ = {
    simpleName: 'DuplicatedCampaignEventBase',
    kind: 'class',
    interfaces: [DuplicatedCampaignEvent]
  };
  Object.defineProperty(DuplicatedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DuplicatedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DuplicatedCampaignEventDTO() {
  }
  DuplicatedCampaignEventDTO.$metadata$ = {
    simpleName: 'DuplicatedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function DuplicatedCampaignEventDTOBase(refCampaignId, newCampaignId, projectId) {
    this.refCampaignId_1 = refCampaignId;
    this.newCampaignId_1 = newCampaignId;
    this.projectId_1 = projectId;
  }
  DuplicatedCampaignEventDTOBase.prototype._get_refCampaignId__3190446419_i9lprh_k$ = function () {
    return this.refCampaignId_1;
  };
  DuplicatedCampaignEventDTOBase.prototype._get_newCampaignId__3112119846_jk8ixm_k$ = function () {
    return this.newCampaignId_1;
  };
  DuplicatedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  DuplicatedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'DuplicatedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [DuplicatedCampaignEventDTO]
  };
  Object.defineProperty(DuplicatedCampaignEventDTOBase.prototype, 'refCampaignId', {
    configurable: true,
    get: function () {
      return this._get_refCampaignId__3190446419_i9lprh_k$();
    }
  });
  Object.defineProperty(DuplicatedCampaignEventDTOBase.prototype, 'newCampaignId', {
    configurable: true,
    get: function () {
      return this._get_newCampaignId__3112119846_jk8ixm_k$();
    }
  });
  Object.defineProperty(DuplicatedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function FinishCampaignCommand() {
  }
  FinishCampaignCommand.$metadata$ = {
    simpleName: 'FinishCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function FinishCampaignDTO() {
  }
  FinishCampaignDTO.$metadata$ = {
    simpleName: 'FinishCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function FinishCampaignDTOBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  FinishCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  FinishCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  FinishCampaignDTOBase.$metadata$ = {
    simpleName: 'FinishCampaignDTOBase',
    kind: 'class',
    interfaces: [FinishCampaignDTO]
  };
  Object.defineProperty(FinishCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(FinishCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function FinishCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  FinishCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  FinishCampaignCommandBase.$metadata$ = {
    simpleName: 'FinishCampaignCommandBase',
    kind: 'class',
    interfaces: [FinishCampaignCommand]
  };
  Object.defineProperty(FinishCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(FinishCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DoneCampaignEvent() {
  }
  DoneCampaignEvent.$metadata$ = {
    simpleName: 'DoneCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DoneCampaignEventDTO() {
  }
  DoneCampaignEventDTO.$metadata$ = {
    simpleName: 'DoneCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function DoneCampaignEventDTOBase(projectId, campaignId, projectStatus, campaignStatus) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.projectStatus_1 = projectStatus;
    this.campaignStatus_1 = campaignStatus;
  }
  DoneCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  DoneCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  DoneCampaignEventDTOBase.prototype._get_projectStatus__3741789638_95cim2_k$ = function () {
    return this.projectStatus_1;
  };
  DoneCampaignEventDTOBase.prototype._get_campaignStatus__3829519657_7p45p3_k$ = function () {
    return this.campaignStatus_1;
  };
  DoneCampaignEventDTOBase.$metadata$ = {
    simpleName: 'DoneCampaignEventDTOBase',
    kind: 'class',
    interfaces: [DoneCampaignEventDTO]
  };
  Object.defineProperty(DoneCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(DoneCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(DoneCampaignEventDTOBase.prototype, 'projectStatus', {
    configurable: true,
    get: function () {
      return this._get_projectStatus__3741789638_95cim2_k$();
    }
  });
  Object.defineProperty(DoneCampaignEventDTOBase.prototype, 'campaignStatus', {
    configurable: true,
    get: function () {
      return this._get_campaignStatus__3829519657_7p45p3_k$();
    }
  });
  function DoneCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  DoneCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DoneCampaignEventBase.$metadata$ = {
    simpleName: 'DoneCampaignEventBase',
    kind: 'class',
    interfaces: [DoneCampaignEvent]
  };
  Object.defineProperty(DoneCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DoneCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function _get_FINISH_PROJECT__2513047646() {
    return FINISH_PROJECT;
  }
  var FINISH_PROJECT;
  function FinishProjectCommand() {
  }
  FinishProjectCommand.$metadata$ = {
    simpleName: 'FinishProjectCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function FinishProjectCommandDTO() {
  }
  FinishProjectCommandDTO.$metadata$ = {
    simpleName: 'FinishProjectCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function FinishProjectCommandBase(payload) {
    this.payload_1 = payload;
  }
  FinishProjectCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  FinishProjectCommandBase.$metadata$ = {
    simpleName: 'FinishProjectCommandBase',
    kind: 'class',
    interfaces: [FinishProjectCommand]
  };
  Object.defineProperty(FinishProjectCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(FinishProjectCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function FinishProjectCommandDTOBase(projectId) {
    this.projectId_1 = projectId;
  }
  FinishProjectCommandDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  FinishProjectCommandDTOBase.$metadata$ = {
    simpleName: 'FinishProjectCommandDTOBase',
    kind: 'class',
    interfaces: [FinishProjectCommandDTO]
  };
  Object.defineProperty(FinishProjectCommandDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function _get_PROJECT_DONE_EVENT__1769888616() {
    return PROJECT_DONE_EVENT;
  }
  var PROJECT_DONE_EVENT;
  function ProjectDoneEvent() {
  }
  ProjectDoneEvent.$metadata$ = {
    simpleName: 'ProjectDoneEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ProjectDoneEventBase(payload) {
    this.payload_1 = payload;
  }
  ProjectDoneEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ProjectDoneEventBase.$metadata$ = {
    simpleName: 'ProjectDoneEventBase',
    kind: 'class',
    interfaces: [ProjectDoneEvent]
  };
  Object.defineProperty(ProjectDoneEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ProjectDoneEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ProjectDoneEventDTO() {
  }
  ProjectDoneEventDTO.$metadata$ = {
    simpleName: 'ProjectDoneEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectDoneEventDTOBase(projectId, projectStatus) {
    this.projectId_1 = projectId;
    this.projectStatus_1 = projectStatus;
  }
  ProjectDoneEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  ProjectDoneEventDTOBase.prototype._get_projectStatus__3741789638_95cim2_k$ = function () {
    return this.projectStatus_1;
  };
  ProjectDoneEventDTOBase.$metadata$ = {
    simpleName: 'ProjectDoneEventDTOBase',
    kind: 'class',
    interfaces: [ProjectDoneEventDTO]
  };
  Object.defineProperty(ProjectDoneEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(ProjectDoneEventDTOBase.prototype, 'projectStatus', {
    configurable: true,
    get: function () {
      return this._get_projectStatus__3741789638_95cim2_k$();
    }
  });
  function PauseCampaignCommand() {
  }
  PauseCampaignCommand.$metadata$ = {
    simpleName: 'PauseCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function PauseCampaignDTO() {
  }
  PauseCampaignDTO.$metadata$ = {
    simpleName: 'PauseCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function PauseCampaignDTOBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  PauseCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  PauseCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  PauseCampaignDTOBase.$metadata$ = {
    simpleName: 'PauseCampaignDTOBase',
    kind: 'class',
    interfaces: [PauseCampaignDTO]
  };
  Object.defineProperty(PauseCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(PauseCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function PauseCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  PauseCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PauseCampaignCommandBase.$metadata$ = {
    simpleName: 'PauseCampaignCommandBase',
    kind: 'class',
    interfaces: [PauseCampaignCommand]
  };
  Object.defineProperty(PauseCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PauseCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PausedCampaignEvent() {
  }
  PausedCampaignEvent.$metadata$ = {
    simpleName: 'PausedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function PausedCampaignEventDTO() {
  }
  PausedCampaignEventDTO.$metadata$ = {
    simpleName: 'PausedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function PausedCampaignEventDTOBase(projectId, campaignId, projectStatus, campaignStatus) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.projectStatus_1 = projectStatus;
    this.campaignStatus_1 = campaignStatus;
  }
  PausedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  PausedCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  PausedCampaignEventDTOBase.prototype._get_projectStatus__3741789638_95cim2_k$ = function () {
    return this.projectStatus_1;
  };
  PausedCampaignEventDTOBase.prototype._get_campaignStatus__3829519657_7p45p3_k$ = function () {
    return this.campaignStatus_1;
  };
  PausedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'PausedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [PausedCampaignEventDTO]
  };
  Object.defineProperty(PausedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(PausedCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(PausedCampaignEventDTOBase.prototype, 'projectStatus', {
    configurable: true,
    get: function () {
      return this._get_projectStatus__3741789638_95cim2_k$();
    }
  });
  Object.defineProperty(PausedCampaignEventDTOBase.prototype, 'campaignStatus', {
    configurable: true,
    get: function () {
      return this._get_campaignStatus__3829519657_7p45p3_k$();
    }
  });
  function PausedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  PausedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PausedCampaignEventBase.$metadata$ = {
    simpleName: 'PausedCampaignEventBase',
    kind: 'class',
    interfaces: [PausedCampaignEvent]
  };
  Object.defineProperty(PausedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PausedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PublishCampaignCommand() {
  }
  PublishCampaignCommand.$metadata$ = {
    simpleName: 'PublishCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function PublishCampaignDTO() {
  }
  PublishCampaignDTO.$metadata$ = {
    simpleName: 'PublishCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function PublishCampaignDTOBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  PublishCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  PublishCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  PublishCampaignDTOBase.$metadata$ = {
    simpleName: 'PublishCampaignDTOBase',
    kind: 'class',
    interfaces: [PublishCampaignDTO]
  };
  Object.defineProperty(PublishCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(PublishCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function PublishCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  PublishCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PublishCampaignCommandBase.$metadata$ = {
    simpleName: 'PublishCampaignCommandBase',
    kind: 'class',
    interfaces: [PublishCampaignCommand]
  };
  Object.defineProperty(PublishCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PublishCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PublishedCampaignEvent() {
  }
  PublishedCampaignEvent.$metadata$ = {
    simpleName: 'PublishedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function PublishedCampaignEventDTO() {
  }
  PublishedCampaignEventDTO.$metadata$ = {
    simpleName: 'PublishedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function PublishedCampaignEventDTOBase(projectId, campaignId, projectStatus, campaignStatus) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.projectStatus_1 = projectStatus;
    this.campaignStatus_1 = campaignStatus;
  }
  PublishedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  PublishedCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  PublishedCampaignEventDTOBase.prototype._get_projectStatus__3741789638_95cim2_k$ = function () {
    return this.projectStatus_1;
  };
  PublishedCampaignEventDTOBase.prototype._get_campaignStatus__3829519657_7p45p3_k$ = function () {
    return this.campaignStatus_1;
  };
  PublishedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'PublishedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [PublishedCampaignEventDTO]
  };
  Object.defineProperty(PublishedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(PublishedCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(PublishedCampaignEventDTOBase.prototype, 'projectStatus', {
    configurable: true,
    get: function () {
      return this._get_projectStatus__3741789638_95cim2_k$();
    }
  });
  Object.defineProperty(PublishedCampaignEventDTOBase.prototype, 'campaignStatus', {
    configurable: true,
    get: function () {
      return this._get_campaignStatus__3829519657_7p45p3_k$();
    }
  });
  function PublishedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  PublishedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PublishedCampaignEventBase.$metadata$ = {
    simpleName: 'PublishedCampaignEventBase',
    kind: 'class',
    interfaces: [PublishedCampaignEvent]
  };
  Object.defineProperty(PublishedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PublishedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function RemoveCampaignCommand() {
  }
  RemoveCampaignCommand.$metadata$ = {
    simpleName: 'RemoveCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function RemoveCampaignCommandDetails() {
  }
  RemoveCampaignCommandDetails.$metadata$ = {
    simpleName: 'RemoveCampaignCommandDetails',
    kind: 'interface',
    interfaces: []
  };
  function RemoveCampaignCommandDetailsBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  RemoveCampaignCommandDetailsBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  RemoveCampaignCommandDetailsBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  RemoveCampaignCommandDetailsBase.$metadata$ = {
    simpleName: 'RemoveCampaignCommandDetailsBase',
    kind: 'class',
    interfaces: [RemoveCampaignCommandDetails]
  };
  Object.defineProperty(RemoveCampaignCommandDetailsBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(RemoveCampaignCommandDetailsBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function RemoveCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  RemoveCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  RemoveCampaignCommandBase.$metadata$ = {
    simpleName: 'RemoveCampaignCommandBase',
    kind: 'class',
    interfaces: [RemoveCampaignCommand]
  };
  Object.defineProperty(RemoveCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(RemoveCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function RemovedCampaignEvent() {
  }
  RemovedCampaignEvent.$metadata$ = {
    simpleName: 'RemovedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function RemovedCampaignEventDetails() {
  }
  RemovedCampaignEventDetails.$metadata$ = {
    simpleName: 'RemovedCampaignEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function RemovedCampaignEventDetailsBase(campaignId, projectId) {
    this.campaignId_1 = campaignId;
    this.projectId_1 = projectId;
  }
  RemovedCampaignEventDetailsBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  RemovedCampaignEventDetailsBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  RemovedCampaignEventDetailsBase.$metadata$ = {
    simpleName: 'RemovedCampaignEventDetailsBase',
    kind: 'class',
    interfaces: [RemovedCampaignEventDetails]
  };
  Object.defineProperty(RemovedCampaignEventDetailsBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(RemovedCampaignEventDetailsBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function RemovedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  RemovedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  RemovedCampaignEventBase.$metadata$ = {
    simpleName: 'RemovedCampaignEventBase',
    kind: 'class',
    interfaces: [RemovedCampaignEvent]
  };
  Object.defineProperty(RemovedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(RemovedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function StartCampaignCommand() {
  }
  StartCampaignCommand.$metadata$ = {
    simpleName: 'StartCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function StartCampaignDTO() {
  }
  StartCampaignDTO.$metadata$ = {
    simpleName: 'StartCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function StartCampaignDTOBase(projectId, campaignId) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
  }
  StartCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  StartCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  StartCampaignDTOBase.$metadata$ = {
    simpleName: 'StartCampaignDTOBase',
    kind: 'class',
    interfaces: [StartCampaignDTO]
  };
  Object.defineProperty(StartCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(StartCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  function StartCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  StartCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  StartCampaignCommandBase.$metadata$ = {
    simpleName: 'StartCampaignCommandBase',
    kind: 'class',
    interfaces: [StartCampaignCommand]
  };
  Object.defineProperty(StartCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(StartCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function StartedCampaignEvent() {
  }
  StartedCampaignEvent.$metadata$ = {
    simpleName: 'StartedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function StartedCampaignEventDTO() {
  }
  StartedCampaignEventDTO.$metadata$ = {
    simpleName: 'StartedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function StartedCampaignEventDTOBase(projectId, campaignId, projectStatus, campaignStatus) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.projectStatus_1 = projectStatus;
    this.campaignStatus_1 = campaignStatus;
  }
  StartedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  StartedCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  StartedCampaignEventDTOBase.prototype._get_projectStatus__3741789638_95cim2_k$ = function () {
    return this.projectStatus_1;
  };
  StartedCampaignEventDTOBase.prototype._get_campaignStatus__3829519657_7p45p3_k$ = function () {
    return this.campaignStatus_1;
  };
  StartedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'StartedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [StartedCampaignEventDTO]
  };
  Object.defineProperty(StartedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(StartedCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(StartedCampaignEventDTOBase.prototype, 'projectStatus', {
    configurable: true,
    get: function () {
      return this._get_projectStatus__3741789638_95cim2_k$();
    }
  });
  Object.defineProperty(StartedCampaignEventDTOBase.prototype, 'campaignStatus', {
    configurable: true,
    get: function () {
      return this._get_campaignStatus__3829519657_7p45p3_k$();
    }
  });
  function StartedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  StartedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  StartedCampaignEventBase.$metadata$ = {
    simpleName: 'StartedCampaignEventBase',
    kind: 'class',
    interfaces: [StartedCampaignEvent]
  };
  Object.defineProperty(StartedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(StartedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateCampaignCommand() {
  }
  UpdateCampaignCommand.$metadata$ = {
    simpleName: 'UpdateCampaignCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateCampaignDTO() {
  }
  UpdateCampaignDTO.$metadata$ = {
    simpleName: 'UpdateCampaignDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateCampaignCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateCampaignCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateCampaignCommandBase.$metadata$ = {
    simpleName: 'UpdateCampaignCommandBase',
    kind: 'class',
    interfaces: [UpdateCampaignCommand]
  };
  Object.defineProperty(UpdateCampaignCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateCampaignCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateCampaignDTOBase(projectId, campaignId, campaignDetails, bonusPrices, funders, budget) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.campaignDetails_1 = campaignDetails;
    this.bonusPrices_1 = bonusPrices;
    this.funders_1 = funders;
    this.budget_1 = budget;
  }
  UpdateCampaignDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdateCampaignDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  UpdateCampaignDTOBase.prototype._get_campaignDetails__2477032255_u2cnnl_k$ = function () {
    return this.campaignDetails_1;
  };
  UpdateCampaignDTOBase.prototype._get_bonusPrices__2570137960_six2u0_k$ = function () {
    return this.bonusPrices_1;
  };
  UpdateCampaignDTOBase.prototype._get_funders__3507435184_d0vjo0_k$ = function () {
    return this.funders_1;
  };
  UpdateCampaignDTOBase.prototype._get_budget__2511517798_thtifu_k$ = function () {
    return this.budget_1;
  };
  UpdateCampaignDTOBase.$metadata$ = {
    simpleName: 'UpdateCampaignDTOBase',
    kind: 'class',
    interfaces: [UpdateCampaignDTO]
  };
  Object.defineProperty(UpdateCampaignDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(UpdateCampaignDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(UpdateCampaignDTOBase.prototype, 'campaignDetails', {
    configurable: true,
    get: function () {
      return this._get_campaignDetails__2477032255_u2cnnl_k$();
    }
  });
  Object.defineProperty(UpdateCampaignDTOBase.prototype, 'bonusPrices', {
    configurable: true,
    get: function () {
      return this._get_bonusPrices__2570137960_six2u0_k$();
    }
  });
  Object.defineProperty(UpdateCampaignDTOBase.prototype, 'funders', {
    configurable: true,
    get: function () {
      return this._get_funders__3507435184_d0vjo0_k$();
    }
  });
  Object.defineProperty(UpdateCampaignDTOBase.prototype, 'budget', {
    configurable: true,
    get: function () {
      return this._get_budget__2511517798_thtifu_k$();
    }
  });
  function UpdatedCampaignEvent() {
  }
  UpdatedCampaignEvent.$metadata$ = {
    simpleName: 'UpdatedCampaignEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UpdatedCampaignEventBase(payload) {
    this.payload_1 = payload;
  }
  UpdatedCampaignEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdatedCampaignEventBase.$metadata$ = {
    simpleName: 'UpdatedCampaignEventBase',
    kind: 'class',
    interfaces: [UpdatedCampaignEvent]
  };
  Object.defineProperty(UpdatedCampaignEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdatedCampaignEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdatedCampaignEventDTO() {
  }
  UpdatedCampaignEventDTO.$metadata$ = {
    simpleName: 'UpdatedCampaignEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdatedCampaignEventDTOBase(campaignId, projectId) {
    this.campaignId_1 = campaignId;
    this.projectId_1 = projectId;
  }
  UpdatedCampaignEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  UpdatedCampaignEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdatedCampaignEventDTOBase.$metadata$ = {
    simpleName: 'UpdatedCampaignEventDTOBase',
    kind: 'class',
    interfaces: [UpdatedCampaignEventDTO]
  };
  Object.defineProperty(UpdatedCampaignEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(UpdatedCampaignEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function UpdateCampaignMissingBudgetCommand() {
  }
  UpdateCampaignMissingBudgetCommand.$metadata$ = {
    simpleName: 'UpdateCampaignMissingBudgetCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateCampaignMissingBudgetDTO() {
  }
  UpdateCampaignMissingBudgetDTO.$metadata$ = {
    simpleName: 'UpdateCampaignMissingBudgetDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateCampaignMissingBudgetCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateCampaignMissingBudgetCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateCampaignMissingBudgetCommandBase.$metadata$ = {
    simpleName: 'UpdateCampaignMissingBudgetCommandBase',
    kind: 'class',
    interfaces: [UpdateCampaignMissingBudgetCommand]
  };
  Object.defineProperty(UpdateCampaignMissingBudgetCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateCampaignMissingBudgetCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateCampaignMissingBudgetDTOBase(projectId, campaignId, missingBudget) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.missingBudget_1 = missingBudget;
  }
  UpdateCampaignMissingBudgetDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdateCampaignMissingBudgetDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  UpdateCampaignMissingBudgetDTOBase.prototype._get_missingBudget__2581184998_sccavu_k$ = function () {
    return this.missingBudget_1;
  };
  UpdateCampaignMissingBudgetDTOBase.$metadata$ = {
    simpleName: 'UpdateCampaignMissingBudgetDTOBase',
    kind: 'class',
    interfaces: [UpdateCampaignMissingBudgetDTO]
  };
  Object.defineProperty(UpdateCampaignMissingBudgetDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(UpdateCampaignMissingBudgetDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(UpdateCampaignMissingBudgetDTOBase.prototype, 'missingBudget', {
    configurable: true,
    get: function () {
      return this._get_missingBudget__2581184998_sccavu_k$();
    }
  });
  function UpdatedCampaignMissingBudgetEvent() {
  }
  UpdatedCampaignMissingBudgetEvent.$metadata$ = {
    simpleName: 'UpdatedCampaignMissingBudgetEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UpdatedCampaignMissingBudgetEventBase(payload) {
    this.payload_1 = payload;
  }
  UpdatedCampaignMissingBudgetEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdatedCampaignMissingBudgetEventBase.$metadata$ = {
    simpleName: 'UpdatedCampaignMissingBudgetEventBase',
    kind: 'class',
    interfaces: [UpdatedCampaignMissingBudgetEvent]
  };
  Object.defineProperty(UpdatedCampaignMissingBudgetEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdatedCampaignMissingBudgetEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdatedCampaignMissingBudgetEventDTO() {
  }
  UpdatedCampaignMissingBudgetEventDTO.$metadata$ = {
    simpleName: 'UpdatedCampaignMissingBudgetEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdatedCampaignMissingBudgetEventDTOBase(campaignId, projectId) {
    this.campaignId_1 = campaignId;
    this.projectId_1 = projectId;
  }
  UpdatedCampaignMissingBudgetEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  UpdatedCampaignMissingBudgetEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdatedCampaignMissingBudgetEventDTOBase.$metadata$ = {
    simpleName: 'UpdatedCampaignMissingBudgetEventDTOBase',
    kind: 'class',
    interfaces: [UpdatedCampaignMissingBudgetEventDTO]
  };
  Object.defineProperty(UpdatedCampaignMissingBudgetEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(UpdatedCampaignMissingBudgetEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function UpdateCampaignNotificationCommand() {
  }
  UpdateCampaignNotificationCommand.$metadata$ = {
    simpleName: 'UpdateCampaignNotificationCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateCampaignNotificationDTO() {
  }
  UpdateCampaignNotificationDTO.$metadata$ = {
    simpleName: 'UpdateCampaignNotificationDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateCampaignNotificationCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateCampaignNotificationCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateCampaignNotificationCommandBase.$metadata$ = {
    simpleName: 'UpdateCampaignNotificationCommandBase',
    kind: 'class',
    interfaces: [UpdateCampaignNotificationCommand]
  };
  Object.defineProperty(UpdateCampaignNotificationCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateCampaignNotificationCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateCampaignNotificationDTOBase(projectId, campaignId, sendExpiringNotification) {
    this.projectId_1 = projectId;
    this.campaignId_1 = campaignId;
    this.sendExpiringNotification_1 = sendExpiringNotification;
  }
  UpdateCampaignNotificationDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdateCampaignNotificationDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  UpdateCampaignNotificationDTOBase.prototype._get_sendExpiringNotification__1305120476_ll19ek_k$ = function () {
    return this.sendExpiringNotification_1;
  };
  UpdateCampaignNotificationDTOBase.$metadata$ = {
    simpleName: 'UpdateCampaignNotificationDTOBase',
    kind: 'class',
    interfaces: [UpdateCampaignNotificationDTO]
  };
  Object.defineProperty(UpdateCampaignNotificationDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(UpdateCampaignNotificationDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(UpdateCampaignNotificationDTOBase.prototype, 'sendExpiringNotification', {
    configurable: true,
    get: function () {
      return this._get_sendExpiringNotification__1305120476_ll19ek_k$();
    }
  });
  function UpdatedCampaignNotificationEvent() {
  }
  UpdatedCampaignNotificationEvent.$metadata$ = {
    simpleName: 'UpdatedCampaignNotificationEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function UpdatedCampaignNotificationEventBase(payload) {
    this.payload_1 = payload;
  }
  UpdatedCampaignNotificationEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdatedCampaignNotificationEventBase.$metadata$ = {
    simpleName: 'UpdatedCampaignNotificationEventBase',
    kind: 'class',
    interfaces: [UpdatedCampaignNotificationEvent]
  };
  Object.defineProperty(UpdatedCampaignNotificationEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdatedCampaignNotificationEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdatedCampaignNotificationEventDTO() {
  }
  UpdatedCampaignNotificationEventDTO.$metadata$ = {
    simpleName: 'UpdatedCampaignNotificationEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdatedCampaignNotificationEventDTOBase(campaignId, projectId) {
    this.campaignId_1 = campaignId;
    this.projectId_1 = projectId;
  }
  UpdatedCampaignNotificationEventDTOBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  UpdatedCampaignNotificationEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdatedCampaignNotificationEventDTOBase.$metadata$ = {
    simpleName: 'UpdatedCampaignNotificationEventDTOBase',
    kind: 'class',
    interfaces: [UpdatedCampaignNotificationEventDTO]
  };
  Object.defineProperty(UpdatedCampaignNotificationEventDTOBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(UpdatedCampaignNotificationEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function _get_UPDATE_PROJECT__806535400() {
    return UPDATE_PROJECT;
  }
  var UPDATE_PROJECT;
  function UpdateProjectCommand() {
  }
  UpdateProjectCommand.$metadata$ = {
    simpleName: 'UpdateProjectCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateProjectCommandDTO() {
  }
  UpdateProjectCommandDTO.$metadata$ = {
    simpleName: 'UpdateProjectCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateProjectCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateProjectCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateProjectCommandBase.$metadata$ = {
    simpleName: 'UpdateProjectCommandBase',
    kind: 'class',
    interfaces: [UpdateProjectCommand]
  };
  Object.defineProperty(UpdateProjectCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateProjectCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateProjectCommandDTOBase(projectId, details, projectFunders) {
    this.projectId_1 = projectId;
    this.details_1 = details;
    this.projectFunders_1 = projectFunders;
  }
  UpdateProjectCommandDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  UpdateProjectCommandDTOBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  UpdateProjectCommandDTOBase.prototype._get_projectFunders__94094307_1k0rmr_k$ = function () {
    return this.projectFunders_1;
  };
  UpdateProjectCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateProjectCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateProjectCommandDTO]
  };
  Object.defineProperty(UpdateProjectCommandDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(UpdateProjectCommandDTOBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(UpdateProjectCommandDTOBase.prototype, 'projectFunders', {
    configurable: true,
    get: function () {
      return this._get_projectFunders__94094307_1k0rmr_k$();
    }
  });
  function _get_UPDATED_PROJECT_EVENT__2802329281() {
    return UPDATED_PROJECT_EVENT;
  }
  var UPDATED_PROJECT_EVENT;
  function ProjectUpdatedEvent() {
  }
  ProjectUpdatedEvent.$metadata$ = {
    simpleName: 'ProjectUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function ProjectUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  ProjectUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ProjectUpdatedEventBase.$metadata$ = {
    simpleName: 'ProjectUpdatedEventBase',
    kind: 'class',
    interfaces: [ProjectUpdatedEvent]
  };
  Object.defineProperty(ProjectUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ProjectUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ProjectUpdatedEventDTO() {
  }
  ProjectUpdatedEventDTO.$metadata$ = {
    simpleName: 'ProjectUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectUpdatedEventDTOBase(projectId) {
    this.projectId_1 = projectId;
  }
  ProjectUpdatedEventDTOBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  ProjectUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'ProjectUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [ProjectUpdatedEventDTO]
  };
  Object.defineProperty(ProjectUpdatedEventDTOBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  function GetCampaignFilter() {
  }
  GetCampaignFilter.$metadata$ = {
    simpleName: 'GetCampaignFilter',
    kind: 'interface',
    interfaces: []
  };
  function GetCampaignFilterBase(operatorId, territoryCode, period, status) {
    this.operatorId_1 = operatorId;
    this.territoryCode_1 = territoryCode;
    this.period_1 = period;
    this.status_1 = status;
  }
  GetCampaignFilterBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  GetCampaignFilterBase.prototype._get_territoryCode__421324938_6yugei_k$ = function () {
    return this.territoryCode_1;
  };
  GetCampaignFilterBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  GetCampaignFilterBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  GetCampaignFilterBase.$metadata$ = {
    simpleName: 'GetCampaignFilterBase',
    kind: 'class',
    interfaces: [GetCampaignFilter]
  };
  Object.defineProperty(GetCampaignFilterBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(GetCampaignFilterBase.prototype, 'territoryCode', {
    configurable: true,
    get: function () {
      return this._get_territoryCode__421324938_6yugei_k$();
    }
  });
  Object.defineProperty(GetCampaignFilterBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(GetCampaignFilterBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  function ProjectRef() {
  }
  ProjectRef.$metadata$ = {
    simpleName: 'ProjectRef',
    kind: 'interface',
    interfaces: []
  };
  function ProjectRefBase(projectId, displayName) {
    this.projectId_1 = projectId;
    this.displayName_1 = displayName;
  }
  ProjectRefBase.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  ProjectRefBase.prototype._get_displayName__3253186756_h88z0c_k$ = function () {
    return this.displayName_1;
  };
  ProjectRefBase.$metadata$ = {
    simpleName: 'ProjectRefBase',
    kind: 'class',
    interfaces: [ProjectRef]
  };
  Object.defineProperty(ProjectRefBase.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(ProjectRefBase.prototype, 'displayName', {
    configurable: true,
    get: function () {
      return this._get_displayName__3253186756_h88z0c_k$();
    }
  });
  function CarrierRef() {
  }
  CarrierRef.$metadata$ = {
    simpleName: 'CarrierRef',
    kind: 'interface',
    interfaces: []
  };
  function CarrierRefBase(id, name) {
    this.id_1 = id;
    this.name_1 = name;
  }
  CarrierRefBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  CarrierRefBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  CarrierRefBase.$metadata$ = {
    simpleName: 'CarrierRefBase',
    kind: 'class',
    interfaces: [CarrierRef]
  };
  Object.defineProperty(CarrierRefBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(CarrierRefBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  function Delivery() {
  }
  Delivery.$metadata$ = {
    simpleName: 'Delivery',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryBase(id, transactionId, packages, stamp) {
    this.id_1 = id;
    this.transactionId_1 = transactionId;
    this.packages_1 = packages;
    this.stamp_1 = stamp;
  }
  DeliveryBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  DeliveryBase.prototype._get_transactionId__1535879000_pef7tk_k$ = function () {
    return this.transactionId_1;
  };
  DeliveryBase.prototype._get_packages__3283896446_gpyr9e_k$ = function () {
    return this.packages_1;
  };
  DeliveryBase.prototype._get_stamp__3614746734_b8zhjm_k$ = function () {
    return this.stamp_1;
  };
  DeliveryBase.$metadata$ = {
    simpleName: 'DeliveryBase',
    kind: 'class',
    interfaces: [Delivery]
  };
  Object.defineProperty(DeliveryBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(DeliveryBase.prototype, 'transactionId', {
    configurable: true,
    get: function () {
      return this._get_transactionId__1535879000_pef7tk_k$();
    }
  });
  Object.defineProperty(DeliveryBase.prototype, 'packages', {
    configurable: true,
    get: function () {
      return this._get_packages__3283896446_gpyr9e_k$();
    }
  });
  Object.defineProperty(DeliveryBase.prototype, 'stamp', {
    configurable: true,
    get: function () {
      return this._get_stamp__3614746734_b8zhjm_k$();
    }
  });
  function DeliveryAiResults() {
  }
  DeliveryAiResults.$metadata$ = {
    simpleName: 'DeliveryAiResults',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryAiResultsBase(algorithmVersion, predictions) {
    this.algorithmVersion_1 = algorithmVersion;
    this.predictions_1 = predictions;
  }
  DeliveryAiResultsBase.prototype._get_algorithmVersion__1296489090_lfw9du_k$ = function () {
    return this.algorithmVersion_1;
  };
  DeliveryAiResultsBase.prototype._get_predictions__909109325_f19d8t_k$ = function () {
    return this.predictions_1;
  };
  DeliveryAiResultsBase.$metadata$ = {
    simpleName: 'DeliveryAiResultsBase',
    kind: 'class',
    interfaces: [DeliveryAiResults]
  };
  Object.defineProperty(DeliveryAiResultsBase.prototype, 'algorithmVersion', {
    configurable: true,
    get: function () {
      return this._get_algorithmVersion__1296489090_lfw9du_k$();
    }
  });
  Object.defineProperty(DeliveryAiResultsBase.prototype, 'predictions', {
    configurable: true,
    get: function () {
      return this._get_predictions__909109325_f19d8t_k$();
    }
  });
  function DeliveryCsvAnalysisQuery() {
  }
  DeliveryCsvAnalysisQuery.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisQuery',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvAnalysisQueryBase_init_$Init$(uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      uploadPeriodStart = null;
    if (!(($mask0 & 2) === 0))
      uploadPeriodEnd = null;
    if (!(($mask0 & 4) === 0))
      contentPeriodStart = null;
    if (!(($mask0 & 8) === 0))
      contentPeriodEnd = null;
    if (!(($mask0 & 16) === 0))
      importerIds = emptyList();
    if (!(($mask0 & 32) === 0))
      operatorIds = emptyList();
    if (!(($mask0 & 64) === 0))
      carrierIds = emptyList();
    if (!(($mask0 & 128) === 0))
      territoryCodes = emptyList();
    if (!(($mask0 & 256) === 0))
      source = null;
    if (!(($mask0 & 512) === 0))
      successOnly = true;
    if (!(($mask0 & 1024) === 0))
      page = 0;
    if (!(($mask0 & 2048) === 0))
      size = 50;
    DeliveryCsvAnalysisQueryBase.call($this, uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size);
    return $this;
  }
  function DeliveryCsvAnalysisQueryBase_init_$Create$(uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size, $mask0, $marker) {
    return DeliveryCsvAnalysisQueryBase_init_$Init$(uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size, $mask0, $marker, Object.create(DeliveryCsvAnalysisQueryBase.prototype));
  }
  function DeliveryCsvAnalysisQueryBase(uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size) {
    var uploadPeriodStart_0 = uploadPeriodStart === void 1 ? null : uploadPeriodStart;
    var uploadPeriodEnd_0 = uploadPeriodEnd === void 1 ? null : uploadPeriodEnd;
    var contentPeriodStart_0 = contentPeriodStart === void 1 ? null : contentPeriodStart;
    var contentPeriodEnd_0 = contentPeriodEnd === void 1 ? null : contentPeriodEnd;
    var importerIds_0 = importerIds === void 1 ? emptyList() : importerIds;
    var operatorIds_0 = operatorIds === void 1 ? emptyList() : operatorIds;
    var carrierIds_0 = carrierIds === void 1 ? emptyList() : carrierIds;
    var territoryCodes_0 = territoryCodes === void 1 ? emptyList() : territoryCodes;
    var source_0 = source === void 1 ? null : source;
    var successOnly_0 = successOnly === void 1 ? true : successOnly;
    var page_0 = page === void 1 ? 0 : page;
    var size_0 = size === void 1 ? 50 : size;
    this.uploadPeriodStart_1 = uploadPeriodStart_0;
    this.uploadPeriodEnd_1 = uploadPeriodEnd_0;
    this.contentPeriodStart_1 = contentPeriodStart_0;
    this.contentPeriodEnd_1 = contentPeriodEnd_0;
    this.importerIds_1 = importerIds_0;
    this.operatorIds_1 = operatorIds_0;
    this.carrierIds_1 = carrierIds_0;
    this.territoryCodes_1 = territoryCodes_0;
    this.source_1 = source_0;
    this.successOnly_1 = successOnly_0;
    this.page_1 = page_0;
    this.size_1 = size_0;
  }
  DeliveryCsvAnalysisQueryBase.prototype._get_uploadPeriodStart__2688134385_qko07j_k$ = function () {
    return this.uploadPeriodStart_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_uploadPeriodEnd__1200138456_juj4rc_k$ = function () {
    return this.uploadPeriodEnd_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_contentPeriodStart__2828428195_o950t9_k$ = function () {
    return this.contentPeriodStart_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_contentPeriodEnd__480732170_7y7rbe_k$ = function () {
    return this.contentPeriodEnd_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_importerIds__117358603_1xveh7_k$ = function () {
    return this.importerIds_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_operatorIds__1553507485_pox21p_k$ = function () {
    return this.operatorIds_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_carrierIds__1640409067_r4nnqj_k$ = function () {
    return this.carrierIds_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_territoryCodes__176172895_2wvzvj_k$ = function () {
    return this.territoryCodes_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_source__263461456_4cuw5s_k$ = function () {
    return this.source_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_successOnly__987162914_gbqbs2_k$ = function () {
    return this.successOnly_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_page__806010268_dbvli4_k$ = function () {
    return this.page_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.size_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component1 = function () {
    return this.uploadPeriodStart_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component2 = function () {
    return this.uploadPeriodEnd_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component3 = function () {
    return this.contentPeriodStart_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component4 = function () {
    return this.contentPeriodEnd_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component5 = function () {
    return this.importerIds_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component6 = function () {
    return this.operatorIds_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component7 = function () {
    return this.carrierIds_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component8 = function () {
    return this.territoryCodes_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component9 = function () {
    return this.source_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component10 = function () {
    return this.successOnly_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component11 = function () {
    return this.page_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.component12 = function () {
    return this.size_1;
  };
  DeliveryCsvAnalysisQueryBase.prototype.copy = function (uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size) {
    return this.copy_5ris5r_k$(uploadPeriodStart === void 1 ? this.uploadPeriodStart_1 : uploadPeriodStart, uploadPeriodEnd === void 1 ? this.uploadPeriodEnd_1 : uploadPeriodEnd, contentPeriodStart === void 1 ? this.contentPeriodStart_1 : contentPeriodStart, contentPeriodEnd === void 1 ? this.contentPeriodEnd_1 : contentPeriodEnd, importerIds === void 1 ? this.importerIds_1 : importerIds, operatorIds === void 1 ? this.operatorIds_1 : operatorIds, carrierIds === void 1 ? this.carrierIds_1 : carrierIds, territoryCodes === void 1 ? this.territoryCodes_1 : territoryCodes, source === void 1 ? this.source_1 : source, successOnly === void 1 ? this.successOnly_1 : successOnly, page === void 1 ? this.page_1 : page, size === void 1 ? this.size_1 : size);
  };
  DeliveryCsvAnalysisQueryBase.prototype.copy_5ris5r_k$ = function (uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size) {
    return new DeliveryCsvAnalysisQueryBase(uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size);
  };
  DeliveryCsvAnalysisQueryBase.prototype.copy$default_ap7anu_k$ = function (uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      uploadPeriodStart = this.uploadPeriodStart_1;
    if (!(($mask0 & 2) === 0))
      uploadPeriodEnd = this.uploadPeriodEnd_1;
    if (!(($mask0 & 4) === 0))
      contentPeriodStart = this.contentPeriodStart_1;
    if (!(($mask0 & 8) === 0))
      contentPeriodEnd = this.contentPeriodEnd_1;
    if (!(($mask0 & 16) === 0))
      importerIds = this.importerIds_1;
    if (!(($mask0 & 32) === 0))
      operatorIds = this.operatorIds_1;
    if (!(($mask0 & 64) === 0))
      carrierIds = this.carrierIds_1;
    if (!(($mask0 & 128) === 0))
      territoryCodes = this.territoryCodes_1;
    if (!(($mask0 & 256) === 0))
      source = this.source_1;
    if (!(($mask0 & 512) === 0))
      successOnly = this.successOnly_1;
    if (!(($mask0 & 1024) === 0))
      page = this.page_1;
    if (!(($mask0 & 2048) === 0))
      size = this.size_1;
    return this.copy_5ris5r_k$(uploadPeriodStart, uploadPeriodEnd, contentPeriodStart, contentPeriodEnd, importerIds, operatorIds, carrierIds, territoryCodes, source, successOnly, page, size);
  };
  DeliveryCsvAnalysisQueryBase.prototype.toString = function () {
    return 'DeliveryCsvAnalysisQueryBase(uploadPeriodStart=' + this.uploadPeriodStart_1 + ', uploadPeriodEnd=' + this.uploadPeriodEnd_1 + ', contentPeriodStart=' + this.contentPeriodStart_1 + ', contentPeriodEnd=' + this.contentPeriodEnd_1 + ', importerIds=' + this.importerIds_1 + ', operatorIds=' + this.operatorIds_1 + ', carrierIds=' + this.carrierIds_1 + ', territoryCodes=' + this.territoryCodes_1 + ', source=' + this.source_1 + ', successOnly=' + this.successOnly_1 + ', page=' + this.page_1 + ', size=' + this.size_1 + ')';
  };
  DeliveryCsvAnalysisQueryBase.prototype.hashCode = function () {
    var result = this.uploadPeriodStart_1 == null ? 0 : getStringHashCode(this.uploadPeriodStart_1);
    result = imul(result, 31) + (this.uploadPeriodEnd_1 == null ? 0 : getStringHashCode(this.uploadPeriodEnd_1)) | 0;
    result = imul(result, 31) + (this.contentPeriodStart_1 == null ? 0 : getStringHashCode(this.contentPeriodStart_1)) | 0;
    result = imul(result, 31) + (this.contentPeriodEnd_1 == null ? 0 : getStringHashCode(this.contentPeriodEnd_1)) | 0;
    result = imul(result, 31) + hashCode(this.importerIds_1) | 0;
    result = imul(result, 31) + hashCode(this.operatorIds_1) | 0;
    result = imul(result, 31) + hashCode(this.carrierIds_1) | 0;
    result = imul(result, 31) + hashCode(this.territoryCodes_1) | 0;
    result = imul(result, 31) + (this.source_1 == null ? 0 : this.source_1.hashCode()) | 0;
    result = imul(result, 31) + (this.successOnly_1 | 0) | 0;
    result = imul(result, 31) + this.page_1 | 0;
    result = imul(result, 31) + this.size_1 | 0;
    return result;
  };
  DeliveryCsvAnalysisQueryBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryCsvAnalysisQueryBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryCsvAnalysisQueryBase ? other : THROW_CCE();
    if (!(this.uploadPeriodStart_1 == tmp0_other_with_cast.uploadPeriodStart_1))
      return false;
    if (!(this.uploadPeriodEnd_1 == tmp0_other_with_cast.uploadPeriodEnd_1))
      return false;
    if (!(this.contentPeriodStart_1 == tmp0_other_with_cast.contentPeriodStart_1))
      return false;
    if (!(this.contentPeriodEnd_1 == tmp0_other_with_cast.contentPeriodEnd_1))
      return false;
    if (!equals(this.importerIds_1, tmp0_other_with_cast.importerIds_1))
      return false;
    if (!equals(this.operatorIds_1, tmp0_other_with_cast.operatorIds_1))
      return false;
    if (!equals(this.carrierIds_1, tmp0_other_with_cast.carrierIds_1))
      return false;
    if (!equals(this.territoryCodes_1, tmp0_other_with_cast.territoryCodes_1))
      return false;
    if (!equals(this.source_1, tmp0_other_with_cast.source_1))
      return false;
    if (!(this.successOnly_1 === tmp0_other_with_cast.successOnly_1))
      return false;
    if (!(this.page_1 === tmp0_other_with_cast.page_1))
      return false;
    if (!(this.size_1 === tmp0_other_with_cast.size_1))
      return false;
    return true;
  };
  DeliveryCsvAnalysisQueryBase.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisQueryBase',
    kind: 'class',
    interfaces: [DeliveryCsvAnalysisQuery]
  };
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'uploadPeriodStart', {
    configurable: true,
    get: function () {
      return this._get_uploadPeriodStart__2688134385_qko07j_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'uploadPeriodEnd', {
    configurable: true,
    get: function () {
      return this._get_uploadPeriodEnd__1200138456_juj4rc_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'contentPeriodStart', {
    configurable: true,
    get: function () {
      return this._get_contentPeriodStart__2828428195_o950t9_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'contentPeriodEnd', {
    configurable: true,
    get: function () {
      return this._get_contentPeriodEnd__480732170_7y7rbe_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'importerIds', {
    configurable: true,
    get: function () {
      return this._get_importerIds__117358603_1xveh7_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'operatorIds', {
    configurable: true,
    get: function () {
      return this._get_operatorIds__1553507485_pox21p_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'carrierIds', {
    configurable: true,
    get: function () {
      return this._get_carrierIds__1640409067_r4nnqj_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'territoryCodes', {
    configurable: true,
    get: function () {
      return this._get_territoryCodes__176172895_2wvzvj_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'source', {
    configurable: true,
    get: function () {
      return this._get_source__263461456_4cuw5s_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'successOnly', {
    configurable: true,
    get: function () {
      return this._get_successOnly__987162914_gbqbs2_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'page', {
    configurable: true,
    get: function () {
      return this._get_page__806010268_dbvli4_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryBase.prototype, 'size', {
    configurable: true,
    get: function () {
      return this._get_size__809037418_ddoh9m_k$();
    }
  });
  var DeliveryCsvAnalysisQueryStatus_READY_instance;
  var DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_instance;
  var DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_instance;
  function values_0() {
    return [DeliveryCsvAnalysisQueryStatus_READY_getInstance(), DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_getInstance(), DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'READY':
        return DeliveryCsvAnalysisQueryStatus_READY_getInstance();
      case 'PENDING_REANALYSIS':
        return DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_getInstance();
      case 'REANALYSIS_IN_PROGRESS':
        return DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_getInstance();
      default:
        DeliveryCsvAnalysisQueryStatus_initEntries();
        THROW_ISE();
        break;
    }
  }
  var DeliveryCsvAnalysisQueryStatus_entriesInitialized;
  function DeliveryCsvAnalysisQueryStatus_initEntries() {
    if (DeliveryCsvAnalysisQueryStatus_entriesInitialized)
      return Unit_getInstance();
    DeliveryCsvAnalysisQueryStatus_entriesInitialized = true;
    DeliveryCsvAnalysisQueryStatus_READY_instance = new DeliveryCsvAnalysisQueryStatus('READY', 0);
    DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_instance = new DeliveryCsvAnalysisQueryStatus('PENDING_REANALYSIS', 1);
    DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_instance = new DeliveryCsvAnalysisQueryStatus('REANALYSIS_IN_PROGRESS', 2);
  }
  function DeliveryCsvAnalysisQueryStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  DeliveryCsvAnalysisQueryStatus.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisQueryStatus',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(DeliveryCsvAnalysisQueryStatus.prototype, 'name', {
    configurable: true,
    get: DeliveryCsvAnalysisQueryStatus.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryStatus.prototype, 'ordinal', {
    configurable: true,
    get: DeliveryCsvAnalysisQueryStatus.prototype._get_ordinal__3363892928_fec5kw_k$
  });
  function DeliveryCsvAnalysisQueryResult() {
  }
  DeliveryCsvAnalysisQueryResult.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisQueryResult',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvAnalysisQueryResultBase_init_$Init$(status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      missingFilesCount = 0;
    if (!(($mask0 & 4) === 0))
      totalFilesCount = 0;
    if (!(($mask0 & 8) === 0))
      reanalysisJobId = null;
    if (!(($mask0 & 16) === 0))
      reanalysisProgress = null;
    if (!(($mask0 & 32) === 0))
      message = null;
    if (!(($mask0 & 64) === 0))
      aggregatedResult = null;
    if (!(($mask0 & 128) === 0))
      contentFiltersActive = false;
    if (!(($mask0 & 256) === 0))
      heatmapPoints = null;
    if (!(($mask0 & 512) === 0))
      heatMatrices = null;
    if (!(($mask0 & 1024) === 0))
      heatMatricesInZone = null;
    DeliveryCsvAnalysisQueryResultBase.call($this, status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone);
    return $this;
  }
  function DeliveryCsvAnalysisQueryResultBase_init_$Create$(status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone, $mask0, $marker) {
    return DeliveryCsvAnalysisQueryResultBase_init_$Init$(status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone, $mask0, $marker, Object.create(DeliveryCsvAnalysisQueryResultBase.prototype));
  }
  function DeliveryCsvAnalysisQueryResultBase(status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone) {
    var missingFilesCount_0 = missingFilesCount === void 1 ? 0 : missingFilesCount;
    var totalFilesCount_0 = totalFilesCount === void 1 ? 0 : totalFilesCount;
    var reanalysisJobId_0 = reanalysisJobId === void 1 ? null : reanalysisJobId;
    var reanalysisProgress_0 = reanalysisProgress === void 1 ? null : reanalysisProgress;
    var message_0 = message === void 1 ? null : message;
    var aggregatedResult_0 = aggregatedResult === void 1 ? null : aggregatedResult;
    var contentFiltersActive_0 = contentFiltersActive === void 1 ? false : contentFiltersActive;
    var heatmapPoints_0 = heatmapPoints === void 1 ? null : heatmapPoints;
    var heatMatrices_0 = heatMatrices === void 1 ? null : heatMatrices;
    var heatMatricesInZone_0 = heatMatricesInZone === void 1 ? null : heatMatricesInZone;
    this.status_1 = status;
    this.missingFilesCount_1 = missingFilesCount_0;
    this.totalFilesCount_1 = totalFilesCount_0;
    this.reanalysisJobId_1 = reanalysisJobId_0;
    this.reanalysisProgress_1 = reanalysisProgress_0;
    this.message_1 = message_0;
    this.aggregatedResult_1 = aggregatedResult_0;
    this.contentFiltersActive_1 = contentFiltersActive_0;
    this.heatmapPoints_1 = heatmapPoints_0;
    this.heatMatrices_1 = heatMatrices_0;
    this.heatMatricesInZone_1 = heatMatricesInZone_0;
  }
  DeliveryCsvAnalysisQueryResultBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_missingFilesCount__4162853939_26nnbh_k$ = function () {
    return this.missingFilesCount_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_totalFilesCount__1525298261_p84fo5_k$ = function () {
    return this.totalFilesCount_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_reanalysisJobId__832153672_drfxvs_k$ = function () {
    return this.reanalysisJobId_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_reanalysisProgress__2638174639_reete9_k$ = function () {
    return this.reanalysisProgress_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_message__1663917034_rinilm_k$ = function () {
    return this.message_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_aggregatedResult__3462482953_drn113_k$ = function () {
    return this.aggregatedResult_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_contentFiltersActive__37831267_miusj_k$ = function () {
    return this.contentFiltersActive_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_heatmapPoints__1276806466_l46e6a_k$ = function () {
    return this.heatmapPoints_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_heatMatrices__2960601889_m2g2xr_k$ = function () {
    return this.heatMatrices_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype._get_heatMatricesInZone__4050950256_41a4r4_k$ = function () {
    return this.heatMatricesInZone_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component1 = function () {
    return this.status_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component2 = function () {
    return this.missingFilesCount_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component3 = function () {
    return this.totalFilesCount_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component4 = function () {
    return this.reanalysisJobId_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component5 = function () {
    return this.reanalysisProgress_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component6 = function () {
    return this.message_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component7 = function () {
    return this.aggregatedResult_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component8 = function () {
    return this.contentFiltersActive_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component9 = function () {
    return this.heatmapPoints_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component10 = function () {
    return this.heatMatrices_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.component11 = function () {
    return this.heatMatricesInZone_1;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.copy = function (status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone) {
    return this.copy_2ij76k_k$(status === void 1 ? this.status_1 : status, missingFilesCount === void 1 ? this.missingFilesCount_1 : missingFilesCount, totalFilesCount === void 1 ? this.totalFilesCount_1 : totalFilesCount, reanalysisJobId === void 1 ? this.reanalysisJobId_1 : reanalysisJobId, reanalysisProgress === void 1 ? this.reanalysisProgress_1 : reanalysisProgress, message === void 1 ? this.message_1 : message, aggregatedResult === void 1 ? this.aggregatedResult_1 : aggregatedResult, contentFiltersActive === void 1 ? this.contentFiltersActive_1 : contentFiltersActive, heatmapPoints === void 1 ? this.heatmapPoints_1 : heatmapPoints, heatMatrices === void 1 ? this.heatMatrices_1 : heatMatrices, heatMatricesInZone === void 1 ? this.heatMatricesInZone_1 : heatMatricesInZone);
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.copy_2ij76k_k$ = function (status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone) {
    return new DeliveryCsvAnalysisQueryResultBase(status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone);
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.copy$default_2nd286_k$ = function (status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      status = this.status_1;
    if (!(($mask0 & 2) === 0))
      missingFilesCount = this.missingFilesCount_1;
    if (!(($mask0 & 4) === 0))
      totalFilesCount = this.totalFilesCount_1;
    if (!(($mask0 & 8) === 0))
      reanalysisJobId = this.reanalysisJobId_1;
    if (!(($mask0 & 16) === 0))
      reanalysisProgress = this.reanalysisProgress_1;
    if (!(($mask0 & 32) === 0))
      message = this.message_1;
    if (!(($mask0 & 64) === 0))
      aggregatedResult = this.aggregatedResult_1;
    if (!(($mask0 & 128) === 0))
      contentFiltersActive = this.contentFiltersActive_1;
    if (!(($mask0 & 256) === 0))
      heatmapPoints = this.heatmapPoints_1;
    if (!(($mask0 & 512) === 0))
      heatMatrices = this.heatMatrices_1;
    if (!(($mask0 & 1024) === 0))
      heatMatricesInZone = this.heatMatricesInZone_1;
    return this.copy_2ij76k_k$(status, missingFilesCount, totalFilesCount, reanalysisJobId, reanalysisProgress, message, aggregatedResult, contentFiltersActive, heatmapPoints, heatMatrices, heatMatricesInZone);
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.toString = function () {
    return 'DeliveryCsvAnalysisQueryResultBase(status=' + this.status_1 + ', missingFilesCount=' + this.missingFilesCount_1 + ', totalFilesCount=' + this.totalFilesCount_1 + ', reanalysisJobId=' + this.reanalysisJobId_1 + ', reanalysisProgress=' + this.reanalysisProgress_1 + ', message=' + this.message_1 + ', aggregatedResult=' + this.aggregatedResult_1 + ', contentFiltersActive=' + this.contentFiltersActive_1 + ', heatmapPoints=' + this.heatmapPoints_1 + ', heatMatrices=' + this.heatMatrices_1 + ', heatMatricesInZone=' + this.heatMatricesInZone_1 + ')';
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.hashCode = function () {
    var result = this.status_1.hashCode();
    result = imul(result, 31) + this.missingFilesCount_1 | 0;
    result = imul(result, 31) + this.totalFilesCount_1 | 0;
    result = imul(result, 31) + (this.reanalysisJobId_1 == null ? 0 : getStringHashCode(this.reanalysisJobId_1)) | 0;
    result = imul(result, 31) + (this.reanalysisProgress_1 == null ? 0 : this.reanalysisProgress_1.hashCode()) | 0;
    result = imul(result, 31) + (this.message_1 == null ? 0 : getStringHashCode(this.message_1)) | 0;
    result = imul(result, 31) + (this.aggregatedResult_1 == null ? 0 : this.aggregatedResult_1.hashCode()) | 0;
    result = imul(result, 31) + (this.contentFiltersActive_1 | 0) | 0;
    result = imul(result, 31) + (this.heatmapPoints_1 == null ? 0 : this.heatmapPoints_1.hashCode()) | 0;
    result = imul(result, 31) + (this.heatMatrices_1 == null ? 0 : this.heatMatrices_1.hashCode()) | 0;
    result = imul(result, 31) + (this.heatMatricesInZone_1 == null ? 0 : this.heatMatricesInZone_1.hashCode()) | 0;
    return result;
  };
  DeliveryCsvAnalysisQueryResultBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryCsvAnalysisQueryResultBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryCsvAnalysisQueryResultBase ? other : THROW_CCE();
    if (!this.status_1.equals(tmp0_other_with_cast.status_1))
      return false;
    if (!(this.missingFilesCount_1 === tmp0_other_with_cast.missingFilesCount_1))
      return false;
    if (!(this.totalFilesCount_1 === tmp0_other_with_cast.totalFilesCount_1))
      return false;
    if (!(this.reanalysisJobId_1 == tmp0_other_with_cast.reanalysisJobId_1))
      return false;
    if (!equals(this.reanalysisProgress_1, tmp0_other_with_cast.reanalysisProgress_1))
      return false;
    if (!(this.message_1 == tmp0_other_with_cast.message_1))
      return false;
    if (!equals(this.aggregatedResult_1, tmp0_other_with_cast.aggregatedResult_1))
      return false;
    if (!(this.contentFiltersActive_1 === tmp0_other_with_cast.contentFiltersActive_1))
      return false;
    if (!equals(this.heatmapPoints_1, tmp0_other_with_cast.heatmapPoints_1))
      return false;
    if (!equals(this.heatMatrices_1, tmp0_other_with_cast.heatMatrices_1))
      return false;
    if (!equals(this.heatMatricesInZone_1, tmp0_other_with_cast.heatMatricesInZone_1))
      return false;
    return true;
  };
  DeliveryCsvAnalysisQueryResultBase.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisQueryResultBase',
    kind: 'class',
    interfaces: [DeliveryCsvAnalysisQueryResult]
  };
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'missingFilesCount', {
    configurable: true,
    get: function () {
      return this._get_missingFilesCount__4162853939_26nnbh_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'totalFilesCount', {
    configurable: true,
    get: function () {
      return this._get_totalFilesCount__1525298261_p84fo5_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'reanalysisJobId', {
    configurable: true,
    get: function () {
      return this._get_reanalysisJobId__832153672_drfxvs_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'reanalysisProgress', {
    configurable: true,
    get: function () {
      return this._get_reanalysisProgress__2638174639_reete9_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'message', {
    configurable: true,
    get: function () {
      return this._get_message__1663917034_rinilm_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'aggregatedResult', {
    configurable: true,
    get: function () {
      return this._get_aggregatedResult__3462482953_drn113_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'contentFiltersActive', {
    configurable: true,
    get: function () {
      return this._get_contentFiltersActive__37831267_miusj_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'heatmapPoints', {
    configurable: true,
    get: function () {
      return this._get_heatmapPoints__1276806466_l46e6a_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'heatMatrices', {
    configurable: true,
    get: function () {
      return this._get_heatMatrices__2960601889_m2g2xr_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisQueryResultBase.prototype, 'heatMatricesInZone', {
    configurable: true,
    get: function () {
      return this._get_heatMatricesInZone__4050950256_41a4r4_k$();
    }
  });
  function DeliveryCsvAnalysisAggregatedResult() {
  }
  DeliveryCsvAnalysisAggregatedResult.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisAggregatedResult',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvAnalysisAggregatedResultBase(totalFiles, totalTours, totalDeliveries, totalPackages, averageApproachDistance, successCount, warningCount, errorCount, skippedCount, analyses, bonusOverviews) {
    this.totalFiles_1 = totalFiles;
    this.totalTours_1 = totalTours;
    this.totalDeliveries_1 = totalDeliveries;
    this.totalPackages_1 = totalPackages;
    this.averageApproachDistance_1 = averageApproachDistance;
    this.successCount_1 = successCount;
    this.warningCount_1 = warningCount;
    this.errorCount_1 = errorCount;
    this.skippedCount_1 = skippedCount;
    this.analyses_1 = analyses;
    this.bonusOverviews_1 = bonusOverviews;
  }
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_totalFiles__1290611032_lce9ug_k$ = function () {
    return this.totalFiles_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_totalTours__1697240884_s2hrg4_k$ = function () {
    return this.totalTours_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_totalDeliveries__3629901019_azyof9_k$ = function () {
    return this.totalDeliveries_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_totalPackages__3147606688_iz3x40_k$ = function () {
    return this.totalPackages_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_averageApproachDistance__1981099095_wrhtuf_k$ = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_successCount__194912255_381n9b_k$ = function () {
    return this.successCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_warningCount__859355352_e7myu0_k$ = function () {
    return this.warningCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_errorCount__785004932_czddok_k$ = function () {
    return this.errorCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_skippedCount__988246380_gcdjsc_k$ = function () {
    return this.skippedCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_analyses__4083751275_3hr3bp_k$ = function () {
    return this.analyses_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype._get_bonusOverviews__384730288_6d23sg_k$ = function () {
    return this.bonusOverviews_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component1 = function () {
    return this.totalFiles_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component2 = function () {
    return this.totalTours_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component3 = function () {
    return this.totalDeliveries_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component4 = function () {
    return this.totalPackages_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component5 = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component6 = function () {
    return this.successCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component7 = function () {
    return this.warningCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component8 = function () {
    return this.errorCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component9 = function () {
    return this.skippedCount_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component10 = function () {
    return this.analyses_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.component11 = function () {
    return this.bonusOverviews_1;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.copy = function (totalFiles, totalTours, totalDeliveries, totalPackages, averageApproachDistance, successCount, warningCount, errorCount, skippedCount, analyses, bonusOverviews) {
    return this.copy_f25mwk_k$(totalFiles === void 1 ? this.totalFiles_1 : totalFiles, totalTours === void 1 ? this.totalTours_1 : totalTours, totalDeliveries === void 1 ? this.totalDeliveries_1 : totalDeliveries, totalPackages === void 1 ? this.totalPackages_1 : totalPackages, averageApproachDistance === void 1 ? this.averageApproachDistance_1 : averageApproachDistance, successCount === void 1 ? this.successCount_1 : successCount, warningCount === void 1 ? this.warningCount_1 : warningCount, errorCount === void 1 ? this.errorCount_1 : errorCount, skippedCount === void 1 ? this.skippedCount_1 : skippedCount, analyses === void 1 ? this.analyses_1 : analyses, bonusOverviews === void 1 ? this.bonusOverviews_1 : bonusOverviews);
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.copy_f25mwk_k$ = function (totalFiles, totalTours, totalDeliveries, totalPackages, averageApproachDistance, successCount, warningCount, errorCount, skippedCount, analyses, bonusOverviews) {
    return new DeliveryCsvAnalysisAggregatedResultBase(totalFiles, totalTours, totalDeliveries, totalPackages, averageApproachDistance, successCount, warningCount, errorCount, skippedCount, analyses, bonusOverviews);
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.copy$default_brd5d1_k$ = function (totalFiles, totalTours, totalDeliveries, totalPackages, averageApproachDistance, successCount, warningCount, errorCount, skippedCount, analyses, bonusOverviews, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      totalFiles = this.totalFiles_1;
    if (!(($mask0 & 2) === 0))
      totalTours = this.totalTours_1;
    if (!(($mask0 & 4) === 0))
      totalDeliveries = this.totalDeliveries_1;
    if (!(($mask0 & 8) === 0))
      totalPackages = this.totalPackages_1;
    if (!(($mask0 & 16) === 0))
      averageApproachDistance = this.averageApproachDistance_1;
    if (!(($mask0 & 32) === 0))
      successCount = this.successCount_1;
    if (!(($mask0 & 64) === 0))
      warningCount = this.warningCount_1;
    if (!(($mask0 & 128) === 0))
      errorCount = this.errorCount_1;
    if (!(($mask0 & 256) === 0))
      skippedCount = this.skippedCount_1;
    if (!(($mask0 & 512) === 0))
      analyses = this.analyses_1;
    if (!(($mask0 & 1024) === 0))
      bonusOverviews = this.bonusOverviews_1;
    return this.copy_f25mwk_k$(totalFiles, totalTours, totalDeliveries, totalPackages, averageApproachDistance, successCount, warningCount, errorCount, skippedCount, analyses, bonusOverviews);
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.toString = function () {
    return 'DeliveryCsvAnalysisAggregatedResultBase(totalFiles=' + this.totalFiles_1 + ', totalTours=' + this.totalTours_1 + ', totalDeliveries=' + this.totalDeliveries_1 + ', totalPackages=' + this.totalPackages_1 + ', averageApproachDistance=' + this.averageApproachDistance_1 + ', successCount=' + this.successCount_1 + ', warningCount=' + this.warningCount_1 + ', errorCount=' + this.errorCount_1 + ', skippedCount=' + this.skippedCount_1 + ', analyses=' + this.analyses_1 + ', bonusOverviews=' + this.bonusOverviews_1 + ')';
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.hashCode = function () {
    var result = this.totalFiles_1;
    result = imul(result, 31) + this.totalTours_1 | 0;
    result = imul(result, 31) + this.totalDeliveries_1 | 0;
    result = imul(result, 31) + this.totalPackages_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.averageApproachDistance_1) | 0;
    result = imul(result, 31) + this.successCount_1 | 0;
    result = imul(result, 31) + this.warningCount_1 | 0;
    result = imul(result, 31) + this.errorCount_1 | 0;
    result = imul(result, 31) + this.skippedCount_1 | 0;
    result = imul(result, 31) + hashCode(this.analyses_1) | 0;
    result = imul(result, 31) + hashCode(this.bonusOverviews_1) | 0;
    return result;
  };
  DeliveryCsvAnalysisAggregatedResultBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryCsvAnalysisAggregatedResultBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryCsvAnalysisAggregatedResultBase ? other : THROW_CCE();
    if (!(this.totalFiles_1 === tmp0_other_with_cast.totalFiles_1))
      return false;
    if (!(this.totalTours_1 === tmp0_other_with_cast.totalTours_1))
      return false;
    if (!(this.totalDeliveries_1 === tmp0_other_with_cast.totalDeliveries_1))
      return false;
    if (!(this.totalPackages_1 === tmp0_other_with_cast.totalPackages_1))
      return false;
    if (!equals(this.averageApproachDistance_1, tmp0_other_with_cast.averageApproachDistance_1))
      return false;
    if (!(this.successCount_1 === tmp0_other_with_cast.successCount_1))
      return false;
    if (!(this.warningCount_1 === tmp0_other_with_cast.warningCount_1))
      return false;
    if (!(this.errorCount_1 === tmp0_other_with_cast.errorCount_1))
      return false;
    if (!(this.skippedCount_1 === tmp0_other_with_cast.skippedCount_1))
      return false;
    if (!equals(this.analyses_1, tmp0_other_with_cast.analyses_1))
      return false;
    if (!equals(this.bonusOverviews_1, tmp0_other_with_cast.bonusOverviews_1))
      return false;
    return true;
  };
  DeliveryCsvAnalysisAggregatedResultBase.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisAggregatedResultBase',
    kind: 'class',
    interfaces: [DeliveryCsvAnalysisAggregatedResult]
  };
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'totalFiles', {
    configurable: true,
    get: function () {
      return this._get_totalFiles__1290611032_lce9ug_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'totalTours', {
    configurable: true,
    get: function () {
      return this._get_totalTours__1697240884_s2hrg4_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'totalDeliveries', {
    configurable: true,
    get: function () {
      return this._get_totalDeliveries__3629901019_azyof9_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'totalPackages', {
    configurable: true,
    get: function () {
      return this._get_totalPackages__3147606688_iz3x40_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'averageApproachDistance', {
    configurable: true,
    get: function () {
      return this._get_averageApproachDistance__1981099095_wrhtuf_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'successCount', {
    configurable: true,
    get: function () {
      return this._get_successCount__194912255_381n9b_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'warningCount', {
    configurable: true,
    get: function () {
      return this._get_warningCount__859355352_e7myu0_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'errorCount', {
    configurable: true,
    get: function () {
      return this._get_errorCount__785004932_czddok_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'skippedCount', {
    configurable: true,
    get: function () {
      return this._get_skippedCount__988246380_gcdjsc_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'analyses', {
    configurable: true,
    get: function () {
      return this._get_analyses__4083751275_3hr3bp_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisAggregatedResultBase.prototype, 'bonusOverviews', {
    configurable: true,
    get: function () {
      return this._get_bonusOverviews__384730288_6d23sg_k$();
    }
  });
  function DeliveryCsvAnalysisSummary() {
  }
  DeliveryCsvAnalysisSummary.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisSummary',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvAnalysisSummaryBase_init_$Init$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, $mask0, $marker, $this) {
    if (!(($mask0 & 65536) === 0))
      tolerateErrors = false;
    DeliveryCsvAnalysisSummaryBase.call($this, id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors);
    return $this;
  }
  function DeliveryCsvAnalysisSummaryBase_init_$Create$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, $mask0, $marker) {
    return DeliveryCsvAnalysisSummaryBase_init_$Init$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, $mask0, $marker, Object.create(DeliveryCsvAnalysisSummaryBase.prototype));
  }
  function DeliveryCsvAnalysisSummaryBase(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors) {
    var tolerateErrors_0 = tolerateErrors === void 1 ? false : tolerateErrors;
    this.id_1 = id;
    this.importerId_1 = importerId;
    this.importerName_1 = importerName;
    this.operatorNames_1 = operatorNames;
    this.carrierNames_1 = carrierNames;
    this.fileName_1 = fileName;
    this.status_1 = status;
    this.period_1 = period;
    this.source_1 = source;
    this.nbTours_1 = nbTours;
    this.totalDeliveries_1 = totalDeliveries;
    this.totalPackages_1 = totalPackages;
    this.averageApproachDistance_1 = averageApproachDistance;
    this.lowAveragePointsAlert_1 = lowAveragePointsAlert;
    this.creationDate_1 = creationDate;
    this.errorCount_1 = errorCount;
    this.tolerateErrors_1 = tolerateErrors_0;
  }
  DeliveryCsvAnalysisSummaryBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_importerId__3883111006_6t7ici_k$ = function () {
    return this.importerId_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_importerName__3642640430_asdmmq_k$ = function () {
    return this.importerName_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_operatorNames__2707278925_q99o6r_k$ = function () {
    return this.operatorNames_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_carrierNames__320353307_5aqa6z_k$ = function () {
    return this.carrierNames_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_fileName__149290628_2gvtdw_k$ = function () {
    return this.fileName_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_source__263461456_4cuw5s_k$ = function () {
    return this.source_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_nbTours__4148592682_2f5bdi_k$ = function () {
    return this.nbTours_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_totalDeliveries__3629901019_azyof9_k$ = function () {
    return this.totalDeliveries_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_totalPackages__3147606688_iz3x40_k$ = function () {
    return this.totalPackages_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_averageApproachDistance__1981099095_wrhtuf_k$ = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_lowAveragePointsAlert__3139726721_j3stbz_k$ = function () {
    return this.lowAveragePointsAlert_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_errorCount__785004932_czddok_k$ = function () {
    return this.errorCount_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype._get_tolerateErrors__758086988_cjcfnw_k$ = function () {
    return this.tolerateErrors_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component1 = function () {
    return this.id_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component2 = function () {
    return this.importerId_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component3 = function () {
    return this.importerName_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component4 = function () {
    return this.operatorNames_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component5 = function () {
    return this.carrierNames_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component6 = function () {
    return this.fileName_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component7 = function () {
    return this.status_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component8 = function () {
    return this.period_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component9 = function () {
    return this.source_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component10 = function () {
    return this.nbTours_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component11 = function () {
    return this.totalDeliveries_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component12 = function () {
    return this.totalPackages_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component13 = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component14 = function () {
    return this.lowAveragePointsAlert_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component15 = function () {
    return this.creationDate_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component16 = function () {
    return this.errorCount_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.component17 = function () {
    return this.tolerateErrors_1;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.copy = function (id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors) {
    return this.copy_dv2cpl_k$(id === void 1 ? this.id_1 : id, importerId === void 1 ? this.importerId_1 : importerId, importerName === void 1 ? this.importerName_1 : importerName, operatorNames === void 1 ? this.operatorNames_1 : operatorNames, carrierNames === void 1 ? this.carrierNames_1 : carrierNames, fileName === void 1 ? this.fileName_1 : fileName, status === void 1 ? this.status_1 : status, period === void 1 ? this.period_1 : period, source === void 1 ? this.source_1 : source, nbTours === void 1 ? this.nbTours_1 : nbTours, totalDeliveries === void 1 ? this.totalDeliveries_1 : totalDeliveries, totalPackages === void 1 ? this.totalPackages_1 : totalPackages, averageApproachDistance === void 1 ? this.averageApproachDistance_1 : averageApproachDistance, lowAveragePointsAlert === void 1 ? this.lowAveragePointsAlert_1 : lowAveragePointsAlert, creationDate === void 1 ? this.creationDate_1 : creationDate, errorCount === void 1 ? this.errorCount_1 : errorCount, tolerateErrors === void 1 ? this.tolerateErrors_1 : tolerateErrors);
  };
  DeliveryCsvAnalysisSummaryBase.prototype.copy_dv2cpl_k$ = function (id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors) {
    return new DeliveryCsvAnalysisSummaryBase(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors);
  };
  DeliveryCsvAnalysisSummaryBase.prototype.copy$default_d3m6n6_k$ = function (id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      importerId = this.importerId_1;
    if (!(($mask0 & 4) === 0))
      importerName = this.importerName_1;
    if (!(($mask0 & 8) === 0))
      operatorNames = this.operatorNames_1;
    if (!(($mask0 & 16) === 0))
      carrierNames = this.carrierNames_1;
    if (!(($mask0 & 32) === 0))
      fileName = this.fileName_1;
    if (!(($mask0 & 64) === 0))
      status = this.status_1;
    if (!(($mask0 & 128) === 0))
      period = this.period_1;
    if (!(($mask0 & 256) === 0))
      source = this.source_1;
    if (!(($mask0 & 512) === 0))
      nbTours = this.nbTours_1;
    if (!(($mask0 & 1024) === 0))
      totalDeliveries = this.totalDeliveries_1;
    if (!(($mask0 & 2048) === 0))
      totalPackages = this.totalPackages_1;
    if (!(($mask0 & 4096) === 0))
      averageApproachDistance = this.averageApproachDistance_1;
    if (!(($mask0 & 8192) === 0))
      lowAveragePointsAlert = this.lowAveragePointsAlert_1;
    if (!(($mask0 & 16384) === 0))
      creationDate = this.creationDate_1;
    if (!(($mask0 & 32768) === 0))
      errorCount = this.errorCount_1;
    if (!(($mask0 & 65536) === 0))
      tolerateErrors = this.tolerateErrors_1;
    return this.copy_dv2cpl_k$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors);
  };
  DeliveryCsvAnalysisSummaryBase.prototype.toString = function () {
    return 'DeliveryCsvAnalysisSummaryBase(id=' + this.id_1 + ', importerId=' + this.importerId_1 + ', importerName=' + this.importerName_1 + ', operatorNames=' + this.operatorNames_1 + ', carrierNames=' + this.carrierNames_1 + ', fileName=' + this.fileName_1 + ', status=' + this.status_1 + ', period=' + this.period_1 + ', source=' + this.source_1 + ', nbTours=' + this.nbTours_1 + ', totalDeliveries=' + this.totalDeliveries_1 + ', totalPackages=' + this.totalPackages_1 + ', averageApproachDistance=' + this.averageApproachDistance_1 + ', lowAveragePointsAlert=' + this.lowAveragePointsAlert_1 + ', creationDate=' + toString_0(this.creationDate_1) + ', errorCount=' + this.errorCount_1 + ', tolerateErrors=' + this.tolerateErrors_1 + ')';
  };
  DeliveryCsvAnalysisSummaryBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.importerId_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.importerName_1) | 0;
    result = imul(result, 31) + hashCode(this.operatorNames_1) | 0;
    result = imul(result, 31) + hashCode(this.carrierNames_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fileName_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.status_1) | 0;
    result = imul(result, 31) + (this.period_1 == null ? 0 : getStringHashCode(this.period_1)) | 0;
    result = imul(result, 31) + this.source_1.hashCode() | 0;
    result = imul(result, 31) + this.nbTours_1 | 0;
    result = imul(result, 31) + this.totalDeliveries_1 | 0;
    result = imul(result, 31) + this.totalPackages_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.averageApproachDistance_1) | 0;
    result = imul(result, 31) + (this.lowAveragePointsAlert_1 | 0) | 0;
    result = imul(result, 31) + (this.creationDate_1 == null ? 0 : this.creationDate_1.hashCode()) | 0;
    result = imul(result, 31) + this.errorCount_1 | 0;
    result = imul(result, 31) + (this.tolerateErrors_1 | 0) | 0;
    return result;
  };
  DeliveryCsvAnalysisSummaryBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryCsvAnalysisSummaryBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryCsvAnalysisSummaryBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.importerId_1 === tmp0_other_with_cast.importerId_1))
      return false;
    if (!(this.importerName_1 === tmp0_other_with_cast.importerName_1))
      return false;
    if (!equals(this.operatorNames_1, tmp0_other_with_cast.operatorNames_1))
      return false;
    if (!equals(this.carrierNames_1, tmp0_other_with_cast.carrierNames_1))
      return false;
    if (!(this.fileName_1 === tmp0_other_with_cast.fileName_1))
      return false;
    if (!(this.status_1 === tmp0_other_with_cast.status_1))
      return false;
    if (!(this.period_1 == tmp0_other_with_cast.period_1))
      return false;
    if (!this.source_1.equals(tmp0_other_with_cast.source_1))
      return false;
    if (!(this.nbTours_1 === tmp0_other_with_cast.nbTours_1))
      return false;
    if (!(this.totalDeliveries_1 === tmp0_other_with_cast.totalDeliveries_1))
      return false;
    if (!(this.totalPackages_1 === tmp0_other_with_cast.totalPackages_1))
      return false;
    if (!equals(this.averageApproachDistance_1, tmp0_other_with_cast.averageApproachDistance_1))
      return false;
    if (!(this.lowAveragePointsAlert_1 === tmp0_other_with_cast.lowAveragePointsAlert_1))
      return false;
    if (!equals(this.creationDate_1, tmp0_other_with_cast.creationDate_1))
      return false;
    if (!(this.errorCount_1 === tmp0_other_with_cast.errorCount_1))
      return false;
    if (!(this.tolerateErrors_1 === tmp0_other_with_cast.tolerateErrors_1))
      return false;
    return true;
  };
  DeliveryCsvAnalysisSummaryBase.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisSummaryBase',
    kind: 'class',
    interfaces: [DeliveryCsvAnalysisSummary]
  };
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'importerId', {
    configurable: true,
    get: function () {
      return this._get_importerId__3883111006_6t7ici_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'importerName', {
    configurable: true,
    get: function () {
      return this._get_importerName__3642640430_asdmmq_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'operatorNames', {
    configurable: true,
    get: function () {
      return this._get_operatorNames__2707278925_q99o6r_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'carrierNames', {
    configurable: true,
    get: function () {
      return this._get_carrierNames__320353307_5aqa6z_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'fileName', {
    configurable: true,
    get: function () {
      return this._get_fileName__149290628_2gvtdw_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'source', {
    configurable: true,
    get: function () {
      return this._get_source__263461456_4cuw5s_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'nbTours', {
    configurable: true,
    get: function () {
      return this._get_nbTours__4148592682_2f5bdi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'totalDeliveries', {
    configurable: true,
    get: function () {
      return this._get_totalDeliveries__3629901019_azyof9_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'totalPackages', {
    configurable: true,
    get: function () {
      return this._get_totalPackages__3147606688_iz3x40_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'averageApproachDistance', {
    configurable: true,
    get: function () {
      return this._get_averageApproachDistance__1981099095_wrhtuf_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'lowAveragePointsAlert', {
    configurable: true,
    get: function () {
      return this._get_lowAveragePointsAlert__3139726721_j3stbz_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'errorCount', {
    configurable: true,
    get: function () {
      return this._get_errorCount__785004932_czddok_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisSummaryBase.prototype, 'tolerateErrors', {
    configurable: true,
    get: function () {
      return this._get_tolerateErrors__758086988_cjcfnw_k$();
    }
  });
  function DeliveryCsvAnalysisDetail() {
  }
  DeliveryCsvAnalysisDetail.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisDetail',
    kind: 'interface',
    interfaces: [DeliveryCsvAnalysisSummary]
  };
  function DeliveryCsvAnalysisDetailBase_init_$Init$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, $mask0, $marker, $this) {
    if (!(($mask0 & 65536) === 0))
      tolerateErrors = false;
    if (!(($mask0 & 2097152) === 0))
      horsZonePoints = emptyList();
    DeliveryCsvAnalysisDetailBase.call($this, id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints);
    return $this;
  }
  function DeliveryCsvAnalysisDetailBase_init_$Create$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, $mask0, $marker) {
    return DeliveryCsvAnalysisDetailBase_init_$Init$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, $mask0, $marker, Object.create(DeliveryCsvAnalysisDetailBase.prototype));
  }
  function DeliveryCsvAnalysisDetailBase(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints) {
    var tolerateErrors_0 = tolerateErrors === void 1 ? false : tolerateErrors;
    var horsZonePoints_0 = horsZonePoints === void 1 ? emptyList() : horsZonePoints;
    this.id_1 = id;
    this.importerId_1 = importerId;
    this.importerName_1 = importerName;
    this.operatorNames_1 = operatorNames;
    this.carrierNames_1 = carrierNames;
    this.fileName_1 = fileName;
    this.status_1 = status;
    this.period_1 = period;
    this.source_1 = source;
    this.nbTours_1 = nbTours;
    this.totalDeliveries_1 = totalDeliveries;
    this.totalPackages_1 = totalPackages;
    this.averageApproachDistance_1 = averageApproachDistance;
    this.lowAveragePointsAlert_1 = lowAveragePointsAlert;
    this.creationDate_1 = creationDate;
    this.errorCount_1 = errorCount;
    this.tolerateErrors_1 = tolerateErrors_0;
    this.bonusOverviews_1 = bonusOverviews;
    this.errors_1 = errors;
    this.hubs_1 = hubs;
    this.deliveryPoints_1 = deliveryPoints;
    this.horsZonePoints_1 = horsZonePoints_0;
  }
  DeliveryCsvAnalysisDetailBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_importerId__3883111006_6t7ici_k$ = function () {
    return this.importerId_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_importerName__3642640430_asdmmq_k$ = function () {
    return this.importerName_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_operatorNames__2707278925_q99o6r_k$ = function () {
    return this.operatorNames_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_carrierNames__320353307_5aqa6z_k$ = function () {
    return this.carrierNames_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_fileName__149290628_2gvtdw_k$ = function () {
    return this.fileName_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_source__263461456_4cuw5s_k$ = function () {
    return this.source_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_nbTours__4148592682_2f5bdi_k$ = function () {
    return this.nbTours_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_totalDeliveries__3629901019_azyof9_k$ = function () {
    return this.totalDeliveries_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_totalPackages__3147606688_iz3x40_k$ = function () {
    return this.totalPackages_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_averageApproachDistance__1981099095_wrhtuf_k$ = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_lowAveragePointsAlert__3139726721_j3stbz_k$ = function () {
    return this.lowAveragePointsAlert_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_errorCount__785004932_czddok_k$ = function () {
    return this.errorCount_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_tolerateErrors__758086988_cjcfnw_k$ = function () {
    return this.tolerateErrors_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_bonusOverviews__384730288_6d23sg_k$ = function () {
    return this.bonusOverviews_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_errors__806354176_dc2yv4_k$ = function () {
    return this.errors_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_hubs__799213549_d7tx4d_k$ = function () {
    return this.hubs_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_deliveryPoints__899908340_evs5pw_k$ = function () {
    return this.deliveryPoints_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype._get_horsZonePoints__653216148_aswot0_k$ = function () {
    return this.horsZonePoints_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component1 = function () {
    return this.id_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component2 = function () {
    return this.importerId_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component3 = function () {
    return this.importerName_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component4 = function () {
    return this.operatorNames_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component5 = function () {
    return this.carrierNames_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component6 = function () {
    return this.fileName_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component7 = function () {
    return this.status_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component8 = function () {
    return this.period_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component9 = function () {
    return this.source_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component10 = function () {
    return this.nbTours_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component11 = function () {
    return this.totalDeliveries_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component12 = function () {
    return this.totalPackages_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component13 = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component14 = function () {
    return this.lowAveragePointsAlert_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component15 = function () {
    return this.creationDate_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component16 = function () {
    return this.errorCount_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component17 = function () {
    return this.tolerateErrors_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component18 = function () {
    return this.bonusOverviews_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component19 = function () {
    return this.errors_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component20 = function () {
    return this.hubs_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component21 = function () {
    return this.deliveryPoints_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.component22 = function () {
    return this.horsZonePoints_1;
  };
  DeliveryCsvAnalysisDetailBase.prototype.copy = function (id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints) {
    return this.copy_budvbd_k$(id === void 1 ? this.id_1 : id, importerId === void 1 ? this.importerId_1 : importerId, importerName === void 1 ? this.importerName_1 : importerName, operatorNames === void 1 ? this.operatorNames_1 : operatorNames, carrierNames === void 1 ? this.carrierNames_1 : carrierNames, fileName === void 1 ? this.fileName_1 : fileName, status === void 1 ? this.status_1 : status, period === void 1 ? this.period_1 : period, source === void 1 ? this.source_1 : source, nbTours === void 1 ? this.nbTours_1 : nbTours, totalDeliveries === void 1 ? this.totalDeliveries_1 : totalDeliveries, totalPackages === void 1 ? this.totalPackages_1 : totalPackages, averageApproachDistance === void 1 ? this.averageApproachDistance_1 : averageApproachDistance, lowAveragePointsAlert === void 1 ? this.lowAveragePointsAlert_1 : lowAveragePointsAlert, creationDate === void 1 ? this.creationDate_1 : creationDate, errorCount === void 1 ? this.errorCount_1 : errorCount, tolerateErrors === void 1 ? this.tolerateErrors_1 : tolerateErrors, bonusOverviews === void 1 ? this.bonusOverviews_1 : bonusOverviews, errors === void 1 ? this.errors_1 : errors, hubs === void 1 ? this.hubs_1 : hubs, deliveryPoints === void 1 ? this.deliveryPoints_1 : deliveryPoints, horsZonePoints === void 1 ? this.horsZonePoints_1 : horsZonePoints);
  };
  DeliveryCsvAnalysisDetailBase.prototype.copy_budvbd_k$ = function (id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints) {
    return new DeliveryCsvAnalysisDetailBase(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints);
  };
  DeliveryCsvAnalysisDetailBase.prototype.copy$default_4a1pnt_k$ = function (id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      importerId = this.importerId_1;
    if (!(($mask0 & 4) === 0))
      importerName = this.importerName_1;
    if (!(($mask0 & 8) === 0))
      operatorNames = this.operatorNames_1;
    if (!(($mask0 & 16) === 0))
      carrierNames = this.carrierNames_1;
    if (!(($mask0 & 32) === 0))
      fileName = this.fileName_1;
    if (!(($mask0 & 64) === 0))
      status = this.status_1;
    if (!(($mask0 & 128) === 0))
      period = this.period_1;
    if (!(($mask0 & 256) === 0))
      source = this.source_1;
    if (!(($mask0 & 512) === 0))
      nbTours = this.nbTours_1;
    if (!(($mask0 & 1024) === 0))
      totalDeliveries = this.totalDeliveries_1;
    if (!(($mask0 & 2048) === 0))
      totalPackages = this.totalPackages_1;
    if (!(($mask0 & 4096) === 0))
      averageApproachDistance = this.averageApproachDistance_1;
    if (!(($mask0 & 8192) === 0))
      lowAveragePointsAlert = this.lowAveragePointsAlert_1;
    if (!(($mask0 & 16384) === 0))
      creationDate = this.creationDate_1;
    if (!(($mask0 & 32768) === 0))
      errorCount = this.errorCount_1;
    if (!(($mask0 & 65536) === 0))
      tolerateErrors = this.tolerateErrors_1;
    if (!(($mask0 & 131072) === 0))
      bonusOverviews = this.bonusOverviews_1;
    if (!(($mask0 & 262144) === 0))
      errors = this.errors_1;
    if (!(($mask0 & 524288) === 0))
      hubs = this.hubs_1;
    if (!(($mask0 & 1048576) === 0))
      deliveryPoints = this.deliveryPoints_1;
    if (!(($mask0 & 2097152) === 0))
      horsZonePoints = this.horsZonePoints_1;
    return this.copy_budvbd_k$(id, importerId, importerName, operatorNames, carrierNames, fileName, status, period, source, nbTours, totalDeliveries, totalPackages, averageApproachDistance, lowAveragePointsAlert, creationDate, errorCount, tolerateErrors, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints);
  };
  DeliveryCsvAnalysisDetailBase.prototype.toString = function () {
    return 'DeliveryCsvAnalysisDetailBase(id=' + this.id_1 + ', importerId=' + this.importerId_1 + ', importerName=' + this.importerName_1 + ', operatorNames=' + this.operatorNames_1 + ', carrierNames=' + this.carrierNames_1 + ', fileName=' + this.fileName_1 + ', status=' + this.status_1 + ', period=' + this.period_1 + ', source=' + this.source_1 + ', nbTours=' + this.nbTours_1 + ', totalDeliveries=' + this.totalDeliveries_1 + ', totalPackages=' + this.totalPackages_1 + ', averageApproachDistance=' + this.averageApproachDistance_1 + ', lowAveragePointsAlert=' + this.lowAveragePointsAlert_1 + ', creationDate=' + toString_0(this.creationDate_1) + ', errorCount=' + this.errorCount_1 + ', tolerateErrors=' + this.tolerateErrors_1 + ', bonusOverviews=' + this.bonusOverviews_1 + ', errors=' + this.errors_1 + ', hubs=' + this.hubs_1 + ', deliveryPoints=' + this.deliveryPoints_1 + ', horsZonePoints=' + this.horsZonePoints_1 + ')';
  };
  DeliveryCsvAnalysisDetailBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.importerId_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.importerName_1) | 0;
    result = imul(result, 31) + hashCode(this.operatorNames_1) | 0;
    result = imul(result, 31) + hashCode(this.carrierNames_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fileName_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.status_1) | 0;
    result = imul(result, 31) + (this.period_1 == null ? 0 : getStringHashCode(this.period_1)) | 0;
    result = imul(result, 31) + this.source_1.hashCode() | 0;
    result = imul(result, 31) + this.nbTours_1 | 0;
    result = imul(result, 31) + this.totalDeliveries_1 | 0;
    result = imul(result, 31) + this.totalPackages_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.averageApproachDistance_1) | 0;
    result = imul(result, 31) + (this.lowAveragePointsAlert_1 | 0) | 0;
    result = imul(result, 31) + (this.creationDate_1 == null ? 0 : this.creationDate_1.hashCode()) | 0;
    result = imul(result, 31) + this.errorCount_1 | 0;
    result = imul(result, 31) + (this.tolerateErrors_1 | 0) | 0;
    result = imul(result, 31) + hashCode(this.bonusOverviews_1) | 0;
    result = imul(result, 31) + hashCode(this.errors_1) | 0;
    result = imul(result, 31) + hashCode(this.hubs_1) | 0;
    result = imul(result, 31) + hashCode(this.deliveryPoints_1) | 0;
    result = imul(result, 31) + hashCode(this.horsZonePoints_1) | 0;
    return result;
  };
  DeliveryCsvAnalysisDetailBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryCsvAnalysisDetailBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryCsvAnalysisDetailBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.importerId_1 === tmp0_other_with_cast.importerId_1))
      return false;
    if (!(this.importerName_1 === tmp0_other_with_cast.importerName_1))
      return false;
    if (!equals(this.operatorNames_1, tmp0_other_with_cast.operatorNames_1))
      return false;
    if (!equals(this.carrierNames_1, tmp0_other_with_cast.carrierNames_1))
      return false;
    if (!(this.fileName_1 === tmp0_other_with_cast.fileName_1))
      return false;
    if (!(this.status_1 === tmp0_other_with_cast.status_1))
      return false;
    if (!(this.period_1 == tmp0_other_with_cast.period_1))
      return false;
    if (!this.source_1.equals(tmp0_other_with_cast.source_1))
      return false;
    if (!(this.nbTours_1 === tmp0_other_with_cast.nbTours_1))
      return false;
    if (!(this.totalDeliveries_1 === tmp0_other_with_cast.totalDeliveries_1))
      return false;
    if (!(this.totalPackages_1 === tmp0_other_with_cast.totalPackages_1))
      return false;
    if (!equals(this.averageApproachDistance_1, tmp0_other_with_cast.averageApproachDistance_1))
      return false;
    if (!(this.lowAveragePointsAlert_1 === tmp0_other_with_cast.lowAveragePointsAlert_1))
      return false;
    if (!equals(this.creationDate_1, tmp0_other_with_cast.creationDate_1))
      return false;
    if (!(this.errorCount_1 === tmp0_other_with_cast.errorCount_1))
      return false;
    if (!(this.tolerateErrors_1 === tmp0_other_with_cast.tolerateErrors_1))
      return false;
    if (!equals(this.bonusOverviews_1, tmp0_other_with_cast.bonusOverviews_1))
      return false;
    if (!equals(this.errors_1, tmp0_other_with_cast.errors_1))
      return false;
    if (!equals(this.hubs_1, tmp0_other_with_cast.hubs_1))
      return false;
    if (!equals(this.deliveryPoints_1, tmp0_other_with_cast.deliveryPoints_1))
      return false;
    if (!equals(this.horsZonePoints_1, tmp0_other_with_cast.horsZonePoints_1))
      return false;
    return true;
  };
  DeliveryCsvAnalysisDetailBase.$metadata$ = {
    simpleName: 'DeliveryCsvAnalysisDetailBase',
    kind: 'class',
    interfaces: [DeliveryCsvAnalysisDetail]
  };
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'importerId', {
    configurable: true,
    get: function () {
      return this._get_importerId__3883111006_6t7ici_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'importerName', {
    configurable: true,
    get: function () {
      return this._get_importerName__3642640430_asdmmq_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'operatorNames', {
    configurable: true,
    get: function () {
      return this._get_operatorNames__2707278925_q99o6r_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'carrierNames', {
    configurable: true,
    get: function () {
      return this._get_carrierNames__320353307_5aqa6z_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'fileName', {
    configurable: true,
    get: function () {
      return this._get_fileName__149290628_2gvtdw_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'source', {
    configurable: true,
    get: function () {
      return this._get_source__263461456_4cuw5s_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'nbTours', {
    configurable: true,
    get: function () {
      return this._get_nbTours__4148592682_2f5bdi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'totalDeliveries', {
    configurable: true,
    get: function () {
      return this._get_totalDeliveries__3629901019_azyof9_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'totalPackages', {
    configurable: true,
    get: function () {
      return this._get_totalPackages__3147606688_iz3x40_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'averageApproachDistance', {
    configurable: true,
    get: function () {
      return this._get_averageApproachDistance__1981099095_wrhtuf_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'lowAveragePointsAlert', {
    configurable: true,
    get: function () {
      return this._get_lowAveragePointsAlert__3139726721_j3stbz_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'errorCount', {
    configurable: true,
    get: function () {
      return this._get_errorCount__785004932_czddok_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'tolerateErrors', {
    configurable: true,
    get: function () {
      return this._get_tolerateErrors__758086988_cjcfnw_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'bonusOverviews', {
    configurable: true,
    get: function () {
      return this._get_bonusOverviews__384730288_6d23sg_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'errors', {
    configurable: true,
    get: function () {
      return this._get_errors__806354176_dc2yv4_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'hubs', {
    configurable: true,
    get: function () {
      return this._get_hubs__799213549_d7tx4d_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'deliveryPoints', {
    configurable: true,
    get: function () {
      return this._get_deliveryPoints__899908340_evs5pw_k$();
    }
  });
  Object.defineProperty(DeliveryCsvAnalysisDetailBase.prototype, 'horsZonePoints', {
    configurable: true,
    get: function () {
      return this._get_horsZonePoints__653216148_aswot0_k$();
    }
  });
  function HeatmapPoint() {
  }
  HeatmapPoint.$metadata$ = {
    simpleName: 'HeatmapPoint',
    kind: 'interface',
    interfaces: []
  };
  function HeatmapPointBase(lat, lon, count) {
    this.lat_1 = lat;
    this.lon_1 = lon;
    this.count_1 = count;
  }
  HeatmapPointBase.prototype._get_lat__857165522_e6c15e_k$ = function () {
    return this.lat_1;
  };
  HeatmapPointBase.prototype._get_lon__857178790_e6cbdy_k$ = function () {
    return this.lon_1;
  };
  HeatmapPointBase.prototype._get_count__3152659618_iw3m8u_k$ = function () {
    return this.count_1;
  };
  HeatmapPointBase.prototype.component1 = function () {
    return this.lat_1;
  };
  HeatmapPointBase.prototype.component2 = function () {
    return this.lon_1;
  };
  HeatmapPointBase.prototype.component3 = function () {
    return this.count_1;
  };
  HeatmapPointBase.prototype.copy = function (lat, lon, count) {
    return this.copy_v92hea_k$(lat === void 1 ? this.lat_1 : lat, lon === void 1 ? this.lon_1 : lon, count === void 1 ? this.count_1 : count);
  };
  HeatmapPointBase.prototype.copy_v92hea_k$ = function (lat, lon, count) {
    return new HeatmapPointBase(lat, lon, count);
  };
  HeatmapPointBase.prototype.copy$default_wwourz_k$ = function (lat, lon, count, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      lat = this.lat_1;
    if (!(($mask0 & 2) === 0))
      lon = this.lon_1;
    if (!(($mask0 & 4) === 0))
      count = this.count_1;
    return this.copy_v92hea_k$(lat, lon, count);
  };
  HeatmapPointBase.prototype.toString = function () {
    return 'HeatmapPointBase(lat=' + this.lat_1 + ', lon=' + this.lon_1 + ', count=' + this.count_1 + ')';
  };
  HeatmapPointBase.prototype.hashCode = function () {
    var result = getNumberHashCode(this.lat_1);
    result = imul(result, 31) + getNumberHashCode(this.lon_1) | 0;
    result = imul(result, 31) + this.count_1 | 0;
    return result;
  };
  HeatmapPointBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeatmapPointBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HeatmapPointBase ? other : THROW_CCE();
    if (!equals(this.lat_1, tmp0_other_with_cast.lat_1))
      return false;
    if (!equals(this.lon_1, tmp0_other_with_cast.lon_1))
      return false;
    if (!(this.count_1 === tmp0_other_with_cast.count_1))
      return false;
    return true;
  };
  HeatmapPointBase.$metadata$ = {
    simpleName: 'HeatmapPointBase',
    kind: 'class',
    interfaces: [HeatmapPoint]
  };
  Object.defineProperty(HeatmapPointBase.prototype, 'lat', {
    configurable: true,
    get: function () {
      return this._get_lat__857165522_e6c15e_k$();
    }
  });
  Object.defineProperty(HeatmapPointBase.prototype, 'lon', {
    configurable: true,
    get: function () {
      return this._get_lon__857178790_e6cbdy_k$();
    }
  });
  Object.defineProperty(HeatmapPointBase.prototype, 'count', {
    configurable: true,
    get: function () {
      return this._get_count__3152659618_iw3m8u_k$();
    }
  });
  function HeatmapPointsData() {
  }
  HeatmapPointsData.$metadata$ = {
    simpleName: 'HeatmapPointsData',
    kind: 'interface',
    interfaces: []
  };
  function HeatmapPointsDataBase_init_$Init$(deliveryPoints, horsZonePoints, hubs, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      horsZonePoints = emptyList();
    HeatmapPointsDataBase.call($this, deliveryPoints, horsZonePoints, hubs);
    return $this;
  }
  function HeatmapPointsDataBase_init_$Create$(deliveryPoints, horsZonePoints, hubs, $mask0, $marker) {
    return HeatmapPointsDataBase_init_$Init$(deliveryPoints, horsZonePoints, hubs, $mask0, $marker, Object.create(HeatmapPointsDataBase.prototype));
  }
  function HeatmapPointsDataBase(deliveryPoints, horsZonePoints, hubs) {
    var horsZonePoints_0 = horsZonePoints === void 1 ? emptyList() : horsZonePoints;
    this.deliveryPoints_1 = deliveryPoints;
    this.horsZonePoints_1 = horsZonePoints_0;
    this.hubs_1 = hubs;
  }
  HeatmapPointsDataBase.prototype._get_deliveryPoints__899908340_evs5pw_k$ = function () {
    return this.deliveryPoints_1;
  };
  HeatmapPointsDataBase.prototype._get_horsZonePoints__653216148_aswot0_k$ = function () {
    return this.horsZonePoints_1;
  };
  HeatmapPointsDataBase.prototype._get_hubs__799213549_d7tx4d_k$ = function () {
    return this.hubs_1;
  };
  HeatmapPointsDataBase.prototype.component1 = function () {
    return this.deliveryPoints_1;
  };
  HeatmapPointsDataBase.prototype.component2 = function () {
    return this.horsZonePoints_1;
  };
  HeatmapPointsDataBase.prototype.component3 = function () {
    return this.hubs_1;
  };
  HeatmapPointsDataBase.prototype.copy = function (deliveryPoints, horsZonePoints, hubs) {
    return this.copy_rayk6d_k$(deliveryPoints === void 1 ? this.deliveryPoints_1 : deliveryPoints, horsZonePoints === void 1 ? this.horsZonePoints_1 : horsZonePoints, hubs === void 1 ? this.hubs_1 : hubs);
  };
  HeatmapPointsDataBase.prototype.copy_rayk6d_k$ = function (deliveryPoints, horsZonePoints, hubs) {
    return new HeatmapPointsDataBase(deliveryPoints, horsZonePoints, hubs);
  };
  HeatmapPointsDataBase.prototype.copy$default_i4w2xr_k$ = function (deliveryPoints, horsZonePoints, hubs, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      deliveryPoints = this.deliveryPoints_1;
    if (!(($mask0 & 2) === 0))
      horsZonePoints = this.horsZonePoints_1;
    if (!(($mask0 & 4) === 0))
      hubs = this.hubs_1;
    return this.copy_rayk6d_k$(deliveryPoints, horsZonePoints, hubs);
  };
  HeatmapPointsDataBase.prototype.toString = function () {
    return 'HeatmapPointsDataBase(deliveryPoints=' + this.deliveryPoints_1 + ', horsZonePoints=' + this.horsZonePoints_1 + ', hubs=' + this.hubs_1 + ')';
  };
  HeatmapPointsDataBase.prototype.hashCode = function () {
    var result = hashCode(this.deliveryPoints_1);
    result = imul(result, 31) + hashCode(this.horsZonePoints_1) | 0;
    result = imul(result, 31) + hashCode(this.hubs_1) | 0;
    return result;
  };
  HeatmapPointsDataBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeatmapPointsDataBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HeatmapPointsDataBase ? other : THROW_CCE();
    if (!equals(this.deliveryPoints_1, tmp0_other_with_cast.deliveryPoints_1))
      return false;
    if (!equals(this.horsZonePoints_1, tmp0_other_with_cast.horsZonePoints_1))
      return false;
    if (!equals(this.hubs_1, tmp0_other_with_cast.hubs_1))
      return false;
    return true;
  };
  HeatmapPointsDataBase.$metadata$ = {
    simpleName: 'HeatmapPointsDataBase',
    kind: 'class',
    interfaces: [HeatmapPointsData]
  };
  Object.defineProperty(HeatmapPointsDataBase.prototype, 'deliveryPoints', {
    configurable: true,
    get: function () {
      return this._get_deliveryPoints__899908340_evs5pw_k$();
    }
  });
  Object.defineProperty(HeatmapPointsDataBase.prototype, 'horsZonePoints', {
    configurable: true,
    get: function () {
      return this._get_horsZonePoints__653216148_aswot0_k$();
    }
  });
  Object.defineProperty(HeatmapPointsDataBase.prototype, 'hubs', {
    configurable: true,
    get: function () {
      return this._get_hubs__799213549_d7tx4d_k$();
    }
  });
  function HeatMatrixCell() {
  }
  HeatMatrixCell.$metadata$ = {
    simpleName: 'HeatMatrixCell',
    kind: 'interface',
    interfaces: []
  };
  function HeatMatrixCellBase(row, col, count) {
    this.row_1 = row;
    this.col_1 = col;
    this.count_1 = count;
  }
  HeatMatrixCellBase.prototype._get_row__857357815_e6g5iv_k$ = function () {
    return this.row_1;
  };
  HeatMatrixCellBase.prototype._get_col__856910609_e66kgh_k$ = function () {
    return this.col_1;
  };
  HeatMatrixCellBase.prototype._get_count__3152659618_iw3m8u_k$ = function () {
    return this.count_1;
  };
  HeatMatrixCellBase.prototype.component1 = function () {
    return this.row_1;
  };
  HeatMatrixCellBase.prototype.component2 = function () {
    return this.col_1;
  };
  HeatMatrixCellBase.prototype.component3 = function () {
    return this.count_1;
  };
  HeatMatrixCellBase.prototype.copy = function (row, col, count) {
    return this.copy_n318ac_k$(row === void 1 ? this.row_1 : row, col === void 1 ? this.col_1 : col, count === void 1 ? this.count_1 : count);
  };
  HeatMatrixCellBase.prototype.copy_n318ac_k$ = function (row, col, count) {
    return new HeatMatrixCellBase(row, col, count);
  };
  HeatMatrixCellBase.prototype.copy$default_80y7u5_k$ = function (row, col, count, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      row = this.row_1;
    if (!(($mask0 & 2) === 0))
      col = this.col_1;
    if (!(($mask0 & 4) === 0))
      count = this.count_1;
    return this.copy_n318ac_k$(row, col, count);
  };
  HeatMatrixCellBase.prototype.toString = function () {
    return 'HeatMatrixCellBase(row=' + this.row_1 + ', col=' + this.col_1 + ', count=' + this.count_1 + ')';
  };
  HeatMatrixCellBase.prototype.hashCode = function () {
    var result = this.row_1;
    result = imul(result, 31) + this.col_1 | 0;
    result = imul(result, 31) + this.count_1 | 0;
    return result;
  };
  HeatMatrixCellBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeatMatrixCellBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HeatMatrixCellBase ? other : THROW_CCE();
    if (!(this.row_1 === tmp0_other_with_cast.row_1))
      return false;
    if (!(this.col_1 === tmp0_other_with_cast.col_1))
      return false;
    if (!(this.count_1 === tmp0_other_with_cast.count_1))
      return false;
    return true;
  };
  HeatMatrixCellBase.$metadata$ = {
    simpleName: 'HeatMatrixCellBase',
    kind: 'class',
    interfaces: [HeatMatrixCell]
  };
  Object.defineProperty(HeatMatrixCellBase.prototype, 'row', {
    configurable: true,
    get: function () {
      return this._get_row__857357815_e6g5iv_k$();
    }
  });
  Object.defineProperty(HeatMatrixCellBase.prototype, 'col', {
    configurable: true,
    get: function () {
      return this._get_col__856910609_e66kgh_k$();
    }
  });
  Object.defineProperty(HeatMatrixCellBase.prototype, 'count', {
    configurable: true,
    get: function () {
      return this._get_count__3152659618_iw3m8u_k$();
    }
  });
  function HeatMatricesData() {
  }
  HeatMatricesData.$metadata$ = {
    simpleName: 'HeatMatricesData',
    kind: 'interface',
    interfaces: []
  };
  function HeatMatricesDataBase(hourDayOfWeek, yearMonth) {
    this.hourDayOfWeek_1 = hourDayOfWeek;
    this.yearMonth_1 = yearMonth;
  }
  HeatMatricesDataBase.prototype._get_hourDayOfWeek__1328804238_lz4vwu_k$ = function () {
    return this.hourDayOfWeek_1;
  };
  HeatMatricesDataBase.prototype._get_yearMonth__475050606_7utze6_k$ = function () {
    return this.yearMonth_1;
  };
  HeatMatricesDataBase.prototype.component1 = function () {
    return this.hourDayOfWeek_1;
  };
  HeatMatricesDataBase.prototype.component2 = function () {
    return this.yearMonth_1;
  };
  HeatMatricesDataBase.prototype.copy = function (hourDayOfWeek, yearMonth) {
    return this.copy_oshz1x_k$(hourDayOfWeek === void 1 ? this.hourDayOfWeek_1 : hourDayOfWeek, yearMonth === void 1 ? this.yearMonth_1 : yearMonth);
  };
  HeatMatricesDataBase.prototype.copy_oshz1x_k$ = function (hourDayOfWeek, yearMonth) {
    return new HeatMatricesDataBase(hourDayOfWeek, yearMonth);
  };
  HeatMatricesDataBase.prototype.copy$default_a6scca_k$ = function (hourDayOfWeek, yearMonth, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      hourDayOfWeek = this.hourDayOfWeek_1;
    if (!(($mask0 & 2) === 0))
      yearMonth = this.yearMonth_1;
    return this.copy_oshz1x_k$(hourDayOfWeek, yearMonth);
  };
  HeatMatricesDataBase.prototype.toString = function () {
    return 'HeatMatricesDataBase(hourDayOfWeek=' + this.hourDayOfWeek_1 + ', yearMonth=' + this.yearMonth_1 + ')';
  };
  HeatMatricesDataBase.prototype.hashCode = function () {
    var result = hashCode(this.hourDayOfWeek_1);
    result = imul(result, 31) + hashCode(this.yearMonth_1) | 0;
    return result;
  };
  HeatMatricesDataBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeatMatricesDataBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HeatMatricesDataBase ? other : THROW_CCE();
    if (!equals(this.hourDayOfWeek_1, tmp0_other_with_cast.hourDayOfWeek_1))
      return false;
    if (!equals(this.yearMonth_1, tmp0_other_with_cast.yearMonth_1))
      return false;
    return true;
  };
  HeatMatricesDataBase.$metadata$ = {
    simpleName: 'HeatMatricesDataBase',
    kind: 'class',
    interfaces: [HeatMatricesData]
  };
  Object.defineProperty(HeatMatricesDataBase.prototype, 'hourDayOfWeek', {
    configurable: true,
    get: function () {
      return this._get_hourDayOfWeek__1328804238_lz4vwu_k$();
    }
  });
  Object.defineProperty(HeatMatricesDataBase.prototype, 'yearMonth', {
    configurable: true,
    get: function () {
      return this._get_yearMonth__475050606_7utze6_k$();
    }
  });
  function DeliveryCsvAnalysisQueryStatus_READY_getInstance() {
    DeliveryCsvAnalysisQueryStatus_initEntries();
    return DeliveryCsvAnalysisQueryStatus_READY_instance;
  }
  function DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_getInstance() {
    DeliveryCsvAnalysisQueryStatus_initEntries();
    return DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_instance;
  }
  function DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_getInstance() {
    DeliveryCsvAnalysisQueryStatus_initEntries();
    return DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_instance;
  }
  function DeliveryCsvBonusOverview() {
  }
  DeliveryCsvBonusOverview.$metadata$ = {
    simpleName: 'DeliveryCsvBonusOverview',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvBonusOverviewBase_init_$Init$(operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      operatorId = null;
    if (!(($mask0 & 4) === 0))
      carrierId = null;
    if (!(($mask0 & 1024) === 0))
      nbTours = 0;
    if (!(($mask0 & 2048) === 0))
      averagePointsPerTour = 0.0;
    if (!(($mask0 & 4096) === 0))
      averageApproachDistance = 0.0;
    DeliveryCsvBonusOverviewBase.call($this, operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance);
    return $this;
  }
  function DeliveryCsvBonusOverviewBase_init_$Create$(operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance, $mask0, $marker) {
    return DeliveryCsvBonusOverviewBase_init_$Init$(operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance, $mask0, $marker, Object.create(DeliveryCsvBonusOverviewBase.prototype));
  }
  function DeliveryCsvBonusOverviewBase(operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance) {
    var operatorId_0 = operatorId === void 1 ? null : operatorId;
    var carrierId_0 = carrierId === void 1 ? null : carrierId;
    var nbTours_0 = nbTours === void 1 ? 0 : nbTours;
    var averagePointsPerTour_0 = averagePointsPerTour === void 1 ? 0.0 : averagePointsPerTour;
    var averageApproachDistance_0 = averageApproachDistance === void 1 ? 0.0 : averageApproachDistance;
    this.operatorId_1 = operatorId_0;
    this.operatorName_1 = operatorName;
    this.carrierId_1 = carrierId_0;
    this.carrierName_1 = carrierName;
    this.territoryCode_1 = territoryCode;
    this.territoryName_1 = territoryName;
    this.period_1 = period;
    this.duration_1 = duration;
    this.deliveryCount_1 = deliveryCount;
    this.packCount_1 = packCount;
    this.nbTours_1 = nbTours_0;
    this.averagePointsPerTour_1 = averagePointsPerTour_0;
    this.averageApproachDistance_1 = averageApproachDistance_0;
  }
  DeliveryCsvBonusOverviewBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_operatorName__918615516_f6x49o_k$ = function () {
    return this.operatorName_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_carrierName__3612564558_baa9bm_k$ = function () {
    return this.carrierName_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_territoryCode__421324938_6yugei_k$ = function () {
    return this.territoryCode_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_territoryName__431075244_74nfsc_k$ = function () {
    return this.territoryName_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_duration__4153959607_2bya89_k$ = function () {
    return this.duration_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_deliveryCount__2566701750_skyq8a_k$ = function () {
    return this.deliveryCount_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_packCount__2165529243_z7t8x1_k$ = function () {
    return this.packCount_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_nbTours__4148592682_2f5bdi_k$ = function () {
    return this.nbTours_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_averagePointsPerTour__3609714518_bbzcfe_k$ = function () {
    return this.averagePointsPerTour_1;
  };
  DeliveryCsvBonusOverviewBase.prototype._get_averageApproachDistance__1981099095_wrhtuf_k$ = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component1 = function () {
    return this.operatorId_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component2 = function () {
    return this.operatorName_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component3 = function () {
    return this.carrierId_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component4 = function () {
    return this.carrierName_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component5 = function () {
    return this.territoryCode_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component6 = function () {
    return this.territoryName_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component7 = function () {
    return this.period_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component8 = function () {
    return this.duration_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component9 = function () {
    return this.deliveryCount_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component10 = function () {
    return this.packCount_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component11 = function () {
    return this.nbTours_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component12 = function () {
    return this.averagePointsPerTour_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.component13 = function () {
    return this.averageApproachDistance_1;
  };
  DeliveryCsvBonusOverviewBase.prototype.copy = function (operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance) {
    return this.copy_medfey_k$(operatorId === void 1 ? this.operatorId_1 : operatorId, operatorName === void 1 ? this.operatorName_1 : operatorName, carrierId === void 1 ? this.carrierId_1 : carrierId, carrierName === void 1 ? this.carrierName_1 : carrierName, territoryCode === void 1 ? this.territoryCode_1 : territoryCode, territoryName === void 1 ? this.territoryName_1 : territoryName, period === void 1 ? this.period_1 : period, duration === void 1 ? this.duration_1 : duration, deliveryCount === void 1 ? this.deliveryCount_1 : deliveryCount, packCount === void 1 ? this.packCount_1 : packCount, nbTours === void 1 ? this.nbTours_1 : nbTours, averagePointsPerTour === void 1 ? this.averagePointsPerTour_1 : averagePointsPerTour, averageApproachDistance === void 1 ? this.averageApproachDistance_1 : averageApproachDistance);
  };
  DeliveryCsvBonusOverviewBase.prototype.copy_medfey_k$ = function (operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance) {
    return new DeliveryCsvBonusOverviewBase(operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance);
  };
  DeliveryCsvBonusOverviewBase.prototype.copy$default_1fmzqh_k$ = function (operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      operatorId = this.operatorId_1;
    if (!(($mask0 & 2) === 0))
      operatorName = this.operatorName_1;
    if (!(($mask0 & 4) === 0))
      carrierId = this.carrierId_1;
    if (!(($mask0 & 8) === 0))
      carrierName = this.carrierName_1;
    if (!(($mask0 & 16) === 0))
      territoryCode = this.territoryCode_1;
    if (!(($mask0 & 32) === 0))
      territoryName = this.territoryName_1;
    if (!(($mask0 & 64) === 0))
      period = this.period_1;
    if (!(($mask0 & 128) === 0))
      duration = this.duration_1;
    if (!(($mask0 & 256) === 0))
      deliveryCount = this.deliveryCount_1;
    if (!(($mask0 & 512) === 0))
      packCount = this.packCount_1;
    if (!(($mask0 & 1024) === 0))
      nbTours = this.nbTours_1;
    if (!(($mask0 & 2048) === 0))
      averagePointsPerTour = this.averagePointsPerTour_1;
    if (!(($mask0 & 4096) === 0))
      averageApproachDistance = this.averageApproachDistance_1;
    return this.copy_medfey_k$(operatorId, operatorName, carrierId, carrierName, territoryCode, territoryName, period, duration, deliveryCount, packCount, nbTours, averagePointsPerTour, averageApproachDistance);
  };
  DeliveryCsvBonusOverviewBase.prototype.toString = function () {
    return 'DeliveryCsvBonusOverviewBase(operatorId=' + this.operatorId_1 + ', operatorName=' + this.operatorName_1 + ', carrierId=' + this.carrierId_1 + ', carrierName=' + this.carrierName_1 + ', territoryCode=' + this.territoryCode_1 + ', territoryName=' + this.territoryName_1 + ', period=' + this.period_1 + ', duration=' + toString_1(this.duration_1) + ', deliveryCount=' + this.deliveryCount_1 + ', packCount=' + this.packCount_1 + ', nbTours=' + this.nbTours_1 + ', averagePointsPerTour=' + this.averagePointsPerTour_1 + ', averageApproachDistance=' + this.averageApproachDistance_1 + ')';
  };
  DeliveryCsvBonusOverviewBase.prototype.hashCode = function () {
    var result = this.operatorId_1 == null ? 0 : getStringHashCode(this.operatorId_1);
    result = imul(result, 31) + getStringHashCode(this.operatorName_1) | 0;
    result = imul(result, 31) + (this.carrierId_1 == null ? 0 : getStringHashCode(this.carrierId_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.carrierName_1) | 0;
    result = imul(result, 31) + (this.territoryCode_1 == null ? 0 : getStringHashCode(this.territoryCode_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.territoryName_1) | 0;
    result = imul(result, 31) + this.period_1.hashCode() | 0;
    result = imul(result, 31) + this.duration_1.hashCode() | 0;
    result = imul(result, 31) + this.deliveryCount_1 | 0;
    result = imul(result, 31) + this.packCount_1 | 0;
    result = imul(result, 31) + this.nbTours_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.averagePointsPerTour_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.averageApproachDistance_1) | 0;
    return result;
  };
  DeliveryCsvBonusOverviewBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryCsvBonusOverviewBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryCsvBonusOverviewBase ? other : THROW_CCE();
    if (!(this.operatorId_1 == tmp0_other_with_cast.operatorId_1))
      return false;
    if (!(this.operatorName_1 === tmp0_other_with_cast.operatorName_1))
      return false;
    if (!(this.carrierId_1 == tmp0_other_with_cast.carrierId_1))
      return false;
    if (!(this.carrierName_1 === tmp0_other_with_cast.carrierName_1))
      return false;
    if (!(this.territoryCode_1 == tmp0_other_with_cast.territoryCode_1))
      return false;
    if (!(this.territoryName_1 === tmp0_other_with_cast.territoryName_1))
      return false;
    if (!this.period_1.equals(tmp0_other_with_cast.period_1))
      return false;
    if (!this.duration_1.equals(tmp0_other_with_cast.duration_1))
      return false;
    if (!(this.deliveryCount_1 === tmp0_other_with_cast.deliveryCount_1))
      return false;
    if (!(this.packCount_1 === tmp0_other_with_cast.packCount_1))
      return false;
    if (!(this.nbTours_1 === tmp0_other_with_cast.nbTours_1))
      return false;
    if (!equals(this.averagePointsPerTour_1, tmp0_other_with_cast.averagePointsPerTour_1))
      return false;
    if (!equals(this.averageApproachDistance_1, tmp0_other_with_cast.averageApproachDistance_1))
      return false;
    return true;
  };
  DeliveryCsvBonusOverviewBase.$metadata$ = {
    simpleName: 'DeliveryCsvBonusOverviewBase',
    kind: 'class',
    interfaces: [DeliveryCsvBonusOverview]
  };
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'operatorName', {
    configurable: true,
    get: function () {
      return this._get_operatorName__918615516_f6x49o_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'carrierName', {
    configurable: true,
    get: function () {
      return this._get_carrierName__3612564558_baa9bm_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'territoryCode', {
    configurable: true,
    get: function () {
      return this._get_territoryCode__421324938_6yugei_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'territoryName', {
    configurable: true,
    get: function () {
      return this._get_territoryName__431075244_74nfsc_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'duration', {
    configurable: true,
    get: function () {
      return this._get_duration__4153959607_2bya89_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'deliveryCount', {
    configurable: true,
    get: function () {
      return this._get_deliveryCount__2566701750_skyq8a_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'packCount', {
    configurable: true,
    get: function () {
      return this._get_packCount__2165529243_z7t8x1_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'nbTours', {
    configurable: true,
    get: function () {
      return this._get_nbTours__4148592682_2f5bdi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'averagePointsPerTour', {
    configurable: true,
    get: function () {
      return this._get_averagePointsPerTour__3609714518_bbzcfe_k$();
    }
  });
  Object.defineProperty(DeliveryCsvBonusOverviewBase.prototype, 'averageApproachDistance', {
    configurable: true,
    get: function () {
      return this._get_averageApproachDistance__1981099095_wrhtuf_k$();
    }
  });
  var DeliveryCsvError_INVALID_FORMAT_instance;
  var DeliveryCsvError_INVALID_SEPARATOR_instance;
  var DeliveryCsvError_INVALID_COLUMN_HEADER_instance;
  var DeliveryCsvError_MISSING_COLUMN_instance;
  var DeliveryCsvError_EMPTY_COLUMN_instance;
  var DeliveryCsvError_EMPTY_VALUE_instance;
  var DeliveryCsvError_RECURRENT_TOUR_ID_instance;
  var DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_instance;
  var DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_instance;
  var DeliveryCsvError_PERIOD_OVERLAP_instance;
  var DeliveryCsvError_INVERTED_COORDINATE_instance;
  var DeliveryCsvError_INVALID_OPERATOR_ID_instance;
  var DeliveryCsvError_INVALID_CARRIER_ID_instance;
  var DeliveryCsvError_INVALID_VALUE_instance;
  var DeliveryCsvError_NEGATIVE_DURATION_instance;
  var DeliveryCsvError_UNKNOWN_ERROR_instance;
  var DeliveryCsvError_HUB_OUT_OF_TERRITORY_instance;
  var DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_instance;
  function values_1() {
    return [DeliveryCsvError_INVALID_FORMAT_getInstance(), DeliveryCsvError_INVALID_SEPARATOR_getInstance(), DeliveryCsvError_INVALID_COLUMN_HEADER_getInstance(), DeliveryCsvError_MISSING_COLUMN_getInstance(), DeliveryCsvError_EMPTY_COLUMN_getInstance(), DeliveryCsvError_EMPTY_VALUE_getInstance(), DeliveryCsvError_RECURRENT_TOUR_ID_getInstance(), DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_getInstance(), DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_getInstance(), DeliveryCsvError_PERIOD_OVERLAP_getInstance(), DeliveryCsvError_INVERTED_COORDINATE_getInstance(), DeliveryCsvError_INVALID_OPERATOR_ID_getInstance(), DeliveryCsvError_INVALID_CARRIER_ID_getInstance(), DeliveryCsvError_INVALID_VALUE_getInstance(), DeliveryCsvError_NEGATIVE_DURATION_getInstance(), DeliveryCsvError_UNKNOWN_ERROR_getInstance(), DeliveryCsvError_HUB_OUT_OF_TERRITORY_getInstance(), DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'INVALID_FORMAT':
        return DeliveryCsvError_INVALID_FORMAT_getInstance();
      case 'INVALID_SEPARATOR':
        return DeliveryCsvError_INVALID_SEPARATOR_getInstance();
      case 'INVALID_COLUMN_HEADER':
        return DeliveryCsvError_INVALID_COLUMN_HEADER_getInstance();
      case 'MISSING_COLUMN':
        return DeliveryCsvError_MISSING_COLUMN_getInstance();
      case 'EMPTY_COLUMN':
        return DeliveryCsvError_EMPTY_COLUMN_getInstance();
      case 'EMPTY_VALUE':
        return DeliveryCsvError_EMPTY_VALUE_getInstance();
      case 'RECURRENT_TOUR_ID':
        return DeliveryCsvError_RECURRENT_TOUR_ID_getInstance();
      case 'TOUR_ID_USED_BY_MULTIPLE_OPERATORS':
        return DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_getInstance();
      case 'TOUR_ID_IN_MULTIPLE_TERRITORIES':
        return DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_getInstance();
      case 'PERIOD_OVERLAP':
        return DeliveryCsvError_PERIOD_OVERLAP_getInstance();
      case 'INVERTED_COORDINATE':
        return DeliveryCsvError_INVERTED_COORDINATE_getInstance();
      case 'INVALID_OPERATOR_ID':
        return DeliveryCsvError_INVALID_OPERATOR_ID_getInstance();
      case 'INVALID_CARRIER_ID':
        return DeliveryCsvError_INVALID_CARRIER_ID_getInstance();
      case 'INVALID_VALUE':
        return DeliveryCsvError_INVALID_VALUE_getInstance();
      case 'NEGATIVE_DURATION':
        return DeliveryCsvError_NEGATIVE_DURATION_getInstance();
      case 'UNKNOWN_ERROR':
        return DeliveryCsvError_UNKNOWN_ERROR_getInstance();
      case 'HUB_OUT_OF_TERRITORY':
        return DeliveryCsvError_HUB_OUT_OF_TERRITORY_getInstance();
      case 'TOO_MANY_LOW_POINT_TOURS':
        return DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_getInstance();
      default:
        DeliveryCsvError_initEntries();
        THROW_ISE();
        break;
    }
  }
  var DeliveryCsvError_entriesInitialized;
  function DeliveryCsvError_initEntries() {
    if (DeliveryCsvError_entriesInitialized)
      return Unit_getInstance();
    DeliveryCsvError_entriesInitialized = true;
    DeliveryCsvError_INVALID_FORMAT_instance = new DeliveryCsvError('INVALID_FORMAT', 0, "Le format de votre fichier n'est pas valide. Veuillez enregistrer votre fichiers Excel sous le format CVS UTF-8 d\xE9limit\xE9 par des virgules");
    DeliveryCsvError_INVALID_SEPARATOR_instance = new DeliveryCsvError('INVALID_SEPARATOR', 1, 'Veuillez changer les points-virgules qui s\xE9parent vos donn\xE9es. En ouvrant votre fichier sous Bloc-notes vous pouvez remplacer tous les points-virgules par des virgules en cliquant sur ctrl+h, puis enregistrer le fichier');
    DeliveryCsvError_INVALID_COLUMN_HEADER_instance = new DeliveryCsvError('INVALID_COLUMN_HEADER', 2, 'Une colonne ne correspond pas \xE0 celles attendues');
    DeliveryCsvError_MISSING_COLUMN_instance = new DeliveryCsvError('MISSING_COLUMN', 3, 'Il manque une colonne');
    DeliveryCsvError_EMPTY_COLUMN_instance = new DeliveryCsvError('EMPTY_COLUMN', 4, 'Veuillez enlever les sauts de colonnes');
    DeliveryCsvError_EMPTY_VALUE_instance = new DeliveryCsvError('EMPTY_VALUE', 5, 'Un champs est vide');
    DeliveryCsvError_RECURRENT_TOUR_ID_instance = new DeliveryCsvError('RECURRENT_TOUR_ID', 6, 'Un identifiant de tourn\xE9e a d\xE9j\xE0 \xE9t\xE9 utilis\xE9 dans un de vos imports');
    DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_instance = new DeliveryCsvError('TOUR_ID_USED_BY_MULTIPLE_OPERATORS', 7, 'Un identifiant de tourn\xE9e est partag\xE9 par plusieurs op\xE9rateurs');
    DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_instance = new DeliveryCsvError('TOUR_ID_IN_MULTIPLE_TERRITORIES', 8, 'Un identifiant de tourn\xE9e est partag\xE9 entre plusieurs territoires');
    DeliveryCsvError_PERIOD_OVERLAP_instance = new DeliveryCsvError('PERIOD_OVERLAP', 9, 'Le fichier contient des dates sur plusieurs mois');
    DeliveryCsvError_INVERTED_COORDINATE_instance = new DeliveryCsvError('INVERTED_COORDINATE', 10, 'Latitude et longitude invers\xE9es');
    DeliveryCsvError_INVALID_OPERATOR_ID_instance = new DeliveryCsvError('INVALID_OPERATOR_ID', 11, 'Un identifiant ne correspond pas \xE0 ceux de vos op\xE9rateurs');
    DeliveryCsvError_INVALID_CARRIER_ID_instance = new DeliveryCsvError('INVALID_CARRIER_ID', 12, 'Un identifiant ne correspond pas \xE0 ceux de vos transporteurs');
    DeliveryCsvError_INVALID_VALUE_instance = new DeliveryCsvError('INVALID_VALUE', 13, 'Une valeur ne correspond pas au format attendu');
    DeliveryCsvError_NEGATIVE_DURATION_instance = new DeliveryCsvError('NEGATIVE_DURATION', 14, 'Une date de d\xE9chargement est ant\xE9rieure ou \xE9gale \xE0 la date de chargement');
    DeliveryCsvError_UNKNOWN_ERROR_instance = new DeliveryCsvError('UNKNOWN_ERROR', 15, "Une erreur est survenue durant l'analyse du fichier");
    DeliveryCsvError_HUB_OUT_OF_TERRITORY_instance = new DeliveryCsvError('HUB_OUT_OF_TERRITORY', 16, 'Hub de tourn\xE9e hors zone ou en dehors du territoire de la tourn\xE9e');
    DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_instance = new DeliveryCsvError('TOO_MANY_LOW_POINT_TOURS', 17, 'Un trop grand nombre de tourn\xE9es, voire la totalit\xE9, ne comporte pas suffisamment de points. V\xE9rifiez que les tour_id sont bien d\xE9finis par tourn\xE9e et non par point de livraison');
  }
  function DeliveryCsvError(name, ordinal, label) {
    Enum.call(this, name, ordinal);
    this.label_1 = label;
  }
  DeliveryCsvError.prototype._get_label__3396817757_euqgmb_k$ = function () {
    return this.label_1;
  };
  DeliveryCsvError.$metadata$ = {
    simpleName: 'DeliveryCsvError',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(DeliveryCsvError.prototype, 'label', {
    configurable: true,
    get: DeliveryCsvError.prototype._get_label__3396817757_euqgmb_k$
  });
  Object.defineProperty(DeliveryCsvError.prototype, 'name', {
    configurable: true,
    get: DeliveryCsvError.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(DeliveryCsvError.prototype, 'ordinal', {
    configurable: true,
    get: DeliveryCsvError.prototype._get_ordinal__3363892928_fec5kw_k$
  });
  function DeliveryCsvError_INVALID_FORMAT_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVALID_FORMAT_instance;
  }
  function DeliveryCsvError_INVALID_SEPARATOR_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVALID_SEPARATOR_instance;
  }
  function DeliveryCsvError_INVALID_COLUMN_HEADER_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVALID_COLUMN_HEADER_instance;
  }
  function DeliveryCsvError_MISSING_COLUMN_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_MISSING_COLUMN_instance;
  }
  function DeliveryCsvError_EMPTY_COLUMN_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_EMPTY_COLUMN_instance;
  }
  function DeliveryCsvError_EMPTY_VALUE_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_EMPTY_VALUE_instance;
  }
  function DeliveryCsvError_RECURRENT_TOUR_ID_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_RECURRENT_TOUR_ID_instance;
  }
  function DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_instance;
  }
  function DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_instance;
  }
  function DeliveryCsvError_PERIOD_OVERLAP_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_PERIOD_OVERLAP_instance;
  }
  function DeliveryCsvError_INVERTED_COORDINATE_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVERTED_COORDINATE_instance;
  }
  function DeliveryCsvError_INVALID_OPERATOR_ID_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVALID_OPERATOR_ID_instance;
  }
  function DeliveryCsvError_INVALID_CARRIER_ID_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVALID_CARRIER_ID_instance;
  }
  function DeliveryCsvError_INVALID_VALUE_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_INVALID_VALUE_instance;
  }
  function DeliveryCsvError_NEGATIVE_DURATION_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_NEGATIVE_DURATION_instance;
  }
  function DeliveryCsvError_UNKNOWN_ERROR_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_UNKNOWN_ERROR_instance;
  }
  function DeliveryCsvError_HUB_OUT_OF_TERRITORY_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_HUB_OUT_OF_TERRITORY_instance;
  }
  function DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_getInstance() {
    DeliveryCsvError_initEntries();
    return DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_instance;
  }
  function DeliveryCsvLineError() {
  }
  DeliveryCsvLineError.$metadata$ = {
    simpleName: 'DeliveryCsvLineError',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvLineErrorBase_init_$Init$(error, value, line, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      value = '';
    DeliveryCsvLineErrorBase.call($this, error, value, line);
    return $this;
  }
  function DeliveryCsvLineErrorBase_init_$Create$(error, value, line, $mask0, $marker) {
    return DeliveryCsvLineErrorBase_init_$Init$(error, value, line, $mask0, $marker, Object.create(DeliveryCsvLineErrorBase.prototype));
  }
  function DeliveryCsvLineErrorBase(error, value, line) {
    var value_0 = value === void 1 ? '' : value;
    this.error_1 = error;
    this.value_1 = value_0;
    this.line_1 = line;
  }
  DeliveryCsvLineErrorBase.prototype._get_error__3212600009_hwevxz_k$ = function () {
    return this.error_1;
  };
  DeliveryCsvLineErrorBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  DeliveryCsvLineErrorBase.prototype._get_line__802561239_d9to7r_k$ = function () {
    return this.line_1;
  };
  DeliveryCsvLineErrorBase.$metadata$ = {
    simpleName: 'DeliveryCsvLineErrorBase',
    kind: 'class',
    interfaces: [DeliveryCsvLineError]
  };
  Object.defineProperty(DeliveryCsvLineErrorBase.prototype, 'error', {
    configurable: true,
    get: function () {
      return this._get_error__3212600009_hwevxz_k$();
    }
  });
  Object.defineProperty(DeliveryCsvLineErrorBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  Object.defineProperty(DeliveryCsvLineErrorBase.prototype, 'line', {
    configurable: true,
    get: function () {
      return this._get_line__802561239_d9to7r_k$();
    }
  });
  function DeliveryCsvScan() {
  }
  DeliveryCsvScan.$metadata$ = {
    simpleName: 'DeliveryCsvScan',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvScanBase(id, organizationId, result, file) {
    this.id_1 = id;
    this.organizationId_1 = organizationId;
    this.result_1 = result;
    this.file_1 = file;
  }
  DeliveryCsvScanBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  DeliveryCsvScanBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  DeliveryCsvScanBase.prototype._get_result__3382885006_f31376_k$ = function () {
    return this.result_1;
  };
  DeliveryCsvScanBase.prototype._get_file__797018191_d6iv67_k$ = function () {
    return this.file_1;
  };
  DeliveryCsvScanBase.$metadata$ = {
    simpleName: 'DeliveryCsvScanBase',
    kind: 'class',
    interfaces: [DeliveryCsvScan]
  };
  Object.defineProperty(DeliveryCsvScanBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScanBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScanBase.prototype, 'result', {
    configurable: true,
    get: function () {
      return this._get_result__3382885006_f31376_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScanBase.prototype, 'file', {
    configurable: true,
    get: function () {
      return this._get_file__797018191_d6iv67_k$();
    }
  });
  function CarrierPackageCount() {
  }
  CarrierPackageCount.$metadata$ = {
    simpleName: 'CarrierPackageCount',
    kind: 'interface',
    interfaces: []
  };
  function CarrierPackageCountBase(carrierId, packageCount) {
    this.carrierId_1 = carrierId;
    this.packageCount_1 = packageCount;
  }
  CarrierPackageCountBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  CarrierPackageCountBase.prototype._get_packageCount__877172226_ei8uf6_k$ = function () {
    return this.packageCount_1;
  };
  CarrierPackageCountBase.prototype.component1 = function () {
    return this.carrierId_1;
  };
  CarrierPackageCountBase.prototype.component2 = function () {
    return this.packageCount_1;
  };
  CarrierPackageCountBase.prototype.copy = function (carrierId, packageCount) {
    return this.copy_ftyo7h_k$(carrierId === void 1 ? this.carrierId_1 : carrierId, packageCount === void 1 ? this.packageCount_1 : packageCount);
  };
  CarrierPackageCountBase.prototype.copy_ftyo7h_k$ = function (carrierId, packageCount) {
    return new CarrierPackageCountBase(carrierId, packageCount);
  };
  CarrierPackageCountBase.prototype.copy$default_9ke13l_k$ = function (carrierId, packageCount, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      carrierId = this.carrierId_1;
    if (!(($mask0 & 2) === 0))
      packageCount = this.packageCount_1;
    return this.copy_ftyo7h_k$(carrierId, packageCount);
  };
  CarrierPackageCountBase.prototype.toString = function () {
    return 'CarrierPackageCountBase(carrierId=' + this.carrierId_1 + ', packageCount=' + this.packageCount_1 + ')';
  };
  CarrierPackageCountBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.carrierId_1);
    result = imul(result, 31) + this.packageCount_1 | 0;
    return result;
  };
  CarrierPackageCountBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CarrierPackageCountBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CarrierPackageCountBase ? other : THROW_CCE();
    if (!(this.carrierId_1 === tmp0_other_with_cast.carrierId_1))
      return false;
    if (!(this.packageCount_1 === tmp0_other_with_cast.packageCount_1))
      return false;
    return true;
  };
  CarrierPackageCountBase.$metadata$ = {
    simpleName: 'CarrierPackageCountBase',
    kind: 'class',
    interfaces: [CarrierPackageCount]
  };
  Object.defineProperty(CarrierPackageCountBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(CarrierPackageCountBase.prototype, 'packageCount', {
    configurable: true,
    get: function () {
      return this._get_packageCount__877172226_ei8uf6_k$();
    }
  });
  function CsvHubPoint() {
  }
  CsvHubPoint.$metadata$ = {
    simpleName: 'CsvHubPoint',
    kind: 'interface',
    interfaces: []
  };
  function CsvHubPointBase_init_$Init$(location, operatorId, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      operatorId = null;
    CsvHubPointBase.call($this, location, operatorId);
    return $this;
  }
  function CsvHubPointBase_init_$Create$(location, operatorId, $mask0, $marker) {
    return CsvHubPointBase_init_$Init$(location, operatorId, $mask0, $marker, Object.create(CsvHubPointBase.prototype));
  }
  function CsvHubPointBase(location, operatorId) {
    var operatorId_0 = operatorId === void 1 ? null : operatorId;
    this.location_1 = location;
    this.operatorId_1 = operatorId_0;
  }
  CsvHubPointBase.prototype._get_location__284645046_4pgxiu_k$ = function () {
    return this.location_1;
  };
  CsvHubPointBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  CsvHubPointBase.prototype.component1 = function () {
    return this.location_1;
  };
  CsvHubPointBase.prototype.component2 = function () {
    return this.operatorId_1;
  };
  CsvHubPointBase.prototype.copy = function (location, operatorId) {
    return this.copy_naaiij_k$(location === void 1 ? this.location_1 : location, operatorId === void 1 ? this.operatorId_1 : operatorId);
  };
  CsvHubPointBase.prototype.copy_naaiij_k$ = function (location, operatorId) {
    return new CsvHubPointBase(location, operatorId);
  };
  CsvHubPointBase.prototype.copy$default_srpxl_k$ = function (location, operatorId, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      location = this.location_1;
    if (!(($mask0 & 2) === 0))
      operatorId = this.operatorId_1;
    return this.copy_naaiij_k$(location, operatorId);
  };
  CsvHubPointBase.prototype.toString = function () {
    return 'CsvHubPointBase(location=' + this.location_1 + ', operatorId=' + this.operatorId_1 + ')';
  };
  CsvHubPointBase.prototype.hashCode = function () {
    var result = this.location_1.hashCode();
    result = imul(result, 31) + (this.operatorId_1 == null ? 0 : getStringHashCode(this.operatorId_1)) | 0;
    return result;
  };
  CsvHubPointBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CsvHubPointBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CsvHubPointBase ? other : THROW_CCE();
    if (!this.location_1.equals(tmp0_other_with_cast.location_1))
      return false;
    if (!(this.operatorId_1 == tmp0_other_with_cast.operatorId_1))
      return false;
    return true;
  };
  CsvHubPointBase.$metadata$ = {
    simpleName: 'CsvHubPointBase',
    kind: 'class',
    interfaces: [CsvHubPoint]
  };
  Object.defineProperty(CsvHubPointBase.prototype, 'location', {
    configurable: true,
    get: function () {
      return this._get_location__284645046_4pgxiu_k$();
    }
  });
  Object.defineProperty(CsvHubPointBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  function CsvDeliveryPoint() {
  }
  CsvDeliveryPoint.$metadata$ = {
    simpleName: 'CsvDeliveryPoint',
    kind: 'interface',
    interfaces: []
  };
  function CsvDeliveryPointBase_init_$Init$(location, deliveryTime, hubTime, operatorId, carrierPackages, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      hubTime = new Long(0, 0);
    if (!(($mask0 & 8) === 0))
      operatorId = null;
    if (!(($mask0 & 16) === 0))
      carrierPackages = emptyList();
    CsvDeliveryPointBase.call($this, location, deliveryTime, hubTime, operatorId, carrierPackages);
    return $this;
  }
  function CsvDeliveryPointBase_init_$Create$(location, deliveryTime, hubTime, operatorId, carrierPackages, $mask0, $marker) {
    return CsvDeliveryPointBase_init_$Init$(location, deliveryTime, hubTime, operatorId, carrierPackages, $mask0, $marker, Object.create(CsvDeliveryPointBase.prototype));
  }
  function CsvDeliveryPointBase(location, deliveryTime, hubTime, operatorId, carrierPackages) {
    var hubTime_0 = hubTime === void 1 ? new Long(0, 0) : hubTime;
    var operatorId_0 = operatorId === void 1 ? null : operatorId;
    var carrierPackages_0 = carrierPackages === void 1 ? emptyList() : carrierPackages;
    this.location_1 = location;
    this.deliveryTime_1 = deliveryTime;
    this.hubTime_1 = hubTime_0;
    this.operatorId_1 = operatorId_0;
    this.carrierPackages_1 = carrierPackages_0;
  }
  CsvDeliveryPointBase.prototype._get_location__284645046_4pgxiu_k$ = function () {
    return this.location_1;
  };
  CsvDeliveryPointBase.prototype._get_deliveryTime__3700540554_9twmly_k$ = function () {
    return this.deliveryTime_1;
  };
  CsvDeliveryPointBase.prototype._get_hubTime__2339876335_wc0du9_k$ = function () {
    return this.hubTime_1;
  };
  CsvDeliveryPointBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  CsvDeliveryPointBase.prototype._get_carrierPackages__779466924_cw2oj0_k$ = function () {
    return this.carrierPackages_1;
  };
  CsvDeliveryPointBase.prototype.component1 = function () {
    return this.location_1;
  };
  CsvDeliveryPointBase.prototype.component2 = function () {
    return this.deliveryTime_1;
  };
  CsvDeliveryPointBase.prototype.component3 = function () {
    return this.hubTime_1;
  };
  CsvDeliveryPointBase.prototype.component4 = function () {
    return this.operatorId_1;
  };
  CsvDeliveryPointBase.prototype.component5 = function () {
    return this.carrierPackages_1;
  };
  CsvDeliveryPointBase.prototype.copy = function (location, deliveryTime, hubTime, operatorId, carrierPackages) {
    return this.copy_y5t3z5_k$(location === void 1 ? this.location_1 : location, deliveryTime === void 1 ? this.deliveryTime_1 : deliveryTime, hubTime === void 1 ? this.hubTime_1 : hubTime, operatorId === void 1 ? this.operatorId_1 : operatorId, carrierPackages === void 1 ? this.carrierPackages_1 : carrierPackages);
  };
  CsvDeliveryPointBase.prototype.copy_y5t3z5_k$ = function (location, deliveryTime, hubTime, operatorId, carrierPackages) {
    return new CsvDeliveryPointBase(location, deliveryTime, hubTime, operatorId, carrierPackages);
  };
  CsvDeliveryPointBase.prototype.copy$default_kfg33y_k$ = function (location, deliveryTime, hubTime, operatorId, carrierPackages, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      location = this.location_1;
    if (!(($mask0 & 2) === 0))
      deliveryTime = this.deliveryTime_1;
    if (!(($mask0 & 4) === 0))
      hubTime = this.hubTime_1;
    if (!(($mask0 & 8) === 0))
      operatorId = this.operatorId_1;
    if (!(($mask0 & 16) === 0))
      carrierPackages = this.carrierPackages_1;
    return this.copy_y5t3z5_k$(location, deliveryTime, hubTime, operatorId, carrierPackages);
  };
  CsvDeliveryPointBase.prototype.toString = function () {
    return 'CsvDeliveryPointBase(location=' + this.location_1 + ', deliveryTime=' + toString_1(this.deliveryTime_1) + ', hubTime=' + toString_1(this.hubTime_1) + ', operatorId=' + this.operatorId_1 + ', carrierPackages=' + this.carrierPackages_1 + ')';
  };
  CsvDeliveryPointBase.prototype.hashCode = function () {
    var result = this.location_1.hashCode();
    result = imul(result, 31) + this.deliveryTime_1.hashCode() | 0;
    result = imul(result, 31) + this.hubTime_1.hashCode() | 0;
    result = imul(result, 31) + (this.operatorId_1 == null ? 0 : getStringHashCode(this.operatorId_1)) | 0;
    result = imul(result, 31) + hashCode(this.carrierPackages_1) | 0;
    return result;
  };
  CsvDeliveryPointBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CsvDeliveryPointBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CsvDeliveryPointBase ? other : THROW_CCE();
    if (!this.location_1.equals(tmp0_other_with_cast.location_1))
      return false;
    if (!this.deliveryTime_1.equals(tmp0_other_with_cast.deliveryTime_1))
      return false;
    if (!this.hubTime_1.equals(tmp0_other_with_cast.hubTime_1))
      return false;
    if (!(this.operatorId_1 == tmp0_other_with_cast.operatorId_1))
      return false;
    if (!equals(this.carrierPackages_1, tmp0_other_with_cast.carrierPackages_1))
      return false;
    return true;
  };
  CsvDeliveryPointBase.$metadata$ = {
    simpleName: 'CsvDeliveryPointBase',
    kind: 'class',
    interfaces: [CsvDeliveryPoint]
  };
  Object.defineProperty(CsvDeliveryPointBase.prototype, 'location', {
    configurable: true,
    get: function () {
      return this._get_location__284645046_4pgxiu_k$();
    }
  });
  Object.defineProperty(CsvDeliveryPointBase.prototype, 'deliveryTime', {
    configurable: true,
    get: function () {
      return this._get_deliveryTime__3700540554_9twmly_k$();
    }
  });
  Object.defineProperty(CsvDeliveryPointBase.prototype, 'hubTime', {
    configurable: true,
    get: function () {
      return this._get_hubTime__2339876335_wc0du9_k$();
    }
  });
  Object.defineProperty(CsvDeliveryPointBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(CsvDeliveryPointBase.prototype, 'carrierPackages', {
    configurable: true,
    get: function () {
      return this._get_carrierPackages__779466924_cw2oj0_k$();
    }
  });
  function DeliveryCsvScannerResult() {
  }
  DeliveryCsvScannerResult.$metadata$ = {
    simpleName: 'DeliveryCsvScannerResult',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryCsvScannerResultBase_init_$Init$(bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, nbTours, lowAveragePointsAlert, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      hubs = emptySet();
    if (!(($mask0 & 8) === 0))
      deliveryPoints = emptyList();
    if (!(($mask0 & 16) === 0))
      horsZonePoints = emptySet();
    if (!(($mask0 & 32) === 0))
      nbTours = 0;
    if (!(($mask0 & 64) === 0))
      lowAveragePointsAlert = false;
    DeliveryCsvScannerResultBase.call($this, bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, nbTours, lowAveragePointsAlert);
    return $this;
  }
  function DeliveryCsvScannerResultBase_init_$Create$(bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, nbTours, lowAveragePointsAlert, $mask0, $marker) {
    return DeliveryCsvScannerResultBase_init_$Init$(bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, nbTours, lowAveragePointsAlert, $mask0, $marker, Object.create(DeliveryCsvScannerResultBase.prototype));
  }
  function DeliveryCsvScannerResultBase(bonusOverviews, errors, hubs, deliveryPoints, horsZonePoints, nbTours, lowAveragePointsAlert) {
    var hubs_0 = hubs === void 1 ? emptySet() : hubs;
    var deliveryPoints_0 = deliveryPoints === void 1 ? emptyList() : deliveryPoints;
    var horsZonePoints_0 = horsZonePoints === void 1 ? emptySet() : horsZonePoints;
    var nbTours_0 = nbTours === void 1 ? 0 : nbTours;
    var lowAveragePointsAlert_0 = lowAveragePointsAlert === void 1 ? false : lowAveragePointsAlert;
    this.bonusOverviews_1 = bonusOverviews;
    this.errors_1 = errors;
    this.hubs_1 = hubs_0;
    this.deliveryPoints_1 = deliveryPoints_0;
    this.horsZonePoints_1 = horsZonePoints_0;
    this.nbTours_1 = nbTours_0;
    this.lowAveragePointsAlert_1 = lowAveragePointsAlert_0;
  }
  DeliveryCsvScannerResultBase.prototype._get_bonusOverviews__384730288_6d23sg_k$ = function () {
    return this.bonusOverviews_1;
  };
  DeliveryCsvScannerResultBase.prototype._get_errors__806354176_dc2yv4_k$ = function () {
    return this.errors_1;
  };
  DeliveryCsvScannerResultBase.prototype._get_hubs__799213549_d7tx4d_k$ = function () {
    return this.hubs_1;
  };
  DeliveryCsvScannerResultBase.prototype._get_deliveryPoints__899908340_evs5pw_k$ = function () {
    return this.deliveryPoints_1;
  };
  DeliveryCsvScannerResultBase.prototype._get_horsZonePoints__653216148_aswot0_k$ = function () {
    return this.horsZonePoints_1;
  };
  DeliveryCsvScannerResultBase.prototype._get_nbTours__4148592682_2f5bdi_k$ = function () {
    return this.nbTours_1;
  };
  DeliveryCsvScannerResultBase.prototype._get_lowAveragePointsAlert__3139726721_j3stbz_k$ = function () {
    return this.lowAveragePointsAlert_1;
  };
  DeliveryCsvScannerResultBase.$metadata$ = {
    simpleName: 'DeliveryCsvScannerResultBase',
    kind: 'class',
    interfaces: [DeliveryCsvScannerResult]
  };
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'bonusOverviews', {
    configurable: true,
    get: function () {
      return this._get_bonusOverviews__384730288_6d23sg_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'errors', {
    configurable: true,
    get: function () {
      return this._get_errors__806354176_dc2yv4_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'hubs', {
    configurable: true,
    get: function () {
      return this._get_hubs__799213549_d7tx4d_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'deliveryPoints', {
    configurable: true,
    get: function () {
      return this._get_deliveryPoints__899908340_evs5pw_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'horsZonePoints', {
    configurable: true,
    get: function () {
      return this._get_horsZonePoints__653216148_aswot0_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'nbTours', {
    configurable: true,
    get: function () {
      return this._get_nbTours__4148592682_2f5bdi_k$();
    }
  });
  Object.defineProperty(DeliveryCsvScannerResultBase.prototype, 'lowAveragePointsAlert', {
    configurable: true,
    get: function () {
      return this._get_lowAveragePointsAlert__3139726721_j3stbz_k$();
    }
  });
  function DeliveryOverview() {
  }
  DeliveryOverview.$metadata$ = {
    simpleName: 'DeliveryOverview',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryOverviewBase(id, packCountPerCarrier, stamp, declaredDate) {
    this.id_1 = id;
    this.packCountPerCarrier_1 = packCountPerCarrier;
    this.stamp_1 = stamp;
    this.declaredDate_1 = declaredDate;
  }
  DeliveryOverviewBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  DeliveryOverviewBase.prototype._get_packCountPerCarrier__4132838016_2oizr4_k$ = function () {
    return this.packCountPerCarrier_1;
  };
  DeliveryOverviewBase.prototype._get_stamp__3614746734_b8zhjm_k$ = function () {
    return this.stamp_1;
  };
  DeliveryOverviewBase.prototype._get_declaredDate__3318362947_g5g0ql_k$ = function () {
    return this.declaredDate_1;
  };
  DeliveryOverviewBase.prototype.component1 = function () {
    return this.id_1;
  };
  DeliveryOverviewBase.prototype.component2 = function () {
    return this.packCountPerCarrier_1;
  };
  DeliveryOverviewBase.prototype.component3 = function () {
    return this.stamp_1;
  };
  DeliveryOverviewBase.prototype.component4 = function () {
    return this.declaredDate_1;
  };
  DeliveryOverviewBase.prototype.copy = function (id, packCountPerCarrier, stamp, declaredDate) {
    return this.copy_swfd9i_k$(id === void 1 ? this.id_1 : id, packCountPerCarrier === void 1 ? this.packCountPerCarrier_1 : packCountPerCarrier, stamp === void 1 ? this.stamp_1 : stamp, declaredDate === void 1 ? this.declaredDate_1 : declaredDate);
  };
  DeliveryOverviewBase.prototype.copy_swfd9i_k$ = function (id, packCountPerCarrier, stamp, declaredDate) {
    return new DeliveryOverviewBase(id, packCountPerCarrier, stamp, declaredDate);
  };
  DeliveryOverviewBase.prototype.copy$default_3lpsv4_k$ = function (id, packCountPerCarrier, stamp, declaredDate, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      packCountPerCarrier = this.packCountPerCarrier_1;
    if (!(($mask0 & 4) === 0))
      stamp = this.stamp_1;
    if (!(($mask0 & 8) === 0))
      declaredDate = this.declaredDate_1;
    return this.copy_swfd9i_k$(id, packCountPerCarrier, stamp, declaredDate);
  };
  DeliveryOverviewBase.prototype.toString = function () {
    return 'DeliveryOverviewBase(id=' + this.id_1 + ', packCountPerCarrier=' + this.packCountPerCarrier_1 + ', stamp=' + this.stamp_1 + ', declaredDate=' + toString_1(this.declaredDate_1) + ')';
  };
  DeliveryOverviewBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + hashCode(this.packCountPerCarrier_1) | 0;
    result = imul(result, 31) + hashCode(this.stamp_1) | 0;
    result = imul(result, 31) + this.declaredDate_1.hashCode() | 0;
    return result;
  };
  DeliveryOverviewBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeliveryOverviewBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeliveryOverviewBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!equals(this.packCountPerCarrier_1, tmp0_other_with_cast.packCountPerCarrier_1))
      return false;
    if (!equals(this.stamp_1, tmp0_other_with_cast.stamp_1))
      return false;
    if (!this.declaredDate_1.equals(tmp0_other_with_cast.declaredDate_1))
      return false;
    return true;
  };
  DeliveryOverviewBase.$metadata$ = {
    simpleName: 'DeliveryOverviewBase',
    kind: 'class',
    interfaces: [DeliveryOverview]
  };
  Object.defineProperty(DeliveryOverviewBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(DeliveryOverviewBase.prototype, 'packCountPerCarrier', {
    configurable: true,
    get: function () {
      return this._get_packCountPerCarrier__4132838016_2oizr4_k$();
    }
  });
  Object.defineProperty(DeliveryOverviewBase.prototype, 'stamp', {
    configurable: true,
    get: function () {
      return this._get_stamp__3614746734_b8zhjm_k$();
    }
  });
  Object.defineProperty(DeliveryOverviewBase.prototype, 'declaredDate', {
    configurable: true,
    get: function () {
      return this._get_declaredDate__3318362947_g5g0ql_k$();
    }
  });
  function Linestring() {
  }
  Linestring.$metadata$ = {
    simpleName: 'Linestring',
    kind: 'interface',
    interfaces: []
  };
  function LinestringBase(type, coordinates) {
    this.type_1 = type;
    this.coordinates_1 = coordinates;
  }
  LinestringBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  LinestringBase.prototype._get_coordinates__3849109238_7dgaa2_k$ = function () {
    return this.coordinates_1;
  };
  LinestringBase.$metadata$ = {
    simpleName: 'LinestringBase',
    kind: 'class',
    interfaces: [Linestring]
  };
  Object.defineProperty(LinestringBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(LinestringBase.prototype, 'coordinates', {
    configurable: true,
    get: function () {
      return this._get_coordinates__3849109238_7dgaa2_k$();
    }
  });
  function OrganizationExternalRef() {
  }
  OrganizationExternalRef.$metadata$ = {
    simpleName: 'OrganizationExternalRef',
    kind: 'interface',
    interfaces: []
  };
  function OrganizationExternalRefBase(id, name) {
    this.id_1 = id;
    this.name_1 = name;
  }
  OrganizationExternalRefBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  OrganizationExternalRefBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  OrganizationExternalRefBase.$metadata$ = {
    simpleName: 'OrganizationExternalRefBase',
    kind: 'class',
    interfaces: [OrganizationExternalRef]
  };
  Object.defineProperty(OrganizationExternalRefBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(OrganizationExternalRefBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  function Package() {
  }
  Package.$metadata$ = {
    simpleName: 'Package',
    kind: 'interface',
    interfaces: []
  };
  function PackageBase(id, carrierId, weight) {
    this.id_1 = id;
    this.carrierId_1 = carrierId;
    this.weight_1 = weight;
  }
  PackageBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  PackageBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  PackageBase.prototype._get_weight__3515779987_cvworx_k$ = function () {
    return this.weight_1;
  };
  PackageBase.$metadata$ = {
    simpleName: 'PackageBase',
    kind: 'class',
    interfaces: [Package]
  };
  Object.defineProperty(PackageBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(PackageBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(PackageBase.prototype, 'weight', {
    configurable: true,
    get: function () {
      return this._get_weight__3515779987_cvworx_k$();
    }
  });
  function Prediction() {
  }
  Prediction.$metadata$ = {
    simpleName: 'Prediction',
    kind: 'interface',
    interfaces: []
  };
  function PredictionBase(tourId, transportType, prediction, probabilities, error, code, description) {
    this.tourId_1 = tourId;
    this.transportType_1 = transportType;
    this.prediction_1 = prediction;
    this.probabilities_1 = probabilities;
    this.error_1 = error;
    this.code_1 = code;
    this.description_1 = description;
  }
  PredictionBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  PredictionBase.prototype._get_transportType__2443064110_umkpn6_k$ = function () {
    return this.transportType_1;
  };
  PredictionBase.prototype._get_prediction__4047198684_43ijhg_k$ = function () {
    return this.prediction_1;
  };
  PredictionBase.prototype._get_probabilities__1955034014_wbz5we_k$ = function () {
    return this.probabilities_1;
  };
  PredictionBase.prototype._get_error__3212600009_hwevxz_k$ = function () {
    return this.error_1;
  };
  PredictionBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  PredictionBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  PredictionBase.$metadata$ = {
    simpleName: 'PredictionBase',
    kind: 'class',
    interfaces: [Prediction]
  };
  Object.defineProperty(PredictionBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(PredictionBase.prototype, 'transportType', {
    configurable: true,
    get: function () {
      return this._get_transportType__2443064110_umkpn6_k$();
    }
  });
  Object.defineProperty(PredictionBase.prototype, 'prediction', {
    configurable: true,
    get: function () {
      return this._get_prediction__4047198684_43ijhg_k$();
    }
  });
  Object.defineProperty(PredictionBase.prototype, 'probabilities', {
    configurable: true,
    get: function () {
      return this._get_probabilities__1955034014_wbz5we_k$();
    }
  });
  Object.defineProperty(PredictionBase.prototype, 'error', {
    configurable: true,
    get: function () {
      return this._get_error__3212600009_hwevxz_k$();
    }
  });
  Object.defineProperty(PredictionBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(PredictionBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  var ReanalysisJobStatus_PENDING_instance;
  var ReanalysisJobStatus_RUNNING_instance;
  var ReanalysisJobStatus_COMPLETED_instance;
  var ReanalysisJobStatus_FAILED_instance;
  var ReanalysisJobStatus_CANCELLED_instance;
  function values_2() {
    return [ReanalysisJobStatus_PENDING_getInstance(), ReanalysisJobStatus_RUNNING_getInstance(), ReanalysisJobStatus_COMPLETED_getInstance(), ReanalysisJobStatus_FAILED_getInstance(), ReanalysisJobStatus_CANCELLED_getInstance()];
  }
  function valueOf_2(value) {
    switch (value) {
      case 'PENDING':
        return ReanalysisJobStatus_PENDING_getInstance();
      case 'RUNNING':
        return ReanalysisJobStatus_RUNNING_getInstance();
      case 'COMPLETED':
        return ReanalysisJobStatus_COMPLETED_getInstance();
      case 'FAILED':
        return ReanalysisJobStatus_FAILED_getInstance();
      case 'CANCELLED':
        return ReanalysisJobStatus_CANCELLED_getInstance();
      default:
        ReanalysisJobStatus_initEntries();
        THROW_ISE();
        break;
    }
  }
  var ReanalysisJobStatus_entriesInitialized;
  function ReanalysisJobStatus_initEntries() {
    if (ReanalysisJobStatus_entriesInitialized)
      return Unit_getInstance();
    ReanalysisJobStatus_entriesInitialized = true;
    ReanalysisJobStatus_PENDING_instance = new ReanalysisJobStatus('PENDING', 0);
    ReanalysisJobStatus_RUNNING_instance = new ReanalysisJobStatus('RUNNING', 1);
    ReanalysisJobStatus_COMPLETED_instance = new ReanalysisJobStatus('COMPLETED', 2);
    ReanalysisJobStatus_FAILED_instance = new ReanalysisJobStatus('FAILED', 3);
    ReanalysisJobStatus_CANCELLED_instance = new ReanalysisJobStatus('CANCELLED', 4);
  }
  function ReanalysisJobStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ReanalysisJobStatus.$metadata$ = {
    simpleName: 'ReanalysisJobStatus',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(ReanalysisJobStatus.prototype, 'name', {
    configurable: true,
    get: ReanalysisJobStatus.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(ReanalysisJobStatus.prototype, 'ordinal', {
    configurable: true,
    get: ReanalysisJobStatus.prototype._get_ordinal__3363892928_fec5kw_k$
  });
  function ReanalysisProgress() {
  }
  ReanalysisProgress.$metadata$ = {
    simpleName: 'ReanalysisProgress',
    kind: 'interface',
    interfaces: []
  };
  function ReanalysisProgressBase_init_$Init$(jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query, $mask0, $marker, $this) {
    if (!(($mask0 & 1024) === 0))
      creationDate = null;
    if (!(($mask0 & 2048) === 0))
      errorMessage = null;
    if (!(($mask0 & 4096) === 0))
      query = null;
    ReanalysisProgressBase.call($this, jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query);
    return $this;
  }
  function ReanalysisProgressBase_init_$Create$(jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query, $mask0, $marker) {
    return ReanalysisProgressBase_init_$Init$(jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query, $mask0, $marker, Object.create(ReanalysisProgressBase.prototype));
  }
  function ReanalysisProgressBase(jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query) {
    var creationDate_0 = creationDate === void 1 ? null : creationDate;
    var errorMessage_0 = errorMessage === void 1 ? null : errorMessage;
    var query_0 = query === void 1 ? null : query;
    this.jobId_1 = jobId;
    this.totalFiles_1 = totalFiles;
    this.processedFiles_1 = processedFiles;
    this.status_1 = status;
    this.importerNames_1 = importerNames;
    this.operatorNames_1 = operatorNames;
    this.carrierNames_1 = carrierNames;
    this.territoryNames_1 = territoryNames;
    this.uploadMonths_1 = uploadMonths;
    this.contentMonths_1 = contentMonths;
    this.creationDate_1 = creationDate_0;
    this.errorMessage_1 = errorMessage_0;
    this.query_1 = query_0;
  }
  ReanalysisProgressBase.prototype._get_jobId__3352461593_fl561z_k$ = function () {
    return this.jobId_1;
  };
  ReanalysisProgressBase.prototype._get_totalFiles__1290611032_lce9ug_k$ = function () {
    return this.totalFiles_1;
  };
  ReanalysisProgressBase.prototype._get_processedFiles__1293220706_ldy7he_k$ = function () {
    return this.processedFiles_1;
  };
  ReanalysisProgressBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  ReanalysisProgressBase.prototype._get_importerNames__1252705339_kpttmj_k$ = function () {
    return this.importerNames_1;
  };
  ReanalysisProgressBase.prototype._get_operatorNames__2707278925_q99o6r_k$ = function () {
    return this.operatorNames_1;
  };
  ReanalysisProgressBase.prototype._get_carrierNames__320353307_5aqa6z_k$ = function () {
    return this.carrierNames_1;
  };
  ReanalysisProgressBase.prototype._get_territoryNames__478432381_7wugsd_k$ = function () {
    return this.territoryNames_1;
  };
  ReanalysisProgressBase.prototype._get_uploadMonths__2067658871_y713sn_k$ = function () {
    return this.uploadMonths_1;
  };
  ReanalysisProgressBase.prototype._get_contentMonths__2117229189_z0jkhx_k$ = function () {
    return this.contentMonths_1;
  };
  ReanalysisProgressBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  ReanalysisProgressBase.prototype._get_errorMessage__2680430668_qp94fo_k$ = function () {
    return this.errorMessage_1;
  };
  ReanalysisProgressBase.prototype._get_query__3558536201_c6g9vb_k$ = function () {
    return this.query_1;
  };
  ReanalysisProgressBase.prototype.component1 = function () {
    return this.jobId_1;
  };
  ReanalysisProgressBase.prototype.component2 = function () {
    return this.totalFiles_1;
  };
  ReanalysisProgressBase.prototype.component3 = function () {
    return this.processedFiles_1;
  };
  ReanalysisProgressBase.prototype.component4 = function () {
    return this.status_1;
  };
  ReanalysisProgressBase.prototype.component5 = function () {
    return this.importerNames_1;
  };
  ReanalysisProgressBase.prototype.component6 = function () {
    return this.operatorNames_1;
  };
  ReanalysisProgressBase.prototype.component7 = function () {
    return this.carrierNames_1;
  };
  ReanalysisProgressBase.prototype.component8 = function () {
    return this.territoryNames_1;
  };
  ReanalysisProgressBase.prototype.component9 = function () {
    return this.uploadMonths_1;
  };
  ReanalysisProgressBase.prototype.component10 = function () {
    return this.contentMonths_1;
  };
  ReanalysisProgressBase.prototype.component11 = function () {
    return this.creationDate_1;
  };
  ReanalysisProgressBase.prototype.component12 = function () {
    return this.errorMessage_1;
  };
  ReanalysisProgressBase.prototype.component13 = function () {
    return this.query_1;
  };
  ReanalysisProgressBase.prototype.copy = function (jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query) {
    return this.copy_j0mjr7_k$(jobId === void 1 ? this.jobId_1 : jobId, totalFiles === void 1 ? this.totalFiles_1 : totalFiles, processedFiles === void 1 ? this.processedFiles_1 : processedFiles, status === void 1 ? this.status_1 : status, importerNames === void 1 ? this.importerNames_1 : importerNames, operatorNames === void 1 ? this.operatorNames_1 : operatorNames, carrierNames === void 1 ? this.carrierNames_1 : carrierNames, territoryNames === void 1 ? this.territoryNames_1 : territoryNames, uploadMonths === void 1 ? this.uploadMonths_1 : uploadMonths, contentMonths === void 1 ? this.contentMonths_1 : contentMonths, creationDate === void 1 ? this.creationDate_1 : creationDate, errorMessage === void 1 ? this.errorMessage_1 : errorMessage, query === void 1 ? this.query_1 : query);
  };
  ReanalysisProgressBase.prototype.copy_j0mjr7_k$ = function (jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query) {
    return new ReanalysisProgressBase(jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query);
  };
  ReanalysisProgressBase.prototype.copy$default_l5czwk_k$ = function (jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      jobId = this.jobId_1;
    if (!(($mask0 & 2) === 0))
      totalFiles = this.totalFiles_1;
    if (!(($mask0 & 4) === 0))
      processedFiles = this.processedFiles_1;
    if (!(($mask0 & 8) === 0))
      status = this.status_1;
    if (!(($mask0 & 16) === 0))
      importerNames = this.importerNames_1;
    if (!(($mask0 & 32) === 0))
      operatorNames = this.operatorNames_1;
    if (!(($mask0 & 64) === 0))
      carrierNames = this.carrierNames_1;
    if (!(($mask0 & 128) === 0))
      territoryNames = this.territoryNames_1;
    if (!(($mask0 & 256) === 0))
      uploadMonths = this.uploadMonths_1;
    if (!(($mask0 & 512) === 0))
      contentMonths = this.contentMonths_1;
    if (!(($mask0 & 1024) === 0))
      creationDate = this.creationDate_1;
    if (!(($mask0 & 2048) === 0))
      errorMessage = this.errorMessage_1;
    if (!(($mask0 & 4096) === 0))
      query = this.query_1;
    return this.copy_j0mjr7_k$(jobId, totalFiles, processedFiles, status, importerNames, operatorNames, carrierNames, territoryNames, uploadMonths, contentMonths, creationDate, errorMessage, query);
  };
  ReanalysisProgressBase.prototype.toString = function () {
    return 'ReanalysisProgressBase(jobId=' + this.jobId_1 + ', totalFiles=' + this.totalFiles_1 + ', processedFiles=' + this.processedFiles_1 + ', status=' + this.status_1 + ', importerNames=' + this.importerNames_1 + ', operatorNames=' + this.operatorNames_1 + ', carrierNames=' + this.carrierNames_1 + ', territoryNames=' + this.territoryNames_1 + ', uploadMonths=' + this.uploadMonths_1 + ', contentMonths=' + this.contentMonths_1 + ', creationDate=' + toString_0(this.creationDate_1) + ', errorMessage=' + this.errorMessage_1 + ', query=' + this.query_1 + ')';
  };
  ReanalysisProgressBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.jobId_1);
    result = imul(result, 31) + this.totalFiles_1 | 0;
    result = imul(result, 31) + this.processedFiles_1 | 0;
    result = imul(result, 31) + this.status_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.importerNames_1) | 0;
    result = imul(result, 31) + hashCode(this.operatorNames_1) | 0;
    result = imul(result, 31) + hashCode(this.carrierNames_1) | 0;
    result = imul(result, 31) + hashCode(this.territoryNames_1) | 0;
    result = imul(result, 31) + hashCode(this.uploadMonths_1) | 0;
    result = imul(result, 31) + hashCode(this.contentMonths_1) | 0;
    result = imul(result, 31) + (this.creationDate_1 == null ? 0 : this.creationDate_1.hashCode()) | 0;
    result = imul(result, 31) + (this.errorMessage_1 == null ? 0 : getStringHashCode(this.errorMessage_1)) | 0;
    result = imul(result, 31) + (this.query_1 == null ? 0 : this.query_1.hashCode()) | 0;
    return result;
  };
  ReanalysisProgressBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReanalysisProgressBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ReanalysisProgressBase ? other : THROW_CCE();
    if (!(this.jobId_1 === tmp0_other_with_cast.jobId_1))
      return false;
    if (!(this.totalFiles_1 === tmp0_other_with_cast.totalFiles_1))
      return false;
    if (!(this.processedFiles_1 === tmp0_other_with_cast.processedFiles_1))
      return false;
    if (!this.status_1.equals(tmp0_other_with_cast.status_1))
      return false;
    if (!equals(this.importerNames_1, tmp0_other_with_cast.importerNames_1))
      return false;
    if (!equals(this.operatorNames_1, tmp0_other_with_cast.operatorNames_1))
      return false;
    if (!equals(this.carrierNames_1, tmp0_other_with_cast.carrierNames_1))
      return false;
    if (!equals(this.territoryNames_1, tmp0_other_with_cast.territoryNames_1))
      return false;
    if (!equals(this.uploadMonths_1, tmp0_other_with_cast.uploadMonths_1))
      return false;
    if (!equals(this.contentMonths_1, tmp0_other_with_cast.contentMonths_1))
      return false;
    if (!equals(this.creationDate_1, tmp0_other_with_cast.creationDate_1))
      return false;
    if (!(this.errorMessage_1 == tmp0_other_with_cast.errorMessage_1))
      return false;
    if (!equals(this.query_1, tmp0_other_with_cast.query_1))
      return false;
    return true;
  };
  ReanalysisProgressBase.$metadata$ = {
    simpleName: 'ReanalysisProgressBase',
    kind: 'class',
    interfaces: [ReanalysisProgress]
  };
  Object.defineProperty(ReanalysisProgressBase.prototype, 'jobId', {
    configurable: true,
    get: function () {
      return this._get_jobId__3352461593_fl561z_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'totalFiles', {
    configurable: true,
    get: function () {
      return this._get_totalFiles__1290611032_lce9ug_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'processedFiles', {
    configurable: true,
    get: function () {
      return this._get_processedFiles__1293220706_ldy7he_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'importerNames', {
    configurable: true,
    get: function () {
      return this._get_importerNames__1252705339_kpttmj_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'operatorNames', {
    configurable: true,
    get: function () {
      return this._get_operatorNames__2707278925_q99o6r_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'carrierNames', {
    configurable: true,
    get: function () {
      return this._get_carrierNames__320353307_5aqa6z_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'territoryNames', {
    configurable: true,
    get: function () {
      return this._get_territoryNames__478432381_7wugsd_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'uploadMonths', {
    configurable: true,
    get: function () {
      return this._get_uploadMonths__2067658871_y713sn_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'contentMonths', {
    configurable: true,
    get: function () {
      return this._get_contentMonths__2117229189_z0jkhx_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'errorMessage', {
    configurable: true,
    get: function () {
      return this._get_errorMessage__2680430668_qp94fo_k$();
    }
  });
  Object.defineProperty(ReanalysisProgressBase.prototype, 'query', {
    configurable: true,
    get: function () {
      return this._get_query__3558536201_c6g9vb_k$();
    }
  });
  function TriggerReanalysisRequest() {
  }
  TriggerReanalysisRequest.$metadata$ = {
    simpleName: 'TriggerReanalysisRequest',
    kind: 'interface',
    interfaces: []
  };
  function TriggerReanalysisRequestBase(query) {
    this.query_1 = query;
  }
  TriggerReanalysisRequestBase.prototype._get_query__3558536201_c6g9vb_k$ = function () {
    return this.query_1;
  };
  TriggerReanalysisRequestBase.prototype.component1 = function () {
    return this.query_1;
  };
  TriggerReanalysisRequestBase.prototype.copy = function (query) {
    return this.copy_ixgsaq_k$(query === void 1 ? this.query_1 : query);
  };
  TriggerReanalysisRequestBase.prototype.copy_ixgsaq_k$ = function (query) {
    return new TriggerReanalysisRequestBase(query);
  };
  TriggerReanalysisRequestBase.prototype.copy$default_ut5mpu_k$ = function (query, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      query = this.query_1;
    return this.copy_ixgsaq_k$(query);
  };
  TriggerReanalysisRequestBase.prototype.toString = function () {
    return 'TriggerReanalysisRequestBase(query=' + this.query_1 + ')';
  };
  TriggerReanalysisRequestBase.prototype.hashCode = function () {
    return this.query_1.hashCode();
  };
  TriggerReanalysisRequestBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TriggerReanalysisRequestBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TriggerReanalysisRequestBase ? other : THROW_CCE();
    if (!this.query_1.equals(tmp0_other_with_cast.query_1))
      return false;
    return true;
  };
  TriggerReanalysisRequestBase.$metadata$ = {
    simpleName: 'TriggerReanalysisRequestBase',
    kind: 'class',
    interfaces: [TriggerReanalysisRequest]
  };
  Object.defineProperty(TriggerReanalysisRequestBase.prototype, 'query', {
    configurable: true,
    get: function () {
      return this._get_query__3558536201_c6g9vb_k$();
    }
  });
  function ReanalysisJobStatus_PENDING_getInstance() {
    ReanalysisJobStatus_initEntries();
    return ReanalysisJobStatus_PENDING_instance;
  }
  function ReanalysisJobStatus_RUNNING_getInstance() {
    ReanalysisJobStatus_initEntries();
    return ReanalysisJobStatus_RUNNING_instance;
  }
  function ReanalysisJobStatus_COMPLETED_getInstance() {
    ReanalysisJobStatus_initEntries();
    return ReanalysisJobStatus_COMPLETED_instance;
  }
  function ReanalysisJobStatus_FAILED_getInstance() {
    ReanalysisJobStatus_initEntries();
    return ReanalysisJobStatus_FAILED_instance;
  }
  function ReanalysisJobStatus_CANCELLED_getInstance() {
    ReanalysisJobStatus_initEntries();
    return ReanalysisJobStatus_CANCELLED_instance;
  }
  function Tour() {
  }
  Tour.$metadata$ = {
    simpleName: 'Tour',
    kind: 'interface',
    interfaces: []
  };
  function TourBase(id, externalId, operatorId, trips, transportType, acceptedByAi, importedBy) {
    this.id_1 = id;
    this.externalId_1 = externalId;
    this.operatorId_1 = operatorId;
    this.trips_1 = trips;
    this.transportType_1 = transportType;
    this.acceptedByAi_1 = acceptedByAi;
    this.importedBy_1 = importedBy;
  }
  TourBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  TourBase.prototype._get_externalId__1255568133_krj6kl_k$ = function () {
    return this.externalId_1;
  };
  TourBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  TourBase.prototype._get_trips__3641770147_aswa59_k$ = function () {
    return this.trips_1;
  };
  TourBase.prototype._get_transportType__2443064110_umkpn6_k$ = function () {
    return this.transportType_1;
  };
  TourBase.prototype._get_acceptedByAi__3163460325_ipo4d7_k$ = function () {
    return this.acceptedByAi_1;
  };
  TourBase.prototype._get_importedBy__3882687856_6tgkuo_k$ = function () {
    return this.importedBy_1;
  };
  TourBase.$metadata$ = {
    simpleName: 'TourBase',
    kind: 'class',
    interfaces: [Tour]
  };
  Object.defineProperty(TourBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(TourBase.prototype, 'externalId', {
    configurable: true,
    get: function () {
      return this._get_externalId__1255568133_krj6kl_k$();
    }
  });
  Object.defineProperty(TourBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(TourBase.prototype, 'trips', {
    configurable: true,
    get: function () {
      return this._get_trips__3641770147_aswa59_k$();
    }
  });
  Object.defineProperty(TourBase.prototype, 'transportType', {
    configurable: true,
    get: function () {
      return this._get_transportType__2443064110_umkpn6_k$();
    }
  });
  Object.defineProperty(TourBase.prototype, 'acceptedByAi', {
    configurable: true,
    get: function () {
      return this._get_acceptedByAi__3163460325_ipo4d7_k$();
    }
  });
  Object.defineProperty(TourBase.prototype, 'importedBy', {
    configurable: true,
    get: function () {
      return this._get_importedBy__3882687856_6tgkuo_k$();
    }
  });
  function TourAudition() {
  }
  TourAudition.$metadata$ = {
    simpleName: 'TourAudition',
    kind: 'interface',
    interfaces: []
  };
  function TourAuditionBase(isActive, date, code, description, activeProbabilities, nonActiveProbabilities) {
    this.isActive_1 = isActive;
    this.date_1 = date;
    this.code_1 = code;
    this.description_1 = description;
    this.activeProbabilities_1 = activeProbabilities;
    this.nonActiveProbabilities_1 = nonActiveProbabilities;
  }
  TourAuditionBase.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return this.isActive_1;
  };
  TourAuditionBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  TourAuditionBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  TourAuditionBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  TourAuditionBase.prototype._set_activeProbabilities__2623190136_3ugxle_k$ = function (_set____804775014) {
    this.activeProbabilities_1 = _set____804775014;
  };
  TourAuditionBase.prototype._get_activeProbabilities__3427271172_eclqm4_k$ = function () {
    return this.activeProbabilities_1;
  };
  TourAuditionBase.prototype._set_nonActiveProbabilities__3277967351_girh1p_k$ = function (_set____804775014) {
    this.nonActiveProbabilities_1 = _set____804775014;
  };
  TourAuditionBase.prototype._get_nonActiveProbabilities__328533739_5flm97_k$ = function () {
    return this.nonActiveProbabilities_1;
  };
  TourAuditionBase.$metadata$ = {
    simpleName: 'TourAuditionBase',
    kind: 'class',
    interfaces: [TourAudition]
  };
  Object.defineProperty(TourAuditionBase.prototype, 'isActive', {
    configurable: true,
    get: function () {
      return this._get_isActive__4035225851_4an5s5_k$();
    }
  });
  Object.defineProperty(TourAuditionBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(TourAuditionBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(TourAuditionBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(TourAuditionBase.prototype, 'activeProbabilities', {
    configurable: true,
    get: function () {
      return this._get_activeProbabilities__3427271172_eclqm4_k$();
    },
    set: function (value) {
      this._set_activeProbabilities__2623190136_3ugxle_k$(value);
    }
  });
  Object.defineProperty(TourAuditionBase.prototype, 'nonActiveProbabilities', {
    configurable: true,
    get: function () {
      return this._get_nonActiveProbabilities__328533739_5flm97_k$();
    },
    set: function (value) {
      this._set_nonActiveProbabilities__3277967351_girh1p_k$(value);
    }
  });
  function TourFinder() {
  }
  TourFinder.$metadata$ = {
    simpleName: 'TourFinder',
    kind: 'interface',
    interfaces: []
  };
  function TourOverview() {
  }
  TourOverview.$metadata$ = {
    simpleName: 'TourOverview',
    kind: 'interface',
    interfaces: []
  };
  function TourOverviewBase(id, operatorId, carrierIds, duration, startingPoint, deliveries, audition, type) {
    this.id_1 = id;
    this.operatorId_1 = operatorId;
    this.carrierIds_1 = carrierIds;
    this.duration_1 = duration;
    this.startingPoint_1 = startingPoint;
    this.deliveries_1 = deliveries;
    this.audition_1 = audition;
    this.type_1 = type;
  }
  TourOverviewBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  TourOverviewBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  TourOverviewBase.prototype._get_carrierIds__1640409067_r4nnqj_k$ = function () {
    return this.carrierIds_1;
  };
  TourOverviewBase.prototype._get_duration__4153959607_2bya89_k$ = function () {
    return this.duration_1;
  };
  TourOverviewBase.prototype._get_startingPoint__3708070305_9pf8m7_k$ = function () {
    return this.startingPoint_1;
  };
  TourOverviewBase.prototype._get_deliveries__1460372281_o5gugp_k$ = function () {
    return this.deliveries_1;
  };
  TourOverviewBase.prototype._get_audition__1675271966_rpew4e_k$ = function () {
    return this.audition_1;
  };
  TourOverviewBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  TourOverviewBase.prototype.component1 = function () {
    return this.id_1;
  };
  TourOverviewBase.prototype.component2 = function () {
    return this.operatorId_1;
  };
  TourOverviewBase.prototype.component3 = function () {
    return this.carrierIds_1;
  };
  TourOverviewBase.prototype.component4 = function () {
    return this.duration_1;
  };
  TourOverviewBase.prototype.component5 = function () {
    return this.startingPoint_1;
  };
  TourOverviewBase.prototype.component6 = function () {
    return this.deliveries_1;
  };
  TourOverviewBase.prototype.component7 = function () {
    return this.audition_1;
  };
  TourOverviewBase.prototype.component8 = function () {
    return this.type_1;
  };
  TourOverviewBase.prototype.copy = function (id, operatorId, carrierIds, duration, startingPoint, deliveries, audition, type) {
    return this.copy_sdqljb_k$(id === void 1 ? this.id_1 : id, operatorId === void 1 ? this.operatorId_1 : operatorId, carrierIds === void 1 ? this.carrierIds_1 : carrierIds, duration === void 1 ? this.duration_1 : duration, startingPoint === void 1 ? this.startingPoint_1 : startingPoint, deliveries === void 1 ? this.deliveries_1 : deliveries, audition === void 1 ? this.audition_1 : audition, type === void 1 ? this.type_1 : type);
  };
  TourOverviewBase.prototype.copy_sdqljb_k$ = function (id, operatorId, carrierIds, duration, startingPoint, deliveries, audition, type) {
    return new TourOverviewBase(id, operatorId, carrierIds, duration, startingPoint, deliveries, audition, type);
  };
  TourOverviewBase.prototype.copy$default_e9hwdd_k$ = function (id, operatorId, carrierIds, duration, startingPoint, deliveries, audition, type, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      operatorId = this.operatorId_1;
    if (!(($mask0 & 4) === 0))
      carrierIds = this.carrierIds_1;
    if (!(($mask0 & 8) === 0))
      duration = this.duration_1;
    if (!(($mask0 & 16) === 0))
      startingPoint = this.startingPoint_1;
    if (!(($mask0 & 32) === 0))
      deliveries = this.deliveries_1;
    if (!(($mask0 & 64) === 0))
      audition = this.audition_1;
    if (!(($mask0 & 128) === 0))
      type = this.type_1;
    return this.copy_sdqljb_k$(id, operatorId, carrierIds, duration, startingPoint, deliveries, audition, type);
  };
  TourOverviewBase.prototype.toString = function () {
    return 'TourOverviewBase(id=' + this.id_1 + ', operatorId=' + this.operatorId_1 + ', carrierIds=' + this.carrierIds_1 + ', duration=' + toString_1(this.duration_1) + ', startingPoint=' + this.startingPoint_1 + ', deliveries=' + this.deliveries_1 + ', audition=' + this.audition_1 + ', type=' + this.type_1 + ')';
  };
  TourOverviewBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.operatorId_1) | 0;
    result = imul(result, 31) + hashCode(this.carrierIds_1) | 0;
    result = imul(result, 31) + this.duration_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.startingPoint_1) | 0;
    result = imul(result, 31) + hashCode(this.deliveries_1) | 0;
    result = imul(result, 31) + hashCode(this.audition_1) | 0;
    result = imul(result, 31) + this.type_1.hashCode() | 0;
    return result;
  };
  TourOverviewBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TourOverviewBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TourOverviewBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.operatorId_1 === tmp0_other_with_cast.operatorId_1))
      return false;
    if (!equals(this.carrierIds_1, tmp0_other_with_cast.carrierIds_1))
      return false;
    if (!this.duration_1.equals(tmp0_other_with_cast.duration_1))
      return false;
    if (!equals(this.startingPoint_1, tmp0_other_with_cast.startingPoint_1))
      return false;
    if (!equals(this.deliveries_1, tmp0_other_with_cast.deliveries_1))
      return false;
    if (!equals(this.audition_1, tmp0_other_with_cast.audition_1))
      return false;
    if (!this.type_1.equals(tmp0_other_with_cast.type_1))
      return false;
    return true;
  };
  TourOverviewBase.$metadata$ = {
    simpleName: 'TourOverviewBase',
    kind: 'class',
    interfaces: [TourOverview]
  };
  Object.defineProperty(TourOverviewBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'carrierIds', {
    configurable: true,
    get: function () {
      return this._get_carrierIds__1640409067_r4nnqj_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'duration', {
    configurable: true,
    get: function () {
      return this._get_duration__4153959607_2bya89_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'startingPoint', {
    configurable: true,
    get: function () {
      return this._get_startingPoint__3708070305_9pf8m7_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'deliveries', {
    configurable: true,
    get: function () {
      return this._get_deliveries__1460372281_o5gugp_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'audition', {
    configurable: true,
    get: function () {
      return this._get_audition__1675271966_rpew4e_k$();
    }
  });
  Object.defineProperty(TourOverviewBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TourTraceGps() {
  }
  TourTraceGps.$metadata$ = {
    simpleName: 'TourTraceGps',
    kind: 'interface',
    interfaces: []
  };
  function TourTraceGpsBase(tourId, points, deliveryDate, operatorId, carrierIds, createdDate) {
    this.tourId_1 = tourId;
    this.points_1 = points;
    this.deliveryDate_1 = deliveryDate;
    this.operatorId_1 = operatorId;
    this.carrierIds_1 = carrierIds;
    this.createdDate_1 = createdDate;
  }
  TourTraceGpsBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  TourTraceGpsBase.prototype._get_points__1884733064_v64dc8_k$ = function () {
    return this.points_1;
  };
  TourTraceGpsBase.prototype._get_deliveryDate__3685532617_a2uat3_k$ = function () {
    return this.deliveryDate_1;
  };
  TourTraceGpsBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  TourTraceGpsBase.prototype._get_carrierIds__1640409067_r4nnqj_k$ = function () {
    return this.carrierIds_1;
  };
  TourTraceGpsBase.prototype._get_createdDate__3631833499_ayt9b9_k$ = function () {
    return this.createdDate_1;
  };
  TourTraceGpsBase.$metadata$ = {
    simpleName: 'TourTraceGpsBase',
    kind: 'class',
    interfaces: [TourTraceGps]
  };
  Object.defineProperty(TourTraceGpsBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(TourTraceGpsBase.prototype, 'points', {
    configurable: true,
    get: function () {
      return this._get_points__1884733064_v64dc8_k$();
    }
  });
  Object.defineProperty(TourTraceGpsBase.prototype, 'deliveryDate', {
    configurable: true,
    get: function () {
      return this._get_deliveryDate__3685532617_a2uat3_k$();
    }
  });
  Object.defineProperty(TourTraceGpsBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(TourTraceGpsBase.prototype, 'carrierIds', {
    configurable: true,
    get: function () {
      return this._get_carrierIds__1640409067_r4nnqj_k$();
    }
  });
  Object.defineProperty(TourTraceGpsBase.prototype, 'createdDate', {
    configurable: true,
    get: function () {
      return this._get_createdDate__3631833499_ayt9b9_k$();
    }
  });
  function TourTraceGpsFinder() {
  }
  TourTraceGpsFinder.$metadata$ = {
    simpleName: 'TourTraceGpsFinder',
    kind: 'interface',
    interfaces: []
  };
  function _get_ACTIVE_TRANSPORTS__1609636462() {
    init_properties_TransportMode_kt_907552392();
    return ACTIVE_TRANSPORTS;
  }
  var ACTIVE_TRANSPORTS;
  function _get_ELECTRIC_TRANSPORTS__4224346437() {
    init_properties_TransportMode_kt_907552392();
    return ELECTRIC_TRANSPORTS;
  }
  var ELECTRIC_TRANSPORTS;
  function _get_THERMAL_TRANSPORTS__1369386393() {
    init_properties_TransportMode_kt_907552392();
    return THERMAL_TRANSPORTS;
  }
  var THERMAL_TRANSPORTS;
  function _get_TRANSPORT_MODE_ACTIVE__3119561317() {
    init_properties_TransportMode_kt_907552392();
    return TRANSPORT_MODE_ACTIVE;
  }
  var TRANSPORT_MODE_ACTIVE;
  function _get_TRANSPORT_MODE_ELECTRIC__3570885614() {
    init_properties_TransportMode_kt_907552392();
    return TRANSPORT_MODE_ELECTRIC;
  }
  var TRANSPORT_MODE_ELECTRIC;
  function _get_TRANSPORT_MODE_THERMAL__691932378() {
    init_properties_TransportMode_kt_907552392();
    return TRANSPORT_MODE_THERMAL;
  }
  var TRANSPORT_MODE_THERMAL;
  function _get_TRANSPORT_MODE_INVALID__201916026() {
    init_properties_TransportMode_kt_907552392();
    return TRANSPORT_MODE_INVALID;
  }
  var TRANSPORT_MODE_INVALID;
  function TransportMode() {
  }
  TransportMode.$metadata$ = {
    simpleName: 'TransportMode',
    kind: 'interface',
    interfaces: []
  };
  function TransportModeBase(value) {
    this.value_1 = value;
  }
  TransportModeBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  TransportModeBase.$metadata$ = {
    simpleName: 'TransportModeBase',
    kind: 'class',
    interfaces: [TransportMode]
  };
  Object.defineProperty(TransportModeBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function TransportModeValues() {
    this.ACTIVE_1 = _get_TRANSPORT_MODE_ACTIVE__3119561317();
    this.ELECTRIC_1 = _get_TRANSPORT_MODE_ELECTRIC__3570885614();
    this.THERMAL_1 = _get_TRANSPORT_MODE_THERMAL__691932378();
    this.INVALID_1 = _get_TRANSPORT_MODE_INVALID__201916026();
  }
  TransportModeValues.prototype._get_ACTIVE__1841523909_uge8xx_k$ = function () {
    return this.ACTIVE_1;
  };
  TransportModeValues.prototype._get_ELECTRIC__3737583182_97uoc2_k$ = function () {
    return this.ELECTRIC_1;
  };
  TransportModeValues.prototype._get_THERMAL__4022445690_4i930m_k$ = function () {
    return this.THERMAL_1;
  };
  TransportModeValues.prototype._get_INVALID__3532429338_clzu1y_k$ = function () {
    return this.INVALID_1;
  };
  TransportModeValues.prototype.fromTransportType = function (transport) {
    var tmp0_subject = transport;
    return _get_ACTIVE_TRANSPORTS__1609636462().contains_i4byw0_k$(tmp0_subject) ? this.ACTIVE_1 : _get_ELECTRIC_TRANSPORTS__4224346437().contains_i4byw0_k$(tmp0_subject) ? this.ELECTRIC_1 : _get_THERMAL_TRANSPORTS__1369386393().contains_i4byw0_k$(tmp0_subject) ? this.THERMAL_1 : this.INVALID_1;
  };
  TransportModeValues.$metadata$ = {
    simpleName: 'TransportModeValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(TransportModeValues.prototype, 'ACTIVE', {
    configurable: true,
    get: TransportModeValues.prototype._get_ACTIVE__1841523909_uge8xx_k$
  });
  Object.defineProperty(TransportModeValues.prototype, 'ELECTRIC', {
    configurable: true,
    get: TransportModeValues.prototype._get_ELECTRIC__3737583182_97uoc2_k$
  });
  Object.defineProperty(TransportModeValues.prototype, 'THERMAL', {
    configurable: true,
    get: TransportModeValues.prototype._get_THERMAL__4022445690_4i930m_k$
  });
  Object.defineProperty(TransportModeValues.prototype, 'INVALID', {
    configurable: true,
    get: TransportModeValues.prototype._get_INVALID__3532429338_clzu1y_k$
  });
  var properties_initialized_TransportMode_kt_1215405540;
  function init_properties_TransportMode_kt_907552392() {
    if (!properties_initialized_TransportMode_kt_1215405540) {
      properties_initialized_TransportMode_kt_1215405540 = true;
      ACTIVE_TRANSPORTS = listOf(['bike', 'walk']);
      ELECTRIC_TRANSPORTS = listOf_0('cargobike');
      THERMAL_TRANSPORTS = listOf(['car', 'motorbike', 'truck', 'van', 'bus', 'taxi']);
      TRANSPORT_MODE_ACTIVE = new TransportModeBase('ACTIVE');
      TRANSPORT_MODE_ELECTRIC = new TransportModeBase('ELECTRIC');
      TRANSPORT_MODE_THERMAL = new TransportModeBase('THERMAL');
      TRANSPORT_MODE_INVALID = new TransportModeBase('INVALID');
    }
  }
  function Trip() {
  }
  Trip.$metadata$ = {
    simpleName: 'Trip',
    kind: 'interface',
    interfaces: []
  };
  function TripBase(id, type, hubStamp, individuals) {
    this.id_1 = id;
    this.type_1 = type;
    this.hubStamp_1 = hubStamp;
    this.individuals_1 = individuals;
  }
  TripBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  TripBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  TripBase.prototype._get_hubStamp__3797871037_87yhxf_k$ = function () {
    return this.hubStamp_1;
  };
  TripBase.prototype._get_individuals__116926423_1xm507_k$ = function () {
    return this.individuals_1;
  };
  TripBase.$metadata$ = {
    simpleName: 'TripBase',
    kind: 'class',
    interfaces: [Trip]
  };
  Object.defineProperty(TripBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(TripBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(TripBase.prototype, 'hubStamp', {
    configurable: true,
    get: function () {
      return this._get_hubStamp__3797871037_87yhxf_k$();
    }
  });
  Object.defineProperty(TripBase.prototype, 'individuals', {
    configurable: true,
    get: function () {
      return this._get_individuals__116926423_1xm507_k$();
    }
  });
  function Viewport() {
  }
  Viewport.$metadata$ = {
    simpleName: 'Viewport',
    kind: 'interface',
    interfaces: []
  };
  function ViewportBase(minLat, maxLat, minLon, maxLon) {
    this.minLat_1 = minLat;
    this.maxLat_1 = maxLat;
    this.minLon_1 = minLon;
    this.maxLon_1 = maxLon;
  }
  ViewportBase.prototype._get_minLat__3349000894_fn7cci_k$ = function () {
    return this.minLat_1;
  };
  ViewportBase.prototype._get_maxLat__3129202896_ja2dkg_k$ = function () {
    return this.maxLat_1;
  };
  ViewportBase.prototype._get_minLon__3349014162_fn723y_k$ = function () {
    return this.minLon_1;
  };
  ViewportBase.prototype._get_maxLon__3129216164_ja23bw_k$ = function () {
    return this.maxLon_1;
  };
  ViewportBase.prototype.component1 = function () {
    return this.minLat_1;
  };
  ViewportBase.prototype.component2 = function () {
    return this.maxLat_1;
  };
  ViewportBase.prototype.component3 = function () {
    return this.minLon_1;
  };
  ViewportBase.prototype.component4 = function () {
    return this.maxLon_1;
  };
  ViewportBase.prototype.copy = function (minLat, maxLat, minLon, maxLon) {
    return this.copy_1c8phr_k$(minLat === void 1 ? this.minLat_1 : minLat, maxLat === void 1 ? this.maxLat_1 : maxLat, minLon === void 1 ? this.minLon_1 : minLon, maxLon === void 1 ? this.maxLon_1 : maxLon);
  };
  ViewportBase.prototype.copy_1c8phr_k$ = function (minLat, maxLat, minLon, maxLon) {
    return new ViewportBase(minLat, maxLat, minLon, maxLon);
  };
  ViewportBase.prototype.copy$default_4r5x6c_k$ = function (minLat, maxLat, minLon, maxLon, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      minLat = this.minLat_1;
    if (!(($mask0 & 2) === 0))
      maxLat = this.maxLat_1;
    if (!(($mask0 & 4) === 0))
      minLon = this.minLon_1;
    if (!(($mask0 & 8) === 0))
      maxLon = this.maxLon_1;
    return this.copy_1c8phr_k$(minLat, maxLat, minLon, maxLon);
  };
  ViewportBase.prototype.toString = function () {
    return 'ViewportBase(minLat=' + this.minLat_1 + ', maxLat=' + this.maxLat_1 + ', minLon=' + this.minLon_1 + ', maxLon=' + this.maxLon_1 + ')';
  };
  ViewportBase.prototype.hashCode = function () {
    var result = getNumberHashCode(this.minLat_1);
    result = imul(result, 31) + getNumberHashCode(this.maxLat_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.minLon_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.maxLon_1) | 0;
    return result;
  };
  ViewportBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ViewportBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ViewportBase ? other : THROW_CCE();
    if (!equals(this.minLat_1, tmp0_other_with_cast.minLat_1))
      return false;
    if (!equals(this.maxLat_1, tmp0_other_with_cast.maxLat_1))
      return false;
    if (!equals(this.minLon_1, tmp0_other_with_cast.minLon_1))
      return false;
    if (!equals(this.maxLon_1, tmp0_other_with_cast.maxLon_1))
      return false;
    return true;
  };
  ViewportBase.$metadata$ = {
    simpleName: 'ViewportBase',
    kind: 'class',
    interfaces: [Viewport]
  };
  Object.defineProperty(ViewportBase.prototype, 'minLat', {
    configurable: true,
    get: function () {
      return this._get_minLat__3349000894_fn7cci_k$();
    }
  });
  Object.defineProperty(ViewportBase.prototype, 'maxLat', {
    configurable: true,
    get: function () {
      return this._get_maxLat__3129202896_ja2dkg_k$();
    }
  });
  Object.defineProperty(ViewportBase.prototype, 'minLon', {
    configurable: true,
    get: function () {
      return this._get_minLon__3349014162_fn723y_k$();
    }
  });
  Object.defineProperty(ViewportBase.prototype, 'maxLon', {
    configurable: true,
    get: function () {
      return this._get_maxLon__3129216164_ja23bw_k$();
    }
  });
  function ViewportPointsRequest() {
  }
  ViewportPointsRequest.$metadata$ = {
    simpleName: 'ViewportPointsRequest',
    kind: 'interface',
    interfaces: []
  };
  function ViewportPointsRequestBase_init_$Init$(viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      operatorIds = null;
    if (!(($mask0 & 4) === 0))
      carrierIds = null;
    if (!(($mask0 & 8) === 0))
      importerIds = null;
    if (!(($mask0 & 16) === 0))
      territoryCodes = null;
    if (!(($mask0 & 32) === 0))
      contentPeriodStart = null;
    if (!(($mask0 & 64) === 0))
      contentPeriodEnd = null;
    ViewportPointsRequestBase.call($this, viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd);
    return $this;
  }
  function ViewportPointsRequestBase_init_$Create$(viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd, $mask0, $marker) {
    return ViewportPointsRequestBase_init_$Init$(viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd, $mask0, $marker, Object.create(ViewportPointsRequestBase.prototype));
  }
  function ViewportPointsRequestBase(viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd) {
    var operatorIds_0 = operatorIds === void 1 ? null : operatorIds;
    var carrierIds_0 = carrierIds === void 1 ? null : carrierIds;
    var importerIds_0 = importerIds === void 1 ? null : importerIds;
    var territoryCodes_0 = territoryCodes === void 1 ? null : territoryCodes;
    var contentPeriodStart_0 = contentPeriodStart === void 1 ? null : contentPeriodStart;
    var contentPeriodEnd_0 = contentPeriodEnd === void 1 ? null : contentPeriodEnd;
    this.viewport_1 = viewport;
    this.operatorIds_1 = operatorIds_0;
    this.carrierIds_1 = carrierIds_0;
    this.importerIds_1 = importerIds_0;
    this.territoryCodes_1 = territoryCodes_0;
    this.contentPeriodStart_1 = contentPeriodStart_0;
    this.contentPeriodEnd_1 = contentPeriodEnd_0;
  }
  ViewportPointsRequestBase.prototype._get_viewport__4219345893_190tuj_k$ = function () {
    return this.viewport_1;
  };
  ViewportPointsRequestBase.prototype._get_operatorIds__1553507485_pox21p_k$ = function () {
    return this.operatorIds_1;
  };
  ViewportPointsRequestBase.prototype._get_carrierIds__1640409067_r4nnqj_k$ = function () {
    return this.carrierIds_1;
  };
  ViewportPointsRequestBase.prototype._get_importerIds__117358603_1xveh7_k$ = function () {
    return this.importerIds_1;
  };
  ViewportPointsRequestBase.prototype._get_territoryCodes__176172895_2wvzvj_k$ = function () {
    return this.territoryCodes_1;
  };
  ViewportPointsRequestBase.prototype._get_contentPeriodStart__2828428195_o950t9_k$ = function () {
    return this.contentPeriodStart_1;
  };
  ViewportPointsRequestBase.prototype._get_contentPeriodEnd__480732170_7y7rbe_k$ = function () {
    return this.contentPeriodEnd_1;
  };
  ViewportPointsRequestBase.prototype.component1 = function () {
    return this.viewport_1;
  };
  ViewportPointsRequestBase.prototype.component2 = function () {
    return this.operatorIds_1;
  };
  ViewportPointsRequestBase.prototype.component3 = function () {
    return this.carrierIds_1;
  };
  ViewportPointsRequestBase.prototype.component4 = function () {
    return this.importerIds_1;
  };
  ViewportPointsRequestBase.prototype.component5 = function () {
    return this.territoryCodes_1;
  };
  ViewportPointsRequestBase.prototype.component6 = function () {
    return this.contentPeriodStart_1;
  };
  ViewportPointsRequestBase.prototype.component7 = function () {
    return this.contentPeriodEnd_1;
  };
  ViewportPointsRequestBase.prototype.copy = function (viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd) {
    return this.copy_kqswd2_k$(viewport === void 1 ? this.viewport_1 : viewport, operatorIds === void 1 ? this.operatorIds_1 : operatorIds, carrierIds === void 1 ? this.carrierIds_1 : carrierIds, importerIds === void 1 ? this.importerIds_1 : importerIds, territoryCodes === void 1 ? this.territoryCodes_1 : territoryCodes, contentPeriodStart === void 1 ? this.contentPeriodStart_1 : contentPeriodStart, contentPeriodEnd === void 1 ? this.contentPeriodEnd_1 : contentPeriodEnd);
  };
  ViewportPointsRequestBase.prototype.copy_kqswd2_k$ = function (viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd) {
    return new ViewportPointsRequestBase(viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd);
  };
  ViewportPointsRequestBase.prototype.copy$default_p63oci_k$ = function (viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      viewport = this.viewport_1;
    if (!(($mask0 & 2) === 0))
      operatorIds = this.operatorIds_1;
    if (!(($mask0 & 4) === 0))
      carrierIds = this.carrierIds_1;
    if (!(($mask0 & 8) === 0))
      importerIds = this.importerIds_1;
    if (!(($mask0 & 16) === 0))
      territoryCodes = this.territoryCodes_1;
    if (!(($mask0 & 32) === 0))
      contentPeriodStart = this.contentPeriodStart_1;
    if (!(($mask0 & 64) === 0))
      contentPeriodEnd = this.contentPeriodEnd_1;
    return this.copy_kqswd2_k$(viewport, operatorIds, carrierIds, importerIds, territoryCodes, contentPeriodStart, contentPeriodEnd);
  };
  ViewportPointsRequestBase.prototype.toString = function () {
    return 'ViewportPointsRequestBase(viewport=' + this.viewport_1 + ', operatorIds=' + this.operatorIds_1 + ', carrierIds=' + this.carrierIds_1 + ', importerIds=' + this.importerIds_1 + ', territoryCodes=' + this.territoryCodes_1 + ', contentPeriodStart=' + this.contentPeriodStart_1 + ', contentPeriodEnd=' + this.contentPeriodEnd_1 + ')';
  };
  ViewportPointsRequestBase.prototype.hashCode = function () {
    var result = this.viewport_1.hashCode();
    result = imul(result, 31) + (this.operatorIds_1 == null ? 0 : hashCode(this.operatorIds_1)) | 0;
    result = imul(result, 31) + (this.carrierIds_1 == null ? 0 : hashCode(this.carrierIds_1)) | 0;
    result = imul(result, 31) + (this.importerIds_1 == null ? 0 : hashCode(this.importerIds_1)) | 0;
    result = imul(result, 31) + (this.territoryCodes_1 == null ? 0 : hashCode(this.territoryCodes_1)) | 0;
    result = imul(result, 31) + (this.contentPeriodStart_1 == null ? 0 : getStringHashCode(this.contentPeriodStart_1)) | 0;
    result = imul(result, 31) + (this.contentPeriodEnd_1 == null ? 0 : getStringHashCode(this.contentPeriodEnd_1)) | 0;
    return result;
  };
  ViewportPointsRequestBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ViewportPointsRequestBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ViewportPointsRequestBase ? other : THROW_CCE();
    if (!this.viewport_1.equals(tmp0_other_with_cast.viewport_1))
      return false;
    if (!equals(this.operatorIds_1, tmp0_other_with_cast.operatorIds_1))
      return false;
    if (!equals(this.carrierIds_1, tmp0_other_with_cast.carrierIds_1))
      return false;
    if (!equals(this.importerIds_1, tmp0_other_with_cast.importerIds_1))
      return false;
    if (!equals(this.territoryCodes_1, tmp0_other_with_cast.territoryCodes_1))
      return false;
    if (!(this.contentPeriodStart_1 == tmp0_other_with_cast.contentPeriodStart_1))
      return false;
    if (!(this.contentPeriodEnd_1 == tmp0_other_with_cast.contentPeriodEnd_1))
      return false;
    return true;
  };
  ViewportPointsRequestBase.$metadata$ = {
    simpleName: 'ViewportPointsRequestBase',
    kind: 'class',
    interfaces: [ViewportPointsRequest]
  };
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'viewport', {
    configurable: true,
    get: function () {
      return this._get_viewport__4219345893_190tuj_k$();
    }
  });
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'operatorIds', {
    configurable: true,
    get: function () {
      return this._get_operatorIds__1553507485_pox21p_k$();
    }
  });
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'carrierIds', {
    configurable: true,
    get: function () {
      return this._get_carrierIds__1640409067_r4nnqj_k$();
    }
  });
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'importerIds', {
    configurable: true,
    get: function () {
      return this._get_importerIds__117358603_1xveh7_k$();
    }
  });
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'territoryCodes', {
    configurable: true,
    get: function () {
      return this._get_territoryCodes__176172895_2wvzvj_k$();
    }
  });
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'contentPeriodStart', {
    configurable: true,
    get: function () {
      return this._get_contentPeriodStart__2828428195_o950t9_k$();
    }
  });
  Object.defineProperty(ViewportPointsRequestBase.prototype, 'contentPeriodEnd', {
    configurable: true,
    get: function () {
      return this._get_contentPeriodEnd__480732170_7y7rbe_k$();
    }
  });
  function ViewportPointsResponse() {
  }
  ViewportPointsResponse.$metadata$ = {
    simpleName: 'ViewportPointsResponse',
    kind: 'interface',
    interfaces: []
  };
  function ViewportPointsResponseBase(deliveryPoints, hubs, totalInViewport) {
    this.deliveryPoints_1 = deliveryPoints;
    this.hubs_1 = hubs;
    this.totalInViewport_1 = totalInViewport;
  }
  ViewportPointsResponseBase.prototype._get_deliveryPoints__899908340_evs5pw_k$ = function () {
    return this.deliveryPoints_1;
  };
  ViewportPointsResponseBase.prototype._get_hubs__799213549_d7tx4d_k$ = function () {
    return this.hubs_1;
  };
  ViewportPointsResponseBase.prototype._get_totalInViewport__886758050_enyaw2_k$ = function () {
    return this.totalInViewport_1;
  };
  ViewportPointsResponseBase.prototype.component1 = function () {
    return this.deliveryPoints_1;
  };
  ViewportPointsResponseBase.prototype.component2 = function () {
    return this.hubs_1;
  };
  ViewportPointsResponseBase.prototype.component3 = function () {
    return this.totalInViewport_1;
  };
  ViewportPointsResponseBase.prototype.copy = function (deliveryPoints, hubs, totalInViewport) {
    return this.copy_dmi9qs_k$(deliveryPoints === void 1 ? this.deliveryPoints_1 : deliveryPoints, hubs === void 1 ? this.hubs_1 : hubs, totalInViewport === void 1 ? this.totalInViewport_1 : totalInViewport);
  };
  ViewportPointsResponseBase.prototype.copy_dmi9qs_k$ = function (deliveryPoints, hubs, totalInViewport) {
    return new ViewportPointsResponseBase(deliveryPoints, hubs, totalInViewport);
  };
  ViewportPointsResponseBase.prototype.copy$default_hwowbb_k$ = function (deliveryPoints, hubs, totalInViewport, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      deliveryPoints = this.deliveryPoints_1;
    if (!(($mask0 & 2) === 0))
      hubs = this.hubs_1;
    if (!(($mask0 & 4) === 0))
      totalInViewport = this.totalInViewport_1;
    return this.copy_dmi9qs_k$(deliveryPoints, hubs, totalInViewport);
  };
  ViewportPointsResponseBase.prototype.toString = function () {
    return 'ViewportPointsResponseBase(deliveryPoints=' + this.deliveryPoints_1 + ', hubs=' + this.hubs_1 + ', totalInViewport=' + this.totalInViewport_1 + ')';
  };
  ViewportPointsResponseBase.prototype.hashCode = function () {
    var result = hashCode(this.deliveryPoints_1);
    result = imul(result, 31) + hashCode(this.hubs_1) | 0;
    result = imul(result, 31) + this.totalInViewport_1 | 0;
    return result;
  };
  ViewportPointsResponseBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ViewportPointsResponseBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ViewportPointsResponseBase ? other : THROW_CCE();
    if (!equals(this.deliveryPoints_1, tmp0_other_with_cast.deliveryPoints_1))
      return false;
    if (!equals(this.hubs_1, tmp0_other_with_cast.hubs_1))
      return false;
    if (!(this.totalInViewport_1 === tmp0_other_with_cast.totalInViewport_1))
      return false;
    return true;
  };
  ViewportPointsResponseBase.$metadata$ = {
    simpleName: 'ViewportPointsResponseBase',
    kind: 'class',
    interfaces: [ViewportPointsResponse]
  };
  Object.defineProperty(ViewportPointsResponseBase.prototype, 'deliveryPoints', {
    configurable: true,
    get: function () {
      return this._get_deliveryPoints__899908340_evs5pw_k$();
    }
  });
  Object.defineProperty(ViewportPointsResponseBase.prototype, 'hubs', {
    configurable: true,
    get: function () {
      return this._get_hubs__799213549_d7tx4d_k$();
    }
  });
  Object.defineProperty(ViewportPointsResponseBase.prototype, 'totalInViewport', {
    configurable: true,
    get: function () {
      return this._get_totalInViewport__886758050_enyaw2_k$();
    }
  });
  function _get_ADD_DELIVERIES__399362555() {
    return ADD_DELIVERIES;
  }
  var ADD_DELIVERIES;
  function _get_DELIVERY_ADDED__374402006() {
    return DELIVERY_ADDED;
  }
  var DELIVERY_ADDED;
  function AddDeliveriesCommand() {
  }
  AddDeliveriesCommand.$metadata$ = {
    simpleName: 'AddDeliveriesCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddDeliveriesCommandDTO() {
  }
  AddDeliveriesCommandDTO.$metadata$ = {
    simpleName: 'AddDeliveriesCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddDeliveriesCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddDeliveriesCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddDeliveriesCommandBase.$metadata$ = {
    simpleName: 'AddDeliveriesCommandBase',
    kind: 'class',
    interfaces: [AddDeliveriesCommand]
  };
  Object.defineProperty(AddDeliveriesCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddDeliveriesCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddDeliveriesCommandDTOBase(tourId, deliveries) {
    this.tourId_1 = tourId;
    this.deliveries_1 = deliveries;
  }
  AddDeliveriesCommandDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  AddDeliveriesCommandDTOBase.prototype._get_deliveries__1460372281_o5gugp_k$ = function () {
    return this.deliveries_1;
  };
  AddDeliveriesCommandDTOBase.$metadata$ = {
    simpleName: 'AddDeliveriesCommandDTOBase',
    kind: 'class',
    interfaces: [AddDeliveriesCommandDTO]
  };
  Object.defineProperty(AddDeliveriesCommandDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(AddDeliveriesCommandDTOBase.prototype, 'deliveries', {
    configurable: true,
    get: function () {
      return this._get_deliveries__1460372281_o5gugp_k$();
    }
  });
  function DeliveryAddedEvent() {
  }
  DeliveryAddedEvent.$metadata$ = {
    simpleName: 'DeliveryAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DeliveryAddedEventDTO() {
  }
  DeliveryAddedEventDTO.$metadata$ = {
    simpleName: 'DeliveryAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  DeliveryAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeliveryAddedEventBase.$metadata$ = {
    simpleName: 'DeliveryAddedEventBase',
    kind: 'class',
    interfaces: [DeliveryAddedEvent]
  };
  Object.defineProperty(DeliveryAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeliveryAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeliveryAddedEventDTOBase(tourId, deliveryId) {
    this.tourId_1 = tourId;
    this.deliveryId_1 = deliveryId;
  }
  DeliveryAddedEventDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  DeliveryAddedEventDTOBase.prototype._get_deliveryId__1460821564_o5qh4s_k$ = function () {
    return this.deliveryId_1;
  };
  DeliveryAddedEventDTOBase.$metadata$ = {
    simpleName: 'DeliveryAddedEventDTOBase',
    kind: 'class',
    interfaces: [DeliveryAddedEventDTO]
  };
  Object.defineProperty(DeliveryAddedEventDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(DeliveryAddedEventDTOBase.prototype, 'deliveryId', {
    configurable: true,
    get: function () {
      return this._get_deliveryId__1460821564_o5qh4s_k$();
    }
  });
  function _get_ADD_DELIVERY_BLOCKCHAIN_TRACE__4162343306() {
    return ADD_DELIVERY_BLOCKCHAIN_TRACE;
  }
  var ADD_DELIVERY_BLOCKCHAIN_TRACE;
  function _get_DELIVERY_BLOCKCHAIN_TRACE_ADDED__1241407051() {
    return DELIVERY_BLOCKCHAIN_TRACE_ADDED;
  }
  var DELIVERY_BLOCKCHAIN_TRACE_ADDED;
  function AddDeliveryBlockchainTraceCommand() {
  }
  AddDeliveryBlockchainTraceCommand.$metadata$ = {
    simpleName: 'AddDeliveryBlockchainTraceCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddDeliveryBlockchainTraceCommandDTO() {
  }
  AddDeliveryBlockchainTraceCommandDTO.$metadata$ = {
    simpleName: 'AddDeliveryBlockchainTraceCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddDeliveryBlockchainTraceCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddDeliveryBlockchainTraceCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddDeliveryBlockchainTraceCommandBase.$metadata$ = {
    simpleName: 'AddDeliveryBlockchainTraceCommandBase',
    kind: 'class',
    interfaces: [AddDeliveryBlockchainTraceCommand]
  };
  Object.defineProperty(AddDeliveryBlockchainTraceCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddDeliveryBlockchainTraceCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddDeliveryBlockchainTraceCommandDTOBase(deliveryId, transactionId, proof) {
    this.deliveryId_1 = deliveryId;
    this.transactionId_1 = transactionId;
    this.proof_1 = proof;
  }
  AddDeliveryBlockchainTraceCommandDTOBase.prototype._get_deliveryId__1460821564_o5qh4s_k$ = function () {
    return this.deliveryId_1;
  };
  AddDeliveryBlockchainTraceCommandDTOBase.prototype._get_transactionId__1535879000_pef7tk_k$ = function () {
    return this.transactionId_1;
  };
  AddDeliveryBlockchainTraceCommandDTOBase.prototype._get_proof__3527430925_coyyur_k$ = function () {
    return this.proof_1;
  };
  AddDeliveryBlockchainTraceCommandDTOBase.$metadata$ = {
    simpleName: 'AddDeliveryBlockchainTraceCommandDTOBase',
    kind: 'class',
    interfaces: [AddDeliveryBlockchainTraceCommandDTO]
  };
  Object.defineProperty(AddDeliveryBlockchainTraceCommandDTOBase.prototype, 'deliveryId', {
    configurable: true,
    get: function () {
      return this._get_deliveryId__1460821564_o5qh4s_k$();
    }
  });
  Object.defineProperty(AddDeliveryBlockchainTraceCommandDTOBase.prototype, 'transactionId', {
    configurable: true,
    get: function () {
      return this._get_transactionId__1535879000_pef7tk_k$();
    }
  });
  Object.defineProperty(AddDeliveryBlockchainTraceCommandDTOBase.prototype, 'proof', {
    configurable: true,
    get: function () {
      return this._get_proof__3527430925_coyyur_k$();
    }
  });
  function DeliveryBlockchainTraceAdded() {
  }
  DeliveryBlockchainTraceAdded.$metadata$ = {
    simpleName: 'DeliveryBlockchainTraceAdded',
    kind: 'interface',
    interfaces: [Event]
  };
  function DeliveryBlockchainTraceAddedDTO() {
  }
  DeliveryBlockchainTraceAddedDTO.$metadata$ = {
    simpleName: 'DeliveryBlockchainTraceAddedDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryBlockchainTraceAddedBase(payload) {
    this.payload_1 = payload;
  }
  DeliveryBlockchainTraceAddedBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeliveryBlockchainTraceAddedBase.$metadata$ = {
    simpleName: 'DeliveryBlockchainTraceAddedBase',
    kind: 'class',
    interfaces: [DeliveryBlockchainTraceAdded]
  };
  Object.defineProperty(DeliveryBlockchainTraceAddedBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeliveryBlockchainTraceAddedBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeliveryBlockchainTraceAddedDTOBase(deliveryId) {
    this.deliveryId_1 = deliveryId;
  }
  DeliveryBlockchainTraceAddedDTOBase.prototype._get_deliveryId__1460821564_o5qh4s_k$ = function () {
    return this.deliveryId_1;
  };
  DeliveryBlockchainTraceAddedDTOBase.$metadata$ = {
    simpleName: 'DeliveryBlockchainTraceAddedDTOBase',
    kind: 'class',
    interfaces: [DeliveryBlockchainTraceAddedDTO]
  };
  Object.defineProperty(DeliveryBlockchainTraceAddedDTOBase.prototype, 'deliveryId', {
    configurable: true,
    get: function () {
      return this._get_deliveryId__1460821564_o5qh4s_k$();
    }
  });
  function _get_ADD_TOUR_METADATA_BLOCKCHAIN_TRACE__3802652362() {
    return ADD_TOUR_METADATA_BLOCKCHAIN_TRACE;
  }
  var ADD_TOUR_METADATA_BLOCKCHAIN_TRACE;
  function _get_TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED__1927811527() {
    return TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED;
  }
  var TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED;
  function AddTourMetadataBlockchainTraceCommand() {
  }
  AddTourMetadataBlockchainTraceCommand.$metadata$ = {
    simpleName: 'AddTourMetadataBlockchainTraceCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddTourMetadataBlockchainTraceCommandDTO() {
  }
  AddTourMetadataBlockchainTraceCommandDTO.$metadata$ = {
    simpleName: 'AddTourMetadataBlockchainTraceCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddTourMetadataBlockchainTraceCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddTourMetadataBlockchainTraceCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddTourMetadataBlockchainTraceCommandBase.$metadata$ = {
    simpleName: 'AddTourMetadataBlockchainTraceCommandBase',
    kind: 'class',
    interfaces: [AddTourMetadataBlockchainTraceCommand]
  };
  Object.defineProperty(AddTourMetadataBlockchainTraceCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddTourMetadataBlockchainTraceCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddTourMetadataBlockchainTraceCommandDTOBase(tourId, proof) {
    this.tourId_1 = tourId;
    this.proof_1 = proof;
  }
  AddTourMetadataBlockchainTraceCommandDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  AddTourMetadataBlockchainTraceCommandDTOBase.prototype._get_proof__3527430925_coyyur_k$ = function () {
    return this.proof_1;
  };
  AddTourMetadataBlockchainTraceCommandDTOBase.$metadata$ = {
    simpleName: 'AddTourMetadataBlockchainTraceCommandDTOBase',
    kind: 'class',
    interfaces: [AddTourMetadataBlockchainTraceCommandDTO]
  };
  Object.defineProperty(AddTourMetadataBlockchainTraceCommandDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(AddTourMetadataBlockchainTraceCommandDTOBase.prototype, 'proof', {
    configurable: true,
    get: function () {
      return this._get_proof__3527430925_coyyur_k$();
    }
  });
  function TourMetadataBlockchainTraceAddedEvent() {
  }
  TourMetadataBlockchainTraceAddedEvent.$metadata$ = {
    simpleName: 'TourMetadataBlockchainTraceAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TourMetadataBlockchainTraceAddedEventDTO() {
  }
  TourMetadataBlockchainTraceAddedEventDTO.$metadata$ = {
    simpleName: 'TourMetadataBlockchainTraceAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TourMetadataBlockchainTraceAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  TourMetadataBlockchainTraceAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TourMetadataBlockchainTraceAddedEventBase.$metadata$ = {
    simpleName: 'TourMetadataBlockchainTraceAddedEventBase',
    kind: 'class',
    interfaces: [TourMetadataBlockchainTraceAddedEvent]
  };
  Object.defineProperty(TourMetadataBlockchainTraceAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TourMetadataBlockchainTraceAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TourMetadataBlockchainTraceAddedEventDTOBase(tourId) {
    this.tourId_1 = tourId;
  }
  TourMetadataBlockchainTraceAddedEventDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  TourMetadataBlockchainTraceAddedEventDTOBase.$metadata$ = {
    simpleName: 'TourMetadataBlockchainTraceAddedEventDTOBase',
    kind: 'class',
    interfaces: [TourMetadataBlockchainTraceAddedEventDTO]
  };
  Object.defineProperty(TourMetadataBlockchainTraceAddedEventDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  function _get_ADD_TOUR_TRACE_GPS__1834851236() {
    return ADD_TOUR_TRACE_GPS;
  }
  var ADD_TOUR_TRACE_GPS;
  function _get_TOUR_TRACE_GPS_ADDED__3639246625() {
    return TOUR_TRACE_GPS_ADDED;
  }
  var TOUR_TRACE_GPS_ADDED;
  function AddTourTraceGpsCommand() {
  }
  AddTourTraceGpsCommand.$metadata$ = {
    simpleName: 'AddTourTraceGpsCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddTourTraceGpsCommandDTO() {
  }
  AddTourTraceGpsCommandDTO.$metadata$ = {
    simpleName: 'AddTourTraceGpsCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddTourTraceGpsCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddTourTraceGpsCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddTourTraceGpsCommandBase.$metadata$ = {
    simpleName: 'AddTourTraceGpsCommandBase',
    kind: 'class',
    interfaces: [AddTourTraceGpsCommand]
  };
  Object.defineProperty(AddTourTraceGpsCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddTourTraceGpsCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddTourTraceGpsCommandDTOBase(tourId, points, operatorId, carrierIds, pickupPoint) {
    this.tourId_1 = tourId;
    this.points_1 = points;
    this.operatorId_1 = operatorId;
    this.carrierIds_1 = carrierIds;
    this.pickupPoint_1 = pickupPoint;
  }
  AddTourTraceGpsCommandDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  AddTourTraceGpsCommandDTOBase.prototype._get_points__1884733064_v64dc8_k$ = function () {
    return this.points_1;
  };
  AddTourTraceGpsCommandDTOBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  AddTourTraceGpsCommandDTOBase.prototype._get_carrierIds__1640409067_r4nnqj_k$ = function () {
    return this.carrierIds_1;
  };
  AddTourTraceGpsCommandDTOBase.prototype._get_pickupPoint__1888763805_v8irh9_k$ = function () {
    return this.pickupPoint_1;
  };
  AddTourTraceGpsCommandDTOBase.$metadata$ = {
    simpleName: 'AddTourTraceGpsCommandDTOBase',
    kind: 'class',
    interfaces: [AddTourTraceGpsCommandDTO]
  };
  Object.defineProperty(AddTourTraceGpsCommandDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(AddTourTraceGpsCommandDTOBase.prototype, 'points', {
    configurable: true,
    get: function () {
      return this._get_points__1884733064_v64dc8_k$();
    }
  });
  Object.defineProperty(AddTourTraceGpsCommandDTOBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(AddTourTraceGpsCommandDTOBase.prototype, 'carrierIds', {
    configurable: true,
    get: function () {
      return this._get_carrierIds__1640409067_r4nnqj_k$();
    }
  });
  Object.defineProperty(AddTourTraceGpsCommandDTOBase.prototype, 'pickupPoint', {
    configurable: true,
    get: function () {
      return this._get_pickupPoint__1888763805_v8irh9_k$();
    }
  });
  function TourTraceGpsAddedEvent() {
  }
  TourTraceGpsAddedEvent.$metadata$ = {
    simpleName: 'TourTraceGpsAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TourTraceGpsAddedEventDTO() {
  }
  TourTraceGpsAddedEventDTO.$metadata$ = {
    simpleName: 'TourTraceGpsAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TourTraceGpsAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  TourTraceGpsAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TourTraceGpsAddedEventBase.$metadata$ = {
    simpleName: 'TourTraceGpsAddedEventBase',
    kind: 'class',
    interfaces: [TourTraceGpsAddedEvent]
  };
  Object.defineProperty(TourTraceGpsAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TourTraceGpsAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TourTraceGpsAddedEventDTOBase(tourId) {
    this.tourId_1 = tourId;
  }
  TourTraceGpsAddedEventDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  TourTraceGpsAddedEventDTOBase.$metadata$ = {
    simpleName: 'TourTraceGpsAddedEventDTOBase',
    kind: 'class',
    interfaces: [TourTraceGpsAddedEventDTO]
  };
  Object.defineProperty(TourTraceGpsAddedEventDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  function _get_DECLARE_TOUR__2957373118() {
    return DECLARE_TOUR;
  }
  var DECLARE_TOUR;
  function _get_TOUR_DECLARED__2089660080() {
    return TOUR_DECLARED;
  }
  var TOUR_DECLARED;
  function DeclareTourCommand() {
  }
  DeclareTourCommand.$metadata$ = {
    simpleName: 'DeclareTourCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DeclareTourCommandDTO() {
  }
  DeclareTourCommandDTO.$metadata$ = {
    simpleName: 'DeclareTourCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeclareTourCommandBase(payload) {
    this.payload_1 = payload;
  }
  DeclareTourCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeclareTourCommandBase.prototype.component1 = function () {
    return this.payload_1;
  };
  DeclareTourCommandBase.prototype.copy = function (payload) {
    return this.copy_57yjo7_k$(payload === void 1 ? this.payload_1 : payload);
  };
  DeclareTourCommandBase.prototype.copy_57yjo7_k$ = function (payload) {
    return new DeclareTourCommandBase(payload);
  };
  DeclareTourCommandBase.prototype.copy$default_ot0ezb_k$ = function (payload, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      payload = this.payload_1;
    return this.copy_57yjo7_k$(payload);
  };
  DeclareTourCommandBase.prototype.toString = function () {
    return 'DeclareTourCommandBase(payload=' + this.payload_1 + ')';
  };
  DeclareTourCommandBase.prototype.hashCode = function () {
    return this.payload_1.hashCode();
  };
  DeclareTourCommandBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeclareTourCommandBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeclareTourCommandBase ? other : THROW_CCE();
    if (!this.payload_1.equals(tmp0_other_with_cast.payload_1))
      return false;
    return true;
  };
  DeclareTourCommandBase.$metadata$ = {
    simpleName: 'DeclareTourCommandBase',
    kind: 'class',
    interfaces: [DeclareTourCommand]
  };
  Object.defineProperty(DeclareTourCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeclareTourCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeclareTourCommandDTOBase(externalId, operatorId, transportType, importedBy, trips, csvLineCount) {
    this.externalId_1 = externalId;
    this.operatorId_1 = operatorId;
    this.transportType_1 = transportType;
    this.importedBy_1 = importedBy;
    this.trips_1 = trips;
    this.csvLineCount_1 = csvLineCount;
  }
  DeclareTourCommandDTOBase.prototype._get_externalId__1255568133_krj6kl_k$ = function () {
    return this.externalId_1;
  };
  DeclareTourCommandDTOBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  DeclareTourCommandDTOBase.prototype._get_transportType__2443064110_umkpn6_k$ = function () {
    return this.transportType_1;
  };
  DeclareTourCommandDTOBase.prototype._get_importedBy__3882687856_6tgkuo_k$ = function () {
    return this.importedBy_1;
  };
  DeclareTourCommandDTOBase.prototype._get_trips__3641770147_aswa59_k$ = function () {
    return this.trips_1;
  };
  DeclareTourCommandDTOBase.prototype._get_csvLineCount__2474583510_u3t54a_k$ = function () {
    return this.csvLineCount_1;
  };
  DeclareTourCommandDTOBase.prototype.component1 = function () {
    return this.externalId_1;
  };
  DeclareTourCommandDTOBase.prototype.component2 = function () {
    return this.operatorId_1;
  };
  DeclareTourCommandDTOBase.prototype.component3 = function () {
    return this.transportType_1;
  };
  DeclareTourCommandDTOBase.prototype.component4 = function () {
    return this.importedBy_1;
  };
  DeclareTourCommandDTOBase.prototype.component5 = function () {
    return this.trips_1;
  };
  DeclareTourCommandDTOBase.prototype.component6 = function () {
    return this.csvLineCount_1;
  };
  DeclareTourCommandDTOBase.prototype.copy = function (externalId, operatorId, transportType, importedBy, trips, csvLineCount) {
    return this.copy_ra385e_k$(externalId === void 1 ? this.externalId_1 : externalId, operatorId === void 1 ? this.operatorId_1 : operatorId, transportType === void 1 ? this.transportType_1 : transportType, importedBy === void 1 ? this.importedBy_1 : importedBy, trips === void 1 ? this.trips_1 : trips, csvLineCount === void 1 ? this.csvLineCount_1 : csvLineCount);
  };
  DeclareTourCommandDTOBase.prototype.copy_ra385e_k$ = function (externalId, operatorId, transportType, importedBy, trips, csvLineCount) {
    return new DeclareTourCommandDTOBase(externalId, operatorId, transportType, importedBy, trips, csvLineCount);
  };
  DeclareTourCommandDTOBase.prototype.copy$default_6hf97y_k$ = function (externalId, operatorId, transportType, importedBy, trips, csvLineCount, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      externalId = this.externalId_1;
    if (!(($mask0 & 2) === 0))
      operatorId = this.operatorId_1;
    if (!(($mask0 & 4) === 0))
      transportType = this.transportType_1;
    if (!(($mask0 & 8) === 0))
      importedBy = this.importedBy_1;
    if (!(($mask0 & 16) === 0))
      trips = this.trips_1;
    if (!(($mask0 & 32) === 0))
      csvLineCount = this.csvLineCount_1;
    return this.copy_ra385e_k$(externalId, operatorId, transportType, importedBy, trips, csvLineCount);
  };
  DeclareTourCommandDTOBase.prototype.toString = function () {
    return 'DeclareTourCommandDTOBase(externalId=' + this.externalId_1 + ', operatorId=' + this.operatorId_1 + ', transportType=' + this.transportType_1 + ', importedBy=' + this.importedBy_1 + ', trips=' + this.trips_1 + ', csvLineCount=' + this.csvLineCount_1 + ')';
  };
  DeclareTourCommandDTOBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.externalId_1);
    result = imul(result, 31) + getStringHashCode(this.operatorId_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.transportType_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.importedBy_1) | 0;
    result = imul(result, 31) + hashCode(this.trips_1) | 0;
    result = imul(result, 31) + this.csvLineCount_1 | 0;
    return result;
  };
  DeclareTourCommandDTOBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeclareTourCommandDTOBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DeclareTourCommandDTOBase ? other : THROW_CCE();
    if (!(this.externalId_1 === tmp0_other_with_cast.externalId_1))
      return false;
    if (!(this.operatorId_1 === tmp0_other_with_cast.operatorId_1))
      return false;
    if (!(this.transportType_1 === tmp0_other_with_cast.transportType_1))
      return false;
    if (!(this.importedBy_1 === tmp0_other_with_cast.importedBy_1))
      return false;
    if (!equals(this.trips_1, tmp0_other_with_cast.trips_1))
      return false;
    if (!(this.csvLineCount_1 === tmp0_other_with_cast.csvLineCount_1))
      return false;
    return true;
  };
  DeclareTourCommandDTOBase.$metadata$ = {
    simpleName: 'DeclareTourCommandDTOBase',
    kind: 'class',
    interfaces: [DeclareTourCommandDTO]
  };
  Object.defineProperty(DeclareTourCommandDTOBase.prototype, 'externalId', {
    configurable: true,
    get: function () {
      return this._get_externalId__1255568133_krj6kl_k$();
    }
  });
  Object.defineProperty(DeclareTourCommandDTOBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(DeclareTourCommandDTOBase.prototype, 'transportType', {
    configurable: true,
    get: function () {
      return this._get_transportType__2443064110_umkpn6_k$();
    }
  });
  Object.defineProperty(DeclareTourCommandDTOBase.prototype, 'importedBy', {
    configurable: true,
    get: function () {
      return this._get_importedBy__3882687856_6tgkuo_k$();
    }
  });
  Object.defineProperty(DeclareTourCommandDTOBase.prototype, 'trips', {
    configurable: true,
    get: function () {
      return this._get_trips__3641770147_aswa59_k$();
    }
  });
  Object.defineProperty(DeclareTourCommandDTOBase.prototype, 'csvLineCount', {
    configurable: true,
    get: function () {
      return this._get_csvLineCount__2474583510_u3t54a_k$();
    }
  });
  function TourDeclaredEvent() {
  }
  TourDeclaredEvent.$metadata$ = {
    simpleName: 'TourDeclaredEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TourDeclaredEventDTO() {
  }
  TourDeclaredEventDTO.$metadata$ = {
    simpleName: 'TourDeclaredEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TourDeclaredEventBase(payload) {
    this.payload_1 = payload;
  }
  TourDeclaredEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TourDeclaredEventBase.$metadata$ = {
    simpleName: 'TourDeclaredEventBase',
    kind: 'class',
    interfaces: [TourDeclaredEvent]
  };
  Object.defineProperty(TourDeclaredEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TourDeclaredEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TourDeclaredEventDTOBase(id) {
    this.id_1 = id;
  }
  TourDeclaredEventDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  TourDeclaredEventDTOBase.$metadata$ = {
    simpleName: 'TourDeclaredEventDTOBase',
    kind: 'class',
    interfaces: [TourDeclaredEventDTO]
  };
  Object.defineProperty(TourDeclaredEventDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function _get_GET_TOURS_WITH_DELIVERIES__519175923() {
    return GET_TOURS_WITH_DELIVERIES;
  }
  var GET_TOURS_WITH_DELIVERIES;
  function GetToursWithDeliveriesQuery() {
  }
  GetToursWithDeliveriesQuery.$metadata$ = {
    simpleName: 'GetToursWithDeliveriesQuery',
    kind: 'interface',
    interfaces: [Command]
  };
  function GetToursWithDeliveriesQueryDTO() {
  }
  GetToursWithDeliveriesQueryDTO.$metadata$ = {
    simpleName: 'GetToursWithDeliveriesQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function GetToursWithDeliveriesQueryBase(payload) {
    this.payload_1 = payload;
  }
  GetToursWithDeliveriesQueryBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  GetToursWithDeliveriesQueryBase.$metadata$ = {
    simpleName: 'GetToursWithDeliveriesQueryBase',
    kind: 'class',
    interfaces: [GetToursWithDeliveriesQuery]
  };
  Object.defineProperty(GetToursWithDeliveriesQueryBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(GetToursWithDeliveriesQueryBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function GetToursWithDeliveriesQueryDTOBase(deliveries) {
    this.deliveries_1 = deliveries;
  }
  GetToursWithDeliveriesQueryDTOBase.prototype._get_deliveries__1460372281_o5gugp_k$ = function () {
    return this.deliveries_1;
  };
  GetToursWithDeliveriesQueryDTOBase.$metadata$ = {
    simpleName: 'GetToursWithDeliveriesQueryDTOBase',
    kind: 'class',
    interfaces: [GetToursWithDeliveriesQueryDTO]
  };
  Object.defineProperty(GetToursWithDeliveriesQueryDTOBase.prototype, 'deliveries', {
    configurable: true,
    get: function () {
      return this._get_deliveries__1460372281_o5gugp_k$();
    }
  });
  function _get_TOUR_AUDITED__2969365752() {
    return TOUR_AUDITED;
  }
  var TOUR_AUDITED;
  function TourAuditedEvent() {
  }
  TourAuditedEvent.$metadata$ = {
    simpleName: 'TourAuditedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TourAuditedEventDTO() {
  }
  TourAuditedEventDTO.$metadata$ = {
    simpleName: 'TourAuditedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TourAuditedEventBase(payload) {
    this.payload_1 = payload;
  }
  TourAuditedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TourAuditedEventBase.$metadata$ = {
    simpleName: 'TourAuditedEventBase',
    kind: 'class',
    interfaces: [TourAuditedEvent]
  };
  Object.defineProperty(TourAuditedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TourAuditedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TourAuditedEventDTOBase(tourId, active, auditedDate, code, description) {
    this.tourId_1 = tourId;
    this.active_1 = active;
    this.auditedDate_1 = auditedDate;
    this.code_1 = code;
    this.description_1 = description;
  }
  TourAuditedEventDTOBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  TourAuditedEventDTOBase.prototype._get_active__1123541189_ikxdxh_k$ = function () {
    return this.active_1;
  };
  TourAuditedEventDTOBase.prototype._get_auditedDate__899560969_evkpop_k$ = function () {
    return this.auditedDate_1;
  };
  TourAuditedEventDTOBase.prototype._get_code__794418686_d4z5dq_k$ = function () {
    return this.code_1;
  };
  TourAuditedEventDTOBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  TourAuditedEventDTOBase.$metadata$ = {
    simpleName: 'TourAuditedEventDTOBase',
    kind: 'class',
    interfaces: [TourAuditedEventDTO]
  };
  Object.defineProperty(TourAuditedEventDTOBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(TourAuditedEventDTOBase.prototype, 'active', {
    configurable: true,
    get: function () {
      return this._get_active__1123541189_ikxdxh_k$();
    }
  });
  Object.defineProperty(TourAuditedEventDTOBase.prototype, 'auditedDate', {
    configurable: true,
    get: function () {
      return this._get_auditedDate__899560969_evkpop_k$();
    }
  });
  Object.defineProperty(TourAuditedEventDTOBase.prototype, 'code', {
    configurable: true,
    get: function () {
      return this._get_code__794418686_d4z5dq_k$();
    }
  });
  Object.defineProperty(TourAuditedEventDTOBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  function _get_UPDATE_ACCEPTED_BY_AI__2651472611() {
    return UPDATE_ACCEPTED_BY_AI;
  }
  var UPDATE_ACCEPTED_BY_AI;
  function _get_ACCEPTED_BY_AI_UPDATED__4116486583() {
    return ACCEPTED_BY_AI_UPDATED;
  }
  var ACCEPTED_BY_AI_UPDATED;
  function UpdateAcceptedByAiCommand() {
  }
  UpdateAcceptedByAiCommand.$metadata$ = {
    simpleName: 'UpdateAcceptedByAiCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateAcceptedByAiCommandDTO() {
  }
  UpdateAcceptedByAiCommandDTO.$metadata$ = {
    simpleName: 'UpdateAcceptedByAiCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateAcceptedByAiCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateAcceptedByAiCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateAcceptedByAiCommandBase.$metadata$ = {
    simpleName: 'UpdateAcceptedByAiCommandBase',
    kind: 'class',
    interfaces: [UpdateAcceptedByAiCommand]
  };
  Object.defineProperty(UpdateAcceptedByAiCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateAcceptedByAiCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateAcceptedByAiCommandBaseDTOBase(tourTraceGpsId, acceptedByAi) {
    this.tourTraceGpsId_1 = tourTraceGpsId;
    this.acceptedByAi_1 = acceptedByAi;
  }
  UpdateAcceptedByAiCommandBaseDTOBase.prototype._get_tourTraceGpsId__1012474739_gqsuib_k$ = function () {
    return this.tourTraceGpsId_1;
  };
  UpdateAcceptedByAiCommandBaseDTOBase.prototype._get_acceptedByAi__3163460325_ipo4d7_k$ = function () {
    return this.acceptedByAi_1;
  };
  UpdateAcceptedByAiCommandBaseDTOBase.$metadata$ = {
    simpleName: 'UpdateAcceptedByAiCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateAcceptedByAiCommandDTO]
  };
  Object.defineProperty(UpdateAcceptedByAiCommandBaseDTOBase.prototype, 'tourTraceGpsId', {
    configurable: true,
    get: function () {
      return this._get_tourTraceGpsId__1012474739_gqsuib_k$();
    }
  });
  Object.defineProperty(UpdateAcceptedByAiCommandBaseDTOBase.prototype, 'acceptedByAi', {
    configurable: true,
    get: function () {
      return this._get_acceptedByAi__3163460325_ipo4d7_k$();
    }
  });
  function AcceptedByAiUpdatedEvent() {
  }
  AcceptedByAiUpdatedEvent.$metadata$ = {
    simpleName: 'AcceptedByAiUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function AcceptedByAiUpdatedEventDTO() {
  }
  AcceptedByAiUpdatedEventDTO.$metadata$ = {
    simpleName: 'AcceptedByAiUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function AcceptedByAiUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  AcceptedByAiUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AcceptedByAiUpdatedEventBase.$metadata$ = {
    simpleName: 'AcceptedByAiUpdatedEventBase',
    kind: 'class',
    interfaces: [AcceptedByAiUpdatedEvent]
  };
  Object.defineProperty(AcceptedByAiUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AcceptedByAiUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AcceptedByAiUpdatedEventDTOBase(tourTraceGpsId) {
    this.tourTraceGpsId_1 = tourTraceGpsId;
  }
  AcceptedByAiUpdatedEventDTOBase.prototype._get_tourTraceGpsId__1012474739_gqsuib_k$ = function () {
    return this.tourTraceGpsId_1;
  };
  AcceptedByAiUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'AcceptedByAiUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [AcceptedByAiUpdatedEventDTO]
  };
  Object.defineProperty(AcceptedByAiUpdatedEventDTOBase.prototype, 'tourTraceGpsId', {
    configurable: true,
    get: function () {
      return this._get_tourTraceGpsId__1012474739_gqsuib_k$();
    }
  });
  function _get_UPDATE_DELIVERY_STATUS__2780937924() {
    return UPDATE_DELIVERY_STATUS;
  }
  var UPDATE_DELIVERY_STATUS;
  function _get_DELIVERY_STATUS_UPDATED__724316984() {
    return DELIVERY_STATUS_UPDATED;
  }
  var DELIVERY_STATUS_UPDATED;
  function UpdateDeliveryStatusCommand() {
  }
  UpdateDeliveryStatusCommand.$metadata$ = {
    simpleName: 'UpdateDeliveryStatusCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateDeliveryStatusCommandDTO() {
  }
  UpdateDeliveryStatusCommandDTO.$metadata$ = {
    simpleName: 'UpdateDeliveryStatusCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateDeliveryStatusCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateDeliveryStatusCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateDeliveryStatusCommandBase.$metadata$ = {
    simpleName: 'UpdateDeliveryStatusCommandBase',
    kind: 'class',
    interfaces: [UpdateDeliveryStatusCommand]
  };
  Object.defineProperty(UpdateDeliveryStatusCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateDeliveryStatusCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateDeliveryStatusCommandDTOBase(deliveryId, state, date) {
    this.deliveryId_1 = deliveryId;
    this.state_1 = state;
    this.date_1 = date;
  }
  UpdateDeliveryStatusCommandDTOBase.prototype._get_deliveryId__1460821564_o5qh4s_k$ = function () {
    return this.deliveryId_1;
  };
  UpdateDeliveryStatusCommandDTOBase.prototype._get_state__3614753120_b8zcm8_k$ = function () {
    return this.state_1;
  };
  UpdateDeliveryStatusCommandDTOBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  UpdateDeliveryStatusCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateDeliveryStatusCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateDeliveryStatusCommandDTO]
  };
  Object.defineProperty(UpdateDeliveryStatusCommandDTOBase.prototype, 'deliveryId', {
    configurable: true,
    get: function () {
      return this._get_deliveryId__1460821564_o5qh4s_k$();
    }
  });
  Object.defineProperty(UpdateDeliveryStatusCommandDTOBase.prototype, 'state', {
    configurable: true,
    get: function () {
      return this._get_state__3614753120_b8zcm8_k$();
    }
  });
  Object.defineProperty(UpdateDeliveryStatusCommandDTOBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  function DeliveryStatusUpdatedEvent() {
  }
  DeliveryStatusUpdatedEvent.$metadata$ = {
    simpleName: 'DeliveryStatusUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function DeliveryStatusUpdatedEventDTO() {
  }
  DeliveryStatusUpdatedEventDTO.$metadata$ = {
    simpleName: 'DeliveryStatusUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeliveryStatusUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  DeliveryStatusUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeliveryStatusUpdatedEventBase.$metadata$ = {
    simpleName: 'DeliveryStatusUpdatedEventBase',
    kind: 'class',
    interfaces: [DeliveryStatusUpdatedEvent]
  };
  Object.defineProperty(DeliveryStatusUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeliveryStatusUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeliveryStatusUpdatedEventDTOBase(deliveryId) {
    this.deliveryId_1 = deliveryId;
  }
  DeliveryStatusUpdatedEventDTOBase.prototype._get_deliveryId__1460821564_o5qh4s_k$ = function () {
    return this.deliveryId_1;
  };
  DeliveryStatusUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'DeliveryStatusUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [DeliveryStatusUpdatedEventDTO]
  };
  Object.defineProperty(DeliveryStatusUpdatedEventDTOBase.prototype, 'deliveryId', {
    configurable: true,
    get: function () {
      return this._get_deliveryId__1460821564_o5qh4s_k$();
    }
  });
  function _get_UPDATE_TERRITORY_CODE__3294055817() {
    return UPDATE_TERRITORY_CODE;
  }
  var UPDATE_TERRITORY_CODE;
  function _get_TERRITORY_CODE_UPDATED__1331666525() {
    return TERRITORY_CODE_UPDATED;
  }
  var TERRITORY_CODE_UPDATED;
  function UpdateTerritoryCodeCommand() {
  }
  UpdateTerritoryCodeCommand.$metadata$ = {
    simpleName: 'UpdateTerritoryCodeCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateTerritoryCodeCommandDTO() {
  }
  UpdateTerritoryCodeCommandDTO.$metadata$ = {
    simpleName: 'UpdateTerritoryCodeCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateTerritoryCodeCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateTerritoryCodeCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateTerritoryCodeCommandBase.$metadata$ = {
    simpleName: 'UpdateTerritoryCodeCommandBase',
    kind: 'class',
    interfaces: [UpdateTerritoryCodeCommand]
  };
  Object.defineProperty(UpdateTerritoryCodeCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateTerritoryCodeCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateTerritoryCodeCommandDTOBase(tourTraceGpsId, territoryCode) {
    this.tourTraceGpsId_1 = tourTraceGpsId;
    this.territoryCode_1 = territoryCode;
  }
  UpdateTerritoryCodeCommandDTOBase.prototype._get_tourTraceGpsId__1012474739_gqsuib_k$ = function () {
    return this.tourTraceGpsId_1;
  };
  UpdateTerritoryCodeCommandDTOBase.prototype._get_territoryCode__421324938_6yugei_k$ = function () {
    return this.territoryCode_1;
  };
  UpdateTerritoryCodeCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateTerritoryCodeCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateTerritoryCodeCommandDTO]
  };
  Object.defineProperty(UpdateTerritoryCodeCommandDTOBase.prototype, 'tourTraceGpsId', {
    configurable: true,
    get: function () {
      return this._get_tourTraceGpsId__1012474739_gqsuib_k$();
    }
  });
  Object.defineProperty(UpdateTerritoryCodeCommandDTOBase.prototype, 'territoryCode', {
    configurable: true,
    get: function () {
      return this._get_territoryCode__421324938_6yugei_k$();
    }
  });
  function TerritoryCodeUpdatedEvent() {
  }
  TerritoryCodeUpdatedEvent.$metadata$ = {
    simpleName: 'TerritoryCodeUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function TerritoryCodeUpdatedEventDTO() {
  }
  TerritoryCodeUpdatedEventDTO.$metadata$ = {
    simpleName: 'TerritoryCodeUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function TerritoryCodeUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  TerritoryCodeUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  TerritoryCodeUpdatedEventBase.$metadata$ = {
    simpleName: 'TerritoryCodeUpdatedEventBase',
    kind: 'class',
    interfaces: [TerritoryCodeUpdatedEvent]
  };
  Object.defineProperty(TerritoryCodeUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(TerritoryCodeUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function TerritoryCodeUpdatedEventDTOBase(tourTraceGpsId) {
    this.tourTraceGpsId_1 = tourTraceGpsId;
  }
  TerritoryCodeUpdatedEventDTOBase.prototype._get_tourTraceGpsId__1012474739_gqsuib_k$ = function () {
    return this.tourTraceGpsId_1;
  };
  TerritoryCodeUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'TerritoryCodeUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [TerritoryCodeUpdatedEventDTO]
  };
  Object.defineProperty(TerritoryCodeUpdatedEventDTOBase.prototype, 'tourTraceGpsId', {
    configurable: true,
    get: function () {
      return this._get_tourTraceGpsId__1012474739_gqsuib_k$();
    }
  });
  function Bonus() {
  }
  Bonus.$metadata$ = {
    simpleName: 'Bonus',
    kind: 'interface',
    interfaces: []
  };
  function BonusBase(id, carrierId, operatorId, campaignId, period, area, activeDeliveryTours, nonActiveDeliveryTours, amount, groupStatus) {
    this.id_1 = id;
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
    this.campaignId_1 = campaignId;
    this.period_1 = period;
    this.area_1 = area;
    this.activeDeliveryTours_1 = activeDeliveryTours;
    this.nonActiveDeliveryTours_1 = nonActiveDeliveryTours;
    this.amount_1 = amount;
    this.groupStatus_1 = groupStatus;
  }
  BonusBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  BonusBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  BonusBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  BonusBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  BonusBase.prototype._get_area__792661854_d3xhsu_k$ = function () {
    return this.area_1;
  };
  BonusBase.prototype._get_activeDeliveryTours__230670992_3tc2vk_k$ = function () {
    return this.activeDeliveryTours_1;
  };
  BonusBase.prototype._get_nonActiveDeliveryTours__1426900855_nljfqv_k$ = function () {
    return this.nonActiveDeliveryTours_1;
  };
  BonusBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  BonusBase.prototype._get_groupStatus__3702590560_9sootc_k$ = function () {
    return this.groupStatus_1;
  };
  BonusBase.prototype.component1 = function () {
    return this.id_1;
  };
  BonusBase.prototype.component2 = function () {
    return this.carrierId_1;
  };
  BonusBase.prototype.component3 = function () {
    return this.operatorId_1;
  };
  BonusBase.prototype.component4 = function () {
    return this.campaignId_1;
  };
  BonusBase.prototype.component5 = function () {
    return this.period_1;
  };
  BonusBase.prototype.component6 = function () {
    return this.area_1;
  };
  BonusBase.prototype.component7 = function () {
    return this.activeDeliveryTours_1;
  };
  BonusBase.prototype.component8 = function () {
    return this.nonActiveDeliveryTours_1;
  };
  BonusBase.prototype.component9 = function () {
    return this.amount_1;
  };
  BonusBase.prototype.component10 = function () {
    return this.groupStatus_1;
  };
  BonusBase.prototype.copy = function (id, carrierId, operatorId, campaignId, period, area, activeDeliveryTours, nonActiveDeliveryTours, amount, groupStatus) {
    return this.copy_gd01bc_k$(id === void 1 ? this.id_1 : id, carrierId === void 1 ? this.carrierId_1 : carrierId, operatorId === void 1 ? this.operatorId_1 : operatorId, campaignId === void 1 ? this.campaignId_1 : campaignId, period === void 1 ? this.period_1 : period, area === void 1 ? this.area_1 : area, activeDeliveryTours === void 1 ? this.activeDeliveryTours_1 : activeDeliveryTours, nonActiveDeliveryTours === void 1 ? this.nonActiveDeliveryTours_1 : nonActiveDeliveryTours, amount === void 1 ? this.amount_1 : amount, groupStatus === void 1 ? this.groupStatus_1 : groupStatus);
  };
  BonusBase.prototype.copy_gd01bc_k$ = function (id, carrierId, operatorId, campaignId, period, area, activeDeliveryTours, nonActiveDeliveryTours, amount, groupStatus) {
    return new BonusBase(id, carrierId, operatorId, campaignId, period, area, activeDeliveryTours, nonActiveDeliveryTours, amount, groupStatus);
  };
  BonusBase.prototype.copy$default_f69583_k$ = function (id, carrierId, operatorId, campaignId, period, area, activeDeliveryTours, nonActiveDeliveryTours, amount, groupStatus, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      carrierId = this.carrierId_1;
    if (!(($mask0 & 4) === 0))
      operatorId = this.operatorId_1;
    if (!(($mask0 & 8) === 0))
      campaignId = this.campaignId_1;
    if (!(($mask0 & 16) === 0))
      period = this.period_1;
    if (!(($mask0 & 32) === 0))
      area = this.area_1;
    if (!(($mask0 & 64) === 0))
      activeDeliveryTours = this.activeDeliveryTours_1;
    if (!(($mask0 & 128) === 0))
      nonActiveDeliveryTours = this.nonActiveDeliveryTours_1;
    if (!(($mask0 & 256) === 0))
      amount = this.amount_1;
    if (!(($mask0 & 512) === 0))
      groupStatus = this.groupStatus_1;
    return this.copy_gd01bc_k$(id, carrierId, operatorId, campaignId, period, area, activeDeliveryTours, nonActiveDeliveryTours, amount, groupStatus);
  };
  BonusBase.prototype.toString = function () {
    return 'BonusBase(id=' + toString_1(this.id_1) + ', carrierId=' + this.carrierId_1 + ', operatorId=' + this.operatorId_1 + ', campaignId=' + this.campaignId_1 + ', period=' + this.period_1 + ', area=' + this.area_1 + ', activeDeliveryTours=' + this.activeDeliveryTours_1 + ', nonActiveDeliveryTours=' + this.nonActiveDeliveryTours_1 + ', amount=' + this.amount_1 + ', groupStatus=' + this.groupStatus_1 + ')';
  };
  BonusBase.prototype.hashCode = function () {
    var result = this.id_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.carrierId_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.operatorId_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.campaignId_1) | 0;
    result = imul(result, 31) + this.period_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.area_1) | 0;
    result = imul(result, 31) + hashCode(this.activeDeliveryTours_1) | 0;
    result = imul(result, 31) + hashCode(this.nonActiveDeliveryTours_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.amount_1) | 0;
    result = imul(result, 31) + this.groupStatus_1.hashCode() | 0;
    return result;
  };
  BonusBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusBase ? other : THROW_CCE();
    if (!this.id_1.equals(tmp0_other_with_cast.id_1))
      return false;
    if (!(this.carrierId_1 === tmp0_other_with_cast.carrierId_1))
      return false;
    if (!(this.operatorId_1 === tmp0_other_with_cast.operatorId_1))
      return false;
    if (!(this.campaignId_1 === tmp0_other_with_cast.campaignId_1))
      return false;
    if (!this.period_1.equals(tmp0_other_with_cast.period_1))
      return false;
    if (!equals(this.area_1, tmp0_other_with_cast.area_1))
      return false;
    if (!equals(this.activeDeliveryTours_1, tmp0_other_with_cast.activeDeliveryTours_1))
      return false;
    if (!equals(this.nonActiveDeliveryTours_1, tmp0_other_with_cast.nonActiveDeliveryTours_1))
      return false;
    if (!equals(this.amount_1, tmp0_other_with_cast.amount_1))
      return false;
    if (!this.groupStatus_1.equals(tmp0_other_with_cast.groupStatus_1))
      return false;
    return true;
  };
  BonusBase.$metadata$ = {
    simpleName: 'BonusBase',
    kind: 'class',
    interfaces: [Bonus]
  };
  Object.defineProperty(BonusBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'area', {
    configurable: true,
    get: function () {
      return this._get_area__792661854_d3xhsu_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'activeDeliveryTours', {
    configurable: true,
    get: function () {
      return this._get_activeDeliveryTours__230670992_3tc2vk_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'nonActiveDeliveryTours', {
    configurable: true,
    get: function () {
      return this._get_nonActiveDeliveryTours__1426900855_nljfqv_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  Object.defineProperty(BonusBase.prototype, 'groupStatus', {
    configurable: true,
    get: function () {
      return this._get_groupStatus__3702590560_9sootc_k$();
    }
  });
  function BonusAggregate() {
  }
  BonusAggregate.$metadata$ = {
    simpleName: 'BonusAggregate',
    kind: 'interface',
    interfaces: []
  };
  function BonusDeliveryTour() {
  }
  BonusDeliveryTour.$metadata$ = {
    simpleName: 'BonusDeliveryTour',
    kind: 'interface',
    interfaces: []
  };
  function BonusDeliveryTourBase_init_$Init$(tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0))
      originalTourId = null;
    BonusDeliveryTourBase.call($this, tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId);
    return $this;
  }
  function BonusDeliveryTourBase_init_$Create$(tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId, $mask0, $marker) {
    return BonusDeliveryTourBase_init_$Init$(tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId, $mask0, $marker, Object.create(BonusDeliveryTourBase.prototype));
  }
  function BonusDeliveryTourBase(tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId) {
    var originalTourId_0 = originalTourId === void 1 ? null : originalTourId;
    this.tourId_1 = tourId;
    this.deliveryCount_1 = deliveryCount;
    this.packCount_1 = packCount;
    this.duration_1 = duration;
    this.manuallyDeclaredDate_1 = manuallyDeclaredDate;
    this.originalTourId_1 = originalTourId_0;
  }
  BonusDeliveryTourBase.prototype._get_tourId__1150940120_j18n2w_k$ = function () {
    return this.tourId_1;
  };
  BonusDeliveryTourBase.prototype._get_deliveryCount__2566701750_skyq8a_k$ = function () {
    return this.deliveryCount_1;
  };
  BonusDeliveryTourBase.prototype._get_packCount__2165529243_z7t8x1_k$ = function () {
    return this.packCount_1;
  };
  BonusDeliveryTourBase.prototype._set_duration__633123523_h8btd0_k$ = function (_set____804775014) {
    this.duration_1 = _set____804775014;
  };
  BonusDeliveryTourBase.prototype._get_duration__4153959607_2bya89_k$ = function () {
    return this.duration_1;
  };
  BonusDeliveryTourBase.prototype._get_manuallyDeclaredDate__260241712_4axvsg_k$ = function () {
    return this.manuallyDeclaredDate_1;
  };
  BonusDeliveryTourBase.prototype._get_originalTourId__1806198727_tvd3uv_k$ = function () {
    return this.originalTourId_1;
  };
  BonusDeliveryTourBase.prototype.component1 = function () {
    return this.tourId_1;
  };
  BonusDeliveryTourBase.prototype.component2 = function () {
    return this.deliveryCount_1;
  };
  BonusDeliveryTourBase.prototype.component3 = function () {
    return this.packCount_1;
  };
  BonusDeliveryTourBase.prototype.component4 = function () {
    return this.duration_1;
  };
  BonusDeliveryTourBase.prototype.component5 = function () {
    return this.manuallyDeclaredDate_1;
  };
  BonusDeliveryTourBase.prototype.component6 = function () {
    return this.originalTourId_1;
  };
  BonusDeliveryTourBase.prototype.copy = function (tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId) {
    return this.copy_ceqlwp_k$(tourId === void 1 ? this.tourId_1 : tourId, deliveryCount === void 1 ? this.deliveryCount_1 : deliveryCount, packCount === void 1 ? this.packCount_1 : packCount, duration === void 1 ? this.duration_1 : duration, manuallyDeclaredDate === void 1 ? this.manuallyDeclaredDate_1 : manuallyDeclaredDate, originalTourId === void 1 ? this.originalTourId_1 : originalTourId);
  };
  BonusDeliveryTourBase.prototype.copy_ceqlwp_k$ = function (tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId) {
    return new BonusDeliveryTourBase(tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId);
  };
  BonusDeliveryTourBase.prototype.copy$default_a45469_k$ = function (tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      tourId = this.tourId_1;
    if (!(($mask0 & 2) === 0))
      deliveryCount = this.deliveryCount_1;
    if (!(($mask0 & 4) === 0))
      packCount = this.packCount_1;
    if (!(($mask0 & 8) === 0))
      duration = this.duration_1;
    if (!(($mask0 & 16) === 0))
      manuallyDeclaredDate = this.manuallyDeclaredDate_1;
    if (!(($mask0 & 32) === 0))
      originalTourId = this.originalTourId_1;
    return this.copy_ceqlwp_k$(tourId, deliveryCount, packCount, duration, manuallyDeclaredDate, originalTourId);
  };
  BonusDeliveryTourBase.prototype.toString = function () {
    return 'BonusDeliveryTourBase(tourId=' + this.tourId_1 + ', deliveryCount=' + this.deliveryCount_1 + ', packCount=' + this.packCount_1 + ', duration=' + toString_1(this.duration_1) + ', manuallyDeclaredDate=' + toString_0(this.manuallyDeclaredDate_1) + ', originalTourId=' + this.originalTourId_1 + ')';
  };
  BonusDeliveryTourBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.tourId_1);
    result = imul(result, 31) + this.deliveryCount_1 | 0;
    result = imul(result, 31) + this.packCount_1 | 0;
    result = imul(result, 31) + this.duration_1.hashCode() | 0;
    result = imul(result, 31) + (this.manuallyDeclaredDate_1 == null ? 0 : this.manuallyDeclaredDate_1.hashCode()) | 0;
    result = imul(result, 31) + (this.originalTourId_1 == null ? 0 : getStringHashCode(this.originalTourId_1)) | 0;
    return result;
  };
  BonusDeliveryTourBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusDeliveryTourBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusDeliveryTourBase ? other : THROW_CCE();
    if (!(this.tourId_1 === tmp0_other_with_cast.tourId_1))
      return false;
    if (!(this.deliveryCount_1 === tmp0_other_with_cast.deliveryCount_1))
      return false;
    if (!(this.packCount_1 === tmp0_other_with_cast.packCount_1))
      return false;
    if (!this.duration_1.equals(tmp0_other_with_cast.duration_1))
      return false;
    if (!equals(this.manuallyDeclaredDate_1, tmp0_other_with_cast.manuallyDeclaredDate_1))
      return false;
    if (!(this.originalTourId_1 == tmp0_other_with_cast.originalTourId_1))
      return false;
    return true;
  };
  BonusDeliveryTourBase.$metadata$ = {
    simpleName: 'BonusDeliveryTourBase',
    kind: 'class',
    interfaces: [BonusDeliveryTour]
  };
  Object.defineProperty(BonusDeliveryTourBase.prototype, 'tourId', {
    configurable: true,
    get: function () {
      return this._get_tourId__1150940120_j18n2w_k$();
    }
  });
  Object.defineProperty(BonusDeliveryTourBase.prototype, 'deliveryCount', {
    configurable: true,
    get: function () {
      return this._get_deliveryCount__2566701750_skyq8a_k$();
    }
  });
  Object.defineProperty(BonusDeliveryTourBase.prototype, 'packCount', {
    configurable: true,
    get: function () {
      return this._get_packCount__2165529243_z7t8x1_k$();
    }
  });
  Object.defineProperty(BonusDeliveryTourBase.prototype, 'duration', {
    configurable: true,
    get: function () {
      return this._get_duration__4153959607_2bya89_k$();
    },
    set: function (value) {
      this._set_duration__633123523_h8btd0_k$(value);
    }
  });
  Object.defineProperty(BonusDeliveryTourBase.prototype, 'manuallyDeclaredDate', {
    configurable: true,
    get: function () {
      return this._get_manuallyDeclaredDate__260241712_4axvsg_k$();
    }
  });
  Object.defineProperty(BonusDeliveryTourBase.prototype, 'originalTourId', {
    configurable: true,
    get: function () {
      return this._get_originalTourId__1806198727_tvd3uv_k$();
    }
  });
  function BonusFinder() {
  }
  BonusFinder.$metadata$ = {
    simpleName: 'BonusFinder',
    kind: 'interface',
    interfaces: []
  };
  function _get_BONUS_GROUP_STATUS_CREATED__3677530192() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_CREATED;
  }
  var BONUS_GROUP_STATUS_CREATED;
  function _get_BONUS_GROUP_STATUS_PUBLISHED__4193571722() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_PUBLISHED;
  }
  var BONUS_GROUP_STATUS_PUBLISHED;
  function _get_BONUS_GROUP_STATUS_INVALID__2480903969() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_INVALID;
  }
  var BONUS_GROUP_STATUS_INVALID;
  function _get_BONUS_GROUP_STATUS_APPROVED__4118766029() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_APPROVED;
  }
  var BONUS_GROUP_STATUS_APPROVED;
  function _get_BONUS_GROUP_STATUS_REJECTED__52391142() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_REJECTED;
  }
  var BONUS_GROUP_STATUS_REJECTED;
  function _get_BONUS_GROUP_STATUS_PAID__3995763544() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_PAID;
  }
  var BONUS_GROUP_STATUS_PAID;
  function _get_BONUS_GROUP_STATUS_DEDUCTED__3309928770() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_DEDUCTED;
  }
  var BONUS_GROUP_STATUS_DEDUCTED;
  function _get_BONUS_GROUP_STATUS_REPORTED__1382590257() {
    init_properties_BonusGroupStatus_kt_4063553960();
    return BONUS_GROUP_STATUS_REPORTED;
  }
  var BONUS_GROUP_STATUS_REPORTED;
  function BonusGroupStatus() {
  }
  BonusGroupStatus.$metadata$ = {
    simpleName: 'BonusGroupStatus',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupStatusBase(value) {
    this.value_1 = value;
  }
  BonusGroupStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  BonusGroupStatusBase.prototype.component1 = function () {
    return this.value_1;
  };
  BonusGroupStatusBase.prototype.copy = function (value) {
    return this.copy_3t26ic_k$(value === void 1 ? this.value_1 : value);
  };
  BonusGroupStatusBase.prototype.copy_3t26ic_k$ = function (value) {
    return new BonusGroupStatusBase(value);
  };
  BonusGroupStatusBase.prototype.copy$default_q3pzg4_k$ = function (value, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      value = this.value_1;
    return this.copy_3t26ic_k$(value);
  };
  BonusGroupStatusBase.prototype.toString = function () {
    return 'BonusGroupStatusBase(value=' + this.value_1 + ')';
  };
  BonusGroupStatusBase.prototype.hashCode = function () {
    return getStringHashCode(this.value_1);
  };
  BonusGroupStatusBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusGroupStatusBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusGroupStatusBase ? other : THROW_CCE();
    if (!(this.value_1 === tmp0_other_with_cast.value_1))
      return false;
    return true;
  };
  BonusGroupStatusBase.$metadata$ = {
    simpleName: 'BonusGroupStatusBase',
    kind: 'class',
    interfaces: [BonusGroupStatus]
  };
  Object.defineProperty(BonusGroupStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function BonusGroupStatusValues() {
    this.CREATED_1 = _get_BONUS_GROUP_STATUS_CREATED__3677530192();
    this.PUBLISHED_1 = _get_BONUS_GROUP_STATUS_PUBLISHED__4193571722();
    this.APPROVED_1 = _get_BONUS_GROUP_STATUS_APPROVED__4118766029();
    this.INVALID_1 = _get_BONUS_GROUP_STATUS_INVALID__2480903969();
    this.REJECTED_1 = _get_BONUS_GROUP_STATUS_REJECTED__52391142();
    this.PAID_1 = _get_BONUS_GROUP_STATUS_PAID__3995763544();
    this.DEDUCTED_1 = _get_BONUS_GROUP_STATUS_DEDUCTED__3309928770();
    this.REPORTED_1 = _get_BONUS_GROUP_STATUS_REPORTED__1382590257();
    this.SWITCHABLE_TO_INVALID_1 = listOf_0(this.PUBLISHED_1);
  }
  BonusGroupStatusValues.prototype._get_CREATED__434088265_76g0nd_k$ = function () {
    return this.CREATED_1;
  };
  BonusGroupStatusValues.prototype._get_PUBLISHED__1097169475_i585dv_k$ = function () {
    return this.PUBLISHED_1;
  };
  BonusGroupStatusValues.prototype._get_APPROVED__2356314100_w282do_k$ = function () {
    return this.APPROVED_1;
  };
  BonusGroupStatusValues.prototype._get_INVALID__3532429338_clzu1y_k$ = function () {
    return this.INVALID_1;
  };
  BonusGroupStatusValues.prototype._get_REJECTED__2584906509_sa4jcj_k$ = function () {
    return this.REJECTED_1;
  };
  BonusGroupStatusValues.prototype._get_PAID__775474431_ctp3wf_k$ = function () {
    return this.PAID_1;
  };
  BonusGroupStatusValues.prototype._get_DEDUCTED__1547476841_plbsrt_k$ = function () {
    return this.DEDUCTED_1;
  };
  BonusGroupStatusValues.prototype._get_REPORTED__3915105624_6a5r54_k$ = function () {
    return this.REPORTED_1;
  };
  BonusGroupStatusValues.prototype._get_SWITCHABLE_TO_INVALID__1508041709_oxukfh_k$ = function () {
    return this.SWITCHABLE_TO_INVALID_1;
  };
  BonusGroupStatusValues.prototype.isCreated = function (status) {
    return status === this.CREATED_1.value_1;
  };
  BonusGroupStatusValues.prototype.isPublished = function (status) {
    return status === this.PUBLISHED_1.value_1;
  };
  BonusGroupStatusValues.prototype.isRejected = function (status) {
    return status === this.REJECTED_1.value_1;
  };
  BonusGroupStatusValues.prototype.isValidated = function (status) {
    return status === this.APPROVED_1.value_1;
  };
  BonusGroupStatusValues.prototype.isInvalid = function (status) {
    return status === this.INVALID_1.value_1;
  };
  BonusGroupStatusValues.prototype.isPaid = function (status) {
    return status === this.PAID_1.value_1;
  };
  BonusGroupStatusValues.prototype.isDeducted = function (status) {
    return status === this.DEDUCTED_1.value_1;
  };
  BonusGroupStatusValues.prototype.isReported = function (status) {
    return status === this.REPORTED_1.value_1;
  };
  BonusGroupStatusValues.prototype.canSwitchToInvalid = function (status) {
    var tmp$ret$1;
    $l$block_0: {
      var tmp0_map_0 = this.SWITCHABLE_TO_INVALID_1;
      var tmp1_map_0 = value$factory();
      var tmp$ret$0;
      $l$block: {
        var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
        var tmp0_iterator_1_2 = tmp0_map_0.iterator_jk1svi_k$();
        while (tmp0_iterator_1_2.hasNext_bitz1p_k$()) {
          var item_2_3 = tmp0_iterator_1_2.next_20eer_k$();
          tmp0_mapTo_0_1.add_6wmvoe_k$(tmp1_map_0(item_2_3));
          Unit_getInstance();
        }
        tmp$ret$0 = tmp0_mapTo_0_1;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0;
      break $l$block_0;
    }
    return tmp$ret$1.contains_i4byw0_k$(status);
  };
  BonusGroupStatusValues.$metadata$ = {
    simpleName: 'BonusGroupStatusValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusGroupStatusValues.prototype, 'CREATED', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_CREATED__434088265_76g0nd_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'PUBLISHED', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_PUBLISHED__1097169475_i585dv_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'APPROVED', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_APPROVED__2356314100_w282do_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'INVALID', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_INVALID__3532429338_clzu1y_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'REJECTED', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_REJECTED__2584906509_sa4jcj_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'PAID', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_PAID__775474431_ctp3wf_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'DEDUCTED', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_DEDUCTED__1547476841_plbsrt_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'REPORTED', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_REPORTED__3915105624_6a5r54_k$
  });
  Object.defineProperty(BonusGroupStatusValues.prototype, 'SWITCHABLE_TO_INVALID', {
    configurable: true,
    get: BonusGroupStatusValues.prototype._get_SWITCHABLE_TO_INVALID__1508041709_oxukfh_k$
  });
  function value$factory() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.value;
    }, null);
  }
  var properties_initialized_BonusGroupStatus_kt_1266541772;
  function init_properties_BonusGroupStatus_kt_4063553960() {
    if (!properties_initialized_BonusGroupStatus_kt_1266541772) {
      properties_initialized_BonusGroupStatus_kt_1266541772 = true;
      BONUS_GROUP_STATUS_CREATED = new BonusGroupStatusBase('CREATED');
      BONUS_GROUP_STATUS_PUBLISHED = new BonusGroupStatusBase('PUBLISHED');
      BONUS_GROUP_STATUS_INVALID = new BonusGroupStatusBase('INVALID');
      BONUS_GROUP_STATUS_APPROVED = new BonusGroupStatusBase('APPROVED');
      BONUS_GROUP_STATUS_REJECTED = new BonusGroupStatusBase('REJECTED');
      BONUS_GROUP_STATUS_PAID = new BonusGroupStatusBase('PAID');
      BONUS_GROUP_STATUS_DEDUCTED = new BonusGroupStatusBase('DEDUCTED');
      BONUS_GROUP_STATUS_REPORTED = new BonusGroupStatusBase('REPORTED');
    }
  }
  function BonusManualData() {
  }
  BonusManualData.$metadata$ = {
    simpleName: 'BonusManualData',
    kind: 'interface',
    interfaces: []
  };
  function BonusManualDataBase(campaignId, areaCode, deliveryTours) {
    this.campaignId_1 = campaignId;
    this.areaCode_1 = areaCode;
    this.deliveryTours_1 = deliveryTours;
  }
  BonusManualDataBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  BonusManualDataBase.prototype._get_areaCode__1355194097_meuigh_k$ = function () {
    return this.areaCode_1;
  };
  BonusManualDataBase.prototype._get_deliveryTours__3053401130_kj72l2_k$ = function () {
    return this.deliveryTours_1;
  };
  BonusManualDataBase.$metadata$ = {
    simpleName: 'BonusManualDataBase',
    kind: 'class',
    interfaces: [BonusManualData]
  };
  Object.defineProperty(BonusManualDataBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(BonusManualDataBase.prototype, 'areaCode', {
    configurable: true,
    get: function () {
      return this._get_areaCode__1355194097_meuigh_k$();
    }
  });
  Object.defineProperty(BonusManualDataBase.prototype, 'deliveryTours', {
    configurable: true,
    get: function () {
      return this._get_deliveryTours__3053401130_kj72l2_k$();
    }
  });
  function _get_ADD_BONUS_DELIVERY_TOURS__690415965() {
    return ADD_BONUS_DELIVERY_TOURS;
  }
  var ADD_BONUS_DELIVERY_TOURS;
  function _get_BONUS_DELIVERY_TOURS_ADDED__1529452442() {
    return BONUS_DELIVERY_TOURS_ADDED;
  }
  var BONUS_DELIVERY_TOURS_ADDED;
  function AddBonusDeliveryToursCommand() {
  }
  AddBonusDeliveryToursCommand.$metadata$ = {
    simpleName: 'AddBonusDeliveryToursCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddBonusDeliveryToursCommandDTO() {
  }
  AddBonusDeliveryToursCommandDTO.$metadata$ = {
    simpleName: 'AddBonusDeliveryToursCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddBonusDeliveryToursCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddBonusDeliveryToursCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddBonusDeliveryToursCommandBase.$metadata$ = {
    simpleName: 'AddBonusDeliveryToursCommandBase',
    kind: 'class',
    interfaces: [AddBonusDeliveryToursCommand]
  };
  Object.defineProperty(AddBonusDeliveryToursCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddBonusDeliveryToursCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddBonusDeliveryToursCommandDTOBase(bonusId, activeTours, nonActiveTours) {
    this.bonusId_1 = bonusId;
    this.activeTours_1 = activeTours;
    this.nonActiveTours_1 = nonActiveTours;
  }
  AddBonusDeliveryToursCommandDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  AddBonusDeliveryToursCommandDTOBase.prototype._get_activeTours__3103558268_jpc138_k$ = function () {
    return this.activeTours_1;
  };
  AddBonusDeliveryToursCommandDTOBase.prototype._get_nonActiveTours__848586339_e185er_k$ = function () {
    return this.nonActiveTours_1;
  };
  AddBonusDeliveryToursCommandDTOBase.$metadata$ = {
    simpleName: 'AddBonusDeliveryToursCommandDTOBase',
    kind: 'class',
    interfaces: [AddBonusDeliveryToursCommandDTO]
  };
  Object.defineProperty(AddBonusDeliveryToursCommandDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(AddBonusDeliveryToursCommandDTOBase.prototype, 'activeTours', {
    configurable: true,
    get: function () {
      return this._get_activeTours__3103558268_jpc138_k$();
    }
  });
  Object.defineProperty(AddBonusDeliveryToursCommandDTOBase.prototype, 'nonActiveTours', {
    configurable: true,
    get: function () {
      return this._get_nonActiveTours__848586339_e185er_k$();
    }
  });
  function BonusDeliveryToursAddedEvent() {
  }
  BonusDeliveryToursAddedEvent.$metadata$ = {
    simpleName: 'BonusDeliveryToursAddedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusDeliveryToursAddedEventDTO() {
  }
  BonusDeliveryToursAddedEventDTO.$metadata$ = {
    simpleName: 'BonusDeliveryToursAddedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusDeliveryToursAddedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusDeliveryToursAddedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusDeliveryToursAddedEventBase.$metadata$ = {
    simpleName: 'BonusDeliveryToursAddedEventBase',
    kind: 'class',
    interfaces: [BonusDeliveryToursAddedEvent]
  };
  Object.defineProperty(BonusDeliveryToursAddedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusDeliveryToursAddedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusDeliveryToursAddedEventDTOBase(bonusId, activeTourIds, nonActiveTourIds) {
    this.bonusId_1 = bonusId;
    this.activeTourIds_1 = activeTourIds;
    this.nonActiveTourIds_1 = nonActiveTourIds;
  }
  BonusDeliveryToursAddedEventDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusDeliveryToursAddedEventDTOBase.prototype._get_activeTourIds__1810981047_ty7lx3_k$ = function () {
    return this.activeTourIds_1;
  };
  BonusDeliveryToursAddedEventDTOBase.prototype._get_nonActiveTourIds__3741441758_95jz1e_k$ = function () {
    return this.nonActiveTourIds_1;
  };
  BonusDeliveryToursAddedEventDTOBase.$metadata$ = {
    simpleName: 'BonusDeliveryToursAddedEventDTOBase',
    kind: 'class',
    interfaces: [BonusDeliveryToursAddedEventDTO]
  };
  Object.defineProperty(BonusDeliveryToursAddedEventDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(BonusDeliveryToursAddedEventDTOBase.prototype, 'activeTourIds', {
    configurable: true,
    get: function () {
      return this._get_activeTourIds__1810981047_ty7lx3_k$();
    }
  });
  Object.defineProperty(BonusDeliveryToursAddedEventDTOBase.prototype, 'nonActiveTourIds', {
    configurable: true,
    get: function () {
      return this._get_nonActiveTourIds__3741441758_95jz1e_k$();
    }
  });
  function _get_BONUS_UPDATED__1940680662() {
    return BONUS_UPDATED;
  }
  var BONUS_UPDATED;
  function BonusUpdatedEvent() {
  }
  BonusUpdatedEvent.$metadata$ = {
    simpleName: 'BonusUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusUpdatedEventDto() {
  }
  BonusUpdatedEventDto.$metadata$ = {
    simpleName: 'BonusUpdatedEventDto',
    kind: 'interface',
    interfaces: []
  };
  function BonusUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusUpdatedEventBase.$metadata$ = {
    simpleName: 'BonusUpdatedEventBase',
    kind: 'class',
    interfaces: [BonusUpdatedEvent]
  };
  Object.defineProperty(BonusUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusUpdatedEventDtoBase(bonusId, oldManualTours) {
    this.bonusId_1 = bonusId;
    this.oldManualTours_1 = oldManualTours;
  }
  BonusUpdatedEventDtoBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusUpdatedEventDtoBase.prototype._get_oldManualTours__4002548605_4u3jpf_k$ = function () {
    return this.oldManualTours_1;
  };
  BonusUpdatedEventDtoBase.$metadata$ = {
    simpleName: 'BonusUpdatedEventDtoBase',
    kind: 'class',
    interfaces: [BonusUpdatedEventDto]
  };
  Object.defineProperty(BonusUpdatedEventDtoBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(BonusUpdatedEventDtoBase.prototype, 'oldManualTours', {
    configurable: true,
    get: function () {
      return this._get_oldManualTours__4002548605_4u3jpf_k$();
    }
  });
  function _get_CREATE_BONUS__3098369487() {
    return CREATE_BONUS;
  }
  var CREATE_BONUS;
  function _get_BONUS_CREATED__2438502217() {
    return BONUS_CREATED;
  }
  var BONUS_CREATED;
  function CreateBonusCommand() {
  }
  CreateBonusCommand.$metadata$ = {
    simpleName: 'CreateBonusCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateBonusCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateBonusCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateBonusCommandBase.$metadata$ = {
    simpleName: 'CreateBonusCommandBase',
    kind: 'class',
    interfaces: [CreateBonusCommand]
  };
  Object.defineProperty(CreateBonusCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateBonusCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateBonusCommandDto() {
  }
  CreateBonusCommandDto.$metadata$ = {
    simpleName: 'CreateBonusCommandDto',
    kind: 'interface',
    interfaces: []
  };
  function CreateBonusCommandDtoBase(carrierId, operatorId, campaignId, areaCode, period, deliveryTours) {
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
    this.campaignId_1 = campaignId;
    this.areaCode_1 = areaCode;
    this.period_1 = period;
    this.deliveryTours_1 = deliveryTours;
  }
  CreateBonusCommandDtoBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  CreateBonusCommandDtoBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  CreateBonusCommandDtoBase.prototype._get_campaignId__197464992_39kcyo_k$ = function () {
    return this.campaignId_1;
  };
  CreateBonusCommandDtoBase.prototype._get_areaCode__1355194097_meuigh_k$ = function () {
    return this.areaCode_1;
  };
  CreateBonusCommandDtoBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  CreateBonusCommandDtoBase.prototype._get_deliveryTours__3053401130_kj72l2_k$ = function () {
    return this.deliveryTours_1;
  };
  CreateBonusCommandDtoBase.$metadata$ = {
    simpleName: 'CreateBonusCommandDtoBase',
    kind: 'class',
    interfaces: [CreateBonusCommandDto]
  };
  Object.defineProperty(CreateBonusCommandDtoBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(CreateBonusCommandDtoBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(CreateBonusCommandDtoBase.prototype, 'campaignId', {
    configurable: true,
    get: function () {
      return this._get_campaignId__197464992_39kcyo_k$();
    }
  });
  Object.defineProperty(CreateBonusCommandDtoBase.prototype, 'areaCode', {
    configurable: true,
    get: function () {
      return this._get_areaCode__1355194097_meuigh_k$();
    }
  });
  Object.defineProperty(CreateBonusCommandDtoBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(CreateBonusCommandDtoBase.prototype, 'deliveryTours', {
    configurable: true,
    get: function () {
      return this._get_deliveryTours__3053401130_kj72l2_k$();
    }
  });
  function BonusCreatedEvent() {
  }
  BonusCreatedEvent.$metadata$ = {
    simpleName: 'BonusCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusCreatedEventBase.$metadata$ = {
    simpleName: 'BonusCreatedEventBase',
    kind: 'class',
    interfaces: [BonusCreatedEvent]
  };
  Object.defineProperty(BonusCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusCreatedEventDto() {
  }
  BonusCreatedEventDto.$metadata$ = {
    simpleName: 'BonusCreatedEventDto',
    kind: 'interface',
    interfaces: []
  };
  function BonusCreatedEventDtoBase(bonusId, carrierId, operatorId, territoryCode) {
    this.bonusId_1 = bonusId;
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
    this.territoryCode_1 = territoryCode;
  }
  BonusCreatedEventDtoBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusCreatedEventDtoBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  BonusCreatedEventDtoBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  BonusCreatedEventDtoBase.prototype._get_territoryCode__421324938_6yugei_k$ = function () {
    return this.territoryCode_1;
  };
  BonusCreatedEventDtoBase.$metadata$ = {
    simpleName: 'BonusCreatedEventDtoBase',
    kind: 'class',
    interfaces: [BonusCreatedEventDto]
  };
  Object.defineProperty(BonusCreatedEventDtoBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(BonusCreatedEventDtoBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(BonusCreatedEventDtoBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(BonusCreatedEventDtoBase.prototype, 'territoryCode', {
    configurable: true,
    get: function () {
      return this._get_territoryCode__421324938_6yugei_k$();
    }
  });
  function _get_CREATE_OR_UPDATE_GROUP_OF_BONUS__587603037() {
    return CREATE_OR_UPDATE_GROUP_OF_BONUS;
  }
  var CREATE_OR_UPDATE_GROUP_OF_BONUS;
  function CreateOrUpdateGroupOfBonusCommand() {
  }
  CreateOrUpdateGroupOfBonusCommand.$metadata$ = {
    simpleName: 'CreateOrUpdateGroupOfBonusCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateOrUpdateGroupOfBonusCommandDTO() {
  }
  CreateOrUpdateGroupOfBonusCommandDTO.$metadata$ = {
    simpleName: 'CreateOrUpdateGroupOfBonusCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateOrUpdateGroupOfBonusCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateOrUpdateGroupOfBonusCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateOrUpdateGroupOfBonusCommandBase.$metadata$ = {
    simpleName: 'CreateOrUpdateGroupOfBonusCommandBase',
    kind: 'class',
    interfaces: [CreateOrUpdateGroupOfBonusCommand]
  };
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateOrUpdateGroupOfBonusCommandDTOBase(carrierId, operatorId, period, territory, bonuses) {
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
    this.period_1 = period;
    this.territory_1 = territory;
    this.bonuses_1 = bonuses;
  }
  CreateOrUpdateGroupOfBonusCommandDTOBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  CreateOrUpdateGroupOfBonusCommandDTOBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  CreateOrUpdateGroupOfBonusCommandDTOBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  CreateOrUpdateGroupOfBonusCommandDTOBase.prototype._get_territory__1826884983_u7ohh3_k$ = function () {
    return this.territory_1;
  };
  CreateOrUpdateGroupOfBonusCommandDTOBase.prototype._get_bonuses__4112178084_30tt24_k$ = function () {
    return this.bonuses_1;
  };
  CreateOrUpdateGroupOfBonusCommandDTOBase.$metadata$ = {
    simpleName: 'CreateOrUpdateGroupOfBonusCommandDTOBase',
    kind: 'class',
    interfaces: [CreateOrUpdateGroupOfBonusCommandDTO]
  };
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandDTOBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandDTOBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandDTOBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandDTOBase.prototype, 'territory', {
    configurable: true,
    get: function () {
      return this._get_territory__1826884983_u7ohh3_k$();
    }
  });
  Object.defineProperty(CreateOrUpdateGroupOfBonusCommandDTOBase.prototype, 'bonuses', {
    configurable: true,
    get: function () {
      return this._get_bonuses__4112178084_30tt24_k$();
    }
  });
  function _get_REMOVE_BONUS_TOURS__850822667() {
    return REMOVE_BONUS_TOURS;
  }
  var REMOVE_BONUS_TOURS;
  function _get_BONUS_TOURS_REMOVED__1738159445() {
    return BONUS_TOURS_REMOVED;
  }
  var BONUS_TOURS_REMOVED;
  function RemoveBonusToursCommand() {
  }
  RemoveBonusToursCommand.$metadata$ = {
    simpleName: 'RemoveBonusToursCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function RemoveBonusToursCommandDTO() {
  }
  RemoveBonusToursCommandDTO.$metadata$ = {
    simpleName: 'RemoveBonusToursCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function RemoveBonusToursCommandBase(payload) {
    this.payload_1 = payload;
  }
  RemoveBonusToursCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  RemoveBonusToursCommandBase.$metadata$ = {
    simpleName: 'RemoveBonusToursCommandBase',
    kind: 'class',
    interfaces: [RemoveBonusToursCommand]
  };
  Object.defineProperty(RemoveBonusToursCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(RemoveBonusToursCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function RemoveBonusToursCommandDTOBase(tourIds) {
    this.tourIds_1 = tourIds;
  }
  RemoveBonusToursCommandDTOBase.prototype._get_tourIds__1319407057_ltjh01_k$ = function () {
    return this.tourIds_1;
  };
  RemoveBonusToursCommandDTOBase.$metadata$ = {
    simpleName: 'RemoveBonusToursCommandDTOBase',
    kind: 'class',
    interfaces: [RemoveBonusToursCommandDTO]
  };
  Object.defineProperty(RemoveBonusToursCommandDTOBase.prototype, 'tourIds', {
    configurable: true,
    get: function () {
      return this._get_tourIds__1319407057_ltjh01_k$();
    }
  });
  function BonusToursRemovedEvent() {
  }
  BonusToursRemovedEvent.$metadata$ = {
    simpleName: 'BonusToursRemovedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusToursRemovedEventDTO() {
  }
  BonusToursRemovedEventDTO.$metadata$ = {
    simpleName: 'BonusToursRemovedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusToursRemovedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusToursRemovedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusToursRemovedEventBase.$metadata$ = {
    simpleName: 'BonusToursRemovedEventBase',
    kind: 'class',
    interfaces: [BonusToursRemovedEvent]
  };
  Object.defineProperty(BonusToursRemovedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusToursRemovedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusToursRemovedEventDTOBase(bonusId) {
    this.bonusId_1 = bonusId;
  }
  BonusToursRemovedEventDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusToursRemovedEventDTOBase.$metadata$ = {
    simpleName: 'BonusToursRemovedEventDTOBase',
    kind: 'class',
    interfaces: [BonusToursRemovedEventDTO]
  };
  Object.defineProperty(BonusToursRemovedEventDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  function _get_SET_BONUS_TOURS_AS_ACTIVE__2758153631() {
    return SET_BONUS_TOURS_AS_ACTIVE;
  }
  var SET_BONUS_TOURS_AS_ACTIVE;
  function _get_BONUS_TOURS_SET_AS_ACTIVE__2299901727() {
    return BONUS_TOURS_SET_AS_ACTIVE;
  }
  var BONUS_TOURS_SET_AS_ACTIVE;
  function SetBonusToursAsActiveCommand() {
  }
  SetBonusToursAsActiveCommand.$metadata$ = {
    simpleName: 'SetBonusToursAsActiveCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function SetBonusToursAsActiveCommandDTO() {
  }
  SetBonusToursAsActiveCommandDTO.$metadata$ = {
    simpleName: 'SetBonusToursAsActiveCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function SetBonusToursAsActiveCommandBase(payload) {
    this.payload_1 = payload;
  }
  SetBonusToursAsActiveCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  SetBonusToursAsActiveCommandBase.$metadata$ = {
    simpleName: 'SetBonusToursAsActiveCommandBase',
    kind: 'class',
    interfaces: [SetBonusToursAsActiveCommand]
  };
  Object.defineProperty(SetBonusToursAsActiveCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(SetBonusToursAsActiveCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function SetBonusToursAsActiveCommandDTOBase(tourIds) {
    this.tourIds_1 = tourIds;
  }
  SetBonusToursAsActiveCommandDTOBase.prototype._get_tourIds__1319407057_ltjh01_k$ = function () {
    return this.tourIds_1;
  };
  SetBonusToursAsActiveCommandDTOBase.$metadata$ = {
    simpleName: 'SetBonusToursAsActiveCommandDTOBase',
    kind: 'class',
    interfaces: [SetBonusToursAsActiveCommandDTO]
  };
  Object.defineProperty(SetBonusToursAsActiveCommandDTOBase.prototype, 'tourIds', {
    configurable: true,
    get: function () {
      return this._get_tourIds__1319407057_ltjh01_k$();
    }
  });
  function BonusToursSetAsActiveEvent() {
  }
  BonusToursSetAsActiveEvent.$metadata$ = {
    simpleName: 'BonusToursSetAsActiveEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusToursSetAsActiveEventDTO() {
  }
  BonusToursSetAsActiveEventDTO.$metadata$ = {
    simpleName: 'BonusToursSetAsActiveEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusToursSetAsActiveEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusToursSetAsActiveEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusToursSetAsActiveEventBase.$metadata$ = {
    simpleName: 'BonusToursSetAsActiveEventBase',
    kind: 'class',
    interfaces: [BonusToursSetAsActiveEvent]
  };
  Object.defineProperty(BonusToursSetAsActiveEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusToursSetAsActiveEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusToursSetAsActiveEventDTOBase(bonusId, tourIds) {
    this.bonusId_1 = bonusId;
    this.tourIds_1 = tourIds;
  }
  BonusToursSetAsActiveEventDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusToursSetAsActiveEventDTOBase.prototype._get_tourIds__1319407057_ltjh01_k$ = function () {
    return this.tourIds_1;
  };
  BonusToursSetAsActiveEventDTOBase.$metadata$ = {
    simpleName: 'BonusToursSetAsActiveEventDTOBase',
    kind: 'class',
    interfaces: [BonusToursSetAsActiveEventDTO]
  };
  Object.defineProperty(BonusToursSetAsActiveEventDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(BonusToursSetAsActiveEventDTOBase.prototype, 'tourIds', {
    configurable: true,
    get: function () {
      return this._get_tourIds__1319407057_ltjh01_k$();
    }
  });
  function _get_UPDATE_BONUS_AMOUNT__2867841027() {
    return UPDATE_BONUS_AMOUNT;
  }
  var UPDATE_BONUS_AMOUNT;
  function _get_BONUS_AMOUNT_UPDATED__3311676119() {
    return BONUS_AMOUNT_UPDATED;
  }
  var BONUS_AMOUNT_UPDATED;
  function UpdateBonusAmountCommand() {
  }
  UpdateBonusAmountCommand.$metadata$ = {
    simpleName: 'UpdateBonusAmountCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateBonusAmountCommandDTO() {
  }
  UpdateBonusAmountCommandDTO.$metadata$ = {
    simpleName: 'UpdateBonusAmountCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateBonusAmountCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateBonusAmountCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateBonusAmountCommandBase.$metadata$ = {
    simpleName: 'UpdateBonusAmountCommandBase',
    kind: 'class',
    interfaces: [UpdateBonusAmountCommand]
  };
  Object.defineProperty(UpdateBonusAmountCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateBonusAmountCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateBonusAmountCommandDTOBase(bonusId, amount) {
    this.bonusId_1 = bonusId;
    this.amount_1 = amount;
  }
  UpdateBonusAmountCommandDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  UpdateBonusAmountCommandDTOBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  UpdateBonusAmountCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateBonusAmountCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateBonusAmountCommandDTO]
  };
  Object.defineProperty(UpdateBonusAmountCommandDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(UpdateBonusAmountCommandDTOBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  function BonusAmountUpdatedEvent() {
  }
  BonusAmountUpdatedEvent.$metadata$ = {
    simpleName: 'BonusAmountUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusAmountUpdatedEventDTO() {
  }
  BonusAmountUpdatedEventDTO.$metadata$ = {
    simpleName: 'BonusAmountUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusAmountUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusAmountUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusAmountUpdatedEventBase.$metadata$ = {
    simpleName: 'BonusAmountUpdatedEventBase',
    kind: 'class',
    interfaces: [BonusAmountUpdatedEvent]
  };
  Object.defineProperty(BonusAmountUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusAmountUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusAmountUpdatedEventDTOBase(bonusId) {
    this.bonusId_1 = bonusId;
  }
  BonusAmountUpdatedEventDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusAmountUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'BonusAmountUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [BonusAmountUpdatedEventDTO]
  };
  Object.defineProperty(BonusAmountUpdatedEventDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  function _get_UPDATE_BONUS_STATUS__1850489769() {
    return UPDATE_BONUS_STATUS;
  }
  var UPDATE_BONUS_STATUS;
  function _get_BONUS_STATUS_UPDATED__1325242493() {
    return BONUS_STATUS_UPDATED;
  }
  var BONUS_STATUS_UPDATED;
  function UpdateBonusStatusCommand() {
  }
  UpdateBonusStatusCommand.$metadata$ = {
    simpleName: 'UpdateBonusStatusCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateBonusStatusCommandDTO() {
  }
  UpdateBonusStatusCommandDTO.$metadata$ = {
    simpleName: 'UpdateBonusStatusCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function UpdateBonusStatusCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateBonusStatusCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateBonusStatusCommandBase.$metadata$ = {
    simpleName: 'UpdateBonusStatusCommandBase',
    kind: 'class',
    interfaces: [UpdateBonusStatusCommand]
  };
  Object.defineProperty(UpdateBonusStatusCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateBonusStatusCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateBonusStatusCommandDTOBase(status, bonusId) {
    this.status_1 = status;
    this.bonusId_1 = bonusId;
  }
  UpdateBonusStatusCommandDTOBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  UpdateBonusStatusCommandDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  UpdateBonusStatusCommandDTOBase.$metadata$ = {
    simpleName: 'UpdateBonusStatusCommandDTOBase',
    kind: 'class',
    interfaces: [UpdateBonusStatusCommandDTO]
  };
  Object.defineProperty(UpdateBonusStatusCommandDTOBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(UpdateBonusStatusCommandDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  function BonusStatusUpdatedEvent() {
  }
  BonusStatusUpdatedEvent.$metadata$ = {
    simpleName: 'BonusStatusUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusStatusUpdatedEventDTO() {
  }
  BonusStatusUpdatedEventDTO.$metadata$ = {
    simpleName: 'BonusStatusUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusStatusUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusStatusUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusStatusUpdatedEventBase.$metadata$ = {
    simpleName: 'BonusStatusUpdatedEventBase',
    kind: 'class',
    interfaces: [BonusStatusUpdatedEvent]
  };
  Object.defineProperty(BonusStatusUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusStatusUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusStatusUpdatedEventDTOBase(status, bonusId) {
    this.status_1 = status;
    this.bonusId_1 = bonusId;
  }
  BonusStatusUpdatedEventDTOBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusStatusUpdatedEventDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusStatusUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'BonusStatusUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [BonusStatusUpdatedEventDTO]
  };
  Object.defineProperty(BonusStatusUpdatedEventDTOBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(BonusStatusUpdatedEventDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  function BonusGroup() {
  }
  BonusGroup.$metadata$ = {
    simpleName: 'BonusGroup',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupBase(id, carrierId, operatorId, period, territory, bonuses, invoices, incidents, status, amount, lastStatusModifiedDate, creationDate, logs, comment) {
    this.id_1 = id;
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
    this.period_1 = period;
    this.territory_1 = territory;
    this.bonuses_1 = bonuses;
    this.invoices_1 = invoices;
    this.incidents_1 = incidents;
    this.status_1 = status;
    this.amount_1 = amount;
    this.lastStatusModifiedDate_1 = lastStatusModifiedDate;
    this.creationDate_1 = creationDate;
    this.logs_1 = logs;
    this.comment_1 = comment;
  }
  BonusGroupBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  BonusGroupBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  BonusGroupBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  BonusGroupBase.prototype._get_territory__1826884983_u7ohh3_k$ = function () {
    return this.territory_1;
  };
  BonusGroupBase.prototype._get_bonuses__4112178084_30tt24_k$ = function () {
    return this.bonuses_1;
  };
  BonusGroupBase.prototype._get_invoices__4037360037_49df17_k$ = function () {
    return this.invoices_1;
  };
  BonusGroupBase.prototype._get_incidents__679368848_b8h8cw_k$ = function () {
    return this.incidents_1;
  };
  BonusGroupBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusGroupBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  BonusGroupBase.prototype._get_lastStatusModifiedDate__180852876_2zoaz0_k$ = function () {
    return this.lastStatusModifiedDate_1;
  };
  BonusGroupBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  BonusGroupBase.prototype._get_logs__802733692_d9xda4_k$ = function () {
    return this.logs_1;
  };
  BonusGroupBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  BonusGroupBase.$metadata$ = {
    simpleName: 'BonusGroupBase',
    kind: 'class',
    interfaces: [BonusGroup]
  };
  Object.defineProperty(BonusGroupBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'territory', {
    configurable: true,
    get: function () {
      return this._get_territory__1826884983_u7ohh3_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'bonuses', {
    configurable: true,
    get: function () {
      return this._get_bonuses__4112178084_30tt24_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'invoices', {
    configurable: true,
    get: function () {
      return this._get_invoices__4037360037_49df17_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'incidents', {
    configurable: true,
    get: function () {
      return this._get_incidents__679368848_b8h8cw_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'lastStatusModifiedDate', {
    configurable: true,
    get: function () {
      return this._get_lastStatusModifiedDate__180852876_2zoaz0_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'logs', {
    configurable: true,
    get: function () {
      return this._get_logs__802733692_d9xda4_k$();
    }
  });
  Object.defineProperty(BonusGroupBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  function BonusGroupAction(canEdit, canEditDocument, canPublish, canApprove, canReject, canResolve, canAddIncident, canPay, canDeduce, canReport, canDelete) {
    this.canEdit_1 = canEdit;
    this.canEditDocument_1 = canEditDocument;
    this.canPublish_1 = canPublish;
    this.canApprove_1 = canApprove;
    this.canReject_1 = canReject;
    this.canResolve_1 = canResolve;
    this.canAddIncident_1 = canAddIncident;
    this.canPay_1 = canPay;
    this.canDeduce_1 = canDeduce;
    this.canReport_1 = canReport;
    this.canDelete_1 = canDelete;
  }
  BonusGroupAction.prototype._get_canEdit__1975099479_wnx8if_k$ = function () {
    return this.canEdit_1;
  };
  BonusGroupAction.prototype._get_canEditDocument__2625104252_rm6ykk_k$ = function () {
    return this.canEditDocument_1;
  };
  BonusGroupAction.prototype._get_canPublish__3123931468_jd7d10_k$ = function () {
    return this.canPublish_1;
  };
  BonusGroupAction.prototype._get_canApprove__3015559886_l5q52q_k$ = function () {
    return this.canApprove_1;
  };
  BonusGroupAction.prototype._get_canReject__2671812770_qudu1q_k$ = function () {
    return this.canReject_1;
  };
  BonusGroupAction.prototype._get_canResolve__1488986127_omi51r_k$ = function () {
    return this.canResolve_1;
  };
  BonusGroupAction.prototype._get_canAddIncident__1042489288_h8o5vs_k$ = function () {
    return this.canAddIncident_1;
  };
  BonusGroupAction.prototype._get_canPay__2834984787_o58hpp_k$ = function () {
    return this.canPay_1;
  };
  BonusGroupAction.prototype._get_canDeduce__3126598189_jbm7df_k$ = function () {
    return this.canDeduce_1;
  };
  BonusGroupAction.prototype._get_canReport__2677666221_qqwdhv_k$ = function () {
    return this.canReport_1;
  };
  BonusGroupAction.prototype._get_canDelete__3133526038_j7hpt6_k$ = function () {
    return this.canDelete_1;
  };
  BonusGroupAction.$metadata$ = {
    simpleName: 'BonusGroupAction',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusGroupAction.prototype, 'canEdit', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canEdit__1975099479_wnx8if_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canEditDocument', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canEditDocument__2625104252_rm6ykk_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canPublish', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canPublish__3123931468_jd7d10_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canApprove', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canApprove__3015559886_l5q52q_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canReject', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canReject__2671812770_qudu1q_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canResolve', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canResolve__1488986127_omi51r_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canAddIncident', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canAddIncident__1042489288_h8o5vs_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canPay', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canPay__2834984787_o58hpp_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canDeduce', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canDeduce__3126598189_jbm7df_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canReport', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canReport__2677666221_qqwdhv_k$
  });
  Object.defineProperty(BonusGroupAction.prototype, 'canDelete', {
    configurable: true,
    get: BonusGroupAction.prototype._get_canDelete__3133526038_j7hpt6_k$
  });
  function BonusGroupStateMachine() {
    this.Status_1 = new BonusGroupStatusValues();
  }
  BonusGroupStateMachine.prototype.getAvailableActions = function (status, isColisActiv) {
    var isCreated = this.Status_1.isCreated(status);
    var isPublished = this.Status_1.isPublished(status);
    var isRejected = this.Status_1.isRejected(status);
    var isInvalid = this.Status_1.isInvalid(status);
    var isValidated = this.Status_1.isValidated(status);
    var isDeducted = this.Status_1.isDeducted(status);
    var isReported = this.Status_1.isReported(status);
    var tmp0_canAddIncident = (isPublished ? true : isRejected) ? true : isDeducted;
    var tmp1_canApprove = isColisActiv ? ((isPublished ? true : isRejected) ? true : isInvalid) ? true : isDeducted : false;
    var tmp2_canPublish = isDeducted ? !isColisActiv : false;
    var tmp3_canReject = (((isPublished ? true : isInvalid) ? true : isCreated) ? true : isDeducted) ? true : isReported;
    var tmp4_canEdit = isColisActiv ? (((isCreated ? true : isInvalid) ? true : isDeducted) ? true : isReported) ? true : isPublished : false;
    var tmp5_canEditDocument = isCreated ? true : isInvalid;
    var tmp6_canDeduce = isCreated ? true : isReported;
    var tmp7_canReport = isCreated ? true : isInvalid;
    var tmp8_canDelete = ((((isPublished ? true : isInvalid) ? true : isCreated) ? true : isDeducted) ? true : isReported) ? true : isRejected;
    return new BonusGroupAction(tmp4_canEdit, tmp5_canEditDocument, tmp2_canPublish, tmp1_canApprove, tmp3_canReject, isInvalid, tmp0_canAddIncident, isValidated, tmp6_canDeduce, tmp7_canReport, tmp8_canDelete);
  };
  BonusGroupStateMachine.$metadata$ = {
    simpleName: 'BonusGroupStateMachine',
    kind: 'class',
    interfaces: []
  };
  function BonusGroupDates() {
  }
  BonusGroupDates.$metadata$ = {
    simpleName: 'BonusGroupDates',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupDatesBase(organizationId, firstCreationDate, lastCreationDate, territoryNames) {
    this.organizationId_1 = organizationId;
    this.firstCreationDate_1 = firstCreationDate;
    this.lastCreationDate_1 = lastCreationDate;
    this.territoryNames_1 = territoryNames;
  }
  BonusGroupDatesBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  BonusGroupDatesBase.prototype._get_firstCreationDate__3391587572_exuk98_k$ = function () {
    return this.firstCreationDate_1;
  };
  BonusGroupDatesBase.prototype._get_lastCreationDate__2447064648_uk6yt4_k$ = function () {
    return this.lastCreationDate_1;
  };
  BonusGroupDatesBase.prototype._get_territoryNames__478432381_7wugsd_k$ = function () {
    return this.territoryNames_1;
  };
  BonusGroupDatesBase.prototype.component1 = function () {
    return this.organizationId_1;
  };
  BonusGroupDatesBase.prototype.component2 = function () {
    return this.firstCreationDate_1;
  };
  BonusGroupDatesBase.prototype.component3 = function () {
    return this.lastCreationDate_1;
  };
  BonusGroupDatesBase.prototype.component4 = function () {
    return this.territoryNames_1;
  };
  BonusGroupDatesBase.prototype.copy = function (organizationId, firstCreationDate, lastCreationDate, territoryNames) {
    return this.copy_vw56el_k$(organizationId === void 1 ? this.organizationId_1 : organizationId, firstCreationDate === void 1 ? this.firstCreationDate_1 : firstCreationDate, lastCreationDate === void 1 ? this.lastCreationDate_1 : lastCreationDate, territoryNames === void 1 ? this.territoryNames_1 : territoryNames);
  };
  BonusGroupDatesBase.prototype.copy_vw56el_k$ = function (organizationId, firstCreationDate, lastCreationDate, territoryNames) {
    return new BonusGroupDatesBase(organizationId, firstCreationDate, lastCreationDate, territoryNames);
  };
  BonusGroupDatesBase.prototype.copy$default_ya9r5c_k$ = function (organizationId, firstCreationDate, lastCreationDate, territoryNames, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      organizationId = this.organizationId_1;
    if (!(($mask0 & 2) === 0))
      firstCreationDate = this.firstCreationDate_1;
    if (!(($mask0 & 4) === 0))
      lastCreationDate = this.lastCreationDate_1;
    if (!(($mask0 & 8) === 0))
      territoryNames = this.territoryNames_1;
    return this.copy_vw56el_k$(organizationId, firstCreationDate, lastCreationDate, territoryNames);
  };
  BonusGroupDatesBase.prototype.toString = function () {
    return 'BonusGroupDatesBase(organizationId=' + this.organizationId_1 + ', firstCreationDate=' + toString_0(this.firstCreationDate_1) + ', lastCreationDate=' + toString_0(this.lastCreationDate_1) + ', territoryNames=' + this.territoryNames_1 + ')';
  };
  BonusGroupDatesBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.organizationId_1);
    result = imul(result, 31) + (this.firstCreationDate_1 == null ? 0 : this.firstCreationDate_1.hashCode()) | 0;
    result = imul(result, 31) + (this.lastCreationDate_1 == null ? 0 : this.lastCreationDate_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.territoryNames_1) | 0;
    return result;
  };
  BonusGroupDatesBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusGroupDatesBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusGroupDatesBase ? other : THROW_CCE();
    if (!(this.organizationId_1 === tmp0_other_with_cast.organizationId_1))
      return false;
    if (!equals(this.firstCreationDate_1, tmp0_other_with_cast.firstCreationDate_1))
      return false;
    if (!equals(this.lastCreationDate_1, tmp0_other_with_cast.lastCreationDate_1))
      return false;
    if (!(this.territoryNames_1 === tmp0_other_with_cast.territoryNames_1))
      return false;
    return true;
  };
  BonusGroupDatesBase.$metadata$ = {
    simpleName: 'BonusGroupDatesBase',
    kind: 'class',
    interfaces: [BonusGroupDates]
  };
  Object.defineProperty(BonusGroupDatesBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(BonusGroupDatesBase.prototype, 'firstCreationDate', {
    configurable: true,
    get: function () {
      return this._get_firstCreationDate__3391587572_exuk98_k$();
    }
  });
  Object.defineProperty(BonusGroupDatesBase.prototype, 'lastCreationDate', {
    configurable: true,
    get: function () {
      return this._get_lastCreationDate__2447064648_uk6yt4_k$();
    }
  });
  Object.defineProperty(BonusGroupDatesBase.prototype, 'territoryNames', {
    configurable: true,
    get: function () {
      return this._get_territoryNames__478432381_7wugsd_k$();
    }
  });
  function BonusGroupFunder() {
  }
  BonusGroupFunder.$metadata$ = {
    simpleName: 'BonusGroupFunder',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupFunderBase(id, fundedAmount) {
    this.id_1 = id;
    this.fundedAmount_1 = fundedAmount;
  }
  BonusGroupFunderBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupFunderBase.prototype._get_fundedAmount__630604079_afg17z_k$ = function () {
    return this.fundedAmount_1;
  };
  BonusGroupFunderBase.$metadata$ = {
    simpleName: 'BonusGroupFunderBase',
    kind: 'class',
    interfaces: [BonusGroupFunder]
  };
  Object.defineProperty(BonusGroupFunderBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupFunderBase.prototype, 'fundedAmount', {
    configurable: true,
    get: function () {
      return this._get_fundedAmount__630604079_afg17z_k$();
    }
  });
  function BonusGroupFunderInvoiceDetails() {
  }
  BonusGroupFunderInvoiceDetails.$metadata$ = {
    simpleName: 'BonusGroupFunderInvoiceDetails',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupFunderInvoiceDetailsBase(invoiceNumber) {
    this.invoiceNumber_1 = invoiceNumber;
  }
  BonusGroupFunderInvoiceDetailsBase.prototype._get_invoiceNumber__3406304955_ep3491_k$ = function () {
    return this.invoiceNumber_1;
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.component1 = function () {
    return this.invoiceNumber_1;
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.copy = function (invoiceNumber) {
    return this.copy_3t26ic_k$(invoiceNumber === void 1 ? this.invoiceNumber_1 : invoiceNumber);
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.copy_3t26ic_k$ = function (invoiceNumber) {
    return new BonusGroupFunderInvoiceDetailsBase(invoiceNumber);
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.copy$default_q3pzg4_k$ = function (invoiceNumber, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      invoiceNumber = this.invoiceNumber_1;
    return this.copy_3t26ic_k$(invoiceNumber);
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.toString = function () {
    return 'BonusGroupFunderInvoiceDetailsBase(invoiceNumber=' + this.invoiceNumber_1 + ')';
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.hashCode = function () {
    return getStringHashCode(this.invoiceNumber_1);
  };
  BonusGroupFunderInvoiceDetailsBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusGroupFunderInvoiceDetailsBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusGroupFunderInvoiceDetailsBase ? other : THROW_CCE();
    if (!(this.invoiceNumber_1 === tmp0_other_with_cast.invoiceNumber_1))
      return false;
    return true;
  };
  BonusGroupFunderInvoiceDetailsBase.$metadata$ = {
    simpleName: 'BonusGroupFunderInvoiceDetailsBase',
    kind: 'class',
    interfaces: [BonusGroupFunderInvoiceDetails]
  };
  Object.defineProperty(BonusGroupFunderInvoiceDetailsBase.prototype, 'invoiceNumber', {
    configurable: true,
    get: function () {
      return this._get_invoiceNumber__3406304955_ep3491_k$();
    }
  });
  function BonusGroupIncident() {
  }
  BonusGroupIncident.$metadata$ = {
    simpleName: 'BonusGroupIncident',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupIncidentBase(id, type, description, status, properties) {
    this.id_1 = id;
    this.type_1 = type;
    this.description_1 = description;
    this.status_1 = status;
    this.properties_1 = properties;
  }
  BonusGroupIncidentBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupIncidentBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  BonusGroupIncidentBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  BonusGroupIncidentBase.prototype._set_status__299634277_kr0odn_k$ = function (_set____804775014) {
    this.status_1 = _set____804775014;
  };
  BonusGroupIncidentBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusGroupIncidentBase.prototype._get_properties__3765791160_8r22x4_k$ = function () {
    return this.properties_1;
  };
  BonusGroupIncidentBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentBase',
    kind: 'class',
    interfaces: [BonusGroupIncident]
  };
  Object.defineProperty(BonusGroupIncidentBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    },
    set: function (value) {
      this._set_status__299634277_kr0odn_k$(value);
    }
  });
  Object.defineProperty(BonusGroupIncidentBase.prototype, 'properties', {
    configurable: true,
    get: function () {
      return this._get_properties__3765791160_8r22x4_k$();
    }
  });
  function _get_BONUS_GROUP_INCIDENT_STATUS_CREATED__794065193() {
    init_properties_BonusGroupIncidentStatus_kt_4255620598();
    return BONUS_GROUP_INCIDENT_STATUS_CREATED;
  }
  var BONUS_GROUP_INCIDENT_STATUS_CREATED;
  function _get_BONUS_GROUP_INCIDENT_STATUS_RESOLVED__551550707() {
    init_properties_BonusGroupIncidentStatus_kt_4255620598();
    return BONUS_GROUP_INCIDENT_STATUS_RESOLVED;
  }
  var BONUS_GROUP_INCIDENT_STATUS_RESOLVED;
  function BonusGroupIncidentStatus() {
  }
  BonusGroupIncidentStatus.$metadata$ = {
    simpleName: 'BonusGroupIncidentStatus',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupIncidentStatusBase(value) {
    this.value_1 = value;
  }
  BonusGroupIncidentStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  BonusGroupIncidentStatusBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentStatusBase',
    kind: 'class',
    interfaces: [BonusGroupIncidentStatus]
  };
  Object.defineProperty(BonusGroupIncidentStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function BonusGroupIncidentStatusValues() {
    this.CREATED_1 = _get_BONUS_GROUP_INCIDENT_STATUS_CREATED__794065193();
    this.RESOLVED_1 = _get_BONUS_GROUP_INCIDENT_STATUS_RESOLVED__551550707();
  }
  BonusGroupIncidentStatusValues.prototype._get_CREATED__434088265_76g0nd_k$ = function () {
    return this.CREATED_1;
  };
  BonusGroupIncidentStatusValues.prototype._get_RESOLVED__2277167827_xdcg19_k$ = function () {
    return this.RESOLVED_1;
  };
  BonusGroupIncidentStatusValues.prototype.isCreated = function (status) {
    return status === this.CREATED_1.value_1;
  };
  BonusGroupIncidentStatusValues.prototype.isResolved = function (status) {
    return status === this.RESOLVED_1.value_1;
  };
  BonusGroupIncidentStatusValues.$metadata$ = {
    simpleName: 'BonusGroupIncidentStatusValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusGroupIncidentStatusValues.prototype, 'CREATED', {
    configurable: true,
    get: BonusGroupIncidentStatusValues.prototype._get_CREATED__434088265_76g0nd_k$
  });
  Object.defineProperty(BonusGroupIncidentStatusValues.prototype, 'RESOLVED', {
    configurable: true,
    get: BonusGroupIncidentStatusValues.prototype._get_RESOLVED__2277167827_xdcg19_k$
  });
  var properties_initialized_BonusGroupIncidentStatus_kt_2170893594;
  function init_properties_BonusGroupIncidentStatus_kt_4255620598() {
    if (!properties_initialized_BonusGroupIncidentStatus_kt_2170893594) {
      properties_initialized_BonusGroupIncidentStatus_kt_2170893594 = true;
      BONUS_GROUP_INCIDENT_STATUS_CREATED = new BonusGroupIncidentStatusBase('CREATED');
      BONUS_GROUP_INCIDENT_STATUS_RESOLVED = new BonusGroupIncidentStatusBase('RESOLVED');
    }
  }
  function _get_BONUS_GROUP_INCIDENT_TYPE_MANUAL__2528055789() {
    init_properties_BonusGroupIncidentType_kt_699812334();
    return BONUS_GROUP_INCIDENT_TYPE_MANUAL;
  }
  var BONUS_GROUP_INCIDENT_TYPE_MANUAL;
  function _get_BONUS_GROUP_INCIDENT_TYPE_REJECTION__1804612768() {
    init_properties_BonusGroupIncidentType_kt_699812334();
    return BONUS_GROUP_INCIDENT_TYPE_REJECTION;
  }
  var BONUS_GROUP_INCIDENT_TYPE_REJECTION;
  function _get_BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA__2162050835() {
    init_properties_BonusGroupIncidentType_kt_699812334();
    return BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA;
  }
  var BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA;
  function _get_BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA__1815693122() {
    init_properties_BonusGroupIncidentType_kt_699812334();
    return BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA;
  }
  var BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA;
  function BonusGroupIncidentType() {
  }
  BonusGroupIncidentType.$metadata$ = {
    simpleName: 'BonusGroupIncidentType',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupIncidentTypeBase(value) {
    this.value_1 = value;
  }
  BonusGroupIncidentTypeBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  BonusGroupIncidentTypeBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentTypeBase',
    kind: 'class',
    interfaces: [BonusGroupIncidentType]
  };
  Object.defineProperty(BonusGroupIncidentTypeBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function BonusGroupIncidentTypeValues() {
    this.MANUAL_1 = _get_BONUS_GROUP_INCIDENT_TYPE_MANUAL__2528055789();
    this.REJECTION_1 = _get_BONUS_GROUP_INCIDENT_TYPE_REJECTION__1804612768();
    this.CARRIER_REPORT_INVALID_DATA_1 = _get_BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA__2162050835();
    this.CARRIER_REPORT_MISSING_DATA_1 = _get_BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA__1815693122();
  }
  BonusGroupIncidentTypeValues.prototype._get_MANUAL__3839171589_7jda7v_k$ = function () {
    return this.MANUAL_1;
  };
  BonusGroupIncidentTypeValues.prototype._get_REJECTION__2822820744_och7js_k$ = function () {
    return this.REJECTION_1;
  };
  BonusGroupIncidentTypeValues.prototype._get_CARRIER_REPORT_INVALID_DATA__2085354491_yhkdtn_k$ = function () {
    return this.CARRIER_REPORT_INVALID_DATA_1;
  };
  BonusGroupIncidentTypeValues.prototype._get_CARRIER_REPORT_MISSING_DATA__1738996778_srcqi2_k$ = function () {
    return this.CARRIER_REPORT_MISSING_DATA_1;
  };
  BonusGroupIncidentTypeValues.$metadata$ = {
    simpleName: 'BonusGroupIncidentTypeValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusGroupIncidentTypeValues.prototype, 'MANUAL', {
    configurable: true,
    get: BonusGroupIncidentTypeValues.prototype._get_MANUAL__3839171589_7jda7v_k$
  });
  Object.defineProperty(BonusGroupIncidentTypeValues.prototype, 'REJECTION', {
    configurable: true,
    get: BonusGroupIncidentTypeValues.prototype._get_REJECTION__2822820744_och7js_k$
  });
  Object.defineProperty(BonusGroupIncidentTypeValues.prototype, 'CARRIER_REPORT_INVALID_DATA', {
    configurable: true,
    get: BonusGroupIncidentTypeValues.prototype._get_CARRIER_REPORT_INVALID_DATA__2085354491_yhkdtn_k$
  });
  Object.defineProperty(BonusGroupIncidentTypeValues.prototype, 'CARRIER_REPORT_MISSING_DATA', {
    configurable: true,
    get: BonusGroupIncidentTypeValues.prototype._get_CARRIER_REPORT_MISSING_DATA__1738996778_srcqi2_k$
  });
  var properties_initialized_BonusGroupIncidentType_kt_2574735890;
  function init_properties_BonusGroupIncidentType_kt_699812334() {
    if (!properties_initialized_BonusGroupIncidentType_kt_2574735890) {
      properties_initialized_BonusGroupIncidentType_kt_2574735890 = true;
      BONUS_GROUP_INCIDENT_TYPE_MANUAL = new BonusGroupIncidentTypeBase('MANUAL');
      BONUS_GROUP_INCIDENT_TYPE_REJECTION = new BonusGroupIncidentTypeBase('REJECTION');
      BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA = new BonusGroupIncidentTypeBase('CARRIER_REPORT_INVALID_DATA');
      BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA = new BonusGroupIncidentTypeBase('CARRIER_REPORT_MISSING_DATA');
    }
  }
  function BonusGroupInvoice() {
  }
  BonusGroupInvoice.$metadata$ = {
    simpleName: 'BonusGroupInvoice',
    kind: 'interface',
    interfaces: [Attachment]
  };
  function BonusGroupInvoiceBase(id, name, file, amount, type, targetId, details, creationDate) {
    this.id_1 = id;
    this.name_1 = name;
    this.file_1 = file;
    this.amount_1 = amount;
    this.type_1 = type;
    this.targetId_1 = targetId;
    this.details_1 = details;
    this.creationDate_1 = creationDate;
  }
  BonusGroupInvoiceBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupInvoiceBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  BonusGroupInvoiceBase.prototype._get_file__797018191_d6iv67_k$ = function () {
    return this.file_1;
  };
  BonusGroupInvoiceBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  BonusGroupInvoiceBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  BonusGroupInvoiceBase.prototype._get_targetId__666236607_b0nrgf_k$ = function () {
    return this.targetId_1;
  };
  BonusGroupInvoiceBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  BonusGroupInvoiceBase.prototype._get_creationDate__1646693310_r8ecou_k$ = function () {
    return this.creationDate_1;
  };
  BonusGroupInvoiceBase.prototype.component1 = function () {
    return this.id_1;
  };
  BonusGroupInvoiceBase.prototype.component2 = function () {
    return this.name_1;
  };
  BonusGroupInvoiceBase.prototype.component3 = function () {
    return this.file_1;
  };
  BonusGroupInvoiceBase.prototype.component4 = function () {
    return this.amount_1;
  };
  BonusGroupInvoiceBase.prototype.component5 = function () {
    return this.type_1;
  };
  BonusGroupInvoiceBase.prototype.component6 = function () {
    return this.targetId_1;
  };
  BonusGroupInvoiceBase.prototype.component7 = function () {
    return this.details_1;
  };
  BonusGroupInvoiceBase.prototype.component8 = function () {
    return this.creationDate_1;
  };
  BonusGroupInvoiceBase.prototype.copy = function (id, name, file, amount, type, targetId, details, creationDate) {
    return this.copy_7pnae0_k$(id === void 1 ? this.id_1 : id, name === void 1 ? this.name_1 : name, file === void 1 ? this.file_1 : file, amount === void 1 ? this.amount_1 : amount, type === void 1 ? this.type_1 : type, targetId === void 1 ? this.targetId_1 : targetId, details === void 1 ? this.details_1 : details, creationDate === void 1 ? this.creationDate_1 : creationDate);
  };
  BonusGroupInvoiceBase.prototype.copy_7pnae0_k$ = function (id, name, file, amount, type, targetId, details, creationDate) {
    return new BonusGroupInvoiceBase(id, name, file, amount, type, targetId, details, creationDate);
  };
  BonusGroupInvoiceBase.prototype.copy$default_ve6ezh_k$ = function (id, name, file, amount, type, targetId, details, creationDate, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      id = this.id_1;
    if (!(($mask0 & 2) === 0))
      name = this.name_1;
    if (!(($mask0 & 4) === 0))
      file = this.file_1;
    if (!(($mask0 & 8) === 0))
      amount = this.amount_1;
    if (!(($mask0 & 16) === 0))
      type = this.type_1;
    if (!(($mask0 & 32) === 0))
      targetId = this.targetId_1;
    if (!(($mask0 & 64) === 0))
      details = this.details_1;
    if (!(($mask0 & 128) === 0))
      creationDate = this.creationDate_1;
    return this.copy_7pnae0_k$(id, name, file, amount, type, targetId, details, creationDate);
  };
  BonusGroupInvoiceBase.prototype.toString = function () {
    return 'BonusGroupInvoiceBase(id=' + this.id_1 + ', name=' + this.name_1 + ', file=' + this.file_1 + ', amount=' + this.amount_1 + ', type=' + this.type_1 + ', targetId=' + this.targetId_1 + ', details=' + this.details_1 + ', creationDate=' + toString_1(this.creationDate_1) + ')';
  };
  BonusGroupInvoiceBase.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.file_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.amount_1) | 0;
    result = imul(result, 31) + hashCode(this.type_1) | 0;
    result = imul(result, 31) + (this.targetId_1 == null ? 0 : getStringHashCode(this.targetId_1)) | 0;
    result = imul(result, 31) + (this.details_1 == null ? 0 : this.details_1.hashCode()) | 0;
    result = imul(result, 31) + this.creationDate_1.hashCode() | 0;
    return result;
  };
  BonusGroupInvoiceBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusGroupInvoiceBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusGroupInvoiceBase ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.file_1 === tmp0_other_with_cast.file_1))
      return false;
    if (!equals(this.amount_1, tmp0_other_with_cast.amount_1))
      return false;
    if (!equals(this.type_1, tmp0_other_with_cast.type_1))
      return false;
    if (!(this.targetId_1 == tmp0_other_with_cast.targetId_1))
      return false;
    if (!equals(this.details_1, tmp0_other_with_cast.details_1))
      return false;
    if (!this.creationDate_1.equals(tmp0_other_with_cast.creationDate_1))
      return false;
    return true;
  };
  BonusGroupInvoiceBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceBase',
    kind: 'class',
    interfaces: [BonusGroupInvoice]
  };
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'file', {
    configurable: true,
    get: function () {
      return this._get_file__797018191_d6iv67_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'targetId', {
    configurable: true,
    get: function () {
      return this._get_targetId__666236607_b0nrgf_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceBase.prototype, 'creationDate', {
    configurable: true,
    get: function () {
      return this._get_creationDate__1646693310_r8ecou_k$();
    }
  });
  function _get_BONUS_GROUP_INVOICE_TYPE_PREVIOUS__3060908039() {
    init_properties_BonusGroupInvoiceType_kt_1029449165();
    return BONUS_GROUP_INVOICE_TYPE_PREVIOUS;
  }
  var BONUS_GROUP_INVOICE_TYPE_PREVIOUS;
  function _get_BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS__4035259641() {
    init_properties_BonusGroupInvoiceType_kt_1029449165();
    return BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS;
  }
  var BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS;
  function _get_BONUS_GROUP_INVOICE_TYPE_CARRIER__1377822854() {
    init_properties_BonusGroupInvoiceType_kt_1029449165();
    return BONUS_GROUP_INVOICE_TYPE_CARRIER;
  }
  var BONUS_GROUP_INVOICE_TYPE_CARRIER;
  function _get_BONUS_GROUP_INVOICE_TYPE_FUNDER__2721236012() {
    init_properties_BonusGroupInvoiceType_kt_1029449165();
    return BONUS_GROUP_INVOICE_TYPE_FUNDER;
  }
  var BONUS_GROUP_INVOICE_TYPE_FUNDER;
  function BonusGroupInvoiceType() {
  }
  BonusGroupInvoiceType.$metadata$ = {
    simpleName: 'BonusGroupInvoiceType',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupInvoiceTypeBase(value) {
    this.value_1 = value;
  }
  BonusGroupInvoiceTypeBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  BonusGroupInvoiceTypeBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceTypeBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceType]
  };
  Object.defineProperty(BonusGroupInvoiceTypeBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function BonusGroupInvoiceTypeValues() {
    this.PREVIOUS_1 = _get_BONUS_GROUP_INVOICE_TYPE_PREVIOUS__3060908039();
    this.CUSTOM_PREVIOUS_1 = _get_BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS__4035259641();
    this.CARRIER_1 = _get_BONUS_GROUP_INVOICE_TYPE_CARRIER__1377822854();
    this.FUNDER_1 = _get_BONUS_GROUP_INVOICE_TYPE_FUNDER__2721236012();
  }
  BonusGroupInvoiceTypeValues.prototype._get_PREVIOUS__3436098484_e7cjf0_k$ = function () {
    return this.PREVIOUS_1;
  };
  BonusGroupInvoiceTypeValues.prototype._get_CUSTOM_PREVIOUS__728509612_c1qhm4_k$ = function () {
    return this.CUSTOM_PREVIOUS_1;
  };
  BonusGroupInvoiceTypeValues.prototype._get_CARRIER__2913946425_mu82iv_k$ = function () {
    return this.CARRIER_1;
  };
  BonusGroupInvoiceTypeValues.prototype._get_FUNDER__2493693721_tsfjl3_k$ = function () {
    return this.FUNDER_1;
  };
  BonusGroupInvoiceTypeValues.$metadata$ = {
    simpleName: 'BonusGroupInvoiceTypeValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusGroupInvoiceTypeValues.prototype, 'PREVIOUS', {
    configurable: true,
    get: BonusGroupInvoiceTypeValues.prototype._get_PREVIOUS__3436098484_e7cjf0_k$
  });
  Object.defineProperty(BonusGroupInvoiceTypeValues.prototype, 'CUSTOM_PREVIOUS', {
    configurable: true,
    get: BonusGroupInvoiceTypeValues.prototype._get_CUSTOM_PREVIOUS__728509612_c1qhm4_k$
  });
  Object.defineProperty(BonusGroupInvoiceTypeValues.prototype, 'CARRIER', {
    configurable: true,
    get: BonusGroupInvoiceTypeValues.prototype._get_CARRIER__2913946425_mu82iv_k$
  });
  Object.defineProperty(BonusGroupInvoiceTypeValues.prototype, 'FUNDER', {
    configurable: true,
    get: BonusGroupInvoiceTypeValues.prototype._get_FUNDER__2493693721_tsfjl3_k$
  });
  var properties_initialized_BonusGroupInvoiceType_kt_4276519209;
  function init_properties_BonusGroupInvoiceType_kt_1029449165() {
    if (!properties_initialized_BonusGroupInvoiceType_kt_4276519209) {
      properties_initialized_BonusGroupInvoiceType_kt_4276519209 = true;
      BONUS_GROUP_INVOICE_TYPE_PREVIOUS = new BonusGroupInvoiceTypeBase('PREVIOUS');
      BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS = new BonusGroupInvoiceTypeBase('CUSTOM_PREVIOUS');
      BONUS_GROUP_INVOICE_TYPE_CARRIER = new BonusGroupInvoiceTypeBase('CARRIER');
      BONUS_GROUP_INVOICE_TYPE_FUNDER = new BonusGroupInvoiceTypeBase('FUNDER');
    }
  }
  var BonusGroupLogType_IMPORT_DELIVERIES_instance;
  var BonusGroupLogType_CREATE_CARRIER_REPORT_instance;
  var BonusGroupLogType_EDIT_CARRIER_REPORT_instance;
  var BonusGroupLogType_UPLOAD_INVOICE_instance;
  var BonusGroupLogType_EDIT_INVOICE_instance;
  var BonusGroupLogType_EDIT_STATUS_instance;
  function values_3() {
    return [BonusGroupLogType_IMPORT_DELIVERIES_getInstance(), BonusGroupLogType_CREATE_CARRIER_REPORT_getInstance(), BonusGroupLogType_EDIT_CARRIER_REPORT_getInstance(), BonusGroupLogType_UPLOAD_INVOICE_getInstance(), BonusGroupLogType_EDIT_INVOICE_getInstance(), BonusGroupLogType_EDIT_STATUS_getInstance()];
  }
  function valueOf_3(value) {
    switch (value) {
      case 'IMPORT_DELIVERIES':
        return BonusGroupLogType_IMPORT_DELIVERIES_getInstance();
      case 'CREATE_CARRIER_REPORT':
        return BonusGroupLogType_CREATE_CARRIER_REPORT_getInstance();
      case 'EDIT_CARRIER_REPORT':
        return BonusGroupLogType_EDIT_CARRIER_REPORT_getInstance();
      case 'UPLOAD_INVOICE':
        return BonusGroupLogType_UPLOAD_INVOICE_getInstance();
      case 'EDIT_INVOICE':
        return BonusGroupLogType_EDIT_INVOICE_getInstance();
      case 'EDIT_STATUS':
        return BonusGroupLogType_EDIT_STATUS_getInstance();
      default:
        BonusGroupLogType_initEntries();
        THROW_ISE();
        break;
    }
  }
  var BonusGroupLogType_entriesInitialized;
  function BonusGroupLogType_initEntries() {
    if (BonusGroupLogType_entriesInitialized)
      return Unit_getInstance();
    BonusGroupLogType_entriesInitialized = true;
    BonusGroupLogType_IMPORT_DELIVERIES_instance = new BonusGroupLogType('IMPORT_DELIVERIES', 0);
    BonusGroupLogType_CREATE_CARRIER_REPORT_instance = new BonusGroupLogType('CREATE_CARRIER_REPORT', 1);
    BonusGroupLogType_EDIT_CARRIER_REPORT_instance = new BonusGroupLogType('EDIT_CARRIER_REPORT', 2);
    BonusGroupLogType_UPLOAD_INVOICE_instance = new BonusGroupLogType('UPLOAD_INVOICE', 3);
    BonusGroupLogType_EDIT_INVOICE_instance = new BonusGroupLogType('EDIT_INVOICE', 4);
    BonusGroupLogType_EDIT_STATUS_instance = new BonusGroupLogType('EDIT_STATUS', 5);
  }
  function BonusGroupLogType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BonusGroupLogType.$metadata$ = {
    simpleName: 'BonusGroupLogType',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusGroupLogType.prototype, 'name', {
    configurable: true,
    get: BonusGroupLogType.prototype._get_name__804168992_das4rk_k$
  });
  Object.defineProperty(BonusGroupLogType.prototype, 'ordinal', {
    configurable: true,
    get: BonusGroupLogType.prototype._get_ordinal__3363892928_fec5kw_k$
  });
  function BonusGroupLog() {
  }
  BonusGroupLog.$metadata$ = {
    simpleName: 'BonusGroupLog',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupLogBase(id, date, type, status, userId, organizationId, comment) {
    this.id_1 = id;
    this.date_1 = date;
    this.type_1 = type;
    this.status_1 = status;
    this.userId_1 = userId;
    this.organizationId_1 = organizationId;
    this.comment_1 = comment;
  }
  BonusGroupLogBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupLogBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  BonusGroupLogBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  BonusGroupLogBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusGroupLogBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  BonusGroupLogBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  BonusGroupLogBase.prototype._set_comment__3072588038_ruh8gc_k$ = function (_set____804775014) {
    this.comment_1 = _set____804775014;
  };
  BonusGroupLogBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  BonusGroupLogBase.$metadata$ = {
    simpleName: 'BonusGroupLogBase',
    kind: 'class',
    interfaces: [BonusGroupLog]
  };
  Object.defineProperty(BonusGroupLogBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupLogBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(BonusGroupLogBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(BonusGroupLogBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(BonusGroupLogBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  Object.defineProperty(BonusGroupLogBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  Object.defineProperty(BonusGroupLogBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    },
    set: function (value) {
      this._set_comment__3072588038_ruh8gc_k$(value);
    }
  });
  function BonusGroupLogDetail() {
  }
  BonusGroupLogDetail.$metadata$ = {
    simpleName: 'BonusGroupLogDetail',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupLogDetailBase(id, date, type, status, userEmail, organizationName, comment) {
    this.id_1 = id;
    this.date_1 = date;
    this.type_1 = type;
    this.status_1 = status;
    this.userEmail_1 = userEmail;
    this.organizationName_1 = organizationName;
    this.comment_1 = comment;
  }
  BonusGroupLogDetailBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupLogDetailBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  BonusGroupLogDetailBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  BonusGroupLogDetailBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusGroupLogDetailBase.prototype._get_userEmail__4171541984_21hfkw_k$ = function () {
    return this.userEmail_1;
  };
  BonusGroupLogDetailBase.prototype._get_organizationName__2262590509_xm0vyr_k$ = function () {
    return this.organizationName_1;
  };
  BonusGroupLogDetailBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  BonusGroupLogDetailBase.$metadata$ = {
    simpleName: 'BonusGroupLogDetailBase',
    kind: 'class',
    interfaces: [BonusGroupLogDetail]
  };
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'userEmail', {
    configurable: true,
    get: function () {
      return this._get_userEmail__4171541984_21hfkw_k$();
    }
  });
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'organizationName', {
    configurable: true,
    get: function () {
      return this._get_organizationName__2262590509_xm0vyr_k$();
    }
  });
  Object.defineProperty(BonusGroupLogDetailBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  function BonusGroupLogType_IMPORT_DELIVERIES_getInstance() {
    BonusGroupLogType_initEntries();
    return BonusGroupLogType_IMPORT_DELIVERIES_instance;
  }
  function BonusGroupLogType_CREATE_CARRIER_REPORT_getInstance() {
    BonusGroupLogType_initEntries();
    return BonusGroupLogType_CREATE_CARRIER_REPORT_instance;
  }
  function BonusGroupLogType_EDIT_CARRIER_REPORT_getInstance() {
    BonusGroupLogType_initEntries();
    return BonusGroupLogType_EDIT_CARRIER_REPORT_instance;
  }
  function BonusGroupLogType_UPLOAD_INVOICE_getInstance() {
    BonusGroupLogType_initEntries();
    return BonusGroupLogType_UPLOAD_INVOICE_instance;
  }
  function BonusGroupLogType_EDIT_INVOICE_getInstance() {
    BonusGroupLogType_initEntries();
    return BonusGroupLogType_EDIT_INVOICE_instance;
  }
  function BonusGroupLogType_EDIT_STATUS_getInstance() {
    BonusGroupLogType_initEntries();
    return BonusGroupLogType_EDIT_STATUS_instance;
  }
  function BonusGroupPoiDashboard() {
  }
  BonusGroupPoiDashboard.$metadata$ = {
    simpleName: 'BonusGroupPoiDashboard',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupPoiDashboardBase(id, carrierId, operatorId, period, territory, bonuses, amount, status) {
    this.id_1 = id;
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
    this.period_1 = period;
    this.territory_1 = territory;
    this.bonuses_1 = bonuses;
    this.amount_1 = amount;
    this.status_1 = status;
  }
  BonusGroupPoiDashboardBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_territory__1826884983_u7ohh3_k$ = function () {
    return this.territory_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_bonuses__4112178084_30tt24_k$ = function () {
    return this.bonuses_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  BonusGroupPoiDashboardBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusGroupPoiDashboardBase.$metadata$ = {
    simpleName: 'BonusGroupPoiDashboardBase',
    kind: 'class',
    interfaces: [BonusGroupPoiDashboard]
  };
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'territory', {
    configurable: true,
    get: function () {
      return this._get_territory__1826884983_u7ohh3_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'bonuses', {
    configurable: true,
    get: function () {
      return this._get_bonuses__4112178084_30tt24_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  Object.defineProperty(BonusGroupPoiDashboardBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  function FunderRepartition() {
  }
  FunderRepartition.$metadata$ = {
    simpleName: 'FunderRepartition',
    kind: 'interface',
    interfaces: []
  };
  function FunderRepartitionBase(ceeAmount, collectivityAmount) {
    this.ceeAmount_1 = ceeAmount;
    this.collectivityAmount_1 = collectivityAmount;
  }
  FunderRepartitionBase.prototype._get_ceeAmount__3557983030_c6s4p6_k$ = function () {
    return this.ceeAmount_1;
  };
  FunderRepartitionBase.prototype._get_collectivityAmount__2978158780_lrzryc_k$ = function () {
    return this.collectivityAmount_1;
  };
  FunderRepartitionBase.$metadata$ = {
    simpleName: 'FunderRepartitionBase',
    kind: 'class',
    interfaces: [FunderRepartition]
  };
  Object.defineProperty(FunderRepartitionBase.prototype, 'ceeAmount', {
    configurable: true,
    get: function () {
      return this._get_ceeAmount__3557983030_c6s4p6_k$();
    }
  });
  Object.defineProperty(FunderRepartitionBase.prototype, 'collectivityAmount', {
    configurable: true,
    get: function () {
      return this._get_collectivityAmount__2978158780_lrzryc_k$();
    }
  });
  function _get_ADD_BONUS_TO_GROUP__3567084370() {
    return ADD_BONUS_TO_GROUP;
  }
  var ADD_BONUS_TO_GROUP;
  function _get_BONUS_ADDED_TO_GROUP__426184497() {
    return BONUS_ADDED_TO_GROUP;
  }
  var BONUS_ADDED_TO_GROUP;
  function AddBonusToGroupCommand() {
  }
  AddBonusToGroupCommand.$metadata$ = {
    simpleName: 'AddBonusToGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddBonusToGroupCommandDTO() {
  }
  AddBonusToGroupCommandDTO.$metadata$ = {
    simpleName: 'AddBonusToGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddBonusToGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddBonusToGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddBonusToGroupCommandBase.$metadata$ = {
    simpleName: 'AddBonusToGroupCommandBase',
    kind: 'class',
    interfaces: [AddBonusToGroupCommand]
  };
  Object.defineProperty(AddBonusToGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddBonusToGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddBonusToGroupCommandDTOBase(bonusId, operatorId, carrierId, period, territoryCode) {
    this.bonusId_1 = bonusId;
    this.operatorId_1 = operatorId;
    this.carrierId_1 = carrierId;
    this.period_1 = period;
    this.territoryCode_1 = territoryCode;
  }
  AddBonusToGroupCommandDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  AddBonusToGroupCommandDTOBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  AddBonusToGroupCommandDTOBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  AddBonusToGroupCommandDTOBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  AddBonusToGroupCommandDTOBase.prototype._get_territoryCode__421324938_6yugei_k$ = function () {
    return this.territoryCode_1;
  };
  AddBonusToGroupCommandDTOBase.$metadata$ = {
    simpleName: 'AddBonusToGroupCommandDTOBase',
    kind: 'class',
    interfaces: [AddBonusToGroupCommandDTO]
  };
  Object.defineProperty(AddBonusToGroupCommandDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(AddBonusToGroupCommandDTOBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(AddBonusToGroupCommandDTOBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(AddBonusToGroupCommandDTOBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(AddBonusToGroupCommandDTOBase.prototype, 'territoryCode', {
    configurable: true,
    get: function () {
      return this._get_territoryCode__421324938_6yugei_k$();
    }
  });
  function BonusAddedToGroupEvent() {
  }
  BonusAddedToGroupEvent.$metadata$ = {
    simpleName: 'BonusAddedToGroupEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusAddedToGroupEventDTO() {
  }
  BonusAddedToGroupEventDTO.$metadata$ = {
    simpleName: 'BonusAddedToGroupEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusAddedToGroupEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusAddedToGroupEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusAddedToGroupEventBase.$metadata$ = {
    simpleName: 'BonusAddedToGroupEventBase',
    kind: 'class',
    interfaces: [BonusAddedToGroupEvent]
  };
  Object.defineProperty(BonusAddedToGroupEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusAddedToGroupEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusAddedToGroupEventDTOBase(bonusId, groupId) {
    this.bonusId_1 = bonusId;
    this.groupId_1 = groupId;
  }
  BonusAddedToGroupEventDTOBase.prototype._get_bonusId__4112150711_30ue6h_k$ = function () {
    return this.bonusId_1;
  };
  BonusAddedToGroupEventDTOBase.prototype._get_groupId__2632351319_rhvmp5_k$ = function () {
    return this.groupId_1;
  };
  BonusAddedToGroupEventDTOBase.$metadata$ = {
    simpleName: 'BonusAddedToGroupEventDTOBase',
    kind: 'class',
    interfaces: [BonusAddedToGroupEventDTO]
  };
  Object.defineProperty(BonusAddedToGroupEventDTOBase.prototype, 'bonusId', {
    configurable: true,
    get: function () {
      return this._get_bonusId__4112150711_30ue6h_k$();
    }
  });
  Object.defineProperty(BonusAddedToGroupEventDTOBase.prototype, 'groupId', {
    configurable: true,
    get: function () {
      return this._get_groupId__2632351319_rhvmp5_k$();
    }
  });
  function _get_BONUS_GROUP_COMMENT_EDITED__91258722() {
    return BONUS_GROUP_COMMENT_EDITED;
  }
  var BONUS_GROUP_COMMENT_EDITED;
  function BonusGroupCommentEditedEvent() {
  }
  BonusGroupCommentEditedEvent.$metadata$ = {
    simpleName: 'BonusGroupCommentEditedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupCommentEditedEventDTO() {
  }
  BonusGroupCommentEditedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupCommentEditedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupCommentEditedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupCommentEditedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupCommentEditedEventBase.$metadata$ = {
    simpleName: 'BonusGroupCommentEditedEventBase',
    kind: 'class',
    interfaces: [BonusGroupCommentEditedEvent]
  };
  Object.defineProperty(BonusGroupCommentEditedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupCommentEditedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupCommentEditedEventDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  BonusGroupCommentEditedEventDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupCommentEditedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupCommentEditedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupCommentEditedEventDTO]
  };
  Object.defineProperty(BonusGroupCommentEditedEventDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_BONUS_GROUP_CREATED__4187642601() {
    return BONUS_GROUP_CREATED;
  }
  var BONUS_GROUP_CREATED;
  function BonusGroupCreatedEvent() {
  }
  BonusGroupCreatedEvent.$metadata$ = {
    simpleName: 'BonusGroupCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupCreatedEventDTO() {
  }
  BonusGroupCreatedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupCreatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupCreatedEventBase.$metadata$ = {
    simpleName: 'BonusGroupCreatedEventBase',
    kind: 'class',
    interfaces: [BonusGroupCreatedEvent]
  };
  Object.defineProperty(BonusGroupCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupCreatedEventDTOBase(id) {
    this.id_1 = id;
  }
  BonusGroupCreatedEventDTOBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusGroupCreatedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupCreatedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupCreatedEventDTO]
  };
  Object.defineProperty(BonusGroupCreatedEventDTOBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function _get_BONUS_GROUP_DELETED__3186937816() {
    return BONUS_GROUP_DELETED;
  }
  var BONUS_GROUP_DELETED;
  function BonusGroupDeletedEvent() {
  }
  BonusGroupDeletedEvent.$metadata$ = {
    simpleName: 'BonusGroupDeletedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupDeletedEventDTO() {
  }
  BonusGroupDeletedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupDeletedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupDeletedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupDeletedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupDeletedEventBase.$metadata$ = {
    simpleName: 'BonusGroupDeletedEventBase',
    kind: 'class',
    interfaces: [BonusGroupDeletedEvent]
  };
  Object.defineProperty(BonusGroupDeletedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupDeletedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupDeletedEventDTOBase(bonusGroupId, by) {
    this.bonusGroupId_1 = bonusGroupId;
    this.by_1 = by;
  }
  BonusGroupDeletedEventDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupDeletedEventDTOBase.prototype._get_by__1413114900_ndbyfo_k$ = function () {
    return this.by_1;
  };
  BonusGroupDeletedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupDeletedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupDeletedEventDTO]
  };
  Object.defineProperty(BonusGroupDeletedEventDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupDeletedEventDTOBase.prototype, 'by', {
    configurable: true,
    get: function () {
      return this._get_by__1413114900_ndbyfo_k$();
    }
  });
  function _get_BONUS_GROUP_INVOICE_DELETED__2684202442() {
    return BONUS_GROUP_INVOICE_DELETED;
  }
  var BONUS_GROUP_INVOICE_DELETED;
  function BonusGroupInvoiceDeletedEvent() {
  }
  BonusGroupInvoiceDeletedEvent.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDeletedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupInvoiceDeletedEventDetails() {
  }
  BonusGroupInvoiceDeletedEventDetails.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDeletedEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupInvoiceDeletedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupInvoiceDeletedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupInvoiceDeletedEventBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDeletedEventBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceDeletedEvent]
  };
  Object.defineProperty(BonusGroupInvoiceDeletedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceDeletedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupInvoiceDeletedEventDetailsBase(bonusGroupId, invoiceId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.invoiceId_1 = invoiceId;
  }
  BonusGroupInvoiceDeletedEventDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupInvoiceDeletedEventDetailsBase.prototype._get_invoiceId__604070441_9znbqh_k$ = function () {
    return this.invoiceId_1;
  };
  BonusGroupInvoiceDeletedEventDetailsBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDeletedEventDetailsBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceDeletedEventDetails]
  };
  Object.defineProperty(BonusGroupInvoiceDeletedEventDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceDeletedEventDetailsBase.prototype, 'invoiceId', {
    configurable: true,
    get: function () {
      return this._get_invoiceId__604070441_9znbqh_k$();
    }
  });
  function _get_BONUS_GROUP_LOG_COMMENT_EDITED__2199147975() {
    return BONUS_GROUP_LOG_COMMENT_EDITED;
  }
  var BONUS_GROUP_LOG_COMMENT_EDITED;
  function BonusGroupLogCommentEditedEvent() {
  }
  BonusGroupLogCommentEditedEvent.$metadata$ = {
    simpleName: 'BonusGroupLogCommentEditedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupLogCommentEditedEventDTO() {
  }
  BonusGroupLogCommentEditedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupLogCommentEditedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupLogCommentEditedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupLogCommentEditedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupLogCommentEditedEventBase.$metadata$ = {
    simpleName: 'BonusGroupLogCommentEditedEventBase',
    kind: 'class',
    interfaces: [BonusGroupLogCommentEditedEvent]
  };
  Object.defineProperty(BonusGroupLogCommentEditedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupLogCommentEditedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupLogCommentEditedEventDTOBase(bonusGroupId, bonusGroupLogId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.bonusGroupLogId_1 = bonusGroupLogId;
  }
  BonusGroupLogCommentEditedEventDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupLogCommentEditedEventDTOBase.prototype._get_bonusGroupLogId__3800674866_86aeha_k$ = function () {
    return this.bonusGroupLogId_1;
  };
  BonusGroupLogCommentEditedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupLogCommentEditedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupLogCommentEditedEventDTO]
  };
  Object.defineProperty(BonusGroupLogCommentEditedEventDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupLogCommentEditedEventDTOBase.prototype, 'bonusGroupLogId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupLogId__3800674866_86aeha_k$();
    }
  });
  function _get_BONUS_GROUP_STATUS_UPDATED__3179708637() {
    return BONUS_GROUP_STATUS_UPDATED;
  }
  var BONUS_GROUP_STATUS_UPDATED;
  function BonusGroupStatusUpdatedEvent() {
  }
  BonusGroupStatusUpdatedEvent.$metadata$ = {
    simpleName: 'BonusGroupStatusUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupStatusUpdatedEventDTO() {
  }
  BonusGroupStatusUpdatedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupStatusUpdatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupStatusUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupStatusUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupStatusUpdatedEventBase.$metadata$ = {
    simpleName: 'BonusGroupStatusUpdatedEventBase',
    kind: 'class',
    interfaces: [BonusGroupStatusUpdatedEvent]
  };
  Object.defineProperty(BonusGroupStatusUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupStatusUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupStatusUpdatedEventDTOBase(bonusGroupId, status, by) {
    this.bonusGroupId_1 = bonusGroupId;
    this.status_1 = status;
    this.by_1 = by;
  }
  BonusGroupStatusUpdatedEventDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupStatusUpdatedEventDTOBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusGroupStatusUpdatedEventDTOBase.prototype._get_by__1413114900_ndbyfo_k$ = function () {
    return this.by_1;
  };
  BonusGroupStatusUpdatedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupStatusUpdatedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupStatusUpdatedEventDTO]
  };
  Object.defineProperty(BonusGroupStatusUpdatedEventDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupStatusUpdatedEventDTOBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(BonusGroupStatusUpdatedEventDTOBase.prototype, 'by', {
    configurable: true,
    get: function () {
      return this._get_by__1413114900_ndbyfo_k$();
    }
  });
  function _get_CREATE_BONUS_GROUP_INCIDENT__2431072220() {
    return CREATE_BONUS_GROUP_INCIDENT;
  }
  var CREATE_BONUS_GROUP_INCIDENT;
  function _get_BONUS_GROUP_INCIDENT_CREATED__2630409264() {
    return BONUS_GROUP_INCIDENT_CREATED;
  }
  var BONUS_GROUP_INCIDENT_CREATED;
  function CreateBonusGroupIncidentCommand() {
  }
  CreateBonusGroupIncidentCommand.$metadata$ = {
    simpleName: 'CreateBonusGroupIncidentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateBonusGroupIncidentCommandDTO() {
  }
  CreateBonusGroupIncidentCommandDTO.$metadata$ = {
    simpleName: 'CreateBonusGroupIncidentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateBonusGroupIncidentCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateBonusGroupIncidentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateBonusGroupIncidentCommandBase.$metadata$ = {
    simpleName: 'CreateBonusGroupIncidentCommandBase',
    kind: 'class',
    interfaces: [CreateBonusGroupIncidentCommand]
  };
  Object.defineProperty(CreateBonusGroupIncidentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupIncidentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateBonusGroupIncidentCommandDTOBase(bonusGroupId, type, description, properties) {
    this.bonusGroupId_1 = bonusGroupId;
    this.type_1 = type;
    this.description_1 = description;
    this.properties_1 = properties;
  }
  CreateBonusGroupIncidentCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  CreateBonusGroupIncidentCommandDTOBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  CreateBonusGroupIncidentCommandDTOBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  CreateBonusGroupIncidentCommandDTOBase.prototype._get_properties__3765791160_8r22x4_k$ = function () {
    return this.properties_1;
  };
  CreateBonusGroupIncidentCommandDTOBase.$metadata$ = {
    simpleName: 'CreateBonusGroupIncidentCommandDTOBase',
    kind: 'class',
    interfaces: [CreateBonusGroupIncidentCommandDTO]
  };
  Object.defineProperty(CreateBonusGroupIncidentCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupIncidentCommandDTOBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupIncidentCommandDTOBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupIncidentCommandDTOBase.prototype, 'properties', {
    configurable: true,
    get: function () {
      return this._get_properties__3765791160_8r22x4_k$();
    }
  });
  function BonusGroupIncidentCreatedEvent() {
  }
  BonusGroupIncidentCreatedEvent.$metadata$ = {
    simpleName: 'BonusGroupIncidentCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupIncidentCreatedEventDTO() {
  }
  BonusGroupIncidentCreatedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupIncidentCreatedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupIncidentCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupIncidentCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupIncidentCreatedEventBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentCreatedEventBase',
    kind: 'class',
    interfaces: [BonusGroupIncidentCreatedEvent]
  };
  Object.defineProperty(BonusGroupIncidentCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupIncidentCreatedEventDTOBase(bonusGroupId, incidentId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.incidentId_1 = incidentId;
  }
  BonusGroupIncidentCreatedEventDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupIncidentCreatedEventDTOBase.prototype._get_incidentId__3880525982_6uqwyq_k$ = function () {
    return this.incidentId_1;
  };
  BonusGroupIncidentCreatedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentCreatedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupIncidentCreatedEventDTO]
  };
  Object.defineProperty(BonusGroupIncidentCreatedEventDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentCreatedEventDTOBase.prototype, 'incidentId', {
    configurable: true,
    get: function () {
      return this._get_incidentId__3880525982_6uqwyq_k$();
    }
  });
  function _get_CREATE_BONUS_GROUP_INVOICE__73874081() {
    return CREATE_BONUS_GROUP_INVOICE;
  }
  var CREATE_BONUS_GROUP_INVOICE;
  function _get_BONUS_GROUP_INVOICE_CREATED__3684907227() {
    return BONUS_GROUP_INVOICE_CREATED;
  }
  var BONUS_GROUP_INVOICE_CREATED;
  function CreateBonusGroupInvoiceCommand() {
  }
  CreateBonusGroupInvoiceCommand.$metadata$ = {
    simpleName: 'CreateBonusGroupInvoiceCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateBonusGroupInvoiceCommandDetails() {
  }
  CreateBonusGroupInvoiceCommandDetails.$metadata$ = {
    simpleName: 'CreateBonusGroupInvoiceCommandDetails',
    kind: 'interface',
    interfaces: []
  };
  function CreateBonusGroupInvoiceCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateBonusGroupInvoiceCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateBonusGroupInvoiceCommandBase.$metadata$ = {
    simpleName: 'CreateBonusGroupInvoiceCommandBase',
    kind: 'class',
    interfaces: [CreateBonusGroupInvoiceCommand]
  };
  Object.defineProperty(CreateBonusGroupInvoiceCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateBonusGroupInvoiceCommandDetailsBase(bonusGroupId, name, file, amount, type, creatorId, targetId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.name_1 = name;
    this.file_1 = file;
    this.amount_1 = amount;
    this.type_1 = type;
    this.creatorId_1 = creatorId;
    this.targetId_1 = targetId;
  }
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_file__797018191_d6iv67_k$ = function () {
    return this.file_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_creatorId__71536842_16la6i_k$ = function () {
    return this.creatorId_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.prototype._get_targetId__666236607_b0nrgf_k$ = function () {
    return this.targetId_1;
  };
  CreateBonusGroupInvoiceCommandDetailsBase.$metadata$ = {
    simpleName: 'CreateBonusGroupInvoiceCommandDetailsBase',
    kind: 'class',
    interfaces: [CreateBonusGroupInvoiceCommandDetails]
  };
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'file', {
    configurable: true,
    get: function () {
      return this._get_file__797018191_d6iv67_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'creatorId', {
    configurable: true,
    get: function () {
      return this._get_creatorId__71536842_16la6i_k$();
    }
  });
  Object.defineProperty(CreateBonusGroupInvoiceCommandDetailsBase.prototype, 'targetId', {
    configurable: true,
    get: function () {
      return this._get_targetId__666236607_b0nrgf_k$();
    }
  });
  function BonusGroupInvoiceCreatedEvent() {
  }
  BonusGroupInvoiceCreatedEvent.$metadata$ = {
    simpleName: 'BonusGroupInvoiceCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupInvoiceCreatedEventDetails() {
  }
  BonusGroupInvoiceCreatedEventDetails.$metadata$ = {
    simpleName: 'BonusGroupInvoiceCreatedEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupInvoiceCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupInvoiceCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupInvoiceCreatedEventBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceCreatedEventBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceCreatedEvent]
  };
  Object.defineProperty(BonusGroupInvoiceCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupInvoiceCreatedEventDetailsBase(invoiceId, bonusGroupId, creatorId, by) {
    this.invoiceId_1 = invoiceId;
    this.bonusGroupId_1 = bonusGroupId;
    this.creatorId_1 = creatorId;
    this.by_1 = by;
  }
  BonusGroupInvoiceCreatedEventDetailsBase.prototype._get_invoiceId__604070441_9znbqh_k$ = function () {
    return this.invoiceId_1;
  };
  BonusGroupInvoiceCreatedEventDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupInvoiceCreatedEventDetailsBase.prototype._get_creatorId__71536842_16la6i_k$ = function () {
    return this.creatorId_1;
  };
  BonusGroupInvoiceCreatedEventDetailsBase.prototype._get_by__1413114900_ndbyfo_k$ = function () {
    return this.by_1;
  };
  BonusGroupInvoiceCreatedEventDetailsBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceCreatedEventDetailsBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceCreatedEventDetails]
  };
  Object.defineProperty(BonusGroupInvoiceCreatedEventDetailsBase.prototype, 'invoiceId', {
    configurable: true,
    get: function () {
      return this._get_invoiceId__604070441_9znbqh_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceCreatedEventDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceCreatedEventDetailsBase.prototype, 'creatorId', {
    configurable: true,
    get: function () {
      return this._get_creatorId__71536842_16la6i_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceCreatedEventDetailsBase.prototype, 'by', {
    configurable: true,
    get: function () {
      return this._get_by__1413114900_ndbyfo_k$();
    }
  });
  function _get_DEDUCE_BONUS_GROUP__2777106167() {
    return DEDUCE_BONUS_GROUP;
  }
  var DEDUCE_BONUS_GROUP;
  function DeduceBonusGroupCommand() {
  }
  DeduceBonusGroupCommand.$metadata$ = {
    simpleName: 'DeduceBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DeduceBonusGroupCommandDTO() {
  }
  DeduceBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'DeduceBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeduceBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  DeduceBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeduceBonusGroupCommandBase.$metadata$ = {
    simpleName: 'DeduceBonusGroupCommandBase',
    kind: 'class',
    interfaces: [DeduceBonusGroupCommand]
  };
  Object.defineProperty(DeduceBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeduceBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeduceBonusGroupCommandDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  DeduceBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  DeduceBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'DeduceBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [DeduceBonusGroupCommandDTO]
  };
  Object.defineProperty(DeduceBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_DELETE_BONUS_GROUP__155871072() {
    return DELETE_BONUS_GROUP;
  }
  var DELETE_BONUS_GROUP;
  function DeleteBonusGroupCommand() {
  }
  DeleteBonusGroupCommand.$metadata$ = {
    simpleName: 'DeleteBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DeleteBonusGroupCommandDTO() {
  }
  DeleteBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'DeleteBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeleteBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  DeleteBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeleteBonusGroupCommandBase.$metadata$ = {
    simpleName: 'DeleteBonusGroupCommandBase',
    kind: 'class',
    interfaces: [DeleteBonusGroupCommand]
  };
  Object.defineProperty(DeleteBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeleteBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeleteBonusGroupCommandDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  DeleteBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  DeleteBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'DeleteBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [DeleteBonusGroupCommandDTO]
  };
  Object.defineProperty(DeleteBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_DELETE_BONUS_GROUPS__537036649() {
    return DELETE_BONUS_GROUPS;
  }
  var DELETE_BONUS_GROUPS;
  function DeleteBonusGroupsCommand() {
  }
  DeleteBonusGroupsCommand.$metadata$ = {
    simpleName: 'DeleteBonusGroupsCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function DeleteBonusGroupsCommandDTO() {
  }
  DeleteBonusGroupsCommandDTO.$metadata$ = {
    simpleName: 'DeleteBonusGroupsCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function DeleteBonusGroupsCommandBase(payload) {
    this.payload_1 = payload;
  }
  DeleteBonusGroupsCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  DeleteBonusGroupsCommandBase.$metadata$ = {
    simpleName: 'DeleteBonusGroupsCommandBase',
    kind: 'class',
    interfaces: [DeleteBonusGroupsCommand]
  };
  Object.defineProperty(DeleteBonusGroupsCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(DeleteBonusGroupsCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function DeleteBonusGroupsCommandDTOBase(bonusGroupIds) {
    this.bonusGroupIds_1 = bonusGroupIds;
  }
  DeleteBonusGroupsCommandDTOBase.prototype._get_bonusGroupIds__937932505_fif5cp_k$ = function () {
    return this.bonusGroupIds_1;
  };
  DeleteBonusGroupsCommandDTOBase.$metadata$ = {
    simpleName: 'DeleteBonusGroupsCommandDTOBase',
    kind: 'class',
    interfaces: [DeleteBonusGroupsCommandDTO]
  };
  Object.defineProperty(DeleteBonusGroupsCommandDTOBase.prototype, 'bonusGroupIds', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupIds__937932505_fif5cp_k$();
    }
  });
  function _get_EDIT_BONUS_GROUP_COMMENT__946677921() {
    return EDIT_BONUS_GROUP_COMMENT;
  }
  var EDIT_BONUS_GROUP_COMMENT;
  function EditBonusGroupCommentCommand() {
  }
  EditBonusGroupCommentCommand.$metadata$ = {
    simpleName: 'EditBonusGroupCommentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function EditBonusGroupCommentCommandDTO() {
  }
  EditBonusGroupCommentCommandDTO.$metadata$ = {
    simpleName: 'EditBonusGroupCommentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function EditBonusGroupCommentCommandBase(payload) {
    this.payload_1 = payload;
  }
  EditBonusGroupCommentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  EditBonusGroupCommentCommandBase.$metadata$ = {
    simpleName: 'EditBonusGroupCommentCommandBase',
    kind: 'class',
    interfaces: [EditBonusGroupCommentCommand]
  };
  Object.defineProperty(EditBonusGroupCommentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(EditBonusGroupCommentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function EditBonusGroupCommentCommandDTOBase(bonusGroupId, comment) {
    this.bonusGroupId_1 = bonusGroupId;
    this.comment_1 = comment;
  }
  EditBonusGroupCommentCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  EditBonusGroupCommentCommandDTOBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  EditBonusGroupCommentCommandDTOBase.$metadata$ = {
    simpleName: 'EditBonusGroupCommentCommandDTOBase',
    kind: 'class',
    interfaces: [EditBonusGroupCommentCommandDTO]
  };
  Object.defineProperty(EditBonusGroupCommentCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(EditBonusGroupCommentCommandDTOBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  function _get_EDIT_BONUS_GROUP_LOG_COMMENT__3371289180() {
    return EDIT_BONUS_GROUP_LOG_COMMENT;
  }
  var EDIT_BONUS_GROUP_LOG_COMMENT;
  function EditBonusGroupLogCommentCommand() {
  }
  EditBonusGroupLogCommentCommand.$metadata$ = {
    simpleName: 'EditBonusGroupLogCommentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function EditBonusGroupLogCommentCommandDTO() {
  }
  EditBonusGroupLogCommentCommandDTO.$metadata$ = {
    simpleName: 'EditBonusGroupLogCommentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function EditBonusGroupLogCommentCommandBase(payload) {
    this.payload_1 = payload;
  }
  EditBonusGroupLogCommentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  EditBonusGroupLogCommentCommandBase.$metadata$ = {
    simpleName: 'EditBonusGroupLogCommentCommandBase',
    kind: 'class',
    interfaces: [EditBonusGroupLogCommentCommand]
  };
  Object.defineProperty(EditBonusGroupLogCommentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(EditBonusGroupLogCommentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function EditBonusGroupLogCommentCommandDTOBase(bonusGroupId, bonusGroupLogId, comment) {
    this.bonusGroupId_1 = bonusGroupId;
    this.bonusGroupLogId_1 = bonusGroupLogId;
    this.comment_1 = comment;
  }
  EditBonusGroupLogCommentCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  EditBonusGroupLogCommentCommandDTOBase.prototype._get_bonusGroupLogId__3800674866_86aeha_k$ = function () {
    return this.bonusGroupLogId_1;
  };
  EditBonusGroupLogCommentCommandDTOBase.prototype._get_comment__1523595410_p73xqq_k$ = function () {
    return this.comment_1;
  };
  EditBonusGroupLogCommentCommandDTOBase.$metadata$ = {
    simpleName: 'EditBonusGroupLogCommentCommandDTOBase',
    kind: 'class',
    interfaces: [EditBonusGroupLogCommentCommandDTO]
  };
  Object.defineProperty(EditBonusGroupLogCommentCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(EditBonusGroupLogCommentCommandDTOBase.prototype, 'bonusGroupLogId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupLogId__3800674866_86aeha_k$();
    }
  });
  Object.defineProperty(EditBonusGroupLogCommentCommandDTOBase.prototype, 'comment', {
    configurable: true,
    get: function () {
      return this._get_comment__1523595410_p73xqq_k$();
    }
  });
  function _get_LOG_BONUS_GROUP__3355921165() {
    return LOG_BONUS_GROUP;
  }
  var LOG_BONUS_GROUP;
  function LogBonusGroupCommand() {
  }
  LogBonusGroupCommand.$metadata$ = {
    simpleName: 'LogBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function LogBonusGroupCommandDTO() {
  }
  LogBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'LogBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function LogBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  LogBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  LogBonusGroupCommandBase.$metadata$ = {
    simpleName: 'LogBonusGroupCommandBase',
    kind: 'class',
    interfaces: [LogBonusGroupCommand]
  };
  Object.defineProperty(LogBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(LogBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function LogBonusGroupCommandDTOBase(bonusGroupId, date, type, status, userId, organizationId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.date_1 = date;
    this.type_1 = type;
    this.status_1 = status;
    this.userId_1 = userId;
    this.organizationId_1 = organizationId;
  }
  LogBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  LogBonusGroupCommandDTOBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  LogBonusGroupCommandDTOBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  LogBonusGroupCommandDTOBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  LogBonusGroupCommandDTOBase.prototype._get_userId__2138184069_zd0pdx_k$ = function () {
    return this.userId_1;
  };
  LogBonusGroupCommandDTOBase.prototype._get_organizationId__431399453_74udy5_k$ = function () {
    return this.organizationId_1;
  };
  LogBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'LogBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [LogBonusGroupCommandDTO]
  };
  Object.defineProperty(LogBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(LogBonusGroupCommandDTOBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(LogBonusGroupCommandDTOBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(LogBonusGroupCommandDTOBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  Object.defineProperty(LogBonusGroupCommandDTOBase.prototype, 'userId', {
    configurable: true,
    get: function () {
      return this._get_userId__2138184069_zd0pdx_k$();
    }
  });
  Object.defineProperty(LogBonusGroupCommandDTOBase.prototype, 'organizationId', {
    configurable: true,
    get: function () {
      return this._get_organizationId__431399453_74udy5_k$();
    }
  });
  function _get_PAY_BONUS_GROUP__1172774953() {
    return PAY_BONUS_GROUP;
  }
  var PAY_BONUS_GROUP;
  function PayBonusGroupCommand() {
  }
  PayBonusGroupCommand.$metadata$ = {
    simpleName: 'PayBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function PayBonusGroupCommandDTO() {
  }
  PayBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'PayBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function PayBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  PayBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PayBonusGroupCommandBase.$metadata$ = {
    simpleName: 'PayBonusGroupCommandBase',
    kind: 'class',
    interfaces: [PayBonusGroupCommand]
  };
  Object.defineProperty(PayBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PayBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PayBonusGroupCommandDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  PayBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  PayBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'PayBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [PayBonusGroupCommandDTO]
  };
  Object.defineProperty(PayBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_PUBLISH_BONUS_GROUP__4289112482() {
    return PUBLISH_BONUS_GROUP;
  }
  var PUBLISH_BONUS_GROUP;
  function PublishBonusGroupCommand() {
  }
  PublishBonusGroupCommand.$metadata$ = {
    simpleName: 'PublishBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function PublishBonusGroupCommandDTO() {
  }
  PublishBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'PublishBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function PublishBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  PublishBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PublishBonusGroupCommandBase.$metadata$ = {
    simpleName: 'PublishBonusGroupCommandBase',
    kind: 'class',
    interfaces: [PublishBonusGroupCommand]
  };
  Object.defineProperty(PublishBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PublishBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PublishBonusGroupCommandDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  PublishBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  PublishBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'PublishBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [PublishBonusGroupCommandDTO]
  };
  Object.defineProperty(PublishBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_REJECT_BONUS_GROUP__3954492908() {
    return REJECT_BONUS_GROUP;
  }
  var REJECT_BONUS_GROUP;
  function RejectBonusGroupCommand() {
  }
  RejectBonusGroupCommand.$metadata$ = {
    simpleName: 'RejectBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function RejectBonusGroupCommandDTO() {
  }
  RejectBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'RejectBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function RejectBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  RejectBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  RejectBonusGroupCommandBase.$metadata$ = {
    simpleName: 'RejectBonusGroupCommandBase',
    kind: 'class',
    interfaces: [RejectBonusGroupCommand]
  };
  Object.defineProperty(RejectBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(RejectBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function RejectBonusGroupCommandDTOBase(bonusGroupId, reasons) {
    this.bonusGroupId_1 = bonusGroupId;
    this.reasons_1 = reasons;
  }
  RejectBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  RejectBonusGroupCommandDTOBase.prototype._get_reasons__1273133634_l1zo76_k$ = function () {
    return this.reasons_1;
  };
  RejectBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'RejectBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [RejectBonusGroupCommandDTO]
  };
  Object.defineProperty(RejectBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(RejectBonusGroupCommandDTOBase.prototype, 'reasons', {
    configurable: true,
    get: function () {
      return this._get_reasons__1273133634_l1zo76_k$();
    }
  });
  function _get_REPORT_BONUS_GROUP__3812482679() {
    return REPORT_BONUS_GROUP;
  }
  var REPORT_BONUS_GROUP;
  function ReportBonusGroupCommand() {
  }
  ReportBonusGroupCommand.$metadata$ = {
    simpleName: 'ReportBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ReportBonusGroupCommandDTO() {
  }
  ReportBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'ReportBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function ReportBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  ReportBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ReportBonusGroupCommandBase.$metadata$ = {
    simpleName: 'ReportBonusGroupCommandBase',
    kind: 'class',
    interfaces: [ReportBonusGroupCommand]
  };
  Object.defineProperty(ReportBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ReportBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ReportBonusGroupCommandDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  ReportBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  ReportBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'ReportBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [ReportBonusGroupCommandDTO]
  };
  Object.defineProperty(ReportBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_RESOLVE_BONUS_GROUP_INCIDENT__3439868006() {
    return RESOLVE_BONUS_GROUP_INCIDENT;
  }
  var RESOLVE_BONUS_GROUP_INCIDENT;
  function ResolveBonusGroupIncidentCommand() {
  }
  ResolveBonusGroupIncidentCommand.$metadata$ = {
    simpleName: 'ResolveBonusGroupIncidentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ResolveBonusGroupIncidentCommandBase(payload) {
    this.payload_1 = payload;
  }
  ResolveBonusGroupIncidentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ResolveBonusGroupIncidentCommandBase.$metadata$ = {
    simpleName: 'ResolveBonusGroupIncidentCommandBase',
    kind: 'class',
    interfaces: [ResolveBonusGroupIncidentCommand]
  };
  Object.defineProperty(ResolveBonusGroupIncidentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ResolveBonusGroupIncidentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ResolveBonusGroupIncidentCommandDTO() {
  }
  ResolveBonusGroupIncidentCommandDTO.$metadata$ = {
    simpleName: 'ResolveBonusGroupIncidentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function ResolveBonusGroupIncidentCommandDTOBase(bonusGroupId, incidentId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.incidentId_1 = incidentId;
  }
  ResolveBonusGroupIncidentCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  ResolveBonusGroupIncidentCommandDTOBase.prototype._get_incidentId__3880525982_6uqwyq_k$ = function () {
    return this.incidentId_1;
  };
  ResolveBonusGroupIncidentCommandDTOBase.$metadata$ = {
    simpleName: 'ResolveBonusGroupIncidentCommandDTOBase',
    kind: 'class',
    interfaces: [ResolveBonusGroupIncidentCommandDTO]
  };
  Object.defineProperty(ResolveBonusGroupIncidentCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(ResolveBonusGroupIncidentCommandDTOBase.prototype, 'incidentId', {
    configurable: true,
    get: function () {
      return this._get_incidentId__3880525982_6uqwyq_k$();
    }
  });
  function _get_BONUS_GROUP_INCIDENT_RESOLVED__1643642060() {
    return BONUS_GROUP_INCIDENT_RESOLVED;
  }
  var BONUS_GROUP_INCIDENT_RESOLVED;
  function BonusGroupIncidentResolvedEvent() {
  }
  BonusGroupIncidentResolvedEvent.$metadata$ = {
    simpleName: 'BonusGroupIncidentResolvedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupIncidentResolvedEventDTO() {
  }
  BonusGroupIncidentResolvedEventDTO.$metadata$ = {
    simpleName: 'BonusGroupIncidentResolvedEventDTO',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupIncidentResolvedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupIncidentResolvedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupIncidentResolvedEventBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentResolvedEventBase',
    kind: 'class',
    interfaces: [BonusGroupIncidentResolvedEvent]
  };
  Object.defineProperty(BonusGroupIncidentResolvedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentResolvedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupIncidentResolvedEventDTOBase(bonusGroupId, incidentId) {
    this.bonusGroupId_1 = bonusGroupId;
    this.incidentId_1 = incidentId;
  }
  BonusGroupIncidentResolvedEventDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupIncidentResolvedEventDTOBase.prototype._get_incidentId__3880525982_6uqwyq_k$ = function () {
    return this.incidentId_1;
  };
  BonusGroupIncidentResolvedEventDTOBase.$metadata$ = {
    simpleName: 'BonusGroupIncidentResolvedEventDTOBase',
    kind: 'class',
    interfaces: [BonusGroupIncidentResolvedEventDTO]
  };
  Object.defineProperty(BonusGroupIncidentResolvedEventDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupIncidentResolvedEventDTOBase.prototype, 'incidentId', {
    configurable: true,
    get: function () {
      return this._get_incidentId__3880525982_6uqwyq_k$();
    }
  });
  function _get_UPDATE_BONUS_GROUP_INVOICE__2218226932() {
    return UPDATE_BONUS_GROUP_INVOICE;
  }
  var UPDATE_BONUS_GROUP_INVOICE;
  function _get_BONUS_GROUP_INVOICE_UPDATED__3187085672() {
    return BONUS_GROUP_INVOICE_UPDATED;
  }
  var BONUS_GROUP_INVOICE_UPDATED;
  function UpdateBonusGroupInvoiceCommand() {
  }
  UpdateBonusGroupInvoiceCommand.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateBonusGroupInvoiceCommandDetails() {
  }
  UpdateBonusGroupInvoiceCommandDetails.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceCommandDetails',
    kind: 'interface',
    interfaces: []
  };
  function UpdateBonusGroupInvoiceCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateBonusGroupInvoiceCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateBonusGroupInvoiceCommandBase.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceCommandBase',
    kind: 'class',
    interfaces: [UpdateBonusGroupInvoiceCommand]
  };
  Object.defineProperty(UpdateBonusGroupInvoiceCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateBonusGroupInvoiceCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateBonusGroupInvoiceCommandDetailsBase(invoiceId, bonusGroupId, amount) {
    this.invoiceId_1 = invoiceId;
    this.bonusGroupId_1 = bonusGroupId;
    this.amount_1 = amount;
  }
  UpdateBonusGroupInvoiceCommandDetailsBase.prototype._get_invoiceId__604070441_9znbqh_k$ = function () {
    return this.invoiceId_1;
  };
  UpdateBonusGroupInvoiceCommandDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  UpdateBonusGroupInvoiceCommandDetailsBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  UpdateBonusGroupInvoiceCommandDetailsBase.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceCommandDetailsBase',
    kind: 'class',
    interfaces: [UpdateBonusGroupInvoiceCommandDetails]
  };
  Object.defineProperty(UpdateBonusGroupInvoiceCommandDetailsBase.prototype, 'invoiceId', {
    configurable: true,
    get: function () {
      return this._get_invoiceId__604070441_9znbqh_k$();
    }
  });
  Object.defineProperty(UpdateBonusGroupInvoiceCommandDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(UpdateBonusGroupInvoiceCommandDetailsBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  function BonusGroupInvoiceUpdatedEvent() {
  }
  BonusGroupInvoiceUpdatedEvent.$metadata$ = {
    simpleName: 'BonusGroupInvoiceUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupInvoiceUpdatedEventDetails() {
  }
  BonusGroupInvoiceUpdatedEventDetails.$metadata$ = {
    simpleName: 'BonusGroupInvoiceUpdatedEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupInvoiceUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupInvoiceUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupInvoiceUpdatedEventBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceUpdatedEventBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceUpdatedEvent]
  };
  Object.defineProperty(BonusGroupInvoiceUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupInvoiceUpdatedEventDetailsBase(invoiceId, bonusGroupId, by) {
    this.invoiceId_1 = invoiceId;
    this.bonusGroupId_1 = bonusGroupId;
    this.by_1 = by;
  }
  BonusGroupInvoiceUpdatedEventDetailsBase.prototype._get_invoiceId__604070441_9znbqh_k$ = function () {
    return this.invoiceId_1;
  };
  BonusGroupInvoiceUpdatedEventDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupInvoiceUpdatedEventDetailsBase.prototype._get_by__1413114900_ndbyfo_k$ = function () {
    return this.by_1;
  };
  BonusGroupInvoiceUpdatedEventDetailsBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceUpdatedEventDetailsBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceUpdatedEventDetails]
  };
  Object.defineProperty(BonusGroupInvoiceUpdatedEventDetailsBase.prototype, 'invoiceId', {
    configurable: true,
    get: function () {
      return this._get_invoiceId__604070441_9znbqh_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceUpdatedEventDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceUpdatedEventDetailsBase.prototype, 'by', {
    configurable: true,
    get: function () {
      return this._get_by__1413114900_ndbyfo_k$();
    }
  });
  function _get_UPDATE_BONUS_GROUP_INVOICE_DETAILS__981128817() {
    return UPDATE_BONUS_GROUP_INVOICE_DETAILS;
  }
  var UPDATE_BONUS_GROUP_INVOICE_DETAILS;
  function _get_BONUS_GROUP_INVOICE_DETAILS_UPDATED__2367444453() {
    return BONUS_GROUP_INVOICE_DETAILS_UPDATED;
  }
  var BONUS_GROUP_INVOICE_DETAILS_UPDATED;
  function UpdateBonusGroupInvoiceDetailsCommand() {
  }
  UpdateBonusGroupInvoiceDetailsCommand.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceDetailsCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function UpdateBonusGroupInvoiceDetailsCommandDetails() {
  }
  UpdateBonusGroupInvoiceDetailsCommandDetails.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceDetailsCommandDetails',
    kind: 'interface',
    interfaces: []
  };
  function UpdateBonusGroupInvoiceDetailsCommandBase(payload) {
    this.payload_1 = payload;
  }
  UpdateBonusGroupInvoiceDetailsCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  UpdateBonusGroupInvoiceDetailsCommandBase.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceDetailsCommandBase',
    kind: 'class',
    interfaces: [UpdateBonusGroupInvoiceDetailsCommand]
  };
  Object.defineProperty(UpdateBonusGroupInvoiceDetailsCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(UpdateBonusGroupInvoiceDetailsCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function UpdateBonusGroupInvoiceDetailsCommandDetailsBase(invoiceId, bonusGroupId, details) {
    this.invoiceId_1 = invoiceId;
    this.bonusGroupId_1 = bonusGroupId;
    this.details_1 = details;
  }
  UpdateBonusGroupInvoiceDetailsCommandDetailsBase.prototype._get_invoiceId__604070441_9znbqh_k$ = function () {
    return this.invoiceId_1;
  };
  UpdateBonusGroupInvoiceDetailsCommandDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  UpdateBonusGroupInvoiceDetailsCommandDetailsBase.prototype._get_details__3170742543_ilc1dd_k$ = function () {
    return this.details_1;
  };
  UpdateBonusGroupInvoiceDetailsCommandDetailsBase.$metadata$ = {
    simpleName: 'UpdateBonusGroupInvoiceDetailsCommandDetailsBase',
    kind: 'class',
    interfaces: [UpdateBonusGroupInvoiceDetailsCommandDetails]
  };
  Object.defineProperty(UpdateBonusGroupInvoiceDetailsCommandDetailsBase.prototype, 'invoiceId', {
    configurable: true,
    get: function () {
      return this._get_invoiceId__604070441_9znbqh_k$();
    }
  });
  Object.defineProperty(UpdateBonusGroupInvoiceDetailsCommandDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(UpdateBonusGroupInvoiceDetailsCommandDetailsBase.prototype, 'details', {
    configurable: true,
    get: function () {
      return this._get_details__3170742543_ilc1dd_k$();
    }
  });
  function BonusGroupInvoiceDetailsUpdatedEvent() {
  }
  BonusGroupInvoiceDetailsUpdatedEvent.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDetailsUpdatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusGroupInvoiceDetailsUpdatedEventDetails() {
  }
  BonusGroupInvoiceDetailsUpdatedEventDetails.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDetailsUpdatedEventDetails',
    kind: 'interface',
    interfaces: []
  };
  function BonusGroupInvoiceDetailsUpdatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusGroupInvoiceDetailsUpdatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusGroupInvoiceDetailsUpdatedEventBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDetailsUpdatedEventBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceDetailsUpdatedEvent]
  };
  Object.defineProperty(BonusGroupInvoiceDetailsUpdatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceDetailsUpdatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusGroupInvoiceDetailsUpdatedEventDetailsBase(invoiceId, bonusGroupId) {
    this.invoiceId_1 = invoiceId;
    this.bonusGroupId_1 = bonusGroupId;
  }
  BonusGroupInvoiceDetailsUpdatedEventDetailsBase.prototype._get_invoiceId__604070441_9znbqh_k$ = function () {
    return this.invoiceId_1;
  };
  BonusGroupInvoiceDetailsUpdatedEventDetailsBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  BonusGroupInvoiceDetailsUpdatedEventDetailsBase.$metadata$ = {
    simpleName: 'BonusGroupInvoiceDetailsUpdatedEventDetailsBase',
    kind: 'class',
    interfaces: [BonusGroupInvoiceDetailsUpdatedEventDetails]
  };
  Object.defineProperty(BonusGroupInvoiceDetailsUpdatedEventDetailsBase.prototype, 'invoiceId', {
    configurable: true,
    get: function () {
      return this._get_invoiceId__604070441_9znbqh_k$();
    }
  });
  Object.defineProperty(BonusGroupInvoiceDetailsUpdatedEventDetailsBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function _get_VALIDATE_BONUS_GROUP__1843977877() {
    return VALIDATE_BONUS_GROUP;
  }
  var VALIDATE_BONUS_GROUP;
  function ValidateBonusGroupCommand() {
  }
  ValidateBonusGroupCommand.$metadata$ = {
    simpleName: 'ValidateBonusGroupCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function ValidateBonusGroupCommandDTO() {
  }
  ValidateBonusGroupCommandDTO.$metadata$ = {
    simpleName: 'ValidateBonusGroupCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function ValidateBonusGroupCommandBase(payload) {
    this.payload_1 = payload;
  }
  ValidateBonusGroupCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ValidateBonusGroupCommandBase.$metadata$ = {
    simpleName: 'ValidateBonusGroupCommandBase',
    kind: 'class',
    interfaces: [ValidateBonusGroupCommand]
  };
  Object.defineProperty(ValidateBonusGroupCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ValidateBonusGroupCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ValidateBonusGroupCommandDTOBase(bonusGroupId) {
    this.bonusGroupId_1 = bonusGroupId;
  }
  ValidateBonusGroupCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  ValidateBonusGroupCommandDTOBase.$metadata$ = {
    simpleName: 'ValidateBonusGroupCommandDTOBase',
    kind: 'class',
    interfaces: [ValidateBonusGroupCommandDTO]
  };
  Object.defineProperty(ValidateBonusGroupCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  function BonusPaymentAggregate() {
  }
  BonusPaymentAggregate.$metadata$ = {
    simpleName: 'BonusPaymentAggregate',
    kind: 'interface',
    interfaces: []
  };
  function BonusPaymentFinder() {
  }
  BonusPaymentFinder.$metadata$ = {
    simpleName: 'BonusPaymentFinder',
    kind: 'interface',
    interfaces: []
  };
  function _get_ADD_BONUS_IN_BONUS_PAYMENT__3251012097() {
    return ADD_BONUS_IN_BONUS_PAYMENT;
  }
  var ADD_BONUS_IN_BONUS_PAYMENT;
  function AddBonusInPaymentCommand() {
  }
  AddBonusInPaymentCommand.$metadata$ = {
    simpleName: 'AddBonusInPaymentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function AddBonusInPaymentCommandBase(payload) {
    this.payload_1 = payload;
  }
  AddBonusInPaymentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AddBonusInPaymentCommandBase.$metadata$ = {
    simpleName: 'AddBonusInPaymentCommandBase',
    kind: 'class',
    interfaces: [AddBonusInPaymentCommand]
  };
  Object.defineProperty(AddBonusInPaymentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AddBonusInPaymentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function AddBonusInPaymentCommandDTO() {
  }
  AddBonusInPaymentCommandDTO.$metadata$ = {
    simpleName: 'AddBonusInPaymentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function AddBonusInPaymentCommandDTOBase(bonusGroupId, operatorId, period, amount) {
    this.bonusGroupId_1 = bonusGroupId;
    this.operatorId_1 = operatorId;
    this.period_1 = period;
    this.amount_1 = amount;
  }
  AddBonusInPaymentCommandDTOBase.prototype._get_bonusGroupId__4048128464_42ym28_k$ = function () {
    return this.bonusGroupId_1;
  };
  AddBonusInPaymentCommandDTOBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  AddBonusInPaymentCommandDTOBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  AddBonusInPaymentCommandDTOBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  AddBonusInPaymentCommandDTOBase.$metadata$ = {
    simpleName: 'AddBonusInPaymentCommandDTOBase',
    kind: 'class',
    interfaces: [AddBonusInPaymentCommandDTO]
  };
  Object.defineProperty(AddBonusInPaymentCommandDTOBase.prototype, 'bonusGroupId', {
    configurable: true,
    get: function () {
      return this._get_bonusGroupId__4048128464_42ym28_k$();
    }
  });
  Object.defineProperty(AddBonusInPaymentCommandDTOBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(AddBonusInPaymentCommandDTOBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(AddBonusInPaymentCommandDTOBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  function _get_ADDED_BONUS_IN_BONUS_PAYMENT__2255856160() {
    return ADDED_BONUS_IN_BONUS_PAYMENT;
  }
  var ADDED_BONUS_IN_BONUS_PAYMENT;
  function BonusPaymentAddedBonusEvent() {
  }
  BonusPaymentAddedBonusEvent.$metadata$ = {
    simpleName: 'BonusPaymentAddedBonusEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusPaymentAddedBonusEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusPaymentAddedBonusEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusPaymentAddedBonusEventBase.$metadata$ = {
    simpleName: 'BonusPaymentAddedBonusEventBase',
    kind: 'class',
    interfaces: [BonusPaymentAddedBonusEvent]
  };
  Object.defineProperty(BonusPaymentAddedBonusEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusPaymentAddedBonusEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusPaymentAddedBonusEventDto() {
  }
  BonusPaymentAddedBonusEventDto.$metadata$ = {
    simpleName: 'BonusPaymentAddedBonusEventDto',
    kind: 'interface',
    interfaces: []
  };
  function BonusPaymentAddedBonusEventDtoBase(bonusPaymentId) {
    this.bonusPaymentId_1 = bonusPaymentId;
  }
  BonusPaymentAddedBonusEventDtoBase.prototype._get_bonusPaymentId__3657263593_ajo7br_k$ = function () {
    return this.bonusPaymentId_1;
  };
  BonusPaymentAddedBonusEventDtoBase.$metadata$ = {
    simpleName: 'BonusPaymentAddedBonusEventDtoBase',
    kind: 'class',
    interfaces: [BonusPaymentAddedBonusEventDto]
  };
  Object.defineProperty(BonusPaymentAddedBonusEventDtoBase.prototype, 'bonusPaymentId', {
    configurable: true,
    get: function () {
      return this._get_bonusPaymentId__3657263593_ajo7br_k$();
    }
  });
  function _get_CREATE_BONUS_PAYMENT__423128328() {
    return CREATE_BONUS_PAYMENT;
  }
  var CREATE_BONUS_PAYMENT;
  function CreateBonusPaymentCommand() {
  }
  CreateBonusPaymentCommand.$metadata$ = {
    simpleName: 'CreateBonusPaymentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function CreateBonusPaymentCommandBase(payload) {
    this.payload_1 = payload;
  }
  CreateBonusPaymentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  CreateBonusPaymentCommandBase.$metadata$ = {
    simpleName: 'CreateBonusPaymentCommandBase',
    kind: 'class',
    interfaces: [CreateBonusPaymentCommand]
  };
  Object.defineProperty(CreateBonusPaymentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(CreateBonusPaymentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function CreateBonusPaymentCommandDTO() {
  }
  CreateBonusPaymentCommandDTO.$metadata$ = {
    simpleName: 'CreateBonusPaymentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function CreateBonusPaymentCommandDTOBase(operatorId, period) {
    this.operatorId_1 = operatorId;
    this.period_1 = period;
  }
  CreateBonusPaymentCommandDTOBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  CreateBonusPaymentCommandDTOBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  CreateBonusPaymentCommandDTOBase.$metadata$ = {
    simpleName: 'CreateBonusPaymentCommandDTOBase',
    kind: 'class',
    interfaces: [CreateBonusPaymentCommandDTO]
  };
  Object.defineProperty(CreateBonusPaymentCommandDTOBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  Object.defineProperty(CreateBonusPaymentCommandDTOBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  function _get_CREATED_BONUS_PAYMENT_EVENT__3445095975() {
    return CREATED_BONUS_PAYMENT_EVENT;
  }
  var CREATED_BONUS_PAYMENT_EVENT;
  function BonusPaymentCreatedEvent() {
  }
  BonusPaymentCreatedEvent.$metadata$ = {
    simpleName: 'BonusPaymentCreatedEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusPaymentCreatedEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusPaymentCreatedEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusPaymentCreatedEventBase.$metadata$ = {
    simpleName: 'BonusPaymentCreatedEventBase',
    kind: 'class',
    interfaces: [BonusPaymentCreatedEvent]
  };
  Object.defineProperty(BonusPaymentCreatedEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusPaymentCreatedEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusPaymentCreatedEventDto() {
  }
  BonusPaymentCreatedEventDto.$metadata$ = {
    simpleName: 'BonusPaymentCreatedEventDto',
    kind: 'interface',
    interfaces: []
  };
  function BonusPaymentCreatedEventDtoBase(id) {
    this.id_1 = id;
  }
  BonusPaymentCreatedEventDtoBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusPaymentCreatedEventDtoBase.$metadata$ = {
    simpleName: 'BonusPaymentCreatedEventDtoBase',
    kind: 'class',
    interfaces: [BonusPaymentCreatedEventDto]
  };
  Object.defineProperty(BonusPaymentCreatedEventDtoBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function _get_PAY_BONUS_PAYMENT__2631622402() {
    return PAY_BONUS_PAYMENT;
  }
  var PAY_BONUS_PAYMENT;
  function PayBonusPaymentCommand() {
  }
  PayBonusPaymentCommand.$metadata$ = {
    simpleName: 'PayBonusPaymentCommand',
    kind: 'interface',
    interfaces: [Command]
  };
  function PayBonusPaymentCommandBase(payload) {
    this.payload_1 = payload;
  }
  PayBonusPaymentCommandBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  PayBonusPaymentCommandBase.$metadata$ = {
    simpleName: 'PayBonusPaymentCommandBase',
    kind: 'class',
    interfaces: [PayBonusPaymentCommand]
  };
  Object.defineProperty(PayBonusPaymentCommandBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(PayBonusPaymentCommandBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function PayBonusPaymentCommandDTO() {
  }
  PayBonusPaymentCommandDTO.$metadata$ = {
    simpleName: 'PayBonusPaymentCommandDTO',
    kind: 'interface',
    interfaces: []
  };
  function PayBonusPaymentCommandDTOBase(bonusPaymentId) {
    this.bonusPaymentId_1 = bonusPaymentId;
  }
  PayBonusPaymentCommandDTOBase.prototype._get_bonusPaymentId__3657263593_ajo7br_k$ = function () {
    return this.bonusPaymentId_1;
  };
  PayBonusPaymentCommandDTOBase.$metadata$ = {
    simpleName: 'PayBonusPaymentCommandDTOBase',
    kind: 'class',
    interfaces: [PayBonusPaymentCommandDTO]
  };
  Object.defineProperty(PayBonusPaymentCommandDTOBase.prototype, 'bonusPaymentId', {
    configurable: true,
    get: function () {
      return this._get_bonusPaymentId__3657263593_ajo7br_k$();
    }
  });
  function _get_PAID_BONUS_PAYMENT_EVENT__427829981() {
    return PAID_BONUS_PAYMENT_EVENT;
  }
  var PAID_BONUS_PAYMENT_EVENT;
  function BonusPaymentPaidEvent() {
  }
  BonusPaymentPaidEvent.$metadata$ = {
    simpleName: 'BonusPaymentPaidEvent',
    kind: 'interface',
    interfaces: [Event]
  };
  function BonusPaymentPaidEventBase(payload) {
    this.payload_1 = payload;
  }
  BonusPaymentPaidEventBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  BonusPaymentPaidEventBase.$metadata$ = {
    simpleName: 'BonusPaymentPaidEventBase',
    kind: 'class',
    interfaces: [BonusPaymentPaidEvent]
  };
  Object.defineProperty(BonusPaymentPaidEventBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(BonusPaymentPaidEventBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function BonusPaymentPaidEventDto() {
  }
  BonusPaymentPaidEventDto.$metadata$ = {
    simpleName: 'BonusPaymentPaidEventDto',
    kind: 'interface',
    interfaces: []
  };
  function BonusPaymentPaidEventDtoBase(bonusPaymentId) {
    this.bonusPaymentId_1 = bonusPaymentId;
  }
  BonusPaymentPaidEventDtoBase.prototype._get_bonusPaymentId__3657263593_ajo7br_k$ = function () {
    return this.bonusPaymentId_1;
  };
  BonusPaymentPaidEventDtoBase.$metadata$ = {
    simpleName: 'BonusPaymentPaidEventDtoBase',
    kind: 'class',
    interfaces: [BonusPaymentPaidEventDto]
  };
  Object.defineProperty(BonusPaymentPaidEventDtoBase.prototype, 'bonusPaymentId', {
    configurable: true,
    get: function () {
      return this._get_bonusPaymentId__3657263593_ajo7br_k$();
    }
  });
  function _get_EXPORT_BONUS_GROUP_INVOICE__1170025193() {
    return EXPORT_BONUS_GROUP_INVOICE;
  }
  var EXPORT_BONUS_GROUP_INVOICE;
  function ExportBonusGroupInvoiceQuery() {
  }
  ExportBonusGroupInvoiceQuery.$metadata$ = {
    simpleName: 'ExportBonusGroupInvoiceQuery',
    kind: 'interface',
    interfaces: [Command]
  };
  function ExportBonusGroupInvoiceQueryDTO() {
  }
  ExportBonusGroupInvoiceQueryDTO.$metadata$ = {
    simpleName: 'ExportBonusGroupInvoiceQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ExportBonusGroupInvoiceQueryBase(payload) {
    this.payload_1 = payload;
  }
  ExportBonusGroupInvoiceQueryBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  ExportBonusGroupInvoiceQueryBase.$metadata$ = {
    simpleName: 'ExportBonusGroupInvoiceQueryBase',
    kind: 'class',
    interfaces: [ExportBonusGroupInvoiceQuery]
  };
  Object.defineProperty(ExportBonusGroupInvoiceQueryBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(ExportBonusGroupInvoiceQueryBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  function ExportBonusGroupInvoiceQueryDTOBase(period) {
    this.period_1 = period;
  }
  ExportBonusGroupInvoiceQueryDTOBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  ExportBonusGroupInvoiceQueryDTOBase.$metadata$ = {
    simpleName: 'ExportBonusGroupInvoiceQueryDTOBase',
    kind: 'class',
    interfaces: [ExportBonusGroupInvoiceQueryDTO]
  };
  Object.defineProperty(ExportBonusGroupInvoiceQueryDTOBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  function BonusPayment() {
  }
  BonusPayment.$metadata$ = {
    simpleName: 'BonusPayment',
    kind: 'interface',
    interfaces: []
  };
  function BonusPaymentBase(id, bonuses, operator, funders, budget, period, status) {
    this.id_1 = id;
    this.bonuses_1 = bonuses;
    this.operator_1 = operator;
    this.funders_1 = funders;
    this.budget_1 = budget;
    this.period_1 = period;
    this.status_1 = status;
  }
  BonusPaymentBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusPaymentBase.prototype._get_bonuses__4112178084_30tt24_k$ = function () {
    return this.bonuses_1;
  };
  BonusPaymentBase.prototype._get_operator__3144543143_j0xkyh_k$ = function () {
    return this.operator_1;
  };
  BonusPaymentBase.prototype._get_funders__3507435184_d0vjo0_k$ = function () {
    return this.funders_1;
  };
  BonusPaymentBase.prototype._get_budget__2511517798_thtifu_k$ = function () {
    return this.budget_1;
  };
  BonusPaymentBase.prototype._get_period__1606599018_qkizqi_k$ = function () {
    return this.period_1;
  };
  BonusPaymentBase.prototype._get_status__388214105_6f4rx5_k$ = function () {
    return this.status_1;
  };
  BonusPaymentBase.$metadata$ = {
    simpleName: 'BonusPaymentBase',
    kind: 'class',
    interfaces: [BonusPayment]
  };
  Object.defineProperty(BonusPaymentBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusPaymentBase.prototype, 'bonuses', {
    configurable: true,
    get: function () {
      return this._get_bonuses__4112178084_30tt24_k$();
    }
  });
  Object.defineProperty(BonusPaymentBase.prototype, 'operator', {
    configurable: true,
    get: function () {
      return this._get_operator__3144543143_j0xkyh_k$();
    }
  });
  Object.defineProperty(BonusPaymentBase.prototype, 'funders', {
    configurable: true,
    get: function () {
      return this._get_funders__3507435184_d0vjo0_k$();
    }
  });
  Object.defineProperty(BonusPaymentBase.prototype, 'budget', {
    configurable: true,
    get: function () {
      return this._get_budget__2511517798_thtifu_k$();
    }
  });
  Object.defineProperty(BonusPaymentBase.prototype, 'period', {
    configurable: true,
    get: function () {
      return this._get_period__1606599018_qkizqi_k$();
    }
  });
  Object.defineProperty(BonusPaymentBase.prototype, 'status', {
    configurable: true,
    get: function () {
      return this._get_status__388214105_6f4rx5_k$();
    }
  });
  function _get_BONUS_PAYMENT_CREATED__1943390850() {
    init_properties_BonusPaymentStatus_kt_3039010177();
    return BONUS_PAYMENT_CREATED;
  }
  var BONUS_PAYMENT_CREATED;
  function _get_BONUS_PAYMENT_PAID__3746291302() {
    init_properties_BonusPaymentStatus_kt_3039010177();
    return BONUS_PAYMENT_PAID;
  }
  var BONUS_PAYMENT_PAID;
  function BonusPaymentStatus() {
  }
  BonusPaymentStatus.$metadata$ = {
    simpleName: 'BonusPaymentStatus',
    kind: 'interface',
    interfaces: []
  };
  function BonusPaymentStatusBase(value) {
    this.value_1 = value;
  }
  BonusPaymentStatusBase.prototype._get_value__3683422336_a43j40_k$ = function () {
    return this.value_1;
  };
  BonusPaymentStatusBase.prototype.component1 = function () {
    return this.value_1;
  };
  BonusPaymentStatusBase.prototype.copy = function (value) {
    return this.copy_3t26ic_k$(value === void 1 ? this.value_1 : value);
  };
  BonusPaymentStatusBase.prototype.copy_3t26ic_k$ = function (value) {
    return new BonusPaymentStatusBase(value);
  };
  BonusPaymentStatusBase.prototype.copy$default_q3pzg4_k$ = function (value, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      value = this.value_1;
    return this.copy_3t26ic_k$(value);
  };
  BonusPaymentStatusBase.prototype.toString = function () {
    return 'BonusPaymentStatusBase(value=' + this.value_1 + ')';
  };
  BonusPaymentStatusBase.prototype.hashCode = function () {
    return getStringHashCode(this.value_1);
  };
  BonusPaymentStatusBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BonusPaymentStatusBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof BonusPaymentStatusBase ? other : THROW_CCE();
    if (!(this.value_1 === tmp0_other_with_cast.value_1))
      return false;
    return true;
  };
  BonusPaymentStatusBase.$metadata$ = {
    simpleName: 'BonusPaymentStatusBase',
    kind: 'class',
    interfaces: [BonusPaymentStatus]
  };
  Object.defineProperty(BonusPaymentStatusBase.prototype, 'value', {
    configurable: true,
    get: function () {
      return this._get_value__3683422336_a43j40_k$();
    }
  });
  function BonusPaymentStatusValues() {
    this.CREATED_1 = _get_BONUS_PAYMENT_CREATED__1943390850();
    this.PAID_1 = _get_BONUS_PAYMENT_PAID__3746291302();
  }
  BonusPaymentStatusValues.prototype._get_CREATED__434088265_76g0nd_k$ = function () {
    return this.CREATED_1;
  };
  BonusPaymentStatusValues.prototype._get_PAID__775474431_ctp3wf_k$ = function () {
    return this.PAID_1;
  };
  BonusPaymentStatusValues.prototype.isCreated = function (status) {
    return status === this.CREATED_1.value_1;
  };
  BonusPaymentStatusValues.prototype.isPaid = function (status) {
    return status === this.PAID_1.value_1;
  };
  BonusPaymentStatusValues.$metadata$ = {
    simpleName: 'BonusPaymentStatusValues',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(BonusPaymentStatusValues.prototype, 'CREATED', {
    configurable: true,
    get: BonusPaymentStatusValues.prototype._get_CREATED__434088265_76g0nd_k$
  });
  Object.defineProperty(BonusPaymentStatusValues.prototype, 'PAID', {
    configurable: true,
    get: BonusPaymentStatusValues.prototype._get_PAID__775474431_ctp3wf_k$
  });
  var properties_initialized_BonusPaymentStatus_kt_3759824805;
  function init_properties_BonusPaymentStatus_kt_3039010177() {
    if (!properties_initialized_BonusPaymentStatus_kt_3759824805) {
      properties_initialized_BonusPaymentStatus_kt_3759824805 = true;
      BONUS_PAYMENT_CREATED = new BonusPaymentStatusBase('CREATED');
      BONUS_PAYMENT_PAID = new BonusPaymentStatusBase('PAID');
    }
  }
  function BonusRef() {
  }
  BonusRef.$metadata$ = {
    simpleName: 'BonusRef',
    kind: 'interface',
    interfaces: []
  };
  function BonusRefBase(id, city, amount, carrierId, operatorId) {
    this.id_1 = id;
    this.city_1 = city;
    this.amount_1 = amount;
    this.carrierId_1 = carrierId;
    this.operatorId_1 = operatorId;
  }
  BonusRefBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  BonusRefBase.prototype._get_city__794255936_d4vnsw_k$ = function () {
    return this.city_1;
  };
  BonusRefBase.prototype._get_amount__1405565363_n8u56b_k$ = function () {
    return this.amount_1;
  };
  BonusRefBase.prototype._get_carrierId__3793694334_8ag0oy_k$ = function () {
    return this.carrierId_1;
  };
  BonusRefBase.prototype._get_operatorId__2543965068_syi1ys_k$ = function () {
    return this.operatorId_1;
  };
  BonusRefBase.$metadata$ = {
    simpleName: 'BonusRefBase',
    kind: 'class',
    interfaces: [BonusRef]
  };
  Object.defineProperty(BonusRefBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(BonusRefBase.prototype, 'city', {
    configurable: true,
    get: function () {
      return this._get_city__794255936_d4vnsw_k$();
    }
  });
  Object.defineProperty(BonusRefBase.prototype, 'amount', {
    configurable: true,
    get: function () {
      return this._get_amount__1405565363_n8u56b_k$();
    }
  });
  Object.defineProperty(BonusRefBase.prototype, 'carrierId', {
    configurable: true,
    get: function () {
      return this._get_carrierId__3793694334_8ag0oy_k$();
    }
  });
  Object.defineProperty(BonusRefBase.prototype, 'operatorId', {
    configurable: true,
    get: function () {
      return this._get_operatorId__2543965068_syi1ys_k$();
    }
  });
  function OperatorRef() {
  }
  OperatorRef.$metadata$ = {
    simpleName: 'OperatorRef',
    kind: 'interface',
    interfaces: []
  };
  function OperatorRefBase(id, iban) {
    this.id_1 = id;
    this.iban_1 = iban;
  }
  OperatorRefBase.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  OperatorRefBase.prototype._get_iban__799569925_d81k3p_k$ = function () {
    return this.iban_1;
  };
  OperatorRefBase.$metadata$ = {
    simpleName: 'OperatorRefBase',
    kind: 'class',
    interfaces: [OperatorRef]
  };
  Object.defineProperty(OperatorRefBase.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(OperatorRefBase.prototype, 'iban', {
    configurable: true,
    get: function () {
      return this._get_iban__799569925_d81k3p_k$();
    }
  });
  //region block: post-declaration
  AddTerritoryZoneCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985;
  TerritoryZoneAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_0;
  ArchiveGeoZoneCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_1;
  GeoZoneArchivedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_2;
  CreateGeoZoneCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_3;
  GeoZoneCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_4;
  CreateTerritoryCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_5;
  TerritoryCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_6;
  AddApplicationPropertiesBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_7;
  ApplicationPropertiesAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_8;
  AddHubCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_9;
  HubAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_10;
  ChangeUserPasswordCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_11;
  CreateApplicationCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_13;
  ApplicationCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_14;
  CreateOrganizationCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_15;
  OrganizationCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_16;
  UploadSimplifiedConventionCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_17;
  SimplifiedConventionUploadedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_18;
  DeleteOrganizationCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_19;
  DeletedOrganizationEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_20;
  DeleteUserCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_21;
  DeletedUserEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_22;
  DisableOrganizationCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_23;
  DisabledOrganizationEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_24;
  DisableUserCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_25;
  DisabledUserEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_26;
  EnableUserCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_27;
  EnabledUserEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_28;
  ExportAuthorizationUpdateCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_29;
  ExportAuthorizationUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_30;
  ExportDolibarrOrganizationsQueryBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_31;
  ExportOrganizationsQueryBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_32;
  HubActivationToggleCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_33;
  HubActivationToggledEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_34;
  LogoCreatedCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_35;
  LogoCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_36;
  OrganizationAddUserCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_37;
  UserAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_38;
  OrganizationUpdateUserDetailsCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_39;
  UserUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_40;
  OrganizationUpdateCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_41;
  OrganizationUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_42;
  RemoveHubCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_43;
  HubRemovedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_44;
  SetOrganizationRsaKeypairCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_45;
  OrganizationRsaKeypairSetEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_46;
  UpdateHubActivityEndDateCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_47;
  HubActivityEndDateUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_48;
  UpdateHubCommentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_49;
  HubCommentUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_50;
  UploadPaymentInfoCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_51;
  UploadedPaymentInfoEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_52;
  VisitorAuthorizationUpdateCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_53;
  VisitorAuthorizationUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_54;
  ConventionPrefilledEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_55;
  ConventionResetedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_56;
  CreateConventionCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_57;
  ConventionCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_58;
  FinalizedConventionCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_59;
  ConventionFinalizedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_60;
  PrepareSignConventionCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_61;
  ConventionSignPreparedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_62;
  SignedConventionCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_63;
  ConventionSignedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_64;
  UpdateApplicationSecretCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_65;
  ApplicationSecretUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_66;
  AddCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_67;
  AddedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_68;
  AddFunderCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_69;
  AddedFunderEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_70;
  ArchiveCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_71;
  ArchivedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_72;
  CreateProjectCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_73;
  ProjectCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_74;
  DuplicateCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_75;
  DuplicatedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_76;
  FinishCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_77;
  DoneCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_78;
  FinishProjectCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_79;
  ProjectDoneEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_80;
  PauseCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_81;
  PausedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_82;
  PublishCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_83;
  PublishedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_84;
  RemoveCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_85;
  RemovedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_86;
  StartCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_87;
  StartedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_88;
  UpdateCampaignCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_89;
  UpdatedCampaignEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_90;
  UpdateCampaignMissingBudgetCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_91;
  UpdatedCampaignMissingBudgetEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_92;
  UpdateCampaignNotificationCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_93;
  UpdatedCampaignNotificationEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_94;
  UpdateProjectCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_95;
  ProjectUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_96;
  AddDeliveriesCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_97;
  DeliveryAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_98;
  AddDeliveryBlockchainTraceCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_99;
  DeliveryBlockchainTraceAddedBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_100;
  AddTourMetadataBlockchainTraceCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_101;
  TourMetadataBlockchainTraceAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_102;
  AddTourTraceGpsCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_103;
  TourTraceGpsAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_104;
  DeclareTourCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_105;
  TourDeclaredEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_106;
  GetToursWithDeliveriesQueryBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_107;
  TourAuditedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_108;
  UpdateAcceptedByAiCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_109;
  AcceptedByAiUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_110;
  UpdateDeliveryStatusCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_111;
  DeliveryStatusUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_112;
  UpdateTerritoryCodeCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_113;
  TerritoryCodeUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_114;
  AddBonusDeliveryToursCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_115;
  BonusDeliveryToursAddedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_116;
  BonusUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_117;
  CreateBonusCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_118;
  BonusCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_119;
  CreateOrUpdateGroupOfBonusCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_120;
  RemoveBonusToursCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_121;
  BonusToursRemovedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_122;
  SetBonusToursAsActiveCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_123;
  BonusToursSetAsActiveEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_124;
  UpdateBonusAmountCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_125;
  BonusAmountUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_126;
  UpdateBonusStatusCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_127;
  BonusStatusUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_128;
  AddBonusToGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_129;
  BonusAddedToGroupEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_130;
  BonusGroupCommentEditedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_131;
  BonusGroupCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_132;
  BonusGroupDeletedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_133;
  BonusGroupInvoiceDeletedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_134;
  BonusGroupLogCommentEditedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_135;
  BonusGroupStatusUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_136;
  CreateBonusGroupIncidentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_137;
  BonusGroupIncidentCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_138;
  CreateBonusGroupInvoiceCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_139;
  BonusGroupInvoiceCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_140;
  DeduceBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_141;
  DeleteBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_142;
  DeleteBonusGroupsCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_143;
  EditBonusGroupCommentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_144;
  EditBonusGroupLogCommentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_145;
  LogBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_146;
  PayBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_147;
  PublishBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_148;
  RejectBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_149;
  ReportBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_150;
  ResolveBonusGroupIncidentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_151;
  BonusGroupIncidentResolvedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_152;
  UpdateBonusGroupInvoiceCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_153;
  BonusGroupInvoiceUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_154;
  UpdateBonusGroupInvoiceDetailsCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_155;
  BonusGroupInvoiceDetailsUpdatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_156;
  ValidateBonusGroupCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_157;
  AddBonusInPaymentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_158;
  BonusPaymentAddedBonusEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_159;
  CreateBonusPaymentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_160;
  BonusPaymentCreatedEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_161;
  PayBonusPaymentCommandBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_162;
  BonusPaymentPaidEventBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_163;
  ExportBonusGroupInvoiceQueryBase.prototype._get_type__810427985_deia8h_k$ = _get_type__810427985_164;
  //endregion
  //region block: init
  ROLE_ADMIN = 'admin';
  ROLE_SUPER_ADMIN = 'super_admin';
  ROLE_OPERATOR_ADMIN = 'operator_admin';
  ROLE_OPERATOR_USER = 'operator_user';
  ROLE_OPERATOR_ADMIN_ONBOARDING = 'operator_admin_onboarding';
  ROLE_OPERATOR_USER_ONBOARDING = 'operator_user_onboarding';
  ROLE_FUNDER_ADMIN = 'funder_admin';
  ROLE_FUNDER_USER = 'funder_user';
  ROLE_CARRIER_ADMIN = 'carrier_admin';
  ROLE_CARRIER_USER = 'carrier_user';
  ROLE_TMS_ADMIN = 'tms_admin';
  ROLE_TMS_USER = 'tms_user';
  ROLE_VISITOR_ADMIN = 'visitor_admin';
  ROLE_VISITOR_USER = 'visitor_user';
  ROLE_READ_HEAT_MAP = 'read_heatmap';
  ROLE_READ_FLUX_MAP = 'read_flux_map';
  ROLE_READ_DASHBOARD_BONUS_TOTAL = 'read_dashboard_bonus_total';
  ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE = 'read_dashboard_bonus_per_package';
  ROLE_READ_DASHBOARD_DELIVERY_TIME = 'read_dashboard_delivery_time';
  ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES = 'read_dashboard_active_deliveries';
  ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT = 'read_dashboard_active_pack_count';
  ROLE_READ_DASHBOARD_HUB_COUNT = 'read_dashboard_hub_count';
  ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE = 'read_dashboard_average_approach_distance';
  ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY = 'read_dashboard_average_distance_per_delivery';
  ROLE_READ_DASHBOARD_TOUR_AMOUNT = 'read_dashboard_tour_amount';
  ROLE_READ_DASHBOARD_DISTANCE_TOTAL = 'read_dashboard_distance_total';
  ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED = 'read_dashboard_thermal_km_avoided';
  ROLE_READ_DASHBOARD_CO2_AVOIDED = 'read_dashboard_co2_avoided';
  ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED = 'read_dashboard_nox_ppm_avoided';
  ADD_TERRITORY_ZONE = 'ADD_TERRITORY_ZONE';
  TERRITORY_ZONE_ADDED = 'TERRITORY_ZONE_ADDED';
  ARCHIVE_GEOZONE = 'ARCHIVE_GEOZONE';
  GEOZONE_ARCHIVED = 'GEOZONE_ARCHIVED';
  CREATE_GEOZONE = 'CREATE_GEOZONE';
  GEOZONE_CREATED = 'GEOZONE_CREATED';
  CREATE_TERRITORY = 'CREATE_TERRITORY';
  TERRITORY_CREATED = 'TERRITORY_CREATED';
  ADD_APPLICATION_PROPERTIES = 'ADD_APPLICATION_PROPERTIES';
  APPLICATION_PROPERTIES_ADDED = 'APPLICATION_PROPERTIES_ADDED';
  ADD_HUB = 'ADD_HUB';
  USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD';
  USER_CHANGED_PASSWORD = 'USER_CHANGED_PASSWORD';
  CREATE_CLIENT = 'CREATE_CLIENT';
  CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
  CREATED_ORGANIZATION_EVENT = 'CREATED_ORGANIZATION_EVENT';
  UPLOAD_SIMPLIFIED_CONVENTION = 'UPLOAD_SIMPLIFIED_CONVENTION';
  UPLOADED_SIMPLIFIED_CONVENTION_EVENT = 'UPLOADED_SIMPLIFIED_CONVENTION_EVENT';
  DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';
  DELETED_ORGANIZATION_EVENT = 'DELETED_ORGANIZATION_EVENT';
  DELETE_USER = 'DELETE_USER';
  DELETED_USER_EVENT = 'DELETED_USER_EVENT';
  DISABLE_ORGANIZATION = 'DISABLE_ORGANIZATION';
  DISABLED_ORGANIZATION_EVENT = 'DISABLED_ORGANIZATION_EVENT';
  DISABLE_USER = 'DISABLE_USER';
  DISABLED_USER_EVENT = 'DISABLED_USER_EVENT';
  ENABLE_USER = 'ENABLE_USER';
  ENABLED_USER_EVENT = 'ENABLED_USER_EVENT';
  EXPORT_DOLIBARR_ORGANIZATIONS = 'EXPORT_DOLIBARR_ORGANIZATIONS';
  EXPORT_ORGANIZATIONS = 'EXPORT_ORGANIZATIONS';
  HUB_ACTIVATION_TOGGLE = 'HUB_ACTIVATION_TOGGLE';
  HUB_ACTIVATION_TOGGLED_EVENT = 'HUB_ACTIVATION_TOGGLED_EVENT';
  LOGO_CREATE = 'LOGO_CREATE';
  LOGO_CREATED_EVENT = 'LOGO_CREATED_EVENT';
  USER_ADD = 'USER_ADD';
  USER_ADDED_EVENT = 'USER_ADDED_EVENT';
  USER_UPDATE = 'USER_UPDATE';
  USER_UPDATED_EVENT = 'USER_UPDATED_EVENT';
  UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
  REMOVE_HUB = 'REMOVE_HUB';
  HUB_REMOVED_EVENT = 'HUB_REMOVED_EVENT';
  SET_ORGANIZATION_RSA_KEYPAIR = 'SET_ORGANIZATION_RSA_KEYPAIR';
  ORGANIZATION_RSA_KEYPAIR_SET = 'ORGANIZATION_RSA_KEYPAIR_SET';
  UPDATE_HUB_ACTIVITY_END_DATE = 'UPDATE_HUB_ACTIVITY_END_DATE';
  HUB_ACTIVITY_END_DATE_UPDATED_EVENT = 'HUB_ACTIVITY_END_DATE_UPDATED_EVENT';
  UPDATE_HUB_COMMENT = 'UPDATE_HUB_COMMENT';
  HUB_COMMENT_UPDATED_EVENT = 'HUB_COMMENT_UPDATED_EVENT';
  CONVENTION_PREFILLED = 'CONVENTION_PREFILLED';
  CONVENTION_RESETED_EVENT = 'CONVENTION_RESETED_EVENT';
  CREATE_CONVENTION = 'CREATE_CONVENTION';
  FINALIZED_CONVENTION = 'FINALIZED_CONVENTION';
  PREPARE_SIGN_CONVENTION = 'PREPARE_SIGN_CONVENTION';
  SIGNED_CONVENTION = 'SIGNED_CONVENTION';
  UPDATE_SECRET = 'UPDATE_SECRET';
  CREATE_PROJECT = 'CREATE_PROJECT';
  CREATED_PROJECT_EVENT = 'CREATED_PROJECT_EVENT';
  FINISH_PROJECT = 'FINISH_PROJECT';
  PROJECT_DONE_EVENT = 'PROJECT_DONE_EVENT';
  UPDATE_PROJECT = 'UPDATE_PROJECT';
  UPDATED_PROJECT_EVENT = 'UPDATED_PROJECT_EVENT';
  ADD_DELIVERIES = 'ADD_DELIVERIES';
  DELIVERY_ADDED = 'DELIVERY_ADDED';
  ADD_DELIVERY_BLOCKCHAIN_TRACE = 'ADD_DELIVERY_BLOCKCHAIN_TRACE';
  DELIVERY_BLOCKCHAIN_TRACE_ADDED = 'DELIVERY_BLOCKCHAIN_TRACE_ADDED';
  ADD_TOUR_METADATA_BLOCKCHAIN_TRACE = 'ADD_TOUR_METADATA_BLOCKCHAIN_TRACE';
  TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED = 'TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED';
  ADD_TOUR_TRACE_GPS = 'ADD_TOUR_TRACE_GPS';
  TOUR_TRACE_GPS_ADDED = 'TOUR_TRACE_GPS_ADDED';
  DECLARE_TOUR = 'DECLARE_TOUR';
  TOUR_DECLARED = 'TOUR_DECLARED';
  GET_TOURS_WITH_DELIVERIES = 'GET_TOURS_WITH_DELIVERIES';
  TOUR_AUDITED = 'TOUR_AUDITED';
  UPDATE_ACCEPTED_BY_AI = 'UPDATE_ACCEPTED_BY_AI';
  ACCEPTED_BY_AI_UPDATED = 'ACCEPTED_BY_AI_UPDATED';
  UPDATE_DELIVERY_STATUS = 'UPDATE_DELIVERY_STATUS';
  DELIVERY_STATUS_UPDATED = 'DELIVERY_STATUS_UPDATED';
  UPDATE_TERRITORY_CODE = 'UPDATE_TERRITORY_CODE';
  TERRITORY_CODE_UPDATED = 'TERRITORY_CODE_UPDATED';
  ADD_BONUS_DELIVERY_TOURS = 'ADD_BONUS_DELIVERY_TOURS';
  BONUS_DELIVERY_TOURS_ADDED = 'BONUS_DELIVERY_TOURS_ADDED';
  BONUS_UPDATED = 'BONUS_UPDATED';
  CREATE_BONUS = 'CREATE_BONUS';
  BONUS_CREATED = 'BONUS_CREATED';
  CREATE_OR_UPDATE_GROUP_OF_BONUS = 'CREATE_OR_UPDATE_GROUP_OF_BONUS';
  REMOVE_BONUS_TOURS = 'REMOVE_BONUS_TOURS';
  BONUS_TOURS_REMOVED = 'BONUS_TOURS_REMOVED';
  SET_BONUS_TOURS_AS_ACTIVE = 'SET_BONUS_TOURS_AS_ACTIVE';
  BONUS_TOURS_SET_AS_ACTIVE = 'BONUS_TOURS_SET_AS_ACTIVE';
  UPDATE_BONUS_AMOUNT = 'UPDATE_BONUS_AMOUNT';
  BONUS_AMOUNT_UPDATED = 'BONUS_AMOUNT_UPDATED';
  UPDATE_BONUS_STATUS = 'UPDATE_BONUS_STATUS';
  BONUS_STATUS_UPDATED = 'BONUS_STATUS_UPDATED';
  ADD_BONUS_TO_GROUP = 'ADD_BONUS_TO_GROUP';
  BONUS_ADDED_TO_GROUP = 'BONUS_ADDED_TO_GROUP';
  BONUS_GROUP_COMMENT_EDITED = 'BONUS_GROUP_COMMENT_EDITED';
  BONUS_GROUP_CREATED = 'BONUS_GROUP_CREATED';
  BONUS_GROUP_DELETED = 'BONUS_GROUP_DELETED';
  BONUS_GROUP_INVOICE_DELETED = 'BONUS_GROUP_INVOICE_DELETED';
  BONUS_GROUP_LOG_COMMENT_EDITED = 'BONUS_GROUP_LOG_COMMENT_EDITED';
  BONUS_GROUP_STATUS_UPDATED = 'BONUS_GROUP_STATUS_UPDATED';
  CREATE_BONUS_GROUP_INCIDENT = 'CREATE_BONUS_GROUP_INCIDENT';
  BONUS_GROUP_INCIDENT_CREATED = 'BONUS_GROUP_INCIDENT_CREATED';
  CREATE_BONUS_GROUP_INVOICE = 'CREATE_BONUS_GROUP_INVOICE';
  BONUS_GROUP_INVOICE_CREATED = 'BONUS_GROUP_INVOICE_CREATED';
  DEDUCE_BONUS_GROUP = 'DEDUCE_BONUS_GROUP';
  DELETE_BONUS_GROUP = 'DELETE_BONUS_GROUP';
  DELETE_BONUS_GROUPS = 'DELETE_BONUS_GROUPS';
  EDIT_BONUS_GROUP_COMMENT = 'EDIT_BONUS_GROUP_COMMENT';
  EDIT_BONUS_GROUP_LOG_COMMENT = 'EDIT_BONUS_GROUP_LOG_COMMENT';
  LOG_BONUS_GROUP = 'LOG_BONUS_GROUP';
  PAY_BONUS_GROUP = 'PAY_BONUS_GROUP';
  PUBLISH_BONUS_GROUP = 'PUBLISH_BONUS_GROUP';
  REJECT_BONUS_GROUP = 'REJECT_BONUS_GROUP';
  REPORT_BONUS_GROUP = 'REPORT_BONUS_GROUP';
  RESOLVE_BONUS_GROUP_INCIDENT = 'RESOLVE_BONUS_GROUP_INCIDENT';
  BONUS_GROUP_INCIDENT_RESOLVED = 'BONUS_GROUP_INCIDENT_RESOLVED';
  UPDATE_BONUS_GROUP_INVOICE = 'UPDATE_BONUS_GROUP_INVOICE';
  BONUS_GROUP_INVOICE_UPDATED = 'BONUS_GROUP_INVOICE_UPDATED';
  UPDATE_BONUS_GROUP_INVOICE_DETAILS = 'UPDATE_BONUS_GROUP_INVOICE_DETAILS';
  BONUS_GROUP_INVOICE_DETAILS_UPDATED = 'BONUS_GROUP_INVOICE_DETAILS_UPDATED';
  VALIDATE_BONUS_GROUP = 'VALIDATE_BONUS_GROUP';
  ADD_BONUS_IN_BONUS_PAYMENT = 'ADD_BONUS_IN_BONUS_PAYMENT';
  ADDED_BONUS_IN_BONUS_PAYMENT = 'ADDED_BONUS_IN_BONUS_PAYMENT';
  CREATE_BONUS_PAYMENT = 'CREATE_BONUS_PAYMENT';
  CREATED_BONUS_PAYMENT_EVENT = 'CREATED_BONUS_PAYMENT_EVENT';
  PAY_BONUS_PAYMENT = 'PAY_BONUS_PAYMENT';
  PAID_BONUS_PAYMENT_EVENT = 'PAID_BONUS_PAYMENT_EVENT';
  EXPORT_BONUS_GROUP_INVOICE = 'EXPORT_BONUS_GROUP_INVOICE';
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    $city$colisactiv$platform$commons.AlertSeverity = AlertSeverity;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.AlertBase = AlertBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.DateIntervalBase = DateIntervalBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.GeoLocationBase = GeoLocationBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.GeoStampBase = GeoStampBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.PageBase = PageBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.PageRequestBase = PageRequestBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$constants = $city$colisactiv$platform$commons.constants || ($city$colisactiv$platform$commons.constants = {});
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_ADMIN', {
      configurable: true,
      get: _get_ROLE_ADMIN__3149651749
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_SUPER_ADMIN', {
      configurable: true,
      get: _get_ROLE_SUPER_ADMIN__3554080777
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_ADMIN', {
      configurable: true,
      get: _get_ROLE_OPERATOR_ADMIN__1787221876
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_USER', {
      configurable: true,
      get: _get_ROLE_OPERATOR_USER__1600582830
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_ADMIN_ONBOARDING', {
      configurable: true,
      get: _get_ROLE_OPERATOR_ADMIN_ONBOARDING__962210510
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_USER_ONBOARDING', {
      configurable: true,
      get: _get_ROLE_OPERATOR_USER_ONBOARDING__1450534228
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_FUNDER_ADMIN', {
      configurable: true,
      get: _get_ROLE_FUNDER_ADMIN__3418638502
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_FUNDER_USER', {
      configurable: true,
      get: _get_ROLE_FUNDER_USER__821925180
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_CARRIER_ADMIN', {
      configurable: true,
      get: _get_ROLE_CARRIER_ADMIN__3637737580
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_CARRIER_USER', {
      configurable: true,
      get: _get_ROLE_CARRIER_USER__2768655542
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_TMS_ADMIN', {
      configurable: true,
      get: _get_ROLE_TMS_ADMIN__3958562570
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_TMS_USER', {
      configurable: true,
      get: _get_ROLE_TMS_USER__3610288728
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_VISITOR_ADMIN', {
      configurable: true,
      get: _get_ROLE_VISITOR_ADMIN__635253302
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_VISITOR_USER', {
      configurable: true,
      get: _get_ROLE_VISITOR_USER__39401900
    });
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$constants = $city$colisactiv$platform$commons.constants || ($city$colisactiv$platform$commons.constants = {});
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_HEATMAP', {
      configurable: true,
      get: _get_ROLE_READ_HEAT_MAP__2334907966
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_FLUX_MAP', {
      configurable: true,
      get: _get_ROLE_READ_FLUX_MAP__1654341093
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_BONUS_TOTAL', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_BONUS_TOTAL__3980768280
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE__961309144
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_DELIVERY_TIME', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_DELIVERY_TIME__1042262468
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES__628138737
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT__3236390426
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_HUB_COUNT', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_HUB_COUNT__3178299799
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE__1081766482
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__2332509822
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_TOUR_AMOUNT', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_TOUR_AMOUNT__144310845
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_DISTANCE_TOTAL', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_DISTANCE_TOTAL__2048129574
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED__1801289601
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_CO2_AVOIDED', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_CO2_AVOIDED__3570012961
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED__3490441090
    });
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$exception = $city$colisactiv$platform$commons.exception || ($city$colisactiv$platform$commons.exception = {});
    $city$colisactiv$platform$commons$exception.NotFoundException = NotFoundException;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$geozone = $city$colisactiv$platform.geozone || ($city$colisactiv$platform.geozone = {});
    var $city$colisactiv$platform$geozone$model = $city$colisactiv$platform$geozone.model || ($city$colisactiv$platform$geozone.model = {});
    $city$colisactiv$platform$geozone$model.GeoZoneBase = GeoZoneBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$geozone = $city$colisactiv$platform.geozone || ($city$colisactiv$platform.geozone = {});
    var $city$colisactiv$platform$geozone$model = $city$colisactiv$platform$geozone.model || ($city$colisactiv$platform$geozone.model = {});
    $city$colisactiv$platform$geozone$model.TerritoryBase = TerritoryBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$geozone = $city$colisactiv$platform.geozone || ($city$colisactiv$platform.geozone = {});
    var $city$colisactiv$platform$geozone$model = $city$colisactiv$platform$geozone.model || ($city$colisactiv$platform$geozone.model = {});
    var $city$colisactiv$platform$geozone$model$features = $city$colisactiv$platform$geozone$model.features || ($city$colisactiv$platform$geozone$model.features = {});
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'ADD_TERRITORY_ZONE', {
      configurable: true,
      get: _get_ADD_TERRITORY_ZONE__3834524956
    });
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'TERRITORY_ZONE_ADDED', {
      configurable: true,
      get: _get_TERRITORY_ZONE_ADDED__2440044185
    });
    $city$colisactiv$platform$geozone$model$features.AddTerritoryZoneCommandBase = AddTerritoryZoneCommandBase;
    $city$colisactiv$platform$geozone$model$features.AddTerritoryZoneCommandDTOBase = AddTerritoryZoneCommandDTOBase;
    $city$colisactiv$platform$geozone$model$features.TerritoryZoneAddedEventBase = TerritoryZoneAddedEventBase;
    $city$colisactiv$platform$geozone$model$features.TerritoryZoneAddedEventDTOBase = TerritoryZoneAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$geozone = $city$colisactiv$platform.geozone || ($city$colisactiv$platform.geozone = {});
    var $city$colisactiv$platform$geozone$model = $city$colisactiv$platform$geozone.model || ($city$colisactiv$platform$geozone.model = {});
    var $city$colisactiv$platform$geozone$model$features = $city$colisactiv$platform$geozone$model.features || ($city$colisactiv$platform$geozone$model.features = {});
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'ARCHIVE_GEOZONE', {
      configurable: true,
      get: _get_ARCHIVE_GEOZONE__2071154769
    });
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'GEOZONE_ARCHIVED', {
      configurable: true,
      get: _get_GEOZONE_ARCHIVED__116494279
    });
    $city$colisactiv$platform$geozone$model$features.ArchiveGeoZoneCommandBase = ArchiveGeoZoneCommandBase;
    $city$colisactiv$platform$geozone$model$features.ArchiveGeoZoneCommandDTOBase = ArchiveGeoZoneCommandDTOBase;
    $city$colisactiv$platform$geozone$model$features.GeoZoneArchivedEventBase = GeoZoneArchivedEventBase;
    $city$colisactiv$platform$geozone$model$features.GeoZoneArchivedEventDTOBase = GeoZoneArchivedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$geozone = $city$colisactiv$platform.geozone || ($city$colisactiv$platform.geozone = {});
    var $city$colisactiv$platform$geozone$model = $city$colisactiv$platform$geozone.model || ($city$colisactiv$platform$geozone.model = {});
    var $city$colisactiv$platform$geozone$model$features = $city$colisactiv$platform$geozone$model.features || ($city$colisactiv$platform$geozone$model.features = {});
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'CREATE_GEOZONE', {
      configurable: true,
      get: _get_CREATE_GEOZONE__992900913
    });
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'GEOZONE_CREATED', {
      configurable: true,
      get: _get_GEOZONE_CREATED__353894891
    });
    $city$colisactiv$platform$geozone$model$features.CreateGeoZoneCommandBase = CreateGeoZoneCommandBase;
    $city$colisactiv$platform$geozone$model$features.CreateGeoZoneCommandDetailsBase = CreateGeoZoneCommandDetailsBase;
    $city$colisactiv$platform$geozone$model$features.GeoZoneCreatedEventBase = GeoZoneCreatedEventBase;
    $city$colisactiv$platform$geozone$model$features.GeoZoneCreatedEventDetailsBase = GeoZoneCreatedEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$geozone = $city$colisactiv$platform.geozone || ($city$colisactiv$platform.geozone = {});
    var $city$colisactiv$platform$geozone$model = $city$colisactiv$platform$geozone.model || ($city$colisactiv$platform$geozone.model = {});
    var $city$colisactiv$platform$geozone$model$features = $city$colisactiv$platform$geozone$model.features || ($city$colisactiv$platform$geozone$model.features = {});
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'CREATE_TERRITORY', {
      configurable: true,
      get: _get_CREATE_TERRITORY__397817140
    });
    Object.defineProperty($city$colisactiv$platform$geozone$model$features, 'TERRITORY_CREATED', {
      configurable: true,
      get: _get_TERRITORY_CREATED__689705006
    });
    $city$colisactiv$platform$geozone$model$features.CreateTerritoryCommandBase = CreateTerritoryCommandBase;
    $city$colisactiv$platform$geozone$model$features.CreateTerritoryCommandDTOBase = CreateTerritoryCommandDTOBase;
    $city$colisactiv$platform$geozone$model$features.TerritoryCreatedEventBase = TerritoryCreatedEventBase;
    $city$colisactiv$platform$geozone$model$features.TerritoryCreatedEventDTOBase = TerritoryCreatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.AddressBase = AddressBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.ConventionBase = ConventionBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.ConventionActions = ConventionActions;
    $city$colisactiv$organization$model.ConventionStateMachine = ConventionStateMachine;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.ConventionStatusBase = ConventionStatusBase;
    $city$colisactiv$organization$model.ConventionStatusValues = ConventionStatusValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.ConventionTypeBase = ConventionTypeBase;
    $city$colisactiv$organization$model.ConventionTypeValues = ConventionTypeValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.EnvelopeBase = EnvelopeBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    Object.defineProperty($city$colisactiv$organization$model, 'ENVELOPE_RECIPIENT_STATUS_SENT', {
      configurable: true,
      get: _get_ENVELOPE_RECIPIENT_STATUS_CREATED__1918709569
    });
    Object.defineProperty($city$colisactiv$organization$model, 'ENVELOPE_RECIPIENT_STATUS_PUBLISHED', {
      configurable: true,
      get: _get_ENVELOPE_RECIPIENT_STATUS_PUBLISHED__1889100347
    });
    Object.defineProperty($city$colisactiv$organization$model, 'ENVELOPE_RECIPIENT_STATUS_APPROVED', {
      configurable: true,
      get: _get_ENVELOPE_RECIPIENT_STATUS_APPROVED__1134934268
    });
    Object.defineProperty($city$colisactiv$organization$model, 'ENVELOPE_RECIPIENT_STATUS_COMPLETED', {
      configurable: true,
      get: _get_ENVELOPE_RECIPIENT_STATUS_COMPLETED__3723008382
    });
    Object.defineProperty($city$colisactiv$organization$model, 'ENVELOPE_RECIPIENT_STATUS_DECLINED', {
      configurable: true,
      get: _get_ENVELOPE_RECIPIENT_STATUS_DECLINED__3481260645
    });
    Object.defineProperty($city$colisactiv$organization$model, 'ENVELOPE_RECIPIENT_STATUS_VOIDED', {
      configurable: true,
      get: _get_ENVELOPE_RECIPIENT_STATUS_VOIDED__1740686144
    });
    $city$colisactiv$organization$model.EnvelopeRecipientStatusBase = EnvelopeRecipientStatusBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.ExportAuthorizationBase = ExportAuthorizationBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.HubBase = HubBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.HubType = HubType;
    $city$colisactiv$organization$model.HubType.values = values;
    $city$colisactiv$organization$model.HubType.valueOf = valueOf;
    Object.defineProperty($city$colisactiv$organization$model.HubType, 'OPERATOR_ACTIVE_HUB', {
      configurable: true,
      get: HubType_OPERATOR_ACTIVE_HUB_getInstance
    });
    Object.defineProperty($city$colisactiv$organization$model.HubType, 'OPERATOR_INACTIVE_HUB', {
      configurable: true,
      get: HubType_OPERATOR_INACTIVE_HUB_getInstance
    });
    Object.defineProperty($city$colisactiv$organization$model.HubType, 'CARRIER_ACTIVE_HUB', {
      configurable: true,
      get: HubType_CARRIER_ACTIVE_HUB_getInstance
    });
    Object.defineProperty($city$colisactiv$organization$model.HubType, 'CARRIER_INACTIVE_HUB', {
      configurable: true,
      get: HubType_CARRIER_INACTIVE_HUB_getInstance
    });
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.OrganizationBase = OrganizationBase;
    $city$colisactiv$organization$model.OrganizationDetailsBase = OrganizationDetailsBase;
    $city$colisactiv$organization$model.ApplicationBase = ApplicationBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.OrganizationAction = OrganizationAction;
    $city$colisactiv$organization$model.OrganizationStateMachine = OrganizationStateMachine;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.OrganizationStatusBase = OrganizationStatusBase;
    $city$colisactiv$organization$model.OrganizationStatusValues = OrganizationStatusValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.OrganizationTypeValues = OrganizationTypeValues;
    $city$colisactiv$organization$model.OrganizationTypeBase = OrganizationTypeBase;
    $city$colisactiv$organization$model.ManagerType = ManagerType;
    $city$colisactiv$organization$model.OperatorType = OperatorType;
    $city$colisactiv$organization$model.FunderType = FunderType;
    $city$colisactiv$organization$model.FunderCeeType = FunderCeeType;
    $city$colisactiv$organization$model.CarrierType = CarrierType;
    $city$colisactiv$organization$model.TmsType = TmsType;
    $city$colisactiv$organization$model.VisitorType = VisitorType;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.PackageTypeValues = PackageTypeValues;
    $city$colisactiv$organization$model.PackageTypeBase = PackageTypeBase;
    $city$colisactiv$organization$model.FoodPackageType = FoodPackageType;
    $city$colisactiv$organization$model.NonFoodPackageType = NonFoodPackageType;
    $city$colisactiv$organization$model.WastePackageType = WastePackageType;
    $city$colisactiv$organization$model.MixFoodPackageType = MixFoodPackageType;
    $city$colisactiv$organization$model.MixNonFoodPackageType = MixNonFoodPackageType;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.PaymentDetailsBase = PaymentDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    $city$colisactiv$organization$model.VisitorAuthorizationBase = VisitorAuthorizationBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'ADD_APPLICATION_PROPERTIES', {
      configurable: true,
      get: _get_ADD_APPLICATION_PROPERTIES__684736875
    });
    Object.defineProperty($city$colisactiv$organization$model$features, 'APPLICATION_PROPERTIES_ADDED', {
      configurable: true,
      get: _get_APPLICATION_PROPERTIES_ADDED__2391332264
    });
    $city$colisactiv$organization$model$features.AddApplicationPropertiesBase = AddApplicationPropertiesBase;
    $city$colisactiv$organization$model$features.AddApplicationPropertiesDTOBase = AddApplicationPropertiesDTOBase;
    $city$colisactiv$organization$model$features.ApplicationPropertiesAddedEventBase = ApplicationPropertiesAddedEventBase;
    $city$colisactiv$organization$model$features.ApplicationPropertiesAddedEventDTOBase = ApplicationPropertiesAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'ADD_HUB', {
      configurable: true,
      get: _get_ADD_HUB__1702019546
    });
    $city$colisactiv$organization$model$features.AddHubCommandBase = AddHubCommandBase;
    $city$colisactiv$organization$model$features.AddHubCommandDTOBase = AddHubCommandDTOBase;
    $city$colisactiv$organization$model$features.HubAddedEventBase = HubAddedEventBase;
    $city$colisactiv$organization$model$features.HubAddedEventDTOBase = HubAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'USER_CHANGE_PASSWORD', {
      configurable: true,
      get: _get_USER_CHANGE_PASSWORD__2583171381
    });
    $city$colisactiv$organization$model$features.ChangeUserPasswordCommandBase = ChangeUserPasswordCommandBase;
    $city$colisactiv$organization$model$features.ChangeUserPasswordCommandDTOBase = ChangeUserPasswordCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'USER_CHANGED_PASSWORD', {
      configurable: true,
      get: _get_USER_CHANGED_PASSWORD__2634180407
    });
    $city$colisactiv$organization$model$features.UserChangedPasswordEventDTOBase = UserChangedPasswordEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'CREATE_CLIENT', {
      configurable: true,
      get: _get_CREATE_CLIENT__2356691491
    });
    $city$colisactiv$organization$model$features.CreateApplicationCommandBase = CreateApplicationCommandBase;
    $city$colisactiv$organization$model$features.CreateApplicationCommandDTOBase = CreateApplicationCommandDTOBase;
    $city$colisactiv$organization$model$features.ApplicationCreatedEventBase = ApplicationCreatedEventBase;
    $city$colisactiv$organization$model$features.ApplicationEventDetailsBase = ApplicationEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'CREATE_ORGANIZATION', {
      configurable: true,
      get: _get_CREATE_ORGANIZATION__281445819
    });
    $city$colisactiv$organization$model$features.CreateOrganizationCommandBase = CreateOrganizationCommandBase;
    $city$colisactiv$organization$model$features.CreateOrganizationCommandDTOBase = CreateOrganizationCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'CREATED_ORGANIZATION_EVENT', {
      configurable: true,
      get: _get_CREATED_ORGANIZATION_EVENT__1975633894
    });
    $city$colisactiv$organization$model$features.OrganizationCreatedEventBase = OrganizationCreatedEventBase;
    $city$colisactiv$organization$model$features.OrganizationEventDetailsBase = OrganizationEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'UPLOAD_SIMPLIFIED_CONVENTION', {
      configurable: true,
      get: _get_UPLOAD_SIMPLIFIED_CONVENTION__4273269649
    });
    $city$colisactiv$organization$model$features.UploadSimplifiedConventionCommandBase = UploadSimplifiedConventionCommandBase;
    $city$colisactiv$organization$model$features.UploadSimplifiedConventionCommandDTOBase = UploadSimplifiedConventionCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'UPLOADED_SIMPLIFIED_CONVENTION_EVENT', {
      configurable: true,
      get: _get_UPLOADED_SIMPLIFIED_CONVENTION_EVENT__2878814199
    });
    $city$colisactiv$organization$model$features.SimplifiedConventionUploadedEventBase = SimplifiedConventionUploadedEventBase;
    $city$colisactiv$organization$model$features.SimplifiedConventionUploadedEventDTOBase = SimplifiedConventionUploadedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'DELETE_ORGANIZATION', {
      configurable: true,
      get: _get_DELETE_ORGANIZATION__694553642
    });
    $city$colisactiv$organization$model$features.DeleteOrganizationCommandBase = DeleteOrganizationCommandBase;
    $city$colisactiv$organization$model$features.DeleteOrganizationDTOBase = DeleteOrganizationDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'DELETED_ORGANIZATION_EVENT', {
      configurable: true,
      get: _get_DELETED_ORGANIZATION_EVENT__610399895
    });
    $city$colisactiv$organization$model$features.DeletedOrganizationEventBase = DeletedOrganizationEventBase;
    $city$colisactiv$organization$model$features.DeletedOrganizationDTOBase = DeletedOrganizationDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'DELETE_USER', {
      configurable: true,
      get: _get_DELETE_USER__177078162
    });
    $city$colisactiv$organization$model$features.DeleteUserCommandBase = DeleteUserCommandBase;
    $city$colisactiv$organization$model$features.DeleteUserDTOBase = DeleteUserDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'DELETED_USER_EVENT', {
      configurable: true,
      get: _get_DELETED_USER_EVENT__1409663999
    });
    $city$colisactiv$organization$model$features.DeletedUserEventBase = DeletedUserEventBase;
    $city$colisactiv$organization$model$features.DeletedUserDTOBase = DeletedUserDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'DISABLE_ORGANIZATION', {
      configurable: true,
      get: _get_DISABLE_ORGANIZATION__1420290113
    });
    $city$colisactiv$organization$model$features.DisableOrganizationCommandBase = DisableOrganizationCommandBase;
    $city$colisactiv$organization$model$features.DisableOrganizationDTOBase = DisableOrganizationDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'DISABLED_ORGANIZATION_EVENT', {
      configurable: true,
      get: _get_DISABLED_ORGANIZATION_EVENT__3586892448
    });
    $city$colisactiv$organization$model$features.DisabledOrganizationEventBase = DisabledOrganizationEventBase;
    $city$colisactiv$organization$model$features.DisabledOrganizationDTOBase = DisabledOrganizationDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'DISABLE_USER', {
      configurable: true,
      get: _get_DISABLE_USER__3275547305
    });
    $city$colisactiv$organization$model$features.DisableUserCommandBase = DisableUserCommandBase;
    $city$colisactiv$organization$model$features.DisableUserDTOBase = DisableUserDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'DISABLED_USER_EVENT', {
      configurable: true,
      get: _get_DISABLED_USER_EVENT__463243528
    });
    $city$colisactiv$organization$model$features.DisabledUserEventBase = DisabledUserEventBase;
    $city$colisactiv$organization$model$features.DisabledUserDTOBase = DisabledUserDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'ENABLE_USER', {
      configurable: true,
      get: _get_ENABLE_USER__3544931690
    });
    $city$colisactiv$organization$model$features.EnableUserCommandBase = EnableUserCommandBase;
    $city$colisactiv$organization$model$features.EnableUserDTOBase = EnableUserDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'ENABLED_USER_EVENT', {
      configurable: true,
      get: _get_ENABLED_USER_EVENT__536060711
    });
    $city$colisactiv$organization$model$features.EnabledUserEventBase = EnabledUserEventBase;
    $city$colisactiv$organization$model$features.EnabledUserDTOBase = EnabledUserDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    $city$colisactiv$organization$model$features.ExportAuthorizationUpdateCommandBase = ExportAuthorizationUpdateCommandBase;
    $city$colisactiv$organization$model$features.ExportAuthorizationUpdatedEventBase = ExportAuthorizationUpdatedEventBase;
    $city$colisactiv$organization$model$features.ExportAuthorizationUpdatedEventDTOBase = ExportAuthorizationUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'EXPORT_DOLIBARR_ORGANIZATIONS', {
      configurable: true,
      get: _get_EXPORT_DOLIBARR_ORGANIZATIONS__858079998
    });
    $city$colisactiv$organization$model$features.ExportDolibarrOrganizationsQueryBase = ExportDolibarrOrganizationsQueryBase;
    $city$colisactiv$organization$model$features.ExportDolibarrOrganizationsQueryDTOBase = ExportDolibarrOrganizationsQueryDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'EXPORT_ORGANIZATIONS', {
      configurable: true,
      get: _get_EXPORT_ORGANIZATIONS__3146513078
    });
    $city$colisactiv$organization$model$features.ExportOrganizationsQueryBase = ExportOrganizationsQueryBase;
    $city$colisactiv$organization$model$features.ExportOrganizationsQueryDTOBase = ExportOrganizationsQueryDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'HUB_ACTIVATION_TOGGLE', {
      configurable: true,
      get: _get_HUB_ACTIVATION_TOGGLE__3035746942
    });
    $city$colisactiv$organization$model$features.HubActivationToggleCommandBase = HubActivationToggleCommandBase;
    $city$colisactiv$organization$model$features.HubActivationToggleCommandDTOBase = HubActivationToggleCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'HUB_ACTIVATION_TOGGLED_EVENT', {
      configurable: true,
      get: _get_HUB_ACTIVATION_TOGGLED_EVENT__1826874143
    });
    $city$colisactiv$organization$model$features.HubActivationToggledEventBase = HubActivationToggledEventBase;
    $city$colisactiv$organization$model$features.HubActivationToggledEventDTOBase = HubActivationToggledEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'LOGO_CREATE', {
      configurable: true,
      get: _get_LOGO_CREATE__336547201
    });
    $city$colisactiv$organization$model$features.LogoCreatedCommandDetailsBase = LogoCreatedCommandDetailsBase;
    $city$colisactiv$organization$model$features.LogoCreatedCommandBase = LogoCreatedCommandBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'LOGO_CREATED_EVENT', {
      configurable: true,
      get: _get_LOGO_CREATED_EVENT__2874773180
    });
    $city$colisactiv$organization$model$features.LogoCreatedEventDetailsBase = LogoCreatedEventDetailsBase;
    $city$colisactiv$organization$model$features.LogoCreatedEventBase = LogoCreatedEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'USER_ADD', {
      configurable: true,
      get: _get_USER_ADD__341970782
    });
    $city$colisactiv$organization$model$features.OrganizationAddUserCommandBase = OrganizationAddUserCommandBase;
    $city$colisactiv$organization$model$features.OrganizationAddUserCommandDTOBase = OrganizationAddUserCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'USER_ADDED_EVENT', {
      configurable: true,
      get: _get_USER_ADDED_EVENT__3351091140
    });
    $city$colisactiv$organization$model$features.UserAddedEventBase = UserAddedEventBase;
    $city$colisactiv$organization$model$features.UserEventDetailsBase = UserEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'USER_UPDATE', {
      configurable: true,
      get: _get_USER_UPDATE__903066996
    });
    $city$colisactiv$organization$model$features.OrganizationUpdateUserDetailsCommandBase = OrganizationUpdateUserDetailsCommandBase;
    $city$colisactiv$organization$model$features.OrganizationUpdateUserDetailsCommandDTOBase = OrganizationUpdateUserDetailsCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'USER_UPDATED_EVENT', {
      configurable: true,
      get: _get_USER_UPDATED_EVENT__4175486825
    });
    $city$colisactiv$organization$model$features.UserUpdatedEventBase = UserUpdatedEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'UPDATE_ORGANIZATION', {
      configurable: true,
      get: _get_UPDATE_ORGANIZATION__4198560456
    });
    $city$colisactiv$organization$model$features.OrganizationUpdateCommandBase = OrganizationUpdateCommandBase;
    $city$colisactiv$organization$model$features.UpdateOrganizationCommandDTOBase = UpdateOrganizationCommandDTOBase;
    $city$colisactiv$organization$model$features.OrganizationUpdatedEventBase = OrganizationUpdatedEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'REMOVE_HUB', {
      configurable: true,
      get: _get_REMOVE_HUB__2314545
    });
    $city$colisactiv$organization$model$features.RemoveHubCommandBase = RemoveHubCommandBase;
    $city$colisactiv$organization$model$features.RemoveHubDTOBase = RemoveHubDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'HUB_REMOVED_EVENT', {
      configurable: true,
      get: _get_HUB_REMOVED_EVENT__3386574240
    });
    $city$colisactiv$organization$model$features.HubRemovedEventBase = HubRemovedEventBase;
    $city$colisactiv$organization$model$features.HubRemovedEventDTOBase = HubRemovedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'SET_ORGANIZATION_RSA_KEYPAIR', {
      configurable: true,
      get: _get_SET_ORGANIZATION_RSA_KEYPAIR__1563051488
    });
    Object.defineProperty($city$colisactiv$organization$model$features, 'ORGANIZATION_RSA_KEYPAIR_SET', {
      configurable: true,
      get: _get_ORGANIZATION_RSA_KEYPAIR_SET__1323295610
    });
    $city$colisactiv$organization$model$features.SetOrganizationRsaKeypairCommandBase = SetOrganizationRsaKeypairCommandBase;
    $city$colisactiv$organization$model$features.SetOrganizationRsaKeypairCommandDTOBase = SetOrganizationRsaKeypairCommandDTOBase;
    $city$colisactiv$organization$model$features.OrganizationRsaKeypairSetEventBase = OrganizationRsaKeypairSetEventBase;
    $city$colisactiv$organization$model$features.OrganizationRsaKeypairSetEventDTOBase = OrganizationRsaKeypairSetEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'UPDATE_HUB_ACTIVITY_END_DATE', {
      configurable: true,
      get: _get_UPDATE_HUB_ACTIVITY_END_DATE__2746941321
    });
    $city$colisactiv$organization$model$features.UpdateHubActivityEndDateCommandBase = UpdateHubActivityEndDateCommandBase;
    $city$colisactiv$organization$model$features.UpdateHubActivityEndDateCommandDTOBase = UpdateHubActivityEndDateCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'HUB_ACTIVITY_END_DATE_UPDATED_EVENT', {
      configurable: true,
      get: _get_HUB_ACTIVITY_END_DATE_UPDATED_EVENT__794257826
    });
    $city$colisactiv$organization$model$features.HubActivityEndDateUpdatedEventBase = HubActivityEndDateUpdatedEventBase;
    $city$colisactiv$organization$model$features.HubActivityEndDateUpdatedEventDTOBase = HubActivityEndDateUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'UPDATE_HUB_COMMENT', {
      configurable: true,
      get: _get_UPDATE_HUB_COMMENT__1485161740
    });
    $city$colisactiv$organization$model$features.UpdateHubCommentCommandBase = UpdateHubCommentCommandBase;
    $city$colisactiv$organization$model$features.UpdateHubCommentCommandDTOBase = UpdateHubCommentCommandDTOBase;
    Object.defineProperty($city$colisactiv$organization$model$features, 'HUB_COMMENT_UPDATED_EVENT', {
      configurable: true,
      get: _get_HUB_COMMENT_UPDATED_EVENT__1396077029
    });
    $city$colisactiv$organization$model$features.HubCommentUpdatedEventBase = HubCommentUpdatedEventBase;
    $city$colisactiv$organization$model$features.HubCommentUpdatedEventDTOBase = HubCommentUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    $city$colisactiv$organization$model$features.UploadPaymentInfoCommandBase = UploadPaymentInfoCommandBase;
    $city$colisactiv$organization$model$features.UploadedPaymentInfoEventBase = UploadedPaymentInfoEventBase;
    $city$colisactiv$organization$model$features.UploadedPaymentInfoEventDetailsBase = UploadedPaymentInfoEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    $city$colisactiv$organization$model$features.VisitorAuthorizationUpdateCommandBase = VisitorAuthorizationUpdateCommandBase;
    $city$colisactiv$organization$model$features.VisitorAuthorizationUpdateCommandDTOBase = VisitorAuthorizationUpdateCommandDTOBase;
    $city$colisactiv$organization$model$features.VisitorAuthorizationUpdatedEventBase = VisitorAuthorizationUpdatedEventBase;
    $city$colisactiv$organization$model$features.VisitorAuthorizationUpdatedEventDTOBase = VisitorAuthorizationUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    var $city$colisactiv$organization$model$features$convention = $city$colisactiv$organization$model$features.convention || ($city$colisactiv$organization$model$features.convention = {});
    Object.defineProperty($city$colisactiv$organization$model$features$convention, 'CONVENTION_PREFILLED', {
      configurable: true,
      get: _get_CONVENTION_PREFILLED__623529172
    });
    $city$colisactiv$organization$model$features$convention.ConventionPrefilledEventBase = ConventionPrefilledEventBase;
    $city$colisactiv$organization$model$features$convention.ConventionPrefilledEventDTOBase = ConventionPrefilledEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    var $city$colisactiv$organization$model$features$convention = $city$colisactiv$organization$model$features.convention || ($city$colisactiv$organization$model$features.convention = {});
    Object.defineProperty($city$colisactiv$organization$model$features$convention, 'CONVENTION_RESETED_EVENT', {
      configurable: true,
      get: _get_CONVENTION_RESETED_EVENT__3447678064
    });
    $city$colisactiv$organization$model$features$convention.ConventionResetedEventBase = ConventionResetedEventBase;
    $city$colisactiv$organization$model$features$convention.ConventionResetedEventDTOBase = ConventionResetedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    var $city$colisactiv$organization$model$features$convention = $city$colisactiv$organization$model$features.convention || ($city$colisactiv$organization$model$features.convention = {});
    Object.defineProperty($city$colisactiv$organization$model$features$convention, 'CREATE_CONVENTION', {
      configurable: true,
      get: _get_CREATE_CONVENTION__4154339133
    });
    $city$colisactiv$organization$model$features$convention.CreateConventionCommandBase = CreateConventionCommandBase;
    $city$colisactiv$organization$model$features$convention.CreateConventionCommandDTOBase = CreateConventionCommandDTOBase;
    $city$colisactiv$organization$model$features$convention.ConventionCreatedEventBase = ConventionCreatedEventBase;
    $city$colisactiv$organization$model$features$convention.ConventionEventDetailsBase = ConventionEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    var $city$colisactiv$organization$model$features$convention = $city$colisactiv$organization$model$features.convention || ($city$colisactiv$organization$model$features.convention = {});
    Object.defineProperty($city$colisactiv$organization$model$features$convention, 'FINALIZED_CONVENTION', {
      configurable: true,
      get: _get_FINALIZED_CONVENTION__2357012513
    });
    $city$colisactiv$organization$model$features$convention.FinalizedConventionCommandBase = FinalizedConventionCommandBase;
    $city$colisactiv$organization$model$features$convention.FinalizedConventionCommandDTOBase = FinalizedConventionCommandDTOBase;
    $city$colisactiv$organization$model$features$convention.ConventionFinalizedEventBase = ConventionFinalizedEventBase;
    $city$colisactiv$organization$model$features$convention.ConventionFinalizedEventDTOBase = ConventionFinalizedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    var $city$colisactiv$organization$model$features$convention = $city$colisactiv$organization$model$features.convention || ($city$colisactiv$organization$model$features.convention = {});
    Object.defineProperty($city$colisactiv$organization$model$features$convention, 'PREPARE_SIGN_CONVENTION', {
      configurable: true,
      get: _get_PREPARE_SIGN_CONVENTION__3123269782
    });
    $city$colisactiv$organization$model$features$convention.PrepareSignConventionCommandBase = PrepareSignConventionCommandBase;
    $city$colisactiv$organization$model$features$convention.PrepareSignConventionCommandDTOBase = PrepareSignConventionCommandDTOBase;
    $city$colisactiv$organization$model$features$convention.ConventionSignPreparedEventBase = ConventionSignPreparedEventBase;
    $city$colisactiv$organization$model$features$convention.ConventionSignPreparedEventDTOBase = ConventionSignPreparedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    var $city$colisactiv$organization$model$features$convention = $city$colisactiv$organization$model$features.convention || ($city$colisactiv$organization$model$features.convention = {});
    Object.defineProperty($city$colisactiv$organization$model$features$convention, 'SIGNED_CONVENTION', {
      configurable: true,
      get: _get_SIGNED_CONVENTION__2475281757
    });
    $city$colisactiv$organization$model$features$convention.SignedConventionCommandBase = SignedConventionCommandBase;
    $city$colisactiv$organization$model$features$convention.SignedConventionCommandDTOBase = SignedConventionCommandDTOBase;
    $city$colisactiv$organization$model$features$convention.ConventionSignedEventBase = ConventionSignedEventBase;
    $city$colisactiv$organization$model$features$convention.ConventionSignedEventDTOBase = ConventionSignedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$features = $city$colisactiv$organization$model.features || ($city$colisactiv$organization$model.features = {});
    Object.defineProperty($city$colisactiv$organization$model$features, 'UPDATE_SECRET', {
      configurable: true,
      get: _get_UPDATE_SECRET__3413884587
    });
    $city$colisactiv$organization$model$features.UpdateApplicationSecretCommandBase = UpdateApplicationSecretCommandBase;
    $city$colisactiv$organization$model$features.UpdateApplicationSecretCommandDTOBase = UpdateApplicationSecretCommandDTOBase;
    $city$colisactiv$organization$model$features.ApplicationSecretUpdatedEventBase = ApplicationSecretUpdatedEventBase;
    $city$colisactiv$organization$model$features.ApplicationSecretEventDetailsBase = ApplicationSecretEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$logo = $city$colisactiv$organization$model.logo || ($city$colisactiv$organization$model.logo = {});
    $city$colisactiv$organization$model$logo.LogoBase = LogoBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$logo = $city$colisactiv$organization$model.logo || ($city$colisactiv$organization$model.logo = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$logo = $city$colisactiv$organization$model.logo || ($city$colisactiv$organization$model.logo = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$simplifiedConvention = $city$colisactiv$organization$model.simplifiedConvention || ($city$colisactiv$organization$model.simplifiedConvention = {});
    $city$colisactiv$organization$model$simplifiedConvention.SimplifiedConventionBase = SimplifiedConventionBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$simplifiedConvention = $city$colisactiv$organization$model.simplifiedConvention || ($city$colisactiv$organization$model.simplifiedConvention = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$user = $city$colisactiv$organization$model.user || ($city$colisactiv$organization$model.user = {});
    Object.defineProperty($city$colisactiv$organization$model$user, 'UserCreatedStatus', {
      configurable: true,
      get: _get_UserCreatedStatus__2559825506
    });
    Object.defineProperty($city$colisactiv$organization$model$user, 'UserEnabledStatus', {
      configurable: true,
      get: _get_UserEnabledStatus__1981146089
    });
    Object.defineProperty($city$colisactiv$organization$model$user, 'UserDisabledStatus', {
      configurable: true,
      get: _get_UserDisabledStatus__3958956114
    });
    $city$colisactiv$organization$model$user.UserBase = UserBase;
    $city$colisactiv$organization$model$user.UserDetailsBase = UserDetailsBase;
    $city$colisactiv$organization$model$user.UserStatusBase = UserStatusBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$user = $city$colisactiv$organization$model.user || ($city$colisactiv$organization$model.user = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$user = $city$colisactiv$organization$model.user || ($city$colisactiv$organization$model.user = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$user = $city$colisactiv$organization$model.user || ($city$colisactiv$organization$model.user = {});
    $city$colisactiv$organization$model$user.UserRoleBase = UserRoleBase;
    $city$colisactiv$organization$model$user.AdminRole = AdminRole;
    $city$colisactiv$organization$model$user.SuperAdminRole = SuperAdminRole;
    $city$colisactiv$organization$model$user.OperatorAdminRole = OperatorAdminRole;
    $city$colisactiv$organization$model$user.OperatorUserRole = OperatorUserRole;
    $city$colisactiv$organization$model$user.OperatorAdminOnboardingRole = OperatorAdminOnboardingRole;
    $city$colisactiv$organization$model$user.OperatorUserOnboardingRole = OperatorUserOnboardingRole;
    $city$colisactiv$organization$model$user.FunderAdminRole = FunderAdminRole;
    $city$colisactiv$organization$model$user.FunderUserRole = FunderUserRole;
    $city$colisactiv$organization$model$user.CarrierAdminRole = CarrierAdminRole;
    $city$colisactiv$organization$model$user.CarrierUserRole = CarrierUserRole;
    $city$colisactiv$organization$model$user.TmsAdminRole = TmsAdminRole;
    $city$colisactiv$organization$model$user.TmsUserRole = TmsUserRole;
    $city$colisactiv$organization$model$user.VisitorAdminRole = VisitorAdminRole;
    $city$colisactiv$organization$model$user.VisitorUserRole = VisitorUserRole;
    $city$colisactiv$organization$model$user.UserRoleValues = UserRoleValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$organization = $city$colisactiv.organization || ($city$colisactiv.organization = {});
    var $city$colisactiv$organization$model = $city$colisactiv$organization.model || ($city$colisactiv$organization.model = {});
    var $city$colisactiv$organization$model$user = $city$colisactiv$organization$model.user || ($city$colisactiv$organization$model.user = {});
    $city$colisactiv$organization$model$user.VisitorRoleBase = VisitorRoleBase;
    $city$colisactiv$organization$model$user.ReadHeatMap = ReadHeatMap;
    $city$colisactiv$organization$model$user.ReadFluxMap = ReadFluxMap;
    $city$colisactiv$organization$model$user.ReadDashboardBonusTotal = ReadDashboardBonusTotal;
    $city$colisactiv$organization$model$user.ReadDashboardBonusPerPackage = ReadDashboardBonusPerPackage;
    $city$colisactiv$organization$model$user.ReadDashboardDeliveryTime = ReadDashboardDeliveryTime;
    $city$colisactiv$organization$model$user.ReadDashboardActiveDeliveries = ReadDashboardActiveDeliveries;
    $city$colisactiv$organization$model$user.ReadDashboardActivePackCount = ReadDashboardActivePackCount;
    $city$colisactiv$organization$model$user.ReadDashboardHubCount = ReadDashboardHubCount;
    $city$colisactiv$organization$model$user.ReadDashboardAverageApproachDistance = ReadDashboardAverageApproachDistance;
    $city$colisactiv$organization$model$user.ReadDashboardAverageDistancePerDelivery = ReadDashboardAverageDistancePerDelivery;
    $city$colisactiv$organization$model$user.ReadDashboardTourAmount = ReadDashboardTourAmount;
    $city$colisactiv$organization$model$user.ReadDashboardDistanceTotal = ReadDashboardDistanceTotal;
    $city$colisactiv$organization$model$user.ReadDashboardThermalKmAvoided = ReadDashboardThermalKmAvoided;
    $city$colisactiv$organization$model$user.ReadDashboardCo2Avoided = ReadDashboardCo2Avoided;
    $city$colisactiv$organization$model$user.ReadDashboardNoxPpmAvoided = ReadDashboardNoxPpmAvoided;
    $city$colisactiv$organization$model$user.VisitorRoleValues = VisitorRoleValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    $city$colisactiv$project$model.BonusPriceBase = BonusPriceBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    $city$colisactiv$project$model.CampaignBase = CampaignBase;
    $city$colisactiv$project$model.CampaignDetailsBase = CampaignDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    $city$colisactiv$project$model.CampaignFunderBase = CampaignFunderBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    Object.defineProperty($city$colisactiv$project$model, 'CAMPAIGN_STATUS_CREATED', {
      configurable: true,
      get: _get_CAMPAIGN_STATUS_CREATED__1335265223
    });
    Object.defineProperty($city$colisactiv$project$model, 'CAMPAIGN_STATUS_PUBLISHED', {
      configurable: true,
      get: _get_CAMPAIGN_STATUS_PUBLISHED__3839799617
    });
    Object.defineProperty($city$colisactiv$project$model, 'CAMPAIGN_STATUS_STARTED', {
      configurable: true,
      get: _get_CAMPAIGN_STATUS_STARTED__831650126
    });
    Object.defineProperty($city$colisactiv$project$model, 'CAMPAIGN_STATUS_PAUSED', {
      configurable: true,
      get: _get_CAMPAIGN_STATUS_PAUSED__3904762207
    });
    Object.defineProperty($city$colisactiv$project$model, 'CAMPAIGN_STATUS_DONE', {
      configurable: true,
      get: _get_CAMPAIGN_STATUS_DONE__333055307
    });
    Object.defineProperty($city$colisactiv$project$model, 'CAMPAIGN_STATUS_ARCHIVED', {
      configurable: true,
      get: _get_CAMPAIGN_STATUS_ARCHIVED__474203499
    });
    $city$colisactiv$project$model.CampaignStatusBase = CampaignStatusBase;
    $city$colisactiv$project$model.CampaignStatusValues = CampaignStatusValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    $city$colisactiv$project$model.ProjectBase = ProjectBase;
    $city$colisactiv$project$model.ProjectDetailsBase = ProjectDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    $city$colisactiv$project$model.ProjectFunderBase = ProjectFunderBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    Object.defineProperty($city$colisactiv$project$model, 'PROJECT_STATUS_CREATED', {
      configurable: true,
      get: _get_PROJECT_STATUS_CREATED__848325546
    });
    Object.defineProperty($city$colisactiv$project$model, 'PROJECT_STATUS_STARTED', {
      configurable: true,
      get: _get_PROJECT_STATUS_STARTED__344710449
    });
    Object.defineProperty($city$colisactiv$project$model, 'PROJECT_STATUS_DONE', {
      configurable: true,
      get: _get_PROJECT_STATUS_DONE__1334731848
    });
    Object.defineProperty($city$colisactiv$project$model, 'PROJECT_STATUS_ARCHIVED', {
      configurable: true,
      get: _get_PROJECT_STATUS_ARCHIVED__2558942696
    });
    $city$colisactiv$project$model.ProjectStatusBase = ProjectStatusBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.AddCampaignCommandBase = AddCampaignCommandBase;
    $city$colisactiv$project$model$features.AddCampaignDTOBase = AddCampaignDTOBase;
    $city$colisactiv$project$model$features.AddedCampaignEventBase = AddedCampaignEventBase;
    $city$colisactiv$project$model$features.AddedCampaignEventDTOBase = AddedCampaignEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.AddFunderDetailsBase = AddFunderDetailsBase;
    $city$colisactiv$project$model$features.AddFunderCommandBase = AddFunderCommandBase;
    $city$colisactiv$project$model$features.AddedFunderEventBase = AddedFunderEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.ArchiveCampaignDTOBase = ArchiveCampaignDTOBase;
    $city$colisactiv$project$model$features.ArchiveCampaignCommandBase = ArchiveCampaignCommandBase;
    $city$colisactiv$project$model$features.ArchivedCampaignEventDTOBase = ArchivedCampaignEventDTOBase;
    $city$colisactiv$project$model$features.ArchivedCampaignEventBase = ArchivedCampaignEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    Object.defineProperty($city$colisactiv$project$model$features, 'CREATE_PROJECT', {
      configurable: true,
      get: _get_CREATE_PROJECT__2430853653
    });
    $city$colisactiv$project$model$features.CreateProjectCommandBase = CreateProjectCommandBase;
    $city$colisactiv$project$model$features.CreateProjectCommandDTOBase = CreateProjectCommandDTOBase;
    Object.defineProperty($city$colisactiv$project$model$features, 'CREATED_PROJECT_EVENT', {
      configurable: true,
      get: _get_CREATED_PROJECT_EVENT__846514420
    });
    $city$colisactiv$project$model$features.ProjectCreatedEventBase = ProjectCreatedEventBase;
    $city$colisactiv$project$model$features.ProjectEventDetailsBase = ProjectEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.DuplicateCampaignCommandBase = DuplicateCampaignCommandBase;
    $city$colisactiv$project$model$features.DuplicateCampaignDTOBase = DuplicateCampaignDTOBase;
    $city$colisactiv$project$model$features.DuplicatedCampaignEventBase = DuplicatedCampaignEventBase;
    $city$colisactiv$project$model$features.DuplicatedCampaignEventDTOBase = DuplicatedCampaignEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.FinishCampaignDTOBase = FinishCampaignDTOBase;
    $city$colisactiv$project$model$features.FinishCampaignCommandBase = FinishCampaignCommandBase;
    $city$colisactiv$project$model$features.DoneCampaignEventDTOBase = DoneCampaignEventDTOBase;
    $city$colisactiv$project$model$features.DoneCampaignEventBase = DoneCampaignEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    Object.defineProperty($city$colisactiv$project$model$features, 'FINISH_PROJECT', {
      configurable: true,
      get: _get_FINISH_PROJECT__2513047646
    });
    $city$colisactiv$project$model$features.FinishProjectCommandBase = FinishProjectCommandBase;
    $city$colisactiv$project$model$features.FinishProjectCommandDTOBase = FinishProjectCommandDTOBase;
    Object.defineProperty($city$colisactiv$project$model$features, 'PROJECT_DONE_EVENT', {
      configurable: true,
      get: _get_PROJECT_DONE_EVENT__1769888616
    });
    $city$colisactiv$project$model$features.ProjectDoneEventBase = ProjectDoneEventBase;
    $city$colisactiv$project$model$features.ProjectDoneEventDTOBase = ProjectDoneEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.PauseCampaignDTOBase = PauseCampaignDTOBase;
    $city$colisactiv$project$model$features.PauseCampaignCommandBase = PauseCampaignCommandBase;
    $city$colisactiv$project$model$features.PausedCampaignEventDTOBase = PausedCampaignEventDTOBase;
    $city$colisactiv$project$model$features.PausedCampaignEventBase = PausedCampaignEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.PublishCampaignDTOBase = PublishCampaignDTOBase;
    $city$colisactiv$project$model$features.PublishCampaignCommandBase = PublishCampaignCommandBase;
    $city$colisactiv$project$model$features.PublishedCampaignEventDTOBase = PublishedCampaignEventDTOBase;
    $city$colisactiv$project$model$features.PublishedCampaignEventBase = PublishedCampaignEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.RemoveCampaignCommandDetailsBase = RemoveCampaignCommandDetailsBase;
    $city$colisactiv$project$model$features.RemoveCampaignCommandBase = RemoveCampaignCommandBase;
    $city$colisactiv$project$model$features.RemovedCampaignEventDetailsBase = RemovedCampaignEventDetailsBase;
    $city$colisactiv$project$model$features.RemovedCampaignEventBase = RemovedCampaignEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.StartCampaignDTOBase = StartCampaignDTOBase;
    $city$colisactiv$project$model$features.StartCampaignCommandBase = StartCampaignCommandBase;
    $city$colisactiv$project$model$features.StartedCampaignEventDTOBase = StartedCampaignEventDTOBase;
    $city$colisactiv$project$model$features.StartedCampaignEventBase = StartedCampaignEventBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.UpdateCampaignCommandBase = UpdateCampaignCommandBase;
    $city$colisactiv$project$model$features.UpdateCampaignDTOBase = UpdateCampaignDTOBase;
    $city$colisactiv$project$model$features.UpdatedCampaignEventBase = UpdatedCampaignEventBase;
    $city$colisactiv$project$model$features.UpdatedCampaignEventDTOBase = UpdatedCampaignEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.UpdateCampaignMissingBudgetCommandBase = UpdateCampaignMissingBudgetCommandBase;
    $city$colisactiv$project$model$features.UpdateCampaignMissingBudgetDTOBase = UpdateCampaignMissingBudgetDTOBase;
    $city$colisactiv$project$model$features.UpdatedCampaignMissingBudgetEventBase = UpdatedCampaignMissingBudgetEventBase;
    $city$colisactiv$project$model$features.UpdatedCampaignMissingBudgetEventDTOBase = UpdatedCampaignMissingBudgetEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    $city$colisactiv$project$model$features.UpdateCampaignNotificationCommandBase = UpdateCampaignNotificationCommandBase;
    $city$colisactiv$project$model$features.UpdateCampaignNotificationDTOBase = UpdateCampaignNotificationDTOBase;
    $city$colisactiv$project$model$features.UpdatedCampaignNotificationEventBase = UpdatedCampaignNotificationEventBase;
    $city$colisactiv$project$model$features.UpdatedCampaignNotificationEventDTOBase = UpdatedCampaignNotificationEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    Object.defineProperty($city$colisactiv$project$model$features, 'UPDATE_PROJECT', {
      configurable: true,
      get: _get_UPDATE_PROJECT__806535400
    });
    $city$colisactiv$project$model$features.UpdateProjectCommandBase = UpdateProjectCommandBase;
    $city$colisactiv$project$model$features.UpdateProjectCommandDTOBase = UpdateProjectCommandDTOBase;
    Object.defineProperty($city$colisactiv$project$model$features, 'UPDATED_PROJECT_EVENT', {
      configurable: true,
      get: _get_UPDATED_PROJECT_EVENT__2802329281
    });
    $city$colisactiv$project$model$features.ProjectUpdatedEventBase = ProjectUpdatedEventBase;
    $city$colisactiv$project$model$features.ProjectUpdatedEventDTOBase = ProjectUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$features = $city$colisactiv$project$model.features || ($city$colisactiv$project$model.features = {});
    var $city$colisactiv$project$model$features$query = $city$colisactiv$project$model$features.query || ($city$colisactiv$project$model$features.query = {});
    $city$colisactiv$project$model$features$query.GetCampaignFilterBase = GetCampaignFilterBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$project = $city$colisactiv.project || ($city$colisactiv.project = {});
    var $city$colisactiv$project$model = $city$colisactiv$project.model || ($city$colisactiv$project.model = {});
    var $city$colisactiv$project$model$references = $city$colisactiv$project$model.references || ($city$colisactiv$project$model.references = {});
    $city$colisactiv$project$model$references.ProjectRefBase = ProjectRefBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.CarrierRefBase = CarrierRefBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryBase = DeliveryBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryAiResultsBase = DeliveryAiResultsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryBase = DeliveryCsvAnalysisQueryBase;
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryStatus = DeliveryCsvAnalysisQueryStatus;
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryStatus.values = values_0;
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryStatus.valueOf = valueOf_0;
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryStatus, 'READY', {
      configurable: true,
      get: DeliveryCsvAnalysisQueryStatus_READY_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryStatus, 'PENDING_REANALYSIS', {
      configurable: true,
      get: DeliveryCsvAnalysisQueryStatus_PENDING_REANALYSIS_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryStatus, 'REANALYSIS_IN_PROGRESS', {
      configurable: true,
      get: DeliveryCsvAnalysisQueryStatus_REANALYSIS_IN_PROGRESS_getInstance
    });
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisQueryResultBase = DeliveryCsvAnalysisQueryResultBase;
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisAggregatedResultBase = DeliveryCsvAnalysisAggregatedResultBase;
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisSummaryBase = DeliveryCsvAnalysisSummaryBase;
    $city$colisactiv$delivery$api$model.DeliveryCsvAnalysisDetailBase = DeliveryCsvAnalysisDetailBase;
    $city$colisactiv$delivery$api$model.HeatmapPointBase = HeatmapPointBase;
    $city$colisactiv$delivery$api$model.HeatmapPointsDataBase = HeatmapPointsDataBase;
    $city$colisactiv$delivery$api$model.HeatMatrixCellBase = HeatMatrixCellBase;
    $city$colisactiv$delivery$api$model.HeatMatricesDataBase = HeatMatricesDataBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryCsvBonusOverviewBase = DeliveryCsvBonusOverviewBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryCsvError = DeliveryCsvError;
    $city$colisactiv$delivery$api$model.DeliveryCsvError.values = values_1;
    $city$colisactiv$delivery$api$model.DeliveryCsvError.valueOf = valueOf_1;
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVALID_FORMAT', {
      configurable: true,
      get: DeliveryCsvError_INVALID_FORMAT_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVALID_SEPARATOR', {
      configurable: true,
      get: DeliveryCsvError_INVALID_SEPARATOR_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVALID_COLUMN_HEADER', {
      configurable: true,
      get: DeliveryCsvError_INVALID_COLUMN_HEADER_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'MISSING_COLUMN', {
      configurable: true,
      get: DeliveryCsvError_MISSING_COLUMN_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'EMPTY_COLUMN', {
      configurable: true,
      get: DeliveryCsvError_EMPTY_COLUMN_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'EMPTY_VALUE', {
      configurable: true,
      get: DeliveryCsvError_EMPTY_VALUE_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'RECURRENT_TOUR_ID', {
      configurable: true,
      get: DeliveryCsvError_RECURRENT_TOUR_ID_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'TOUR_ID_USED_BY_MULTIPLE_OPERATORS', {
      configurable: true,
      get: DeliveryCsvError_TOUR_ID_USED_BY_MULTIPLE_OPERATORS_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'TOUR_ID_IN_MULTIPLE_TERRITORIES', {
      configurable: true,
      get: DeliveryCsvError_TOUR_ID_IN_MULTIPLE_TERRITORIES_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'PERIOD_OVERLAP', {
      configurable: true,
      get: DeliveryCsvError_PERIOD_OVERLAP_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVERTED_COORDINATE', {
      configurable: true,
      get: DeliveryCsvError_INVERTED_COORDINATE_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVALID_OPERATOR_ID', {
      configurable: true,
      get: DeliveryCsvError_INVALID_OPERATOR_ID_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVALID_CARRIER_ID', {
      configurable: true,
      get: DeliveryCsvError_INVALID_CARRIER_ID_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'INVALID_VALUE', {
      configurable: true,
      get: DeliveryCsvError_INVALID_VALUE_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'NEGATIVE_DURATION', {
      configurable: true,
      get: DeliveryCsvError_NEGATIVE_DURATION_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'UNKNOWN_ERROR', {
      configurable: true,
      get: DeliveryCsvError_UNKNOWN_ERROR_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'HUB_OUT_OF_TERRITORY', {
      configurable: true,
      get: DeliveryCsvError_HUB_OUT_OF_TERRITORY_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.DeliveryCsvError, 'TOO_MANY_LOW_POINT_TOURS', {
      configurable: true,
      get: DeliveryCsvError_TOO_MANY_LOW_POINT_TOURS_getInstance
    });
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryCsvLineErrorBase = DeliveryCsvLineErrorBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryCsvScanBase = DeliveryCsvScanBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.CarrierPackageCountBase = CarrierPackageCountBase;
    $city$colisactiv$delivery$api$model.CsvHubPointBase = CsvHubPointBase;
    $city$colisactiv$delivery$api$model.CsvDeliveryPointBase = CsvDeliveryPointBase;
    $city$colisactiv$delivery$api$model.DeliveryCsvScannerResultBase = DeliveryCsvScannerResultBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.DeliveryOverviewBase = DeliveryOverviewBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.LinestringBase = LinestringBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.OrganizationExternalRefBase = OrganizationExternalRefBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.PackageBase = PackageBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.PredictionBase = PredictionBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.ReanalysisJobStatus = ReanalysisJobStatus;
    $city$colisactiv$delivery$api$model.ReanalysisJobStatus.values = values_2;
    $city$colisactiv$delivery$api$model.ReanalysisJobStatus.valueOf = valueOf_2;
    Object.defineProperty($city$colisactiv$delivery$api$model.ReanalysisJobStatus, 'PENDING', {
      configurable: true,
      get: ReanalysisJobStatus_PENDING_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.ReanalysisJobStatus, 'RUNNING', {
      configurable: true,
      get: ReanalysisJobStatus_RUNNING_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.ReanalysisJobStatus, 'COMPLETED', {
      configurable: true,
      get: ReanalysisJobStatus_COMPLETED_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.ReanalysisJobStatus, 'FAILED', {
      configurable: true,
      get: ReanalysisJobStatus_FAILED_getInstance
    });
    Object.defineProperty($city$colisactiv$delivery$api$model.ReanalysisJobStatus, 'CANCELLED', {
      configurable: true,
      get: ReanalysisJobStatus_CANCELLED_getInstance
    });
    $city$colisactiv$delivery$api$model.ReanalysisProgressBase = ReanalysisProgressBase;
    $city$colisactiv$delivery$api$model.TriggerReanalysisRequestBase = TriggerReanalysisRequestBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.TourBase = TourBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.TourAuditionBase = TourAuditionBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.TourOverviewBase = TourOverviewBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.TourTraceGpsBase = TourTraceGpsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.TransportModeBase = TransportModeBase;
    $city$colisactiv$delivery$api$model.TransportModeValues = TransportModeValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.TripBase = TripBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    $city$colisactiv$delivery$api$model.ViewportBase = ViewportBase;
    $city$colisactiv$delivery$api$model.ViewportPointsRequestBase = ViewportPointsRequestBase;
    $city$colisactiv$delivery$api$model.ViewportPointsResponseBase = ViewportPointsResponseBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'ADD_DELIVERIES', {
      configurable: true,
      get: _get_ADD_DELIVERIES__399362555
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'DELIVERY_ADDED', {
      configurable: true,
      get: _get_DELIVERY_ADDED__374402006
    });
    $city$colisactiv$delivery$api$model$features.AddDeliveriesCommandBase = AddDeliveriesCommandBase;
    $city$colisactiv$delivery$api$model$features.AddDeliveriesCommandDTOBase = AddDeliveriesCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.DeliveryAddedEventBase = DeliveryAddedEventBase;
    $city$colisactiv$delivery$api$model$features.DeliveryAddedEventDTOBase = DeliveryAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'ADD_DELIVERY_BLOCKCHAIN_TRACE', {
      configurable: true,
      get: _get_ADD_DELIVERY_BLOCKCHAIN_TRACE__4162343306
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'DELIVERY_BLOCKCHAIN_TRACE_ADDED', {
      configurable: true,
      get: _get_DELIVERY_BLOCKCHAIN_TRACE_ADDED__1241407051
    });
    $city$colisactiv$delivery$api$model$features.AddDeliveryBlockchainTraceCommandBase = AddDeliveryBlockchainTraceCommandBase;
    $city$colisactiv$delivery$api$model$features.AddDeliveryBlockchainTraceCommandDTOBase = AddDeliveryBlockchainTraceCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.DeliveryBlockchainTraceAddedBase = DeliveryBlockchainTraceAddedBase;
    $city$colisactiv$delivery$api$model$features.DeliveryBlockchainTraceAddedDTOBase = DeliveryBlockchainTraceAddedDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'ADD_TOUR_METADATA_BLOCKCHAIN_TRACE', {
      configurable: true,
      get: _get_ADD_TOUR_METADATA_BLOCKCHAIN_TRACE__3802652362
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED', {
      configurable: true,
      get: _get_TOUR_METADATA_BLOCKCHAIN_TRACE_ADDED__1927811527
    });
    $city$colisactiv$delivery$api$model$features.AddTourMetadataBlockchainTraceCommandBase = AddTourMetadataBlockchainTraceCommandBase;
    $city$colisactiv$delivery$api$model$features.AddTourMetadataBlockchainTraceCommandDTOBase = AddTourMetadataBlockchainTraceCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.TourMetadataBlockchainTraceAddedEventBase = TourMetadataBlockchainTraceAddedEventBase;
    $city$colisactiv$delivery$api$model$features.TourMetadataBlockchainTraceAddedEventDTOBase = TourMetadataBlockchainTraceAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'ADD_TOUR_TRACE_GPS', {
      configurable: true,
      get: _get_ADD_TOUR_TRACE_GPS__1834851236
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'TOUR_TRACE_GPS_ADDED', {
      configurable: true,
      get: _get_TOUR_TRACE_GPS_ADDED__3639246625
    });
    $city$colisactiv$delivery$api$model$features.AddTourTraceGpsCommandBase = AddTourTraceGpsCommandBase;
    $city$colisactiv$delivery$api$model$features.AddTourTraceGpsCommandDTOBase = AddTourTraceGpsCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.TourTraceGpsAddedEventBase = TourTraceGpsAddedEventBase;
    $city$colisactiv$delivery$api$model$features.TourTraceGpsAddedEventDTOBase = TourTraceGpsAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'DECLARE_TOUR', {
      configurable: true,
      get: _get_DECLARE_TOUR__2957373118
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'TOUR_DECLARED', {
      configurable: true,
      get: _get_TOUR_DECLARED__2089660080
    });
    $city$colisactiv$delivery$api$model$features.DeclareTourCommandBase = DeclareTourCommandBase;
    $city$colisactiv$delivery$api$model$features.DeclareTourCommandDTOBase = DeclareTourCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.TourDeclaredEventBase = TourDeclaredEventBase;
    $city$colisactiv$delivery$api$model$features.TourDeclaredEventDTOBase = TourDeclaredEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'GET_TOURS_WITH_DELIVERIES', {
      configurable: true,
      get: _get_GET_TOURS_WITH_DELIVERIES__519175923
    });
    $city$colisactiv$delivery$api$model$features.GetToursWithDeliveriesQueryBase = GetToursWithDeliveriesQueryBase;
    $city$colisactiv$delivery$api$model$features.GetToursWithDeliveriesQueryDTOBase = GetToursWithDeliveriesQueryDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'TOUR_AUDITED', {
      configurable: true,
      get: _get_TOUR_AUDITED__2969365752
    });
    $city$colisactiv$delivery$api$model$features.TourAuditedEventBase = TourAuditedEventBase;
    $city$colisactiv$delivery$api$model$features.TourAuditedEventDTOBase = TourAuditedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'UPDATE_ACCEPTED_BY_AI', {
      configurable: true,
      get: _get_UPDATE_ACCEPTED_BY_AI__2651472611
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'ACCEPTED_BY_AI_UPDATED', {
      configurable: true,
      get: _get_ACCEPTED_BY_AI_UPDATED__4116486583
    });
    $city$colisactiv$delivery$api$model$features.UpdateAcceptedByAiCommandBase = UpdateAcceptedByAiCommandBase;
    $city$colisactiv$delivery$api$model$features.UpdateAcceptedByAiCommandBaseDTOBase = UpdateAcceptedByAiCommandBaseDTOBase;
    $city$colisactiv$delivery$api$model$features.AcceptedByAiUpdatedEventBase = AcceptedByAiUpdatedEventBase;
    $city$colisactiv$delivery$api$model$features.AcceptedByAiUpdatedEventDTOBase = AcceptedByAiUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'UPDATE_DELIVERY_STATUS', {
      configurable: true,
      get: _get_UPDATE_DELIVERY_STATUS__2780937924
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'DELIVERY_STATUS_UPDATED', {
      configurable: true,
      get: _get_DELIVERY_STATUS_UPDATED__724316984
    });
    $city$colisactiv$delivery$api$model$features.UpdateDeliveryStatusCommandBase = UpdateDeliveryStatusCommandBase;
    $city$colisactiv$delivery$api$model$features.UpdateDeliveryStatusCommandDTOBase = UpdateDeliveryStatusCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.DeliveryStatusUpdatedEventBase = DeliveryStatusUpdatedEventBase;
    $city$colisactiv$delivery$api$model$features.DeliveryStatusUpdatedEventDTOBase = DeliveryStatusUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$delivery = $city$colisactiv.delivery || ($city$colisactiv.delivery = {});
    var $city$colisactiv$delivery$api = $city$colisactiv$delivery.api || ($city$colisactiv$delivery.api = {});
    var $city$colisactiv$delivery$api$model = $city$colisactiv$delivery$api.model || ($city$colisactiv$delivery$api.model = {});
    var $city$colisactiv$delivery$api$model$features = $city$colisactiv$delivery$api$model.features || ($city$colisactiv$delivery$api$model.features = {});
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'UPDATE_TERRITORY_CODE', {
      configurable: true,
      get: _get_UPDATE_TERRITORY_CODE__3294055817
    });
    Object.defineProperty($city$colisactiv$delivery$api$model$features, 'TERRITORY_CODE_UPDATED', {
      configurable: true,
      get: _get_TERRITORY_CODE_UPDATED__1331666525
    });
    $city$colisactiv$delivery$api$model$features.UpdateTerritoryCodeCommandBase = UpdateTerritoryCodeCommandBase;
    $city$colisactiv$delivery$api$model$features.UpdateTerritoryCodeCommandDTOBase = UpdateTerritoryCodeCommandDTOBase;
    $city$colisactiv$delivery$api$model$features.TerritoryCodeUpdatedEventBase = TerritoryCodeUpdatedEventBase;
    $city$colisactiv$delivery$api$model$features.TerritoryCodeUpdatedEventDTOBase = TerritoryCodeUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    $city$colisactiv$plateform$bonus$model.BonusBase = BonusBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    $city$colisactiv$plateform$bonus$model.BonusDeliveryTourBase = BonusDeliveryTourBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    $city$colisactiv$plateform$bonus$model.BonusGroupStatusBase = BonusGroupStatusBase;
    $city$colisactiv$plateform$bonus$model.BonusGroupStatusValues = BonusGroupStatusValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    $city$colisactiv$plateform$bonus$model.BonusManualDataBase = BonusManualDataBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'ADD_BONUS_DELIVERY_TOURS', {
      configurable: true,
      get: _get_ADD_BONUS_DELIVERY_TOURS__690415965
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_DELIVERY_TOURS_ADDED', {
      configurable: true,
      get: _get_BONUS_DELIVERY_TOURS_ADDED__1529452442
    });
    $city$colisactiv$plateform$bonus$model$features.AddBonusDeliveryToursCommandBase = AddBonusDeliveryToursCommandBase;
    $city$colisactiv$plateform$bonus$model$features.AddBonusDeliveryToursCommandDTOBase = AddBonusDeliveryToursCommandDTOBase;
    $city$colisactiv$plateform$bonus$model$features.BonusDeliveryToursAddedEventBase = BonusDeliveryToursAddedEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusDeliveryToursAddedEventDTOBase = BonusDeliveryToursAddedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_UPDATED', {
      configurable: true,
      get: _get_BONUS_UPDATED__1940680662
    });
    $city$colisactiv$plateform$bonus$model$features.BonusUpdatedEventBase = BonusUpdatedEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusUpdatedEventDtoBase = BonusUpdatedEventDtoBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'CREATE_BONUS', {
      configurable: true,
      get: _get_CREATE_BONUS__3098369487
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_CREATED', {
      configurable: true,
      get: _get_BONUS_CREATED__2438502217
    });
    $city$colisactiv$plateform$bonus$model$features.CreateBonusCommandBase = CreateBonusCommandBase;
    $city$colisactiv$plateform$bonus$model$features.CreateBonusCommandDtoBase = CreateBonusCommandDtoBase;
    $city$colisactiv$plateform$bonus$model$features.BonusCreatedEventBase = BonusCreatedEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusCreatedEventDtoBase = BonusCreatedEventDtoBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'CREATE_OR_UPDATE_GROUP_OF_BONUS', {
      configurable: true,
      get: _get_CREATE_OR_UPDATE_GROUP_OF_BONUS__587603037
    });
    $city$colisactiv$plateform$bonus$model$features.CreateOrUpdateGroupOfBonusCommandBase = CreateOrUpdateGroupOfBonusCommandBase;
    $city$colisactiv$plateform$bonus$model$features.CreateOrUpdateGroupOfBonusCommandDTOBase = CreateOrUpdateGroupOfBonusCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'REMOVE_BONUS_TOURS', {
      configurable: true,
      get: _get_REMOVE_BONUS_TOURS__850822667
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_TOURS_REMOVED', {
      configurable: true,
      get: _get_BONUS_TOURS_REMOVED__1738159445
    });
    $city$colisactiv$plateform$bonus$model$features.RemoveBonusToursCommandBase = RemoveBonusToursCommandBase;
    $city$colisactiv$plateform$bonus$model$features.RemoveBonusToursCommandDTOBase = RemoveBonusToursCommandDTOBase;
    $city$colisactiv$plateform$bonus$model$features.BonusToursRemovedEventBase = BonusToursRemovedEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusToursRemovedEventDTOBase = BonusToursRemovedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'SET_BONUS_TOURS_AS_ACTIVE', {
      configurable: true,
      get: _get_SET_BONUS_TOURS_AS_ACTIVE__2758153631
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_TOURS_SET_AS_ACTIVE', {
      configurable: true,
      get: _get_BONUS_TOURS_SET_AS_ACTIVE__2299901727
    });
    $city$colisactiv$plateform$bonus$model$features.SetBonusToursAsActiveCommandBase = SetBonusToursAsActiveCommandBase;
    $city$colisactiv$plateform$bonus$model$features.SetBonusToursAsActiveCommandDTOBase = SetBonusToursAsActiveCommandDTOBase;
    $city$colisactiv$plateform$bonus$model$features.BonusToursSetAsActiveEventBase = BonusToursSetAsActiveEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusToursSetAsActiveEventDTOBase = BonusToursSetAsActiveEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'UPDATE_BONUS_AMOUNT', {
      configurable: true,
      get: _get_UPDATE_BONUS_AMOUNT__2867841027
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_AMOUNT_UPDATED', {
      configurable: true,
      get: _get_BONUS_AMOUNT_UPDATED__3311676119
    });
    $city$colisactiv$plateform$bonus$model$features.UpdateBonusAmountCommandBase = UpdateBonusAmountCommandBase;
    $city$colisactiv$plateform$bonus$model$features.UpdateBonusAmountCommandDTOBase = UpdateBonusAmountCommandDTOBase;
    $city$colisactiv$plateform$bonus$model$features.BonusAmountUpdatedEventBase = BonusAmountUpdatedEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusAmountUpdatedEventDTOBase = BonusAmountUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$model = $city$colisactiv$plateform$bonus.model || ($city$colisactiv$plateform$bonus.model = {});
    var $city$colisactiv$plateform$bonus$model$features = $city$colisactiv$plateform$bonus$model.features || ($city$colisactiv$plateform$bonus$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'UPDATE_BONUS_STATUS', {
      configurable: true,
      get: _get_UPDATE_BONUS_STATUS__1850489769
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$model$features, 'BONUS_STATUS_UPDATED', {
      configurable: true,
      get: _get_BONUS_STATUS_UPDATED__1325242493
    });
    $city$colisactiv$plateform$bonus$model$features.UpdateBonusStatusCommandBase = UpdateBonusStatusCommandBase;
    $city$colisactiv$plateform$bonus$model$features.UpdateBonusStatusCommandDTOBase = UpdateBonusStatusCommandDTOBase;
    $city$colisactiv$plateform$bonus$model$features.BonusStatusUpdatedEventBase = BonusStatusUpdatedEventBase;
    $city$colisactiv$plateform$bonus$model$features.BonusStatusUpdatedEventDTOBase = BonusStatusUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupBase = BonusGroupBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupAction = BonusGroupAction;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupStateMachine = BonusGroupStateMachine;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupDatesBase = BonusGroupDatesBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupFunderBase = BonusGroupFunderBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupFunderInvoiceDetailsBase = BonusGroupFunderInvoiceDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupIncidentBase = BonusGroupIncidentBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupIncidentStatusBase = BonusGroupIncidentStatusBase;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupIncidentStatusValues = BonusGroupIncidentStatusValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INCIDENT_TYPE_MANUAL', {
      configurable: true,
      get: _get_BONUS_GROUP_INCIDENT_TYPE_MANUAL__2528055789
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INCIDENT_TYPE_REJECTION', {
      configurable: true,
      get: _get_BONUS_GROUP_INCIDENT_TYPE_REJECTION__1804612768
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA', {
      configurable: true,
      get: _get_BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_INVALID_DATA__2162050835
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA', {
      configurable: true,
      get: _get_BONUS_GROUP_INCIDENT_TYPE_CARRIER_REPORT_MISSING_DATA__1815693122
    });
    $city$colisactiv$plateform$bonus$group$model.BonusGroupIncidentTypeBase = BonusGroupIncidentTypeBase;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupIncidentTypeValues = BonusGroupIncidentTypeValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupInvoiceBase = BonusGroupInvoiceBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INVOICE_TYPE_PREVIOUS', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_TYPE_PREVIOUS__3060908039
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_TYPE_CUSTOM_PREVIOUS__4035259641
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INVOICE_TYPE_CARRIER', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_TYPE_CARRIER__1377822854
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model, 'BONUS_GROUP_INVOICE_TYPE_FUNDER', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_TYPE_FUNDER__2721236012
    });
    $city$colisactiv$plateform$bonus$group$model.BonusGroupInvoiceTypeBase = BonusGroupInvoiceTypeBase;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupInvoiceTypeValues = BonusGroupInvoiceTypeValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupLogType = BonusGroupLogType;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupLogType.values = values_3;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupLogType.valueOf = valueOf_3;
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model.BonusGroupLogType, 'IMPORT_DELIVERIES', {
      configurable: true,
      get: BonusGroupLogType_IMPORT_DELIVERIES_getInstance
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model.BonusGroupLogType, 'CREATE_CARRIER_REPORT', {
      configurable: true,
      get: BonusGroupLogType_CREATE_CARRIER_REPORT_getInstance
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model.BonusGroupLogType, 'EDIT_CARRIER_REPORT', {
      configurable: true,
      get: BonusGroupLogType_EDIT_CARRIER_REPORT_getInstance
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model.BonusGroupLogType, 'UPLOAD_INVOICE', {
      configurable: true,
      get: BonusGroupLogType_UPLOAD_INVOICE_getInstance
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model.BonusGroupLogType, 'EDIT_INVOICE', {
      configurable: true,
      get: BonusGroupLogType_EDIT_INVOICE_getInstance
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model.BonusGroupLogType, 'EDIT_STATUS', {
      configurable: true,
      get: BonusGroupLogType_EDIT_STATUS_getInstance
    });
    $city$colisactiv$plateform$bonus$group$model.BonusGroupLogBase = BonusGroupLogBase;
    $city$colisactiv$plateform$bonus$group$model.BonusGroupLogDetailBase = BonusGroupLogDetailBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.BonusGroupPoiDashboardBase = BonusGroupPoiDashboardBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    $city$colisactiv$plateform$bonus$group$model.FunderRepartitionBase = FunderRepartitionBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'ADD_BONUS_TO_GROUP', {
      configurable: true,
      get: _get_ADD_BONUS_TO_GROUP__3567084370
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_ADDED_TO_GROUP', {
      configurable: true,
      get: _get_BONUS_ADDED_TO_GROUP__426184497
    });
    $city$colisactiv$plateform$bonus$group$model$features.AddBonusToGroupCommandBase = AddBonusToGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.AddBonusToGroupCommandDTOBase = AddBonusToGroupCommandDTOBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusAddedToGroupEventBase = BonusAddedToGroupEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusAddedToGroupEventDTOBase = BonusAddedToGroupEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_COMMENT_EDITED', {
      configurable: true,
      get: _get_BONUS_GROUP_COMMENT_EDITED__91258722
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupCommentEditedEventBase = BonusGroupCommentEditedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupCommentEditedEventDTOBase = BonusGroupCommentEditedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_CREATED', {
      configurable: true,
      get: _get_BONUS_GROUP_CREATED__4187642601
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupCreatedEventBase = BonusGroupCreatedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupCreatedEventDTOBase = BonusGroupCreatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_DELETED', {
      configurable: true,
      get: _get_BONUS_GROUP_DELETED__3186937816
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupDeletedEventBase = BonusGroupDeletedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupDeletedEventDTOBase = BonusGroupDeletedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_INVOICE_DELETED', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_DELETED__2684202442
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceDeletedEventBase = BonusGroupInvoiceDeletedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceDeletedEventDetailsBase = BonusGroupInvoiceDeletedEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_LOG_COMMENT_EDITED', {
      configurable: true,
      get: _get_BONUS_GROUP_LOG_COMMENT_EDITED__2199147975
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupLogCommentEditedEventBase = BonusGroupLogCommentEditedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupLogCommentEditedEventDTOBase = BonusGroupLogCommentEditedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_STATUS_UPDATED', {
      configurable: true,
      get: _get_BONUS_GROUP_STATUS_UPDATED__3179708637
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupStatusUpdatedEventBase = BonusGroupStatusUpdatedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupStatusUpdatedEventDTOBase = BonusGroupStatusUpdatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'CREATE_BONUS_GROUP_INCIDENT', {
      configurable: true,
      get: _get_CREATE_BONUS_GROUP_INCIDENT__2431072220
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_INCIDENT_CREATED', {
      configurable: true,
      get: _get_BONUS_GROUP_INCIDENT_CREATED__2630409264
    });
    $city$colisactiv$plateform$bonus$group$model$features.CreateBonusGroupIncidentCommandBase = CreateBonusGroupIncidentCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.CreateBonusGroupIncidentCommandDTOBase = CreateBonusGroupIncidentCommandDTOBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupIncidentCreatedEventBase = BonusGroupIncidentCreatedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupIncidentCreatedEventDTOBase = BonusGroupIncidentCreatedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'CREATE_BONUS_GROUP_INVOICE', {
      configurable: true,
      get: _get_CREATE_BONUS_GROUP_INVOICE__73874081
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_INVOICE_CREATED', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_CREATED__3684907227
    });
    $city$colisactiv$plateform$bonus$group$model$features.CreateBonusGroupInvoiceCommandBase = CreateBonusGroupInvoiceCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.CreateBonusGroupInvoiceCommandDetailsBase = CreateBonusGroupInvoiceCommandDetailsBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceCreatedEventBase = BonusGroupInvoiceCreatedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceCreatedEventDetailsBase = BonusGroupInvoiceCreatedEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'DEDUCE_BONUS_GROUP', {
      configurable: true,
      get: _get_DEDUCE_BONUS_GROUP__2777106167
    });
    $city$colisactiv$plateform$bonus$group$model$features.DeduceBonusGroupCommandBase = DeduceBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.DeduceBonusGroupCommandDTOBase = DeduceBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'DELETE_BONUS_GROUP', {
      configurable: true,
      get: _get_DELETE_BONUS_GROUP__155871072
    });
    $city$colisactiv$plateform$bonus$group$model$features.DeleteBonusGroupCommandBase = DeleteBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.DeleteBonusGroupCommandDTOBase = DeleteBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'DELETE_BONUS_GROUPS', {
      configurable: true,
      get: _get_DELETE_BONUS_GROUPS__537036649
    });
    $city$colisactiv$plateform$bonus$group$model$features.DeleteBonusGroupsCommandBase = DeleteBonusGroupsCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.DeleteBonusGroupsCommandDTOBase = DeleteBonusGroupsCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'EDIT_BONUS_GROUP_COMMENT', {
      configurable: true,
      get: _get_EDIT_BONUS_GROUP_COMMENT__946677921
    });
    $city$colisactiv$plateform$bonus$group$model$features.EditBonusGroupCommentCommandBase = EditBonusGroupCommentCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.EditBonusGroupCommentCommandDTOBase = EditBonusGroupCommentCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'EDIT_BONUS_GROUP_LOG_COMMENT', {
      configurable: true,
      get: _get_EDIT_BONUS_GROUP_LOG_COMMENT__3371289180
    });
    $city$colisactiv$plateform$bonus$group$model$features.EditBonusGroupLogCommentCommandBase = EditBonusGroupLogCommentCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.EditBonusGroupLogCommentCommandDTOBase = EditBonusGroupLogCommentCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'LOG_BONUS_GROUP', {
      configurable: true,
      get: _get_LOG_BONUS_GROUP__3355921165
    });
    $city$colisactiv$plateform$bonus$group$model$features.LogBonusGroupCommandBase = LogBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.LogBonusGroupCommandDTOBase = LogBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'PAY_BONUS_GROUP', {
      configurable: true,
      get: _get_PAY_BONUS_GROUP__1172774953
    });
    $city$colisactiv$plateform$bonus$group$model$features.PayBonusGroupCommandBase = PayBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.PayBonusGroupCommandDTOBase = PayBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'PUBLISH_BONUS_GROUP', {
      configurable: true,
      get: _get_PUBLISH_BONUS_GROUP__4289112482
    });
    $city$colisactiv$plateform$bonus$group$model$features.PublishBonusGroupCommandBase = PublishBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.PublishBonusGroupCommandDTOBase = PublishBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'REJECT_BONUS_GROUP', {
      configurable: true,
      get: _get_REJECT_BONUS_GROUP__3954492908
    });
    $city$colisactiv$plateform$bonus$group$model$features.RejectBonusGroupCommandBase = RejectBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.RejectBonusGroupCommandDTOBase = RejectBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'REPORT_BONUS_GROUP', {
      configurable: true,
      get: _get_REPORT_BONUS_GROUP__3812482679
    });
    $city$colisactiv$plateform$bonus$group$model$features.ReportBonusGroupCommandBase = ReportBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.ReportBonusGroupCommandDTOBase = ReportBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'RESOLVE_BONUS_GROUP_INCIDENT', {
      configurable: true,
      get: _get_RESOLVE_BONUS_GROUP_INCIDENT__3439868006
    });
    $city$colisactiv$plateform$bonus$group$model$features.ResolveBonusGroupIncidentCommandBase = ResolveBonusGroupIncidentCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.ResolveBonusGroupIncidentCommandDTOBase = ResolveBonusGroupIncidentCommandDTOBase;
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_INCIDENT_RESOLVED', {
      configurable: true,
      get: _get_BONUS_GROUP_INCIDENT_RESOLVED__1643642060
    });
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupIncidentResolvedEventBase = BonusGroupIncidentResolvedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupIncidentResolvedEventDTOBase = BonusGroupIncidentResolvedEventDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'UPDATE_BONUS_GROUP_INVOICE', {
      configurable: true,
      get: _get_UPDATE_BONUS_GROUP_INVOICE__2218226932
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_INVOICE_UPDATED', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_UPDATED__3187085672
    });
    $city$colisactiv$plateform$bonus$group$model$features.UpdateBonusGroupInvoiceCommandBase = UpdateBonusGroupInvoiceCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.UpdateBonusGroupInvoiceCommandDetailsBase = UpdateBonusGroupInvoiceCommandDetailsBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceUpdatedEventBase = BonusGroupInvoiceUpdatedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceUpdatedEventDetailsBase = BonusGroupInvoiceUpdatedEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'UPDATE_BONUS_GROUP_INVOICE_DETAILS', {
      configurable: true,
      get: _get_UPDATE_BONUS_GROUP_INVOICE_DETAILS__981128817
    });
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'BONUS_GROUP_INVOICE_DETAILS_UPDATED', {
      configurable: true,
      get: _get_BONUS_GROUP_INVOICE_DETAILS_UPDATED__2367444453
    });
    $city$colisactiv$plateform$bonus$group$model$features.UpdateBonusGroupInvoiceDetailsCommandBase = UpdateBonusGroupInvoiceDetailsCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.UpdateBonusGroupInvoiceDetailsCommandDetailsBase = UpdateBonusGroupInvoiceDetailsCommandDetailsBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceDetailsUpdatedEventBase = BonusGroupInvoiceDetailsUpdatedEventBase;
    $city$colisactiv$plateform$bonus$group$model$features.BonusGroupInvoiceDetailsUpdatedEventDetailsBase = BonusGroupInvoiceDetailsUpdatedEventDetailsBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$plateform = $city$colisactiv.plateform || ($city$colisactiv.plateform = {});
    var $city$colisactiv$plateform$bonus = $city$colisactiv$plateform.bonus || ($city$colisactiv$plateform.bonus = {});
    var $city$colisactiv$plateform$bonus$group = $city$colisactiv$plateform$bonus.group || ($city$colisactiv$plateform$bonus.group = {});
    var $city$colisactiv$plateform$bonus$group$model = $city$colisactiv$plateform$bonus$group.model || ($city$colisactiv$plateform$bonus$group.model = {});
    var $city$colisactiv$plateform$bonus$group$model$features = $city$colisactiv$plateform$bonus$group$model.features || ($city$colisactiv$plateform$bonus$group$model.features = {});
    Object.defineProperty($city$colisactiv$plateform$bonus$group$model$features, 'VALIDATE_BONUS_GROUP', {
      configurable: true,
      get: _get_VALIDATE_BONUS_GROUP__1843977877
    });
    $city$colisactiv$plateform$bonus$group$model$features.ValidateBonusGroupCommandBase = ValidateBonusGroupCommandBase;
    $city$colisactiv$plateform$bonus$group$model$features.ValidateBonusGroupCommandDTOBase = ValidateBonusGroupCommandDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$features = $city$colisactiv$platform$bonus$payment$domain.features || ($city$colisactiv$platform$bonus$payment$domain.features = {});
    var $city$colisactiv$platform$bonus$payment$domain$features$command = $city$colisactiv$platform$bonus$payment$domain$features.command || ($city$colisactiv$platform$bonus$payment$domain$features.command = {});
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$command, 'ADD_BONUS_IN_BONUS_PAYMENT', {
      configurable: true,
      get: _get_ADD_BONUS_IN_BONUS_PAYMENT__3251012097
    });
    $city$colisactiv$platform$bonus$payment$domain$features$command.AddBonusInPaymentCommandBase = AddBonusInPaymentCommandBase;
    $city$colisactiv$platform$bonus$payment$domain$features$command.AddBonusInPaymentCommandDTOBase = AddBonusInPaymentCommandDTOBase;
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$command, 'ADDED_BONUS_IN_BONUS_PAYMENT', {
      configurable: true,
      get: _get_ADDED_BONUS_IN_BONUS_PAYMENT__2255856160
    });
    $city$colisactiv$platform$bonus$payment$domain$features$command.BonusPaymentAddedBonusEventBase = BonusPaymentAddedBonusEventBase;
    $city$colisactiv$platform$bonus$payment$domain$features$command.BonusPaymentAddedBonusEventDtoBase = BonusPaymentAddedBonusEventDtoBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$features = $city$colisactiv$platform$bonus$payment$domain.features || ($city$colisactiv$platform$bonus$payment$domain.features = {});
    var $city$colisactiv$platform$bonus$payment$domain$features$command = $city$colisactiv$platform$bonus$payment$domain$features.command || ($city$colisactiv$platform$bonus$payment$domain$features.command = {});
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$command, 'CREATE_BONUS_PAYMENT', {
      configurable: true,
      get: _get_CREATE_BONUS_PAYMENT__423128328
    });
    $city$colisactiv$platform$bonus$payment$domain$features$command.CreateBonusPaymentCommandBase = CreateBonusPaymentCommandBase;
    $city$colisactiv$platform$bonus$payment$domain$features$command.CreateBonusPaymentCommandDTOBase = CreateBonusPaymentCommandDTOBase;
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$command, 'CREATED_BONUS_PAYMENT_EVENT', {
      configurable: true,
      get: _get_CREATED_BONUS_PAYMENT_EVENT__3445095975
    });
    $city$colisactiv$platform$bonus$payment$domain$features$command.BonusPaymentCreatedEventBase = BonusPaymentCreatedEventBase;
    $city$colisactiv$platform$bonus$payment$domain$features$command.BonusPaymentCreatedEventDtoBase = BonusPaymentCreatedEventDtoBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$features = $city$colisactiv$platform$bonus$payment$domain.features || ($city$colisactiv$platform$bonus$payment$domain.features = {});
    var $city$colisactiv$platform$bonus$payment$domain$features$command = $city$colisactiv$platform$bonus$payment$domain$features.command || ($city$colisactiv$platform$bonus$payment$domain$features.command = {});
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$command, 'PAY_BONUS_PAYMENT', {
      configurable: true,
      get: _get_PAY_BONUS_PAYMENT__2631622402
    });
    $city$colisactiv$platform$bonus$payment$domain$features$command.PayBonusPaymentCommandBase = PayBonusPaymentCommandBase;
    $city$colisactiv$platform$bonus$payment$domain$features$command.PayBonusPaymentCommandDTOBase = PayBonusPaymentCommandDTOBase;
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$command, 'PAID_BONUS_PAYMENT_EVENT', {
      configurable: true,
      get: _get_PAID_BONUS_PAYMENT_EVENT__427829981
    });
    $city$colisactiv$platform$bonus$payment$domain$features$command.BonusPaymentPaidEventBase = BonusPaymentPaidEventBase;
    $city$colisactiv$platform$bonus$payment$domain$features$command.BonusPaymentPaidEventDtoBase = BonusPaymentPaidEventDtoBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$features = $city$colisactiv$platform$bonus$payment$domain.features || ($city$colisactiv$platform$bonus$payment$domain.features = {});
    var $city$colisactiv$platform$bonus$payment$domain$features$query = $city$colisactiv$platform$bonus$payment$domain$features.query || ($city$colisactiv$platform$bonus$payment$domain$features.query = {});
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$features$query, 'EXPORT_BONUS_GROUP_INVOICE', {
      configurable: true,
      get: _get_EXPORT_BONUS_GROUP_INVOICE__1170025193
    });
    $city$colisactiv$platform$bonus$payment$domain$features$query.ExportBonusGroupInvoiceQueryBase = ExportBonusGroupInvoiceQueryBase;
    $city$colisactiv$platform$bonus$payment$domain$features$query.ExportBonusGroupInvoiceQueryDTOBase = ExportBonusGroupInvoiceQueryDTOBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$model = $city$colisactiv$platform$bonus$payment$domain.model || ($city$colisactiv$platform$bonus$payment$domain.model = {});
    $city$colisactiv$platform$bonus$payment$domain$model.BonusPaymentBase = BonusPaymentBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$model = $city$colisactiv$platform$bonus$payment$domain.model || ($city$colisactiv$platform$bonus$payment$domain.model = {});
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$model, 'BONUS_PAYMENT_CREATED', {
      configurable: true,
      get: _get_BONUS_PAYMENT_CREATED__1943390850
    });
    Object.defineProperty($city$colisactiv$platform$bonus$payment$domain$model, 'BONUS_PAYMENT_PAID', {
      configurable: true,
      get: _get_BONUS_PAYMENT_PAID__3746291302
    });
    $city$colisactiv$platform$bonus$payment$domain$model.BonusPaymentStatusBase = BonusPaymentStatusBase;
    $city$colisactiv$platform$bonus$payment$domain$model.BonusPaymentStatusValues = BonusPaymentStatusValues;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$model = $city$colisactiv$platform$bonus$payment$domain.model || ($city$colisactiv$platform$bonus$payment$domain.model = {});
    $city$colisactiv$platform$bonus$payment$domain$model.BonusRefBase = BonusRefBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$bonus = $city$colisactiv$platform.bonus || ($city$colisactiv$platform.bonus = {});
    var $city$colisactiv$platform$bonus$payment = $city$colisactiv$platform$bonus.payment || ($city$colisactiv$platform$bonus.payment = {});
    var $city$colisactiv$platform$bonus$payment$domain = $city$colisactiv$platform$bonus$payment.domain || ($city$colisactiv$platform$bonus$payment.domain = {});
    var $city$colisactiv$platform$bonus$payment$domain$model = $city$colisactiv$platform$bonus$payment$domain.model || ($city$colisactiv$platform$bonus$payment$domain.model = {});
    $city$colisactiv$platform$bonus$payment$domain$model.OperatorRefBase = OperatorRefBase;
  }
  $jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=ca-plateform-bonus-payment-domain.js.map